import { NgModule, Directive, HostBinding, Component, ChangeDetectionStrategy, Renderer2, Inject, HostListener, EventEmitter, Output, Input, Injectable, ɵɵdefineInjectable, ɵɵinject, Pipe, ChangeDetectorRef, ViewChild, InjectionToken, Optional, ɵlooseIdentical, forwardRef, ViewEncapsulation, NgZone, isDevMode, ViewChildren } from '@angular/core';
import { DOCUMENT, CommonModule, DecimalPipe, DatePipe } from '@angular/common';
import { AppConfigurationService, NotificationService, SpinnerModule, TranslationModule, NumberUtilService, GeolocationService, nameof, ApplicationType, EmploymentSalaryType, DictionaryType, DictionariesService, QualityAssessmentType, Month, DateUtilService, FieldAuditAreaType, ProductCatalogAuditResult, TreatmentFertilizerUnit, TreatmentIrrigationUnit, TreatmentPesticideUnit, PesticideTypeDictionaryService, TreatmentSeedUnit, MachineServiceCardType, MachineServiceCardUnit, AlarmThresholdProperty, ThresholdOperator, AlarmLocation, MapCultivationAreaModeEnum, GeolocationModule, WeatherStationMeasurementTypes, PipesModule, DocumentEnumType, SpinnerService, TranslateService as TranslateService$1, HumidityPipe, TemperaturePipe, AirHumidityPipe, TrueFalse, DeviceType, GroundCategory, ComplexOfAgriculturalSuitability, AgronomicCategory, CustomMapType, CultivationType, WorkPriceUnit, StorageSensorMeasurementTypes, MachineServiceType, MessageType, CertificateType } from 'farmcloud-core';
import { of, Subject, BehaviorSubject, iif, combineLatest, merge, Observable, Subscription, NEVER, from } from 'rxjs';
import { catchError, map, takeUntil, finalize, tap, startWith, switchMap, distinctUntilChanged, pairwise, filter, flatMap, debounceTime } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DateTime } from 'luxon';
import { __read, __spread, __values, __awaiter, __generator, __assign, __extends, __decorate, __metadata } from 'tslib';
import { NgbDate, NgbCalendar, NgbModule, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule, NG_VALIDATORS } from '@angular/forms';
import { ImageItem, Gallery, GalleryModule } from '@ngx-gallery/core';
import { Lightbox, LightboxModule } from '@ngx-gallery/lightbox';
import { DynamicFormService, parseReviver, DYNAMIC_FORM_CONTROL_TYPE_TIMEPICKER, DynamicTimePickerModel, DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA, DynamicTextAreaModel, DYNAMIC_FORM_CONTROL_TYPE_SWITCH, DynamicSwitchModel, DYNAMIC_FORM_CONTROL_TYPE_SLIDER, DynamicSliderModel, DYNAMIC_FORM_CONTROL_TYPE_SELECT, DynamicSelectModel, DYNAMIC_FORM_CONTROL_TYPE_RATING, DynamicRatingModel, DYNAMIC_FORM_CONTROL_TYPE_RADIO_GROUP, DynamicRadioGroupModel, DYNAMIC_FORM_CONTROL_TYPE_INPUT, maskFromString, DynamicInputModel, DYNAMIC_FORM_CONTROL_TYPE_GROUP, DynamicFormGroupModel, DYNAMIC_FORM_CONTROL_TYPE_FILE_UPLOAD, DynamicFileUploadModel, DYNAMIC_FORM_CONTROL_TYPE_EDITOR, DynamicEditorModel, DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER, DynamicDatePickerModel, DYNAMIC_FORM_CONTROL_TYPE_COLORPICKER, DynamicColorPickerModel, DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX_GROUP, DynamicCheckboxGroupModel, DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX, DynamicCheckboxModel, DYNAMIC_FORM_CONTROL_TYPE_ARRAY, DynamicFormArrayModel, DynamicFormValidationService, serializable, DynamicFormValueControlModel, DynamicFormLayoutService, DynamicFormControlComponent, isFunction, isBoolean, DynamicFormOption, DYNAMIC_FORM_CONTROL_INPUT_TYPE_TEXT, isNumber, DynamicFormsCoreModule, DYNAMIC_FORM_CONTROL_MAP_FN, DYNAMIC_VALIDATORS } from '@ng-dynamic-forms/core';
import { DynamicFormsNGBootstrapUIModule } from '@ng-dynamic-forms/ui-ng-bootstrap';
import { AgmCoreModule, MapsAPILoader, LazyMapsAPILoader, LAZY_MAPS_API_CONFIG } from '@agm/core';
import { BROWSER_GLOBALS_PROVIDERS } from '@agm/core/utils/browser-globals';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { v4 } from 'uuid';
import { Router, RouterModule, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Loader } from 'google-maps';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { cloneDeep, isEmpty, differenceBy, join, remove, flatten, max, min, sum, groupBy, map as map$1 } from 'lodash-es';
import { NgSelectModule } from '@ng-select/ng-select';
import { compareAsc, format, fromUnixTime } from 'date-fns';
import { polygon } from '@turf/helpers';
import intersect from '@turf/intersect';
import { BaseChartDirective, ChartsModule } from 'ng2-charts';
import 'chartjs-adapter-luxon';
import { CdkColumnDef, CdkTableModule, DataSource } from '@angular/cdk/table';
import { coerceNumberProperty, coerceBooleanProperty } from '@angular/cdk/coercion';
import { SharedModule } from 'apex-shared';
import { UiSwitchModule } from 'ngx-ui-switch';
import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory';
import Coordinate from 'jsts/org/locationtech/jts/geom/Coordinate';
import Polygonizer from 'jsts/org/locationtech/jts/operation/polygonize/Polygonizer';
import UnaryUnionOp from 'jsts/org/locationtech/jts/operation/union/UnaryUnionOp';
import OverlayOp from 'jsts/org/locationtech/jts/operation/overlay/OverlayOp';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IPosition() { }
if (false) {
    /** @type {?} */
    IPosition.prototype.lat;
    /** @type {?} */
    IPosition.prototype.lng;
}
/**
 * @param {?} location
 * @return {?}
 */
function mapToPosition(location) {
    if (location && location.length >= 1) {
        return {
            lat: location[1],
            lng: location[0]
        };
    }
    return null;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RecommendationServicesModule = /** @class */ (function () {
    function RecommendationServicesModule() {
    }
    RecommendationServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return RecommendationServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PanelFullscreenDirective = /** @class */ (function () {
    function PanelFullscreenDirective() {
        this.isFullscreen = false;
    }
    PanelFullscreenDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appPanelFullscreen]'
                },] }
    ];
    PanelFullscreenDirective.propDecorators = {
        isFullscreen: [{ type: HostBinding, args: ['class.card-fullscreen',] }]
    };
    return PanelFullscreenDirective;
}());
if (false) {
    /** @type {?} */
    PanelFullscreenDirective.prototype.isFullscreen;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PanelFullscreenButtonComponent = /** @class */ (function () {
    function PanelFullscreenButtonComponent(panelFullscreenDirective, renderer, document) {
        this.panelFullscreenDirective = panelFullscreenDirective;
        this.renderer = renderer;
        this.document = document;
        this.isFullscreen = false;
    }
    /**
     * @return {?}
     */
    PanelFullscreenButtonComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.isFullscreen = !this.isFullscreen;
        if (this.isFullscreen) {
            this.renderer.addClass(this.document.body, 'body-fullscreen');
        }
        else {
            this.renderer.removeClass(this.document.body, 'body-fullscreen');
        }
        this.panelFullscreenDirective.isFullscreen = this.isFullscreen;
    };
    PanelFullscreenButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-panel-fullscreen-button',
                    template: "<a href=\"javascript:;\">\r\n    <i class=\"font-medium-3 blue-grey darken-4\"></i>\r\n    <p class=\"d-none\">fullscreen</p>\r\n</a>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [":host i{font-family:feather!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:host i:before{content:\"\\e978\"}:host.fullscreen i:before{content:\"\\e97f\"}"]
                }] }
    ];
    /** @nocollapse */
    PanelFullscreenButtonComponent.ctorParameters = function () { return [
        { type: PanelFullscreenDirective },
        { type: Renderer2 },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    PanelFullscreenButtonComponent.propDecorators = {
        isFullscreen: [{ type: HostBinding, args: ['class.fullscreen',] }],
        onClick: [{ type: HostListener, args: ['click',] }]
    };
    return PanelFullscreenButtonComponent;
}());
if (false) {
    /** @type {?} */
    PanelFullscreenButtonComponent.prototype.isFullscreen;
    /**
     * @type {?}
     * @private
     */
    PanelFullscreenButtonComponent.prototype.panelFullscreenDirective;
    /**
     * @type {?}
     * @private
     */
    PanelFullscreenButtonComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    PanelFullscreenButtonComponent.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PanelHideButtonComponent = /** @class */ (function () {
    function PanelHideButtonComponent() {
        this.hiddenChange = new EventEmitter();
        this.hidden = false;
    }
    /**
     * @return {?}
     */
    PanelHideButtonComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.hidden = !this.hidden;
        this.hiddenChange.emit(this.hidden);
    };
    PanelHideButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-panel-hide-button',
                    template: "<a href=\"javascript:;\">\r\n    <i class=\"font-medium-3 blue-grey darken-4\"></i>\r\n    <p class=\"d-none\">hide</p>\r\n</a>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [":host i{font-family:feather!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:host i:before{content:\"\\e981\"}:host.hidden i:before{content:\"\\e99c\"}"]
                }] }
    ];
    PanelHideButtonComponent.propDecorators = {
        hiddenChange: [{ type: Output }],
        hidden: [{ type: HostBinding, args: ['class.hidden',] }, { type: Input }],
        onClick: [{ type: HostListener, args: ['click',] }]
    };
    return PanelHideButtonComponent;
}());
if (false) {
    /** @type {?} */
    PanelHideButtonComponent.prototype.hiddenChange;
    /** @type {?} */
    PanelHideButtonComponent.prototype.hidden;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PanelHideDirective = /** @class */ (function () {
    function PanelHideDirective() {
        this.appPanelHide = true;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    PanelHideDirective.prototype.setHidden = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.appPanelHide = value;
    };
    PanelHideDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appPanelHide]',
                    exportAs: 'panelHide'
                },] }
    ];
    PanelHideDirective.propDecorators = {
        appPanelHide: [{ type: HostBinding, args: ['class.d-none',] }, { type: Input }]
    };
    return PanelHideDirective;
}());
if (false) {
    /** @type {?} */
    PanelHideDirective.prototype.appPanelHide;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PanelSharedModule = /** @class */ (function () {
    function PanelSharedModule() {
    }
    PanelSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        PanelFullscreenButtonComponent,
                        PanelFullscreenDirective,
                        PanelHideDirective,
                        PanelHideButtonComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        PanelFullscreenButtonComponent,
                        PanelFullscreenDirective,
                        PanelHideDirective,
                        PanelHideButtonComponent
                    ]
                },] }
    ];
    return PanelSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OpenweathermapProxyService = /** @class */ (function () {
    function OpenweathermapProxyService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.openaweathermapUrl = 'https://api.openweathermap.org/data/2.5';
    }
    /**
     * @param {?} lon
     * @param {?} lat
     * @param {?} cnt
     * @return {?}
     */
    OpenweathermapProxyService.prototype.getUVForecast = /**
     * @param {?} lon
     * @param {?} lat
     * @param {?} cnt
     * @return {?}
     */
    function (lon, lat, cnt) {
        return this.httpClient
            .get(this.openaweathermapUrl + "/uvi/forecast?appid=" + this.appid + "&lat=" + lat + "&lon=" + lon + "&cnt=" + cnt);
    };
    /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    OpenweathermapProxyService.prototype.getUVCurrentValue = /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    function (lon, lat) {
        return this.httpClient
            .get(this.openaweathermapUrl + "/uvi?appid=" + this.appid + "&lat=" + lat + "&lon=" + lon);
    };
    /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    OpenweathermapProxyService.prototype.getForecast = /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    function (lon, lat) {
        return this.httpClient
            .get(this.openaweathermapUrl + "/forecast?appid=" + this.appid + "&lat=" + lat + "&lon=" + lon + "&units=metric");
    };
    Object.defineProperty(OpenweathermapProxyService.prototype, "appid", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.config.configuration.openweather_key;
        },
        enumerable: true,
        configurable: true
    });
    OpenweathermapProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    OpenweathermapProxyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    /** @nocollapse */ OpenweathermapProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function OpenweathermapProxyService_Factory() { return new OpenweathermapProxyService(ɵɵinject(HttpClient), ɵɵinject(AppConfigurationService)); }, token: OpenweathermapProxyService, providedIn: "root" });
    return OpenweathermapProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    OpenweathermapProxyService.prototype.openaweathermapUrl;
    /**
     * @type {?}
     * @private
     */
    OpenweathermapProxyService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    OpenweathermapProxyService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function UVIndex() { }
if (false) {
    /** @type {?} */
    UVIndex.prototype.lat;
    /** @type {?} */
    UVIndex.prototype.lon;
    /** @type {?} */
    UVIndex.prototype.date_iso;
    /** @type {?} */
    UVIndex.prototype.date;
    /** @type {?} */
    UVIndex.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Main() { }
if (false) {
    /** @type {?} */
    Main.prototype.temp;
    /** @type {?} */
    Main.prototype.temp_min;
    /** @type {?} */
    Main.prototype.temp_max;
    /** @type {?} */
    Main.prototype.pressure;
    /** @type {?} */
    Main.prototype.sea_level;
    /** @type {?} */
    Main.prototype.grnd_level;
    /** @type {?} */
    Main.prototype.humidity;
    /** @type {?} */
    Main.prototype.temp_kf;
}
/**
 * @record
 */
function Weather() { }
if (false) {
    /** @type {?} */
    Weather.prototype.id;
    /** @type {?} */
    Weather.prototype.main;
    /** @type {?} */
    Weather.prototype.description;
    /** @type {?} */
    Weather.prototype.icon;
}
/**
 * @record
 */
function Clouds() { }
if (false) {
    /** @type {?} */
    Clouds.prototype.all;
}
/**
 * @record
 */
function Wind() { }
if (false) {
    /** @type {?} */
    Wind.prototype.speed;
    /** @type {?} */
    Wind.prototype.deg;
}
/**
 * @record
 */
function Sys() { }
if (false) {
    /** @type {?} */
    Sys.prototype.pod;
}
/**
 * @record
 */
function Rain() { }
if (false) {
    /* Skipping unnamed member:
    '3h': number;*/
}
/**
 * @record
 */
function Forecast() { }
if (false) {
    /** @type {?} */
    Forecast.prototype.dt;
    /** @type {?} */
    Forecast.prototype.main;
    /** @type {?} */
    Forecast.prototype.weather;
    /** @type {?} */
    Forecast.prototype.clouds;
    /** @type {?} */
    Forecast.prototype.wind;
    /** @type {?} */
    Forecast.prototype.sys;
    /** @type {?} */
    Forecast.prototype.dt_txt;
    /** @type {?} */
    Forecast.prototype.rain;
}
/**
 * @record
 */
function Coord() { }
if (false) {
    /** @type {?} */
    Coord.prototype.lat;
    /** @type {?} */
    Coord.prototype.lon;
}
/**
 * @record
 */
function City() { }
if (false) {
    /** @type {?} */
    City.prototype.id;
    /** @type {?} */
    City.prototype.name;
    /** @type {?} */
    City.prototype.coord;
    /** @type {?} */
    City.prototype.country;
    /** @type {?} */
    City.prototype.population;
    /** @type {?} */
    City.prototype.timezone;
    /** @type {?} */
    City.prototype.sunrise;
    /** @type {?} */
    City.prototype.sunset;
}
/**
 * @record
 */
function ForecastResponse() { }
if (false) {
    /** @type {?} */
    ForecastResponse.prototype.cod;
    /** @type {?} */
    ForecastResponse.prototype.message;
    /** @type {?} */
    ForecastResponse.prototype.cnt;
    /** @type {?} */
    ForecastResponse.prototype.list;
    /** @type {?} */
    ForecastResponse.prototype.city;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundWeatherForecastService = /** @class */ (function () {
    function GroundWeatherForecastService(openweathermapProxyService, notificationService) {
        this.openweathermapProxyService = openweathermapProxyService;
        this.notificationService = notificationService;
    }
    /**
     * @param {?} position
     * @param {?=} cnt
     * @return {?}
     */
    GroundWeatherForecastService.prototype.getForecast = /**
     * @param {?} position
     * @param {?=} cnt
     * @return {?}
     */
    function (position, cnt) {
        var _this = this;
        if (cnt === void 0) { cnt = 18; }
        return this.openweathermapProxyService.getForecast(position.lng, position.lat)
            .pipe(catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.notificationService.error(error, "SHARED.RECOMENDATION.FUGICIDE.API.forecast:errorMessage");
            return of(null);
        })), map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response && response.list || []; })), map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response.slice(0, cnt); })), map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response.map(_this.mapResponse); })), map(this.groupResponse));
    };
    /**
     * @private
     * @param {?} forecast
     * @return {?}
     */
    GroundWeatherForecastService.prototype.mapResponse = /**
     * @private
     * @param {?} forecast
     * @return {?}
     */
    function (forecast) {
        return {
            onlyDate: DateTime.fromSeconds(forecast.dt).toISODate(),
            onlyTime: DateTime.fromSeconds(forecast.dt).toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }),
            temp: forecast.main.temp
        };
    };
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    GroundWeatherForecastService.prototype.groupResponse = /**
     * @private
     * @param {?} response
     * @return {?}
     */
    function (response) {
        /** @type {?} */
        var groupByDate = {};
        /** @type {?} */
        var uniqueTime = response
            .map((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.onlyTime; }))
            .filter((/**
         * @param {?} onlyTime
         * @param {?} index
         * @param {?} arr
         * @return {?}
         */
        function (onlyTime, index, arr) { return arr.indexOf(onlyTime) === index; }))
            .sort();
        response.forEach((/**
         * @param {?} a
         * @return {?}
         */
        function (a) {
            groupByDate[a.onlyDate] = groupByDate[a.onlyDate] || [];
            groupByDate[a.onlyDate].push({ onlyTime: a.onlyTime, temp: a.temp });
        }));
        /** @type {?} */
        var data = Object.keys(groupByDate).map((/**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            return {
                date: id,
                data: groupByDate[id].reduce((/**
                 * @param {?} entities
                 * @param {?} item
                 * @return {?}
                 */
                function (entities, item) {
                    var _a;
                    return Object.assign(entities, (_a = {}, _a[item.onlyTime] = item.temp, _a));
                }), {})
            };
        }));
        return {
            header: uniqueTime,
            data: data
        };
    };
    GroundWeatherForecastService.decorators = [
        { type: Injectable, args: [{
                    providedIn: RecommendationServicesModule
                },] }
    ];
    /** @nocollapse */
    GroundWeatherForecastService.ctorParameters = function () { return [
        { type: OpenweathermapProxyService },
        { type: NotificationService }
    ]; };
    /** @nocollapse */ GroundWeatherForecastService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GroundWeatherForecastService_Factory() { return new GroundWeatherForecastService(ɵɵinject(OpenweathermapProxyService), ɵɵinject(NotificationService)); }, token: GroundWeatherForecastService, providedIn: RecommendationServicesModule });
    return GroundWeatherForecastService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundWeatherForecastService.prototype.openweathermapProxyService;
    /**
     * @type {?}
     * @private
     */
    GroundWeatherForecastService.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FungicideRecommendationsService = /** @class */ (function () {
    function FungicideRecommendationsService() {
        this.data = [
            {
                chemicalGroup: 'Anilinopirimidyny',
                examples: 'Unix 75 WG',
                minTemp: '> 10',
                optimalTemp: '11-24',
                maxTemp: '< 25-30',
                min: 10,
                max: 30,
                optimalMin: 11,
                optimalMax: 24
            },
            {
                chemicalGroup: 'Ditiokarbaminiany',
                examples: 'Dithane Neo Tec 75 WG, Sancozeb 80 WP',
                minTemp: '> 7',
                optimalTemp: '10-20',
                maxTemp: '< 25',
                min: 7,
                max: 25,
                optimalMin: 10,
                optimalMax: 20
            },
            {
                chemicalGroup: 'Karboksyamidy',
                examples: 'Aviator Xpro 225 EC, Bell 300 SC, Seguris 215 SC',
                minTemp: '> 5',
                optimalTemp: '10-25',
                maxTemp: '< 25',
                min: 5,
                max: 25,
                optimalMin: 10,
                optimalMax: 25
            },
            {
                chemicalGroup: 'Fenoksychinony',
                examples: 'Atlas 500 SC',
                minTemp: '> 7',
                optimalTemp: '10-20',
                maxTemp: '< 25',
                min: 7,
                max: 25,
                optimalMin: 10,
                optimalMax: 20
            },
            {
                chemicalGroup: 'Benzofenony + morfoliny + triazole',
                examples: 'Capalo 337,5 SE',
                minTemp: '> 5',
                optimalTemp: '10-25',
                maxTemp: '< 25',
                min: 5,
                max: 25,
                optimalMin: 10,
                optimalMax: 25
            },
            {
                chemicalGroup: 'Benzimidazole',
                examples: 'Topsin M 500 SC',
                minTemp: '> 5',
                optimalTemp: '10-25',
                maxTemp: '< 25',
                min: 5,
                max: 25,
                optimalMin: 10,
                optimalMax: 25
            },
            {
                chemicalGroup: 'Ftalany',
                examples: 'Gwarant 500 SC',
                minTemp: '> 5',
                optimalTemp: '10-25',
                maxTemp: '< 25',
                min: 5,
                max: 25,
                optimalMin: 10,
                optimalMax: 25
            },
            {
                chemicalGroup: 'Morfoliny',
                examples: 'Fentop 750 EC',
                minTemp: '> 5-10',
                optimalTemp: '11-20',
                maxTemp: '22-25*',
                min: 5,
                max: 25,
                optimalMin: 11,
                optimalMax: 20
            },
            {
                chemicalGroup: 'Quinozoliny',
                examples: 'Talius 200 EC',
                minTemp: '> 5',
                optimalTemp: '8-25',
                maxTemp: '25',
                min: 5,
                max: 25,
                optimalMin: 8,
                optimalMax: 25
            },
            {
                chemicalGroup: 'Strobiluryny',
                examples: 'Acanto 250 SC',
                minTemp: '> 8-10',
                optimalTemp: '11-24',
                maxTemp: '25',
                min: 8,
                max: 25,
                optimalMin: 11,
                optimalMax: 24
            },
            {
                chemicalGroup: 'Strobiluryny',
                examples: 'Amistar 250 SC',
                minTemp: '> 10',
                optimalTemp: '11-25',
                maxTemp: '< 25',
                min: 10,
                max: 25,
                optimalMin: 11,
                optimalMax: 25
            },
            {
                chemicalGroup: 'Strobiluryny + triazole',
                examples: 'Fandango 200 EC',
                minTemp: '> 10',
                optimalTemp: '12-25',
                maxTemp: '< 28',
                min: 10,
                max: 28,
                optimalMin: 12,
                optimalMax: 25
            },
            {
                chemicalGroup: 'Triazole',
                examples: 'Artea 330 EC',
                minTemp: '14',
                optimalTemp: '15-21',
                maxTemp: '22-25*',
                min: 14,
                max: 25,
                optimalMin: 15,
                optimalMax: 21
            },
            {
                chemicalGroup: 'Triazole',
                examples: 'Horizon 250 EW, Prosaro 250 EC, Tebu 250 EW, Traper 250 EC',
                minTemp: '> 10',
                optimalTemp: '12-25',
                maxTemp: '< 28',
                min: 10,
                max: 28,
                optimalMin: 12,
                optimalMax: 25
            }
        ];
    }
    FungicideRecommendationsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: RecommendationServicesModule
                },] }
    ];
    /** @nocollapse */ FungicideRecommendationsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FungicideRecommendationsService_Factory() { return new FungicideRecommendationsService(); }, token: FungicideRecommendationsService, providedIn: RecommendationServicesModule });
    return FungicideRecommendationsService;
}());
if (false) {
    /** @type {?} */
    FungicideRecommendationsService.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FungicideRecommendationsComponent = /** @class */ (function () {
    function FungicideRecommendationsComponent(groundWeatherForecastService, fungicideRecommendationsService) {
        this.groundWeatherForecastService = groundWeatherForecastService;
        this.fungicideRecommendationsService = fungicideRecommendationsService;
        this.unsubscribe$ = new Subject();
        this.displaySpinnerSubject = new BehaviorSubject(true);
        this.displaySpinner$ = this.displaySpinnerSubject.asObservable();
    }
    /**
     * @return {?}
     */
    FungicideRecommendationsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.position != null) {
            this.fungicideRecommendations = this.fungicideRecommendationsService.data;
            this.data$ = this.groundWeatherForecastService.getForecast(this.position)
                .pipe(takeUntil(this.unsubscribe$), finalize((/**
             * @return {?}
             */
            function () {
                _this.displaySpinnerSubject.next(false);
            })));
        }
        else {
            this.displaySpinnerSubject.next(false);
        }
    };
    /**
     * @return {?}
     */
    FungicideRecommendationsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    FungicideRecommendationsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-fungicide-recommendations',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n\r\n        <div class=\"card-content\">\r\n            <app-panel-fullscreen-button class=\"float-right mr-3 mt-3\"></app-panel-fullscreen-button>\r\n            <div class=\"card-body\" *ngIf=\"position; else emptyPosition\">\r\n                <label class=\"px-0 mb-2\">\r\n                    <h5 class=\"m-0\">\r\n                        <i class=\"ft ft-tag\"></i> {{ 'SHARED.RECOMENDATION.FUGICIDE.recommendation:title' | translate }}\r\n                    </h5>\r\n                </label>\r\n                <hr class=\"mt-0\" />\r\n                <div>\r\n                    <div class=\"p-0 m-0\">\r\n                        <ul class=\"p-0 legend\">\r\n                            <li class=\"p-1\"><span class=\"extra_bg-success\"></span>\r\n                                {{ 'SHARED.RECOMENDATION.FUGICIDE.optimal' | translate }}</li>\r\n                            <li class=\"p-1\"><span\r\n                                    class=\"extra_bg-warning\"></span>{{ 'SHARED.RECOMENDATION.FUGICIDE.recommended' | translate }}\r\n                            </li>\r\n                            <li class=\"p-1\"><span\r\n                                    class=\"extra_bg-danger\"></span>{{ 'SHARED.RECOMENDATION.FUGICIDE.notRecommended' | translate }}\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                    <div class=\"table-responsive\" *ngIf=\"data$ | async as data\">\r\n\r\n                        <ng-container *ngFor=\"let fungicideRecommendation of fungicideRecommendations\">\r\n                            <table class=\"table\">\r\n                                <tbody>\r\n                                    <tr>\r\n                                        <td class=\"text-center extra_bg-light-grey\"\r\n                                            [attr.colspan]=\"(1 + data.header.length)\">\r\n                                            {{ fungicideRecommendation.chemicalGroup  }}</td>\r\n                                    </tr>\r\n                                    <tr>\r\n                                        <td class=\"text-center extra_bg-light-grey\"\r\n                                            [attr.colspan]=\"(1 + data.header.length)\">\r\n                                            {{ fungicideRecommendation.examples  }}</td>\r\n                                    </tr>\r\n                                    <tr>\r\n                                        <td class=\"text-center\" scope=\"col\"></td>\r\n                                        <td class=\"text-center col-time\" *ngFor=\"let hour of data.header\" scope=\"col\">                                \r\n                                            <i class=\"farm_icon position-absolute\" [ngClass]=\"{'farm_icon-01': hour=='01:00', 'farm_icon-02': hour=='02:00',\r\n                                            'farm_icon-04': hour=='04:00', 'farm_icon-05': hour=='05:00', \r\n                                            'farm_icon-07': hour=='07:00', 'farm_icon-08': hour=='08:00',\r\n                                            'farm_icon-10': hour=='10:00', 'farm_icon-11': hour=='11:00',\r\n                                            'farm_icon-13': hour=='13:00', 'farm_icon-14': hour=='14:00',\r\n                                            'farm_icon-16': hour=='16:00', 'farm_icon-17': hour=='17:00',\r\n                                            'farm_icon-19': hour=='19:00', 'farm_icon-20': hour=='20:00',\r\n                                            'farm_icon-22': hour=='22:00', 'farm_icon-23': hour=='23:00'}\"></i>\r\n                                            <span>{{ hour }}</span>\r\n                                        </td>\r\n                                    </tr>\r\n                                    <!-- <td  [ngClass]=\"fungicideRecommendation | fungicideRecommendation : hourData.temp\" class=\"text-center\" *ngFor=\"let hourData of dayData\">{{ hourData.temp }}</td> -->\r\n                                    <tr *ngFor=\"let day of data.data\" class=\"bordered\">\r\n                                        <td>\r\n                                            <div class=\"d-flex align-items-center justify-content-center\">\r\n                                                <i class=\"farm_icon farm_icon-calendar mr-1\"></i>\r\n                                            <span>{{ day.date | i18nDate: 'shortDate' }}</span>\r\n                                            </div>\r\n                                        </td>\r\n                                        <td class=\"text-center text-white\" *ngFor=\"let hour of data.header\"\r\n                                            [ngClass]=\"fungicideRecommendation | fungicideRecommendation : day.data[hour]\">\r\n                                            {{ day.data[hour] ? day.data[hour] + '&#8451;' : '' }}</td>\r\n                                    </tr>\r\n                                </tbody>\r\n                            </table>\r\n                        </ng-container>\r\n\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <ng-template #emptyPosition>\r\n                <div class=\"card-body\">\r\n                    <div class=\"alert alert-info\" role=\"alert\">\r\n                        {{ 'SHARED.RECOMENDATION.FUGICIDE.missingPosition:message' | translate }}\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </div>\r\n    </div>\r\n</div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["ul.legend li{list-style-type:none;display:inline-flex;align-items:center;margin-right:1rem}ul.legend li span{width:2rem;height:2rem;margin-right:.5rem;display:inline-block;border-radius:3px}.bg-examples{background-color:#f9c234}.table{border-collapse:separate;border-spacing:0 .5rem}.table tr td{border:none}.table tr td.col-time{position:relative;z-index:3}.table tr td.col-time .farm_icon{transform:translate(50%,0);right:50%;z-index:-1}.table tr.bordered td{border:1px solid #e4e7eb;border-right:none;vertical-align:middle}.table tr.bordered td:last-child{border-right:1px solid #e4e7eb}"]
                }] }
    ];
    /** @nocollapse */
    FungicideRecommendationsComponent.ctorParameters = function () { return [
        { type: GroundWeatherForecastService },
        { type: FungicideRecommendationsService }
    ]; };
    FungicideRecommendationsComponent.propDecorators = {
        position: [{ type: Input }]
    };
    return FungicideRecommendationsComponent;
}());
if (false) {
    /** @type {?} */
    FungicideRecommendationsComponent.prototype.position;
    /**
     * @type {?}
     * @private
     */
    FungicideRecommendationsComponent.prototype.unsubscribe$;
    /** @type {?} */
    FungicideRecommendationsComponent.prototype.data$;
    /** @type {?} */
    FungicideRecommendationsComponent.prototype.fungicideRecommendations;
    /**
     * @type {?}
     * @private
     */
    FungicideRecommendationsComponent.prototype.displaySpinnerSubject;
    /** @type {?} */
    FungicideRecommendationsComponent.prototype.displaySpinner$;
    /**
     * @type {?}
     * @private
     */
    FungicideRecommendationsComponent.prototype.groundWeatherForecastService;
    /**
     * @type {?}
     * @private
     */
    FungicideRecommendationsComponent.prototype.fungicideRecommendationsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FungicideRecommendationPipe = /** @class */ (function () {
    function FungicideRecommendationPipe() {
    }
    /**
     * @param {?} value
     * @param {?=} temperature
     * @return {?}
     */
    FungicideRecommendationPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} temperature
     * @return {?}
     */
    function (value, temperature) {
        if (value == null || temperature == null) {
            return null;
        }
        if (value.optimalMin <= temperature && value.optimalMax >= temperature) {
            return 'extra_bg-success';
        }
        else if (value.min <= temperature && value.max >= temperature) {
            return 'extra_bg-warning';
        }
        return 'extra_bg-danger';
    };
    FungicideRecommendationPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'fungicideRecommendation'
                },] }
    ];
    return FungicideRecommendationPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RecommendationSharedModule = /** @class */ (function () {
    function RecommendationSharedModule() {
    }
    RecommendationSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [FungicideRecommendationsComponent, FungicideRecommendationPipe],
                    imports: [
                        CommonModule,
                        PanelSharedModule,
                        SpinnerModule,
                        TranslationModule,
                        RecommendationServicesModule
                    ],
                    exports: [
                        FungicideRecommendationsComponent
                    ]
                },] }
    ];
    return RecommendationSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAgroMonitoring() { }
if (false) {
    /** @type {?} */
    IAgroMonitoring.prototype.polygonId;
    /** @type {?} */
    IAgroMonitoring.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SatelliteServicesModule = /** @class */ (function () {
    function SatelliteServicesModule() {
    }
    SatelliteServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return SatelliteServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AgromonitoringProxyService = /** @class */ (function () {
    function AgromonitoringProxyService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.agromonitoringUrl = 'https://api.agromonitoring.com/agro/1.0/image';
    }
    /**
     * @param {?} start
     * @param {?} end
     * @param {?} polyid
     * @return {?}
     */
    AgromonitoringProxyService.prototype.getImages = /**
     * @param {?} start
     * @param {?} end
     * @param {?} polyid
     * @return {?}
     */
    function (start, end, polyid) {
        // tslint:disable-next-line: max-line-length
        return this.httpClient.get(this.agromonitoringUrl + "/search?appid=" + this.appid + "&start=" + start + "&end=" + end + "&polyid=" + polyid + "&type=s2");
    };
    Object.defineProperty(AgromonitoringProxyService.prototype, "appid", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.config.configuration.openweather_key;
        },
        enumerable: true,
        configurable: true
    });
    AgromonitoringProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: SatelliteServicesModule
                },] }
    ];
    /** @nocollapse */
    AgromonitoringProxyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    /** @nocollapse */ AgromonitoringProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AgromonitoringProxyService_Factory() { return new AgromonitoringProxyService(ɵɵinject(HttpClient), ɵɵinject(AppConfigurationService)); }, token: AgromonitoringProxyService, providedIn: SatelliteServicesModule });
    return AgromonitoringProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AgromonitoringProxyService.prototype.agromonitoringUrl;
    /**
     * @type {?}
     * @private
     */
    AgromonitoringProxyService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    AgromonitoringProxyService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AgromonitoringService = /** @class */ (function () {
    function AgromonitoringService(agromonitoringProxyService, notificationService) {
        this.agromonitoringProxyService = agromonitoringProxyService;
        this.notificationService = notificationService;
    }
    /**
     * @param {?} start
     * @param {?} end
     * @param {?} poligonId
     * @return {?}
     */
    AgromonitoringService.prototype.getImages = /**
     * @param {?} start
     * @param {?} end
     * @param {?} poligonId
     * @return {?}
     */
    function (start, end, poligonId) {
        var _this = this;
        if (poligonId == null) {
            return of([]);
        }
        /** @type {?} */
        var startValue = DateTime.fromObject(start).toSeconds();
        /** @type {?} */
        var endValue = DateTime.fromObject(end).toSeconds();
        return this.agromonitoringProxyService.getImages(startValue, endValue, poligonId)
            .pipe(map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.map((/**
         * @param {?} y
         * @return {?}
         */
        function (y) {
            return {
                dt: DateTime.fromSeconds(y.dt).toISO(),
                cl: y.cl,
                image: y.image
            };
        })); })), catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.notificationService.error(error, "SHARED.SATELLITE.API.error:httpError");
            return of([]);
        })));
    };
    AgromonitoringService.decorators = [
        { type: Injectable, args: [{
                    providedIn: SatelliteServicesModule
                },] }
    ];
    /** @nocollapse */
    AgromonitoringService.ctorParameters = function () { return [
        { type: AgromonitoringProxyService },
        { type: NotificationService }
    ]; };
    /** @nocollapse */ AgromonitoringService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AgromonitoringService_Factory() { return new AgromonitoringService(ɵɵinject(AgromonitoringProxyService), ɵɵinject(NotificationService)); }, token: AgromonitoringService, providedIn: SatelliteServicesModule });
    return AgromonitoringService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AgromonitoringService.prototype.agromonitoringProxyService;
    /**
     * @type {?}
     * @private
     */
    AgromonitoringService.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SatelliteImageryComponent = /** @class */ (function () {
    function SatelliteImageryComponent(calendar, fb, agromonitoringService, gallery, changeDetectorRef) {
        this.calendar = calendar;
        this.fb = fb;
        this.agromonitoringService = agromonitoringService;
        this.gallery = gallery;
        this.changeDetectorRef = changeDetectorRef;
        this.displaySpinner$ = new BehaviorSubject(true);
        this.unsubscribe$ = new Subject();
        this.maxDate = NgbDate.from(DateTime.local().toObject());
        this.minDate = NgbDate.from(DateTime.local().plus({ years: -2 }).toObject());
    }
    /**
     * @return {?}
     */
    SatelliteImageryComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.galleryId = "note_" + (this.data && this.data.polygonId);
        this.galleryRef = this.gallery.ref(this.galleryId);
        this.galleryRef.setConfig({
            loadingMode: 'indeterminate'
        });
        /** @type {?} */
        var initValue = {
            // tslint:disable-next-line: no-magic-numbers
            fromDate: this.calendar.getPrev(this.calendar.getToday(), 'd', 4 * 7),
            toDate: this.calendar.getToday()
        };
        /** @type {?} */
        var initFormat = 'truecolor';
        this.formGroup = this.fb.group({
            dateRange: [initValue],
            format: [initFormat]
        });
        /** @type {?} */
        var dataFromApi$ = this.formGroup.get('dateRange')
            .valueChanges
            .pipe(tap((/**
         * @return {?}
         */
        function () { return _this.displaySpinner$.next(true); })), startWith(initValue), switchMap((/**
         * @param {?} v
         * @return {?}
         */
        function (v) { return iif((/**
         * @return {?}
         */
        function () { return v == null; }), of([]), _this.agromonitoringService.getImages(v.fromDate, v.toDate, _this.data && _this.data.polygonId)
            .pipe(catchError((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(false);
            return of([]);
        })))); })), tap((/**
         * @return {?}
         */
        function () { return _this.displaySpinner$.next(false); })));
        /** @type {?} */
        var format$ = this.formGroup.get('format')
            .valueChanges
            .pipe(startWith(initFormat), distinctUntilChanged());
        combineLatest([dataFromApi$, format$])
            .pipe(takeUntil(this.unsubscribe$)).subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), result = _b[0], format = _b[1];
            _this.items = result.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                return new ImageItem({
                    src: x.image[format],
                    thumbSrc: x.image[format],
                    created: x.dt,
                    cl: x.cl
                });
            }));
            _this.galleryRef.load(_this.items);
            _this.changeDetectorRef.markForCheck();
        }));
    };
    /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    SatelliteImageryComponent.prototype.trackByFn = /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    function (index, item) {
        return item.dt;
    };
    /**
     * @return {?}
     */
    SatelliteImageryComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    SatelliteImageryComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-satellite-imagery',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header\">\r\n        <div class=\"card-header d-flex\">\r\n            <div class=\"w-100\" *ngIf=\"data && data.polygonId\">\r\n                <form [formGroup]=\"formGroup\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-6\">\r\n                            <lib-datepicker-range formControlName=\"dateRange\" [minDate]=\"minDate\" [maxDate]=\"maxDate\"></lib-datepicker-range>\r\n                        </div>\r\n                        <div class=\"col-6\">\r\n                            <div class=\"btn-group btn-group-toggle\" ngbRadioGroup name=\"format\" formControlName=\"format\">\r\n                                <label ngbButtonLabel class=\"btn-primary btn-raised\">\r\n                                    <input ngbButton type=\"radio\" value=\"truecolor\" />\r\n                                    {{ 'SHARED.SATELLITE.API.imageryFormat:truecolor' | translate }}\r\n                                </label>\r\n                                <label ngbButtonLabel class=\"btn-primary btn-raised\">\r\n                                    <input ngbButton type=\"radio\" value=\"ndvi\" />\r\n                                    {{ 'SHARED.SATELLITE.API.imageryFormat:ndvi' | translate }}\r\n                                </label>\r\n                                <label ngbButtonLabel class=\"btn-primary btn-raised\">\r\n                                    <input ngbButton type=\"radio\" value=\"evi\" />\r\n                                    {{ 'SHARED.SATELLITE.API.imageryFormat:evi' | translate }}\r\n                                </label>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container\" *ngIf=\"data && data.polygonId; else missingData\">\r\n                <div class=\"row text-left\" matchHeight=\"card\" *ngIf=\"items && items.length > 0; else emptyList\" [appSpinner]=\"displaySpinner$ | async\">\r\n                    <div class=\"col-lg-3 col-6 p-1\" *ngFor=\"let item of items; let i = index; trackBy: trackByFn\">\r\n                        <div class=\"card bg-light\" [lightbox]=\"i\" [gallery]=\"galleryId\">\r\n                            <div class=\"card-content p-1\">\r\n                                <img alt=\"Card image cap\" class=\"card-img-top img-fluid\" [src]=\"item.data.thumbSrc\">\r\n                                <div class=\"card-body\">\r\n                                    <h4 class=\"card-title text-center\">{{ item.data.created | i18nDate: 'shortDate' }}</h4>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"card-footer px-1 bg-light\">\r\n                                <p class=\"card-text text-right\">\r\n                                    <small class=\"text-muted\">{{ 'SHARED.SATELLITE.IMAGERY.cloud_coverage:label' | translate }}: {{ item.data.cl | number:'1.2-2' }}%</small>\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <ng-template #emptyList>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12 alert alert-info text-center\" role=\"alert\">\r\n                            {{ 'SHARED.SATELLITE.IMAGERY.list:empty' | translate }}\r\n                        </div>\r\n                    </div>\r\n                </ng-template>\r\n            </div>\r\n            <ng-template #missingData>\r\n                <div class=\"container-fluid\">\r\n                    <div class=\"alert alert-info\" role=\"alert\">\r\n                        {{ data?.message | messageTranslation | translate }}\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </div>\r\n    </div>\r\n</div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".grid-item{margin:1em .4em 0;border-radius:.2em;overflow:hidden;padding:0;width:100px;height:100px}@media only screen and (max-width:480px){.grid-item{margin:.4em .2em 0;width:100px;height:80px}}.grid{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:0}.grid-empty{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:1em .4em 0;border-radius:.2em;padding:0;width:100%;height:100px}@media only screen and (max-width:480px){.grid-empty{margin:.4em .2em 0;height:80px}}.grid-image{display:block;width:100%;height:100%;background-size:cover;background-position:center center}"]
                }] }
    ];
    /** @nocollapse */
    SatelliteImageryComponent.ctorParameters = function () { return [
        { type: NgbCalendar },
        { type: FormBuilder },
        { type: AgromonitoringService },
        { type: Gallery },
        { type: ChangeDetectorRef }
    ]; };
    SatelliteImageryComponent.propDecorators = {
        data: [{ type: Input }]
    };
    return SatelliteImageryComponent;
}());
if (false) {
    /** @type {?} */
    SatelliteImageryComponent.prototype.data;
    /** @type {?} */
    SatelliteImageryComponent.prototype.formGroup;
    /** @type {?} */
    SatelliteImageryComponent.prototype.minDate;
    /** @type {?} */
    SatelliteImageryComponent.prototype.maxDate;
    /** @type {?} */
    SatelliteImageryComponent.prototype.displaySpinner$;
    /** @type {?} */
    SatelliteImageryComponent.prototype.items;
    /** @type {?} */
    SatelliteImageryComponent.prototype.galleryId;
    /** @type {?} */
    SatelliteImageryComponent.prototype.galleryRef;
    /**
     * @type {?}
     * @private
     */
    SatelliteImageryComponent.prototype.unsubscribe$;
    /**
     * @type {?}
     * @private
     */
    SatelliteImageryComponent.prototype.calendar;
    /**
     * @type {?}
     * @private
     */
    SatelliteImageryComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    SatelliteImageryComponent.prototype.agromonitoringService;
    /**
     * @type {?}
     * @private
     */
    SatelliteImageryComponent.prototype.gallery;
    /**
     * @type {?}
     * @private
     */
    SatelliteImageryComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageTranslationPipe = /** @class */ (function () {
    function MessageTranslationPipe() {
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    MessageTranslationPipe.prototype.transform = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        if (value && value.toLowerCase().startsWith('area of the polygon')) {
            return 'SHARED.SATELLITE.API.error:toSmallArea';
        }
        else if (value && value.toLowerCase().startsWith('the polygon can not has self')) {
            return 'SHARED.SATELLITE.API.error:selfIntersections';
        }
        return value;
    };
    MessageTranslationPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'messageTranslation'
                },] }
    ];
    return MessageTranslationPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DateRange() { }
if (false) {
    /** @type {?} */
    DateRange.prototype.fromDate;
    /** @type {?} */
    DateRange.prototype.toDate;
}
var DatepickerRangeComponent = /** @class */ (function () {
    function DatepickerRangeComponent(calendar, fb) {
        this.calendar = calendar;
        this.fb = fb;
        this.unsubscribe = new Subject();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
        this.formGroup = this.fb.group({
            from: [null, Validators.required],
            to: [null, Validators.required]
        });
    }
    Object.defineProperty(DatepickerRangeComponent.prototype, "to", {
        get: /**
         * @return {?}
         */
        function () {
            return this.formGroup.get('to').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatepickerRangeComponent.prototype, "from", {
        get: /**
         * @return {?}
         */
        function () {
            return this.formGroup.get('from').value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DatepickerRangeComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup.valueChanges
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            if (x.from != null && x.to != null) {
                if (_this.calendar.isValid(x.from) && _this.calendar.isValid(x.to)) {
                    _this.onChange({
                        fromDate: x.from,
                        toDate: x.to
                    });
                }
                else {
                    _this.onChange(null);
                }
            }
            else {
                _this.onChange(null);
            }
            _this.onTouched();
        }));
    };
    /**
     * @return {?}
     */
    DatepickerRangeComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    DatepickerRangeComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        if (obj) {
            this.formGroup.setValue({
                from: obj.fromDate,
                to: obj.toDate
            });
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DatepickerRangeComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DatepickerRangeComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DatepickerRangeComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    DatepickerRangeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-datepicker-range',
                    template: "<form class=\"form-inline\" [formGroup]=\"formGroup\">\r\n    <div class=\"form-group\">\r\n        <div class=\"input-group\">\r\n            <input class=\"form-control\" name=\"dfrom\" formControlName=\"from\" ngbDatepicker #dfrom=\"ngbDatepicker\" [minDate]=\"minDate\"\r\n            [maxDate]=\"to || maxDate\" />\r\n            <div class=\"input-group-append\">\r\n                <button class=\"btn btn-outline-secondary calendar\" (click)=\"dfrom.toggle()\" type=\"button\"></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"form-group ml-1\">\r\n        <div class=\"input-group\">\r\n            <input class=\"form-control\" name=\"dto\" formControlName=\"to\" ngbDatepicker #dto=\"ngbDatepicker\" [minDate]=\"from || minDate\"\r\n            [maxDate]=\"maxDate\" />\r\n            <div class=\"input-group-append\">\r\n                <button class=\"btn btn-outline-secondary calendar\" (click)=\"dto.toggle()\" type=\"button\"></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</form>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: DatepickerRangeComponent,
                            multi: true
                        }
                    ],
                    styles: [".form-group.hidden{width:0!important;height:0!important;margin:0;border:none;padding:0}.custom-day{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.custom-day.focused{background-color:#e6e6e6}.custom-day.range,.custom-day:hover{background-color:#0275d8;color:#fff}.custom-day.faded{background-color:rgba(2,117,216,.5)}"]
                }] }
    ];
    /** @nocollapse */
    DatepickerRangeComponent.ctorParameters = function () { return [
        { type: NgbCalendar },
        { type: FormBuilder }
    ]; };
    DatepickerRangeComponent.propDecorators = {
        minDate: [{ type: Input }],
        maxDate: [{ type: Input }]
    };
    return DatepickerRangeComponent;
}());
if (false) {
    /** @type {?} */
    DatepickerRangeComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    DatepickerRangeComponent.prototype.unsubscribe;
    /** @type {?} */
    DatepickerRangeComponent.prototype.minDate;
    /** @type {?} */
    DatepickerRangeComponent.prototype.maxDate;
    /**
     * @type {?}
     * @private
     */
    DatepickerRangeComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    DatepickerRangeComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    DatepickerRangeComponent.prototype.calendar;
    /**
     * @type {?}
     * @private
     */
    DatepickerRangeComponent.prototype.fb;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgbdDatepickerRangeModule = /** @class */ (function () {
    function NgbdDatepickerRangeModule() {
    }
    NgbdDatepickerRangeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DatepickerRangeComponent],
                    imports: [
                        CommonModule,
                        NgbModule,
                        FormsModule,
                        ReactiveFormsModule
                    ],
                    exports: [
                        CommonModule,
                        NgbModule,
                        DatepickerRangeComponent
                    ]
                },] }
    ];
    return NgbdDatepickerRangeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DataLayerComponent = /** @class */ (function () {
    function DataLayerComponent() {
    }
    Object.defineProperty(DataLayerComponent.prototype, "latLng", {
        get: /**
         * @return {?}
         */
        function () {
            return this._latLng;
        },
        set: /**
         * @param {?} latLng
         * @return {?}
         */
        function (latLng) {
            this._latLng = latLng;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataLayerComponent.prototype, "feature", {
        get: /**
         * @return {?}
         */
        function () {
            return this._feature;
        },
        set: /**
         * @param {?} feature
         * @return {?}
         */
        function (feature) {
            this._feature = feature;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataLayerComponent.prototype, "showInfoWindow", {
        get: /**
         * @return {?}
         */
        function () {
            return this.showWindow;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.showWindow = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} feature
     * @return {?}
     */
    DataLayerComponent.prototype.styleFunc = /**
     * @param {?} feature
     * @return {?}
     */
    function (feature) {
        return {
            clickable: true,
            draggable: false,
            editable: false,
            fillColor: feature.getProperty('fillColor'),
            fillOpacity: feature.getProperty('fillOpacity'),
            geodesic: feature.getProperty('geodesic'),
            strokeColor: feature.getProperty('strokeColor'),
            strokeOpacity: feature.getProperty('strokeOpacity'),
            strokeWeight: feature.getProperty('strokeWeight'),
            visible: true,
            zIndex: feature.getProperty('zIndex')
        };
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    DataLayerComponent.prototype.onLayerClick = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.latLng = $event.latLng;
        this.feature = $event.feature;
        this.showInfoWindow = true;
    };
    /**
     * @return {?}
     */
    DataLayerComponent.prototype.closeInfoWindow = /**
     * @return {?}
     */
    function () {
        this.showInfoWindow = false;
    };
    DataLayerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-data-layer',
                    template: "<agm-data-layer [geoJson]=\"geoJsonUrl\" [style]=\"styleFunc\" (layerClick)=\"onLayerClick($event)\">\r\n</agm-data-layer>\r\n\r\n<agm-snazzy-info-window *ngIf=\"feature && showInfoWindow\" [maxWidth]=\"320\" [closeWhenOthersOpen]=\"true\"\r\n    [latitude]=\"latLng.lat()\" [longitude]=\"latLng.lng()\" [isOpen]=\"showInfoWindow\"\r\n    (afterClose)=\"closeInfoWindow()\">\r\n    <ng-template>\r\n        <div class=\"row no-gutters\">\r\n            <div class=\"col-6\">\r\n                {{ feature.l.area }} [ha]\r\n            </div>\r\n            <div class=\"col-6\">\r\n                {{ feature.l.name }}\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n</agm-snazzy-info-window>\r\n"
                }] }
    ];
    DataLayerComponent.propDecorators = {
        geoJsonUrl: [{ type: Input }]
    };
    return DataLayerComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DataLayerComponent.prototype._latLng;
    /**
     * @type {?}
     * @private
     */
    DataLayerComponent.prototype._feature;
    /**
     * @type {?}
     * @private
     */
    DataLayerComponent.prototype.showWindow;
    /** @type {?} */
    DataLayerComponent.prototype.geoJsonUrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FeaturesStoreService = /** @class */ (function () {
    function FeaturesStoreService() {
        this.featuresSubject = new BehaviorSubject(null);
    }
    Object.defineProperty(FeaturesStoreService.prototype, "features$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.featuresSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesStoreService.prototype, "features", {
        get: /**
         * @return {?}
         */
        function () {
            return this.featuresSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} features
     * @return {?}
     */
    FeaturesStoreService.prototype.setFeatures = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        this.featuresSubject.next(features);
    };
    FeaturesStoreService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FeaturesStoreService.ctorParameters = function () { return []; };
    return FeaturesStoreService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FeaturesStoreService.prototype.featuresSubject;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var MapType = {
    Roadmap: 'roadmap',
    Hybrid: 'hybrid',
    Satellite: 'satellite',
    Terrain: 'terrain',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var farmDrawingColor = '#ff5349';
/** @type {?} */
var groundDrawingColor = '#ffff00';
/** @type {?} */
var parcelDrawingColor = '#fde456';
/** @type {?} */
var groupDrawingColor = '#0000FF';
var MapConfig = /** @class */ (function () {
    function MapConfig(fitBounds, latitude, longitude, zoom, fullscreenControl, mapTypeControl, mapTypeControlOptions, mapTypeId) {
        if (fitBounds === void 0) { fitBounds = null; }
        if (latitude === void 0) { latitude = 52.237049; }
        if (longitude === void 0) { longitude = 21.017532; }
        if (zoom === void 0) { zoom = 6; }
        if (fullscreenControl === void 0) { fullscreenControl = true; }
        if (mapTypeControl === void 0) { mapTypeControl = true; }
        if (mapTypeControlOptions === void 0) { mapTypeControlOptions = null; }
        if (mapTypeId === void 0) { mapTypeId = MapType.Hybrid; }
        this.fitBounds = fitBounds;
        this.latitude = latitude;
        this.longitude = longitude;
        this.zoom = zoom;
        this.fullscreenControl = fullscreenControl;
        this.mapTypeControl = mapTypeControl;
        this.mapTypeControlOptions = mapTypeControlOptions;
        this.mapTypeId = mapTypeId;
    }
    return MapConfig;
}());
if (false) {
    /** @type {?} */
    MapConfig.prototype.fitBounds;
    /** @type {?} */
    MapConfig.prototype.latitude;
    /** @type {?} */
    MapConfig.prototype.longitude;
    /** @type {?} */
    MapConfig.prototype.zoom;
    /** @type {?} */
    MapConfig.prototype.fullscreenControl;
    /** @type {?} */
    MapConfig.prototype.mapTypeControl;
    /** @type {?} */
    MapConfig.prototype.mapTypeControlOptions;
    /** @type {?} */
    MapConfig.prototype.mapTypeId;
}
var PolygonConfig = /** @class */ (function () {
    function PolygonConfig(drawingColor, drawingEnabled, editable, singlePolygonDrawing) {
        if (drawingColor === void 0) { drawingColor = groundDrawingColor; }
        if (drawingEnabled === void 0) { drawingEnabled = true; }
        if (editable === void 0) { editable = true; }
        if (singlePolygonDrawing === void 0) { singlePolygonDrawing = true; }
        this.drawingColor = drawingColor;
        this.drawingEnabled = drawingEnabled;
        this.editable = editable;
        this.singlePolygonDrawing = singlePolygonDrawing;
    }
    return PolygonConfig;
}());
if (false) {
    /** @type {?} */
    PolygonConfig.prototype.drawingColor;
    /** @type {?} */
    PolygonConfig.prototype.drawingEnabled;
    /** @type {?} */
    PolygonConfig.prototype.editable;
    /** @type {?} */
    PolygonConfig.prototype.singlePolygonDrawing;
}
var MarkerConfig = /** @class */ (function () {
    function MarkerConfig(drawingEnabled, editable, singleMarkerDrawing) {
        if (drawingEnabled === void 0) { drawingEnabled = true; }
        if (editable === void 0) { editable = true; }
        if (singleMarkerDrawing === void 0) { singleMarkerDrawing = true; }
        this.drawingEnabled = drawingEnabled;
        this.editable = editable;
        this.singleMarkerDrawing = singleMarkerDrawing;
    }
    return MarkerConfig;
}());
if (false) {
    /** @type {?} */
    MarkerConfig.prototype.drawingEnabled;
    /** @type {?} */
    MarkerConfig.prototype.editable;
    /** @type {?} */
    MarkerConfig.prototype.singleMarkerDrawing;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapService = /** @class */ (function () {
    function MapService() {
    }
    /**
     * @param {?} features
     * @return {?}
     */
    MapService.prototype.getFeatureBounds = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        var _this = this;
        /** @type {?} */
        var bounds = (/** @type {?} */ ((/** @type {?} */ (new google.maps.LatLngBounds()))));
        /** @type {?} */
        var polygonLatLngLiteralsCollection = this.getPolygonsLatLngLiteralsFromFeatures(features);
        /** @type {?} */
        var markerLatLngLiterals = features
            .filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Point'; }))
            .map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.getMarkerLatLngLiterals(((/** @type {?} */ (x.geometry))).coordinates); }));
        polygonLatLngLiteralsCollection.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.forEach((/**
         * @param {?} y
         * @return {?}
         */
        function (y) { return bounds.extend(y); })); }));
        markerLatLngLiterals.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return bounds.extend(x); }));
        return !bounds.isEmpty() ? bounds : null;
    };
    /**
     * @param {?} features
     * @return {?}
     */
    MapService.prototype.getPolygonsLatLngLiteralsFromFeatures = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        var _this = this;
        return features
            .filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Polygon'; }))
            .map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.getPolygonLatLngLiterals(((/** @type {?} */ (x.geometry))).coordinates); }));
    };
    /**
     * @param {?} coordinates
     * @return {?}
     */
    MapService.prototype.getPolygonBounds = /**
     * @param {?} coordinates
     * @return {?}
     */
    function (coordinates) {
        /** @type {?} */
        var bounds = (/** @type {?} */ ((/** @type {?} */ (new google.maps.LatLngBounds()))));
        /** @type {?} */
        var latLngLiterals = this.getPolygonLatLngLiterals(coordinates);
        latLngLiterals.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return bounds.extend(x); }));
        return bounds;
    };
    /**
     * @param {?} coordinates
     * @return {?}
     */
    MapService.prototype.getMarkerBounds = /**
     * @param {?} coordinates
     * @return {?}
     */
    function (coordinates) {
        /** @type {?} */
        var bounds = (/** @type {?} */ ((/** @type {?} */ (new google.maps.LatLngBounds()))));
        /** @type {?} */
        var latLngLiteral = this.getMarkerLatLngLiterals(coordinates);
        bounds.extend(latLngLiteral);
        return bounds;
    };
    /**
     * @private
     * @param {?} coordinatesCollection
     * @return {?}
     */
    MapService.prototype.getPolygonLatLngLiterals = /**
     * @private
     * @param {?} coordinatesCollection
     * @return {?}
     */
    function (coordinatesCollection) {
        return coordinatesCollection[0].map((/**
         * @param {?} coordinates
         * @return {?}
         */
        function (coordinates) {
            return new google.maps.LatLng(coordinates[1], coordinates[0]);
        }));
    };
    /**
     * @private
     * @param {?} coordinates
     * @return {?}
     */
    MapService.prototype.getMarkerLatLngLiterals = /**
     * @private
     * @param {?} coordinates
     * @return {?}
     */
    function (coordinates) {
        return { lat: coordinates[1], lng: coordinates[0] };
    };
    MapService.decorators = [
        { type: Injectable }
    ];
    return MapService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapComponent = /** @class */ (function () {
    function MapComponent(featuresStore, mapService) {
        this.featuresStore = featuresStore;
        this.mapService = mapService;
        this.mapIsReady = false;
        this.polygonCfg = new PolygonConfig();
        this.isMapDisabled = false;
        this.markerCfg = new MarkerConfig();
        this.mapCfg = new MapConfig();
        this.fitBoundsVal = false;
        this.featureCollection = new Array();
        this.featuresChange = new EventEmitter();
    }
    Object.defineProperty(MapComponent.prototype, "isDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.isMapDisabled;
        },
        set: /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.isMapDisabled = isDisabled;
            if (this.mapIsReady) {
                this.drawingOptions.drawingControl = this.isMapDisabled === false ?
                    this.polygonCfg.drawingEnabled || this.markerCfg.drawingEnabled : false;
                this.googleDrawingManager.setOptions(this.drawingOptions);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "features", {
        get: /**
         * @return {?}
         */
        function () {
            return this.featureCollection;
        },
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            this.featureCollection = features;
            if (this.mapIsReady && features && features.length > 0) {
                this.fitBoundsVal = this.mapService.getFeatureBounds(features);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "mapConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.mapCfg;
        },
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            if (config) {
                this.mapCfg = config;
                this.fitBoundsVal = config.fitBounds ? config.fitBounds : false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "polygonConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygonCfg;
        },
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            if (config) {
                this.polygonCfg = config;
                if (this.mapIsReady) {
                    this.drawingOptions.drawingControl = this.polygonCfg.drawingEnabled || this.markerCfg.drawingEnabled;
                    this.googleDrawingManager.setOptions(this.drawingOptions);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "markerConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.markerCfg;
        },
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            if (config) {
                this.markerCfg = config;
                if (this.mapIsReady) {
                    this.drawingOptions.drawingControl = this.polygonCfg.drawingEnabled || this.markerCfg.drawingEnabled;
                    this.googleDrawingManager.setOptions(this.drawingOptions);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "drawingManager", {
        get: /**
         * @return {?}
         */
        function () {
            return this.googleDrawingManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "drawingManagerOptions", {
        get: /**
         * @return {?}
         */
        function () {
            return this.drawingOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "fitBounds", {
        get: /**
         * @return {?}
         */
        function () {
            return this.fitBoundsVal;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.drawingOptions = {
            drawingMode: null,
            drawingControl: this.isMapDisabled === false ? this.polygonCfg.drawingEnabled || this.markerCfg.drawingEnabled : false,
            drawingControlOptions: {
                drawingModes: new Array()
            }
        };
        this.subscribeToFeatures();
    };
    /**
     * @return {?}
     */
    MapComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.featuresSubscription) {
            this.featuresSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} googleMap
     * @return {?}
     */
    MapComponent.prototype.onMapReady = /**
     * @param {?} googleMap
     * @return {?}
     */
    function (googleMap) {
        this.mapIsReady = true;
        this.drawingOptions.drawingControlOptions.position = google.maps.ControlPosition.TOP_CENTER;
        this.googleDrawingManager = new google.maps.drawing.DrawingManager(this.drawingOptions);
        this.googleDrawingManager.setMap(googleMap);
        if (this.features && this.features.length > 0) {
            this.fitBoundsVal = this.mapService.getFeatureBounds(this.features);
        }
    };
    /**
     * @private
     * @return {?}
     */
    MapComponent.prototype.subscribeToFeatures = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.featuresSubscription = this.featuresStore.features$
            .pipe(startWith([null]), pairwise(), filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return JSON.stringify(prev) !== JSON.stringify(current);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return current;
        })), filter((/**
         * @param {?} features
         * @return {?}
         */
        function (features) { return features !== null; })))
            .subscribe((/**
         * @param {?} features
         * @return {?}
         */
        function (features) { return _this.featuresChange.emit(features); }));
    };
    MapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-map',
                    template: "<agm-map [latitude]=\"mapConfig.latitude\" [longitude]=\"mapConfig.longitude\" [zoom]=\"mapConfig.zoom\"\r\n    [fullscreenControl]=\"mapConfig.fullscreenControl\" [mapTypeControl]=\"mapConfig.mapTypeControl\"\r\n    [mapTypeControlOptions]=\"mapConfig.mapTypeControlOptions\" [mapTypeId]=\"mapConfig.mapTypeId\" [fitBounds]=\"fitBounds\"\r\n    (mapReady)=\"onMapReady($event)\">\r\n\r\n    <app-polygon [drawingManager]=\"drawingManager\" [drawingManagerOptions]=\"drawingManagerOptions\"\r\n        [polygonConfig]=\"polygonConfig\" [features]=\"features\" [isDisabled]=\"isDisabled\">\r\n    </app-polygon>\r\n\r\n    <app-marker [drawingManager]=\"drawingManager\" [drawingManagerOptions]=\"drawingManagerOptions\"\r\n        [markerConfig]=\"markerConfig\" [features]=\"features\" [isDisabled]=\"isDisabled\">\r\n    </app-marker>\r\n\r\n    <app-data-layer *ngIf=\"geoJsonUrl\" [geoJsonUrl]=\"geoJsonUrl\"></app-data-layer>\r\n</agm-map>\r\n",
                    providers: [FeaturesStoreService, MapService],
                    styles: ["agm-map{height:100%}"]
                }] }
    ];
    /** @nocollapse */
    MapComponent.ctorParameters = function () { return [
        { type: FeaturesStoreService },
        { type: MapService }
    ]; };
    MapComponent.propDecorators = {
        geoJsonUrl: [{ type: Input }],
        isDisabled: [{ type: Input }],
        features: [{ type: Input }],
        mapConfig: [{ type: Input }],
        polygonConfig: [{ type: Input }],
        markerConfig: [{ type: Input }],
        featuresChange: [{ type: Output }]
    };
    return MapComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.googleDrawingManager;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.drawingOptions;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.featuresSubscription;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.mapIsReady;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.polygonCfg;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.isMapDisabled;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.markerCfg;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.mapCfg;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.fitBoundsVal;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.featureCollection;
    /** @type {?} */
    MapComponent.prototype.geoJsonUrl;
    /** @type {?} */
    MapComponent.prototype.featuresChange;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.featuresStore;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.mapService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarkerStoreService = /** @class */ (function () {
    function MarkerStoreService() {
        this.markersSubject = new BehaviorSubject(new Array());
    }
    Object.defineProperty(MarkerStoreService.prototype, "markers$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.markersSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerStoreService.prototype, "markers", {
        get: /**
         * @return {?}
         */
        function () {
            return this.markersSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} markers
     * @return {?}
     */
    MarkerStoreService.prototype.setMarkers = /**
     * @param {?} markers
     * @return {?}
     */
    function (markers) {
        this.markersSubject.next(markers);
    };
    /**
     * @param {?} marker
     * @return {?}
     */
    MarkerStoreService.prototype.addMarker = /**
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        /** @type {?} */
        var newMarkers = __spread(this.markersSubject.value, [marker]);
        this.markersSubject.next(newMarkers);
    };
    /**
     * @param {?} marker
     * @return {?}
     */
    MarkerStoreService.prototype.deleteMarker = /**
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        /** @type {?} */
        var markers = this.markersSubject.value.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x !== marker; }));
        this.markersSubject.next(markers);
    };
    MarkerStoreService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MarkerStoreService.ctorParameters = function () { return []; };
    return MarkerStoreService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MarkerStoreService.prototype.markersSubject;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Marker = /** @class */ (function () {
    function Marker(animation, clickable, editable, iconUrl, label, latitude, longitude, opacity, openInfoWindow, title, visible, zIndex, id, name) {
        this.animation = animation;
        this.clickable = clickable;
        this.editable = editable;
        this.iconUrl = iconUrl;
        this.label = label;
        this.latitude = latitude;
        this.longitude = longitude;
        this.opacity = opacity;
        this.openInfoWindow = openInfoWindow;
        this.title = title;
        this.visible = visible;
        this.zIndex = zIndex;
        this.id = id;
        this.name = name;
    }
    return Marker;
}());
if (false) {
    /** @type {?} */
    Marker.prototype.animation;
    /** @type {?} */
    Marker.prototype.clickable;
    /** @type {?} */
    Marker.prototype.editable;
    /** @type {?} */
    Marker.prototype.iconUrl;
    /** @type {?} */
    Marker.prototype.label;
    /** @type {?} */
    Marker.prototype.latitude;
    /** @type {?} */
    Marker.prototype.longitude;
    /** @type {?} */
    Marker.prototype.opacity;
    /** @type {?} */
    Marker.prototype.openInfoWindow;
    /** @type {?} */
    Marker.prototype.title;
    /** @type {?} */
    Marker.prototype.visible;
    /** @type {?} */
    Marker.prototype.zIndex;
    /** @type {?} */
    Marker.prototype.id;
    /** @type {?} */
    Marker.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarkerService = /** @class */ (function () {
    function MarkerService(markerStore, featuresStore) {
        this.markerStore = markerStore;
        this.featuresStore = featuresStore;
        this.defaultZIndex = 1;
        this.googleMapsAnimationBounce = 1;
        this.googleMapsAnimationDrop = 2;
        this.defaultOptions = {
            animation: this.googleMapsAnimationDrop,
            clickable: true,
            draggable: true,
            icon: 'https://mts.googleapis.com/vt/icon/name=icons/spotlight/spotlight-waypoint-b.png',
            opacity: 1,
            visible: true,
            zIndex: this.defaultZIndex
        };
    }
    Object.defineProperty(MarkerService.prototype, "markerDefaultOptions", {
        get: /**
         * @return {?}
         */
        function () {
            return this.defaultOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerService.prototype, "markers$", {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.markerStore.markers$
                .pipe(tap((/**
             * @param {?} markers
             * @return {?}
             */
            function (markers) { return _this.setFeatures(markers); })));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerService.prototype, "markers", {
        get: /**
         * @return {?}
         */
        function () {
            return this.markerStore.markers;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} drawingManager
     * @return {?}
     */
    MarkerService.prototype.setMarkerCompleteEventListener = /**
     * @param {?} drawingManager
     * @return {?}
     */
    function (drawingManager) {
        var _this = this;
        return google.maps.event.addListener(drawingManager, 'markercomplete', (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var marker = _this.createMarker(event, v4());
            _this.markerStore.addMarker(marker);
            event.setMap(null);
        }));
    };
    /**
     * @param {?} markers
     * @return {?}
     */
    MarkerService.prototype.setMarkers = /**
     * @param {?} markers
     * @return {?}
     */
    function (markers) {
        markers = markers && markers.length > 0 ? markers : new Array();
        this.markerStore.setMarkers(markers);
    };
    /**
     * @param {?} editable
     * @return {?}
     */
    MarkerService.prototype.updateMarkerEditableSetting = /**
     * @param {?} editable
     * @return {?}
     */
    function (editable) {
        if (this.markerStore.markers && this.markerStore.markers.length > 0) {
            /** @type {?} */
            var markers = this.markerStore.markers.map((/**
             * @param {?} marker
             * @return {?}
             */
            function (marker) {
                marker.editable = editable;
                return marker;
            }));
            this.markerStore.setMarkers(markers);
        }
    };
    /**
     * @param {?} marker
     * @param {?} $event
     * @return {?}
     */
    MarkerService.prototype.onMarkerDragEnd = /**
     * @param {?} marker
     * @param {?} $event
     * @return {?}
     */
    function (marker, $event) {
        /** @type {?} */
        var options = {
            animation: marker.animation === 'BOUNCE' ? this.googleMapsAnimationBounce : this.googleMapsAnimationDrop,
            clickable: marker.clickable,
            draggable: marker.editable,
            icon: marker.iconUrl,
            label: marker.label,
            opacity: marker.opacity,
            // tslint:disable-next-line: no-string-literal
            position: { lat: $event['coords'].lat, lng: $event['coords'].lng },
            title: marker.title,
            visible: marker.visible,
            zIndex: marker.zIndex
        };
        /** @type {?} */
        var googleMarker = new google.maps.Marker(options);
        this.markerStore.deleteMarker(marker);
        /** @type {?} */
        var newMarker = this.createMarker(googleMarker, marker.id, marker.name);
        this.markerStore.addMarker(newMarker);
    };
    /**
     * @param {?} marker
     * @return {?}
     */
    MarkerService.prototype.deleteMarker = /**
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        this.markerStore.deleteMarker(marker);
    };
    /**
     * @param {?} options
     * @param {?} coordinates
     * @param {?} properties
     * @param {?=} id
     * @return {?}
     */
    MarkerService.prototype.mapFeatureToMarker = /**
     * @param {?} options
     * @param {?} coordinates
     * @param {?} properties
     * @param {?=} id
     * @return {?}
     */
    function (options, coordinates, 
    // tslint:disable-next-line: no-any
    properties, id) {
        /** @type {?} */
        var animation = options.animation === this.googleMapsAnimationBounce ? 'BOUNCE' : 'DROP';
        /** @type {?} */
        var icon = properties.iconUrl ? properties.iconUrl : options.icon;
        /** @type {?} */
        var markerId = id ? id : v4();
        return new Marker(animation, options.clickable, options.draggable, icon, (/** @type {?} */ (options.label)), coordinates[1], coordinates[0], options.opacity, false, options.title, options.visible, options.zIndex, markerId, properties.name);
    };
    /**
     * @private
     * @param {?} markers
     * @return {?}
     */
    MarkerService.prototype.setFeatures = /**
     * @private
     * @param {?} markers
     * @return {?}
     */
    function (markers) {
        var _this = this;
        /** @type {?} */
        var otherFeatures = this.featuresStore.features ?
            this.featuresStore.features.filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.geometry.type !== 'Point'; })) :
            new Array();
        if (markers && markers.length > 0) {
            /** @type {?} */
            var markerfeatures = markers.map((/**
             * @param {?} marker
             * @return {?}
             */
            function (marker) { return _this.createFeature(marker); }));
            /** @type {?} */
            var newFeatures = otherFeatures.concat(markerfeatures);
            this.featuresStore.setFeatures(newFeatures);
        }
        else {
            this.featuresStore.setFeatures(otherFeatures);
        }
    };
    /**
     * @private
     * @param {?} marker
     * @return {?}
     */
    MarkerService.prototype.createFeature = /**
     * @private
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        return {
            type: 'Feature',
            id: marker.id,
            geometry: {
                type: 'Point',
                coordinates: [marker.longitude, marker.latitude]
            },
            properties: {
                iconUrl: marker.iconUrl,
                name: marker.name
            }
        };
    };
    /**
     * @private
     * @param {?} marker
     * @param {?} id
     * @param {?=} name
     * @return {?}
     */
    MarkerService.prototype.createMarker = /**
     * @private
     * @param {?} marker
     * @param {?} id
     * @param {?=} name
     * @return {?}
     */
    function (marker, id, name) {
        /** @type {?} */
        var animation = marker.getAnimation() === this.googleMapsAnimationBounce ? 'BOUNCE' : 'DROP';
        /** @type {?} */
        var googleMarkerLabel = marker.getLabel();
        /** @type {?} */
        var label = googleMarkerLabel ? {
            color: googleMarkerLabel.color,
            fontFamily: googleMarkerLabel.fontFamily,
            fontSize: googleMarkerLabel.fontSize,
            fontWeight: googleMarkerLabel.fontWeight,
            text: googleMarkerLabel.text
        } : null;
        return new Marker(animation, marker.getClickable(), marker.getDraggable(), String(marker.getIcon()), label, marker.getPosition().lat(), marker.getPosition().lng(), marker.getOpacity(), false, marker.getTitle(), marker.getVisible(), marker.getZIndex(), id, name);
    };
    MarkerService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MarkerService.ctorParameters = function () { return [
        { type: MarkerStoreService },
        { type: FeaturesStoreService }
    ]; };
    return MarkerService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MarkerService.prototype.defaultZIndex;
    /**
     * @type {?}
     * @private
     */
    MarkerService.prototype.googleMapsAnimationBounce;
    /**
     * @type {?}
     * @private
     */
    MarkerService.prototype.googleMapsAnimationDrop;
    /**
     * @type {?}
     * @private
     */
    MarkerService.prototype.defaultOptions;
    /**
     * @type {?}
     * @private
     */
    MarkerService.prototype.markerStore;
    /**
     * @type {?}
     * @private
     */
    MarkerService.prototype.featuresStore;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarkerComponent = /** @class */ (function () {
    function MarkerComponent(markerService, featuresStore) {
        this.markerService = markerService;
        this.featuresStore = featuresStore;
        this.drawingReady = false;
        this.isMapDisabled = false;
        this.config = new MarkerConfig();
        this.markerFeaturesSubject = new BehaviorSubject(new Array());
        this.markerOptions = this.markerService.markerDefaultOptions;
        this.drawingOptions = {
            markerOptions: this.markerOptions
        };
    }
    Object.defineProperty(MarkerComponent.prototype, "isDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.isMapDisabled;
        },
        set: /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.isMapDisabled = isDisabled;
            if (this.config) {
                this.markerOptions.draggable = this.checkIfMapIsDisabledAndSetEditableValue(this.config);
                this.markerService.updateMarkerEditableSetting(this.checkIfMapIsDisabledAndSetEditableValue(this.config));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerComponent.prototype, "drawingManager", {
        set: /**
         * @param {?} drawingManager
         * @return {?}
         */
        function (drawingManager) {
            var _this = this;
            if (drawingManager) {
                this.drawingReady = true;
                this.googleDrawingManager = drawingManager;
                if (this.config.drawingEnabled) {
                    this.drawingOptions.drawingControlOptions.drawingModes.push(google.maps.drawing.OverlayType.MARKER);
                }
                this.googleDrawingManager.setOptions(this.drawingOptions);
                this.markerCompleteEventListener = this.markerService.setMarkerCompleteEventListener(drawingManager);
                /** @type {?} */
                var markers = this.markerFeaturesSubject.getValue()
                    // tslint:disable-next-line: no-string-literal
                    .map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return _this.markerService.mapFeatureToMarker(_this.markerOptions, x.geometry['coordinates'], x.properties, x.id); }));
                this.markerService.setMarkers(markers);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerComponent.prototype, "drawingManagerOptions", {
        set: /**
         * @param {?} options
         * @return {?}
         */
        function (options) {
            if (options) {
                this.drawingOptions = options;
                this.drawingOptions.markerOptions = this.markerOptions;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerComponent.prototype, "markerConfig", {
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            if (config) {
                this.config = config;
                this.markerOptions.draggable = this.checkIfMapIsDisabledAndSetEditableValue(config);
                this.drawingOptions.markerOptions = this.markerOptions;
                this.markerService.updateMarkerEditableSetting(this.checkIfMapIsDisabledAndSetEditableValue(config));
                if (this.drawingIsReady) {
                    /** @type {?} */
                    var markerOverlayType = this.drawingOptions.drawingControlOptions.drawingModes
                        .find((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return x === google.maps.drawing.OverlayType.MARKER; }));
                    if (config.drawingEnabled && !markerOverlayType) {
                        this.drawingOptions.drawingControlOptions.drawingModes.push(google.maps.drawing.OverlayType.MARKER);
                    }
                    if (!config.drawingEnabled && markerOverlayType) {
                        this.drawingOptions.drawingControlOptions.drawingModes = this.drawingOptions.drawingControlOptions.drawingModes
                            .filter((/**
                         * @param {?} x
                         * @return {?}
                         */
                        function (x) { return x !== google.maps.drawing.OverlayType.MARKER; }));
                    }
                    this.googleDrawingManager.setOptions(this.drawingOptions);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerComponent.prototype, "features", {
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            var _this = this;
            /** @type {?} */
            var markerFeatures = features && features.length > 0 ?
                features.filter((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x.geometry.type === 'Point'; })) :
                new Array();
            /** @type {?} */
            var currentMarkerFeatures = this.featuresStore.features && this.featuresStore.features.length > 0 ?
                this.featuresStore.features.filter((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x.geometry.type === 'Point'; })) :
                new Array();
            if (markerFeatures.length > 0 && this.config.drawingEnabled && this.config.singleMarkerDrawing) {
                this.config.drawingEnabled = false;
                this.markerConfig = this.config;
            }
            if (JSON.stringify(markerFeatures) !== JSON.stringify(currentMarkerFeatures)) {
                if (this.drawingIsReady) {
                    /** @type {?} */
                    var markers = markerFeatures
                        // tslint:disable-next-line: no-string-literal
                        .map((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return _this.markerService.mapFeatureToMarker(_this.markerOptions, x.geometry['coordinates'], x.properties, x.id); }));
                    this.markerService.setMarkers(markers);
                }
                else {
                    this.markerFeaturesSubject.next(markerFeatures);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerComponent.prototype, "drawingIsReady", {
        get: /**
         * @return {?}
         */
        function () {
            return this.drawingReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkerComponent.prototype, "markers$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.markersSource$;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MarkerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.markersSource$ = this.markerService.markers$;
    };
    /**
     * @return {?}
     */
    MarkerComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.markerCompleteEventListener) {
            this.markerCompleteEventListener.remove();
        }
    };
    /**
     * @param {?} marker
     * @return {?}
     */
    MarkerComponent.prototype.deleteMarker = /**
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        this.markerService.deleteMarker(marker);
        if (this.markerService.markers && this.markerService.markers.length === 0 &&
            !this.config.drawingEnabled && this.config.singleMarkerDrawing) {
            this.config.drawingEnabled = true;
            this.markerConfig = this.config;
            this.drawingOptions.drawingControl = this.config.drawingEnabled;
            this.googleDrawingManager.setOptions(this.drawingOptions);
        }
    };
    /**
     * @param {?} marker
     * @param {?} $event
     * @return {?}
     */
    MarkerComponent.prototype.onDragEnd = /**
     * @param {?} marker
     * @param {?} $event
     * @return {?}
     */
    function (marker, $event) {
        this.markerService.onMarkerDragEnd(marker, $event);
    };
    /**
     * @param {?} config
     * @return {?}
     */
    MarkerComponent.prototype.checkIfMapIsDisabledAndSetEditableValue = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return this.isMapDisabled === false ? config.editable : false;
    };
    MarkerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-marker',
                    template: "<ng-container *ngIf=\"drawingIsReady\">\r\n    <agm-marker *ngFor=\"let marker of markers$ | async\" [latitude]=\"marker.latitude\" [longitude]=\"marker.longitude\"\r\n        [title]=\"marker.title\" [label]=\"marker.label\" [markerDraggable]=\"marker.editable\" [iconUrl]=\"marker.iconUrl\"\r\n        [visible]=\"marker.visible\" [openInfoWindow]=\"marker.openInfoWindow\" [opacity]=\"marker.opacity\"\r\n        [zIndex]=\"marker.zIndex\" [markerClickable]=\"marker.clickable\" [animation]=\"marker.animation\"\r\n        (dragEnd)=\"onDragEnd(marker, $event)\">\r\n        <agm-snazzy-info-window [maxWidth]=\"800\" [closeWhenOthersOpen]=\"true\">\r\n            <ng-template>\r\n                <div class=\"d-flex align-items-center justify-content-between border py-1 pl-2 pr-1\">\r\n                    <div class=\"marker-content\" [innerHTML]=\"marker.name\"></div>\r\n                    <div *ngIf=\"marker.editable\">\r\n                        <button (click)=\"deleteMarker(marker)\"\r\n                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-danger\">\r\n                        <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </agm-snazzy-info-window>\r\n    </agm-marker>\r\n</ng-container>\r\n",
                    providers: [MarkerService, MarkerStoreService]
                }] }
    ];
    /** @nocollapse */
    MarkerComponent.ctorParameters = function () { return [
        { type: MarkerService },
        { type: FeaturesStoreService }
    ]; };
    MarkerComponent.propDecorators = {
        isDisabled: [{ type: Input }],
        drawingManager: [{ type: Input }],
        drawingManagerOptions: [{ type: Input }],
        markerConfig: [{ type: Input }],
        features: [{ type: Input }]
    };
    return MarkerComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.markersSource$;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.googleDrawingManager;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.drawingOptions;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.markerCompleteEventListener;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.markerOptions;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.drawingReady;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.isMapDisabled;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.config;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.markerFeaturesSubject;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.markerService;
    /**
     * @type {?}
     * @private
     */
    MarkerComponent.prototype.featuresStore;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolygonStoreService = /** @class */ (function () {
    function PolygonStoreService() {
        this.polygonsSubject = new BehaviorSubject(new Array());
    }
    Object.defineProperty(PolygonStoreService.prototype, "polygons$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygonsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonStoreService.prototype, "polygons", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygonsSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} polygons
     * @return {?}
     */
    PolygonStoreService.prototype.setPolygons = /**
     * @param {?} polygons
     * @return {?}
     */
    function (polygons) {
        this.polygonsSubject.next(polygons);
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    PolygonStoreService.prototype.addPolygon = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var newPolygons = __spread(this.polygonsSubject.value, [polygon]);
        this.polygonsSubject.next(newPolygons);
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    PolygonStoreService.prototype.deletePolygon = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var polygons = this.polygonsSubject.value.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x !== polygon; }));
        this.polygonsSubject.next(polygons);
    };
    PolygonStoreService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PolygonStoreService.ctorParameters = function () { return []; };
    return PolygonStoreService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PolygonStoreService.prototype.polygonsSubject;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Polygon = /** @class */ (function () {
    function Polygon(clickable, draggable, editable, fillColor, fillOpacity, geodesic, paths, strokeColor, strokeOpacity, strokeWeight, visible, zIndex, center, area, showInfoWindow, id, name, navigate) {
        this.clickable = clickable;
        this.draggable = draggable;
        this.editable = editable;
        this.fillColor = fillColor;
        this.fillOpacity = fillOpacity;
        this.geodesic = geodesic;
        this.paths = paths;
        this.strokeColor = strokeColor;
        this.strokeOpacity = strokeOpacity;
        this.strokeWeight = strokeWeight;
        this.visible = visible;
        this.zIndex = zIndex;
        this.center = center;
        this.area = area;
        this.showInfoWindow = showInfoWindow;
        this.id = id;
        this.name = name;
        this.navigate = navigate;
    }
    return Polygon;
}());
if (false) {
    /** @type {?} */
    Polygon.prototype.clickable;
    /** @type {?} */
    Polygon.prototype.draggable;
    /** @type {?} */
    Polygon.prototype.editable;
    /** @type {?} */
    Polygon.prototype.fillColor;
    /** @type {?} */
    Polygon.prototype.fillOpacity;
    /** @type {?} */
    Polygon.prototype.geodesic;
    /** @type {?} */
    Polygon.prototype.paths;
    /** @type {?} */
    Polygon.prototype.strokeColor;
    /** @type {?} */
    Polygon.prototype.strokeOpacity;
    /** @type {?} */
    Polygon.prototype.strokeWeight;
    /** @type {?} */
    Polygon.prototype.visible;
    /** @type {?} */
    Polygon.prototype.zIndex;
    /** @type {?} */
    Polygon.prototype.center;
    /** @type {?} */
    Polygon.prototype.area;
    /** @type {?} */
    Polygon.prototype.showInfoWindow;
    /** @type {?} */
    Polygon.prototype.id;
    /** @type {?} */
    Polygon.prototype.name;
    /** @type {?} */
    Polygon.prototype.navigate;
}
var PolygonCenter = /** @class */ (function () {
    function PolygonCenter(lat, lng) {
        this.lat = lat;
        this.lng = lng;
    }
    return PolygonCenter;
}());
if (false) {
    /** @type {?} */
    PolygonCenter.prototype.lat;
    /** @type {?} */
    PolygonCenter.prototype.lng;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolygonService = /** @class */ (function () {
    function PolygonService(polygonStore, featuresStore, decimalPipe) {
        this.polygonStore = polygonStore;
        this.featuresStore = featuresStore;
        this.decimalPipe = decimalPipe;
        this.defaultZIndex = 1;
        this.meterToHa = 10000;
        this.defaultOptions = {
            clickable: true,
            draggable: false,
            editable: true,
            fillOpacity: 0.35,
            geodesic: true,
            strokeOpacity: 0.8,
            strokeWeight: 3,
            visible: true
        };
    }
    Object.defineProperty(PolygonService.prototype, "polygonDefaultOptions", {
        get: /**
         * @return {?}
         */
        function () {
            return this.defaultOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonService.prototype, "polygons$", {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.polygonStore.polygons$
                .pipe(tap((/**
             * @param {?} polygons
             * @return {?}
             */
            function (polygons) { return _this.setFeatures(polygons); })));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonService.prototype, "polygons", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygonStore.polygons;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} drawingManager
     * @return {?}
     */
    PolygonService.prototype.setPolygonCompleteEventListener = /**
     * @param {?} drawingManager
     * @return {?}
     */
    function (drawingManager) {
        var _this = this;
        return google.maps.event.addListener(drawingManager, 'polygoncomplete', (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var polygon = _this.createPolygon(event, v4());
            _this.polygonStore.addPolygon(polygon);
            event.setMap(null);
        }));
    };
    /**
     * @param {?} polygons
     * @return {?}
     */
    PolygonService.prototype.setPolygons = /**
     * @param {?} polygons
     * @return {?}
     */
    function (polygons) {
        polygons = polygons && polygons.length > 0 ? polygons : new Array();
        this.polygonStore.setPolygons(polygons);
    };
    /**
     * @param {?} editable
     * @return {?}
     */
    PolygonService.prototype.updatePolygonEditableSetting = /**
     * @param {?} editable
     * @return {?}
     */
    function (editable) {
        if (this.polygonStore.polygons && this.polygonStore.polygons.length > 0) {
            /** @type {?} */
            var polygons = this.polygonStore.polygons.map((/**
             * @param {?} polygon
             * @return {?}
             */
            function (polygon) {
                polygon.editable = editable;
                return polygon;
            }));
            this.polygonStore.setPolygons(polygons);
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} polygon
     * @param {?} $event
     * @return {?}
     */
    PolygonService.prototype.onPolygonPathsChange = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} polygon
     * @param {?} $event
     * @return {?}
     */
    function (polygon, $event) {
        /** @type {?} */
        var options = {
            clickable: polygon.clickable,
            draggable: polygon.draggable,
            editable: polygon.editable,
            fillColor: polygon.fillColor,
            fillOpacity: polygon.fillOpacity,
            geodesic: polygon.geodesic,
            paths: this.createLatLngLiteralDoubleArrayFromChangedPaths($event.newArr),
            // wrong event newArr type!
            strokeColor: polygon.strokeColor,
            strokeOpacity: polygon.strokeOpacity,
            strokeWeight: polygon.strokeWeight,
            visible: polygon.visible,
            zIndex: polygon.zIndex,
        };
        /** @type {?} */
        var googlePolygon = new google.maps.Polygon(options);
        this.polygonStore.deletePolygon(polygon);
        /** @type {?} */
        var newPolygon = this.createPolygon(googlePolygon, polygon.id, polygon.name, polygon.navigate);
        this.polygonStore.addPolygon(newPolygon);
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    PolygonService.prototype.deletePolygon = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        this.polygonStore.deletePolygon(polygon);
    };
    /**
     * @param {?} options
     * @param {?} coordinates
     * @param {?} properties
     * @param {?=} id
     * @return {?}
     */
    PolygonService.prototype.mapFeatureToPolygon = /**
     * @param {?} options
     * @param {?} coordinates
     * @param {?} properties
     * @param {?=} id
     * @return {?}
     */
    function (options, coordinates, 
    // tslint:disable-next-line: no-any
    properties, id) {
        options.fillColor = properties.fillColor ? properties.fillColor : options.fillColor;
        options.fillOpacity = properties.fillOpacity ? properties.fillOpacity : options.fillOpacity;
        options.strokeColor = properties.strokeColor ? properties.strokeColor : options.strokeColor;
        options.strokeOpacity = properties.strokeOpacity ? properties.strokeOpacity : options.strokeOpacity;
        options.zIndex = properties.zIndex ? properties.zIndex : options.zIndex;
        options.paths = coordinates.map((/**
         * @param {?} coordinate
         * @return {?}
         */
        function (coordinate) { return coordinate.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return new google.maps.LatLng(x[1], x[0]); })); }));
        /** @type {?} */
        var polygonId = id ? id : v4();
        /** @type {?} */
        var googlePolygon = new google.maps.Polygon(options);
        return this.createPolygon(googlePolygon, polygonId, properties.name, properties.navigate);
    };
    /**
     * @private
     * @param {?} polygons
     * @return {?}
     */
    PolygonService.prototype.setFeatures = /**
     * @private
     * @param {?} polygons
     * @return {?}
     */
    function (polygons) {
        var _this = this;
        /** @type {?} */
        var otherFeatures = this.featuresStore.features ?
            this.featuresStore.features.filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.geometry.type !== 'Polygon'; })) :
            new Array();
        if (polygons && polygons.length > 0) {
            /** @type {?} */
            var polygonFeatures = polygons.map((/**
             * @param {?} polygon
             * @return {?}
             */
            function (polygon) { return _this.createFeature(polygon); }));
            /** @type {?} */
            var newFeatures = otherFeatures.concat(polygonFeatures);
            this.featuresStore.setFeatures(newFeatures);
        }
        else {
            this.featuresStore.setFeatures(otherFeatures);
        }
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    PolygonService.prototype.createFeature = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        return {
            type: 'Feature',
            id: polygon.id,
            geometry: {
                type: 'Polygon',
                coordinates: polygon.paths.map((/**
                 * @param {?} path
                 * @return {?}
                 */
                function (path) { return path.map((/**
                 * @param {?} latLngLiteral
                 * @return {?}
                 */
                function (latLngLiteral) { return [latLngLiteral.lng, latLngLiteral.lat]; })); }))
            },
            properties: {
                area: polygon.area,
                center: polygon.center,
                fillColor: polygon.fillColor,
                strokeColor: polygon.strokeColor,
                zIndex: polygon.zIndex,
                name: polygon.name
            }
        };
    };
    /**
     * @private
     * @param {?} polygon
     * @param {?} id
     * @param {?=} name
     * @param {?=} navigate
     * @return {?}
     */
    PolygonService.prototype.createPolygon = /**
     * @private
     * @param {?} polygon
     * @param {?} id
     * @param {?=} name
     * @param {?=} navigate
     * @return {?}
     */
    function (polygon, id, name, navigate) {
        /** @type {?} */
        var latLngArray = polygon.getPaths().getArray().map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.getArray(); }));
        /** @type {?} */
        var paths = this.createLatLngLiteralDoubleArrayFromLatLngDoubleArray(latLngArray);
        /** @type {?} */
        var polygonCenter = this.calculatePolygonCenter(latLngArray);
        /** @type {?} */
        var area = this.calculateArea(polygon.getPath());
        /** @type {?} */
        var zIndex = this.calculateZIndex(latLngArray);
        return new Polygon(polygon.get('clickable'), polygon.getDraggable(), polygon.getEditable(), polygon.get('fillColor'), polygon.get('fillOpacity'), polygon.get('geodesic'), paths, polygon.get('strokeColor'), polygon.get('strokeOpacity'), polygon.get('strokeWeight'), polygon.getVisible(), zIndex, polygonCenter, area, false, id, name, navigate);
    };
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    PolygonService.prototype.createLatLngLiteralDoubleArrayFromLatLngDoubleArray = /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        return paths.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.map((/**
         * @param {?} y
         * @return {?}
         */
        function (y) {
            return { lat: y.lat(), lng: y.lng() };
        })); }));
    };
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    PolygonService.prototype.calculatePolygonCenter = /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        /** @type {?} */
        var bounds = new google.maps.LatLngBounds();
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < paths[0].length; i++) {
            bounds.extend(paths[0][i]);
        }
        /** @type {?} */
        var center = bounds.getCenter();
        return new PolygonCenter(center.lat(), center.lng());
    };
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    PolygonService.prototype.calculateArea = /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        /** @type {?} */
        var areaValue = google.maps.geometry.spherical.computeArea(paths) / this.meterToHa;
        /** @type {?} */
        var digitsInfo = '1.2-2';
        /** @type {?} */
        var locale = 'en-US';
        /** @type {?} */
        var twoDecimalPointArea = this.decimalPipe.transform(areaValue, digitsInfo, locale);
        return Number(twoDecimalPointArea);
    };
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    PolygonService.prototype.calculateZIndex = /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        if (this.polygonStore.polygons && this.polygonStore.polygons.length > 0) {
            /** @type {?} */
            var zIndexes = this.getZIndexes(paths);
            if (zIndexes.length > 0) {
                zIndexes.sort((/**
                 * @param {?} x
                 * @param {?} y
                 * @return {?}
                 */
                function (x, y) {
                    if (x > y) {
                        return -1;
                    }
                    else if (x < y) {
                        return 1;
                    }
                    return 0;
                }));
                return zIndexes[0];
            }
        }
        return this.defaultZIndex;
    };
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    PolygonService.prototype.getZIndexes = /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        var e_1, _a, e_2, _b, e_3, _c;
        /** @type {?} */
        var zIndexes = new Array();
        try {
            for (var _d = __values(this.polygonStore.polygons), _e = _d.next(); !_e.done; _e = _d.next()) {
                var polygon = _e.value;
                /** @type {?} */
                var options = {
                    paths: polygon.paths
                };
                /** @type {?} */
                var googlePolyon = new google.maps.Polygon(options);
                try {
                    for (var paths_1 = (e_2 = void 0, __values(paths)), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
                        var path = paths_1_1.value;
                        try {
                            for (var path_1 = (e_3 = void 0, __values(path)), path_1_1 = path_1.next(); !path_1_1.done; path_1_1 = path_1.next()) {
                                var point = path_1_1.value;
                                /** @type {?} */
                                var containsLocation = google.maps.geometry.poly.containsLocation(point, googlePolyon);
                                if (containsLocation) {
                                    zIndexes.push(polygon.zIndex + 1);
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (path_1_1 && !path_1_1.done && (_c = path_1.return)) _c.call(path_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (paths_1_1 && !paths_1_1.done && (_b = paths_1.return)) _b.call(paths_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return zIndexes;
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    PolygonService.prototype.createLatLngLiteralDoubleArrayFromChangedPaths = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        return paths.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.map((/**
         * @param {?} y
         * @return {?}
         */
        function (y) {
            return { lat: y.lat, lng: y.lng };
        })); }));
    };
    PolygonService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PolygonService.ctorParameters = function () { return [
        { type: PolygonStoreService },
        { type: FeaturesStoreService },
        { type: DecimalPipe }
    ]; };
    return PolygonService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PolygonService.prototype.defaultZIndex;
    /**
     * @type {?}
     * @private
     */
    PolygonService.prototype.meterToHa;
    /**
     * @type {?}
     * @private
     */
    PolygonService.prototype.defaultOptions;
    /**
     * @type {?}
     * @private
     */
    PolygonService.prototype.polygonStore;
    /**
     * @type {?}
     * @private
     */
    PolygonService.prototype.featuresStore;
    /**
     * @type {?}
     * @private
     */
    PolygonService.prototype.decimalPipe;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolygonComponent = /** @class */ (function () {
    function PolygonComponent(route, polygonService, featuresStore) {
        this.route = route;
        this.polygonService = polygonService;
        this.featuresStore = featuresStore;
        this.drawingReady = false;
        this.isMapDisabled = false;
        this.config = new PolygonConfig();
        this.polygonFeaturesSubject = new BehaviorSubject(new Array());
        this.polygonOptions = this.polygonService.polygonDefaultOptions;
        this.drawingOptions = {
            polygonOptions: this.polygonOptions
        };
    }
    Object.defineProperty(PolygonComponent.prototype, "isDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.isMapDisabled;
        },
        set: /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.isMapDisabled = isDisabled;
            if (this.config) {
                this.polygonOptions.draggable = this.checkIfMapIsDisabledAndSetEditableValue(this.config);
                this.polygonOptions.editable = this.checkIfMapIsDisabledAndSetEditableValue(this.config);
                this.polygonService.updatePolygonEditableSetting(this.checkIfMapIsDisabledAndSetEditableValue(this.config));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonComponent.prototype, "drawingManager", {
        set: /**
         * @param {?} drawingManager
         * @return {?}
         */
        function (drawingManager) {
            var _this = this;
            if (drawingManager) {
                this.drawingReady = true;
                this.googleDrawingManager = drawingManager;
                if (this.config.drawingEnabled) {
                    this.drawingOptions.drawingControlOptions.drawingModes.push(google.maps.drawing.OverlayType.POLYGON);
                }
                this.googleDrawingManager.setOptions(this.drawingOptions);
                this.polygonCompleteEventListener = this.polygonService.setPolygonCompleteEventListener(this.googleDrawingManager);
                /** @type {?} */
                var polygons = this.polygonFeaturesSubject.getValue()
                    // tslint:disable-next-line: no-string-literal
                    .map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return _this.polygonService.mapFeatureToPolygon(_this.polygonOptions, x.geometry['coordinates'], x.properties, x.id); }));
                this.polygonService.setPolygons(polygons);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonComponent.prototype, "drawingManagerOptions", {
        set: /**
         * @param {?} options
         * @return {?}
         */
        function (options) {
            if (options) {
                this.drawingOptions = options;
                this.drawingOptions.polygonOptions = this.polygonOptions;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonComponent.prototype, "polygonConfig", {
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            if (config) {
                this.config = config;
                this.polygonOptions.editable = this.checkIfMapIsDisabledAndSetEditableValue(this.config);
                this.polygonOptions.fillColor = config.drawingColor;
                this.polygonOptions.strokeColor = config.drawingColor;
                this.drawingOptions.polygonOptions = this.polygonOptions;
                this.polygonService.updatePolygonEditableSetting(this.checkIfMapIsDisabledAndSetEditableValue(this.config));
                if (this.drawingIsReady) {
                    /** @type {?} */
                    var polygonOverlayType = this.drawingOptions.drawingControlOptions.drawingModes
                        .find((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return x === google.maps.drawing.OverlayType.POLYGON; }));
                    if (config.drawingEnabled && !polygonOverlayType) {
                        this.drawingOptions.drawingControlOptions.drawingModes.push(google.maps.drawing.OverlayType.POLYGON);
                    }
                    if (!config.drawingEnabled && polygonOverlayType) {
                        this.drawingOptions.drawingControlOptions.drawingModes = this.drawingOptions.drawingControlOptions.drawingModes
                            .filter((/**
                         * @param {?} x
                         * @return {?}
                         */
                        function (x) { return x !== google.maps.drawing.OverlayType.POLYGON; }));
                    }
                    this.googleDrawingManager.setOptions(this.drawingOptions);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonComponent.prototype, "features", {
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            var _this = this;
            /** @type {?} */
            var polygonFeatures = features && features.length > 0 ?
                features.filter((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x.geometry.type === 'Polygon'; })) :
                new Array();
            /** @type {?} */
            var currentPolygonFeatures = this.featuresStore.features && this.featuresStore.features.length > 0 ?
                this.featuresStore.features.filter((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x.geometry.type === 'Polygon'; })) :
                new Array();
            if (polygonFeatures.length > 0 && this.config.drawingEnabled && this.config.singlePolygonDrawing) {
                this.config.drawingEnabled = false;
                this.polygonConfig = this.config;
            }
            if (JSON.stringify(polygonFeatures) !== JSON.stringify(currentPolygonFeatures)) {
                if (this.drawingIsReady) {
                    /** @type {?} */
                    var polygons = polygonFeatures
                        // tslint:disable-next-line: no-string-literal
                        .map((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return _this.polygonService.mapFeatureToPolygon(_this.polygonOptions, x.geometry['coordinates'], x.properties, x.id); }));
                    this.polygonService.setPolygons(polygons);
                }
                else {
                    this.polygonFeaturesSubject.next(polygonFeatures);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonComponent.prototype, "drawingIsReady", {
        get: /**
         * @return {?}
         */
        function () {
            return this.drawingReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonComponent.prototype, "polygons$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygonsSource$;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PolygonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.polygonsSource$ = this.polygonService.polygons$;
    };
    /**
     * @return {?}
     */
    PolygonComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.polygonCompleteEventListener) {
            this.polygonCompleteEventListener.remove();
        }
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    PolygonComponent.prototype.deletePolygon = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        this.polygonService.deletePolygon(polygon);
        if (this.polygonService.polygons && this.polygonService.polygons.length === 0 &&
            !this.config.drawingEnabled && this.config.singlePolygonDrawing) {
            this.config.drawingEnabled = true;
            this.polygonConfig = this.config;
            this.drawingOptions.drawingControl = this.config.drawingEnabled;
            this.googleDrawingManager.setOptions(this.drawingOptions);
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} polygon
     * @param {?} $event
     * @return {?}
     */
    PolygonComponent.prototype.onPolygonPathsChange = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} polygon
     * @param {?} $event
     * @return {?}
     */
    function (polygon, $event) {
        this.polygonService.onPolygonPathsChange(polygon, $event);
    };
    /**
     * @param {?} polygon
     * @param {?} $event
     * @return {?}
     */
    PolygonComponent.prototype.onPolygonClick = /**
     * @param {?} polygon
     * @param {?} $event
     * @return {?}
     */
    function (polygon, $event) {
        polygon.showInfoWindow = true;
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    PolygonComponent.prototype.displayDetails = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        this.route.navigate(polygon.navigate);
    };
    /**
     * @param {?} config
     * @return {?}
     */
    PolygonComponent.prototype.checkIfMapIsDisabledAndSetEditableValue = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return this.isMapDisabled === false ? config.editable : false;
    };
    PolygonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-polygon',
                    template: "<ng-container *ngIf=\"drawingIsReady\">\r\n    <agm-polygon *ngFor=\"let polygon of polygons$ | async\" [clickable]=\"polygon.clickable\"\r\n    [polyDraggable]=\"polygon.draggable\" [editable]=\"polygon.editable\" [fillColor]=\"polygon.fillColor\"\r\n    [fillOpacity]=\"polygon.fillOpacity\" [geodesic]=\"polygon.geodesic\" [paths]=\"polygon.paths\"\r\n    [strokeColor]=\"polygon.strokeColor\" [strokeOpacity]=\"polygon.strokeOpacity\" [strokeWeight]=\"polygon.strokeWeight\"\r\n    [visible]=\"polygon.visible\" [zIndex]=\"polygon.zIndex\" (polyClick)=\"onPolygonClick(polygon, $event)\"\r\n    (polyPathsChange)=\"onPolygonPathsChange(polygon, $event)\">\r\n    <agm-snazzy-info-window [maxWidth]=\"320\" [closeWhenOthersOpen]=\"true\" [latitude]=\"polygon.center.lat\"\r\n        [longitude]=\"polygon.center.lng\" [isOpen]=\"polygon.showInfoWindow\"\r\n        (afterClose)=\"polygon.showInfoWindow=false\">\r\n        <ng-template>\r\n            <div class=\"border\">\r\n                <div class=\"d-flex align-items-center justify-content-between py-1 pl-2 pr-1\">\r\n                    <div class=\"polygon-content\" [innerHTML]=\"polygon.name\"></div>\r\n\r\n                    <div *ngIf=\"polygon.editable\" class=\"align-self-start ml-2\">\r\n                        <button (click)=\"deletePolygon(polygon)\"\r\n                                class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-danger\">\r\n                            <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"polygon.navigate\" class=\"d-flex align-items-center justify-content-between py-1 pl-2 pr-1\">\r\n                    <a (click)=\"displayDetails(polygon)\" class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                        <i class=\"ft ft-zoom-in\" aria-hidden=\"true\"></i>\r\n                    {{ 'APPLICATION.DETAILS.details:button' | translate }}\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </ng-template>\r\n    </agm-snazzy-info-window>\r\n</agm-polygon>\r\n</ng-container>\r\n",
                    providers: [PolygonService, PolygonStoreService, DecimalPipe]
                }] }
    ];
    /** @nocollapse */
    PolygonComponent.ctorParameters = function () { return [
        { type: Router },
        { type: PolygonService },
        { type: FeaturesStoreService }
    ]; };
    PolygonComponent.propDecorators = {
        isDisabled: [{ type: Input }],
        drawingManager: [{ type: Input }],
        drawingManagerOptions: [{ type: Input }],
        polygonConfig: [{ type: Input }],
        features: [{ type: Input }]
    };
    return PolygonComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.polygonsSource$;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.googleDrawingManager;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.drawingOptions;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.polygonCompleteEventListener;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.polygonOptions;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.drawingReady;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.isMapDisabled;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.config;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.polygonFeaturesSubject;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.polygonService;
    /**
     * @type {?}
     * @private
     */
    PolygonComponent.prototype.featuresStore;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} appConfigurationService
 * @return {?}
 */
function lazyMapsAPILoaderConfigFactory(appConfigurationService) {
    return {
        apiKey: appConfigurationService.configuration.google_maps_api_key,
        apiVersion: '3.64',
        libraries: ['drawing', 'geometry']
    };
}
var GoogleMapsSharedModule = /** @class */ (function () {
    function GoogleMapsSharedModule() {
    }
    GoogleMapsSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MapComponent, PolygonComponent, DataLayerComponent, MarkerComponent],
                    imports: [CommonModule, AgmCoreModule, AgmSnazzyInfoWindowModule, ReactiveFormsModule, TranslationModule],
                    providers: __spread(BROWSER_GLOBALS_PROVIDERS, [
                        { provide: MapsAPILoader, useClass: LazyMapsAPILoader },
                        {
                            provide: LAZY_MAPS_API_CONFIG,
                            useFactory: lazyMapsAPILoaderConfigFactory,
                            deps: [AppConfigurationService]
                        }
                    ]),
                    exports: [MapComponent, PolygonComponent, DataLayerComponent, MarkerComponent]
                },] }
    ];
    return GoogleMapsSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PureGoogleMapsServicesModule = /** @class */ (function () {
    function PureGoogleMapsServicesModule() {
    }
    PureGoogleMapsServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return PureGoogleMapsServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PureMapService = /** @class */ (function () {
    function PureMapService(appConfigurationService) {
        this.appConfigurationService = appConfigurationService;
        this.mapReady = new Subject();
        this.markers = [];
        this.polygons = [];
    }
    /**
     * @param {?} mapDiv
     * @param {?} tilt
     * @return {?}
     */
    PureMapService.prototype.initMap = /**
     * @param {?} mapDiv
     * @param {?} tilt
     * @return {?}
     */
    function (mapDiv, tilt) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadGoogleMaps()];
                    case 1:
                        _a.sent();
                        this.googleMap = new google.maps.Map(mapDiv.nativeElement, {
                            center: { lat: 52.16045455774706, lng: 19.1162109375 },
                            zoom: 7,
                            mapTypeId: 'hybrid',
                            tilt: tilt
                        });
                        this.mapReady.next(this.googleMap);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PureMapService.prototype, "map", {
        get: /**
         * @return {?}
         */
        function () {
            this.assertMapInitialized();
            return this.googleMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} options
     * @return {?}
     */
    PureMapService.prototype.createMarker = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        /** @type {?} */
        var marker = new google.maps.Marker(options);
        marker.setMap(this.map);
        return marker;
    };
    /**
     * @param {?} options
     * @return {?}
     */
    PureMapService.prototype.createSingleMarker = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        this.markers.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            x.setMap(null);
        }));
        /** @type {?} */
        var marker = new google.maps.Marker(options);
        marker.setMap(this.map);
        this.markers.push(marker);
        return marker;
    };
    /**
     * @param {?} options
     * @return {?}
     */
    PureMapService.prototype.createPolygon = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        /** @type {?} */
        var polygon = new google.maps.Polygon(options);
        polygon.setMap(this.map);
        this.polygons.push(polygon);
        return polygon;
    };
    /**
     * @return {?}
     */
    PureMapService.prototype.clearPolygons = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.polygons.forEach((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) { return _this.removePolygon(polygon); }));
        this.polygons = [];
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    PureMapService.prototype.removePolygon = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        polygon.setMap(null);
    };
    /**
     * @param {?} options
     * @return {?}
     */
    PureMapService.prototype.createPolyline = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        /** @type {?} */
        var polyline = new google.maps.Polyline(options);
        polyline.setMap(this.map);
        return polyline;
    };
    /**
     * @param {?} options
     * @return {?}
     */
    PureMapService.prototype.createDrawingManager = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        if (this.drawingManager) {
            this.drawingManager.setMap(null);
        }
        this.drawingManager = new google.maps.drawing.DrawingManager(options);
        this.drawingManager.setMap(this.map);
        return this.drawingManager;
    };
    /**
     * @param {?} zoomValue
     * @return {?}
     */
    PureMapService.prototype.setZoom = /**
     * @param {?} zoomValue
     * @return {?}
     */
    function (zoomValue) {
        this.map.setZoom(zoomValue);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    PureMapService.prototype.centerMap = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.map.setCenter(value);
    };
    /**
     * @param {?} bounds
     * @return {?}
     */
    PureMapService.prototype.fitBounds = /**
     * @param {?} bounds
     * @return {?}
     */
    function (bounds) {
        this.map.fitBounds(bounds);
        this.map.panToBounds(bounds);
    };
    /**
     * @private
     * @return {?}
     */
    PureMapService.prototype.loadGoogleMaps = /**
     * @private
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var loader;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(window['google'] == null)) return [3 /*break*/, 2];
                        loader = new Loader(this.appConfigurationService.configuration.google_maps_api_key, {
                            libraries: ['drawing'],
                            version: '3.64'
                        });
                        return [4 /*yield*/, loader.load()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @private
     * @return {?}
     */
    PureMapService.prototype.assertMapInitialized = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.googleMap == null) {
            throw new Error('Map is not initialized');
        }
    };
    PureMapService.decorators = [
        { type: Injectable, args: [{
                    providedIn: PureGoogleMapsServicesModule
                },] }
    ];
    /** @nocollapse */
    PureMapService.ctorParameters = function () { return [
        { type: AppConfigurationService }
    ]; };
    /** @nocollapse */ PureMapService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PureMapService_Factory() { return new PureMapService(ɵɵinject(AppConfigurationService)); }, token: PureMapService, providedIn: PureGoogleMapsServicesModule });
    return PureMapService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PureMapService.prototype.googleMap;
    /**
     * @type {?}
     * @private
     */
    PureMapService.prototype.drawingManager;
    /** @type {?} */
    PureMapService.prototype.mapReady;
    /**
     * @type {?}
     * @private
     */
    PureMapService.prototype.markers;
    /**
     * @type {?}
     * @private
     */
    PureMapService.prototype.polygons;
    /**
     * @type {?}
     * @private
     */
    PureMapService.prototype.appConfigurationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PureMapComponent = /** @class */ (function () {
    function PureMapComponent(mapService) {
        this.mapService = mapService;
        this.height = 500;
        this.tilt = 45;
    }
    /**
     * @return {?}
     */
    PureMapComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.mapService.initMap(this.mapDiv, this.tilt);
    };
    PureMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-pure-map',
                    template: "<div #mapDiv id=\"map\" [style.height.px]=\"height\"></div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["#map{width:100%;flex-grow:1}:host{flex-grow:1;display:flex;flex-direction:column}"]
                }] }
    ];
    /** @nocollapse */
    PureMapComponent.ctorParameters = function () { return [
        { type: PureMapService }
    ]; };
    PureMapComponent.propDecorators = {
        mapDiv: [{ type: ViewChild, args: ['mapDiv', { static: false },] }],
        height: [{ type: Input }],
        tilt: [{ type: Input }]
    };
    return PureMapComponent;
}());
if (false) {
    /** @type {?} */
    PureMapComponent.prototype.mapDiv;
    /** @type {?} */
    PureMapComponent.prototype.height;
    /** @type {?} */
    PureMapComponent.prototype.tilt;
    /**
     * @type {?}
     * @private
     */
    PureMapComponent.prototype.mapService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PureGoogleMapsSharedModule = /** @class */ (function () {
    function PureGoogleMapsSharedModule() {
    }
    PureGoogleMapsSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [PureMapComponent],
                    entryComponents: [PureMapComponent],
                    imports: [
                        CommonModule,
                        PureGoogleMapsServicesModule
                    ],
                    exports: [PureMapComponent]
                },] }
    ];
    return PureGoogleMapsSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TranslateFormModelService = /** @class */ (function () {
    function TranslateFormModelService(translateService, formService) {
        this.translateService = translateService;
        this.formService = formService;
    }
    /**
     * @param {?} formModel
     * @param {?} translationPath
     * @return {?}
     */
    TranslateFormModelService.prototype.translateFormModel = /**
     * @param {?} formModel
     * @param {?} translationPath
     * @return {?}
     */
    function (formModel, translationPath) {
        var _this = this;
        /** @type {?} */
        var serializedFormModel = JSON.stringify(formModel);
        /** @type {?} */
        var validationMessages = this.translateService.translations
            && this.translateService.currentLang
            && this.translateService.translations[this.translateService.currentLang]
            ? this.translateService.translations[this.translateService.currentLang].APPLICATION.VALIDATORS : {};
        /** @type {?} */
        var model = this.formService.fromJSON(serializedFormModel);
        return model.map((/**
         * @param {?} field
         * @return {?}
         */
        function (field) {
            return _this.mapDynamicFormControlModel(field, translationPath, validationMessages);
        }));
    };
    // tslint:disable-next-line: cognitive-complexity
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @param {?} field
     * @param {?} translationPath
     * @param {?} errorMessages
     * @return {?}
     */
    TranslateFormModelService.prototype.mapDynamicFormControlModel = 
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @param {?} field
     * @param {?} translationPath
     * @param {?} errorMessages
     * @return {?}
     */
    function (field, translationPath, errorMessages) {
        var _this = this;
        if (field.type === 'ARRAY') {
            /** @type {?} */
            var arrayField = (/** @type {?} */ (field));
            /** @type {?} */
            var translatedLabel = this.translateService.instant(translationPath + "." + arrayField.id);
            arrayField.label = "<h5 class=\"m-0\"><i class=\"ft ft-target ft-" + field.id + "\"></i> " + translatedLabel + "</h5><hr class=\"mt-1 mb-0\">";
            arrayField.groups = arrayField.groups.map((/**
             * @param {?} groupArray
             * @return {?}
             */
            function (groupArray) {
                // tslint:disable-next-line: max-line-length
                groupArray.group = groupArray.group.map((/**
                 * @param {?} groupField
                 * @return {?}
                 */
                function (groupField) {
                    return _this.mapDynamicFormControlModel(groupField, translationPath, errorMessages);
                }));
                return groupArray;
            }));
        }
        else if (field.type === 'GROUP') {
            /** @type {?} */
            var fieldGroup = (/** @type {?} */ (field));
            /** @type {?} */
            var translatedLabel = this.translateService.instant(translationPath + "." + fieldGroup.id);
            fieldGroup.label = "<h5 class=\"m-0\"><i class=\"ft ft-target ft-" + field.id + "\"></i> " + translatedLabel + "</h5>";
            // tslint:disable-next-line: max-line-length
            fieldGroup.group = fieldGroup.group.map((/**
             * @param {?} groupField
             * @return {?}
             */
            function (groupField) {
                return _this.mapDynamicFormControlModel(groupField, translationPath, errorMessages);
            }));
        }
        else {
            /** @type {?} */
            var inputField = (/** @type {?} */ (field));
            /** @type {?} */
            var translatedLabel = this.translateService.instant(translationPath + "." + inputField.id);
            /** @type {?} */
            var translatedLabelTooltop = inputField.labelTooltip ? this.translateService.instant(inputField.labelTooltip) : '';
            /** @type {?} */
            var isRequired = inputField.validators && inputField.validators.required !== undefined;
            /** @type {?} */
            var labelTooltip = inputField.labelTooltip ? " <i class=\"ft ft-help-circle\" title=\"" + translatedLabelTooltop + "\"></i>" : '';
            inputField.label = "<span class=\"" + (isRequired ? 'required' : '') + "\">" + translatedLabel + "</span>" + labelTooltip;
            inputField.placeholder = translatedLabel;
            if (field.type === 'SELECT' || field.type === 'NUMERIC_CONDITION') {
                /** @type {?} */
                var selectField = (/** @type {?} */ (field));
                selectField.options = selectField.options.map((/**
                 * @param {?} option
                 * @return {?}
                 */
                function (option) {
                    /** @type {?} */
                    var optionLabel = option.label ? _this.translateService.instant(option.label) : option.label;
                    return __assign({}, option, {
                        label: optionLabel
                    });
                }));
            }
        }
        field.errorMessages = this.errorMessages(field.errorMessages, errorMessages);
        return field;
    };
    /**
     * @private
     * @param {?} currentControlMessages
     * @param {?} errorMessages
     * @return {?}
     */
    TranslateFormModelService.prototype.errorMessages = /**
     * @private
     * @param {?} currentControlMessages
     * @param {?} errorMessages
     * @return {?}
     */
    function (currentControlMessages, errorMessages) {
        /** @type {?} */
        var customErrorMessages = currentControlMessages || {};
        for (var key in customErrorMessages) {
            if (customErrorMessages.hasOwnProperty(key)) {
                /** @type {?} */
                var translationKey = customErrorMessages[key];
                customErrorMessages[key] = this.translateService.instant(translationKey);
            }
        }
        return __assign({}, errorMessages, customErrorMessages);
    };
    TranslateFormModelService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TranslateFormModelService.ctorParameters = function () { return [
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TranslateFormModelService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TranslateFormModelService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TranslateFormModelService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var AddFormComponent = /** @class */ (function () {
    function AddFormComponent(formService, translateFormModelService, translateService) {
        this.formService = formService;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.refreshFormModel$ = new BehaviorSubject(true);
        this.add = new EventEmitter();
        this.afterCancel = new EventEmitter();
        this.formGroupInitialized = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AddFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup = this.formService.createFormGroup(this.formModel);
        if (this.model) {
            this.formGroup.patchValue(this.model);
        }
        this.formModel$ = merge(this.refreshFormModel$, this.translateService.onLangChange).pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModel, _this.translateKey); })));
    };
    /**
     * @return {?}
     */
    AddFormComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this.formGroupInitialized.next(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    AddFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.model && this.formGroup) {
            this.formGroup.patchValue(this.model);
        }
    };
    /**
     * @return {?}
     */
    AddFormComponent.prototype.addClick = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.add.emit(this.formGroup.value);
        }
        else {
            this.formGroup.markAllAsTouched();
        }
    };
    /**
     * @return {?}
     */
    AddFormComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.afterCancel.emit(true);
    };
    /**
     * @return {?}
     */
    AddFormComponent.prototype.refreshFormModel = /**
     * @return {?}
     */
    function () {
        this.refreshFormModel$.next(true);
    };
    AddFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-add-form',
                    template: "<div class=\"container-fluid px-0\" *ngIf=\"formModel$ | async as formModel\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\">\r\n        <fieldset class=\"w-100\">\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{ legend }}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n    <div class=\"w-100 text-right d-flex justify-content-end\">\r\n        <button class=\"btn btn-raised btn-secondary mr-1 mb-0\" type=\"button\" (click)=\"cancel()\">\r\n            <i class=\"ft-x\"></i> {{ 'APPLICATION.FORM.cancel' | translate }}\r\n        </button>\r\n        <button class=\"btn btn-raised btn-primary mb-0\" type=\"button\" (click)=\"addClick()\">\r\n            <i class=\"ft-save\"></i> {{ 'APPLICATION.FORM.add' | translate }}\r\n        </button>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        TranslateFormModelService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    AddFormComponent.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TranslateFormModelService },
        { type: TranslateService }
    ]; };
    AddFormComponent.propDecorators = {
        formLayout: [{ type: Input }],
        formModel: [{ type: Input }],
        header: [{ type: Input }],
        model: [{ type: Input }],
        translateKey: [{ type: Input }],
        add: [{ type: Output }],
        afterCancel: [{ type: Output }],
        formGroupInitialized: [{ type: Output }]
    };
    return AddFormComponent;
}());
if (false) {
    /** @type {?} */
    AddFormComponent.prototype.refreshFormModel$;
    /** @type {?} */
    AddFormComponent.prototype.formModel$;
    /** @type {?} */
    AddFormComponent.prototype.formGroup;
    /** @type {?} */
    AddFormComponent.prototype.formLayout;
    /** @type {?} */
    AddFormComponent.prototype.formModel;
    /** @type {?} */
    AddFormComponent.prototype.header;
    /** @type {?} */
    AddFormComponent.prototype.model;
    /** @type {?} */
    AddFormComponent.prototype.translateKey;
    /** @type {?} */
    AddFormComponent.prototype.add;
    /** @type {?} */
    AddFormComponent.prototype.afterCancel;
    /** @type {?} */
    AddFormComponent.prototype.formGroupInitialized;
    /**
     * @type {?}
     * @private
     */
    AddFormComponent.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    AddFormComponent.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    AddFormComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_MODEL_MAP_FN = new InjectionToken('DYNAMIC_FORM_MODEL_MAP_FN')
// tslint:disable-next-line: max-line-length
/* Based on: https://github.com/udos86/ng-dynamic-forms/blob/master/projects/ng-dynamic-forms/core/src/lib/service/dynamic-form.service.ts */
;
// tslint:disable-next-line: max-line-length
/* Based on: https://github.com/udos86/ng-dynamic-forms/blob/master/projects/ng-dynamic-forms/core/src/lib/service/dynamic-form.service.ts */
var CustomDynamicFormService = /** @class */ (function (_super) {
    __extends(CustomDynamicFormService, _super);
    function CustomDynamicFormService(DYNAMIC_FORM_MODEL_MAP_FN, validationService) {
        var _this = _super.call(this, validationService) || this;
        _this.DYNAMIC_FORM_MODEL_MAP_FN = DYNAMIC_FORM_MODEL_MAP_FN;
        _this.DYNAMIC_FORM_MODEL_MAP_FN = (/** @type {?} */ (DYNAMIC_FORM_MODEL_MAP_FN));
        return _this;
    }
    // tslint:disable-next-line: cognitive-complexity
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @param {?} json
     * @return {?}
     */
    CustomDynamicFormService.prototype.fromJSON = 
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @param {?} json
     * @return {?}
     */
    function (json) {
        var _this = this;
        // tslint:disable-next-line: one-variable-per-declaration
        /** @type {?} */
        var formModelJSON = typeof json === 'string' ? JSON.parse(json, parseReviver) : json;
        /** @type {?} */
        var formModel = [];
        // tslint:disable-next-line: no-any
        formModelJSON.forEach((/**
         * @param {?} model
         * @return {?}
         */
        function (model) {
            /** @type {?} */
            var layout = model.layout || model.cls || null;
            switch (model.type) {
                case DYNAMIC_FORM_CONTROL_TYPE_ARRAY:
                    /** @type {?} */
                    var formArrayModel_1 = (/** @type {?} */ (model));
                    if (Array.isArray(formArrayModel_1.groups)) {
                        formArrayModel_1.groups.forEach((/**
                         * @param {?} groupModel
                         * @return {?}
                         */
                        function (groupModel) {
                            groupModel.group = _this.fromJSON(groupModel.group);
                        }));
                    }
                    formArrayModel_1.groupFactory = (/**
                     * @return {?}
                     */
                    function () {
                        return _this.fromJSON(formArrayModel_1.groupPrototype);
                    });
                    formModel.push(new DynamicFormArrayModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX:
                    formModel.push(new DynamicCheckboxModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX_GROUP:
                    model.group = (/** @type {?} */ (_this.fromJSON(model.group)));
                    formModel.push(new DynamicCheckboxGroupModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_COLORPICKER:
                    formModel.push(new DynamicColorPickerModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER:
                    formModel.push(new DynamicDatePickerModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_EDITOR:
                    formModel.push(new DynamicEditorModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_FILE_UPLOAD:
                    model.value = null;
                    formModel.push(new DynamicFileUploadModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_GROUP:
                    model.group = _this.fromJSON(model.group);
                    formModel.push(new DynamicFormGroupModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_INPUT:
                    /** @type {?} */
                    var inputModel = (/** @type {?} */ (model));
                    if (inputModel.mask !== null) {
                        inputModel.mask = maskFromString((/** @type {?} */ (inputModel.mask)));
                    }
                    formModel.push(new DynamicInputModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_RADIO_GROUP:
                    formModel.push(new DynamicRadioGroupModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_RATING:
                    formModel.push(new DynamicRatingModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_SELECT:
                    formModel.push(new DynamicSelectModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_SLIDER:
                    formModel.push(new DynamicSliderModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_SWITCH:
                    formModel.push(new DynamicSwitchModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA:
                    formModel.push(new DynamicTextAreaModel(model, layout));
                    break;
                case DYNAMIC_FORM_CONTROL_TYPE_TIMEPICKER:
                    formModel.push(new DynamicTimePickerModel(model, layout));
                    break;
                default:
                    if (_this.DYNAMIC_FORM_MODEL_MAP_FN !== undefined) {
                        /** @type {?} */
                        var dynamicModel = _this.DYNAMIC_FORM_MODEL_MAP_FN(model.type, model, layout);
                        if (dynamicModel !== null) {
                            formModel.push(dynamicModel);
                        }
                        else {
                            throw new Error("custom form control model is not resolved by type \"" + model.type + "\"");
                        }
                    }
                    else {
                        throw new Error("unknown form control model defined on JSON with id \"" + model.id + "\"");
                    }
            }
        }));
        return formModel;
    };
    /** @nocollapse */
    CustomDynamicFormService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DYNAMIC_FORM_MODEL_MAP_FN,] }, { type: Optional }] },
        { type: DynamicFormValidationService }
    ]; };
    return CustomDynamicFormService;
}(DynamicFormService));
if (false) {
    /**
     * @type {?}
     * @private
     */
    CustomDynamicFormService.prototype.DYNAMIC_FORM_MODEL_MAP_FN;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var FormComponent = /** @class */ (function () {
    function FormComponent(formService, translateFormModelService, translateService, changeDetectorRef) {
        this.formService = formService;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.changeDetectorRef = changeDetectorRef;
        this.isEditing = false;
        this.startFromIsEditing = false;
        this.isEditable = true;
        this.isDeletable = false;
        this.refreshFormModel$ = new BehaviorSubject(true);
        this.save = new EventEmitter();
        this.afterCancel = new EventEmitter();
        this.isEditingChange = new EventEmitter();
        this.delete = new EventEmitter();
        this.formGroupInitialized = new EventEmitter();
    }
    /**
     * @return {?}
     */
    FormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup = this.formService.createFormGroup(this.formModel);
        if (this.model) {
            this.formGroup.patchValue(this.model);
        }
        if (this.startFromIsEditing === true) {
            this.isEditing = true;
            this.formGroup.enable();
        }
        else {
            this.formGroup.disable();
        }
        this.formModel$ = merge(this.refreshFormModel$, this.translateService.onLangChange).pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModel, _this.translateKey); })));
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this.formGroupInitialized.next(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.model && this.formGroup) {
            this.formGroup.patchValue(this.model);
        }
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.switchToEdit = /**
     * @return {?}
     */
    function () {
        this.isEditing = true;
        this.isEditingChange.emit(true);
        this.formGroup.enable();
        this.changeDetectorRef.detectChanges();
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.deleteClick = /**
     * @return {?}
     */
    function () {
        this.delete.emit(true);
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.formGroup.markAsPristine();
        this.formGroup.markAsUntouched();
        this.formGroup.reset(this.model);
        this.isEditing = false;
        this.isEditingChange.emit(false);
        this.formGroup.disable();
        this.changeDetectorRef.detectChanges();
        this.afterCancel.emit(true);
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.saveClick = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.save.emit(this.formGroup.value);
        }
        else {
            this.formGroup.markAllAsTouched();
        }
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.saveSuccess = /**
     * @return {?}
     */
    function () {
        this.formGroup.markAsPristine();
        this.formGroup.markAsUntouched();
        this.isEditing = false;
        this.isEditingChange.emit(false);
        this.formGroup.disable();
        this.changeDetectorRef.detectChanges();
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.saveFailed = /**
     * @return {?}
     */
    function () {
        this.changeDetectorRef.detectChanges();
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.refreshFormModel = /**
     * @return {?}
     */
    function () {
        this.refreshFormModel$.next(true);
    };
    FormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-form',
                    template: "<div class=\"container-fluid px-0\" *ngIf=\"formModel$ | async as formModel\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\">\r\n        <fieldset [disabled]=\"!isEditing\">\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{ legend }}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n    <div class=\"d-flex justify-content-end w-100 text-right d-print-none\" *ngIf=\"isEditable\">\r\n        <button class=\"btn btn-raised btn-primary mb-0\" type=\"button\" *ngIf=\"!isEditing\" (click)=\"switchToEdit()\">\r\n            <i class=\"ft-edit\"></i> {{ 'APPLICATION.FORM.edit' | translate }}\r\n        </button>\r\n        <button class=\"btn btn-raised btn-secondary mr-1 mb-0\" type=\"button\" *ngIf=\"isEditing\" (click)=\"cancel()\">\r\n            <i class=\"ft-x\"></i> {{ 'APPLICATION.FORM.cancel' | translate }}\r\n        </button>\r\n        <button class=\"btn btn-raised btn-primary mb-0\" type=\"button\" *ngIf=\"isEditing\" (click)=\"saveClick()\">\r\n            <i class=\"ft-save\"></i> {{ 'APPLICATION.FORM.save' | translate }}\r\n        </button>\r\n        <button class=\"btn btn-raised btn btn-secondary btn-raised ml-1 mb-0\" type=\"button\" *ngIf=\"isDeletable\" (click)=\"deleteClick()\">\r\n            <i class=\"ft-save\"></i> {{ 'APPLICATION.FORM.delete' | translate }}\r\n        </button>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        TranslateFormModelService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    FormComponent.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: ChangeDetectorRef }
    ]; };
    FormComponent.propDecorators = {
        startFromIsEditing: [{ type: Input }],
        isEditable: [{ type: Input }],
        isDeletable: [{ type: Input }],
        formLayout: [{ type: Input }],
        formModel: [{ type: Input }],
        model: [{ type: Input }],
        translateKey: [{ type: Input }],
        save: [{ type: Output }],
        afterCancel: [{ type: Output }],
        isEditingChange: [{ type: Output }],
        delete: [{ type: Output }],
        formGroupInitialized: [{ type: Output }]
    };
    return FormComponent;
}());
if (false) {
    /** @type {?} */
    FormComponent.prototype.isEditing;
    /** @type {?} */
    FormComponent.prototype.startFromIsEditing;
    /** @type {?} */
    FormComponent.prototype.isEditable;
    /** @type {?} */
    FormComponent.prototype.isDeletable;
    /** @type {?} */
    FormComponent.prototype.refreshFormModel$;
    /** @type {?} */
    FormComponent.prototype.formModel$;
    /** @type {?} */
    FormComponent.prototype.formGroup;
    /** @type {?} */
    FormComponent.prototype.formLayout;
    /** @type {?} */
    FormComponent.prototype.formModel;
    /** @type {?} */
    FormComponent.prototype.model;
    /** @type {?} */
    FormComponent.prototype.translateKey;
    /** @type {?} */
    FormComponent.prototype.save;
    /** @type {?} */
    FormComponent.prototype.afterCancel;
    /** @type {?} */
    FormComponent.prototype.isEditingChange;
    /** @type {?} */
    FormComponent.prototype.delete;
    /** @type {?} */
    FormComponent.prototype.formGroupInitialized;
    /**
     * @type {?}
     * @private
     */
    FormComponent.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    FormComponent.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    FormComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    FormComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var SearchFlatFormComponent = /** @class */ (function () {
    function SearchFlatFormComponent(formService, translateFormModelService, translateService) {
        this.formService = formService;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.search = new EventEmitter();
        this.refreshFormModel$ = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    SearchFlatFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup = this.formService.createFormGroup(this.formModel);
        if (this.model) {
            this.formGroup.patchValue(this.model);
        }
        this.formModel$ = merge(this.refreshFormModel$, this.translateService.onLangChange).pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModel, _this.translateKey); })));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    SearchFlatFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.model && this.formGroup) {
            this.formGroup.patchValue(this.model);
        }
    };
    /**
     * @return {?}
     */
    SearchFlatFormComponent.prototype.searchClick = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.search.emit(this.formGroup.value);
        }
    };
    /**
     * @return {?}
     */
    SearchFlatFormComponent.prototype.refreshFormModel = /**
     * @return {?}
     */
    function () {
        this.refreshFormModel$.next(true);
    };
    SearchFlatFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-search-flat-form',
                    template: "\r\n<div class=\"container-fluid px-0\" *ngIf=\"formModel$ | async as formModelx\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModelx\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{ legend }}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n        <div class=\"actions text-right pb-1\">\r\n            <button class=\"btn btn-raised btn-primary mb-0\" type=\"button\" (click)=\"searchClick()\">\r\n                <i class=\"ft-search\"></i> {{ 'APPLICATION.SEARCH.button' | translate }}\r\n            </button>\r\n        </div>\r\n    </form>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        TranslateFormModelService
                    ],
                    styles: [".form-group-legend{font-size:.75rem}"]
                }] }
    ];
    /** @nocollapse */
    SearchFlatFormComponent.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TranslateFormModelService },
        { type: TranslateService }
    ]; };
    SearchFlatFormComponent.propDecorators = {
        formLayout: [{ type: Input }],
        formModel: [{ type: Input }],
        model: [{ type: Input }],
        translateKey: [{ type: Input }],
        search: [{ type: Output }]
    };
    return SearchFlatFormComponent;
}());
if (false) {
    /** @type {?} */
    SearchFlatFormComponent.prototype.formLayout;
    /** @type {?} */
    SearchFlatFormComponent.prototype.formModel;
    /** @type {?} */
    SearchFlatFormComponent.prototype.model;
    /** @type {?} */
    SearchFlatFormComponent.prototype.translateKey;
    /** @type {?} */
    SearchFlatFormComponent.prototype.search;
    /** @type {?} */
    SearchFlatFormComponent.prototype.formModel$;
    /** @type {?} */
    SearchFlatFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    SearchFlatFormComponent.prototype.refreshFormModel$;
    /**
     * @type {?}
     * @private
     */
    SearchFlatFormComponent.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    SearchFlatFormComponent.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    SearchFlatFormComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var SearchFormComponent = /** @class */ (function () {
    function SearchFormComponent(formService, translateFormModelService, translateService) {
        this.formService = formService;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.refreshFormModel = new BehaviorSubject(true);
        this.search = new EventEmitter();
        this.formGroupInitialized = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SearchFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup = this.formService.createFormGroup(this.formModel);
        if (this.model) {
            this.formGroup.patchValue(this.model);
        }
        this.formModel$ = merge(this.refreshFormModel, this.translateService.onLangChange).pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModel, _this.translateKey); })));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    SearchFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.model && this.formGroup) {
            this.formGroup.patchValue(this.model);
        }
    };
    /**
     * @return {?}
     */
    SearchFormComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this.formGroupInitialized.next(this.formGroup);
    };
    /**
     * @return {?}
     */
    SearchFormComponent.prototype.searchClick = /**
     * @return {?}
     */
    function () {
        if (this.formGroup.valid) {
            this.search.emit(this.formGroup.value);
        }
        else {
            this.formGroup.markAllAsTouched();
        }
    };
    SearchFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-search-form',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\"><i class=\"ft ft-sliders\"></i> {{ 'APPLICATION.SEARCH.title' | translate }}</h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"d-print-none float-right\"></app-panel-fullscreen-button>\r\n        <app-panel-hide-button\r\n            [hidden]=\"!showOnStart\"\r\n            (hiddenChange)=\"panelHide.setHidden($event)\"\r\n            class=\"d-print-none float-right mr-1\"\r\n        ></app-panel-hide-button>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container-fluid px-0\" *ngIf=\"formModel$ | async as formModelx\" [appPanelHide]=\"!showOnStart\">\r\n                <hr class=\"mt-0\" />\r\n                <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" (keydown.enter)=\"searchClick()\">\r\n                    <fieldset>\r\n                        <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModelx\">\r\n                            <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                                <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                                <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{ legend }}</p>\r\n                            </ng-template>\r\n                        </dynamic-ng-bootstrap-form>\r\n                    </fieldset>\r\n                    <div class=\"actions text-right pb-1 d-print-none d-flex justify-content-end\">\r\n                        <button class=\"btn btn-raised btn-secondary mb-0\" type=\"button\" (click)=\"searchClick()\">\r\n                            <i class=\"ft-search\"></i> {{ 'APPLICATION.SEARCH.button' | translate }}\r\n                        </button>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        TranslateFormModelService
                    ],
                    styles: [".form-group-legend{font-size:.75rem}"]
                }] }
    ];
    /** @nocollapse */
    SearchFormComponent.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TranslateFormModelService },
        { type: TranslateService }
    ]; };
    SearchFormComponent.propDecorators = {
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }],
        formLayout: [{ type: Input }],
        formModel: [{ type: Input }],
        model: [{ type: Input }],
        translateKey: [{ type: Input }],
        showOnStart: [{ type: Input }],
        search: [{ type: Output }],
        formGroupInitialized: [{ type: Output }]
    };
    return SearchFormComponent;
}());
if (false) {
    /** @type {?} */
    SearchFormComponent.prototype.refreshFormModel;
    /** @type {?} */
    SearchFormComponent.prototype.formModel$;
    /** @type {?} */
    SearchFormComponent.prototype.formGroup;
    /** @type {?} */
    SearchFormComponent.prototype.panelHide;
    /** @type {?} */
    SearchFormComponent.prototype.formLayout;
    /** @type {?} */
    SearchFormComponent.prototype.formModel;
    /** @type {?} */
    SearchFormComponent.prototype.model;
    /** @type {?} */
    SearchFormComponent.prototype.translateKey;
    /** @type {?} */
    SearchFormComponent.prototype.showOnStart;
    /** @type {?} */
    SearchFormComponent.prototype.search;
    /** @type {?} */
    SearchFormComponent.prototype.formGroupInitialized;
    /**
     * @type {?}
     * @private
     */
    SearchFormComponent.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    SearchFormComponent.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    SearchFormComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var SimpleFormComponent = /** @class */ (function () {
    function SimpleFormComponent(formService, translateFormModelService, translateService) {
        this.formService = formService;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.refreshFormModel$ = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    SimpleFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup = this.formService.createFormGroup(this.formModel);
        if (this.model) {
            this.formGroup.patchValue(this.model);
        }
        this.formModel$ = merge(this.refreshFormModel$, this.translateService.onLangChange).pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModel, _this.translateKey); })));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    SimpleFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.model && this.formGroup) {
            this.formGroup.patchValue(this.model);
        }
    };
    /**
     * @return {?}
     */
    SimpleFormComponent.prototype.refreshFormModel = /**
     * @return {?}
     */
    function () {
        this.refreshFormModel$.next(true);
    };
    SimpleFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-simple-form',
                    template: "<div class=\"container-fluid px-0\" *ngIf=\"formModel$ | async as formModelx\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModelx\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{ legend }}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        TranslateFormModelService
                    ],
                    styles: [".form-group-legend{font-size:.75rem}"]
                }] }
    ];
    /** @nocollapse */
    SimpleFormComponent.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TranslateFormModelService },
        { type: TranslateService }
    ]; };
    SimpleFormComponent.propDecorators = {
        formLayout: [{ type: Input }],
        formModel: [{ type: Input }],
        model: [{ type: Input }],
        translateKey: [{ type: Input }]
    };
    return SimpleFormComponent;
}());
if (false) {
    /** @type {?} */
    SimpleFormComponent.prototype.formLayout;
    /** @type {?} */
    SimpleFormComponent.prototype.formModel;
    /** @type {?} */
    SimpleFormComponent.prototype.model;
    /** @type {?} */
    SimpleFormComponent.prototype.translateKey;
    /** @type {?} */
    SimpleFormComponent.prototype.formModel$;
    /** @type {?} */
    SimpleFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    SimpleFormComponent.prototype.refreshFormModel$;
    /**
     * @type {?}
     * @private
     */
    SimpleFormComponent.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    SimpleFormComponent.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    SimpleFormComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_MAP_AREA_SELECT = 'MAP_AREA_SELECT';
/**
 * @record
 */
function DynamicMapAreaSelectFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicMapAreaSelectFormControlModelConfig.prototype.features;
    /** @type {?|undefined} */
    DynamicMapAreaSelectFormControlModelConfig.prototype.organizationLocations;
}
var DynamicMapAreaSelectFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicMapAreaSelectFormControlModel, _super);
    function DynamicMapAreaSelectFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_MAP_AREA_SELECT;
        _this.features = config.features;
        _this.organizationLocations = config.organizationLocations;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMapAreaSelectFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicMapAreaSelectFormControlModel.prototype, "features", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMapAreaSelectFormControlModel.prototype, "organizationLocations", void 0);
    return DynamicMapAreaSelectFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMapAreaSelectFormControlModel.prototype.type;
    /** @type {?} */
    DynamicMapAreaSelectFormControlModel.prototype.features;
    /** @type {?} */
    DynamicMapAreaSelectFormControlModel.prototype.organizationLocations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMapAreaSelectFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMapAreaSelectFormControlComponent, _super);
    function DynamicMapAreaSelectFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMapAreaSelectFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-map-area-select-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-map-area-select-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [features]=\"model.features\"\r\n        [organizationLocations] = \"model.organizationLocations\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </lib-map-area-select-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicMapAreaSelectFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMapAreaSelectFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMapAreaSelectFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMapAreaSelectFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMapAreaSelectFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMapAreaSelectFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMapAreaSelectFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMapAreaSelectFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMapAreaSelectFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMapAreaSelectFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapAreaSelectFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapAreaSelectFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterProxyService = /** @class */ (function () {
    function CadastralRegisterProxyService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.apiUrl = this.config.configuration.api_url + "/v1/cadastre";
    }
    /**
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.getStates = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.apiUrl + "/states";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.getCounties = /**
     * @param {?} stateId
     * @return {?}
     */
    function (stateId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.getCommunes = /**
     * @param {?} stateId
     * @param {?} countyId
     * @return {?}
     */
    function (stateId, countyId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.getAreas = /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @return {?}
     */
    function (stateId, countyId, communeId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.getArea = /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId;
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.getCadastres = /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId + "/katastr";
        return this.httpClient.get(url);
    };
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreId
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.getCadastre = 
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreId
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId, cadastreId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId + "/katastr/" + cadastreId;
        return this.httpClient.get(url);
    };
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreNumber
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.searchCadastre = 
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreNumber
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId, cadastreNumber) {
        // tslint:disable-next-line: max-line-length
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId + "/katastr/search?number=" + cadastreNumber;
        return this.httpClient.get(url).pipe(catchError((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return of(null); })));
    };
    /**
     * @param {?} latitude
     * @param {?} longitude
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.searchCadastres = /**
     * @param {?} latitude
     * @param {?} longitude
     * @return {?}
     */
    function (latitude, longitude) {
        /** @type {?} */
        var url = this.apiUrl + "/area_search?lat=" + latitude + "&lng=" + longitude;
        return this.httpClient.get(url).pipe(catchError((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return of([]); })));
    };
    /**
     * @param {?} teryt
     * @return {?}
     */
    CadastralRegisterProxyService.prototype.searchCadastreByTeryt = /**
     * @param {?} teryt
     * @return {?}
     */
    function (teryt) {
        /** @type {?} */
        var url = this.apiUrl + "/search?teryt=" + teryt;
        return this.httpClient.get(url).pipe(catchError((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return of(null); })));
    };
    CadastralRegisterProxyService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CadastralRegisterProxyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return CadastralRegisterProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterProxyService.prototype.apiUrl;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterProxyService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterProxyService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolygonShapesOptions = /** @class */ (function () {
    function PolygonShapesOptions() {
    }
    PolygonShapesOptions.DISABLED_POLYGON_PARCEL_OPTIONS = {
        strokeColor: '#1a292b',
        fillColor: '#1a292b'
    };
    PolygonShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS = {
        strokeColor: '#8fff05',
        fillColor: '#8fff05'
    };
    PolygonShapesOptions.UNSELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ffff00',
        fillColor: '#ffff00'
    };
    PolygonShapesOptions.SELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ff0000',
        fillColor: '#ff0000'
    };
    return PolygonShapesOptions;
}());
if (false) {
    /** @type {?} */
    PolygonShapesOptions.DISABLED_POLYGON_PARCEL_OPTIONS;
    /** @type {?} */
    PolygonShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS;
    /** @type {?} */
    PolygonShapesOptions.UNSELECTED_POLYGON_OPTIONS;
    /** @type {?} */
    PolygonShapesOptions.SELECTED_POLYGON_OPTIONS;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapAreaSelectControlService = /** @class */ (function () {
    function MapAreaSelectControlService(pureMapService, numberUtilService) {
        var _this = this;
        this.pureMapService = pureMapService;
        this.numberUtilService = numberUtilService;
        this.selectedFeaturesSubject = new BehaviorSubject(new Array());
        this.markerPosition = new BehaviorSubject(null);
        this.selectedFeatures$ = this.selectedFeaturesSubject.asObservable();
        this.isDrawingEnabled = new BehaviorSubject(false);
        this.isManuallyDraweMarkerSelected = false;
        this.mapCenterZoomValue = 14;
        this.isCenteredToMarker = false;
        this.polygons = [];
        this.manuallyDrawedPolygons = [];
        this.setPolygonSelected = (/**
         * @param {?} polygon
         * @param {?} isSelected
         * @return {?}
         */
        function (polygon, isSelected) {
            _this.polygons.forEach((/**
             * @param {?} p
             * @return {?}
             */
            function (p) {
                p.set('selected', false);
            }));
            polygon.set('selected', isSelected);
            polygon.set('label', polygon.get('name'));
            if (_this.manuallyDrawedPolygons.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x === polygon && polygon.get('selected'); }))) {
                _this.isManuallyDraweMarkerSelected = true;
            }
            else {
                _this.isManuallyDraweMarkerSelected = false;
            }
        });
        this.getFeatureKey = (/**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            /** @type {?} */
            var paths = features
                .filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.geometry.type === 'Polygon'; }))
                .map((/**
             * @param {?} feature
             * @return {?}
             */
            function (feature) { return _this.getPolygonPaths((/** @type {?} */ (feature))); }));
            return JSON.stringify(paths);
        });
        this.getPolygonKey = (/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) {
            /** @type {?} */
            var polygonPaths = [];
            polygon.getPaths().forEach((/**
             * @param {?} pPaths
             * @return {?}
             */
            function (pPaths) {
                pPaths.forEach((/**
                 * @param {?} path
                 * @return {?}
                 */
                function (path) {
                    polygonPaths.push(new google.maps.LatLng(path.lat(), path.lng()));
                }));
            }));
            return JSON.stringify([polygonPaths]);
        });
    }
    Object.defineProperty(MapAreaSelectControlService.prototype, "mapReady$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.pureMapService.mapReady.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} organizationLocations
     * @return {?}
     */
    MapAreaSelectControlService.prototype.markPosition = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} organizationLocations
     * @return {?}
     */
    function (organizationLocations) {
        var _this = this;
        /** @type {?} */
        var organizationCenterPoint = organizationLocations.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Point'; }));
        // tslint:disable-next-line: no-magic-numbers
        /** @type {?} */
        var point = new google.maps.LatLng(50.22005290158697, 20.182460816577382);
        if (organizationCenterPoint) {
            // tslint:disable-next-line: max-line-length
            point = new google.maps.LatLng(organizationCenterPoint.geometry.coordinates[1], organizationCenterPoint.geometry.coordinates[0]);
        }
        /** @type {?} */
        var marker = this.pureMapService.createSingleMarker({
            position: point,
            draggable: true
        });
        this.markerPosition.next(this.mapMarkerPositionToGeolocationPosition(point.lat(), point.lng()));
        marker.addListener('dragend', (/**
         * @param {?} dragEndMarkerEvent
         * @return {?}
         */
        function (dragEndMarkerEvent) {
            _this.markerPosition.next(_this.mapMarkerPositionToGeolocationPosition(dragEndMarkerEvent.latLng.lat(), dragEndMarkerEvent.latLng.lng()));
        }));
        if (!this.isCenteredToMarker) {
            this.pureMapService.centerMap(point);
            this.pureMapService.setZoom(this.mapCenterZoomValue);
        }
        this.isCenteredToMarker = true;
    };
    /**
     * @param {?} features
     * @param {?=} isFromCadastralRegister
     * @return {?}
     */
    MapAreaSelectControlService.prototype.draw = /**
     * @param {?} features
     * @param {?=} isFromCadastralRegister
     * @return {?}
     */
    function (features, isFromCadastralRegister) {
        var _this = this;
        if (isFromCadastralRegister === void 0) { isFromCadastralRegister = false; }
        features
            .filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Polygon'; }))
            .forEach((/**
         * @param {?} feature
         * @return {?}
         */
        function (feature) { return _this.createPolygon((/** @type {?} */ (feature)), isFromCadastralRegister); }));
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlService.prototype.turnOnDrawing = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.isDrawingEnabled.value) {
            /** @type {?} */
            var drawingManager = this.pureMapService.createDrawingManager({
                drawingControl: true,
                drawingControlOptions: {
                    drawingModes: [google.maps.drawing.OverlayType.POLYGON],
                    position: google.maps.ControlPosition.TOP_CENTER
                },
                polygonOptions: PolygonShapesOptions.UNSELECTED_POLYGON_OPTIONS
            });
            drawingManager.addListener('overlaycomplete', (/**
             * @param {?} polygon
             * @return {?}
             */
            function (polygon) {
                if (polygon.type === google.maps.drawing.OverlayType.POLYGON) {
                    _this.manuallyDrawedPolygons.forEach((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return _this.pureMapService.removePolygon(x); }));
                    /** @type {?} */
                    var poly = ((/** @type {?} */ (polygon.overlay)));
                    poly.setMap(null);
                    /** @type {?} */
                    var oneHectareInSquareMeters = 10000;
                    /** @type {?} */
                    var unselectedOptions = PolygonShapesOptions.UNSELECTED_POLYGON_OPTIONS;
                    /** @type {?} */
                    var polygonCenterPoint = _this.getPolygonCenterPoint(poly);
                    /** @type {?} */
                    var areaInHa = google.maps.geometry.spherical.computeArea(poly.getPath()) / oneHectareInSquareMeters;
                    /** @type {?} */
                    var properties = __assign({ cadastralRegister: null, area: _this.numberUtilService.round2(areaInHa), disabled: false, isCustomName: true, centerPoint: [polygonCenterPoint.lat(), polygonCenterPoint.lng()], name: null, parcelId: null, selected: false }, unselectedOptions);
                    /** @type {?} */
                    var addPolygon = _this.pureMapService.createPolygon(__assign({ paths: poly.getPath() }, properties));
                    _this.setPolygonListeners(addPolygon);
                    _this.polygons.push(addPolygon);
                    _this.manuallyDrawedPolygons.push(addPolygon);
                    _this.setPolygonSelectedAndUpdateSelectedFeatures(addPolygon);
                }
            }));
            this.isDrawingEnabled.next(true);
        }
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlService.prototype.turnOffDrawing = /**
     * @return {?}
     */
    function () {
        if (this.isDrawingEnabled.value) {
            /** @type {?} */
            var drawingManager = this.pureMapService.createDrawingManager({
                drawingControl: false,
                drawingControlOptions: {
                    drawingModes: null
                }
            });
            drawingManager.unbindAll();
            this.isDrawingEnabled.next(false);
        }
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlService.prototype.centerToMarkerPosition = /**
     * @return {?}
     */
    function () {
        this.pureMapService.map.setCenter({ lat: this.markerPosition.value.coords.latitude, lng: this.markerPosition.value.coords.longitude });
    };
    /**
     * @param {?} features
     * @return {?}
     */
    MapAreaSelectControlService.prototype.fitBoundsMapToNewCadastreFeatures = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        var _this = this;
        if (features.length > 0) {
            /** @type {?} */
            var bounds_1 = new google.maps.LatLngBounds();
            features.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                _this.getPolygonPaths((/** @type {?} */ (x))).forEach((/**
                 * @param {?} path
                 * @return {?}
                 */
                function (path) {
                    bounds_1.extend(path);
                }));
            }));
            this.pureMapService.fitBounds(bounds_1);
        }
    };
    /**
     * @param {?} features
     * @return {?}
     */
    MapAreaSelectControlService.prototype.markSelected = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        var _this = this;
        if (features != null && features.length > 0) {
            /** @type {?} */
            var featureKey_1 = this.getFeatureKey(features);
            this.polygons.forEach((/**
             * @param {?} polygon
             * @return {?}
             */
            function (polygon) {
                /** @type {?} */
                var polygonKey = _this.getPolygonKey(polygon);
                if (featureKey_1 === polygonKey) {
                    _this.setPolygonSelected(polygon, true);
                }
            }));
        }
    };
    /**
     * @private
     * @param {?} feature
     * @param {?=} isFromCadastralRegister
     * @return {?}
     */
    MapAreaSelectControlService.prototype.createPolygon = /**
     * @private
     * @param {?} feature
     * @param {?=} isFromCadastralRegister
     * @return {?}
     */
    function (feature, isFromCadastralRegister) {
        if (isFromCadastralRegister === void 0) { isFromCadastralRegister = false; }
        // tslint:disable-next-line: no-string-literal
        /** @type {?} */
        var isParcel = (/** @type {?} */ (feature.properties['parcelId'])) != null;
        // tslint:disable-next-line: no-string-literal
        /** @type {?} */
        var isDisabled = (/** @type {?} */ (feature.properties['disabled']));
        /** @type {?} */
        var unselectedOptions = isDisabled
            ? PolygonShapesOptions.DISABLED_POLYGON_PARCEL_OPTIONS
            :
                isParcel
                    ? PolygonShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS
                    : PolygonShapesOptions.UNSELECTED_POLYGON_OPTIONS;
        feature.properties.isCustomName = false;
        feature.properties.selected = false;
        /** @type {?} */
        var polygon = this.pureMapService.createPolygon(__assign({ paths: this.getPolygonPaths(feature) }, feature.properties, unselectedOptions));
        if (!isDisabled) {
            this.setPolygonListeners(polygon);
        }
        this.polygons.push(polygon);
        if (isFromCadastralRegister) {
            /** @type {?} */
            var bounds_2 = new google.maps.LatLngBounds();
            this.getPolygonPaths(feature).forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return bounds_2.extend(x); }));
            this.pureMapService.fitBounds(bounds_2);
            this.setPolygonSelectedAndUpdateSelectedFeatures(polygon);
        }
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapAreaSelectControlService.prototype.setPolygonListeners = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        var _this = this;
        polygon.addListener('selected_changed', (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var isPolygonSelected = (/** @type {?} */ (polygon.get('selected')));
            /** @type {?} */
            var isParcel = (/** @type {?} */ (polygon.get('parcelId'))) != null;
            /** @type {?} */
            var polygonOptions = isPolygonSelected
                ? PolygonShapesOptions.SELECTED_POLYGON_OPTIONS
                : isParcel
                    ? PolygonShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS
                    : PolygonShapesOptions.UNSELECTED_POLYGON_OPTIONS;
            polygon.setOptions(polygonOptions);
        }));
        polygon.addListener('click', (/**
         * @return {?}
         */
        function () {
            _this.setPolygonSelectedAndUpdateSelectedFeatures(polygon);
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapAreaSelectControlService.prototype.setPolygonSelectedAndUpdateSelectedFeatures = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var isSelected = polygon.get('selected');
        this.setPolygonSelected(polygon, !isSelected);
        this.updateSelectedFeatures();
    };
    /**
     * @param {?} cadastralRegister
     * @return {?}
     */
    MapAreaSelectControlService.prototype.updateManuallySelectedMarker = /**
     * @param {?} cadastralRegister
     * @return {?}
     */
    function (cadastralRegister) {
        /** @type {?} */
        var selectedFeatures = this.getSelectedFeatures();
        // tslint:disable-next-line: no-any
        selectedFeatures.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            if (cadastralRegister !== null) {
                cadastralRegister.cadastreCoordinates = [x.geometry.coordinates];
                cadastralRegister.cadastreSizeInHa = x.properties.area;
                x.properties.isCustomName = true;
                x.properties.cadastralRegister = JSON.stringify(cadastralRegister);
                x.properties.name = cadastralRegister.cadastreGroundName;
            }
        }));
        this.selectedFeaturesSubject.next(selectedFeatures);
    };
    /**
     * @private
     * @return {?}
     */
    MapAreaSelectControlService.prototype.updateSelectedFeatures = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selectedFeatures = this.getSelectedFeatures();
        this.selectedFeaturesSubject.next(selectedFeatures);
    };
    /**
     * @private
     * @return {?}
     */
    MapAreaSelectControlService.prototype.getSelectedFeatures = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var selectedPolygons = this.polygons.filter((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) { return !!polygon.get('selected'); }));
        return selectedPolygons.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: _this.getPolygonCoordinates(x)
                },
                id: undefined,
                properties: {
                    name: x.get('name'),
                    area: x.get('area'),
                    isCustomName: x.get('isCustomName'),
                    centerPoint: x.get('centerPoint'),
                    parcelId: x.get('parcelId'),
                    cadastralRegister: x.get('cadastralRegister')
                }
            };
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapAreaSelectControlService.prototype.getPolygonCoordinates = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        return polygon.getPaths().getArray()
            .map((/**
         * @param {?} path
         * @return {?}
         */
        function (path) {
            return path.getArray().map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                return [x.lng(), x.lat()];
            }));
        }));
    };
    /**
     * @private
     * @param {?} feature
     * @return {?}
     */
    MapAreaSelectControlService.prototype.getPolygonPaths = /**
     * @private
     * @param {?} feature
     * @return {?}
     */
    function (feature) {
        /** @type {?} */
        var coordinates = feature.geometry.coordinates;
        return coordinates[0].map((/**
         * @param {?} coordinate
         * @return {?}
         */
        function (coordinate) {
            return new google.maps.LatLng(coordinate[1], coordinate[0]);
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapAreaSelectControlService.prototype.getPolygonCenterPoint = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var bounds = new google.maps.LatLngBounds();
        /** @type {?} */
        var polygonCoordinates = this.getPolygonCoordinates(polygon)[0];
        polygonCoordinates.push(polygonCoordinates[0]);
        polygonCoordinates.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            bounds.extend(new google.maps.LatLng(x[0], x[1]));
        }));
        /** @type {?} */
        var boundsCenter = bounds.getCenter();
        return new google.maps.LatLng(boundsCenter.lat(), boundsCenter.lng());
    };
    /**
     * @param {?} markerLatitude
     * @param {?} markerLongitude
     * @return {?}
     */
    MapAreaSelectControlService.prototype.mapMarkerPositionToGeolocationPosition = /**
     * @param {?} markerLatitude
     * @param {?} markerLongitude
     * @return {?}
     */
    function (markerLatitude, markerLongitude) {
        return {
            coords: {
                latitude: markerLatitude,
                longitude: markerLongitude,
                speed: null,
                heading: null,
                altitudeAccuracy: null,
                accuracy: null,
                altitude: null
            },
            timestamp: null
        };
    };
    MapAreaSelectControlService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapAreaSelectControlService.ctorParameters = function () { return [
        { type: PureMapService },
        { type: NumberUtilService }
    ]; };
    return MapAreaSelectControlService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.selectedFeaturesSubject;
    /** @type {?} */
    MapAreaSelectControlService.prototype.markerPosition;
    /** @type {?} */
    MapAreaSelectControlService.prototype.selectedFeatures$;
    /** @type {?} */
    MapAreaSelectControlService.prototype.isDrawingEnabled;
    /** @type {?} */
    MapAreaSelectControlService.prototype.isManuallyDraweMarkerSelected;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.mapCenterZoomValue;
    /** @type {?} */
    MapAreaSelectControlService.prototype.isCenteredToMarker;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.polygons;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.manuallyDrawedPolygons;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.setPolygonSelected;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.getFeatureKey;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.getPolygonKey;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.pureMapService;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlService.prototype.numberUtilService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegister = /** @class */ (function () {
    function CadastralRegister(cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, cadastreSizeInHa, cadastreCoordinates) {
        this.cadastralState = cadastralState;
        this.cadastralCounty = cadastralCounty;
        this.cadastralCommune = cadastralCommune;
        this.cadastralArea = cadastralArea;
        this.cadastreNumber = cadastreNumber;
        this.cadastreSizeInHa = cadastreSizeInHa;
        this.cadastreCoordinates = cadastreCoordinates;
    }
    return CadastralRegister;
}());
if (false) {
    /** @type {?} */
    CadastralRegister.prototype.cadastralState;
    /** @type {?} */
    CadastralRegister.prototype.cadastralCounty;
    /** @type {?} */
    CadastralRegister.prototype.cadastralCommune;
    /** @type {?} */
    CadastralRegister.prototype.cadastralArea;
    /** @type {?} */
    CadastralRegister.prototype.cadastreNumber;
    /** @type {?} */
    CadastralRegister.prototype.cadastreSizeInHa;
    /** @type {?} */
    CadastralRegister.prototype.cadastreCoordinates;
}
var CadastralRegisterGeoData = /** @class */ (function () {
    function CadastralRegisterGeoData(id, name) {
        this.id = id;
        this.name = name;
    }
    return CadastralRegisterGeoData;
}());
if (false) {
    /** @type {?} */
    CadastralRegisterGeoData.prototype.id;
    /** @type {?} */
    CadastralRegisterGeoData.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapAreaCadastralService = /** @class */ (function () {
    function MapAreaCadastralService(geolocationService, numberUtilService, cadastralRegisterProxyService) {
        var _this = this;
        this.geolocationService = geolocationService;
        this.numberUtilService = numberUtilService;
        this.cadastralRegisterProxyService = cadastralRegisterProxyService;
        this.getCurrentPosition = (/**
         * @return {?}
         */
        function () {
            return _this.geolocationService.getCurrentPosition();
        });
        this.searchCadastres = (/**
         * @param {?} position
         * @return {?}
         */
        function (position) {
            return _this.cadastralRegisterProxyService.searchCadastres(position.coords.latitude, position.coords.longitude);
        });
        this.convertToFeatures = (/**
         * @param {?} cadasterDetailsDtos
         * @return {?}
         */
        function (cadasterDetailsDtos) {
            return (cadasterDetailsDtos || [])
                .map((/**
             * @param {?} cadasterDetailsDto
             * @return {?}
             */
            function (cadasterDetailsDto) {
                /** @type {?} */
                var cadastralRegister = _this.buildCadastralRegister(cadasterDetailsDto);
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: cadasterDetailsDto.geojson.coordinates[0]
                    },
                    properties: {
                        name: cadasterDetailsDto.area.name + " - " + cadasterDetailsDto.number,
                        area: _this.round2AreaInHa(cadasterDetailsDto.size),
                        cadastralRegister: cadastralRegister != null ? JSON.stringify(cadastralRegister) : undefined
                    }
                };
            }));
        });
        this.buildCadastralRegister = (/**
         * @param {?} cadasterDetailsDto
         * @return {?}
         */
        function (cadasterDetailsDto) {
            if (cadasterDetailsDto == null
                || cadasterDetailsDto.area == null
                || cadasterDetailsDto.area.commune == null
                || cadasterDetailsDto.area.commune.county == null
                || cadasterDetailsDto.area.commune.county.state == null) {
                return null;
            }
            /** @type {?} */
            var cadastralState = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.county.state.id, cadasterDetailsDto.area.commune.county.state.name);
            /** @type {?} */
            var cadastralCounty = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.county.id, cadasterDetailsDto.area.commune.county.name);
            /** @type {?} */
            var cadastralCommune = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.id, cadasterDetailsDto.area.commune.name);
            /** @type {?} */
            var cadastralArea = new CadastralRegisterGeoData(cadasterDetailsDto.area.id, cadasterDetailsDto.area.name);
            /** @type {?} */
            var cadastreNumber = cadasterDetailsDto.number;
            /** @type {?} */
            var cadastreSizeInHa = cadasterDetailsDto.size;
            /** @type {?} */
            var cadastreCoordinates = cadasterDetailsDto.geojson.coordinates;
            return new CadastralRegister(cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, cadastreSizeInHa, cadastreCoordinates);
        });
    }
    /**
     * @return {?}
     */
    MapAreaCadastralService.prototype.getCadastresForCurrentPosition = /**
     * @return {?}
     */
    function () {
        return this.getCurrentPosition()
            .pipe(switchMap(this.searchCadastres))
            .pipe(map(this.convertToFeatures));
    };
    /**
     * @param {?} position
     * @return {?}
     */
    MapAreaCadastralService.prototype.getCadastresForMarkerPosition = /**
     * @param {?} position
     * @return {?}
     */
    function (position) {
        return this.searchCadastres(position)
            .pipe(map(this.convertToFeatures));
    };
    /**
     * @param {?} areaInHa
     * @return {?}
     */
    MapAreaCadastralService.prototype.round2AreaInHa = /**
     * @param {?} areaInHa
     * @return {?}
     */
    function (areaInHa) {
        return this.numberUtilService.round2(areaInHa);
    };
    MapAreaCadastralService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapAreaCadastralService.ctorParameters = function () { return [
        { type: GeolocationService },
        { type: NumberUtilService },
        { type: CadastralRegisterProxyService }
    ]; };
    return MapAreaCadastralService;
}());
if (false) {
    /** @type {?} */
    MapAreaCadastralService.prototype.getCurrentPosition;
    /**
     * @type {?}
     * @private
     */
    MapAreaCadastralService.prototype.searchCadastres;
    /**
     * @type {?}
     * @private
     */
    MapAreaCadastralService.prototype.convertToFeatures;
    /**
     * @type {?}
     * @private
     */
    MapAreaCadastralService.prototype.buildCadastralRegister;
    /**
     * @type {?}
     * @private
     */
    MapAreaCadastralService.prototype.geolocationService;
    /**
     * @type {?}
     * @private
     */
    MapAreaCadastralService.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    MapAreaCadastralService.prototype.cadastralRegisterProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterSelect = /** @class */ (function () {
    function CadastralRegisterSelect(value, label) {
        this.value = value;
        this.label = label;
    }
    return CadastralRegisterSelect;
}());
if (false) {
    /** @type {?} */
    CadastralRegisterSelect.prototype.value;
    /** @type {?} */
    CadastralRegisterSelect.prototype.label;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterFormService = /** @class */ (function () {
    function CadastralRegisterFormService(translateFormModelService, translateService, cadastralRegisterProxyService, formService) {
        var _this = this;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.cadastralRegisterProxyService = cadastralRegisterProxyService;
        this.formService = formService;
        this.statesSubject = new BehaviorSubject(new Array());
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
        this.stateSubscription = this.cadastralRegisterProxyService.getStates()
            .pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.displaySpinnerSubject.next(false); })))
            .subscribe((/**
         * @param {?} states
         * @return {?}
         */
        function (states) { return _this.statesSubject.next(states.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return new CadastralRegisterSelect(x.id, x.name); }))); }));
    }
    /**
     * @return {?}
     */
    CadastralRegisterFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.stateSubscription.unsubscribe();
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    CadastralRegisterFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    CadastralRegisterFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @return {?}
     */
    CadastralRegisterFormService.prototype.updateFormModelWithStateOptions$ = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var formModel$ = this.formModelSubject
            .pipe(startWith([null]), pairwise(), filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return JSON.stringify(prev) !== JSON.stringify(current);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return current;
        })));
        return combineLatest([formModel$, this.statesSubject])
            .pipe(tap((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), formModel = _b[0], states = _b[1];
            return _this.assignOptions(formModel, 'state', states);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), formModel = _b[0], states = _b[1];
            return formModel;
        })));
    };
    /**
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterFormService.prototype.updateFormWithCountyOptions$ = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        return this.getValueChanges(form, 'state', true)
            .pipe(startWith([null]), pairwise(), filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return JSON.stringify(prev) !== JSON.stringify(current);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return current;
        })))
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'county', form); })), filter((/**
         * @param {?} state
         * @return {?}
         */
        function (state) { return state; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} state
         * @return {?}
         */
        function (state) { return _this.cadastralRegisterProxyService.getCounties(state.value); })), map((/**
         * @param {?} counties
         * @return {?}
         */
        function (counties) { return counties.map((/**
         * @param {?} county
         * @return {?}
         */
        function (county) { return new CadastralRegisterSelect(county.id, county.name); })); })), tap((/**
         * @param {?} counties
         * @return {?}
         */
        function (counties) { return _this.assignOptions(_this.formModelSubject.getValue(), 'county', counties); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterFormService.prototype.updateFormWithCommuneOptions$ = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        return this.getValueChanges(form, 'county', true)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'commune', form); })), filter((/**
         * @param {?} county
         * @return {?}
         */
        function (county) { return county; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} county
         * @return {?}
         */
        function (county) {
            /** @type {?} */
            var state = form.get('state').value;
            return _this.cadastralRegisterProxyService.getCommunes(state.value, county.value);
        })), map((/**
         * @param {?} communes
         * @return {?}
         */
        function (communes) { return communes.map((/**
         * @param {?} commune
         * @return {?}
         */
        function (commune) { return new CadastralRegisterSelect(commune.id, commune.name); })); })), tap((/**
         * @param {?} communes
         * @return {?}
         */
        function (communes) { return _this.assignOptions(_this.formModelSubject.getValue(), 'commune', communes); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterFormService.prototype.updateFormWithAreaOptions$ = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        return this.getValueChanges(form, 'commune', true)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'area', form); })), filter((/**
         * @param {?} commune
         * @return {?}
         */
        function (commune) { return commune; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} commune
         * @return {?}
         */
        function (commune) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            return _this.cadastralRegisterProxyService.getAreas(state.value, county.value, commune.value);
        })), map((/**
         * @param {?} areas
         * @return {?}
         */
        function (areas) { return areas.map((/**
         * @param {?} area
         * @return {?}
         */
        function (area) { return new CadastralRegisterSelect(area.id, area.name); })); })), tap((/**
         * @param {?} areas
         * @return {?}
         */
        function (areas) { return _this.assignOptions(_this.formModelSubject.getValue(), 'area', areas); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormService.prototype.updateFormWithCadastreOptions$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        return this.getValueChanges(form, 'area', cadastreAsSelectInput)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'cadastre', form); })), filter((/**
         * @param {?} area
         * @return {?}
         */
        function (area) { return area; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} area
         * @return {?}
         */
        function (area) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            /** @type {?} */
            var commune = form.get('commune').value;
            return _this.cadastralRegisterProxyService.getCadastres(state.value, county.value, commune.value, area.value);
        })), map((/**
         * @param {?} cadastres
         * @return {?}
         */
        function (cadastres) { return cadastres.map((/**
         * @param {?} cadastre
         * @return {?}
         */
        function (cadastre) { return new CadastralRegisterSelect(cadastre.id, cadastre.number); })); })), tap((/**
         * @param {?} cadastres
         * @return {?}
         */
        function (cadastres) { return _this.assignOptions(_this.formModelSubject.getValue(), 'cadastre', cadastres); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormService.prototype.getArea$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        return this.getValueChanges(form, 'area', !cadastreAsSelectInput)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.patchValue(form, 'cadastre', null); })), filter((/**
         * @param {?} area
         * @return {?}
         */
        function (area) { return area; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} area
         * @return {?}
         */
        function (area) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            /** @type {?} */
            var commune = form.get('commune').value;
            return _this.cadastralRegisterProxyService.getArea(state.value, county.value, commune.value, area.value);
        })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormService.prototype.getCadastreDetails$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        return form.get('cadastre').valueChanges
            .pipe(filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return cadastreAsSelectInput; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} cadastre
         * @return {?}
         */
        function (cadastre) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            /** @type {?} */
            var commune = form.get('commune').value;
            /** @type {?} */
            var area = form.get('area').value;
            if (cadastre == null
                || state == null || state.value == null
                || county == null || county.value == null
                || commune == null || commune.value == null
                || area == null || area.value == null) {
                return of(null);
            }
            return cadastre.value == null
                ? _this.cadastralRegisterProxyService
                    .searchCadastre(state.value, county.value, commune.value, area.value, cadastre.label)
                : _this.cadastralRegisterProxyService
                    .getCadastre(state.value, county.value, commune.value, area.value, cadastre.value);
        })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormService.prototype.getCadastreTextInputValue$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        return form.get('cadastre').valueChanges
            .pipe(filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return !cadastreAsSelectInput; })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormService.prototype.clearFormOptions = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        this.clearOptions(this.formModelSubject.getValue(), 'county', form);
        this.clearOptions(this.formModelSubject.getValue(), 'commune', form);
        this.clearOptions(this.formModelSubject.getValue(), 'area', form);
        if (cadastreAsSelectInput) {
            this.clearOptions(this.formModelSubject.getValue(), 'cadastre', form);
        }
    };
    /**
     * @private
     * @param {?} form
     * @param {?} controlName
     * @param {?} isActiveValueChanges
     * @return {?}
     */
    CadastralRegisterFormService.prototype.getValueChanges = /**
     * @private
     * @param {?} form
     * @param {?} controlName
     * @param {?} isActiveValueChanges
     * @return {?}
     */
    function (form, controlName, isActiveValueChanges) {
        return form.get(controlName).valueChanges
            .pipe(filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return isActiveValueChanges; })), startWith([null]), pairwise(), filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return JSON.stringify(prev) !== JSON.stringify(current);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return current;
        })));
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} formGroup
     * @return {?}
     */
    CadastralRegisterFormService.prototype.clearOptions = /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} formGroup
     * @return {?}
     */
    function (formModel, controlName, formGroup) {
        /** @type {?} */
        var selectModel = (/** @type {?} */ (formModel.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === controlName; }))));
        selectModel.items = [];
        this.patchValue(formGroup, controlName, null);
        this.formModelSubject.next(formModel);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} data
     * @return {?}
     */
    CadastralRegisterFormService.prototype.assignOptions = /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} data
     * @return {?}
     */
    function (formModel, controlName, data) {
        /** @type {?} */
        var selectModel = (/** @type {?} */ (formModel.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === controlName; }))));
        selectModel.items = data;
        this.formModelSubject.next(formModel);
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    CadastralRegisterFormService.prototype.patchValue = /**
     * @private
     * @param {?} formGroup
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    function (formGroup, controlName, value) {
        if (this.isEquals(value, formGroup.get(controlName).value) === false) {
            formGroup.get(controlName).patchValue(value);
        }
    };
    /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    CadastralRegisterFormService.prototype.isEquals = /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    function (valueA, valueB) {
        if (valueA == null && valueB == null) {
            return true;
        }
        if (valueA == null || valueB == null) {
            return false;
        }
        return JSON.stringify(valueA) === JSON.stringify(valueB);
    };
    CadastralRegisterFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CadastralRegisterFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: CadastralRegisterProxyService },
        { type: DynamicFormService }
    ]; };
    return CadastralRegisterFormService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormService.prototype.stateSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormService.prototype.statesSubject;
    /** @type {?} */
    CadastralRegisterFormService.prototype.formModelSubject;
    /** @type {?} */
    CadastralRegisterFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormService.prototype.cadastralRegisterProxyService;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_MULTI_SELECT = 'NGXSELECT';
/**
 * @record
 * @template T
 */
function DynamicMultiSelectControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.compareWithFn;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.items;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.bindLabel;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.groupBy;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.multiple;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.readonly;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.addTag;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.useTranslate;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.translationPrefix;
    /** @type {?|undefined} */
    DynamicMultiSelectControlModelConfig.prototype.searchByField;
}
/**
 * @template T
 */
var DynamicMultiSelectControlModel = /** @class */ (function (_super) {
    __extends(DynamicMultiSelectControlModel, _super);
    function DynamicMultiSelectControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_MULTI_SELECT;
        _this.compareWithFn = isFunction(config.compareWithFn) ? config.compareWithFn : ɵlooseIdentical;
        _this.items = config.items || [];
        _this.bindLabel = config.bindLabel || 'label';
        _this.groupBy = config.groupBy || null;
        _this.multiple = isBoolean(config.multiple) ? config.multiple : false;
        _this.readonly = isBoolean(config.readonly) ? config.readonly : false;
        _this.addTag = isBoolean(config.addTag) ? config.addTag : false;
        _this.useTranslate = isBoolean(config.useTranslate) ? config.useTranslate : false;
        _this.translationPrefix = config.translationPrefix || null;
        _this.searchByField = config.searchByField || null;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicMultiSelectControlModel.prototype, "items", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMultiSelectControlModel.prototype, "bindLabel", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMultiSelectControlModel.prototype, "groupBy", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicMultiSelectControlModel.prototype, "multiple", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicMultiSelectControlModel.prototype, "readonly", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicMultiSelectControlModel.prototype, "addTag", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicMultiSelectControlModel.prototype, "useTranslate", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMultiSelectControlModel.prototype, "translationPrefix", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMultiSelectControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMultiSelectControlModel.prototype, "placeholder", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMultiSelectControlModel.prototype, "searchByField", void 0);
    return DynamicMultiSelectControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.compareWithFn;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.items;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.bindLabel;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.groupBy;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.multiple;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.readonly;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.addTag;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.useTranslate;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.translationPrefix;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.type;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.placeholder;
    /** @type {?} */
    DynamicMultiSelectControlModel.prototype.searchByField;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT = {
    grid: {
        host: 'col-12 col-xl-6 order-md-1',
        container: 'form-group row',
        label: 'col-12',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT = {
    state: FORM_LAYOUT_INPUT,
    county: FORM_LAYOUT_INPUT,
    commune: FORM_LAYOUT_INPUT,
    area: FORM_LAYOUT_INPUT,
    cadastre: FORM_LAYOUT_INPUT
};
/** @type {?} */
var CADASTRE_SELECT_INPUT_FORM_MODEL = [
    new DynamicMultiSelectControlModel({
        id: 'state',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'county',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'commune',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'area',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'cadastre',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        addTag: true,
        required: true,
        validators: {
            required: null
        }
    })
];
/** @type {?} */
var CADASTRE_TEXT_INPUT_FORM_MODEL = [
    new DynamicMultiSelectControlModel({
        id: 'state',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'county',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'commune',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'area',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'cadastre',
        minLength: 1,
        maxLength: 60,
        updateOn: 'blur',
        validators: {
            minLength: 1,
            maxLength: 60
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterFormComponent = /** @class */ (function () {
    function CadastralRegisterFormComponent(cadastralRegisterFormService) {
        this.cadastralRegisterFormService = cadastralRegisterFormService;
        this.formLayout = FORM_LAYOUT;
        this.cadastralRegisterChange = new EventEmitter();
        this.displaySpinnerSubject = this.cadastralRegisterFormService.displaySpinnerSubject;
    }
    Object.defineProperty(CadastralRegisterFormComponent.prototype, "displaySpinner$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.displaySpinnerSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterFormComponent.prototype, "formGroup", {
        get: /**
         * @return {?}
         */
        function () {
            return this.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterFormComponent.prototype, "cadastralRegister", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this.formGroup != null && this.isEquals(value, this.cadastralRegisterData) === false) {
                this.updateFormValue(value);
            }
            this.cadastralRegisterData = value;
            this.clearFormOptionsIfNotStateSelected();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterFormComponent.prototype, "cadastreAsSelectInput", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.cadastreAsSelectInputData = value;
            /** @type {?} */
            var formModel = value ? CADASTRE_SELECT_INPUT_FORM_MODEL : CADASTRE_TEXT_INPUT_FORM_MODEL;
            this.form = this.cadastralRegisterFormService.createFormGroup(formModel);
            this.cadastralRegisterFormService.formModelSubject.next(formModel);
            this.subscribeToStateChanges(this.form);
            this.subscribeToCountyChanges(this.form);
            this.subscribeToCommuneChanges(this.form);
            this.subscribeToAreaChangesForSelectInput(this.form, value);
            this.subscribeToAreaChangesForTextInput(this.form, value);
            this.subscribeToCadastreSelectInputChanges(this.form, value);
            this.subscribeToCadastreTextInputChanges(this.form, value);
            if (this.cadastralRegisterData != null) {
                this.updateFormValue(this.cadastralRegisterData);
            }
            this.clearFormOptionsIfNotStateSelected();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(CadastralRegisterFormComponent.prototype, "isDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value != null && value !== this.formGroup.disabled) {
                if (value) {
                    this.formGroup.disable();
                }
                else {
                    this.formGroup.enable();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.cadastralRegisterFormService.getFormModel$(this.translateKey);
        this.addStatesToFormModel();
    };
    /**
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.addStatesToFormModelSubscription.unsubscribe();
        if (this.stateChangesSubscription) {
            this.stateChangesSubscription.unsubscribe();
        }
        if (this.countyChangesSubscription) {
            this.countyChangesSubscription.unsubscribe();
        }
        if (this.communeChangesSubscription) {
            this.communeChangesSubscription.unsubscribe();
        }
        if (this.areaChangesForSelectInputSubscription) {
            this.areaChangesForSelectInputSubscription.unsubscribe();
        }
        if (this.areaChangesForTextInputSubscription) {
            this.areaChangesForTextInputSubscription.unsubscribe();
        }
        if (this.cadastreSelectInputChangesSubscription) {
            this.cadastreSelectInputChangesSubscription.unsubscribe();
        }
        if (this.cadastreTextInputChangesSubscription) {
            this.cadastreTextInputChangesSubscription.unsubscribe();
        }
    };
    /**
     * @private
     * @param {?} cadastralRegister
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} cadastralRegister
     * @return {?}
     */
    function (cadastralRegister) {
        /** @type {?} */
        var createCadastralRegisterSelect = (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data != null && data.id != null ? new CadastralRegisterSelect(data.id, data.name) : null;
        });
        /** @type {?} */
        var state = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralState) : null;
        /** @type {?} */
        var county = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralCounty) : null;
        /** @type {?} */
        var commune = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralCommune) : null;
        /** @type {?} */
        var area = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralArea) : null;
        this.patchValue('state', state);
        this.patchValue('county', county);
        this.patchValue('commune', commune);
        this.patchValue('area', area);
        /** @type {?} */
        var cadastre = this.cadastreAsSelectInputData
            ? (cadastralRegister != null && cadastralRegister.cadastreNumber != null
                ? new CadastralRegisterSelect(null, cadastralRegister.cadastreNumber)
                : null)
            : (cadastralRegister != null ? cadastralRegister.cadastreNumber : null);
        this.patchValue('cadastre', cadastre);
    };
    /**
     * @private
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.clearFormOptionsIfNotStateSelected = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.form != null && this.form.get('state').value == null) {
            this.cadastralRegisterFormService.clearFormOptions(this.form, this.cadastreAsSelectInputData);
        }
    };
    /**
     * @private
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.addStatesToFormModel = /**
     * @private
     * @return {?}
     */
    function () {
        this.addStatesToFormModelSubscription = this.cadastralRegisterFormService.updateFormModelWithStateOptions$()
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { }));
    };
    /**
     * @private
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.subscribeToStateChanges = /**
     * @private
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        this.stateChangesSubscription = this.cadastralRegisterFormService.updateFormWithCountyOptions$(form)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.subscribeToCountyChanges = /**
     * @private
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        this.countyChangesSubscription = this.cadastralRegisterFormService.updateFormWithCommuneOptions$(form)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.subscribeToCommuneChanges = /**
     * @private
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        this.communeChangesSubscription = this.cadastralRegisterFormService.updateFormWithAreaOptions$(form)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.subscribeToAreaChangesForSelectInput = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.areaChangesForSelectInputSubscription =
            this.cadastralRegisterFormService.updateFormWithCadastreOptions$(form, cadastreAsSelectInput)
                .subscribe((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.subscribeToAreaChangesForTextInput = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.areaChangesForTextInputSubscription = this.cadastralRegisterFormService.getArea$(form, cadastreAsSelectInput)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            /** @type {?} */
            var stateGeoData = _this.getGeoDataFromFormControl('state');
            /** @type {?} */
            var countyGeoData = _this.getGeoDataFromFormControl('county');
            /** @type {?} */
            var communeGeoData = _this.getGeoDataFromFormControl('commune');
            /** @type {?} */
            var areaGeoData = _this.getGeoDataFromFormControl('area');
            /** @type {?} */
            var cadastreNumber = _this.getFormControlStringValue('cadastre');
            /** @type {?} */
            var value = new CadastralRegister(stateGeoData, countyGeoData, communeGeoData, areaGeoData, cadastreNumber);
            _this.cadastralRegisterData = value;
            _this.cadastralRegisterChange.emit(value);
            _this.cadastralRegisterFormService.displaySpinnerSubject.next(false);
        }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.subscribeToCadastreSelectInputChanges = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.cadastreSelectInputChangesSubscription = this.cadastralRegisterFormService
            .getCadastreDetails$(form, cadastreAsSelectInput)
            .subscribe((/**
         * @param {?} cadastre
         * @return {?}
         */
        function (cadastre) {
            /** @type {?} */
            var stateGeoData = _this.getGeoDataFromFormControl('state');
            /** @type {?} */
            var countyGeoData = _this.getGeoDataFromFormControl('county');
            /** @type {?} */
            var communeGeoData = _this.getGeoDataFromFormControl('commune');
            /** @type {?} */
            var areaGeoData = _this.getGeoDataFromFormControl('area');
            /** @type {?} */
            var cadastreNumber = cadastre != null ? cadastre.number : null;
            /** @type {?} */
            var cadastreSize = cadastre != null ? cadastre.size : null;
            /** @type {?} */
            var cadastreCoordinates = cadastre != null && cadastre.geojson != null ? cadastre.geojson.coordinates : null;
            /** @type {?} */
            var value = new CadastralRegister(stateGeoData, countyGeoData, communeGeoData, areaGeoData, cadastreNumber, cadastreSize, cadastreCoordinates);
            if (cadastre != null) {
                _this.cadastralRegisterData = value;
            }
            _this.cadastralRegisterChange.emit(value);
            _this.cadastralRegisterFormService.displaySpinnerSubject.next(false);
        }), (/**
         * @return {?}
         */
        function () { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.subscribeToCadastreTextInputChanges = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.cadastreTextInputChangesSubscription = this.cadastralRegisterFormService
            .getCadastreTextInputValue$(form, cadastreAsSelectInput)
            .subscribe((/**
         * @param {?} cadastreNumber
         * @return {?}
         */
        function (cadastreNumber) {
            /** @type {?} */
            var stateGeoData = _this.getGeoDataFromFormControl('state');
            /** @type {?} */
            var countyGeoData = _this.getGeoDataFromFormControl('county');
            /** @type {?} */
            var communeGeoData = _this.getGeoDataFromFormControl('commune');
            /** @type {?} */
            var areaGeoData = _this.getGeoDataFromFormControl('area');
            _this.cadastralRegisterData = new CadastralRegister(stateGeoData, countyGeoData, communeGeoData, areaGeoData, cadastreNumber);
            _this.cadastralRegisterChange.emit(_this.cadastralRegisterData);
        }));
    };
    /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.getGeoDataFromFormControl = /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        /** @type {?} */
        var cadastralRegisterSelect = this.getFormControlValue(controlName);
        return cadastralRegisterSelect != null && cadastralRegisterSelect.value != null
            ? new CadastralRegisterGeoData(cadastralRegisterSelect.value, cadastralRegisterSelect.label)
            : null;
    };
    /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.getFormControlValue = /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        return this.form.get(controlName).value;
    };
    /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.getFormControlStringValue = /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        return this.form.get(controlName).value;
    };
    /**
     * @private
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.patchValue = /**
     * @private
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    function (controlName, value) {
        if (this.isEquals(value, this.getFormControlValue(controlName)) === false) {
            this.form.get(controlName).patchValue(value);
        }
    };
    /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    CadastralRegisterFormComponent.prototype.isEquals = /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    function (valueA, valueB) {
        if (valueA == null && valueB == null) {
            return true;
        }
        if (valueA == null || valueB == null) {
            return false;
        }
        return JSON.stringify(valueA) === JSON.stringify(valueB);
    };
    CadastralRegisterFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cadastral-register-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        CadastralRegisterProxyService,
                        CadastralRegisterFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    CadastralRegisterFormComponent.ctorParameters = function () { return [
        { type: CadastralRegisterFormService }
    ]; };
    CadastralRegisterFormComponent.propDecorators = {
        cadastralRegister: [{ type: Input }],
        translateKey: [{ type: Input }],
        cadastreAsSelectInput: [{ type: Input }],
        touched: [{ type: Input }],
        isDisabled: [{ type: Input }],
        cadastralRegisterChange: [{ type: Output }]
    };
    return CadastralRegisterFormComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.addStatesToFormModelSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.stateChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.countyChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.communeChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.areaChangesForSelectInputSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.areaChangesForTextInputSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.cadastreSelectInputChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.cadastreTextInputChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.cadastralRegisterData;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.displaySpinnerSubject;
    /** @type {?} */
    CadastralRegisterFormComponent.prototype.formModel$;
    /** @type {?} */
    CadastralRegisterFormComponent.prototype.formLayout;
    /** @type {?} */
    CadastralRegisterFormComponent.prototype.translateKey;
    /** @type {?} */
    CadastralRegisterFormComponent.prototype.cadastralRegisterChange;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.cadastreAsSelectInputData;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormComponent.prototype.cadastralRegisterFormService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterName = /** @class */ (function () {
    function CadastralRegisterName(cadastreGroundName, cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, cadastreSizeInHa, cadastreCoordinates) {
        this.cadastreGroundName = cadastreGroundName;
        this.cadastralState = cadastralState;
        this.cadastralCounty = cadastralCounty;
        this.cadastralCommune = cadastralCommune;
        this.cadastralArea = cadastralArea;
        this.cadastreNumber = cadastreNumber;
        this.cadastreSizeInHa = cadastreSizeInHa;
        this.cadastreCoordinates = cadastreCoordinates;
    }
    return CadastralRegisterName;
}());
if (false) {
    /** @type {?} */
    CadastralRegisterName.prototype.cadastreGroundName;
    /** @type {?} */
    CadastralRegisterName.prototype.cadastralState;
    /** @type {?} */
    CadastralRegisterName.prototype.cadastralCounty;
    /** @type {?} */
    CadastralRegisterName.prototype.cadastralCommune;
    /** @type {?} */
    CadastralRegisterName.prototype.cadastralArea;
    /** @type {?} */
    CadastralRegisterName.prototype.cadastreNumber;
    /** @type {?} */
    CadastralRegisterName.prototype.cadastreSizeInHa;
    /** @type {?} */
    CadastralRegisterName.prototype.cadastreCoordinates;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapAreaSelectControlComponent = /** @class */ (function () {
    function MapAreaSelectControlComponent(mapAreaSelectControlService, mapAreaCadastralService) {
        this.mapAreaSelectControlService = mapAreaSelectControlService;
        this.mapAreaCadastralService = mapAreaCadastralService;
        this.selectedFeaturesChange = new EventEmitter();
        this.showCadastreRegister = false;
        this.areFeaturesDrawed = false;
        this.featuresSubject = new BehaviorSubject(new Array());
        this.features$ = this.featuresSubject.asObservable();
        this.organizationLocationsSubject = new BehaviorSubject(new Array());
        this.organizationLocations$ = this.organizationLocationsSubject.asObservable();
        this.cadastralRegisterSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(false);
        this.featuresCadastralRegisterSubject = new BehaviorSubject(new Array());
        this.featuresCadastralRegister$ = this.featuresCadastralRegisterSubject.asObservable();
        this.cadastralRegisterForGroundSubject = new BehaviorSubject(null);
        this.cadastralRegisterForGround$ = this.cadastralRegisterForGroundSubject.asObservable();
    }
    Object.defineProperty(MapAreaSelectControlComponent.prototype, "features", {
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            this.featuresSubject.next(features || []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapAreaSelectControlComponent.prototype, "organizationLocations", {
        set: /**
         * @param {?} locationsJSON
         * @return {?}
         */
        function (locationsJSON) {
            /** @type {?} */
            var organizationLocationsArray = [];
            try {
                organizationLocationsArray = [].concat((/** @type {?} */ (JSON.parse(locationsJSON))));
            }
            catch (ex) { }
            this.organizationLocationsSubject.next(organizationLocationsArray);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapAreaSelectControlComponent.prototype, "cadastralRegister", {
        get: /**
         * @return {?}
         */
        function () {
            return this.cadastralRegisterSubject.value;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.cadastreNumber) {
                this.cadastralRegisterSubject.next(value);
                this.featuresCadastralRegisterSubject.next(new Array({
                    type: 'Feature',
                    id: v4(),
                    geometry: {
                        type: 'Polygon',
                        coordinates: value.cadastreCoordinates[0]
                    },
                    properties: {
                        name: value.cadastralArea.name + (" - " + value.cadastreNumber),
                        area: this.mapAreaCadastralService.round2AreaInHa(value.cadastreSizeInHa),
                        isCustomName: false,
                        parcelId: null,
                        cadastralRegister: JSON.stringify(value)
                    }
                }) || []);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapAreaSelectControlComponent.prototype, "cadastralRegisterForGround", {
        get: /**
         * @return {?}
         */
        function () {
            return this.cadastralRegisterForGroundSubject.value;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.cadastralRegisterForGroundSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapAreaSelectControlComponent.prototype, "isManualPolygonSelected", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.mapAreaSelectControlService.isManuallyDraweMarkerSelected) {
                this.cadastralRegisterForGroundSubject.next(null);
            }
            return this.mapAreaSelectControlService.isManuallyDraweMarkerSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapAreaSelectControlComponent.prototype, "displaySpinner$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.displaySpinnerSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.initSubscription = combineLatest([
            this.mapAreaSelectControlService.mapReady$,
            this.organizationLocations$,
            this.features$,
            this.featuresCadastralRegister$
        ]).subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 4), map = _b[0], organizationLocations = _b[1], features = _b[2], featuresCadastralRegister = _b[3];
            if (!_this.showCadastreRegister) {
                _this.mapAreaSelectControlService.turnOnDrawing();
            }
            if (!_this.areFeaturesDrawed) {
                _this.mapAreaSelectControlService.draw(features);
                _this.areFeaturesDrawed = true;
            }
            _this.mapAreaSelectControlService.draw(featuresCadastralRegister, true);
            _this.mapAreaSelectControlService.markPosition(organizationLocations);
        }));
        this.selectedFeaturesSubscription = this.mapAreaSelectControlService.selectedFeatures$.pipe(tap((/**
         * @return {?}
         */
        function () { return _this.displaySpinnerSubject.next(true); })), flatMap((/**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            _this.selectedFeaturesChange.emit(features);
            if (features.length > 0 && features[0].properties.isCustomName &&
                features[0].properties.centerPoint && !features[0].properties.cadastralRegister) {
                /** @type {?} */
                var selectedFeatureCenterPoint = _this.mapAreaSelectControlService.mapMarkerPositionToGeolocationPosition(features[0].properties.centerPoint[1], features[0].properties.centerPoint[0]);
                return _this.mapAreaCadastralService.getCadastresForMarkerPosition(selectedFeatureCenterPoint);
            }
            return of(null);
        })), catchError((/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            return of(null);
        }))).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res && res.length > 0) {
                /** @type {?} */
                var cadastralRegister = res[0].properties.cadastralRegister != null ?
                    JSON.parse(res[0].properties.cadastralRegister) : null;
                /** @type {?} */
                var cadastralRegisterName = _this.mapCadastralRegisterToCadastralRegisterName(cadastralRegister);
                _this.cadastralRegisterForGroundSubject.next(cadastralRegisterName);
            }
            _this.displaySpinnerSubject.next(false);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) { return _this.displaySpinnerSubject.next(false); }));
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.cadastralRegisterForGroundSubscription = this.cadastralRegisterForGround$.subscribe((/**
         * @param {?} cadastralRegister
         * @return {?}
         */
        function (cadastralRegister) {
            _this.mapAreaSelectControlService.updateManuallySelectedMarker(cadastralRegister);
        }));
        this.fieldAuditAreaSelectCadastreRegisterForm.touched = true;
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.initSubscription != null) {
            this.initSubscription.unsubscribe();
        }
        if (this.selectedFeaturesSubscription != null) {
            this.selectedFeaturesSubscription.unsubscribe();
        }
        if (this.fieldAuditAreaSelectGroundNameSubscription != null) {
            this.fieldAuditAreaSelectGroundNameSubscription.unsubscribe();
        }
        if (this.cadastralRegisterForGroundSubscription != null) {
            this.cadastralRegisterForGroundSubscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.showCadastreFeatures = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.mapAreaCadastralService.getCadastresForMarkerPosition(this.mapAreaSelectControlService.markerPosition.value).pipe(tap((/**
         * @return {?}
         */
        function () { return _this.displaySpinnerSubject.next(true); }))).subscribe((/**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            _this.mapAreaSelectControlService.draw(features);
            _this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(features);
            _this.displaySpinnerSubject.next(false);
        }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(false); }));
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.enableCadastre = /**
     * @return {?}
     */
    function () {
        this.showCadastreRegister = true;
        this.mapAreaSelectControlService.turnOffDrawing();
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.enableDrawing = /**
     * @return {?}
     */
    function () {
        this.showCadastreRegister = false;
        this.mapAreaSelectControlService.turnOnDrawing();
    };
    /**
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.centerMapToMarker = /**
     * @return {?}
     */
    function () {
        this.mapAreaSelectControlService.centerToMarkerPosition();
    };
    /**
     * @private
     * @param {?} cadastralRegister
     * @return {?}
     */
    MapAreaSelectControlComponent.prototype.mapCadastralRegisterToCadastralRegisterName = /**
     * @private
     * @param {?} cadastralRegister
     * @return {?}
     */
    function (cadastralRegister) {
        return new CadastralRegisterName(null, cadastralRegister.cadastralState, cadastralRegister.cadastralCounty, cadastralRegister.cadastralCommune, cadastralRegister.cadastralArea);
    };
    MapAreaSelectControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-map-area-select-control',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <button class=\"btn btn-raised btn-primary mb-2 mr-2\" (click)=\"enableDrawing()\">{{\r\n        'FIELDAUDIT.SELECTFIELDAUDITAREA.draw' | translate }}</button>\r\n    <button class=\"btn btn-raised btn-primary mb-2 mr-2\" (click)=\"enableCadastre()\">{{\r\n        'FIELDAUDIT.SELECTFIELDAUDITAREA.takeFromCadastral' | translate }}</button>\r\n    <div class=\"map-container\">\r\n        <app-pure-map [height]=\"420\"></app-pure-map>\r\n        <div class=\"map-buttons\">\r\n            <div class=\"icon-button\">\r\n                <button (click)=\"showCadastreFeatures()\">{{ 'FIELDAUDIT.SELECTFIELDAUDITAREA.showCadastre' | translate\r\n                    }}</button>\r\n            </div>\r\n            <div\r\n                style=\"position: relative; overflow: hidden; width: 110px; height: 1px; margin: 0px 5px; background-color: rgb(230, 230, 230); top: 0px;\">\r\n            </div>\r\n            <div class=\"icon-button icon-button__search\">\r\n                <button (click)=\"centerMapToMarker()\">{{ 'FIELDAUDIT.SELECTFIELDAUDITAREA.centerMap' | translate\r\n                    }}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"showCadastreRegister\" class=\"col-12 mt-3\">\r\n        <app-cadastral-register-form [(cadastralRegister)]=\"cadastralRegister\" [translateKey]=\"'GROUND'\"\r\n            [cadastreAsSelectInput]=\"true\">\r\n        </app-cadastral-register-form>\r\n    </div>\r\n    <div [hidden]=\"!isManualPolygonSelected\" class=\"mt-4\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-target\"></i> {{ 'FIELDAUDIT.SELECTFIELDAUDITAREA.groundInfo' | translate }}\r\n            </h5>\r\n        </label>\r\n        <hr class=\"mt-0 ng-star-inserted\">\r\n        <app-cadastral-register-name-form #fieldAuditAreaSelectCadastreRegisterForm\r\n            [(cadastralRegister)]=\"cadastralRegisterForGround\" [translateKey]=\"'GROUND'\"\r\n            [cadastreAsSelectInput]=\"false\">\r\n        </app-cadastral-register-name-form>\r\n    </div>\r\n</div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [CadastralRegisterProxyService, MapAreaCadastralService, MapAreaSelectControlService],
                    styles: [".map-container{position:relative}.map-buttons{position:absolute;display:flex;flex-direction:column;background-color:#fff;border-radius:2px;left:15px;bottom:25px;z-index:1000;box-shadow:#000 0 1px 4px -1px}.map-buttons .icon-button{position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;background-color:#fff;border-radius:2px;width:120px;height:40px}.map-buttons .icon-button button{background:padding-box #fff;display:table-cell;border:0;margin:0;text-transform:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;direction:ltr;overflow:hidden;text-align:center;height:40px;vertical-align:middle;color:#565656;font-family:Roboto,Arial,sans-serif;font-size:18px;border-bottom-left-radius:2px;border-top-left-radius:2px;box-shadow:#000 0 1px 4px -1px;min-width:120px}.map-buttons .icon-button button:hover{background:padding-box #ebebeb;display:table-cell}.map-buttons .icon-button button:focus{color:#000}"]
                }] }
    ];
    /** @nocollapse */
    MapAreaSelectControlComponent.ctorParameters = function () { return [
        { type: MapAreaSelectControlService },
        { type: MapAreaCadastralService }
    ]; };
    MapAreaSelectControlComponent.propDecorators = {
        fieldAuditAreaSelectCadastreRegisterForm: [{ type: ViewChild, args: ['fieldAuditAreaSelectCadastreRegisterForm', { static: false },] }],
        features: [{ type: Input }],
        organizationLocations: [{ type: Input }],
        selectedFeatures: [{ type: Input }],
        selectedFeaturesChange: [{ type: Output }],
        cadastralRegister: [{ type: Input }],
        cadastralRegisterForGround: [{ type: Input }]
    };
    return MapAreaSelectControlComponent;
}());
if (false) {
    /** @type {?} */
    MapAreaSelectControlComponent.prototype.fieldAuditAreaSelectCadastreRegisterForm;
    /** @type {?} */
    MapAreaSelectControlComponent.prototype.selectedFeatures;
    /** @type {?} */
    MapAreaSelectControlComponent.prototype.selectedFeaturesChange;
    /** @type {?} */
    MapAreaSelectControlComponent.prototype.showCadastreRegister;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.areFeaturesDrawed;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.featuresSubject;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.features$;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.organizationLocationsSubject;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.organizationLocations$;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.cadastralRegisterSubject;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.featuresCadastralRegisterSubject;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.featuresCadastralRegister$;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.cadastralRegisterForGroundSubject;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.cadastralRegisterForGround$;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.initSubscription;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.selectedFeaturesSubscription;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.cadastralRegisterForGroundSubscription;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.fieldAuditAreaSelectGroundNameSubscription;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.mapAreaSelectControlService;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectControlComponent.prototype.mapAreaCadastralService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapAreaSelectFormControlComponent = /** @class */ (function () {
    function MapAreaSelectFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        // tslint:disable-next-line: variable-name
        this._selectedFeatures = new Array();
        this.isDisabled = false;
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(MapAreaSelectFormControlComponent.prototype, "selectedFeatures", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selectedFeatures;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._selectedFeatures = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    MapAreaSelectFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._selectedFeatures = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapAreaSelectFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapAreaSelectFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MapAreaSelectFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    MapAreaSelectFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-map-area-select-form-control',
                    template: "<lib-map-area-select-control [features]=\"features\" [(selectedFeatures)]=\"selectedFeatures\"  [organizationLocations] = \"organizationLocations\"></lib-map-area-select-control>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MapAreaSelectFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    MapAreaSelectFormControlComponent.propDecorators = {
        features: [{ type: Input }],
        organizationLocations: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MapAreaSelectFormControlComponent;
}());
if (false) {
    /** @type {?} */
    MapAreaSelectFormControlComponent.prototype.features;
    /** @type {?} */
    MapAreaSelectFormControlComponent.prototype.organizationLocations;
    /** @type {?} */
    MapAreaSelectFormControlComponent.prototype.blur;
    /** @type {?} */
    MapAreaSelectFormControlComponent.prototype.change;
    /** @type {?} */
    MapAreaSelectFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectFormControlComponent.prototype._selectedFeatures;
    /** @type {?} */
    MapAreaSelectFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    MapAreaSelectFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_MAP = 'MAP';
/**
 * @record
 */
function DynamicMapControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicMapControlModelConfig.prototype.mapConfig;
    /** @type {?} */
    DynamicMapControlModelConfig.prototype.polygonConfig;
    /** @type {?} */
    DynamicMapControlModelConfig.prototype.markerConfig;
}
var DynamicMapControlModel = /** @class */ (function (_super) {
    __extends(DynamicMapControlModel, _super);
    function DynamicMapControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_MAP;
        _this.mapConfig = config.mapConfig;
        _this.polygonConfig = config.polygonConfig;
        _this.markerConfig = config.markerConfig;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMapControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", MapConfig)
    ], DynamicMapControlModel.prototype, "mapConfig", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", PolygonConfig)
    ], DynamicMapControlModel.prototype, "polygonConfig", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", MarkerConfig)
    ], DynamicMapControlModel.prototype, "markerConfig", void 0);
    return DynamicMapControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMapControlModel.prototype.type;
    /** @type {?} */
    DynamicMapControlModel.prototype.mapConfig;
    /** @type {?} */
    DynamicMapControlModel.prototype.polygonConfig;
    /** @type {?} */
    DynamicMapControlModel.prototype.markerConfig;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMapFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMapFormControlComponent, _super);
    function DynamicMapFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMapFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-map-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-map-form-control formControlName=\"{{model.id}}\" [mapConfig]=\"model.mapConfig\"\r\n        [polygonConfig]=\"model.polygonConfig\" [markerConfig]=\"model.markerConfig\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        (blur)=\"onBlur($event)\" (change)=\"onChange($event)\" (focus)=\"onFocus($event)\">\r\n    </app-map-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicMapFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMapFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMapFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMapFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMapFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMapFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMapFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMapFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMapFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMapFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapFormControlComponent = /** @class */ (function () {
    function MapFormControlComponent() {
        // tslint:disable-next-line: variable-name
        this._features = new Array();
        this.isDisabled = false;
        this.mapConfig = new MapConfig();
        this.polygonConfig = new PolygonConfig();
        this.markerConfig = new MarkerConfig();
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(MapFormControlComponent.prototype, "features", {
        get: /**
         * @return {?}
         */
        function () {
            return this._features;
        },
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            this._features = features;
            this.onChange(features);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    MapFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._features = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MapFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    MapFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-map-form-control',
                    template: "<div style=\"height: 400px;\">\r\n    <app-map [mapConfig]=\"mapConfig\" [polygonConfig]=\"polygonConfig\" [markerConfig]=\"markerConfig\"\r\n        [(features)]=\"features\" [isDisabled]=\"isDisabled\">\r\n    </app-map>\r\n</div>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MapFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    MapFormControlComponent.propDecorators = {
        mapConfig: [{ type: Input }],
        polygonConfig: [{ type: Input }],
        markerConfig: [{ type: Input }],
        features: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MapFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MapFormControlComponent.prototype._features;
    /** @type {?} */
    MapFormControlComponent.prototype.isDisabled;
    /** @type {?} */
    MapFormControlComponent.prototype.mapConfig;
    /** @type {?} */
    MapFormControlComponent.prototype.polygonConfig;
    /** @type {?} */
    MapFormControlComponent.prototype.markerConfig;
    /** @type {?} */
    MapFormControlComponent.prototype.blur;
    /** @type {?} */
    MapFormControlComponent.prototype.change;
    /** @type {?} */
    MapFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    MapFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    MapFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFileFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicFileFormControlComponent, _super);
    function DynamicFileFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicFileFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-file-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-file-form-control [formControlName]=\"model.id\"\r\n                            [name]=\"model.name\"\r\n                            [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n                            [multiple]=\"model.multiple\"\r\n                            [accept]=\"model.accept\"\r\n                            [maxSize]=\"model.maxSize\"\r\n                            [readonly]=\"model.disabled\"\r\n                            (blur)=\"onBlur($event)\"\r\n                            (change)=\"onChange($event)\"\r\n                            (focus)=\"onFocus($event)\"></lib-file-form-control>\r\n\r\n</ng-container>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DynamicFileFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicFileFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicFileFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicFileFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicFileFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicFileFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicFileFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicFileFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicFileFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicFileFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicFileFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicFileFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ResizeOptions() { }
if (false) {
    /** @type {?|undefined} */
    ResizeOptions.prototype.resizeHeight;
    /** @type {?|undefined} */
    ResizeOptions.prototype.resizeWidth;
    /** @type {?|undefined} */
    ResizeOptions.prototype.resizeQuality;
    /** @type {?|undefined} */
    ResizeOptions.prototype.resizeType;
    /** @type {?|undefined} */
    ResizeOptions.prototype.resizeMode;
}
/**
 * @param {?} url
 * @param {?} cb
 * @return {?}
 */
function createImage(url, cb) {
    /** @type {?} */
    var image = new Image();
    // tslint:disable-next-line: only-arrow-functions
    image.onload = (/**
     * @return {?}
     */
    function () {
        cb(image);
    });
    image.src = url;
}
/** @type {?} */
var resizeAreaId = 'imageupload-resize-area';
/**
 * @return {?}
 */
function getResizeArea() {
    /** @type {?} */
    var resizeArea = document.getElementById(resizeAreaId);
    if (!resizeArea) {
        resizeArea = document.createElement('canvas');
        resizeArea.id = resizeAreaId;
        resizeArea.style.display = 'none';
        document.body.appendChild(resizeArea);
    }
    return (/** @type {?} */ (resizeArea));
}
// tslint:disable-next-line: cognitive-complexity
/**
 * @param {?} origImage
 * @param {?=} __1
 * @return {?}
 */
function resizeImage(origImage, _a) {
    var _b = _a === void 0 ? {} : _a, resizeHeight = _b.resizeHeight, resizeWidth = _b.resizeWidth, 
    // tslint:disable-next-line: no-magic-numbers
    _c = _b.resizeQuality, 
    // tslint:disable-next-line: no-magic-numbers
    resizeQuality = _c === void 0 ? 0.7 : _c, _d = _b.resizeType, resizeType = _d === void 0 ? 'image/jpeg' : _d, _e = _b.resizeMode, resizeMode = _e === void 0 ? 'fill' : _e;
    /** @type {?} */
    var canvas = getResizeArea();
    /** @type {?} */
    var height = origImage.height;
    /** @type {?} */
    var width = origImage.width;
    /** @type {?} */
    var offsetX = 0;
    /** @type {?} */
    var offsetY = 0;
    if (resizeMode === 'fill') {
        // calculate the width and height, constraining the proportions
        if (width / height > resizeWidth / resizeHeight) {
            width = Math.round(height * resizeWidth / resizeHeight);
        }
        else {
            height = Math.round(width * resizeHeight / resizeWidth);
        }
        canvas.width = resizeWidth <= width ? resizeWidth : width;
        canvas.height = resizeHeight <= height ? resizeHeight : height;
        // tslint:disable-next-line: no-magic-numbers
        offsetX = origImage.width / 2 - width / 2;
        // tslint:disable-next-line: no-magic-numbers
        offsetY = origImage.height / 2 - height / 2;
        // draw image on canvas
        /** @type {?} */
        var ctx = canvas.getContext('2d');
        ctx.drawImage(origImage, offsetX, offsetY, width, height, 0, 0, canvas.width, canvas.height);
    }
    else if (resizeMode === 'fit') {
        // calculate the width and height, constraining the proportions
        if (width > height) {
            if (width > resizeWidth) {
                height = Math.round(height *= resizeWidth / width);
                width = resizeWidth;
            }
        }
        else {
            if (height > resizeHeight) {
                width = Math.round(width *= resizeHeight / height);
                height = resizeHeight;
            }
        }
        canvas.width = width;
        canvas.height = height;
        // draw image on canvas
        /** @type {?} */
        var ctx = canvas.getContext('2d');
        ctx.drawImage(origImage, 0, 0, width, height);
    }
    else {
        throw new Error('Unknown resizeMode: ' + resizeMode);
    }
    // get the data from canvas as 70% jpg (or specified type).
    return canvas.toDataURL(resizeType, resizeQuality);
}
// tslint:disable-next-line: max-line-length
/** @type {?} */
var documentImageDataUrl = "data:image/png;base64,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";

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileFormService = /** @class */ (function () {
    function FileFormService() {
    }
    /**
     * @return {?}
     */
    FileFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} file
     * @param {?} allowedImageTypes
     * @return {?}
     */
    FileFormService.prototype.setImageThumbnailFromUrl = /**
     * @param {?} file
     * @param {?} allowedImageTypes
     * @return {?}
     */
    function (file, allowedImageTypes) {
        if (file.mimeType && file.mimeType.includes('image')) {
            return { noImageFile: false, url: file.link };
        }
        if (file.mimeType == null || file.mimeType === undefined) {
            /** @type {?} */
            var fileExtension = new URL(file.link.split('?sv')[0]).pathname.split('.')[1];
            if (!allowedImageTypes.includes(fileExtension)) {
                return { noImageFile: true, url: documentImageDataUrl };
            }
            else {
                return { noImageFile: false, url: file.link };
            }
        }
        return { noImageFile: true, url: documentImageDataUrl };
    };
    /**
     * @param {?} file
     * @param {?} allowedImageTypes
     * @return {?}
     */
    FileFormService.prototype.setImageThumbnailFromFile = /**
     * @param {?} file
     * @param {?} allowedImageTypes
     * @return {?}
     */
    function (file, allowedImageTypes) {
        /** @type {?} */
        var extension = file.name.split('.')[1];
        if (!allowedImageTypes.includes(extension)) {
            return {
                file: file,
                url: documentImageDataUrl,
                noImageFile: true
            };
        }
        else {
            return {
                file: file,
                url: URL.createObjectURL(file),
                noImageFile: false
            };
        }
    };
    FileFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FileFormService.ctorParameters = function () { return []; };
    return FileFormService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ImageResult() { }
if (false) {
    /** @type {?} */
    ImageResult.prototype.file;
    /** @type {?} */
    ImageResult.prototype.url;
    /** @type {?|undefined} */
    ImageResult.prototype.dataURL;
    /** @type {?|undefined} */
    ImageResult.prototype.width;
    /** @type {?|undefined} */
    ImageResult.prototype.height;
    /** @type {?|undefined} */
    ImageResult.prototype.resized;
}
var FileFormControlComponent = /** @class */ (function () {
    function FileFormControlComponent(changeDetector, fileFormService, lightbox, gallery) {
        this.changeDetector = changeDetector;
        this.fileFormService = fileFormService;
        this.lightbox = lightbox;
        this.gallery = gallery;
        this.isDraggingOverDropZone = false;
        this.isFile = false;
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.thumbnailWidth = 150;
        this.thumbnailHeight = 150;
        this.noImageFile = false;
        this.isDisabled = false;
        this.allowedImageTypes = ['jpg', 'jpeg', 'png', 'svg', 'jfif', 'gif', 'bmp'];
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    /**
     * @return {?}
     */
    FileFormControlComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    Object.defineProperty(FileFormControlComponent.prototype, "imageThumbnail", {
        get: /**
         * @return {?}
         */
        function () {
            return this._imageThumbnail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileFormControlComponent.prototype, "imageName", {
        get: /**
         * @return {?}
         */
        function () {
            return this._imageFile.rootFileName ? this._imageFile.rootFileName : this._imageFile.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileFormControlComponent.prototype, "imageFile", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._imageFile = value;
            this.onChange(this._imageFile);
            this.onTouched();
            this.initImageThumbnail();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    FileFormControlComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.imageFile = value;
        this.initImageThumbnail();
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FileFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FileFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @return {?}
     */
    FileFormControlComponent.prototype.onImageClicked = /**
     * @return {?}
     */
    function () {
        if (!this.readonly) {
            this.fileInputElement.nativeElement.click();
        }
    };
    /**
     * @return {?}
     */
    FileFormControlComponent.prototype.onFileChanged = /**
     * @return {?}
     */
    function () {
        this.dismissError();
        /** @type {?} */
        var file = (/** @type {?} */ (this.fileInputElement.nativeElement.files[0]));
        if (!file) {
            return;
        }
        this.setFile(file);
    };
    /**
     * @return {?}
     */
    FileFormControlComponent.prototype.openLightbox = /**
     * @return {?}
     */
    function () {
        this.initGallery();
        this.lightbox.open(0, this.galleryId);
    };
    /**
     * @param {?} file
     * @return {?}
     */
    FileFormControlComponent.prototype.validate = /**
     * @param {?} file
     * @return {?}
     */
    function (file) {
        if (this.accept && this.accept.length > 0 && !this.accept.some((/**
         * @param {?} allowedType
         * @return {?}
         */
        function (allowedType) { return file.type === allowedType; }))) {
            this.errorMessageTranslationKey = 'APPLICATION.VALIDATORS.fileAcceptFormat';
            this.errorMessageInfo = '';
            return false;
        }
        // tslint:disable-next-line: no-magic-numbers
        if (this.maxSize && file.size > this.maxSize * 1024 * 1024) {
            this.errorMessageTranslationKey = 'APPLICATION.VALIDATORS.fileMaxSize';
            this.errorMessageInfo = this.maxSize + " MB";
            return false;
        }
        return true;
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    FileFormControlComponent.prototype.setFile = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        if (this.validate(file)) {
            this.imageFile = {
                name: file.name,
                file: file
            };
        }
        else {
            this.imageFile = undefined;
        }
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    FileFormControlComponent.prototype.setImageThumbnailFromFile = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        var _this = this;
        /** @type {?} */
        var result = null;
        /** @type {?} */
        var res = this.fileFormService.setImageThumbnailFromFile(file, this.allowedImageTypes);
        this.noImageFile = res.noImageFile;
        result = {
            file: res.file,
            url: res.url
        };
        this.resize(result).then((/**
         * @param {?} r
         * @return {?}
         */
        function (r) {
            _this._imageThumbnail = r.resized.dataURL;
            _this.origImageWidth = r.width;
            _this.orgiImageHeight = r.height;
            _this.isFile = true;
            if (_this.changeDetector && !((/** @type {?} */ (_this.changeDetector))).destroyed) {
                _this.changeDetector.detectChanges();
            }
        }));
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    FileFormControlComponent.prototype.setImageThumbnailFromUrl = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        /** @type {?} */
        var result = this.fileFormService.setImageThumbnailFromUrl(file, this.allowedImageTypes);
        this._imageThumbnail = result.url;
        this.noImageFile = result.noImageFile;
        this.isFile = true;
    };
    /**
     * @private
     * @return {?}
     */
    FileFormControlComponent.prototype.initImageThumbnail = /**
     * @private
     * @return {?}
     */
    function () {
        if (this._imageFile) {
            if (this._imageFile.link != null) {
                this.setImageThumbnailFromUrl(this._imageFile);
            }
            else if (this._imageFile.file != null) {
                this.setImageThumbnailFromFile(this._imageFile.file);
            }
        }
        else {
            this._imageThumbnail = undefined;
            this.isFile = false;
        }
    };
    /**
     * @return {?}
     */
    FileFormControlComponent.prototype.downloadFile = /**
     * @return {?}
     */
    function () {
        if (this._imageFile.link) {
            /** @type {?} */
            var downloadLink = document.createElement('a');
            downloadLink.href = this._imageFile.link;
            downloadLink.download = this.imageName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };
    /**
     * @return {?}
     */
    FileFormControlComponent.prototype.removeImage = /**
     * @return {?}
     */
    function () {
        this.fileInputElement.nativeElement.value = null;
        this.imageFile = undefined;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    FileFormControlComponent.prototype.drop = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.dismissError();
        if (!e.dataTransfer || !e.dataTransfer.files.length) {
            return;
        }
        this.setFile(e.dataTransfer.files[0]);
        this.updateDragOverlayStyles(false);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    FileFormControlComponent.prototype.dragenter = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    /**
     * @param {?} e
     * @return {?}
     */
    FileFormControlComponent.prototype.dragover = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.updateDragOverlayStyles(true);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    FileFormControlComponent.prototype.dragleave = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.updateDragOverlayStyles(false);
    };
    /**
     * @private
     * @param {?} isDragOver
     * @return {?}
     */
    FileFormControlComponent.prototype.updateDragOverlayStyles = /**
     * @private
     * @param {?} isDragOver
     * @return {?}
     */
    function (isDragOver) {
        this.isDraggingOverDropZone = isDragOver;
    };
    /**
     * @private
     * @param {?} result
     * @return {?}
     */
    FileFormControlComponent.prototype.resize = /**
     * @private
     * @param {?} result
     * @return {?}
     */
    function (result) {
        var _this = this;
        /** @type {?} */
        var resizeOptions = {
            resizeHeight: this.thumbnailHeight,
            resizeWidth: this.thumbnailWidth,
            resizeType: result.file.type,
            resizeMode: 'fit'
        };
        return new Promise((/**
         * @param {?} resolve
         * @return {?}
         */
        function (resolve) {
            createImage(result.url, (/**
             * @param {?} image
             * @return {?}
             */
            function (image) {
                /** @type {?} */
                var dataUrl = resizeImage(image, resizeOptions);
                result.width = image.width;
                result.height = image.height;
                result.resized = {
                    dataURL: dataUrl,
                    type: _this.getType(dataUrl)
                };
                resolve(result);
            }));
        }));
    };
    /**
     * @private
     * @return {?}
     */
    FileFormControlComponent.prototype.dismissError = /**
     * @private
     * @return {?}
     */
    function () {
        this.errorMessageInfo = undefined;
        this.errorMessageTranslationKey = undefined;
    };
    /**
     * @private
     * @param {?} dataUrl
     * @return {?}
     */
    FileFormControlComponent.prototype.getType = /**
     * @private
     * @param {?} dataUrl
     * @return {?}
     */
    function (dataUrl) {
        return dataUrl.match(/:(.+\/.+;)/)[1];
    };
    /**
     * @private
     * @return {?}
     */
    FileFormControlComponent.prototype.initGallery = /**
     * @private
     * @return {?}
     */
    function () {
        this.galleryId = "" + this.imageName;
        /** @type {?} */
        var items = [];
        /** @type {?} */
        var item = new ImageItem({
            src: this._imageFile.link ? this._imageFile.link : URL.createObjectURL(this._imageFile.file),
            thumb: this._imageThumbnail
        });
        items.push(item);
        /** @type {?} */
        var galleryRef = this.gallery.ref(this.galleryId);
        galleryRef.load(items);
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    FileFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    FileFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-file-form-control',
                    template: "<div class=\"image-container\">\r\n    <div class=\"match-parent\">\r\n        <div class=\"not-selected\" [ngClass]=\"{'over': isDraggingOverDropZone}\" *ngIf=\"!isFile\">\r\n            <button type=\"button\" class=\"add-image-btn\" (click)=\"onImageClicked()\">\r\n                <div>\r\n                    <p class=\"plus\">\r\n                        <i class=\"ft\" [ngClass]=\"{'ft-plus': !readonly, 'ft-image': readonly}\"></i>\r\n                    </p>\r\n                    <span *ngIf=\"errorMessageTranslationKey\" class=\"text-danger font-small-2\">{{\r\n                        errorMessageTranslationKey | translate }}{{ errorMessageInfo }}</span>\r\n                </div>\r\n            </button>\r\n        </div>\r\n        <div class=\"selected-status-wrapper\" *ngIf=\"isFile\">\r\n            <div class=\"hide\">\r\n                <div class=\"buttons-wrapper\">\r\n                    <i role=\"button\" tabindex=\"0\" *ngIf=\"!noImageFile\" (click)=\"openLightbox()\"\r\n                        class=\"btn btn-raised btn-primary mb-0 ng-star-inserted custom-button zoom-button\">\r\n                        <p class=\"button-icon\">\r\n                            <i class=\"ft ft-zoom-in\"></i>\r\n                        </p>\r\n                    </i>\r\n                    <i *ngIf=\"this._imageFile.link\" role=\"button\" tabindex=\"0\"\r\n                        class=\"btn btn-raised btn-primary mb-0 ng-star-inserted custom-button\" (click)=\"downloadFile()\">\r\n                        <p class=\"button-icon\">\r\n                            <i class=\"ft ft-download\"></i>\r\n                        </p>\r\n                    </i>\r\n                </div>\r\n            </div>\r\n            <img [src]=\"imageThumbnail\" #imageElement />\r\n            <span *ngIf=\"noImageFile\" class=\"no-image-file-span\">{{ imageName.length>15 ? (imageName | slice:0:15) +\r\n                \"...\" : (imageName) }}</span>\r\n            <button type=\"button\" class=\"remove\" (click)=\"removeImage()\" *ngIf=\"!readonly\"\r\n                [disabled]=\"isDisabled\">\u00D7</button>\r\n        </div>\r\n    </div>\r\n    <fieldset [disabled]=\"isDisabled\">\r\n        <input type=\"file\" #fileInput (change)=\"onFileChanged()\" />\r\n    </fieldset>\r\n    <div class=\"drag-overlay\" [hidden]=\"true\" #dragOverlay></div>\r\n</div>\r\n",
                    // tslint:disable-next-line: use-host-property-decorator
                    host: {
                        '[style.width]': 'thumbnailWidth + "px"',
                        '[style.height]': 'thumbnailHeight + "px"',
                        '[style.max-width]': 'thumbnailWidth + "px"',
                        '(drop)': 'drop($event)',
                        '(dragenter)': 'dragenter($event)',
                        '(dragover)': 'dragover($event)',
                        '(dragleave)': 'dragleave($event)',
                    },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return FileFormControlComponent; })),
                            multi: true
                        },
                        FileFormService
                    ],
                    styles: [":host{display:block}.match-parent,.not-selected{max-width:inherit;width:100%;height:100%}.not-selected{border:3px dotted #d3d3d3}.not-selected.over{border:3px dotted red}.add-image-btn{width:100%;height:100%;border:0}.add-image-btn .plus{opacity:.5;font-size:30px;font-weight:400;margin-bottom:5px;margin-top:5px}img{max-height:100%;max-width:inherit;cursor:pointer;position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}.image-container{max-width:100%;width:100%;height:100%;position:relative;display:inline-block;background-color:#f1f1f1;box-shadow:inset 0 0 5px rgba(0,0,0,.2)}.remove{position:absolute;top:0;right:0;width:40px;height:40px;font-size:25px;text-align:center;opacity:.8;border:0;z-index:21;cursor:pointer}.selected-status-wrapper{max-width:inherit}.selected-status-wrapper .hide{display:none}.selected-status-wrapper .hide .buttons-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;width:100%;height:100%;justify-content:center;align-items:center}.selected-status-wrapper .hide .buttons-wrapper .custom-button{margin:5px;font-size:12px}.selected-status-wrapper .hide .button-icon{margin-bottom:0}.selected-status-wrapper:hover .hide{position:absolute;top:0;left:0;background-color:#00000023;z-index:20;width:100%;height:100%;display:block}.selected-status-wrapper>.remove:hover{opacity:.7;background-color:#fff}input{display:none}.drag-overlay{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#ff0;opacity:.3}.no-image-file-span{position:absolute;bottom:5px;left:5px}[role=button]{-webkit-appearance:button;-moz-appearance:button;appearance:button;cursor:default;font-style:normal;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}"]
                }] }
    ];
    /** @nocollapse */
    FileFormControlComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: FileFormService },
        { type: Lightbox },
        { type: Gallery }
    ]; };
    FileFormControlComponent.propDecorators = {
        name: [{ type: Input }],
        accept: [{ type: Input }],
        maxSize: [{ type: Input }],
        multiple: [{ type: Input }],
        readonly: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }],
        imageElement: [{ type: ViewChild, args: ['imageElement', { static: false },] }],
        fileInputElement: [{ type: ViewChild, args: ['fileInput', { static: false },] }],
        dragOverlayElement: [{ type: ViewChild, args: ['dragOverlay', { static: false },] }]
    };
    return FileFormControlComponent;
}());
if (false) {
    /** @type {?} */
    FileFormControlComponent.prototype.isDraggingOverDropZone;
    /** @type {?} */
    FileFormControlComponent.prototype.isFile;
    /** @type {?} */
    FileFormControlComponent.prototype.name;
    /** @type {?} */
    FileFormControlComponent.prototype.accept;
    /** @type {?} */
    FileFormControlComponent.prototype.maxSize;
    /** @type {?} */
    FileFormControlComponent.prototype.multiple;
    /** @type {?} */
    FileFormControlComponent.prototype.readonly;
    /** @type {?} */
    FileFormControlComponent.prototype.blur;
    /** @type {?} */
    FileFormControlComponent.prototype.change;
    /** @type {?} */
    FileFormControlComponent.prototype.customEvent;
    /** @type {?} */
    FileFormControlComponent.prototype.focus;
    /** @type {?} */
    FileFormControlComponent.prototype.thumbnailWidth;
    /** @type {?} */
    FileFormControlComponent.prototype.thumbnailHeight;
    /** @type {?} */
    FileFormControlComponent.prototype.noImageFile;
    /** @type {?} */
    FileFormControlComponent.prototype.isDisabled;
    /** @type {?} */
    FileFormControlComponent.prototype.allowedImageTypes;
    /** @type {?} */
    FileFormControlComponent.prototype.galleryId;
    /** @type {?} */
    FileFormControlComponent.prototype._imageThumbnail;
    /** @type {?} */
    FileFormControlComponent.prototype.errorMessageTranslationKey;
    /** @type {?} */
    FileFormControlComponent.prototype.errorMessageInfo;
    /** @type {?} */
    FileFormControlComponent.prototype.origImageWidth;
    /** @type {?} */
    FileFormControlComponent.prototype.orgiImageHeight;
    /** @type {?} */
    FileFormControlComponent.prototype._imageFile;
    /** @type {?} */
    FileFormControlComponent.prototype.imageElement;
    /** @type {?} */
    FileFormControlComponent.prototype.fileInputElement;
    /** @type {?} */
    FileFormControlComponent.prototype.dragOverlayElement;
    /**
     * @type {?}
     * @private
     */
    FileFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    FileFormControlComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    FileFormControlComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    FileFormControlComponent.prototype.fileFormService;
    /**
     * @type {?}
     * @private
     */
    FileFormControlComponent.prototype.lightbox;
    /**
     * @type {?}
     * @private
     */
    FileFormControlComponent.prototype.gallery;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_FILE_SHARING = 'FILE_SHARING';
/**
 * @record
 */
function DynamicFileSharingFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicFileSharingFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicFileSharingFormControlModelConfig.prototype.accept;
    /** @type {?|undefined} */
    DynamicFileSharingFormControlModelConfig.prototype.maxSize;
    /** @type {?|undefined} */
    DynamicFileSharingFormControlModelConfig.prototype.multiple;
    /** @type {?|undefined} */
    DynamicFileSharingFormControlModelConfig.prototype.readonly;
}
var DynamicFileSharingFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicFileSharingFormControlModel, _super);
    function DynamicFileSharingFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_FILE_SHARING;
        _this.translateKey = config.translateKey;
        _this.accept = config.accept || [];
        _this.maxSize = config.maxSize != null ? +config.maxSize : null;
        _this.multiple = isBoolean(config.multiple) ? config.multiple : false;
        _this.readonly = isBoolean(config.readonly) ? config.readonly : false;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicFileSharingFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicFileSharingFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicFileSharingFormControlModel.prototype, "accept", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicFileSharingFormControlModel.prototype, "maxSize", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicFileSharingFormControlModel.prototype, "multiple", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicFileSharingFormControlModel.prototype, "readonly", void 0);
    return DynamicFileSharingFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicFileSharingFormControlModel.prototype.type;
    /** @type {?} */
    DynamicFileSharingFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicFileSharingFormControlModel.prototype.accept;
    /** @type {?} */
    DynamicFileSharingFormControlModel.prototype.maxSize;
    /** @type {?} */
    DynamicFileSharingFormControlModel.prototype.multiple;
    /** @type {?} */
    DynamicFileSharingFormControlModel.prototype.readonly;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFileSharingFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicFileSharingFormControlComponent, _super);
    function DynamicFileSharingFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicFileSharingFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-file-sharing-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-file-sharing-form-control\r\n        [formControlName]=\"model.id\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [accept]=\"model.accept\"\r\n        [maxSize]=\"model.maxSize\"\r\n        [multiple]=\"model.multiple\"\r\n        [readonly]=\"model.readonly\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\"></lib-file-sharing-form-control>\r\n\r\n</ng-container>\r\n\r\n\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DynamicFileSharingFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicFileSharingFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicFileSharingFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicFileSharingFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicFileSharingFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicFileSharingFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicFileSharingFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicFileSharingFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicFileSharingFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicFileSharingFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicFileSharingFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicFileSharingFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} e
 * @param {?} translationName
 * @param {?} optional
 * @return {?}
 */
function getOptionsForDynamicSelectModel(e, translationName, optional) {
    /** @type {?} */
    var options = [];
    if (optional) {
        options = [{ value: '', label: 'APPLICATION.FORM.select' }];
    }
    return options.concat(Object.keys(e)
        .map((/**
     * @param {?} name
     * @return {?}
     */
    function (name) {
        return {
            value: (/** @type {?} */ (e[name])),
            label: "APPLICATION.DICTIONARIES." + translationName + "." + (name.charAt(0).toLocaleLowerCase() + name.slice(1))
        };
    })));
}
/**
 * @template T
 * @param {?} e
 * @return {?}
 */
function getOptionsForDynamicMultiSelectControlModel(e) {
    return Object.keys(e)
        .map((/**
     * @param {?} name
     * @return {?}
     */
    function (name) {
        return {
            value: (/** @type {?} */ (e[name])),
            label: "" + (name.charAt(0).toLocaleLowerCase() + name.slice(1))
        };
    }));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileSharing = /** @class */ (function () {
    function FileSharing(file, sharing) {
        this.file = file;
        this.sharing = sharing;
    }
    return FileSharing;
}());
if (false) {
    /** @type {?} */
    FileSharing.prototype.file;
    /** @type {?} */
    FileSharing.prototype.sharing;
}

var _a;
/** @type {?} */
var FS_FILE = 'file';
/** @type {?} */
var FS_SHARING = 'sharing';
/** @type {?} */
var MAX_FILE_SIZE = 1;
// MB
/** @type {?} */
var FS_FILE_LAYOUT = {
    grid: {
        host: 'col-12 m-0'
    },
    element: {
        control: 'mx-2'
    }
};
/** @type {?} */
var FS_SHARING_LAYOUT = {
    grid: {
        host: 'col-12 m-0'
    }
};
/** @type {?} */
var FILE_SHARING_FORM_LAYOUT = (_a = {},
    _a[FS_FILE] = FS_FILE_LAYOUT,
    _a[FS_SHARING] = FS_SHARING_LAYOUT,
    _a);
/** @type {?} */
var FILE_SHARING_FORM_MODEL = [
    new DynamicFileUploadModel({
        id: FS_FILE,
        maxSize: MAX_FILE_SIZE
    }),
    new DynamicMultiSelectControlModel({
        id: FS_SHARING,
        multiple: true,
        items: getOptionsForDynamicMultiSelectControlModel(ApplicationType),
        translationPrefix: 'APPLICATION.DICTIONARIES.APPLICATION_TYPE'
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileSharingFormService = /** @class */ (function () {
    function FileSharingFormService(formService, translateFormModelService, translateService) {
        this.formService = formService;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    FileSharingFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    FileSharingFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    FileSharingFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    FileSharingFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    FileSharingFormService.prototype.getFileValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FS_FILE).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    FileSharingFormService.prototype.getSharingValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FS_SHARING).valueChanges;
    };
    FileSharingFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FileSharingFormService.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TranslateFormModelService },
        { type: TranslateService }
    ]; };
    return FileSharingFormService;
}());
if (false) {
    /** @type {?} */
    FileSharingFormService.prototype.formModelSubject;
    /** @type {?} */
    FileSharingFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormService.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormService.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileSharingFormComponent = /** @class */ (function () {
    function FileSharingFormComponent(fileSharingFormService) {
        this.fileSharingFormService = fileSharingFormService;
        this.fileSharingChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = cloneDeep(FILE_SHARING_FORM_LAYOUT);
        /** @type {?} */
        var formModel = cloneDeep(FILE_SHARING_FORM_MODEL);
        this.fileSharingFormService.formModelSubject.next(formModel);
        this.formGroup = this.fileSharingFormService.createFormGroup(formModel);
    }
    Object.defineProperty(FileSharingFormComponent.prototype, "fileSharing", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.fileSharingData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.fileSharingData = value;
            }
            else {
                this.fileSharingData = new FileSharing(null, []);
                this.updateFormValue(this.fileSharingData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileSharingFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    FileSharingFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.fileSharingFormService.getFormModel$(this.translateKey);
        this.subscribeToFileModelValueChanges(this.formGroup);
        this.subscribeToSharingModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FileSharingFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.accept && changes.accept.currentValue !== changes.accept.previousValue) {
            this.getFileModel().accept = this.accept;
        }
        if (changes && changes.maxSize && changes.maxSize.currentValue !== changes.maxSize.previousValue) {
            this.getFileModel().maxSize = this.maxSize;
        }
        if (changes && changes.multiple && changes.multiple.currentValue !== changes.multiple.previousValue) {
            this.getFileModel().multiple = this.multiple;
        }
        if (changes && changes.readonly && changes.readonly.currentValue !== changes.readonly.previousValue) {
            this.getFileModel().disabled = this.readonly || this.isDisabled;
            this.getSharingModel().readonly = this.readonly || this.isDisabled || this.getFileControl().value == null;
        }
        if (changes && changes.isDisabled && changes.isDisabled.currentValue !== changes.isDisabled.previousValue) {
            this.getFileModel().disabled = this.readonly || this.isDisabled;
            this.getSharingModel().readonly = this.readonly || this.isDisabled || this.getFileControl().value == null;
        }
        this.refreshFormModel();
    };
    /**
     * @return {?}
     */
    FileSharingFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.fileChangesSubscription != null) {
            this.fileChangesSubscription.unsubscribe();
        }
        if (this.sharingChangesSubscription != null) {
            this.sharingChangesSubscription.unsubscribe();
        }
    };
    /**
     * @private
     * @param {?} fileSharing
     * @return {?}
     */
    FileSharingFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} fileSharing
     * @return {?}
     */
    function (fileSharing) {
        /** @type {?} */
        var allSharing = getOptionsForDynamicMultiSelectControlModel(ApplicationType);
        /** @type {?} */
        var sharing = allSharing.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return (fileSharing.sharing || []).some((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s === x.value.toString(); })); }));
        this.formGroup.get(FS_FILE).patchValue(fileSharing.file);
        this.formGroup.get(FS_SHARING).patchValue(sharing);
    };
    /**
     * @private
     * @return {?}
     */
    FileSharingFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var file = this.formGroup.get(FS_FILE).value;
        /** @type {?} */
        var sharing = this.formGroup.get(FS_SHARING).value;
        return file == null
            ? null
            : new FileSharing(file, (sharing || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.value; })));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FileSharingFormComponent.prototype.subscribeToFileModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.fileChangesSubscription = this.fileSharingFormService
            .getFileValue$(formGroup)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.getSharingModel().readonly = _this.readonly || _this.isDisabled || _this.getFileControl().value == null;
            _this.refreshFormModel();
            if (_this.getFileControl().value == null) {
                _this.getSharingControl().patchValue([]);
            }
            else {
                _this.onFileSharingChanged();
            }
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FileSharingFormComponent.prototype.subscribeToSharingModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.sharingChangesSubscription = this.fileSharingFormService
            .getSharingValue$(formGroup)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.onFileSharingChanged();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    FileSharingFormComponent.prototype.onFileSharingChanged = /**
     * @private
     * @return {?}
     */
    function () {
        this.fileSharingData = this.getFormValue();
        this.fileSharingChange.emit(this.fileSharingData);
    };
    /**
     * @private
     * @return {?}
     */
    FileSharingFormComponent.prototype.refreshFormModel = /**
     * @private
     * @return {?}
     */
    function () {
        this.fileSharingFormService.formModelSubject.next(this.formModel);
    };
    // Models & Controls
    // Models & Controls
    /**
     * @private
     * @return {?}
     */
    FileSharingFormComponent.prototype.getFileControl = 
    // Models & Controls
    /**
     * @private
     * @return {?}
     */
    function () {
        return this.formGroup.get(FS_FILE);
    };
    /**
     * @private
     * @return {?}
     */
    FileSharingFormComponent.prototype.getFileModel = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var controlModel = this.formModel.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === FS_FILE; }));
        return (/** @type {?} */ (controlModel));
    };
    /**
     * @private
     * @return {?}
     */
    FileSharingFormComponent.prototype.getSharingControl = /**
     * @private
     * @return {?}
     */
    function () {
        return this.formGroup.get(FS_SHARING);
    };
    /**
     * @private
     * @return {?}
     */
    FileSharingFormComponent.prototype.getSharingModel = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var controlModel = this.formModel.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === FS_SHARING; }));
        return (/** @type {?} */ (controlModel));
    };
    Object.defineProperty(FileSharingFormComponent.prototype, "formModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.fileSharingFormService.formModelSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    FileSharingFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-file-sharing-form',
                    template: "<div class=\"container-fluid px-0 mt-2 file-sharing-form-container\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        FileSharingFormService
                    ],
                    styles: [".file-sharing-form-container{max-width:170px}"]
                }] }
    ];
    /** @nocollapse */
    FileSharingFormComponent.ctorParameters = function () { return [
        { type: FileSharingFormService }
    ]; };
    FileSharingFormComponent.propDecorators = {
        fileSharing: [{ type: Input }],
        translateKey: [{ type: Input }],
        accept: [{ type: Input }],
        maxSize: [{ type: Input }],
        multiple: [{ type: Input }],
        readonly: [{ type: Input }],
        isDisabled: [{ type: Input }],
        touched: [{ type: Input }],
        fileSharingChange: [{ type: Output }]
    };
    return FileSharingFormComponent;
}());
if (false) {
    /** @type {?} */
    FileSharingFormComponent.prototype.translateKey;
    /** @type {?} */
    FileSharingFormComponent.prototype.accept;
    /** @type {?} */
    FileSharingFormComponent.prototype.maxSize;
    /** @type {?} */
    FileSharingFormComponent.prototype.multiple;
    /** @type {?} */
    FileSharingFormComponent.prototype.readonly;
    /** @type {?} */
    FileSharingFormComponent.prototype.isDisabled;
    /** @type {?} */
    FileSharingFormComponent.prototype.fileSharingChange;
    /** @type {?} */
    FileSharingFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    FileSharingFormComponent.prototype.formLayout;
    /** @type {?} */
    FileSharingFormComponent.prototype.formModel$;
    /** @type {?} */
    FileSharingFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormComponent.prototype.fileSharingData;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormComponent.prototype.fileChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormComponent.prototype.sharingChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormComponent.prototype.fileSharingFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileSharingFormControlComponent = /** @class */ (function () {
    function FileSharingFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(FileSharingFormControlComponent.prototype, "fileSharing", {
        get: /**
         * @return {?}
         */
        function () {
            return this.fileSharingData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.fileSharingData = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    FileSharingFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.fileSharingData = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FileSharingFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FileSharingFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    FileSharingFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    FileSharingFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-file-sharing-form-control',
                    template: "<lib-file-sharing-form\r\n    [(fileSharing)]=\"fileSharing\"\r\n    [translateKey]=\"translateKey\"\r\n    [accept]=\"accept\"\r\n    [maxSize]=\"maxSize\"\r\n    [multiple]=\"multiple\"\r\n    [readonly]=\"readonly\"\r\n    [touched]=\"touched\">\r\n</lib-file-sharing-form>\r\n",
                    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return FileSharingFormControlComponent; })), multi: true }],
                    styles: [""]
                }] }
    ];
    FileSharingFormControlComponent.propDecorators = {
        fileSharing: [{ type: Input }],
        translateKey: [{ type: Input }],
        accept: [{ type: Input }],
        maxSize: [{ type: Input }],
        multiple: [{ type: Input }],
        readonly: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return FileSharingFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FileSharingFormControlComponent.prototype.fileSharingData;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.translateKey;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.accept;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.maxSize;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.multiple;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.readonly;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.touched;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.blur;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.change;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.customEvent;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.focus;
    /** @type {?} */
    FileSharingFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    FileSharingFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_DICTIONARY = 'DICTIONARY';
/**
 * @record
 * @template T
 */
function DynamicDictionaryControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicDictionaryControlModelConfig.prototype.multiple;
    /** @type {?|undefined} */
    DynamicDictionaryControlModelConfig.prototype.placeholder;
    /** @type {?} */
    DynamicDictionaryControlModelConfig.prototype.dictionaryKey;
    /** @type {?|undefined} */
    DynamicDictionaryControlModelConfig.prototype.translationPrefix;
}
/**
 * @template T
 */
var DynamicDictionaryControlModel = /** @class */ (function (_super) {
    __extends(DynamicDictionaryControlModel, _super);
    function DynamicDictionaryControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_DICTIONARY;
        _this.multiple = isBoolean(config.multiple) ? config.multiple : false;
        _this.placeholder = config.placeholder || '';
        _this.dictionaryKey = config.dictionaryKey;
        _this.translationPrefix = config.translationPrefix || null;
        return _this;
    }
    /**
     * @param {?} options
     * @param {...?} indices
     * @return {?}
     */
    DynamicDictionaryControlModel.prototype.select = /**
     * @param {?} options
     * @param {...?} indices
     * @return {?}
     */
    function (options) {
        var indices = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            indices[_i - 1] = arguments[_i];
        }
        /** @type {?} */
        var value = this.multiple ? indices.map((/**
         * @param {?} index
         * @return {?}
         */
        function (index) { return options[index].value; })) : (options[indices[0]]).value;
        this.valueUpdates.next(value);
    };
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicDictionaryControlModel.prototype, "multiple", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicDictionaryControlModel.prototype, "placeholder", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicDictionaryControlModel.prototype, "dictionaryKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicDictionaryControlModel.prototype, "translationPrefix", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicDictionaryControlModel.prototype, "type", void 0);
    return DynamicDictionaryControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicDictionaryControlModel.prototype.multiple;
    /** @type {?} */
    DynamicDictionaryControlModel.prototype.placeholder;
    /** @type {?} */
    DynamicDictionaryControlModel.prototype.dictionaryKey;
    /** @type {?} */
    DynamicDictionaryControlModel.prototype.translationPrefix;
    /** @type {?} */
    DynamicDictionaryControlModel.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_DICTIONARY_SERVICE = new InjectionToken('DynamicDictionaryService for dynamic form');
/**
 * @record
 */
function DynamicDictionaryService() { }
if (false) {
    /**
     * @template T
     * @param {?} id
     * @return {?}
     */
    DynamicDictionaryService.prototype.getOptionsForDynamicSelectModel = function (id) { };
    /**
     * @param {...?} ids
     * @return {?}
     */
    DynamicDictionaryService.prototype.loadCache = function (ids) { };
    /**
     * @template T
     * @param {?} id
     * @return {?}
     */
    DynamicDictionaryService.prototype.getCachedOptionsForSingleDictionary = function (id) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicDictionaryFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicDictionaryFormControlComponent, _super);
    function DynamicDictionaryFormControlComponent(layoutService, validationService, dynamicDictionaryService, translateService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        _this.dynamicDictionaryService = dynamicDictionaryService;
        _this.translateService = translateService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.customSearchFn = (/**
         * @param {?} term
         * @param {?} item
         * @return {?}
         */
        function (term, item) {
            if (item == null || item.value === '') {
                return false;
            }
            /** @type {?} */
            var termLowerCase = term.toLowerCase();
            return _this.translateService.instant(item.label).toLowerCase().indexOf(termLowerCase) > -1;
        });
        return _this;
    }
    /**
     * @return {?}
     */
    DynamicDictionaryFormControlComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.options$ = this.dynamicDictionaryService
            .getOptionsForDynamicSelectModel(this.model.dictionaryKey)
            .pipe(map((/**
         * @param {?} optionsConfig
         * @return {?}
         */
        function (optionsConfig) { return optionsConfig.map((/**
         * @param {?} optionConfig
         * @return {?}
         */
        function (optionConfig) {
            if (_this.model.translationPrefix != null && optionConfig.value !== '') {
                optionConfig.label = _this.model.translationPrefix + "." + optionConfig.label;
            }
            // tslint:disable-next-line: no-any
            return new DynamicFormOption(optionConfig);
        })); })));
    };
    DynamicDictionaryFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-dictionary-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <ng-select\r\n        [id]=\"elementId\"\r\n        [class.is-invalid]=\"showErrorMessages\"\r\n        formControlName=\"{{model.id}}\"\r\n        [required]=\"model.required\"\r\n        [tabIndex]=\"model.tabIndex\"\r\n        (change)=\"onChange($event)\"\r\n        (blur)=\"onBlur($event)\"\r\n        (focus)=\"onFocus($event)\"\r\n        [items]=\"options$ | async\"\r\n        [multiple]=\"model.multiple\"\r\n        [clearable]=\"false\"\r\n        [placeholder]=\"model.placeholder\"\r\n        [readonly]=\"false\"\r\n        [bindValue]=\"'value'\"\r\n        [notFoundText]=\"'APPLICATION.FORM.multiSelect:notFoundText' | translate\"\r\n        [searchFn]=\"customSearchFn\">\r\n\r\n        <ng-template ng-label-tmp let-item=\"item\">\r\n            {{ item.label | translate }}\r\n        </ng-template>\r\n\r\n        <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"searchTerm\">\r\n            {{ item.label | translate }}\r\n        </ng-template>\r\n\r\n    </ng-select>\r\n\r\n</ng-container>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DynamicDictionaryFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService },
        { type: undefined, decorators: [{ type: Inject, args: [DYNAMIC_FORM_DICTIONARY_SERVICE,] }] },
        { type: TranslateService }
    ]; };
    DynamicDictionaryFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicDictionaryFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.options$;
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.focus;
    /** @type {?} */
    DynamicDictionaryFormControlComponent.prototype.customSearchFn;
    /**
     * @type {?}
     * @protected
     */
    DynamicDictionaryFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicDictionaryFormControlComponent.prototype.validationService;
    /**
     * @type {?}
     * @protected
     */
    DynamicDictionaryFormControlComponent.prototype.dynamicDictionaryService;
    /**
     * @type {?}
     * @private
     */
    DynamicDictionaryFormControlComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterFormControlComponent = /** @class */ (function () {
    function CadastralRegisterFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(CadastralRegisterFormControlComponent.prototype, "cadastralRegister", {
        get: /**
         * @return {?}
         */
        function () {
            return this.cadastralRegisterData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.cadastralRegisterData = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    CadastralRegisterFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.cadastralRegisterData = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CadastralRegisterFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CadastralRegisterFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CadastralRegisterFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    CadastralRegisterFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cadastral-register-form-control',
                    template: "<app-cadastral-register-form\r\n    [(cadastralRegister)]=\"cadastralRegister\"\r\n    [translateKey]=\"translateKey\"\r\n    [cadastreAsSelectInput]=\"cadastreAsSelectInput\"\r\n    [touched]=\"touched\"\r\n    [isDisabled]=\"isDisabled\">\r\n</app-cadastral-register-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return CadastralRegisterFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    CadastralRegisterFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        cadastreAsSelectInput: [{ type: Input }],
        cadastralRegister: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return CadastralRegisterFormControlComponent;
}());
if (false) {
    /** @type {?} */
    CadastralRegisterFormControlComponent.prototype.translateKey;
    /** @type {?} */
    CadastralRegisterFormControlComponent.prototype.cadastreAsSelectInput;
    /** @type {?} */
    CadastralRegisterFormControlComponent.prototype.touched;
    /** @type {?} */
    CadastralRegisterFormControlComponent.prototype.blur;
    /** @type {?} */
    CadastralRegisterFormControlComponent.prototype.change;
    /** @type {?} */
    CadastralRegisterFormControlComponent.prototype.focus;
    /** @type {?} */
    CadastralRegisterFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormControlComponent.prototype.cadastralRegisterData;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER = 'CADASTRAL_REGISTER';
/**
 * @record
 */
function DynamicCadastralRegisterFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterFormControlModelConfig.prototype.translateKey;
    /** @type {?} */
    DynamicCadastralRegisterFormControlModelConfig.prototype.cadastreAsSelectInput;
}
var DynamicCadastralRegisterFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicCadastralRegisterFormControlModel, _super);
    function DynamicCadastralRegisterFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER;
        _this.translateKey = config.translateKey;
        _this.cadastreAsSelectInput = config.cadastreAsSelectInput;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicCadastralRegisterFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicCadastralRegisterFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicCadastralRegisterFormControlModel.prototype, "cadastreAsSelectInput", void 0);
    return DynamicCadastralRegisterFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterFormControlModel.prototype.type;
    /** @type {?} */
    DynamicCadastralRegisterFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicCadastralRegisterFormControlModel.prototype.cadastreAsSelectInput;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicCadastralRegisterFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicCadastralRegisterFormControlComponent, _super);
    function DynamicCadastralRegisterFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicCadastralRegisterFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-cadastral-register-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-cadastral-register-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [cadastreAsSelectInput]=\"model.cadastreAsSelectInput\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-cadastral-register-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicCadastralRegisterFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicCadastralRegisterFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicCadastralRegisterFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicCadastralRegisterFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicCadastralRegisterFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicCadastralRegisterFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicCadastralRegisterFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicCadastralRegisterFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicCadastralRegisterFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicCadastralRegisterFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicCadastralRegisterFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterMapValue = /** @class */ (function () {
    function CadastralRegisterMapValue(cadastralRegister, features) {
        this.cadastralRegister = cadastralRegister;
        this.features = features;
    }
    return CadastralRegisterMapValue;
}());
if (false) {
    /** @type {?} */
    CadastralRegisterMapValue.prototype.cadastralRegister;
    /** @type {?} */
    CadastralRegisterMapValue.prototype.features;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterMapFormControlComponent = /** @class */ (function () {
    function CadastralRegisterMapFormControlComponent() {
        this.featureCollection = new Array();
        this.mapCfg = new MapConfig();
        this.markerCfg = new MarkerConfig(false, false);
        this.polygonCfg = new PolygonConfig();
        this.drawing = true;
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(CadastralRegisterMapFormControlComponent.prototype, "features", {
        get: /**
         * @return {?}
         */
        function () {
            return this.featureCollection;
        },
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            this.featureCollection = features;
            this.onChange(new CadastralRegisterMapValue(this.cadastralRegisterData, this.featureCollection));
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterMapFormControlComponent.prototype, "mapConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.mapCfg;
        },
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            this.mapCfg = config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterMapFormControlComponent.prototype, "polygonConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygonCfg;
        },
        set: /**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            this.polygonCfg = config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterMapFormControlComponent.prototype, "markerConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.markerCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterMapFormControlComponent.prototype, "cadastralRegister", {
        get: /**
         * @return {?}
         */
        function () {
            return this.cadastralRegisterData;
        },
        set: /**
         * @param {?} cadastralRegister
         * @return {?}
         */
        function (cadastralRegister) {
            this.cadastralRegisterData = cadastralRegister;
            this.features = new Array({
                type: 'Feature',
                id: v4(),
                geometry: {
                    type: 'Polygon',
                    coordinates: cadastralRegister.cadastreCoordinates[0]
                },
                properties: {}
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterMapFormControlComponent.prototype, "drawingEnabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.drawing;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    CadastralRegisterMapFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.featureCollection = obj != null && obj.features != null ? obj.features : [];
        this.cadastralRegisterData = obj != null ? obj.cadastralRegister : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CadastralRegisterMapFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CadastralRegisterMapFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CadastralRegisterMapFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    /**
     * @return {?}
     */
    CadastralRegisterMapFormControlComponent.prototype.enableDrawing = /**
     * @return {?}
     */
    function () {
        this.drawing = true;
        this.polygonCfg = new PolygonConfig(groundDrawingColor, true, true);
        this.cadastralRegisterData = null;
        this.featureCollection = new Array();
    };
    /**
     * @return {?}
     */
    CadastralRegisterMapFormControlComponent.prototype.enableChoosing = /**
     * @return {?}
     */
    function () {
        this.drawing = false;
        this.polygonCfg = new PolygonConfig(groundDrawingColor, false, false);
        this.featureCollection = new Array();
        this.cadastralRegisterData = null;
    };
    CadastralRegisterMapFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cadastral-register-map-form-control',
                    template: "<div class=\"row ground-contour-edit-buttons\">\r\n    <div class=\"col-12\">\r\n        <div class=\"d-flex\">\r\n            <a class=\"btn btn-raised mr-1 btn-secondary\" (click)=\"enableDrawing()\">\r\n                <i class=\"ft-edit-2 mr-1\"></i>{{ 'CADASTRALREGISTERMAP.draw:button' | translate }}\r\n            </a>\r\n            <a class=\"btn btn-raised mr-1 btn-secondary\" (click)=\"enableChoosing()\">\r\n                <i class=\"ft-list mr-1\"></i>{{ 'CADASTRALREGISTERMAP.choose:button' | translate }}\r\n            </a>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\" [ngClass]=\"{ 'flex-column-reverse flex-md-row': !drawingEnabled }\">\r\n    <div [ngClass]=\"{ 'col-12 col-md-6 mb-4 mb-md-0': !drawingEnabled, 'col-12': drawingEnabled }\">\r\n        <div style=\"height: 420px;\">\r\n            <app-map [mapConfig]=\"mapConfig\" [markerConfig]=\"markerConfig\" [polygonConfig]=\"polygonConfig\" [(features)]=\"features\">\r\n            </app-map>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12 col-md-6\" *ngIf=\"!drawingEnabled\">\r\n        <app-cadastral-register-form [(cadastralRegister)]=\"cadastralRegister\" [translateKey]=\"'GROUND'\" [cadastreAsSelectInput]=\"true\">\r\n        </app-cadastral-register-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    providers: [
                        PolygonService,
                        PolygonStoreService,
                        FeaturesStoreService,
                        DecimalPipe,
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return CadastralRegisterMapFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    /** @nocollapse */
    CadastralRegisterMapFormControlComponent.ctorParameters = function () { return []; };
    CadastralRegisterMapFormControlComponent.propDecorators = {
        features: [{ type: Input }],
        mapConfig: [{ type: Input }],
        polygonConfig: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return CadastralRegisterMapFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.cadastralRegisterData;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.featureCollection;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.mapCfg;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.markerCfg;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.polygonCfg;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.drawing;
    /** @type {?} */
    CadastralRegisterMapFormControlComponent.prototype.blur;
    /** @type {?} */
    CadastralRegisterMapFormControlComponent.prototype.change;
    /** @type {?} */
    CadastralRegisterMapFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterMapFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_MAP = 'CADASTRAL_REGISTER_MAP';
/**
 * @record
 */
function DynamicCadastralRegisterMapFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlModelConfig.prototype.mapConfig;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlModelConfig.prototype.polygonConfig;
}
var DynamicCadastralRegisterMapFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicCadastralRegisterMapFormControlModel, _super);
    function DynamicCadastralRegisterMapFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_MAP;
        _this.mapConfig = config.mapConfig;
        _this.polygonConfig = config.polygonConfig;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicCadastralRegisterMapFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", MapConfig)
    ], DynamicCadastralRegisterMapFormControlModel.prototype, "mapConfig", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", PolygonConfig)
    ], DynamicCadastralRegisterMapFormControlModel.prototype, "polygonConfig", void 0);
    return DynamicCadastralRegisterMapFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlModel.prototype.type;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlModel.prototype.mapConfig;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlModel.prototype.polygonConfig;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicCadastralRegisterMapFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicCadastralRegisterMapFormControlComponent, _super);
    function DynamicCadastralRegisterMapFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicCadastralRegisterMapFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-cadastral-register-map-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-cadastral-register-map-form-control formControlName=\"{{model.id}}\" [mapConfig]=\"model.mapConfig\"\r\n        [polygonConfig]=\"model.polygonConfig\" [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        (blur)=\"onBlur($event)\" (change)=\"onChange($event)\" (focus)=\"onFocus($event)\">\r\n    </app-cadastral-register-map-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicCadastralRegisterMapFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicCadastralRegisterMapFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicCadastralRegisterMapFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicCadastralRegisterMapFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicCadastralRegisterMapFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicCadastralRegisterMapFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function cadastralRegisterValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return { productDelivery: {} };
        }
        /** @type {?} */
        var cadastralRegister = (/** @type {?} */ (control.value));
        /** @type {?} */
        var isEmptyCadastralRegisterGeoData = (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data == null || isEmpty(data.name);
        });
        if (isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralState)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralCounty)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralCommune)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralArea)
            || isEmpty(cadastralRegister.cadastreNumber)) {
            return { productDelivery: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_BUTTON = 'BUTTON';
/**
 * @record
 */
function DynamicButtonControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicButtonControlModelConfig.prototype.compareWithFn;
    /** @type {?} */
    DynamicButtonControlModelConfig.prototype.buttonIcon;
    /** @type {?} */
    DynamicButtonControlModelConfig.prototype.buttonLabel;
    /** @type {?|undefined} */
    DynamicButtonControlModelConfig.prototype.buttonHide;
}
var DynamicButtonControlModel = /** @class */ (function (_super) {
    __extends(DynamicButtonControlModel, _super);
    function DynamicButtonControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_BUTTON;
        _this.compareWithFn = isFunction(config.compareWithFn) ? config.compareWithFn : ɵlooseIdentical;
        _this.buttonIcon = config.buttonIcon || '';
        _this.buttonLabel = config.buttonLabel || '';
        _this.buttonHide = isBoolean(config.buttonHide) ? config.buttonHide : false;
        return _this;
    }
    DynamicButtonControlModel.CLICK = 'click';
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicButtonControlModel.prototype, "buttonIcon", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicButtonControlModel.prototype, "buttonLabel", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicButtonControlModel.prototype, "buttonHide", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicButtonControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicButtonControlModel.prototype, "placeholder", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicButtonControlModel.prototype, "searchByField", void 0);
    return DynamicButtonControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicButtonControlModel.CLICK;
    /** @type {?} */
    DynamicButtonControlModel.prototype.compareWithFn;
    /** @type {?} */
    DynamicButtonControlModel.prototype.buttonIcon;
    /** @type {?} */
    DynamicButtonControlModel.prototype.buttonLabel;
    /** @type {?} */
    DynamicButtonControlModel.prototype.buttonHide;
    /** @type {?} */
    DynamicButtonControlModel.prototype.type;
    /** @type {?} */
    DynamicButtonControlModel.prototype.placeholder;
    /** @type {?} */
    DynamicButtonControlModel.prototype.searchByField;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonFormControlComponent = /** @class */ (function () {
    function ButtonFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChangeCallback = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    /**
     * @param {?} value
     * @return {?}
     */
    ButtonFormControlComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value === DynamicButtonControlModel.CLICK) {
            this.onChangeCallback(null);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ButtonFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChangeCallback = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ButtonFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    ButtonFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    /**
     * @return {?}
     */
    ButtonFormControlComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.onChangeCallback(DynamicButtonControlModel.CLICK);
    };
    ButtonFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-button-form-control',
                    template: "<button class=\"btn btn-raised btn-primary m-0 w-100\" [ngClass]=\"{'d-none' : hide}\" type=\"button\" (click)=\"onClick()\">\r\n    <i class=\"{{icon}}\"></i> {{ label | translate }}\r\n</button>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return ButtonFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    ButtonFormControlComponent.propDecorators = {
        icon: [{ type: Input }],
        label: [{ type: Input }],
        hide: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return ButtonFormControlComponent;
}());
if (false) {
    /** @type {?} */
    ButtonFormControlComponent.prototype.icon;
    /** @type {?} */
    ButtonFormControlComponent.prototype.label;
    /** @type {?} */
    ButtonFormControlComponent.prototype.hide;
    /** @type {?} */
    ButtonFormControlComponent.prototype.touched;
    /** @type {?} */
    ButtonFormControlComponent.prototype.blur;
    /** @type {?} */
    ButtonFormControlComponent.prototype.change;
    /** @type {?} */
    ButtonFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    ButtonFormControlComponent.prototype.onChangeCallback;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicButtonFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicButtonFormControlComponent, _super);
    function DynamicButtonFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicButtonFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-button-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-button-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [icon]=\"model.buttonIcon\"\r\n        [label]=\"model.buttonLabel\"\r\n        [hide]=\"model.buttonHide\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-button-form-control>\r\n\r\n</ng-container>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DynamicButtonFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicButtonFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicButtonFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicButtonFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicButtonFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicButtonFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicButtonFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicButtonFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicButtonFormControlComponent.prototype.focus;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} decimalNumber
 * @return {?}
 */
function decimalNumberValidator(decimalNumber) {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (!control.value) {
            return null;
        }
        /** @type {?} */
        var isDecimal = isDecimalNumber(decimalNumber, control.value);
        // tslint:disable-next-line: object-literal-key-quotes
        return isDecimal ? null : { 'decimalNumber': { 'decimalNumber': decimalNumber } };
    });
}
// tslint:disable-next-line: cognitive-complexity
/**
 * @param {?} params
 * @return {?}
 */
function numericConditionValidator(params) {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (params == null || control.value == null) {
            return null;
        }
        if (isEmptyInputValue(control.value.value) || isEmptyInputValue(control.value.comparison)) {
            return { required: true };
        }
        /** @type {?} */
        var value = parseFloat(control.value.value);
        if (!isEmptyInputValue(params.min) && !isNaN(value) && value < params.min) {
            // tslint:disable-next-line: object-literal-key-quotes
            return { 'min': { 'min': params.min, 'actual': control.value.value } };
        }
        if (!isEmptyInputValue(params.max) && !isNaN(value) && value > params.max) {
            // tslint:disable-next-line: object-literal-key-quotes
            return { 'max': { 'max': params.max, 'actual': control.value.value } };
        }
        if (!isEmptyInputValue(params.decimalNumber) && !isNaN(value)) {
            /** @type {?} */
            var isDecimal = isDecimalNumber(params.decimalNumber, control.value.value);
            // tslint:disable-next-line: object-literal-key-quotes
            return isDecimal ? null : { 'decimalNumber': { 'decimalNumber': params.decimalNumber } };
        }
        return null;
    });
}
/**
 * @param {?} decimalNumber
 * @param {?} controlValue
 * @return {?}
 */
function isDecimalNumber(decimalNumber, controlValue) {
    /** @type {?} */
    var regexExpr = "^\\d*\\.?\\d{1," + decimalNumber + "}$";
    /** @type {?} */
    var regex = new RegExp(regexExpr);
    /** @type {?} */
    var value = String(controlValue);
    return regex.test(value);
}
// tslint:disable-next-line: no-any
/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_DUAL_LIST = 'DUAL_LIST';
/**
 * @record
 * @template T
 */
function DynamicDualListFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicDualListFormControlModelConfig.prototype.items;
    /** @type {?|undefined} */
    DynamicDualListFormControlModelConfig.prototype.bindLabel;
    /** @type {?|undefined} */
    DynamicDualListFormControlModelConfig.prototype.readonly;
    /** @type {?|undefined} */
    DynamicDualListFormControlModelConfig.prototype.translationPrefix;
}
/**
 * @template T
 */
var DynamicDualListFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicDualListFormControlModel, _super);
    function DynamicDualListFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_DUAL_LIST;
        _this.items = config.items || [];
        _this.bindLabel = config.bindLabel || 'label';
        _this.readonly = isBoolean(config.readonly) ? config.readonly : false;
        _this.translationPrefix = config.translationPrefix || null;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicDualListFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicDualListFormControlModel.prototype, "items", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicDualListFormControlModel.prototype, "bindLabel", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicDualListFormControlModel.prototype, "readonly", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicDualListFormControlModel.prototype, "translationPrefix", void 0);
    return DynamicDualListFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicDualListFormControlModel.prototype.type;
    /** @type {?} */
    DynamicDualListFormControlModel.prototype.items;
    /** @type {?} */
    DynamicDualListFormControlModel.prototype.bindLabel;
    /** @type {?} */
    DynamicDualListFormControlModel.prototype.readonly;
    /** @type {?} */
    DynamicDualListFormControlModel.prototype.translationPrefix;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicDualListFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicDualListFormControlComponent, _super);
    function DynamicDualListFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicDualListFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-dual-list-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-dual-list-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [items]=\"model.items\"\r\n        [bindLabel]=\"model.bindLabel\"\r\n        [readonly]=\"model.readonly\"\r\n        [translationPrefix]=\"model.translationPrefix\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </lib-dual-list-form-control>\r\n\r\n</ng-container>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    DynamicDualListFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicDualListFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicDualListFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicDualListFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicDualListFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicDualListFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicDualListFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicDualListFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicDualListFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicDualListFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicDualListFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicDualListFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DualListFormControlComponent = /** @class */ (function () {
    function DualListFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(DualListFormControlComponent.prototype, "selectedItems", {
        get: /**
         * @return {?}
         */
        function () {
            return this.selectedItemsData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.selectedItemsData = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    DualListFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.selectedItemsData = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DualListFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DualListFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DualListFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.disabledState = isDisabled;
    };
    DualListFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dual-list-form-control',
                    template: "<lib-dual-list\r\n    [(selectedItems)]=\"selectedItems\"\r\n    [items]=\"items\"\r\n    [bindLabel]=\"bindLabel\"\r\n    [readonly]=\"readonly\"\r\n    [isDisabled]=\"disabledState\"\r\n    [translationPrefix]=\"translationPrefix\">\r\n</lib-dual-list>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return DualListFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    DualListFormControlComponent.propDecorators = {
        items: [{ type: Input }],
        bindLabel: [{ type: Input }],
        readonly: [{ type: Input }],
        translationPrefix: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DualListFormControlComponent;
}());
if (false) {
    /** @type {?} */
    DualListFormControlComponent.prototype.items;
    /** @type {?} */
    DualListFormControlComponent.prototype.bindLabel;
    /** @type {?} */
    DualListFormControlComponent.prototype.readonly;
    /** @type {?} */
    DualListFormControlComponent.prototype.translationPrefix;
    /** @type {?} */
    DualListFormControlComponent.prototype.touched;
    /** @type {?} */
    DualListFormControlComponent.prototype.blur;
    /** @type {?} */
    DualListFormControlComponent.prototype.change;
    /** @type {?} */
    DualListFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    DualListFormControlComponent.prototype.selectedItemsData;
    /** @type {?} */
    DualListFormControlComponent.prototype.disabledState;
    /**
     * @type {?}
     * @private
     */
    DualListFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    DualListFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var /**
 * @template T
 */
DualListSelectedItem = /** @class */ (function () {
    function DualListSelectedItem(label, isSelected, value) {
        this.label = label;
        this.isSelected = isSelected;
        this.value = value;
    }
    return DualListSelectedItem;
}());
if (false) {
    /** @type {?} */
    DualListSelectedItem.prototype.label;
    /** @type {?} */
    DualListSelectedItem.prototype.isSelected;
    /** @type {?} */
    DualListSelectedItem.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DualListComponent = /** @class */ (function () {
    function DualListComponent(changeDetectorRef, translateService) {
        var _this = this;
        this.changeDetectorRef = changeDetectorRef;
        this.translateService = translateService;
        this.selectedItemsChange = new EventEmitter();
        this.availableListItems = [];
        this.selectedListItems = [];
        this.unsubscribe$ = new Subject();
        this.calculateAvailableListItems = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var allListItems = (_this.items || []).map(_this.createDualListSelectedItem);
            _this.availableListItems = differenceBy(allListItems, _this.selectedListItems, (/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.label; }))
                .sort(_this.sortDualListSelectedItem);
            _this.availableListItems.forEach(_this.clearSelectionDualListSelectedItem);
        });
        this.updateTranslation = (/**
         * @return {?}
         */
        function () {
            _this.availableListItems.forEach(_this.updateLabelDualListSelectedItem);
            _this.selectedItems.forEach(_this.updateLabelDualListSelectedItem);
        });
        this.createDualListSelectedItem = (/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            return new DualListSelectedItem(item[_this.bindLabel], false, item);
        });
        this.updateLabelDualListSelectedItem = (/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            if (_this.translationPrefix != null) {
                item.label = _this.translateService.instant(_this.translationPrefix + item.value[_this.bindLabel]);
            }
            else {
                item.label = item.value[_this.bindLabel];
            }
        });
        this.sortDualListSelectedItem = (/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            if (a.label != null) {
                return a.label.localeCompare(b.label);
            }
            return 1;
        });
        this.clearSelectionDualListSelectedItem = (/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            item.isSelected = false;
        });
    }
    Object.defineProperty(DualListComponent.prototype, "selectedItems", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.selectedListItems = (value || [])
                .map(this.createDualListSelectedItem)
                .sort(this.sortDualListSelectedItem);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DualListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.updateTranslation();
            _this.changeDetectorRef.markForCheck();
        }));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    DualListComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.items && changes.items.currentValue !== changes.items.previousValue) {
            this.calculateAvailableListItems();
        }
        if (changes
            && ((changes.isDisabled && changes.isDisabled.currentValue !== changes.isDisabled.previousValue)
                || (changes.readonly && changes.readonly.currentValue !== changes.readonly.previousValue))) {
            this.availableListItems.forEach(this.clearSelectionDualListSelectedItem);
            this.selectedListItems.forEach(this.clearSelectionDualListSelectedItem);
            this.changeDetectorRef.markForCheck();
        }
    };
    /**
     * @return {?}
     */
    DualListComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @param {?} item
     * @return {?}
     */
    DualListComponent.prototype.onSelectItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (!this.isDisabled && !this.readonly) {
            item.isSelected = !item.isSelected;
        }
    };
    /**
     * @return {?}
     */
    DualListComponent.prototype.onAddSelected = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selectedItems = this.availableListItems.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.isSelected; }));
        this.availableListItems = this.availableListItems.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return !x.isSelected; })).sort(this.sortDualListSelectedItem);
        this.selectedListItems = __spread(this.selectedListItems, selectedItems).sort(this.sortDualListSelectedItem);
        this.selectedListItems.forEach(this.clearSelectionDualListSelectedItem);
        this.selectedItemsChange.emit(this.selectedListItems.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.value; })));
    };
    /**
     * @return {?}
     */
    DualListComponent.prototype.onAddAll = /**
     * @return {?}
     */
    function () {
        this.selectedListItems = __spread(this.availableListItems, this.selectedListItems).sort(this.sortDualListSelectedItem);
        this.selectedListItems.forEach(this.clearSelectionDualListSelectedItem);
        this.availableListItems = [];
        this.selectedItemsChange.emit(this.selectedListItems.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.value; })));
    };
    /**
     * @return {?}
     */
    DualListComponent.prototype.onRemoveSelected = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selectedItems = this.selectedListItems.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.isSelected; }));
        this.selectedListItems = this.selectedListItems.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return !x.isSelected; })).sort(this.sortDualListSelectedItem);
        this.availableListItems = __spread(this.availableListItems, selectedItems).sort(this.sortDualListSelectedItem);
        this.availableListItems.forEach(this.clearSelectionDualListSelectedItem);
        this.selectedItemsChange.emit(this.selectedListItems.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.value; })));
    };
    /**
     * @return {?}
     */
    DualListComponent.prototype.onRemoveAll = /**
     * @return {?}
     */
    function () {
        this.availableListItems = __spread(this.availableListItems, this.selectedListItems).sort(this.sortDualListSelectedItem);
        this.availableListItems.forEach(this.clearSelectionDualListSelectedItem);
        this.selectedListItems = [];
        this.selectedItemsChange.emit(this.selectedListItems.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.value; })));
    };
    DualListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dual-list',
                    template: "<div class=\"d-flex justify-content-between\">\r\n\r\n    <ul class=\"available-items\">\r\n        <li *ngFor=\"let item of availableListItems\" class=\"item\" [ngClass]=\"{'selected-item': item.isSelected}\" (click)=\"onSelectItem(item)\">\r\n            <span>{{ item.label }}</span>\r\n        </li>\r\n    </ul>\r\n\r\n    <div class=\"pl-1 pr-1\">\r\n        <button (click)=\"onAddSelected()\"\r\n            title=\"{{ 'ORGANIZATION.delete:button' | translate }}\"\r\n            class=\"d-none d-md-block btn btn-raised m-0 my-1 btn-sm btn-primary\">\r\n            <i class=\"ft ft-chevron-right\" aria-hidden=\"true\"></i>\r\n        </button>\r\n        <button (click)=\"onAddAll()\"\r\n            title=\"{{ 'ORGANIZATION.delete:button' | translate }}\"\r\n            class=\"d-none d-md-block btn btn-raised m-0 my-1 btn-sm btn-primary mb-2\">\r\n            <i class=\"ft ft-chevrons-right\" aria-hidden=\"true\"></i>\r\n        </button>\r\n        <button (click)=\"onRemoveSelected()\"\r\n            title=\"{{ 'ORGANIZATION.delete:button' | translate }}\"\r\n            class=\"d-none d-md-block btn btn-raised m-0 my-1 btn-sm btn-danger\">\r\n            <i class=\"ft ft-chevron-left\" aria-hidden=\"true\"></i>\r\n        </button>\r\n        <button (click)=\"onRemoveAll()\"\r\n            title=\"{{ 'ORGANIZATION.delete:button' | translate }}\"\r\n            class=\"d-none d-md-block btn btn-raised m-0 my-1 btn-sm btn-danger\">\r\n            <i class=\"ft ft-chevrons-left\" aria-hidden=\"true\"></i>\r\n        </button>\r\n    </div>\r\n\r\n    <ul class=\"selected-items\">\r\n        <li *ngFor=\"let item of selectedListItems\" class=\"item\" [ngClass]=\"{'selected-item': item.isSelected}\" (click)=\"onSelectItem(item)\">\r\n            <span>{{ item.label }}</span>\r\n        </li>\r\n    </ul>\r\n\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".available-items,.selected-items{overflow-x:hidden;overflow-y:auto;border:1px solid #ddd;border-radius:8px;position:relative;cursor:pointer;display:block;height:250px;width:50%;list-style-type:none;padding:0;margin:0}.available-items .item,.selected-items .item{padding:5px 10px}.available-items .selected-item{background-color:#009da0}.selected-items .selected-item{background-color:#aa0404}"]
                }] }
    ];
    /** @nocollapse */
    DualListComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: TranslateService }
    ]; };
    DualListComponent.propDecorators = {
        bindLabel: [{ type: Input }],
        readonly: [{ type: Input }],
        translationPrefix: [{ type: Input }],
        items: [{ type: Input }],
        selectedItems: [{ type: Input }],
        isDisabled: [{ type: Input }],
        selectedItemsChange: [{ type: Output }]
    };
    return DualListComponent;
}());
if (false) {
    /** @type {?} */
    DualListComponent.prototype.bindLabel;
    /** @type {?} */
    DualListComponent.prototype.readonly;
    /** @type {?} */
    DualListComponent.prototype.translationPrefix;
    /** @type {?} */
    DualListComponent.prototype.items;
    /** @type {?} */
    DualListComponent.prototype.isDisabled;
    /** @type {?} */
    DualListComponent.prototype.selectedItemsChange;
    /** @type {?} */
    DualListComponent.prototype.availableListItems;
    /** @type {?} */
    DualListComponent.prototype.selectedListItems;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.unsubscribe$;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.calculateAvailableListItems;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.updateTranslation;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.createDualListSelectedItem;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.updateLabelDualListSelectedItem;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.sortDualListSelectedItem;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.clearSelectionDualListSelectedItem;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.changeDetectorRef;
    /**
     * @type {?}
     * @private
     */
    DualListComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARY = 'EMPLOYEE_SALARY';
/**
 * @record
 */
function DynamicEmployeeSalaryFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicEmployeeSalaryFormControlModelConfig.prototype.translateKey;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlModelConfig.prototype.treatmentTypes;
}
var DynamicEmployeeSalaryFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicEmployeeSalaryFormControlModel, _super);
    function DynamicEmployeeSalaryFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARY;
        _this.translateKey = config.translateKey;
        _this.treatmentTypes = config.treatmentTypes;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicEmployeeSalaryFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicEmployeeSalaryFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicEmployeeSalaryFormControlModel.prototype, "treatmentTypes", void 0);
    return DynamicEmployeeSalaryFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicEmployeeSalaryFormControlModel.prototype.type;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlModel.prototype.treatmentTypes;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicEmployeeSalaryFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicEmployeeSalaryFormControlComponent, _super);
    function DynamicEmployeeSalaryFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicEmployeeSalaryFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-employee-salary-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-employee-salary-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [treatmentTypes]=\"model.treatmentTypes\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </lib-employee-salary-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicEmployeeSalaryFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicEmployeeSalaryFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicEmployeeSalaryFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicEmployeeSalaryFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicEmployeeSalaryFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicEmployeeSalaryFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicEmployeeSalaryFormControlComponent.prototype.validationService;
}

var _a$1;
/** @type {?} */
var EMPLOYMENT_SALARY_TREATMENT_TYPE = 'treatmentType';
/** @type {?} */
var EMPLOYMENT_SALARY_SALARY = 'salary';
/** @type {?} */
var EMPLOYMENT_SALARY_SALARY_TYPE = 'salaryType';
/** @type {?} */
var FORM_LAYOUT_INPUT$1 = {
    grid: {
        host: 'employee-salary-host',
        container: 'employee-salary-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var EMPLOYEE_SALARY_LAYOUT = (_a$1 = {},
    _a$1[EMPLOYMENT_SALARY_TREATMENT_TYPE] = FORM_LAYOUT_INPUT$1,
    _a$1[EMPLOYMENT_SALARY_SALARY] = FORM_LAYOUT_INPUT$1,
    _a$1[EMPLOYMENT_SALARY_SALARY_TYPE] = FORM_LAYOUT_INPUT$1,
    _a$1);
/** @type {?} */
var EMPLOYEE_SALARY_FORM_MODEL = [
    new DynamicMultiSelectControlModel({
        id: EMPLOYMENT_SALARY_TREATMENT_TYPE,
        bindLabel: nameof('codeName'),
        multiple: false,
        translationPrefix: 'APPLICATION.DICTIONARIES',
        required: true,
        validators: {
            required: null
        },
        searchByField: nameof('codeName')
    }),
    new DynamicInputModel({
        id: EMPLOYMENT_SALARY_SALARY,
        inputType: 'number',
        min: 0.01,
        required: true,
        validators: {
            min: 0.01,
            required: null
        },
    }),
    new DynamicSelectModel({
        id: EMPLOYMENT_SALARY_SALARY_TYPE,
        options: getOptionsForDynamicSelectModel(EmploymentSalaryType, 'EMPLOYMENT_SALARY_TYPES', false),
        required: true,
        validators: {
            required: null
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalaryFormService = /** @class */ (function () {
    function EmployeeSalaryFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    EmployeeSalaryFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    EmployeeSalaryFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    EmployeeSalaryFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    EmployeeSalaryFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalaryFormService.prototype.getTreatmentTypeValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(EMPLOYMENT_SALARY_TREATMENT_TYPE).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalaryFormService.prototype.getSalaryValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(EMPLOYMENT_SALARY_SALARY).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalaryFormService.prototype.getSalaryTypeValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(EMPLOYMENT_SALARY_SALARY_TYPE).valueChanges;
    };
    EmployeeSalaryFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    EmployeeSalaryFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return EmployeeSalaryFormService;
}());
if (false) {
    /** @type {?} */
    EmployeeSalaryFormService.prototype.formModelSubject;
    /** @type {?} */
    EmployeeSalaryFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalary = /** @class */ (function () {
    function EmployeeSalary(treatmentTypeCodeName, salary, salaryType) {
        this.treatmentTypeCodeName = treatmentTypeCodeName;
        this.salary = salary;
        this.salaryType = salaryType;
    }
    return EmployeeSalary;
}());
if (false) {
    /** @type {?} */
    EmployeeSalary.prototype.treatmentTypeCodeName;
    /** @type {?} */
    EmployeeSalary.prototype.salary;
    /** @type {?} */
    EmployeeSalary.prototype.salaryType;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalaryFormComponent = /** @class */ (function () {
    function EmployeeSalaryFormComponent(employeeSalaryFormService) {
        this.employeeSalaryFormService = employeeSalaryFormService;
        this.employeeSalaryChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = EMPLOYEE_SALARY_LAYOUT;
        this.employeeSalaryFormService.formModelSubject.next(EMPLOYEE_SALARY_FORM_MODEL);
        this.formGroup = this.employeeSalaryFormService.createFormGroup(EMPLOYEE_SALARY_FORM_MODEL);
    }
    Object.defineProperty(EmployeeSalaryFormComponent.prototype, "employeeSalary", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.employeeSalaryData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.employeeSalaryData = value;
            }
            else {
                this.employeeSalaryData = new EmployeeSalary(null, 0, EmploymentSalaryType.PerHour);
                this.updateFormValue(this.employeeSalaryData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeSalaryFormComponent.prototype, "isDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value != null && value !== this.formGroup.disabled) {
                if (value) {
                    this.formGroup.disable();
                }
                else {
                    this.formGroup.enable();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(EmployeeSalaryFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.employeeSalaryFormService.getFormModel$(this.translateKey);
        this.subscribeToTreatmentTypeModelValueChanges(this.formGroup);
        this.subscribeToSalaryModelValueChanges(this.formGroup);
        this.subscribeToSalaryTypeModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.treatmentTypes) {
            this.treatmentTypeModel.items = changes.treatmentTypes.currentValue;
            this.updateTreatmentTypeFormValue(this.employeeSalaryTreatmentTypeCodeName, changes.treatmentTypes.currentValue);
        }
    };
    /**
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.treatmentTypeChangesSubscription) {
            this.treatmentTypeChangesSubscription.unsubscribe();
        }
        if (this.salaryChangeSubscription) {
            this.salaryChangeSubscription.unsubscribe();
        }
        if (this.salaryTypeChangeSubscription) {
            this.salaryTypeChangeSubscription.unsubscribe();
        }
    };
    /**
     * @private
     * @param {?} employeeSalary
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} employeeSalary
     * @return {?}
     */
    function (employeeSalary) {
        this.employeeSalaryTreatmentTypeCodeName = employeeSalary.treatmentTypeCodeName;
        this.updateTreatmentTypeFormValue(employeeSalary.treatmentTypeCodeName, this.treatmentTypes);
        this.formGroup.get(EMPLOYMENT_SALARY_SALARY).patchValue(employeeSalary.salary);
        this.formGroup.get(EMPLOYMENT_SALARY_SALARY_TYPE).patchValue(employeeSalary.salaryType);
    };
    /**
     * @private
     * @param {?} treatmentTypeCodeName
     * @param {?} treatmentTypes
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.updateTreatmentTypeFormValue = /**
     * @private
     * @param {?} treatmentTypeCodeName
     * @param {?} treatmentTypes
     * @return {?}
     */
    function (treatmentTypeCodeName, treatmentTypes) {
        /** @type {?} */
        var treatmentTypeValue = (treatmentTypes || []).find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.codeName === treatmentTypeCodeName; }));
        this.formGroup.get(EMPLOYMENT_SALARY_TREATMENT_TYPE).patchValue(treatmentTypeValue);
    };
    /**
     * @private
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var treatmentType = this.formGroup.get(EMPLOYMENT_SALARY_TREATMENT_TYPE).value;
        /** @type {?} */
        var salary = this.formGroup.get(EMPLOYMENT_SALARY_SALARY).value;
        /** @type {?} */
        var salaryPeriodType = this.formGroup.get(EMPLOYMENT_SALARY_SALARY_TYPE).value;
        return new EmployeeSalary(treatmentType != null ? treatmentType.codeName : null, salary, salaryPeriodType);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.subscribeToTreatmentTypeModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.treatmentTypeChangesSubscription = this.employeeSalaryFormService
            .getTreatmentTypeValue$(formGroup)
            .subscribe((/**
         * @param {?} treatmentType
         * @return {?}
         */
        function (treatmentType) {
            _this.onEmployeeSalaryChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.subscribeToSalaryModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.salaryChangeSubscription = this.employeeSalaryFormService
            .getSalaryValue$(formGroup)
            .subscribe((/**
         * @param {?} salary
         * @return {?}
         */
        function (salary) {
            _this.onEmployeeSalaryChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.subscribeToSalaryTypeModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.salaryTypeChangeSubscription = this.employeeSalaryFormService
            .getSalaryTypeValue$(formGroup)
            .subscribe((/**
         * @param {?} salaryPeriodType
         * @return {?}
         */
        function (salaryPeriodType) {
            _this.onEmployeeSalaryChange();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    EmployeeSalaryFormComponent.prototype.onEmployeeSalaryChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.employeeSalaryData = this.getFormValue();
        this.employeeSalaryChange.emit(this.employeeSalaryData);
    };
    Object.defineProperty(EmployeeSalaryFormComponent.prototype, "treatmentTypeModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this.employeeSalaryFormService
                .findModelById(EMPLOYMENT_SALARY_TREATMENT_TYPE, EMPLOYEE_SALARY_FORM_MODEL)));
        },
        enumerable: true,
        configurable: true
    });
    EmployeeSalaryFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-employee-salary-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        EmployeeSalaryFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    EmployeeSalaryFormComponent.ctorParameters = function () { return [
        { type: EmployeeSalaryFormService }
    ]; };
    EmployeeSalaryFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        treatmentTypes: [{ type: Input }],
        employeeSalary: [{ type: Input }],
        isDisabled: [{ type: Input }],
        touched: [{ type: Input }],
        employeeSalaryChange: [{ type: Output }]
    };
    return EmployeeSalaryFormComponent;
}());
if (false) {
    /** @type {?} */
    EmployeeSalaryFormComponent.prototype.translateKey;
    /** @type {?} */
    EmployeeSalaryFormComponent.prototype.treatmentTypes;
    /** @type {?} */
    EmployeeSalaryFormComponent.prototype.employeeSalaryChange;
    /** @type {?} */
    EmployeeSalaryFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    EmployeeSalaryFormComponent.prototype.formLayout;
    /** @type {?} */
    EmployeeSalaryFormComponent.prototype.formModel$;
    /** @type {?} */
    EmployeeSalaryFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormComponent.prototype.employeeSalaryData;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormComponent.prototype.employeeSalaryTreatmentTypeCodeName;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormComponent.prototype.treatmentTypeChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormComponent.prototype.salaryChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormComponent.prototype.salaryTypeChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormComponent.prototype.employeeSalaryFormService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalaryFormControlComponent = /** @class */ (function () {
    function EmployeeSalaryFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(EmployeeSalaryFormControlComponent.prototype, "employeeSalary", {
        get: /**
         * @return {?}
         */
        function () {
            return this.employeeSalaryData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.employeeSalaryData = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    EmployeeSalaryFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.employeeSalaryData = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmployeeSalaryFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmployeeSalaryFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    EmployeeSalaryFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    EmployeeSalaryFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-employee-salary-form-control',
                    template: "<lib-employee-salary-form\r\n    [(employeeSalary)]=\"employeeSalary\"\r\n    [translateKey]=\"translateKey\"\r\n    [treatmentTypes]=\"treatmentTypes\"\r\n    [isDisabled]=\"isDisabled\"\r\n    [touched]=\"touched\">\r\n</lib-employee-salary-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return EmployeeSalaryFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    EmployeeSalaryFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        treatmentTypes: [{ type: Input }],
        employeeSalary: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return EmployeeSalaryFormControlComponent;
}());
if (false) {
    /** @type {?} */
    EmployeeSalaryFormControlComponent.prototype.translateKey;
    /** @type {?} */
    EmployeeSalaryFormControlComponent.prototype.treatmentTypes;
    /** @type {?} */
    EmployeeSalaryFormControlComponent.prototype.touched;
    /** @type {?} */
    EmployeeSalaryFormControlComponent.prototype.blur;
    /** @type {?} */
    EmployeeSalaryFormControlComponent.prototype.change;
    /** @type {?} */
    EmployeeSalaryFormControlComponent.prototype.focus;
    /** @type {?} */
    EmployeeSalaryFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormControlComponent.prototype.employeeSalaryData;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalaryFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARIES = 'EMPLOYEE_SALARIES';
/**
 * @record
 */
function DynamicEmployeeSalariesFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicEmployeeSalariesFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicEmployeeSalariesFormControlModelConfig.prototype.minCountRequired;
}
var DynamicEmployeeSalariesFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicEmployeeSalariesFormControlModel, _super);
    function DynamicEmployeeSalariesFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARIES;
        _this.translateKey = config.translateKey;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicEmployeeSalariesFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicEmployeeSalariesFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicEmployeeSalariesFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicEmployeeSalariesFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicEmployeeSalariesFormControlModel.prototype.type;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicEmployeeSalariesFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicEmployeeSalariesFormControlComponent, _super);
    function DynamicEmployeeSalariesFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicEmployeeSalariesFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-employee-salaries-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-employee-salaries-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </lib-employee-salaries-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicEmployeeSalariesFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicEmployeeSalariesFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicEmployeeSalariesFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicEmployeeSalariesFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicEmployeeSalariesFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicEmployeeSalariesFormControlComponent.prototype.validationService;
}

var _a$2;
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM = {
    grid: {
        host: 'employee-salaries-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var EMPLOYEE_SALARIES_ARRAY_MODEL = 'employeeSalariesArrayModel';
/** @type {?} */
var EMPLOYEE_SALARIES_SALARY = 'salary';
/** @type {?} */
var EMPLOYEE_SALARIES_LAYOUT = (_a$2 = {},
    _a$2[EMPLOYEE_SALARIES_ARRAY_MODEL] = FORM_LAYOUT_INPUT_ALL,
    _a$2[EMPLOYEE_SALARIES_SALARY] = FORM_LAYOUT_INPUT_ALL_ITEM,
    _a$2);
var ɵ0 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicEmployeeSalaryFormControlModel({
            id: EMPLOYEE_SALARIES_SALARY,
            treatmentTypes: []
        })
    ];
};
/** @type {?} */
var EMPLOYEE_SALARIES_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: EMPLOYEE_SALARIES_ARRAY_MODEL,
        initialCount: 1,
        groupFactory: (ɵ0)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalariesFormService = /** @class */ (function () {
    function EmployeeSalariesFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.formModelTreatmentTypesSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelTreatmentTypesChange$ = this.formModelTreatmentTypesSubject
            .pipe(map((/**
         * @param {?} treatmentTypes
         * @return {?}
         */
        function (treatmentTypes) {
            /** @type {?} */
            var formModel = _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey);
            return _this.assignTreatmentTypes(formModel, treatmentTypes);
        })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelTreatmentTypesChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} treatmentTypes
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.assignTreatmentTypes = /**
     * @private
     * @param {?} formModel
     * @param {?} treatmentTypes
     * @return {?}
     */
    function (formModel, treatmentTypes) {
        if (treatmentTypes != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = EMPLOYEE_SALARIES_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} employeeSalaryModel
             * @return {?}
             */
            function (employeeSalaryModel) {
                employeeSalaryModel.treatmentTypes = treatmentTypes;
            })); }));
        }
        return formModel;
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = EMPLOYEE_SALARIES_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} employeeSalaryModel
             * @return {?}
             */
            function (employeeSalaryModel) {
                employeeSalaryModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalariesFormService.prototype.getEmployeeSalariesArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(EMPLOYEE_SALARIES_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.salary; }));
        })));
    };
    EmployeeSalariesFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    EmployeeSalariesFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return EmployeeSalariesFormService;
}());
if (false) {
    /** @type {?} */
    EmployeeSalariesFormService.prototype.formModelSubject;
    /** @type {?} */
    EmployeeSalariesFormService.prototype.formModelTreatmentTypesSubject;
    /** @type {?} */
    EmployeeSalariesFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalaries = /** @class */ (function () {
    function EmployeeSalaries(salaries) {
        this.salaries = salaries;
    }
    return EmployeeSalaries;
}());
if (false) {
    /** @type {?} */
    EmployeeSalaries.prototype.salaries;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalariesFormComponent = /** @class */ (function () {
    function EmployeeSalariesFormComponent(employeeSalariesFormService, dictionariesService) {
        var _this = this;
        this.employeeSalariesFormService = employeeSalariesFormService;
        this.dictionariesService = dictionariesService;
        this.employeeSalariesChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getEmployeeSalariesFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.employeeSalariesFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === EMPLOYEE_SALARIES_ARRAY_MODEL; }))));
        });
        this.getEmployeeSalariesArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.employeeSalariesFormService
                .findModelById(EMPLOYEE_SALARIES_ARRAY_MODEL, EMPLOYEE_SALARIES_FORM_MODEL);
            return (/** @type {?} */ (_this.employeeSalariesFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = EMPLOYEE_SALARIES_LAYOUT;
        this.employeeSalariesFormService.formModelSubject.next(EMPLOYEE_SALARIES_FORM_MODEL);
        this.formGroup = this.employeeSalariesFormService.createFormGroup(EMPLOYEE_SALARIES_FORM_MODEL);
        this.subscribeToEmployeeSalariesArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(EmployeeSalariesFormComponent.prototype, "employeeSalaries", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.salaries != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.employeeSalariesData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.employeeSalariesData = value;
            }
            else {
                this.employeeSalariesData = new EmployeeSalaries([]);
                this.updateFormValue(this.employeeSalariesData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeSalariesFormComponent.prototype, "isDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._isDisabled = value;
            this.updateFormGroupDisabled();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(EmployeeSalariesFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formModel$ = this.employeeSalariesFormService.getFormModel$(this.translateKey);
        this.updateFormValue(this.employeeSalariesData);
        this.displaySpinner$.next(true);
        this.dictionariesService
            .getItems(DictionaryType.TreatmentType)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} treatmentTypes
         * @return {?}
         */
        function (treatmentTypes) {
            _this.treatmentTypes = treatmentTypes;
            _this.onUpdateTreatmentTypes(treatmentTypes);
        }));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @private
     * @param {?} treatmentTypes
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.onUpdateTreatmentTypes = /**
     * @private
     * @param {?} treatmentTypes
     * @return {?}
     */
    function (treatmentTypes) {
        /** @type {?} */
        var sortedTreatmentTypes = (treatmentTypes || []).sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return a.codeName.localeCompare(b.codeName); }));
        this.employeeSalariesFormService.formModelTreatmentTypesSubject.next(sortedTreatmentTypes);
    };
    /**
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.employeeSalariesArrayModelChangesSubscription.unsubscribe();
    };
    Object.defineProperty(EmployeeSalariesFormComponent.prototype, "isExistSalaries", {
        get: /**
         * @return {?}
         */
        function () {
            return this.employeeSalariesData != null
                && this.employeeSalariesData.salaries != null
                && this.employeeSalariesData.salaries.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeSalariesFormComponent.prototype, "showAddSalaryButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getEmployeeSalariesArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeSalariesFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getEmployeeSalariesArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @param {?} emplyeeSalaries
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} emplyeeSalaries
     * @return {?}
     */
    function (emplyeeSalaries) {
        /** @type {?} */
        var groupSize = this.minCountRequired || 0;
        /** @type {?} */
        var values = null;
        if (emplyeeSalaries != null && emplyeeSalaries.salaries != null) {
            groupSize = emplyeeSalaries.salaries.length;
            values = emplyeeSalaries.salaries.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ salary: x }); }));
        }
        this.employeeSalariesFormService.initFormArrayGroup(groupSize, this.getEmployeeSalariesArrayModelControl(), this.getEmployeeSalariesFormArrayModel());
        if (groupSize > 0) {
            this.formGroup.get(EMPLOYEE_SALARIES_ARRAY_MODEL).patchValue(values);
        }
        this.employeeSalariesFormService.formModelSubject.next([this.getEmployeeSalariesFormArrayModel()]);
        this.employeeSalariesFormService.formModelTreatmentTypesSubject.next(this.treatmentTypes);
        this.updateFormGroupDisabled();
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.subscribeToEmployeeSalariesArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.employeeSalariesArrayModelChangesSubscription = this.employeeSalariesFormService
            .getEmployeeSalariesArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.employeeSalariesData = null;
            }
            else {
                _this.employeeSalariesData = new EmployeeSalaries(value);
            }
            _this.employeeSalariesChange.emit(_this.employeeSalariesData);
        }));
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.employeeSalariesFormService.removeFormArrayGroup(index, this.getEmployeeSalariesArrayModelControl(), context);
        this.employeeSalariesFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.employeeSalariesFormService.insertFormArrayGroup(index, this.getEmployeeSalariesArrayModelControl(), context);
        this.employeeSalariesFormService.formModelSubject.next([context]);
        this.employeeSalariesFormService.formModelTreatmentTypesSubject.next(this.treatmentTypes);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.employeeSalariesFormService.insertFormArrayGroup(0, this.getEmployeeSalariesArrayModelControl(), this.getEmployeeSalariesFormArrayModel());
        this.employeeSalariesFormService.formModelSubject.next([this.getEmployeeSalariesFormArrayModel()]);
        this.employeeSalariesFormService.formModelTreatmentTypesSubject.next(this.treatmentTypes);
        this.updateFormGroupTouched();
    };
    /**
     * @private
     * @return {?}
     */
    EmployeeSalariesFormComponent.prototype.updateFormGroupDisabled = /**
     * @private
     * @return {?}
     */
    function () {
        if (this._isDisabled) {
            this.formGroup.disable();
        }
        else {
            this.formGroup.enable();
        }
    };
    EmployeeSalariesFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-employee-salaries-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #employeeSalaryForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\" *ngIf=\"showAddSalaryButton\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addSalary:button' | translate}}</span>\r\n            </button>\r\n            <h5 *ngIf=\"!isExistSalaries\">\r\n                <i class=\"ft ft-info mr-2\"></i>\r\n                <span>{{translateKey + '.noSalaries' | translate}}</span>\r\n            </h5>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n\r\n                <ng-template modelId=\"employeeSalariesArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"employee-salaries-buttons\">\r\n                        <button type=\"button\" class=\"btn btn-danger\" (click)=\"removeItem(context, index)\" [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i class=\"ft-plus\"></i></button>\r\n                    </div>\r\n                </ng-template>\r\n\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        EmployeeSalariesFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    EmployeeSalariesFormComponent.ctorParameters = function () { return [
        { type: EmployeeSalariesFormService },
        { type: DictionariesService }
    ]; };
    EmployeeSalariesFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        employeeSalaries: [{ type: Input }],
        isDisabled: [{ type: Input }],
        touched: [{ type: Input }],
        employeeSalariesChange: [{ type: Output }]
    };
    return EmployeeSalariesFormComponent;
}());
if (false) {
    /** @type {?} */
    EmployeeSalariesFormComponent.prototype.translateKey;
    /** @type {?} */
    EmployeeSalariesFormComponent.prototype.minCountRequired;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype._isDisabled;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype._touched;
    /** @type {?} */
    EmployeeSalariesFormComponent.prototype.employeeSalariesChange;
    /** @type {?} */
    EmployeeSalariesFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    EmployeeSalariesFormComponent.prototype.formLayout;
    /** @type {?} */
    EmployeeSalariesFormComponent.prototype.formModel$;
    /** @type {?} */
    EmployeeSalariesFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.employeeSalariesData;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.employeeSalariesArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.treatmentTypes;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.getEmployeeSalariesFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.getEmployeeSalariesArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.employeeSalariesFormService;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormComponent.prototype.dictionariesService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmployeeSalariesFormControlComponent = /** @class */ (function () {
    function EmployeeSalariesFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(EmployeeSalariesFormControlComponent.prototype, "employeeSalaries", {
        get: /**
         * @return {?}
         */
        function () {
            return this.employeeSalariesData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.employeeSalariesData = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    EmployeeSalariesFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.employeeSalariesData = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmployeeSalariesFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmployeeSalariesFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    EmployeeSalariesFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    EmployeeSalariesFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-employee-salaries-form-control',
                    template: "<lib-employee-salaries-form\r\n    [(employeeSalaries)]=\"employeeSalaries\"\r\n    [translateKey]=\"translateKey\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [isDisabled]=\"isDisabled\"\r\n    [touched]=\"touched\">\r\n</lib-employee-salaries-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return EmployeeSalariesFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    EmployeeSalariesFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        employeeSalaries: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return EmployeeSalariesFormControlComponent;
}());
if (false) {
    /** @type {?} */
    EmployeeSalariesFormControlComponent.prototype.translateKey;
    /** @type {?} */
    EmployeeSalariesFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    EmployeeSalariesFormControlComponent.prototype.touched;
    /** @type {?} */
    EmployeeSalariesFormControlComponent.prototype.blur;
    /** @type {?} */
    EmployeeSalariesFormControlComponent.prototype.change;
    /** @type {?} */
    EmployeeSalariesFormControlComponent.prototype.focus;
    /** @type {?} */
    EmployeeSalariesFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormControlComponent.prototype.employeeSalariesData;
    /**
     * @type {?}
     * @private
     */
    EmployeeSalariesFormControlComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function employeeSalariesValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var employeeSalaries = (/** @type {?} */ (control.value));
        if (employeeSalaries.salaries == null || employeeSalaries.salaries.length === 0) {
            return null;
        }
        /** @type {?} */
        var isEmployeeSalaryCorrect = (/**
         * @param {?} salary
         * @return {?}
         */
        function (salary) {
            if (salary == null) {
                return false;
            }
            return !isEmpty(salary.treatmentTypeCodeName)
                && salary.salary != null
                && salary.salary > 0
                && (salary.salaryType === EmploymentSalaryType.PerHour || salary.salaryType === EmploymentSalaryType.PerHectare);
        });
        if (employeeSalaries.salaries.some((/**
         * @param {?} seed
         * @return {?}
         */
        function (seed) { return !isEmployeeSalaryCorrect(seed); }))) {
            return { employeeSalaries: {} };
        }
        /** @type {?} */
        var isUniqueTreatmentType = (/**
         * @param {?} salaries
         * @return {?}
         */
        function (salaries) {
            /** @type {?} */
            var uniqueTreatmentTypes = Array.from(new Set(salaries.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.treatmentTypeCodeName; }))));
            return uniqueTreatmentTypes.length === salaries.length;
        });
        if (isUniqueTreatmentType(employeeSalaries.salaries) === false) {
            return { employeeSalariesNotUniqueTreatmentType: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_FARM_AUDIT_REQUIREMENT = 'FARM_AUDIT_REQUIREMENT';
/**
 * @record
 */
function DynamicFarmAuditRequirementFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlModelConfig.prototype.translateKey;
}
var DynamicFarmAuditRequirementFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicFarmAuditRequirementFormControlModel, _super);
    function DynamicFarmAuditRequirementFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_FARM_AUDIT_REQUIREMENT;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicFarmAuditRequirementFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicFarmAuditRequirementFormControlModel.prototype, "translateKey", void 0);
    return DynamicFarmAuditRequirementFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlModel.prototype.type;
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFarmAuditRequirementFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicFarmAuditRequirementFormControlComponent, _super);
    function DynamicFarmAuditRequirementFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicFarmAuditRequirementFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-farm-audit-requirement-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-farm-audit-requirement-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </lib-farm-audit-requirement-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicFarmAuditRequirementFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicFarmAuditRequirementFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicFarmAuditRequirementFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicFarmAuditRequirementFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicFarmAuditRequirementFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicFarmAuditRequirementFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DEFAULT_FORM_LAYOUT_GROUP = {
    grid: {
        host: 'w-100 mt-1',
        label: 'col-12 px-0'
    },
    element: {
        control: 'row'
    }
};
/** @type {?} */
var DEFAULT_FORM_LAYOUT_INPUT = {
    grid: {
        host: 'col-12 col-md-6 m-0'
    }
};
/** @type {?} */
var FORM_LAYOUT_SINGLE_LINE_INPUT = {
    grid: {
        host: 'col-12 m-0'
    }
};
/** @type {?} */
var DEFAULT_SEARCH_FORM_LAYOUT_INPUT_EVEN = {
    grid: {
        host: 'col-12 col-md-6',
        container: 'form-group row mr-md-1',
        label: 'col-12',
        control: 'col-12'
    }
};
/** @type {?} */
var DEFAULT_SEARCH_FORM_LAYOUT_INPUT_ODD = {
    grid: {
        host: 'col-12 col-md-6',
        container: 'form-group row ml-md-1',
        label: 'col-12',
        control: 'col-12'
    }
};

var _a$3;
/** @type {?} */
var FAR_ANSWER = 'answer';
/** @type {?} */
var FAR_ANSWER_DESCRIPTION = 'answerDescription';
/** @type {?} */
var FARM_AUDIT_REQUIREMENT_LAYOUT = (_a$3 = {},
    _a$3[FAR_ANSWER] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$3[FAR_ANSWER_DESCRIPTION] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$3);
/** @type {?} */
var FARM_AUDIT_REQUIREMENT_FORM_MODEL = [
    new DynamicMultiSelectControlModel({
        id: FAR_ANSWER,
        multiple: false
    }),
    new DynamicTextAreaModel({
        id: FAR_ANSWER_DESCRIPTION,
        maxLength: 1000,
        rows: 3,
        validators: {
            maxLength: 1000
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FarmAuditRequirement = /** @class */ (function () {
    function FarmAuditRequirement(orderNumber, sectionKey, sectionLabel, sectionColor, weight, text, hintText, answers, answerKey, answerDescription) {
        this.orderNumber = orderNumber;
        this.sectionKey = sectionKey;
        this.sectionLabel = sectionLabel;
        this.sectionColor = sectionColor;
        this.weight = weight;
        this.text = text;
        this.hintText = hintText;
        this.answers = answers;
        this.answerKey = answerKey;
        this.answerDescription = answerDescription;
    }
    return FarmAuditRequirement;
}());
if (false) {
    /** @type {?} */
    FarmAuditRequirement.prototype.orderNumber;
    /** @type {?} */
    FarmAuditRequirement.prototype.sectionKey;
    /** @type {?} */
    FarmAuditRequirement.prototype.sectionLabel;
    /** @type {?} */
    FarmAuditRequirement.prototype.sectionColor;
    /** @type {?} */
    FarmAuditRequirement.prototype.weight;
    /** @type {?} */
    FarmAuditRequirement.prototype.text;
    /** @type {?} */
    FarmAuditRequirement.prototype.hintText;
    /** @type {?} */
    FarmAuditRequirement.prototype.answers;
    /** @type {?} */
    FarmAuditRequirement.prototype.answerKey;
    /** @type {?} */
    FarmAuditRequirement.prototype.answerDescription;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FarmAuditRequirementFormService = /** @class */ (function () {
    function FarmAuditRequirementFormService(translateFormModelService, translateService, changeDetectorRef, formService) {
        var _this = this;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.changeDetectorRef = changeDetectorRef;
        this.formService = formService;
        this.refreshFormModel$ = new BehaviorSubject(true);
        this.formModelSubject$ = new BehaviorSubject(null);
        this.onRefresh = (/**
         * @return {?}
         */
        function () {
            _this.refreshFormModel$.next(true);
        });
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} formGroup
     * @param {?} farmAuditRequirement
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.getFormValue = /**
     * @param {?} formGroup
     * @param {?} farmAuditRequirement
     * @return {?}
     */
    function (formGroup, farmAuditRequirement) {
        /** @type {?} */
        var answer = this.getAnswerControl(formGroup).value;
        /** @type {?} */
        var answerDescription = this.getAnswerDescriptionControl(formGroup).value;
        return new FarmAuditRequirement(farmAuditRequirement != null ? farmAuditRequirement.orderNumber : null, farmAuditRequirement != null ? farmAuditRequirement.sectionKey : null, farmAuditRequirement != null ? farmAuditRequirement.sectionLabel : null, farmAuditRequirement != null ? farmAuditRequirement.sectionColor : null, farmAuditRequirement != null ? farmAuditRequirement.weight : 1, farmAuditRequirement != null ? farmAuditRequirement.text : null, farmAuditRequirement != null ? farmAuditRequirement.hintText : null, farmAuditRequirement != null ? farmAuditRequirement.answers : [], answer != null ? answer.key : null, answerDescription);
    };
    /**
     * @param {?} formGroup
     * @param {?} formModel
     * @param {?} farmAuditRequirement
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.updateFormValue = /**
     * @param {?} formGroup
     * @param {?} formModel
     * @param {?} farmAuditRequirement
     * @return {?}
     */
    function (formGroup, formModel, farmAuditRequirement) {
        /** @type {?} */
        var items = __spread(farmAuditRequirement.answers);
        this.getAnswerModel(formModel).items = items;
        /** @type {?} */
        var answer = farmAuditRequirement != null ? items.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.key === farmAuditRequirement.answerKey; })) : null;
        this.getAnswerControl(formGroup).patchValue(answer);
        this.getAnswerDescriptionControl(formGroup).patchValue(farmAuditRequirement != null ? farmAuditRequirement.answerDescription : '');
    };
    /**
     * @param {?} formGroup
     * @param {?} formModel
     * @param {?} onChange
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.subscribeOnChanges = /**
     * @param {?} formGroup
     * @param {?} formModel
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, formModel, onChange) {
        this.subscribeToAnswerChanges(formGroup, formModel, onChange);
        this.subscribeToAnswerDescriptionChanges(formGroup, onChange);
    };
    /**
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.unsubscribeChanges = /**
     * @return {?}
     */
    function () {
        this.answerChangesSubscription.unsubscribe();
        this.answerDescriptionChangesSubscription.unsubscribe();
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject$
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject$.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var refreshFormModeChange$ = this.refreshFormModel$
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject$.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(refreshFormModeChange$, formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.getFormModelValue = /**
     * @return {?}
     */
    function () {
        return this.formModelSubject$.getValue();
    };
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @param {?} formModel
     * @param {?} onChange
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.subscribeToAnswerChanges = 
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @param {?} formModel
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, formModel, onChange) {
        var _this = this;
        this.answerChangesSubscription =
            this.getAnswerControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} answer
             * @return {?}
             */
            function (answer) {
                if (answer != null) {
                    if (answer.isRequiredDescription) {
                        _this.getAnswerDescriptionModel(formModel).required = true;
                        _this.getAnswerDescriptionModel(formModel).validators = {
                            required: null,
                            maxLength: 1000
                        };
                        _this.getAnswerDescriptionControl(formGroup).setValidators(Validators.required);
                    }
                    else {
                        _this.getAnswerDescriptionModel(formModel).required = false;
                        _this.getAnswerDescriptionModel(formModel).validators = {
                            maxLength: 1000
                        };
                        _this.getAnswerDescriptionControl(formGroup).setValidators(null);
                    }
                    _this.onRefresh();
                    _this.changeDetectorRef.markForCheck();
                }
                onChange();
            }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.subscribeToAnswerDescriptionChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.answerDescriptionChangesSubscription =
            this.getAnswerDescriptionControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} answerDescription
             * @return {?}
             */
            function (answerDescription) { return onChange(); }));
    };
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.getAnswerControl = 
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAR_ANSWER);
    };
    /**
     * @private
     * @param {?} formModel
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.getAnswerModel = /**
     * @private
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return (/** @type {?} */ (this.formService
            .findModelById(FAR_ANSWER, formModel)));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.getAnswerDescriptionControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAR_ANSWER_DESCRIPTION);
    };
    /**
     * @private
     * @param {?} formModel
     * @return {?}
     */
    FarmAuditRequirementFormService.prototype.getAnswerDescriptionModel = /**
     * @private
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return (/** @type {?} */ (this.formService.findModelById(FAR_ANSWER_DESCRIPTION, formModel)));
    };
    FarmAuditRequirementFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FarmAuditRequirementFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: ChangeDetectorRef },
        { type: DynamicFormService }
    ]; };
    return FarmAuditRequirementFormService;
}());
if (false) {
    /** @type {?} */
    FarmAuditRequirementFormService.prototype.refreshFormModel$;
    /** @type {?} */
    FarmAuditRequirementFormService.prototype.formModelSubject$;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormService.prototype.answerChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormService.prototype.answerDescriptionChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormService.prototype.onRefresh;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormService.prototype.changeDetectorRef;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FarmAuditRequirementFormComponent = /** @class */ (function () {
    function FarmAuditRequirementFormComponent(farmAuditRequirementFormService) {
        var _this = this;
        this.farmAuditRequirementFormService = farmAuditRequirementFormService;
        this.farmAuditRequirementChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.onFieldAuditAreaChange = (/**
         * @return {?}
         */
        function () {
            _this.farmAuditRequirementData = _this.getFormValue();
            _this.farmAuditRequirementChange.emit(_this.farmAuditRequirementData);
        });
        /** @type {?} */
        var layout = cloneDeep(FARM_AUDIT_REQUIREMENT_LAYOUT);
        /** @type {?} */
        var model = cloneDeep(FARM_AUDIT_REQUIREMENT_FORM_MODEL);
        this.formLayout = layout;
        this.farmAuditRequirementFormService.formModelSubject$.next(model);
        this.formGroup = this.farmAuditRequirementFormService.createFormGroup(model);
    }
    Object.defineProperty(FarmAuditRequirementFormComponent.prototype, "farmAuditRequirement", {
        get: /**
         * @return {?}
         */
        function () {
            return this.farmAuditRequirementData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.farmAuditRequirementData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.farmAuditRequirementData = value;
            }
            else {
                this.farmAuditRequirementData = new FarmAuditRequirement(0, // public orderNumber: number,
                null, // public sectionKey: string,
                null, // public sectionLabel: string,
                null, // public sectionColor: string,
                0, // public weight: number,
                null, // public text: string,
                null, // public hintText: string,
                [], // public answers: { key: string, label: string, isRequiredDescription: boolean, points: number }[],
                null, // public answerKey: string,
                null // public answerDescription: string
                );
                this.updateFormValue(this.farmAuditRequirementData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FarmAuditRequirementFormComponent.prototype, "sectionColor", {
        get: /**
         * @return {?}
         */
        function () {
            return this.farmAuditRequirement.sectionColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FarmAuditRequirementFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FarmAuditRequirementFormComponent.prototype, "isDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.disable();
            }
            else {
                this.formGroup.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    FarmAuditRequirementFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.farmAuditRequirementFormService.getFormModel$(this.translateKey);
        /** @type {?} */
        var formModelValue = this.farmAuditRequirementFormService.getFormModelValue();
        this.farmAuditRequirementFormService.subscribeOnChanges(this.formGroup, formModelValue, this.onFieldAuditAreaChange);
    };
    /**
     * @return {?}
     */
    FarmAuditRequirementFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.farmAuditRequirementFormService.unsubscribeChanges();
    };
    /**
     * @private
     * @param {?} farmAuditRequirement
     * @return {?}
     */
    FarmAuditRequirementFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} farmAuditRequirement
     * @return {?}
     */
    function (farmAuditRequirement) {
        /** @type {?} */
        var formModelValue = this.farmAuditRequirementFormService.getFormModelValue();
        this.farmAuditRequirementFormService.updateFormValue(this.formGroup, formModelValue, farmAuditRequirement);
    };
    /**
     * @private
     * @return {?}
     */
    FarmAuditRequirementFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        return this.farmAuditRequirementFormService.getFormValue(this.formGroup, this.farmAuditRequirement);
    };
    FarmAuditRequirementFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-farm-audit-requirement-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n\r\n    <div>\r\n        <span class=\"py-0 px-1 text-center alert alert-secondary mr-1\" [ngStyle]=\"{ 'background-color': sectionColor }\">\r\n            {{ farmAuditRequirement.sectionLabel }}\r\n        </span>\r\n        <span class=\"mr-1\">{{ farmAuditRequirement.orderNumber }}.</span>\r\n        <span>{{ farmAuditRequirement.text }}</span>\r\n        <span *ngIf=\"farmAuditRequirement.hintText\" class=\"ml-1 font-italic\">({{ farmAuditRequirement.hintText\r\n            }})</span>\r\n    </div>\r\n\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row farmAuditRequirementFormRow\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        FarmAuditRequirementFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    FarmAuditRequirementFormComponent.ctorParameters = function () { return [
        { type: FarmAuditRequirementFormService }
    ]; };
    FarmAuditRequirementFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        farmAuditRequirement: [{ type: Input }],
        touched: [{ type: Input }],
        isDisabled: [{ type: Input }],
        farmAuditRequirementChange: [{ type: Output }]
    };
    return FarmAuditRequirementFormComponent;
}());
if (false) {
    /** @type {?} */
    FarmAuditRequirementFormComponent.prototype.translateKey;
    /** @type {?} */
    FarmAuditRequirementFormComponent.prototype.farmAuditRequirementChange;
    /** @type {?} */
    FarmAuditRequirementFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    FarmAuditRequirementFormComponent.prototype.formLayout;
    /** @type {?} */
    FarmAuditRequirementFormComponent.prototype.formModel$;
    /** @type {?} */
    FarmAuditRequirementFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormComponent.prototype.farmAuditRequirementData;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormComponent.prototype.onFieldAuditAreaChange;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormComponent.prototype.farmAuditRequirementFormService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FarmAuditRequirementFormControlComponent = /** @class */ (function () {
    function FarmAuditRequirementFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(FarmAuditRequirementFormControlComponent.prototype, "farmAuditRequirement", {
        get: /**
         * @return {?}
         */
        function () {
            return this._farmAuditRequirement;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._farmAuditRequirement = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    FarmAuditRequirementFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._farmAuditRequirement = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FarmAuditRequirementFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FarmAuditRequirementFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    FarmAuditRequirementFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    FarmAuditRequirementFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-farm-audit-requirement-form-control',
                    template: "<lib-farm-audit-requirement-form\r\n    [(farmAuditRequirement)]=\"farmAuditRequirement\"\r\n    [translateKey]=\"translateKey\"\r\n    [touched]=\"touched\"\r\n    [isDisabled]=\"isDisabled\">\r\n</lib-farm-audit-requirement-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return FarmAuditRequirementFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    FarmAuditRequirementFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        farmAuditRequirement: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return FarmAuditRequirementFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormControlComponent.prototype._farmAuditRequirement;
    /** @type {?} */
    FarmAuditRequirementFormControlComponent.prototype.translateKey;
    /** @type {?} */
    FarmAuditRequirementFormControlComponent.prototype.touched;
    /** @type {?} */
    FarmAuditRequirementFormControlComponent.prototype.blur;
    /** @type {?} */
    FarmAuditRequirementFormControlComponent.prototype.change;
    /** @type {?} */
    FarmAuditRequirementFormControlComponent.prototype.focus;
    /** @type {?} */
    FarmAuditRequirementFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    FarmAuditRequirementFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_FIELD_AUDIT_AREA = 'FIELD_AUDIT_AREA';
/**
 * @record
 */
function DynamicFieldAuditAreaFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicFieldAuditAreaFormControlModelConfig.prototype.translateKey;
}
var DynamicFieldAuditAreaFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicFieldAuditAreaFormControlModel, _super);
    function DynamicFieldAuditAreaFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_FIELD_AUDIT_AREA;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicFieldAuditAreaFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicFieldAuditAreaFormControlModel.prototype, "translateKey", void 0);
    return DynamicFieldAuditAreaFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicFieldAuditAreaFormControlModel.prototype.type;
    /** @type {?} */
    DynamicFieldAuditAreaFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFieldAuditAreaFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicFieldAuditAreaFormControlComponent, _super);
    function DynamicFieldAuditAreaFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicFieldAuditAreaFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-field-audit-area-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-field-audit-area-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-field-audit-area-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicFieldAuditAreaFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicFieldAuditAreaFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicFieldAuditAreaFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicFieldAuditAreaFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicFieldAuditAreaFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicFieldAuditAreaFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicFieldAuditAreaFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicFieldAuditAreaFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicFieldAuditAreaFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicFieldAuditAreaFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicFieldAuditAreaFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicFieldAuditAreaFormControlComponent.prototype.validationService;
}

var _a$4;
/** @type {?} */
var MAX_FILE_SIZE$1 = 10;
// MB
/** @type {?} */
var FAA_PESTICIDE_USE_ASSESSMENT = 'pesticideUseAssessment';
/** @type {?} */
var FAA_PESTICIDE_USE_DESCRIPTION = 'pesticideUseDescription';
/** @type {?} */
var FAA_QUALITY_ASSESSMENT = 'qualityAssessment';
/** @type {?} */
var FAA_QUALITY_DESCRIPTION = 'qualityDescription';
/** @type {?} */
var FAA_AVAILABILITY_ASSESSMENT = 'availabilityAssessment';
/** @type {?} */
var FAA_AVAILABILITY_DESCRIPTION = 'availabilityDescription';
/** @type {?} */
var FAA_CULTIVATION_ASSESSMENT = 'cultivationAssessment';
/** @type {?} */
var FAA_CULTIVATION_DESCRIPTION = 'cultivationDescription';
/** @type {?} */
var FAA_FILES_GROUP_KEY = 'filesGroup';
/** @type {?} */
var FAA_FILE = 'file';
/** @type {?} */
var FIELD_AUDIT_AREA_LAYOUT = (_a$4 = {},
    _a$4[FAA_PESTICIDE_USE_ASSESSMENT] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_PESTICIDE_USE_DESCRIPTION] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_QUALITY_ASSESSMENT] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_QUALITY_DESCRIPTION] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_AVAILABILITY_ASSESSMENT] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_AVAILABILITY_DESCRIPTION] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_CULTIVATION_ASSESSMENT] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_CULTIVATION_DESCRIPTION] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$4[FAA_FILES_GROUP_KEY] = {
        grid: {
            host: 'col-12 col-md-12 m-0',
            label: 'col-12 px-0'
        },
        element: {
            control: 'd-flex align-content-start flex-wrap',
            group: 'mx-1'
        }
    },
    _a$4);
var ɵ0$1 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicFileUploadModel({
            id: FAA_FILE,
            accept: ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/bmp'],
            maxSize: MAX_FILE_SIZE$1
        })
    ];
};
/** @type {?} */
var FIELD_AUDIT_AREA_FORM_MODEL = [
    new DynamicSelectModel({
        id: FAA_PESTICIDE_USE_ASSESSMENT,
        options: getOptionsForDynamicSelectModel(QualityAssessmentType, 'QUALITY_ASSESSMENT_TYPE', false),
        validators: {
            required: null
        }
    }),
    new DynamicSelectModel({
        id: FAA_QUALITY_ASSESSMENT,
        options: getOptionsForDynamicSelectModel(QualityAssessmentType, 'QUALITY_ASSESSMENT_TYPE', false),
        validators: {
            required: null
        }
    }),
    new DynamicTextAreaModel({
        id: FAA_PESTICIDE_USE_DESCRIPTION,
        maxLength: 1000,
        rows: 3,
        validators: {
            maxLength: 1000
        }
    }),
    new DynamicTextAreaModel({
        id: FAA_QUALITY_DESCRIPTION,
        maxLength: 1000,
        rows: 3,
        validators: {
            maxLength: 1000
        }
    }),
    new DynamicSelectModel({
        id: FAA_AVAILABILITY_ASSESSMENT,
        options: getOptionsForDynamicSelectModel(QualityAssessmentType, 'QUALITY_ASSESSMENT_TYPE', false),
        validators: {
            required: null
        }
    }),
    new DynamicSelectModel({
        id: FAA_CULTIVATION_ASSESSMENT,
        options: getOptionsForDynamicSelectModel(QualityAssessmentType, 'QUALITY_ASSESSMENT_TYPE', false),
        validators: {
            required: null
        }
    }),
    new DynamicTextAreaModel({
        id: FAA_AVAILABILITY_DESCRIPTION,
        maxLength: 1000,
        rows: 3,
        validators: {
            maxLength: 1000
        }
    }),
    new DynamicTextAreaModel({
        id: FAA_CULTIVATION_DESCRIPTION,
        maxLength: 1000,
        rows: 3,
        validators: {
            maxLength: 1000
        }
    }),
    new DynamicFormArrayModel({
        id: FAA_FILES_GROUP_KEY,
        initialCount: 5,
        groupFactory: (ɵ0$1)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FieldAuditArea = /** @class */ (function () {
    function FieldAuditArea(areaName, crop, areaInHa, locations, parcelId, fieldCardId, pesticideUseAssessment, pesticideUseDescription, qualityAssessment, qualityDescription, availabilityAssessment, availabilityDescription, cultivationAssessment, cultivationDescription, files, organizationId, auditDate) {
        this.areaName = areaName;
        this.crop = crop;
        this.areaInHa = areaInHa;
        this.locations = locations;
        this.parcelId = parcelId;
        this.fieldCardId = fieldCardId;
        this.pesticideUseAssessment = pesticideUseAssessment;
        this.pesticideUseDescription = pesticideUseDescription;
        this.qualityAssessment = qualityAssessment;
        this.qualityDescription = qualityDescription;
        this.availabilityAssessment = availabilityAssessment;
        this.availabilityDescription = availabilityDescription;
        this.cultivationAssessment = cultivationAssessment;
        this.cultivationDescription = cultivationDescription;
        this.files = files;
        this.organizationId = organizationId;
        this.auditDate = auditDate;
    }
    return FieldAuditArea;
}());
if (false) {
    /** @type {?} */
    FieldAuditArea.prototype.areaName;
    /** @type {?} */
    FieldAuditArea.prototype.crop;
    /** @type {?} */
    FieldAuditArea.prototype.areaInHa;
    /** @type {?} */
    FieldAuditArea.prototype.locations;
    /** @type {?} */
    FieldAuditArea.prototype.parcelId;
    /** @type {?} */
    FieldAuditArea.prototype.fieldCardId;
    /** @type {?} */
    FieldAuditArea.prototype.pesticideUseAssessment;
    /** @type {?} */
    FieldAuditArea.prototype.pesticideUseDescription;
    /** @type {?} */
    FieldAuditArea.prototype.qualityAssessment;
    /** @type {?} */
    FieldAuditArea.prototype.qualityDescription;
    /** @type {?} */
    FieldAuditArea.prototype.availabilityAssessment;
    /** @type {?} */
    FieldAuditArea.prototype.availabilityDescription;
    /** @type {?} */
    FieldAuditArea.prototype.cultivationAssessment;
    /** @type {?} */
    FieldAuditArea.prototype.cultivationDescription;
    /** @type {?} */
    FieldAuditArea.prototype.files;
    /** @type {?} */
    FieldAuditArea.prototype.organizationId;
    /** @type {?} */
    FieldAuditArea.prototype.auditDate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FieldAuditAreaFormService = /** @class */ (function () {
    function FieldAuditAreaFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} formGroup
     * @param {?} fieldAuditArea
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getFormValue = /**
     * @param {?} formGroup
     * @param {?} fieldAuditArea
     * @return {?}
     */
    function (formGroup, fieldAuditArea) {
        /** @type {?} */
        var pesticideUseAssessment = this.getPesticideUseAssessmentControl(formGroup).value;
        /** @type {?} */
        var pesticideUseDescription = this.getPesticideUseDescriptionControl(formGroup).value;
        /** @type {?} */
        var qualityAssessment = this.getQualityAssessmentControl(formGroup).value;
        /** @type {?} */
        var qualityDescription = this.getQualityDescriptionControl(formGroup).value;
        /** @type {?} */
        var availabilityAssessment = this.getAvailabilityAssessmentControl(formGroup).value;
        /** @type {?} */
        var availabilityDescription = this.getAvailabilityDescriptionControl(formGroup).value;
        /** @type {?} */
        var cultivationAssessment = this.getCultivationAssessmentChangeControl(formGroup).value;
        /** @type {?} */
        var cultivationDescription = this.getCultivationDescriptionControl(formGroup).value;
        /** @type {?} */
        var files = this.getFilesControl(formGroup).value;
        return new FieldAuditArea(fieldAuditArea != null ? fieldAuditArea.areaName : null, fieldAuditArea != null ? fieldAuditArea.crop : null, fieldAuditArea != null ? fieldAuditArea.areaInHa : null, fieldAuditArea != null ? fieldAuditArea.locations : null, fieldAuditArea != null ? fieldAuditArea.parcelId : null, fieldAuditArea != null ? fieldAuditArea.fieldCardId : null, pesticideUseAssessment, pesticideUseDescription, qualityAssessment, qualityDescription, availabilityAssessment, availabilityDescription, cultivationAssessment, cultivationDescription, (files || []).filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x[FAA_FILE] != null; })).map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x[FAA_FILE]; })), fieldAuditArea != null ? fieldAuditArea.organizationId : null, fieldAuditArea != null ? fieldAuditArea.auditDate : null);
    };
    /**
     * @param {?} formGroup
     * @param {?} fieldAuditArea
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.updateFormValue = /**
     * @param {?} formGroup
     * @param {?} fieldAuditArea
     * @return {?}
     */
    function (formGroup, fieldAuditArea) {
        this.getPesticideUseAssessmentControl(formGroup)
            .patchValue(fieldAuditArea != null && fieldAuditArea.pesticideUseAssessment != null
            ? fieldAuditArea.pesticideUseAssessment : QualityAssessmentType.Incorrect);
        this.getPesticideUseDescriptionControl(formGroup)
            .patchValue(fieldAuditArea != null ? fieldAuditArea.pesticideUseDescription : null);
        this.getQualityAssessmentControl(formGroup)
            .patchValue(fieldAuditArea != null && fieldAuditArea.qualityAssessment != null
            ? fieldAuditArea.qualityAssessment : QualityAssessmentType.Incorrect);
        this.getQualityDescriptionControl(formGroup)
            .patchValue(fieldAuditArea != null ? fieldAuditArea.qualityDescription : null);
        this.getAvailabilityAssessmentControl(formGroup)
            .patchValue(fieldAuditArea != null && fieldAuditArea.availabilityAssessment != null
            ? fieldAuditArea.availabilityAssessment : QualityAssessmentType.Incorrect);
        this.getAvailabilityDescriptionControl(formGroup)
            .patchValue(fieldAuditArea != null ? fieldAuditArea.availabilityDescription : null);
        this.getCultivationAssessmentChangeControl(formGroup)
            .patchValue(fieldAuditArea != null && fieldAuditArea.cultivationAssessment != null
            ? fieldAuditArea.cultivationAssessment : QualityAssessmentType.Incorrect);
        this.getCultivationDescriptionControl(formGroup)
            .patchValue(fieldAuditArea != null ? fieldAuditArea.cultivationDescription : null);
        /** @type {?} */
        var filesValue = fieldAuditArea != null ? (fieldAuditArea.files || []).map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            var _a;
            return (_a = {}, _a[FAA_FILE] = x, _a);
        })) : [];
        this.getFilesControl(formGroup)
            .patchValue(filesValue);
    };
    /**
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeOnChanges = /**
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.subscribeToPesticideUseAssessmentChanges(formGroup, onChange);
        this.subscribeToPesticideUseDescriptionChanges(formGroup, onChange);
        this.subscribeToQualityAssessmentChanges(formGroup, onChange);
        this.subscribeToQualityDescriptionChanges(formGroup, onChange);
        this.subscribeToAvailabilityAssessmentChanges(formGroup, onChange);
        this.subscribeToAvailabilityDescriptionChanges(formGroup, onChange);
        this.subscribeToCultivationAssessmentChanges(formGroup, onChange);
        this.subscribeToCultivationDescriptionChanges(formGroup, onChange);
        this.subscribeToFilesChanges(formGroup, onChange);
    };
    /**
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.unsubscribeChanges = /**
     * @return {?}
     */
    function () {
        this.pesticideUseAssessmentChangesSubscription.unsubscribe();
        this.pesticideUseDescriptionChangesSubscription.unsubscribe();
        this.qualityAssessmentChangesSubscription.unsubscribe();
        this.qualityDescriptionChangesSubscription.unsubscribe();
        this.availabilityAssessmentChangesSubscription.unsubscribe();
        this.availabilityDescriptionChangesSubscription.unsubscribe();
        this.cultivationAssessmentChangesSubscription.unsubscribe();
        this.cultivationDescriptionChangesSubscription.unsubscribe();
        this.filesChangesSubscription.unsubscribe();
    };
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToPesticideUseAssessmentChanges = 
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.pesticideUseAssessmentChangesSubscription =
            this.getPesticideUseAssessmentControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} pesticideUseAssessment
             * @return {?}
             */
            function (pesticideUseAssessment) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToPesticideUseDescriptionChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.pesticideUseDescriptionChangesSubscription =
            this.getPesticideUseDescriptionControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} pesticideUseDescription
             * @return {?}
             */
            function (pesticideUseDescription) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToQualityAssessmentChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.qualityAssessmentChangesSubscription =
            this.getQualityAssessmentControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} qualityChangesAssessment
             * @return {?}
             */
            function (qualityChangesAssessment) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToQualityDescriptionChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.qualityDescriptionChangesSubscription =
            this.getQualityDescriptionControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} qualityChangesDescription
             * @return {?}
             */
            function (qualityChangesDescription) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToAvailabilityAssessmentChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.availabilityAssessmentChangesSubscription =
            this.getAvailabilityAssessmentControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} availabilityChangesAssessment
             * @return {?}
             */
            function (availabilityChangesAssessment) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToAvailabilityDescriptionChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.availabilityDescriptionChangesSubscription =
            this.getAvailabilityDescriptionControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} availabilityChangesDescription
             * @return {?}
             */
            function (availabilityChangesDescription) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToCultivationAssessmentChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.cultivationAssessmentChangesSubscription =
            this.getCultivationAssessmentChangeControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} cultivationChangesAssessment
             * @return {?}
             */
            function (cultivationChangesAssessment) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToCultivationDescriptionChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.cultivationDescriptionChangesSubscription =
            this.getCultivationDescriptionControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} cultivationChangesDescription
             * @return {?}
             */
            function (cultivationChangesDescription) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.subscribeToFilesChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.filesChangesSubscription =
            this.getFilesControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} commissionedAuditsChanges
             * @return {?}
             */
            function (commissionedAuditsChanges) { return onChange(); }));
    };
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getPesticideUseAssessmentControl = 
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_PESTICIDE_USE_ASSESSMENT);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getPesticideUseDescriptionControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_PESTICIDE_USE_DESCRIPTION);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getQualityAssessmentControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_QUALITY_ASSESSMENT);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getQualityDescriptionControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_QUALITY_DESCRIPTION);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getAvailabilityAssessmentControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_AVAILABILITY_ASSESSMENT);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getAvailabilityDescriptionControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_AVAILABILITY_DESCRIPTION);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getCultivationAssessmentChangeControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_CULTIVATION_ASSESSMENT);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getCultivationDescriptionControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_CULTIVATION_DESCRIPTION);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    FieldAuditAreaFormService.prototype.getFilesControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(FAA_FILES_GROUP_KEY);
    };
    FieldAuditAreaFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FieldAuditAreaFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return FieldAuditAreaFormService;
}());
if (false) {
    /** @type {?} */
    FieldAuditAreaFormService.prototype.formModelSubject;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.pesticideUseAssessmentChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.pesticideUseDescriptionChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.qualityAssessmentChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.qualityDescriptionChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.availabilityAssessmentChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.availabilityDescriptionChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.cultivationAssessmentChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.cultivationDescriptionChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.filesChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FieldAuditAreaFormComponent = /** @class */ (function () {
    function FieldAuditAreaFormComponent(fieldAuditAreaFormService) {
        var _this = this;
        this.fieldAuditAreaFormService = fieldAuditAreaFormService;
        this.fieldAuditAreaChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.onFieldAuditAreaChange = (/**
         * @return {?}
         */
        function () {
            _this.fieldAuditAreaData = _this.getFormValue();
            _this.fieldAuditAreaChange.emit(_this.fieldAuditAreaData);
        });
        this.formLayout = FIELD_AUDIT_AREA_LAYOUT;
        this.fieldAuditAreaFormService.formModelSubject.next(FIELD_AUDIT_AREA_FORM_MODEL);
        this.formGroup = this.fieldAuditAreaFormService.createFormGroup(FIELD_AUDIT_AREA_FORM_MODEL);
    }
    Object.defineProperty(FieldAuditAreaFormComponent.prototype, "fieldAuditArea", {
        get: /**
         * @return {?}
         */
        function () {
            return this.fieldAuditAreaData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.fieldAuditAreaData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.fieldAuditAreaData = value;
            }
            else {
                this.fieldAuditAreaData = new FieldAuditArea(null, // areaName: string,
                null, // crop: string,
                0, // areaInHa: number
                [], // locations
                null, // parcelId: string,
                null, QualityAssessmentType.Incorrect, // pesticideUseAssessment: QualityAssessmentType,
                null, //  pesticideUseDescription: string,
                QualityAssessmentType.Incorrect, // qualityAssessment: QualityAssessmentType,
                null, // qualityDescription: string,
                QualityAssessmentType.Incorrect, // availabilityAssessment: QualityAssessmentType,
                null, // availabilityDescription: string,
                QualityAssessmentType.Incorrect, // cultivationAssessment: QualityAssessmentType,
                null, // cultivationDescription: string,
                [], // files
                null, // organizationId: string,
                null);
                this.updateFormValue(this.fieldAuditAreaData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldAuditAreaFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FieldAuditAreaFormComponent.prototype, "isDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.disable();
            }
            else {
                this.formGroup.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    FieldAuditAreaFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.fieldAuditAreaFormService.getFormModel$(this.translateKey);
        this.fieldAuditAreaFormService.subscribeOnChanges(this.formGroup, this.onFieldAuditAreaChange);
    };
    /**
     * @return {?}
     */
    FieldAuditAreaFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.fieldAuditAreaFormService.unsubscribeChanges();
    };
    /**
     * @private
     * @param {?} fieldAuditArea
     * @return {?}
     */
    FieldAuditAreaFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} fieldAuditArea
     * @return {?}
     */
    function (fieldAuditArea) {
        this.fieldAuditAreaFormService.updateFormValue(this.formGroup, fieldAuditArea);
    };
    /**
     * @private
     * @return {?}
     */
    FieldAuditAreaFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        return this.fieldAuditAreaFormService.getFormValue(this.formGroup, this.fieldAuditArea);
    };
    FieldAuditAreaFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-field-audit-area-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n\r\n    <label class=\"px-0\">\r\n        <h5 class=\"m-0\">\r\n            <i class=\"ft ft-target\"></i> <span *ngIf=\"fieldAuditArea\">{{fieldAuditArea.crop | dictionaryTranslateKey |\r\n                translate}} - {{fieldAuditArea.areaName}}</span>\r\n        </h5>\r\n    </label>\r\n    <hr class=\"mt-0\">\r\n\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row fieldAuditAreaFormRow\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        FieldAuditAreaFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    FieldAuditAreaFormComponent.ctorParameters = function () { return [
        { type: FieldAuditAreaFormService }
    ]; };
    FieldAuditAreaFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        fieldAuditArea: [{ type: Input }],
        touched: [{ type: Input }],
        isDisabled: [{ type: Input }],
        fieldAuditAreaChange: [{ type: Output }]
    };
    return FieldAuditAreaFormComponent;
}());
if (false) {
    /** @type {?} */
    FieldAuditAreaFormComponent.prototype.translateKey;
    /** @type {?} */
    FieldAuditAreaFormComponent.prototype.fieldAuditAreaChange;
    /** @type {?} */
    FieldAuditAreaFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    FieldAuditAreaFormComponent.prototype.formLayout;
    /** @type {?} */
    FieldAuditAreaFormComponent.prototype.formModel$;
    /** @type {?} */
    FieldAuditAreaFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormComponent.prototype.fieldAuditAreaData;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormComponent.prototype.onFieldAuditAreaChange;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormComponent.prototype.fieldAuditAreaFormService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FieldAuditAreaFormControlComponent = /** @class */ (function () {
    function FieldAuditAreaFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(FieldAuditAreaFormControlComponent.prototype, "fieldAuditArea", {
        get: /**
         * @return {?}
         */
        function () {
            return this._fieldAuditArea;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._fieldAuditArea = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    FieldAuditAreaFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._fieldAuditArea = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FieldAuditAreaFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FieldAuditAreaFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    FieldAuditAreaFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    FieldAuditAreaFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-field-audit-area-form-control',
                    template: "<app-field-audit-area-form\r\n    [(fieldAuditArea)]=\"fieldAuditArea\"\r\n    [translateKey]=\"translateKey\"\r\n    [touched]=\"touched\"\r\n    [isDisabled]=\"isDisabled\">\r\n</app-field-audit-area-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return FieldAuditAreaFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    FieldAuditAreaFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        fieldAuditArea: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return FieldAuditAreaFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormControlComponent.prototype._fieldAuditArea;
    /** @type {?} */
    FieldAuditAreaFormControlComponent.prototype.translateKey;
    /** @type {?} */
    FieldAuditAreaFormControlComponent.prototype.touched;
    /** @type {?} */
    FieldAuditAreaFormControlComponent.prototype.blur;
    /** @type {?} */
    FieldAuditAreaFormControlComponent.prototype.change;
    /** @type {?} */
    FieldAuditAreaFormControlComponent.prototype.focus;
    /** @type {?} */
    FieldAuditAreaFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    FieldAuditAreaFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function NumericCondition() { }
if (false) {
    /** @type {?} */
    NumericCondition.prototype.comparison;
    /** @type {?} */
    NumericCondition.prototype.value;
}
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_NUMERIC_CONDITION = 'NUMERIC_CONDITION';
/**
 * @record
 * @template T
 */
function DynamicNumericConditionModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicNumericConditionModelConfig.prototype.accept;
    /** @type {?|undefined} */
    DynamicNumericConditionModelConfig.prototype.inputType;
    /** @type {?|undefined} */
    DynamicNumericConditionModelConfig.prototype.max;
    /** @type {?|undefined} */
    DynamicNumericConditionModelConfig.prototype.min;
    /** @type {?|undefined} */
    DynamicNumericConditionModelConfig.prototype.step;
}
/**
 * @template T
 */
var DynamicNumericConditionModel = /** @class */ (function (_super) {
    __extends(DynamicNumericConditionModel, _super);
    function DynamicNumericConditionModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_NUMERIC_CONDITION;
        _this.accept = config.accept || null;
        _this.inputType = config.inputType || DYNAMIC_FORM_CONTROL_INPUT_TYPE_TEXT;
        _this.max = config.max !== undefined ? config.max : null;
        _this.min = config.min !== undefined ? config.min : null;
        _this.step = isNumber(config.step) ? config.step : null;
        return _this;
    }
    /**
     * @param {...?} indices
     * @return {?}
     */
    DynamicNumericConditionModel.prototype.select = /**
     * @param {...?} indices
     * @return {?}
     */
    function () {
        var _this = this;
        var indices = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            indices[_i] = arguments[_i];
        }
        /** @type {?} */
        var value = this.multiple ? indices.map((/**
         * @param {?} index
         * @return {?}
         */
        function (index) { return _this.get(index).value; })) : this.get(indices[0]).value;
        this.valueUpdates.next(value);
    };
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicNumericConditionModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicNumericConditionModel.prototype, "accept", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicNumericConditionModel.prototype, "inputType", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicNumericConditionModel.prototype, "max", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicNumericConditionModel.prototype, "min", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicNumericConditionModel.prototype, "step", void 0);
    return DynamicNumericConditionModel;
}(DynamicSelectModel));
if (false) {
    /** @type {?} */
    DynamicNumericConditionModel.prototype.type;
    /** @type {?} */
    DynamicNumericConditionModel.prototype.accept;
    /** @type {?} */
    DynamicNumericConditionModel.prototype.inputType;
    /** @type {?} */
    DynamicNumericConditionModel.prototype.max;
    /** @type {?} */
    DynamicNumericConditionModel.prototype.min;
    /** @type {?} */
    DynamicNumericConditionModel.prototype.step;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NumericConditionControlComponent = /** @class */ (function () {
    function NumericConditionControlComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.subscriptions = [];
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} $event
     * @return {?}
     */
    NumericConditionControlComponent.prototype.onFocus = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if ($event instanceof Event) {
            $event.stopPropagation();
        }
        this.focus.emit($event);
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} $event
     * @return {?}
     */
    NumericConditionControlComponent.prototype.onBlur = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if ($event instanceof Event) {
            $event.stopPropagation();
        }
        this.blur.emit($event);
    };
    Object.defineProperty(NumericConditionControlComponent.prototype, "value", {
        // tslint:disable-next-line: no-any
        get: 
        // tslint:disable-next-line: no-any
        /**
         * @return {?}
         */
        function () {
            return this.form.value;
        },
        // tslint:disable-next-line: no-any
        set: 
        // tslint:disable-next-line: no-any
        /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.form.setValue(value);
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NumericConditionControlComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.form = this.formBuilder.group({
            comparison: [],
            value: []
        });
        this.subscriptions.push(this.form.valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.onChange(value);
            _this.onTouched();
        })));
    };
    /**
     * @return {?}
     */
    NumericConditionControlComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s.unsubscribe(); }));
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    NumericConditionControlComponent.prototype.registerOnChange = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @return {?}
     */
    NumericConditionControlComponent.prototype.writeValue = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value) {
            this.value = value;
        }
        if (value === null) {
            this.form.reset();
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumericConditionControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} _
     * @return {?}
     */
    NumericConditionControlComponent.prototype.validate = /**
     * @param {?} _
     * @return {?}
     */
    function (_) {
        return this.form.valid ? null : { profile: { valid: false, }, };
    };
    NumericConditionControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-numeric-condition-control',
                    template: "<div [formGroup]=\"form\" class=\"form-inline\" [class.input-group]=\"model.prefix || model.suffix\">\r\n        <div *ngIf=\"model.prefix\" class=\"input-group-addon\" [innerHTML]=\"model.prefix\"></div>\r\n        <div class=\"form-group\">\r\n            <select\r\n                class=\"form-control\"\r\n                [compareWith]=\"model.compareWithFn\"\r\n                formControlName=\"comparison\"\r\n                [name]=\"model.name + '_select'\"\r\n                (blur)=\"onBlur($event)\"\r\n                (focus)=\"onFocus($event)\"\r\n            >\r\n                <option *ngFor=\"let option of model.options$ | async\" [disabled]=\"option.disabled\" [ngValue]=\"option.value\"\r\n                    >{{ option.label }}\r\n                </option>\r\n            </select>\r\n        </div>\r\n        <div class=\"form-group mx-sm-3\">\r\n            <input\r\n                class=\"form-control\"\r\n                [attr.accept]=\"model.accept\"\r\n                [attr.max]=\"model.max\"\r\n                [attr.min]=\"model.min\"\r\n                [attr.step]=\"model.step\"\r\n                formControlName=\"value\"\r\n                [name]=\"model.name + '_input'\"\r\n                [placeholder]=\"model.placeholder\"\r\n                [required]=\"model.required\"\r\n                [tabindex]=\"model.tabIndex\"\r\n                [type]=\"model.inputType\"\r\n                (blur)=\"onBlur($event)\"\r\n                (focus)=\"onFocus($event)\"\r\n            />\r\n        </div>\r\n</div>\r\n",
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return NumericConditionControlComponent; })),
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return NumericConditionControlComponent; })),
                            multi: true,
                        }
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NumericConditionControlComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    NumericConditionControlComponent.propDecorators = {
        model: [{ type: Input }],
        blur: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return NumericConditionControlComponent;
}());
if (false) {
    /** @type {?} */
    NumericConditionControlComponent.prototype.form;
    /** @type {?} */
    NumericConditionControlComponent.prototype.subscriptions;
    /** @type {?} */
    NumericConditionControlComponent.prototype.model;
    /** @type {?} */
    NumericConditionControlComponent.prototype.blur;
    /** @type {?} */
    NumericConditionControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    NumericConditionControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    NumericConditionControlComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    NumericConditionControlComponent.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicNumericConditionControlComponent = /** @class */ (function (_super) {
    __extends(DynamicNumericConditionControlComponent, _super);
    function DynamicNumericConditionControlComponent(layoutService, validationService, changeDetectorRef) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        _this.changeDetectorRef = changeDetectorRef;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    DynamicNumericConditionControlComponent.prototype.add = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _a;
        this.group.patchValue((_a = {},
            _a[this.model.id] = {
                comparison: null,
                value: null
            },
            _a));
        this.change.emit({
            comparison: null,
            value: null
        });
        $event.preventDefault();
        $event.stopPropagation();
        this.changeDetectorRef.markForCheck();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    DynamicNumericConditionControlComponent.prototype.remove = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _a;
        this.group.patchValue((_a = {},
            _a[this.model.id] = undefined,
            _a));
        // tslint:disable-next-line: no-undefined-argument
        this.change.emit(undefined);
        $event.preventDefault();
        $event.stopPropagation();
        this.changeDetectorRef.markForCheck();
    };
    DynamicNumericConditionControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-numeric-condition-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n    <div *ngIf=\"group.value[model.id] != null; else empty\">\r\n            <div class=\"d-flex flex-row align-items-baseline\">\r\n                    <lib-numeric-condition-control [formControlName]=\"model.id\"\r\n                    [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n                    [model]=\"model\"\r\n                    (blur)=\"onBlur($event)\"\r\n                    (change)=\"onChange($event)\"\r\n                    (focus)=\"onFocus($event)\"></lib-numeric-condition-control>\r\n                    <button class=\"my-0 btn btn-warning mr-1 btn-fab btn-sm d-disabled-none\" (click)=\"remove($event)\"><i class=\"ft-minus-circle\"></i> {{ 'APPLICATION.FORM.disable' | translate }}</button>\r\n                </div>\r\n    </div>\r\n    <ng-template #empty>\r\n            <button class=\"btn btn-primary mr-1 btn-fab btn-sm\" (click)=\"add($event)\"><i class=\"ft-plus-circle\"></i> {{ 'APPLICATION.FORM.enable' | translate }}</button>\r\n    </ng-template>\r\n</ng-container>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DynamicNumericConditionControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService },
        { type: ChangeDetectorRef }
    ]; };
    DynamicNumericConditionControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicNumericConditionControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicNumericConditionControlComponent.prototype.group;
    /** @type {?} */
    DynamicNumericConditionControlComponent.prototype.layout;
    /** @type {?} */
    DynamicNumericConditionControlComponent.prototype.model;
    /** @type {?} */
    DynamicNumericConditionControlComponent.prototype.blur;
    /** @type {?} */
    DynamicNumericConditionControlComponent.prototype.change;
    /** @type {?} */
    DynamicNumericConditionControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicNumericConditionControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicNumericConditionControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicNumericConditionControlComponent.prototype.validationService;
    /**
     * @type {?}
     * @private
     */
    DynamicNumericConditionControlComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMultiSelectFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMultiSelectFormControlComponent, _super);
    function DynamicMultiSelectFormControlComponent(layoutService, validationService, translateService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.translateService = translateService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        _this.customSearchFn = (/**
         * @param {?} term
         * @param {?} item
         * @return {?}
         */
        function (term, item) {
            term = term.toLowerCase();
            /** @type {?} */
            var value = item[_this.model.searchByField];
            /** @type {?} */
            var selectValue = _this.model.translationPrefix
                ? _this.translateService.instant(_this.model.translationPrefix + "." + value)
                : value;
            return selectValue.toLowerCase().indexOf(term) > -1;
        });
        _this.addTagFn = (/**
         * @param {?} $event
         * @return {?}
         */
        function ($event) {
            /** @type {?} */
            var tag = { tag: true };
            tag[_this.model.bindLabel] = $event;
            return tag;
        });
        return _this;
    }
    DynamicMultiSelectFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-multi-select-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n    <ng-select\r\n        [id]=\"elementId\"\r\n        [class.is-invalid]=\"showErrorMessages\"\r\n        formControlName=\"{{model.id}}\"\r\n        [items]=\"model.items\"\r\n        [addTag]=\"model.addTag ? addTagFn : null\"\r\n        [addTagText]=\"'APPLICATION.FORM.multiSelect:addTagText' | translate\"\r\n        [bindLabel]=\"model.bindLabel\"\r\n        [groupBy]=\"model.groupBy\"\r\n        [multiple]=\"model.multiple\"\r\n        [clearable]=\"model.multiple\"\r\n        [placeholder]=\"model.placeholder\"\r\n        [readonly]=\"model.readonly\"\r\n        [notFoundText]=\"'APPLICATION.FORM.multiSelect:notFoundText' | translate\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\"\r\n        [searchFn]=\"model.searchByField != null ? customSearchFn : null\">\r\n\r\n        <ng-template ng-label-tmp let-item=\"item\" *ngIf=\"model.translationPrefix == null\">\r\n            <span *ngIf=\"model.useTranslate\">{{ item[model.bindLabel] | translate }}</span>\r\n            <span *ngIf=\"model.useTranslate == false\">{{ item[model.bindLabel] }}</span>\r\n        </ng-template>\r\n\r\n        <ng-template ng-optgroup-tmp let-item=\"item\" let-index=\"index\" *ngIf=\"model.translationPrefix == null\">\r\n            <span *ngIf=\"model.useTranslate\">{{ item[model.groupBy] | translate }}</span>\r\n            <span *ngIf=\"model.useTranslate == false\">{{ item[model.groupBy] }}</span>\r\n        </ng-template>\r\n\r\n        <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"searchTerm\" *ngIf=\"model.translationPrefix == null\">\r\n            <span *ngIf=\"model.useTranslate\">{{ item[model.bindLabel] | translate }}</span>\r\n            <span *ngIf=\"model.useTranslate == false\">{{ item[model.bindLabel] }}</span>\r\n        </ng-template>\r\n\r\n        <ng-template ng-label-tmp let-item=\"item\" *ngIf=\"model.translationPrefix != null\">\r\n            {{ model.translationPrefix + '.' + item[model.bindLabel] | translate }}\r\n        </ng-template>\r\n\r\n        <ng-template ng-optgroup-tmp let-item=\"item\" let-index=\"index\" *ngIf=\"model.translationPrefix != null\">\r\n            {{ model.translationPrefix + '.' + item[model.groupBy] | translate }}\r\n        </ng-template>\r\n\r\n        <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"searchTerm\" *ngIf=\"model.translationPrefix != null\">\r\n            {{ model.translationPrefix + '.' + item[model.bindLabel] | translate }}\r\n        </ng-template>\r\n   </ng-select>\r\n</ng-container>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DynamicMultiSelectFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService },
        { type: TranslateService }
    ]; };
    DynamicMultiSelectFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMultiSelectFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.focus;
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.customSearchFn;
    /** @type {?} */
    DynamicMultiSelectFormControlComponent.prototype.addTagFn;
    /**
     * @type {?}
     * @private
     */
    DynamicMultiSelectFormControlComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_PERIOD = 'PERIOD';
/**
 * @record
 */
function DynamicPeriodFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicPeriodFormControlModelConfig.prototype.translateKey;
}
var DynamicPeriodFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicPeriodFormControlModel, _super);
    function DynamicPeriodFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_PERIOD;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicPeriodFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicPeriodFormControlModel.prototype, "translateKey", void 0);
    return DynamicPeriodFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicPeriodFormControlModel.prototype.type;
    /** @type {?} */
    DynamicPeriodFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicPeriodFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicPeriodFormControlComponent, _super);
    function DynamicPeriodFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicPeriodFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-period-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-period-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-period-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicPeriodFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicPeriodFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicPeriodFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicPeriodFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicPeriodFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicPeriodFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicPeriodFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicPeriodFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicPeriodFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicPeriodFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicPeriodFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicPeriodFormControlComponent.prototype.validationService;
}

var _a$5;
/** @type {?} */
var FORM_LAYOUT_INPUT$2 = {
    grid: {
        host: 'period-host',
        container: 'period-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var PERIOD_START_MONTH = 'startMonth';
/** @type {?} */
var PERIOD_START_DAY = 'startDay';
/** @type {?} */
var PERIOD_END_MONTH = 'endMonth';
/** @type {?} */
var PERIOD_END_DAY = 'endDay';
/** @type {?} */
var PERIOD_LAYOUT = (_a$5 = {},
    _a$5[PERIOD_START_MONTH] = FORM_LAYOUT_INPUT$2,
    _a$5[PERIOD_START_DAY] = FORM_LAYOUT_INPUT$2,
    _a$5[PERIOD_END_MONTH] = FORM_LAYOUT_INPUT$2,
    _a$5[PERIOD_END_DAY] = FORM_LAYOUT_INPUT$2,
    _a$5);
/** @type {?} */
var PERIOD_FORM_MODEL = [
    new DynamicSelectModel({
        id: 'startMonth',
        options: getOptionsForDynamicSelectModel(Month, 'MONTH', true),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'startDay',
        min: 1,
        max: 31,
        step: 1,
        inputType: 'number',
        validators: {
            required: null,
            min: 1,
            max: 31
        }
    }),
    new DynamicSelectModel({
        id: 'endMonth',
        options: getOptionsForDynamicSelectModel(Month, 'MONTH', true),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'endDay',
        min: 1,
        max: 31,
        step: 1,
        inputType: 'number',
        validators: {
            required: null,
            min: 1,
            max: 31
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeriodFormService = /** @class */ (function () {
    function PeriodFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    PeriodFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    PeriodFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getStartMonthControl = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PERIOD_START_MONTH);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getStartDayControl = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PERIOD_START_DAY);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getEndMonthControl = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PERIOD_END_MONTH);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getEndDayControl = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PERIOD_END_DAY);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getStartMonthValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return this.getStartMonthControl(formGroup).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getStartDayValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return this.getStartDayControl(formGroup).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getEndMonthValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return this.getEndMonthControl(formGroup).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormService.prototype.getEndDayValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return this.getEndDayControl(formGroup).valueChanges;
    };
    PeriodFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PeriodFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return PeriodFormService;
}());
if (false) {
    /** @type {?} */
    PeriodFormService.prototype.formModelSubject;
    /** @type {?} */
    PeriodFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    PeriodFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    PeriodFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    PeriodFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Period = /** @class */ (function () {
    function Period(startMonth, startDay, endMonth, endDay) {
        this.startMonth = startMonth;
        this.startDay = startDay;
        this.endMonth = endMonth;
        this.endDay = endDay;
    }
    return Period;
}());
if (false) {
    /** @type {?} */
    Period.prototype.startMonth;
    /** @type {?} */
    Period.prototype.startDay;
    /** @type {?} */
    Period.prototype.endMonth;
    /** @type {?} */
    Period.prototype.endDay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeriodFormComponent = /** @class */ (function () {
    function PeriodFormComponent(periodFormService, dateUtilService) {
        this.periodFormService = periodFormService;
        this.dateUtilService = dateUtilService;
        this.periodChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = PERIOD_LAYOUT;
        this.periodFormService.formModelSubject.next(PERIOD_FORM_MODEL);
        this.formGroup = this.periodFormService.createFormGroup(PERIOD_FORM_MODEL);
    }
    Object.defineProperty(PeriodFormComponent.prototype, "period", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.periodData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.periodData = value;
            }
            else {
                this.periodData = new Period(null, null, null, null);
                this.updateFormValue(this.periodData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    PeriodFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.periodFormService.getFormModel$(this.translateKey);
        this.subscribeToStartMonthModelValueChanges(this.formGroup);
        this.subscribeToStartDayModelValueChanges(this.formGroup);
        this.subscribeToEndMonthModelValueChanges(this.formGroup);
        this.subscribeToEndDayModelValueChanges(this.formGroup);
    };
    /**
     * @return {?}
     */
    PeriodFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.startMonthSubscription.unsubscribe();
        this.startDaySubscription.unsubscribe();
        this.endMonthSubscription.unsubscribe();
        this.endDaySubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} period
     * @return {?}
     */
    PeriodFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} period
     * @return {?}
     */
    function (period) {
        this.startMonthControl.patchValue(period.startMonth == null ? '' : this.dateUtilService.getMonth(period.startMonth));
        this.startDayControl.patchValue(period.startDay);
        this.endMonthControl.patchValue(period.endMonth == null ? '' : this.dateUtilService.getMonth(period.endMonth));
        this.endDayControl.patchValue(period.endDay);
        this.formGroup.updateValueAndValidity();
    };
    /**
     * @private
     * @return {?}
     */
    PeriodFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var startMonth = this.dateUtilService.getMonthIndex(this.startMonthControl.value);
        /** @type {?} */
        var startDay = +this.startDayControl.value;
        /** @type {?} */
        var endMonth = this.dateUtilService.getMonthIndex(this.endMonthControl.value);
        /** @type {?} */
        var endDay = +this.endDayControl.value;
        return new Period(startMonth, startDay, endMonth, endDay);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormComponent.prototype.subscribeToStartMonthModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.startMonthSubscription = this.periodFormService
            .getStartMonthValue$(formGroup)
            .subscribe((/**
         * @param {?} startMonth
         * @return {?}
         */
        function (startMonth) {
            _this.updateStartDayIfInvalid();
            _this.onPeriodChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormComponent.prototype.subscribeToStartDayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.startDaySubscription = this.periodFormService
            .getStartDayValue$(formGroup)
            .subscribe((/**
         * @param {?} startDay
         * @return {?}
         */
        function (startDay) {
            _this.updateStartDayIfInvalid();
            _this.onPeriodChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormComponent.prototype.subscribeToEndMonthModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.endMonthSubscription = this.periodFormService
            .getEndMonthValue$(formGroup)
            .subscribe((/**
         * @param {?} endMonth
         * @return {?}
         */
        function (endMonth) {
            _this.updateEndDayIfInvalid();
            _this.onPeriodChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    PeriodFormComponent.prototype.subscribeToEndDayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.endDaySubscription = this.periodFormService
            .getEndDayValue$(formGroup)
            .subscribe((/**
         * @param {?} endDay
         * @return {?}
         */
        function (endDay) {
            _this.updateEndDayIfInvalid();
            _this.onPeriodChange();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    PeriodFormComponent.prototype.updateStartDayIfInvalid = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var month = this.startMonthControl.value;
        /** @type {?} */
        var day = this.startDayControl.value;
        if (month != null && day != null) {
            /** @type {?} */
            var maxDays = this.dateUtilService.getMaxDays(month);
            if (+day > maxDays) {
                this.startDayControl.patchValue(maxDays);
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    PeriodFormComponent.prototype.updateEndDayIfInvalid = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var month = this.endMonthControl.value;
        /** @type {?} */
        var day = this.endDayControl.value;
        if (month != null && day != null) {
            /** @type {?} */
            var maxDays = this.dateUtilService.getMaxDays(month);
            if (+day > maxDays) {
                this.endDayControl.patchValue(maxDays);
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    PeriodFormComponent.prototype.onPeriodChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.periodData = this.getFormValue();
        this.periodChange.emit(this.periodData);
    };
    Object.defineProperty(PeriodFormComponent.prototype, "startMonthControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.periodFormService.getStartMonthControl(this.formGroup);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodFormComponent.prototype, "startDayControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.periodFormService.getStartDayControl(this.formGroup);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodFormComponent.prototype, "endMonthControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.periodFormService.getEndMonthControl(this.formGroup);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodFormComponent.prototype, "endDayControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.periodFormService.getEndDayControl(this.formGroup);
        },
        enumerable: true,
        configurable: true
    });
    PeriodFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-period-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        PeriodFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    PeriodFormComponent.ctorParameters = function () { return [
        { type: PeriodFormService },
        { type: DateUtilService }
    ]; };
    PeriodFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        period: [{ type: Input }],
        touched: [{ type: Input }],
        periodChange: [{ type: Output }]
    };
    return PeriodFormComponent;
}());
if (false) {
    /** @type {?} */
    PeriodFormComponent.prototype.translateKey;
    /** @type {?} */
    PeriodFormComponent.prototype.periodChange;
    /** @type {?} */
    PeriodFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    PeriodFormComponent.prototype.formLayout;
    /** @type {?} */
    PeriodFormComponent.prototype.formModel$;
    /** @type {?} */
    PeriodFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    PeriodFormComponent.prototype.periodData;
    /**
     * @type {?}
     * @private
     */
    PeriodFormComponent.prototype.startMonthSubscription;
    /**
     * @type {?}
     * @private
     */
    PeriodFormComponent.prototype.startDaySubscription;
    /**
     * @type {?}
     * @private
     */
    PeriodFormComponent.prototype.endMonthSubscription;
    /**
     * @type {?}
     * @private
     */
    PeriodFormComponent.prototype.endDaySubscription;
    /**
     * @type {?}
     * @private
     */
    PeriodFormComponent.prototype.periodFormService;
    /**
     * @type {?}
     * @private
     */
    PeriodFormComponent.prototype.dateUtilService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeriodFormControlComponent = /** @class */ (function () {
    function PeriodFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(PeriodFormControlComponent.prototype, "period", {
        get: /**
         * @return {?}
         */
        function () {
            return this._period;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._period = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    PeriodFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._period = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PeriodFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PeriodFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    PeriodFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    PeriodFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-period-form-control',
                    template: "<app-period-form\r\n    [(period)]=\"period\"\r\n    [translateKey]=\"translateKey\"\r\n    [touched]=\"touched\">\r\n</app-period-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return PeriodFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    PeriodFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        period: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return PeriodFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PeriodFormControlComponent.prototype._period;
    /** @type {?} */
    PeriodFormControlComponent.prototype.translateKey;
    /** @type {?} */
    PeriodFormControlComponent.prototype.touched;
    /** @type {?} */
    PeriodFormControlComponent.prototype.blur;
    /** @type {?} */
    PeriodFormControlComponent.prototype.change;
    /** @type {?} */
    PeriodFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    PeriodFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    PeriodFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_PERIODS = 'PERIODS';
/**
 * @record
 */
function DynamicPeriodsFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicPeriodsFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicPeriodsFormControlModelConfig.prototype.minCountRequired;
}
var DynamicPeriodsFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicPeriodsFormControlModel, _super);
    function DynamicPeriodsFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_PERIODS;
        _this.translateKey = config.translateKey;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicPeriodsFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicPeriodsFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicPeriodsFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicPeriodsFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicPeriodsFormControlModel.prototype.type;
    /** @type {?} */
    DynamicPeriodsFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicPeriodsFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicPeriodsFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicPeriodsFormControlComponent, _super);
    function DynamicPeriodsFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicPeriodsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-periods-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-periods-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-periods-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicPeriodsFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicPeriodsFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicPeriodsFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicPeriodsFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicPeriodsFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicPeriodsFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicPeriodsFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicPeriodsFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicPeriodsFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicPeriodsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicPeriodsFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicPeriodsFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Periods = /** @class */ (function () {
    function Periods(periods) {
        this.periods = periods;
    }
    return Periods;
}());
if (false) {
    /** @type {?} */
    Periods.prototype.periods;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeriodsFormControlComponent = /** @class */ (function () {
    function PeriodsFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(PeriodsFormControlComponent.prototype, "periods", {
        get: /**
         * @return {?}
         */
        function () {
            return this._periods;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._periods = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    PeriodsFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._periods = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PeriodsFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PeriodsFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    PeriodsFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    PeriodsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-periods-form-control',
                    template: "<app-periods-form\r\n    [(periods)]=\"periods\"\r\n    [translateKey]=\"translateKey\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [touched]=\"touched\">\r\n</app-periods-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return PeriodsFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    PeriodsFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        periods: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return PeriodsFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PeriodsFormControlComponent.prototype._periods;
    /** @type {?} */
    PeriodsFormControlComponent.prototype.translateKey;
    /** @type {?} */
    PeriodsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    PeriodsFormControlComponent.prototype.touched;
    /** @type {?} */
    PeriodsFormControlComponent.prototype.blur;
    /** @type {?} */
    PeriodsFormControlComponent.prototype.change;
    /** @type {?} */
    PeriodsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormControlComponent.prototype.onChange;
}

var _a$6;
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$1 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$1 = {
    grid: {
        host: 'periods-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var PERIODS_ARRAY_MODEL = 'periodsArrayModel';
/** @type {?} */
var PERIODS_PERIOD = 'period';
/** @type {?} */
var PERIODS_LAYOUT = (_a$6 = {},
    _a$6[PERIODS_ARRAY_MODEL] = FORM_LAYOUT_INPUT_ALL$1,
    _a$6[PERIODS_PERIOD] = FORM_LAYOUT_INPUT_ALL_ITEM$1,
    _a$6);
var ɵ0$2 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicPeriodFormControlModel({
            id: PERIODS_PERIOD
        })
    ];
};
/** @type {?} */
var PERIODS_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: PERIODS_ARRAY_MODEL,
        initialCount: 0,
        groupFactory: (ɵ0$2),
        validators: {
            periodArrayValidator: {}
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeriodsFormService = /** @class */ (function () {
    function PeriodsFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    PeriodsFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    PeriodsFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    PeriodsFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    PeriodsFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = PERIODS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} periodModel
             * @return {?}
             */
            function (periodModel) {
                periodModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    PeriodsFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    PeriodsFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    PeriodsFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    PeriodsFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    PeriodsFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    PeriodsFormService.prototype.getPeriodsArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PERIODS_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.period; }));
        })));
    };
    PeriodsFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PeriodsFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return PeriodsFormService;
}());
if (false) {
    /** @type {?} */
    PeriodsFormService.prototype.formModelSubject;
    /** @type {?} */
    PeriodsFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeriodsFormComponent = /** @class */ (function () {
    function PeriodsFormComponent(periodsFormService) {
        var _this = this;
        this.periodsFormService = periodsFormService;
        this.periodsChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getPeriodsFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.periodsFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === PERIODS_ARRAY_MODEL; }))));
        });
        this.getPeriodsArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.periodsFormService
                .findModelById(PERIODS_ARRAY_MODEL, PERIODS_FORM_MODEL);
            return (/** @type {?} */ (_this.periodsFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = PERIODS_LAYOUT;
        this.periodsFormService.formModelSubject.next(PERIODS_FORM_MODEL);
        this.formGroup = this.periodsFormService.createFormGroup(PERIODS_FORM_MODEL);
        this.subscribeToPeriodsArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(PeriodsFormComponent.prototype, "periods", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.periods != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.periodsData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.periodsData = value;
            }
            else {
                this.periodsData = new Periods([]);
                this.updateFormValue(this.periodsData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodsFormComponent.prototype, "touched", {
        get: /**
         * @return {?}
         */
        function () { return this._touched; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    PeriodsFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.periodsFormService.getFormModel$(this.translateKey);
        this.updateFormValue(this.periodsData);
    };
    /**
     * @return {?}
     */
    PeriodsFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.periodsArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} periods
     * @return {?}
     */
    PeriodsFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} periods
     * @return {?}
     */
    function (periods) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (periods != null && periods.periods != null && periods.periods.length > 0) {
            groupSize = periods.periods.length;
            values = periods.periods.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ period: x }); }));
        }
        this.periodsFormService
            .initFormArrayGroup(groupSize, this.getPeriodsArrayModelControl(), this.getPeriodsFormArrayModel());
        this.periodsFormService.formModelSubject.next([this.getPeriodsFormArrayModel()]);
        if (values) {
            this.formGroup.get(PERIODS_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    PeriodsFormComponent.prototype.subscribeToPeriodsArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.periodsArrayModelChangesSubscription = this.periodsFormService
            .getPeriodsArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.periodsData = null;
            }
            else {
                _this.periodsData = new Periods(value);
            }
            _this.periodsChange.emit(_this.periodsData);
        }));
    };
    Object.defineProperty(PeriodsFormComponent.prototype, "showAddPeriodButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getPeriodsArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodsFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getPeriodsArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    PeriodsFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.periodsFormService.removeFormArrayGroup(index, this.getPeriodsArrayModelControl(), context);
        this.periodsFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    PeriodsFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.periodsFormService.insertFormArrayGroup(index, this.getPeriodsArrayModelControl(), context);
        this.periodsFormService.formModelSubject.next([context]);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    PeriodsFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.periodsFormService.insertFormArrayGroup(0, this.getPeriodsArrayModelControl(), this.getPeriodsFormArrayModel());
        this.periodsFormService.formModelSubject.next([this.getPeriodsFormArrayModel()]);
        this.updateFormGroupTouched();
    };
    Object.defineProperty(PeriodsFormComponent.prototype, "hasError", {
        get: /**
         * @return {?}
         */
        function () {
            return this.formGroup != null && this.formGroup.get(PERIODS_ARRAY_MODEL).errors != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodsFormComponent.prototype, "errorTranslationKey", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var errors = this.formGroup != null ? this.formGroup.get(PERIODS_ARRAY_MODEL).errors : null;
            if (errors != null) {
                return Object.keys(errors)[0];
            }
        },
        enumerable: true,
        configurable: true
    });
    PeriodsFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-periods-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #treatmentForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddPeriodButton\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addPeriod' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n\r\n                <ng-template modelId=\"periodsArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"periods-buttons\">\r\n                        <button type=\"button\" class=\"btn btn-danger\" (click)=\"removeItem(context, index)\" [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i class=\"ft-plus\"></i></button>\r\n                    </div>\r\n                </ng-template>\r\n\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n    <div *ngIf=\"touched && hasError\">\r\n        <small class=\"invalid-feedback d-block ng-star-inserted\">\r\n            {{errorTranslationKey |  enumTranslateKey: 'APPLICATION.VALIDATORS' | translate}}\r\n        </small>\r\n    </div>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        PeriodsFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    PeriodsFormComponent.ctorParameters = function () { return [
        { type: PeriodsFormService }
    ]; };
    PeriodsFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        periods: [{ type: Input }],
        touched: [{ type: Input }],
        periodsChange: [{ type: Output }]
    };
    return PeriodsFormComponent;
}());
if (false) {
    /** @type {?} */
    PeriodsFormComponent.prototype.translateKey;
    /** @type {?} */
    PeriodsFormComponent.prototype.minCountRequired;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormComponent.prototype._touched;
    /** @type {?} */
    PeriodsFormComponent.prototype.periodsChange;
    /** @type {?} */
    PeriodsFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    PeriodsFormComponent.prototype.formLayout;
    /** @type {?} */
    PeriodsFormComponent.prototype.formModel$;
    /** @type {?} */
    PeriodsFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormComponent.prototype.periodsData;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormComponent.prototype.periodsArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormComponent.prototype.getPeriodsFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormComponent.prototype.getPeriodsArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    PeriodsFormComponent.prototype.periodsFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_COMMISSIONED_AUDIT_RESULT = 'COMMISSIONED_AUDIT_RESULT';
/**
 * @record
 */
function DynamicCommissionedAuditResultFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlModelConfig.prototype.translateKey;
}
var DynamicCommissionedAuditResultFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicCommissionedAuditResultFormControlModel, _super);
    function DynamicCommissionedAuditResultFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_COMMISSIONED_AUDIT_RESULT;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicCommissionedAuditResultFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicCommissionedAuditResultFormControlModel.prototype, "translateKey", void 0);
    return DynamicCommissionedAuditResultFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlModel.prototype.type;
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicCommissionedAuditResultFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicCommissionedAuditResultFormControlComponent, _super);
    function DynamicCommissionedAuditResultFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicCommissionedAuditResultFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-commissioned-audit-result-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <lib-commissioned-audit-result-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </lib-commissioned-audit-result-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicCommissionedAuditResultFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicCommissionedAuditResultFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicCommissionedAuditResultFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicCommissionedAuditResultFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicCommissionedAuditResultFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicCommissionedAuditResultFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CommissionedAuditResult = /** @class */ (function () {
    function CommissionedAuditResult(commissionedAudit, result, sharing) {
        this.commissionedAudit = commissionedAudit;
        this.result = result;
        this.sharing = sharing;
    }
    return CommissionedAuditResult;
}());
if (false) {
    /** @type {?} */
    CommissionedAuditResult.prototype.commissionedAudit;
    /** @type {?} */
    CommissionedAuditResult.prototype.result;
    /** @type {?} */
    CommissionedAuditResult.prototype.sharing;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CommissionedAuditResultFormControlComponent = /** @class */ (function () {
    function CommissionedAuditResultFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(CommissionedAuditResultFormControlComponent.prototype, "samplingResult", {
        get: /**
         * @return {?}
         */
        function () {
            return this._samplingResultData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._samplingResultData = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    CommissionedAuditResultFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._samplingResultData = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CommissionedAuditResultFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CommissionedAuditResultFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CommissionedAuditResultFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    CommissionedAuditResultFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-commissioned-audit-result-form-control',
                    template: "<lib-commissioned-audit-result-form\r\n    [(samplingResult)]=\"samplingResult\"\r\n    [translateKey]=\"translateKey\"\r\n    [touched]=\"touched\">\r\n</lib-commissioned-audit-result-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return CommissionedAuditResultFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    CommissionedAuditResultFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        samplingResult: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return CommissionedAuditResultFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormControlComponent.prototype._samplingResultData;
    /** @type {?} */
    CommissionedAuditResultFormControlComponent.prototype.translateKey;
    /** @type {?} */
    CommissionedAuditResultFormControlComponent.prototype.touched;
    /** @type {?} */
    CommissionedAuditResultFormControlComponent.prototype.blur;
    /** @type {?} */
    CommissionedAuditResultFormControlComponent.prototype.change;
    /** @type {?} */
    CommissionedAuditResultFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormControlComponent.prototype.onTouched;
}

var _a$7;
/** @type {?} */
var FORM_LAYOUT_INPUT$3 = {
    grid: {
        host: 'commissioned-audit-result-host col-12 col-md-6 col-xl-auto',
        container: 'commissioned-audit-result-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var PCA_SR_COMMISSIONED_AUDIT = 'commissionedAudit';
/** @type {?} */
var PCA_SR_RESULT = 'result';
/** @type {?} */
var PCA_SR_SHARING = 'sharing';
/** @type {?} */
var PCA_SR_LAYOUT = (_a$7 = {},
    _a$7[PCA_SR_COMMISSIONED_AUDIT] = FORM_LAYOUT_INPUT$3,
    _a$7[PCA_SR_RESULT] = FORM_LAYOUT_INPUT$3,
    _a$7[PCA_SR_SHARING] = FORM_LAYOUT_INPUT$3,
    _a$7);
/** @type {?} */
var PCA_SR_FORM_MODEL = [
    new DynamicMultiSelectControlModel({
        id: PCA_SR_COMMISSIONED_AUDIT,
        multiple: false,
        items: getOptionsForDynamicMultiSelectControlModel(FieldAuditAreaType),
        translationPrefix: 'APPLICATION.DICTIONARIES.FIELD_AUDIT_AREA_TYPE',
        readonly: true,
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: PCA_SR_RESULT,
        multiple: false,
        items: getOptionsForDynamicMultiSelectControlModel(ProductCatalogAuditResult),
        translationPrefix: 'APPLICATION.DICTIONARIES.PRODUCT_CATALOG_AUDIT_RESULT',
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: PCA_SR_SHARING,
        multiple: true,
        items: getOptionsForDynamicMultiSelectControlModel(ApplicationType),
        translationPrefix: 'APPLICATION.DICTIONARIES.APPLICATION_TYPE'
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CommissionedAuditResultFormService = /** @class */ (function () {
    function CommissionedAuditResultFormService(formService, translateFormModelService, translateService) {
        this.formService = formService;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    CommissionedAuditResultFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    CommissionedAuditResultFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    CommissionedAuditResultFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    CommissionedAuditResultFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    CommissionedAuditResultFormService.prototype.getCommissionedAuditValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PCA_SR_COMMISSIONED_AUDIT).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    CommissionedAuditResultFormService.prototype.getResultValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PCA_SR_RESULT).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    CommissionedAuditResultFormService.prototype.getSharingValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PCA_SR_SHARING).valueChanges;
    };
    CommissionedAuditResultFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CommissionedAuditResultFormService.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TranslateFormModelService },
        { type: TranslateService }
    ]; };
    return CommissionedAuditResultFormService;
}());
if (false) {
    /** @type {?} */
    CommissionedAuditResultFormService.prototype.formModelSubject;
    /** @type {?} */
    CommissionedAuditResultFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormService.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormService.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CommissionedAuditResultFormComponent = /** @class */ (function () {
    function CommissionedAuditResultFormComponent(productCatalogAuditSamplingResultFormService) {
        this.productCatalogAuditSamplingResultFormService = productCatalogAuditSamplingResultFormService;
        this.samplingResultChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = PCA_SR_LAYOUT;
        this.productCatalogAuditSamplingResultFormService.formModelSubject.next(PCA_SR_FORM_MODEL);
        this.formGroup = this.productCatalogAuditSamplingResultFormService.createFormGroup(PCA_SR_FORM_MODEL);
    }
    Object.defineProperty(CommissionedAuditResultFormComponent.prototype, "samplingResult", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.samplingResultData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.samplingResultData = value;
            }
            else {
                this.samplingResultData = new CommissionedAuditResult(null, ProductCatalogAuditResult.Incompatible, []);
                this.updateFormValue(this.samplingResultData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommissionedAuditResultFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.productCatalogAuditSamplingResultFormService.getFormModel$(this.translateKey);
        this.subscribeToCommissionedAuditModelValueChanges(this.formGroup);
        this.subscribeToResultModelValueChanges(this.formGroup);
        this.subscribeToSharingModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.commissionedAuditChangesSubscription.unsubscribe();
        this.resultChangesSubscription.unsubscribe();
        this.sharingChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} samplingResult
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} samplingResult
     * @return {?}
     */
    function (samplingResult) {
        /** @type {?} */
        var allCommissionedAudits = getOptionsForDynamicMultiSelectControlModel(FieldAuditAreaType);
        /** @type {?} */
        var commissionedAudit = allCommissionedAudits.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.value.toString() === samplingResult.commissionedAudit; }));
        /** @type {?} */
        var allResults = getOptionsForDynamicMultiSelectControlModel(ProductCatalogAuditResult);
        /** @type {?} */
        var result = allResults.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.value.toString() === samplingResult.result; }));
        /** @type {?} */
        var allSharings = getOptionsForDynamicMultiSelectControlModel(ApplicationType);
        /** @type {?} */
        var sharings = allSharings.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return (samplingResult.sharing || []).some((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s === x.value.toString(); })); }));
        this.formGroup.get(PCA_SR_COMMISSIONED_AUDIT).patchValue(commissionedAudit);
        this.formGroup.get(PCA_SR_RESULT).patchValue(result);
        this.formGroup.get(PCA_SR_SHARING).patchValue(sharings);
    };
    /**
     * @private
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var commissionedAudit = this.formGroup.get(PCA_SR_COMMISSIONED_AUDIT).value;
        /** @type {?} */
        var result = this.formGroup.get(PCA_SR_RESULT).value;
        /** @type {?} */
        var sharing = this.formGroup.get(PCA_SR_SHARING).value;
        return new CommissionedAuditResult(commissionedAudit != null ? commissionedAudit.value : null, result != null ? result.value : null, (sharing || []).map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.value; })));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.subscribeToCommissionedAuditModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.commissionedAuditChangesSubscription = this.productCatalogAuditSamplingResultFormService
            .getCommissionedAuditValue$(formGroup)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.onSamplingResultChanged();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.subscribeToResultModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.resultChangesSubscription = this.productCatalogAuditSamplingResultFormService
            .getResultValue$(formGroup)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.onSamplingResultChanged();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.subscribeToSharingModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.sharingChangesSubscription = this.productCatalogAuditSamplingResultFormService
            .getSharingValue$(formGroup)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.onSamplingResultChanged();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    CommissionedAuditResultFormComponent.prototype.onSamplingResultChanged = /**
     * @private
     * @return {?}
     */
    function () {
        this.samplingResultData = this.getFormValue();
        this.samplingResultChange.emit(this.samplingResultData);
    };
    CommissionedAuditResultFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-commissioned-audit-result-form',
                    template: "<div class=\"container-fluid px-0 mt-2\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        CommissionedAuditResultFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CommissionedAuditResultFormComponent.ctorParameters = function () { return [
        { type: CommissionedAuditResultFormService }
    ]; };
    CommissionedAuditResultFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        samplingResult: [{ type: Input }],
        touched: [{ type: Input }],
        samplingResultChange: [{ type: Output }]
    };
    return CommissionedAuditResultFormComponent;
}());
if (false) {
    /** @type {?} */
    CommissionedAuditResultFormComponent.prototype.translateKey;
    /** @type {?} */
    CommissionedAuditResultFormComponent.prototype.samplingResultChange;
    /** @type {?} */
    CommissionedAuditResultFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    CommissionedAuditResultFormComponent.prototype.formLayout;
    /** @type {?} */
    CommissionedAuditResultFormComponent.prototype.formModel$;
    /** @type {?} */
    CommissionedAuditResultFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormComponent.prototype.samplingResultData;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormComponent.prototype.commissionedAuditChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormComponent.prototype.resultChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormComponent.prototype.sharingChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CommissionedAuditResultFormComponent.prototype.productCatalogAuditSamplingResultFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function commissionedAuditResultValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var samplingResult = (/** @type {?} */ (control.value));
        if (isEmpty(samplingResult.commissionedAudit)
            || isEmpty(samplingResult.result)) {
            return { commissionedAuditResult: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_PRODUCT_DELIVERY = 'PRODUCT_DELIVERY';
/**
 * @record
 */
function DynamicProductDeliveryFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicProductDeliveryFormControlModelConfig.prototype.month;
    /** @type {?} */
    DynamicProductDeliveryFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicProductDeliveryFormControlModelConfig.prototype.parcels;
}
var DynamicProductDeliveryFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicProductDeliveryFormControlModel, _super);
    function DynamicProductDeliveryFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_PRODUCT_DELIVERY;
        _this.month = config.month;
        _this.translateKey = config.translateKey;
        _this.parcels = config.parcels || [];
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicProductDeliveryFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicProductDeliveryFormControlModel.prototype, "month", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicProductDeliveryFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicProductDeliveryFormControlModel.prototype, "parcels", void 0);
    return DynamicProductDeliveryFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicProductDeliveryFormControlModel.prototype.type;
    /** @type {?} */
    DynamicProductDeliveryFormControlModel.prototype.month;
    /** @type {?} */
    DynamicProductDeliveryFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicProductDeliveryFormControlModel.prototype.parcels;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicProductDeliveryFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicProductDeliveryFormControlComponent, _super);
    function DynamicProductDeliveryFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicProductDeliveryFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-product-delivery-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-product-delivery-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [controlPrefix]=\"model.id\"\r\n        [month]=\"model.month\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [parcels]=\"model.parcels\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-product-delivery-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicProductDeliveryFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicProductDeliveryFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicProductDeliveryFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicProductDeliveryFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicProductDeliveryFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicProductDeliveryFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicProductDeliveryFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicProductDeliveryFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicProductDeliveryFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicProductDeliveryFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicProductDeliveryFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicProductDeliveryFormControlComponent.prototype.validationService;
}

var _a$8;
/** @type {?} */
var PD_AMOUNT = 'amount';
/** @type {?} */
var PD_VARIETIES = 'varieties';
/** @type {?} */
var PD_PARCELS = 'parcels';
/** @type {?} */
var lauoutContainer = 'product-delivery-container';
/** @type {?} */
var AMOUNT_FORM_LAYOUT_INPUT = {
    grid: {
        host: 'product-delivery-amount-host',
        container: lauoutContainer,
        label: '',
        control: ''
    }
};
/** @type {?} */
var VARIETIES_FORM_LAYOUT_INPUT = {
    grid: {
        host: 'product-delivery-varieties-host',
        container: lauoutContainer,
        label: '',
        control: ''
    }
};
/** @type {?} */
var PARCELS_FORM_LAYOUT_INPUT = {
    grid: {
        host: 'product-delivery-parcels-host',
        container: lauoutContainer,
        label: '',
        control: ''
    }
};
/** @type {?} */
var PRODUCT_DELIVERY_LAYOUT = (_a$8 = {},
    _a$8[PD_AMOUNT] = AMOUNT_FORM_LAYOUT_INPUT,
    _a$8[PD_VARIETIES] = VARIETIES_FORM_LAYOUT_INPUT,
    _a$8[PD_PARCELS] = PARCELS_FORM_LAYOUT_INPUT,
    _a$8);
/** @type {?} */
var PRODUCT_DELIVERY_FORM_MODEL = [
    new DynamicInputModel({
        id: PD_AMOUNT,
        min: 1,
        max: 5000000,
        inputType: 'number',
        validators: {
            required: null,
            min: 1,
            max: 5000000
        }
    }),
    new DynamicInputModel({
        id: PD_VARIETIES,
        maxLength: 1000,
        validators: {
            maxLength: 1000
        }
    }),
    new DynamicMultiSelectControlModel({
        id: PD_PARCELS,
        bindLabel: nameof('name'),
        multiple: true,
        searchByField: nameof('name')
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductDelivery = /** @class */ (function () {
    function ProductDelivery(isActive, amount, varieties, parcels, isAddNewParcel) {
        this.isActive = isActive;
        this.amount = amount;
        this.varieties = varieties;
        this.parcels = parcels;
        this.isAddNewParcel = isAddNewParcel;
    }
    return ProductDelivery;
}());
if (false) {
    /** @type {?} */
    ProductDelivery.prototype.isActive;
    /** @type {?} */
    ProductDelivery.prototype.amount;
    /** @type {?} */
    ProductDelivery.prototype.varieties;
    /** @type {?} */
    ProductDelivery.prototype.parcels;
    /** @type {?} */
    ProductDelivery.prototype.isAddNewParcel;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductDeliveryFormService = /** @class */ (function () {
    function ProductDeliveryFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    ProductDeliveryFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    ProductDeliveryFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} formGroup
     * @param {?} isActive
     * @return {?}
     */
    ProductDeliveryFormService.prototype.getFormValue = /**
     * @param {?} formGroup
     * @param {?} isActive
     * @return {?}
     */
    function (formGroup, isActive) {
        /** @type {?} */
        var amountString = this.getAmountControl(formGroup).value;
        /** @type {?} */
        var varietiesString = this.getVarietiesControl(formGroup).value;
        /** @type {?} */
        var parcels = this.getParcelsControl(formGroup).value;
        /** @type {?} */
        var amount = amountString != null ? +amountString : 0;
        /** @type {?} */
        var varieties = varietiesString != null
            ? varietiesString.split(',').filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x != null; })).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.trim(); })).filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x !== ''; }))
            : [];
        /** @type {?} */
        var isActiveDelivery = isActive || amount > 0 || isEmpty(varieties) === false || isEmpty(parcels) === false;
        return new ProductDelivery(isActiveDelivery, amount, varieties, parcels, false);
    };
    /**
     * @param {?} formGroup
     * @param {?} productDelivery
     * @return {?}
     */
    ProductDeliveryFormService.prototype.updateFormValue = /**
     * @param {?} formGroup
     * @param {?} productDelivery
     * @return {?}
     */
    function (formGroup, productDelivery) {
        this.getAmountControl(formGroup)
            .patchValue(productDelivery != null && productDelivery.amount != null ? productDelivery.amount : 0);
        this.getVarietiesControl(formGroup)
            .patchValue(productDelivery != null && productDelivery.varieties != null
            ? productDelivery.varieties.join(', ') : null);
        this.getParcelsControl(formGroup)
            .patchValue(productDelivery != null && productDelivery.parcels != null ? productDelivery.parcels : []);
    };
    /**
     * @param {?} formModel
     * @param {?} parcels
     * @return {?}
     */
    ProductDeliveryFormService.prototype.updateParcels = /**
     * @param {?} formModel
     * @param {?} parcels
     * @return {?}
     */
    function (formModel, parcels) {
        this.getParcelsModel(formModel).items = parcels;
    };
    /**
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    ProductDeliveryFormService.prototype.subscribeOnChanges = /**
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.subscribeToAmountChanges(formGroup, onChange);
        this.subscribeToVarietiesChanges(formGroup, onChange);
        this.subscribeToParcelsChanges(formGroup, onChange);
    };
    /**
     * @return {?}
     */
    ProductDeliveryFormService.prototype.unsubscribeChanges = /**
     * @return {?}
     */
    function () {
        this.amountChangesSubscription.unsubscribe();
        this.varietiesChangesSubscription.unsubscribe();
        this.parcelsChangesSubscription.unsubscribe();
    };
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    ProductDeliveryFormService.prototype.subscribeToAmountChanges = 
    // -----------------------------------------------------------------------------------
    // SUBSCRIBE
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.amountChangesSubscription =
            this.getAmountControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} amount
             * @return {?}
             */
            function (amount) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    ProductDeliveryFormService.prototype.subscribeToVarietiesChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.varietiesChangesSubscription =
            this.getVarietiesControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} varieties
             * @return {?}
             */
            function (varieties) { return onChange(); }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    ProductDeliveryFormService.prototype.subscribeToParcelsChanges = /**
     * @private
     * @param {?} formGroup
     * @param {?} onChange
     * @return {?}
     */
    function (formGroup, onChange) {
        this.parcelsChangesSubscription =
            this.getParcelsControl(formGroup).valueChanges
                .subscribe((/**
             * @param {?} parcels
             * @return {?}
             */
            function (parcels) { return onChange(); }));
    };
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    ProductDeliveryFormService.prototype.getAmountControl = 
    // -----------------------------------------------------------------------------------
    // GET CONTROLS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PD_AMOUNT);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    ProductDeliveryFormService.prototype.getVarietiesControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PD_VARIETIES);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    ProductDeliveryFormService.prototype.getParcelsControl = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(PD_PARCELS);
    };
    // -----------------------------------------------------------------------------------
    // GET MODELS
    // -----------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------
    // GET MODELS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formModel
     * @return {?}
     */
    ProductDeliveryFormService.prototype.getParcelsModel = 
    // -----------------------------------------------------------------------------------
    // GET MODELS
    // -----------------------------------------------------------------------------------
    /**
     * @private
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return (/** @type {?} */ (formModel.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === PD_PARCELS; }))));
    };
    ProductDeliveryFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ProductDeliveryFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return ProductDeliveryFormService;
}());
if (false) {
    /** @type {?} */
    ProductDeliveryFormService.prototype.formModelSubject;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormService.prototype.amountChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormService.prototype.varietiesChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormService.prototype.parcelsChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductDeliveryFormComponent = /** @class */ (function () {
    function ProductDeliveryFormComponent(productDeliveryFormService) {
        var _this = this;
        this.productDeliveryFormService = productDeliveryFormService;
        this.productDeliveryChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.onActive = (/**
         * @param {?} $event
         * @return {?}
         */
        function ($event) {
            _this.isMonthSelected = !_this.isMonthSelected;
            /** @type {?} */
            var copy = JSON.parse(JSON.stringify(_this.productDeliveryData));
            copy.isActive = !_this.productDeliveryData.isActive;
            if (copy.isActive === false) {
                copy.amount = 0;
                copy.varieties = [];
                copy.parcels = [];
            }
            _this.productDeliveryChange.emit(copy);
        });
        this.onAddParcel = (/**
         * @return {?}
         */
        function () {
            _this.productDeliveryData = _this.getFormValue();
            _this.productDeliveryData.isAddNewParcel = true;
            _this.productDeliveryChange.emit(_this.productDeliveryData);
        });
        this.onProductDeliveryChange = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var productDelivery = _this.getFormValue();
            _this.productDeliveryChange.emit(productDelivery);
        });
        this.formLayout = PRODUCT_DELIVERY_LAYOUT;
        this.productDeliveryFormService.formModelSubject.next(PRODUCT_DELIVERY_FORM_MODEL);
        this.formGroup = this.productDeliveryFormService.createFormGroup(PRODUCT_DELIVERY_FORM_MODEL);
    }
    Object.defineProperty(ProductDeliveryFormComponent.prototype, "parcels", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.productDeliveryFormService.updateParcels(PRODUCT_DELIVERY_FORM_MODEL, value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDeliveryFormComponent.prototype, "productDelivery", {
        get: /**
         * @return {?}
         */
        function () {
            return this.productDeliveryData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.productDeliveryData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.productDeliveryData = value;
                this.isMonthSelected = this.productDeliveryData.isActive;
            }
            else {
                this.productDeliveryData = new ProductDelivery(false, 0, // amount
                [], // varieties
                [], // parcels
                false // isAddNewParcel
                );
                this.isMonthSelected = this.productDeliveryData.isActive;
                this.updateFormValue(this.productDeliveryData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDeliveryFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ProductDeliveryFormComponent.prototype, "isDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value || !this.productDelivery.isActive) {
                this.formGroup.disable();
            }
            else {
                this.formGroup.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    ProductDeliveryFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.productDeliveryFormService.getFormModel$(this.translateKey);
        this.productDeliveryFormService.subscribeOnChanges(this.formGroup, this.onProductDeliveryChange);
    };
    /**
     * @return {?}
     */
    ProductDeliveryFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.productDeliveryFormService.unsubscribeChanges();
    };
    /**
     * @private
     * @param {?} isEnabled
     * @return {?}
     */
    ProductDeliveryFormComponent.prototype.initEnabledDisabledForm = /**
     * @private
     * @param {?} isEnabled
     * @return {?}
     */
    function (isEnabled) {
        if (isEnabled) {
            this.formGroup.enable();
        }
        else {
            this.formGroup.disable();
        }
    };
    /**
     * @private
     * @param {?} productDelivery
     * @return {?}
     */
    ProductDeliveryFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} productDelivery
     * @return {?}
     */
    function (productDelivery) {
        this.productDeliveryFormService.updateFormValue(this.formGroup, productDelivery);
        this.initEnabledDisabledForm(productDelivery.isActive);
    };
    /**
     * @private
     * @return {?}
     */
    ProductDeliveryFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        return this.productDeliveryFormService.getFormValue(this.formGroup, this.isMonthSelected);
    };
    ProductDeliveryFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-product-delivery-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"row\">\r\n        <div class=\"col-12\" *ngIf=\"productDelivery && formGroup && formModel$ | async as formModel\">\r\n            <div class=\"float-left product-delivery-checkbox\">\r\n                <input class=\"form-check-input\"\r\n                    id=\"{{controlPrefix}}-month-checkbox\"\r\n                    type=\"checkbox\"\r\n                    [checked]=\"isMonthSelected\"\r\n                    (change)=\"onActive($event)\">\r\n                <label class=\"form-check-label\" for=\"{{controlPrefix}}-month-checkbox\">\r\n                    {{month | enumTranslateKey: 'APPLICATION.DICTIONARIES.MONTH' | translate}}\r\n                </label>\r\n            </div>\r\n\r\n            <form class=\"form-horizontal ng-dynamic-form product-delivery-form\" [formGroup]=\"formGroup\">\r\n                <fieldset>\r\n                    <dynamic-ng-bootstrap-form class=\"row fieldAuditAreaFormRow\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                        [model]=\"formModel\">\r\n                        <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                            <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                            <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                        </ng-template>\r\n                    </dynamic-ng-bootstrap-form>\r\n                </fieldset>\r\n            </form>\r\n            <button type=\"button\" class=\"btn btn-primary float-right product-delivery-button\"\r\n                (click)=\"onAddParcel()\"\r\n                [disabled]=\"!productDelivery.isActive\"><i class=\"ft-plus\"></i> </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    providers: [
                        ProductDeliveryFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ProductDeliveryFormComponent.ctorParameters = function () { return [
        { type: ProductDeliveryFormService }
    ]; };
    ProductDeliveryFormComponent.propDecorators = {
        controlPrefix: [{ type: Input }],
        month: [{ type: Input }],
        translateKey: [{ type: Input }],
        parcels: [{ type: Input }],
        productDelivery: [{ type: Input }],
        touched: [{ type: Input }],
        isDisabled: [{ type: Input }],
        productDeliveryChange: [{ type: Output }]
    };
    return ProductDeliveryFormComponent;
}());
if (false) {
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.controlPrefix;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.month;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.translateKey;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.productDeliveryChange;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.formLayout;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.formModel$;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.formGroup;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.isMonthSelected;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormComponent.prototype.productDeliveryData;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.onActive;
    /** @type {?} */
    ProductDeliveryFormComponent.prototype.onAddParcel;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormComponent.prototype.onProductDeliveryChange;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormComponent.prototype.productDeliveryFormService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductDeliveryFormControlComponent = /** @class */ (function () {
    function ProductDeliveryFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(ProductDeliveryFormControlComponent.prototype, "productDelivery", {
        get: /**
         * @return {?}
         */
        function () {
            return this._productDelivery;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._productDelivery = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    ProductDeliveryFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._productDelivery = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ProductDeliveryFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ProductDeliveryFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    ProductDeliveryFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    ProductDeliveryFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-product-delivery-form-control',
                    template: "<app-product-delivery-form\r\n    [(productDelivery)]=\"productDelivery\"\r\n    [controlPrefix]=\"controlPrefix\"\r\n    [month]=\"month\"\r\n    [translateKey]=\"translateKey\"\r\n    [parcels]=\"parcels\"\r\n    [touched]=\"touched\"\r\n    [isDisabled]=\"isDisabled\">\r\n</app-product-delivery-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return ProductDeliveryFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    ProductDeliveryFormControlComponent.propDecorators = {
        controlPrefix: [{ type: Input }],
        month: [{ type: Input }],
        translateKey: [{ type: Input }],
        parcels: [{ type: Input }],
        productDelivery: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return ProductDeliveryFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormControlComponent.prototype._productDelivery;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.controlPrefix;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.month;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.translateKey;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.parcels;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.touched;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.blur;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.change;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.focus;
    /** @type {?} */
    ProductDeliveryFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    ProductDeliveryFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function productDeliveryValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var productDelivery = (/** @type {?} */ (control.value));
        if (productDelivery.isActive) {
            if (productDelivery.amount <= 0) {
                return { productDelivery: {} };
            }
            return null;
        }
        if (productDelivery.amount !== 0
            || isEmpty(productDelivery.varieties) === false
            || isEmpty(productDelivery.parcels) === false) {
            return { productDelivery: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARD = 'SUPPLIER_AWARD';
/**
 * @record
 */
function DynamicSupplierAwardFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicSupplierAwardFormControlModelConfig.prototype.translateKey;
}
var DynamicSupplierAwardFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicSupplierAwardFormControlModel, _super);
    function DynamicSupplierAwardFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARD;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicSupplierAwardFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicSupplierAwardFormControlModel.prototype, "translateKey", void 0);
    return DynamicSupplierAwardFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicSupplierAwardFormControlModel.prototype.type;
    /** @type {?} */
    DynamicSupplierAwardFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicSupplierAwardFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicSupplierAwardFormControlComponent, _super);
    function DynamicSupplierAwardFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicSupplierAwardFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-supplier-award-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-supplier-award-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-supplier-award-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicSupplierAwardFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicSupplierAwardFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicSupplierAwardFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicSupplierAwardFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicSupplierAwardFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicSupplierAwardFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicSupplierAwardFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicSupplierAwardFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicSupplierAwardFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicSupplierAwardFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicSupplierAwardFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicSupplierAwardFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function mapDatePickerValueToISOString(value) {
    if (value == null || typeof (value) === 'string') {
        return undefined;
    }
    return new Date(value.year, value.month - 1, value.day).toISOString();
}
/**
 * @param {?} value
 * @return {?}
 */
function mapDatePickerValueToUnixTimestamp(value) {
    if (value == null) {
        return undefined;
    }
    // tslint:disable-next-line:no-magic-numbers
    return new Date(value.year, value.month - 1, value.day).getTime() / 1000;
}
/**
 * @param {?} value
 * @return {?}
 */
function mapISOStringToDatePickerValue(value) {
    /** @type {?} */
    var dateTime = value == null ? null : DateTime.fromISO(value);
    if (dateTime == null) {
        return null;
    }
    return {
        year: dateTime.year,
        month: dateTime.month,
        day: dateTime.day
    };
}
/**
 * @param {?} value
 * @return {?}
 */
function mapUnixTimestampToDatePickerValue(value) {
    // tslint:disable-next-line:no-magic-numbers
    /** @type {?} */
    var date = value == null ? null : new Date(value * 1000);
    if (date == null) {
        return null;
    }
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$4 = {
    grid: {
        host: 'supplier-award-host col-12 col-md-6 col-xl-auto',
        container: 'supplier-award-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var SUPPLIER_AWARD_TITLE = 'title';
/** @type {?} */
var SUPPLIER_AWARD_DESCRIPTION = 'description';
/** @type {?} */
var SUPPLIER_AWARD_DATE = 'date';
/** @type {?} */
var SUPPLIER_AWARD_LAYOUT = {
    title: FORM_LAYOUT_INPUT$4,
    description: FORM_LAYOUT_INPUT$4,
    date: FORM_LAYOUT_INPUT$4
};
/** @type {?} */
var SUPPLIER_AWARD_FORM_MODEL = [
    new DynamicInputModel({
        id: 'title',
        minLength: 3,
        maxLength: 100,
        validators: {
            required: null,
            minLength: 3,
            maxLength: 160
        }
    }),
    new DynamicInputModel({
        id: 'description',
        maxLength: 200,
        validators: {
            maxLength: 200
        }
    }),
    new DynamicDatePickerModel({
        id: 'date',
        toggleIcon: './assets/icons/calendar-icon.svg',
        validators: {
            required: null
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAwardFormService = /** @class */ (function () {
    function SupplierAwardFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    SupplierAwardFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    SupplierAwardFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    SupplierAwardFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    SupplierAwardFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardFormService.prototype.getTitleValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(SUPPLIER_AWARD_TITLE).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardFormService.prototype.getDescriptionValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(SUPPLIER_AWARD_DESCRIPTION).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardFormService.prototype.getDateValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(SUPPLIER_AWARD_DATE).valueChanges;
    };
    SupplierAwardFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SupplierAwardFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return SupplierAwardFormService;
}());
if (false) {
    /** @type {?} */
    SupplierAwardFormService.prototype.formModelSubject;
    /** @type {?} */
    SupplierAwardFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAward = /** @class */ (function () {
    function SupplierAward(title, description, date) {
        this.title = title;
        this.description = description;
        this.date = date;
    }
    return SupplierAward;
}());
if (false) {
    /** @type {?} */
    SupplierAward.prototype.title;
    /** @type {?} */
    SupplierAward.prototype.description;
    /** @type {?} */
    SupplierAward.prototype.date;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAwardFormComponent = /** @class */ (function () {
    function SupplierAwardFormComponent(supplierAwardFormService) {
        this.supplierAwardFormService = supplierAwardFormService;
        this.supplierAwardChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = SUPPLIER_AWARD_LAYOUT;
        this.supplierAwardFormService.formModelSubject.next(SUPPLIER_AWARD_FORM_MODEL);
        this.formGroup = this.supplierAwardFormService.createFormGroup(SUPPLIER_AWARD_FORM_MODEL);
    }
    Object.defineProperty(SupplierAwardFormComponent.prototype, "supplierAward", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.supplierAwardData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.supplierAwardData = value;
            }
            else {
                this.supplierAwardData = new SupplierAward('', '', null);
                this.updateFormValue(this.supplierAwardData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAwardFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.supplierAwardFormService.getFormModel$(this.translateKey);
        this.subscribeToTitleModelValueChanges(this.formGroup);
        this.subscribeToDescriptionModelValueChanges(this.formGroup);
        this.subscribeToDateModelValueChanges(this.formGroup);
    };
    /**
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.titleChangesSubscription != null) {
            this.titleChangesSubscription.unsubscribe();
        }
        if (this.descriptionChangesSubscription != null) {
            this.descriptionChangesSubscription.unsubscribe();
        }
        if (this.dateChangesSubscription != null) {
            this.dateChangesSubscription.unsubscribe();
        }
    };
    /**
     * @private
     * @param {?} supplierAward
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} supplierAward
     * @return {?}
     */
    function (supplierAward) {
        this.formGroup.get(SUPPLIER_AWARD_TITLE).patchValue(supplierAward.title);
        this.formGroup.get(SUPPLIER_AWARD_DESCRIPTION).patchValue(supplierAward.description);
        /** @type {?} */
        var awardDate = mapISOStringToDatePickerValue(supplierAward.date);
        this.formGroup.get(SUPPLIER_AWARD_DATE).patchValue(awardDate);
    };
    /**
     * @private
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var title = this.formGroup.get(SUPPLIER_AWARD_TITLE).value;
        /** @type {?} */
        var description = this.formGroup.get(SUPPLIER_AWARD_DESCRIPTION).value;
        /** @type {?} */
        var date = mapDatePickerValueToISOString(this.formGroup.get(SUPPLIER_AWARD_DATE).value);
        return new SupplierAward(title, description, date);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.subscribeToTitleModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.titleChangesSubscription = this.supplierAwardFormService
            .getTitleValue$(formGroup)
            .subscribe((/**
         * @param {?} title
         * @return {?}
         */
        function (title) {
            _this.onSupplierAwardChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.subscribeToDescriptionModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.descriptionChangesSubscription = this.supplierAwardFormService
            .getDescriptionValue$(formGroup)
            .subscribe((/**
         * @param {?} description
         * @return {?}
         */
        function (description) {
            _this.onSupplierAwardChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.subscribeToDateModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.dateChangesSubscription = this.supplierAwardFormService
            .getDateValue$(formGroup)
            .subscribe((/**
         * @param {?} awardDate
         * @return {?}
         */
        function (awardDate) {
            _this.onSupplierAwardChange();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    SupplierAwardFormComponent.prototype.onSupplierAwardChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.supplierAwardData = this.getFormValue();
        this.supplierAwardChange.emit(this.supplierAwardData);
    };
    SupplierAwardFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-supplier-award-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        SupplierAwardFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SupplierAwardFormComponent.ctorParameters = function () { return [
        { type: SupplierAwardFormService }
    ]; };
    SupplierAwardFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        supplierAward: [{ type: Input }],
        touched: [{ type: Input }],
        supplierAwardChange: [{ type: Output }]
    };
    return SupplierAwardFormComponent;
}());
if (false) {
    /** @type {?} */
    SupplierAwardFormComponent.prototype.translateKey;
    /** @type {?} */
    SupplierAwardFormComponent.prototype.supplierAwardChange;
    /** @type {?} */
    SupplierAwardFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    SupplierAwardFormComponent.prototype.formLayout;
    /** @type {?} */
    SupplierAwardFormComponent.prototype.formModel$;
    /** @type {?} */
    SupplierAwardFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormComponent.prototype.supplierAwardData;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormComponent.prototype.titleChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormComponent.prototype.descriptionChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormComponent.prototype.dateChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormComponent.prototype.supplierAwardFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAwardFormControlComponent = /** @class */ (function () {
    function SupplierAwardFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(SupplierAwardFormControlComponent.prototype, "supplierAward", {
        get: /**
         * @return {?}
         */
        function () {
            return this._supplierAward;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._supplierAward = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    SupplierAwardFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._supplierAward = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SupplierAwardFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SupplierAwardFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SupplierAwardFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    SupplierAwardFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-supplier-award-form-control',
                    template: "<app-supplier-award-form\r\n    [(supplierAward)]=\"supplierAward\"\r\n    [translateKey]=\"translateKey\"\r\n    [touched]=\"touched\">\r\n</app-supplier-award-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return SupplierAwardFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    SupplierAwardFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        supplierAward: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return SupplierAwardFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormControlComponent.prototype._supplierAward;
    /** @type {?} */
    SupplierAwardFormControlComponent.prototype.translateKey;
    /** @type {?} */
    SupplierAwardFormControlComponent.prototype.touched;
    /** @type {?} */
    SupplierAwardFormControlComponent.prototype.blur;
    /** @type {?} */
    SupplierAwardFormControlComponent.prototype.change;
    /** @type {?} */
    SupplierAwardFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARDS = 'SUPPLIER_AWARDS';
/**
 * @record
 */
function DynamicSupplierAwardsFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicSupplierAwardsFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicSupplierAwardsFormControlModelConfig.prototype.minCountRequired;
}
var DynamicSupplierAwardsFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicSupplierAwardsFormControlModel, _super);
    function DynamicSupplierAwardsFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARDS;
        _this.translateKey = config.translateKey;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicSupplierAwardsFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicSupplierAwardsFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicSupplierAwardsFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicSupplierAwardsFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicSupplierAwardsFormControlModel.prototype.type;
    /** @type {?} */
    DynamicSupplierAwardsFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicSupplierAwardsFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicSupplierAwardsFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicSupplierAwardsFormControlComponent, _super);
    function DynamicSupplierAwardsFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicSupplierAwardsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-supplier-awards-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-supplier-awards-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-supplier-awards-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicSupplierAwardsFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicSupplierAwardsFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicSupplierAwardsFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicSupplierAwardsFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicSupplierAwardsFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicSupplierAwardsFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicSupplierAwardsFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicSupplierAwardsFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicSupplierAwardsFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicSupplierAwardsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicSupplierAwardsFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicSupplierAwardsFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAwards = /** @class */ (function () {
    function SupplierAwards(awards) {
        this.awards = awards;
    }
    return SupplierAwards;
}());
if (false) {
    /** @type {?} */
    SupplierAwards.prototype.awards;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAwardsFormControlComponent = /** @class */ (function () {
    function SupplierAwardsFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(SupplierAwardsFormControlComponent.prototype, "supplierAwards", {
        get: /**
         * @return {?}
         */
        function () {
            return this._supplierAwards;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._supplierAwards = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    SupplierAwardsFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._supplierAwards = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SupplierAwardsFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SupplierAwardsFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SupplierAwardsFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    SupplierAwardsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-supplier-awards-form-control',
                    template: "<app-supplier-awards-form\r\n    [(supplierAwards)]=\"supplierAwards\"\r\n    [translateKey]=\"translateKey\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [touched]=\"touched\">\r\n</app-supplier-awards-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return SupplierAwardsFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    SupplierAwardsFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        cultivationCodeNames: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        supplierAwards: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return SupplierAwardsFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormControlComponent.prototype._supplierAwards;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.translateKey;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.cultivationCodeNames;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.touched;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.blur;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.change;
    /** @type {?} */
    SupplierAwardsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormControlComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$2 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$2 = {
    grid: {
        host: 'supplier-awards-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var SUPPLIER_AWARDS_ARRAY_MODEL = 'supplierAwardsArrayModel';
/** @type {?} */
var SUPPLIER_AWARDS_AWARD = 'award';
/** @type {?} */
var SUPPLIER_AWARDS_LAYOUT = {
    supplierAwardsArrayModel: FORM_LAYOUT_INPUT_ALL$2,
    award: FORM_LAYOUT_INPUT_ALL_ITEM$2
};
var ɵ0$3 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicSupplierAwardFormControlModel({
            id: SUPPLIER_AWARDS_AWARD
        })
    ];
};
/** @type {?} */
var SUPPLIER_AWARDS_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: SUPPLIER_AWARDS_ARRAY_MODEL,
        initialCount: 0,
        groupFactory: (ɵ0$3)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAwardsFormService = /** @class */ (function () {
    function SupplierAwardsFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    SupplierAwardsFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    SupplierAwardsFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    SupplierAwardsFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    SupplierAwardsFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = SUPPLIER_AWARDS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} supplierAwardModel
             * @return {?}
             */
            function (supplierAwardModel) {
                supplierAwardModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    SupplierAwardsFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    SupplierAwardsFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    SupplierAwardsFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    SupplierAwardsFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    SupplierAwardsFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardsFormService.prototype.getSupplierAwardsArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(SUPPLIER_AWARDS_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.award; }));
        })));
    };
    SupplierAwardsFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SupplierAwardsFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return SupplierAwardsFormService;
}());
if (false) {
    /** @type {?} */
    SupplierAwardsFormService.prototype.formModelSubject;
    /** @type {?} */
    SupplierAwardsFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SupplierAwardsFormComponent = /** @class */ (function () {
    function SupplierAwardsFormComponent(supplierAwardsFormService) {
        var _this = this;
        this.supplierAwardsFormService = supplierAwardsFormService;
        this.supplierAwardsChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getSupplierAwardsFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.supplierAwardsFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === SUPPLIER_AWARDS_ARRAY_MODEL; }))));
        });
        this.getSupplierAwardsArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.supplierAwardsFormService
                .findModelById(SUPPLIER_AWARDS_ARRAY_MODEL, SUPPLIER_AWARDS_FORM_MODEL);
            return (/** @type {?} */ (_this.supplierAwardsFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = SUPPLIER_AWARDS_LAYOUT;
        this.supplierAwardsFormService.formModelSubject.next(SUPPLIER_AWARDS_FORM_MODEL);
        this.formGroup = this.supplierAwardsFormService.createFormGroup(SUPPLIER_AWARDS_FORM_MODEL);
        this.subscribeToSupplierAwardsArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(SupplierAwardsFormComponent.prototype, "supplierAwards", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.awards != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.supplierAwardsData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.supplierAwardsData = value;
            }
            else {
                this.supplierAwardsData = new SupplierAwards([]);
                this.updateFormValue(this.supplierAwardsData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAwardsFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    SupplierAwardsFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.supplierAwardsFormService.getFormModel$(this.translateKey);
        this.updateFormValue(this.supplierAwardsData);
    };
    /**
     * @return {?}
     */
    SupplierAwardsFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.supplierAwardsArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} supplierAwards
     * @return {?}
     */
    SupplierAwardsFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} supplierAwards
     * @return {?}
     */
    function (supplierAwards) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (supplierAwards != null && supplierAwards.awards != null) {
            groupSize = supplierAwards.awards.length;
            values = supplierAwards.awards.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ award: x }); }));
        }
        this.supplierAwardsFormService
            .initFormArrayGroup(groupSize, this.getSupplierAwardsArrayModelControl(), this.getSupplierAwardsFormArrayModel());
        if (values) {
            this.formGroup.get(SUPPLIER_AWARDS_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    SupplierAwardsFormComponent.prototype.subscribeToSupplierAwardsArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.supplierAwardsArrayModelChangesSubscription = this.supplierAwardsFormService
            .getSupplierAwardsArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.supplierAwardsData = null;
            }
            else {
                _this.supplierAwardsData = new SupplierAwards(value);
            }
            _this.supplierAwardsChange.emit(_this.supplierAwardsData);
        }));
    };
    Object.defineProperty(SupplierAwardsFormComponent.prototype, "showAddAwardButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getSupplierAwardsArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierAwardsFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getSupplierAwardsArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    SupplierAwardsFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.supplierAwardsFormService.removeFormArrayGroup(index, this.getSupplierAwardsArrayModelControl(), context);
        this.supplierAwardsFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    SupplierAwardsFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.supplierAwardsFormService.insertFormArrayGroup(index, this.getSupplierAwardsArrayModelControl(), context);
        this.supplierAwardsFormService.formModelSubject.next([context]);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    SupplierAwardsFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.supplierAwardsFormService.insertFormArrayGroup(0, this.getSupplierAwardsArrayModelControl(), this.getSupplierAwardsFormArrayModel());
        this.supplierAwardsFormService.formModelSubject.next([this.getSupplierAwardsFormArrayModel()]);
        this.updateFormGroupTouched();
    };
    SupplierAwardsFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-supplier-awards-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #treatmentForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddAwardButton\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addAward:button' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n                <ng-template modelId=\"supplierAwardsArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"supplier-awards-buttons row mt-2 justify-content-md-end justify-content-xl-center mt-xl-0\">\r\n                        <div class=\"col-6 col-md-auto px-md-0\">\r\n                            <button type=\"button\" class=\"btn btn-danger\" *ngIf=\"!removeItemDisabled\" (click)=\"removeItem(context, index)\"\r\n                                [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        </div>\r\n                        <div class=\"col-6 col-md-auto\">\r\n                            <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i\r\n                                    class=\"ft-plus\"></i></button>\r\n                        </div>\r\n                    </div>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        SupplierAwardsFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SupplierAwardsFormComponent.ctorParameters = function () { return [
        { type: SupplierAwardsFormService }
    ]; };
    SupplierAwardsFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        supplierAwards: [{ type: Input }],
        touched: [{ type: Input }],
        supplierAwardsChange: [{ type: Output }]
    };
    return SupplierAwardsFormComponent;
}());
if (false) {
    /** @type {?} */
    SupplierAwardsFormComponent.prototype.translateKey;
    /** @type {?} */
    SupplierAwardsFormComponent.prototype.minCountRequired;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormComponent.prototype._touched;
    /** @type {?} */
    SupplierAwardsFormComponent.prototype.supplierAwardsChange;
    /** @type {?} */
    SupplierAwardsFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    SupplierAwardsFormComponent.prototype.formLayout;
    /** @type {?} */
    SupplierAwardsFormComponent.prototype.formModel$;
    /** @type {?} */
    SupplierAwardsFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormComponent.prototype.supplierAwardsData;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormComponent.prototype.supplierAwardsArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormComponent.prototype.getSupplierAwardsFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormComponent.prototype.getSupplierAwardsArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    SupplierAwardsFormComponent.prototype.supplierAwardsFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function supplierAwardsValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var supplierAwards = (/** @type {?} */ (control.value));
        if (supplierAwards.awards == null || supplierAwards.awards.length === 0) {
            return null;
        }
        /** @type {?} */
        var isSupplierAwardCorrect = (/**
         * @param {?} award
         * @return {?}
         */
        function (award) {
            if (award == null) {
                return false;
            }
            return !isEmpty(award.title)
                && !isEmpty(award.date);
        });
        if (supplierAwards.awards.some((/**
         * @param {?} seed
         * @return {?}
         */
        function (seed) { return !isSupplierAwardCorrect(seed); }))) {
            return { supplierAwards: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZER = 'TREATMENT_FERTILIZER';
/**
 * @record
 */
function DynamicTreatmentFertilizerFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicTreatmentFertilizerFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicTreatmentFertilizerFormControlModelConfig.prototype.totalAreaInHa;
}
var DynamicTreatmentFertilizerFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicTreatmentFertilizerFormControlModel, _super);
    function DynamicTreatmentFertilizerFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZER;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentFertilizerFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentFertilizerFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentFertilizerFormControlModel.prototype, "totalAreaInHa", void 0);
    return DynamicTreatmentFertilizerFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlModel.prototype.type;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlModel.prototype.totalAreaInHa;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicTreatmentFertilizerFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicTreatmentFertilizerFormControlComponent, _super);
    function DynamicTreatmentFertilizerFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicTreatmentFertilizerFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-treatment-fertilizer-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-treatment-fertilizer-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [totalAreaInHa]=\"model.totalAreaInHa\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-treatment-fertilizer-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicTreatmentFertilizerFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicTreatmentFertilizerFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicTreatmentFertilizerFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicTreatmentFertilizerFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentFertilizerFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentFertilizerFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$5 = {
    grid: {
        host: 'treatment-fertilizer-host col-12 col-md-6 col-xl-auto',
        container: 'treatment-fertilizer-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var TREATMENT_FERTILIZER = 'fertilizer';
/** @type {?} */
var TREATMENT_FERTILIZER_UNIT = 'unit';
/** @type {?} */
var TREATMENT_FERTILIZER_QUANTITY_PER_HA = 'quantityPerHa';
/** @type {?} */
var TREATMENT_FERTILIZER_QUANTITY = 'quantity';
/** @type {?} */
var TREATMENT_FERTILIZER_LAYOUT = {
    fertilizer: FORM_LAYOUT_INPUT$5,
    unit: FORM_LAYOUT_INPUT$5,
    quantityInUnit: FORM_LAYOUT_INPUT$5,
    quantityPerHa: FORM_LAYOUT_INPUT$5,
    quantity: FORM_LAYOUT_INPUT$5,
};
/** @type {?} */
var TREATMENT_FERTILIZER_FORM_MODEL = [
    new DynamicDictionaryControlModel({
        id: 'fertilizer',
        dictionaryKey: DictionaryType[DictionaryType.FertilizerType],
        validators: {
            required: null
        }
    }),
    new DynamicSelectModel({
        id: 'unit',
        options: getOptionsForDynamicSelectModel(TreatmentFertilizerUnit, 'TREATMENT_FERTILIZER_UNITS', false),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'quantityPerHa',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        }
    }),
    new DynamicInputModel({
        id: 'quantity',
        readOnly: true,
        inputType: 'number'
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizerFormService = /** @class */ (function () {
    function TreatmentFertilizerFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.getFertilizerValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_FERTILIZER).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.getUnitValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_FERTILIZER_UNIT).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.getQuantityPerHaValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_FERTILIZER_QUANTITY_PER_HA).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormService.prototype.getQuantityValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_FERTILIZER_QUANTITY).valueChanges;
    };
    TreatmentFertilizerFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentFertilizerFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TreatmentFertilizerFormService;
}());
if (false) {
    /** @type {?} */
    TreatmentFertilizerFormService.prototype.formModelSubject;
    /** @type {?} */
    TreatmentFertilizerFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizer = /** @class */ (function () {
    function TreatmentFertilizer(resourceId, name, unit, quantityPerHa, quantity) {
        this.resourceId = resourceId;
        this.name = name;
        this.unit = unit;
        this.quantityPerHa = quantityPerHa;
        this.quantity = quantity;
    }
    return TreatmentFertilizer;
}());
if (false) {
    /** @type {?} */
    TreatmentFertilizer.prototype.resourceId;
    /** @type {?} */
    TreatmentFertilizer.prototype.name;
    /** @type {?} */
    TreatmentFertilizer.prototype.unit;
    /** @type {?} */
    TreatmentFertilizer.prototype.quantityPerHa;
    /** @type {?} */
    TreatmentFertilizer.prototype.quantity;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizerFormComponent = /** @class */ (function () {
    function TreatmentFertilizerFormComponent(numberUtilService, treatmentFertilizerFormService) {
        this.numberUtilService = numberUtilService;
        this.treatmentFertilizerFormService = treatmentFertilizerFormService;
        this.treatmentFertilizerChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = TREATMENT_FERTILIZER_LAYOUT;
        this.treatmentFertilizerFormService.formModelSubject.next(TREATMENT_FERTILIZER_FORM_MODEL);
        this.formGroup = this.treatmentFertilizerFormService.createFormGroup(TREATMENT_FERTILIZER_FORM_MODEL);
    }
    Object.defineProperty(TreatmentFertilizerFormComponent.prototype, "treatmentFertilizer", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.treatmentFertilizerData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.treatmentFertilizerData = value;
            }
            else {
                this.treatmentFertilizerData = new TreatmentFertilizer('', null, TreatmentFertilizerUnit.Kilogram, null, null);
                this.updateFormValue(this.treatmentFertilizerData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentFertilizerFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.treatmentFertilizerFormService.getFormModel$(this.translateKey);
        this.subscribeToFertilizerModelValueChanges(this.formGroup);
        this.subscribeToUnitModelValueChanges(this.formGroup);
        this.subscribeToQantityPerHaModelValueChanges(this.formGroup);
        this.subscribeToQuantityModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.totalAreaInHa && changes.totalAreaInHa.currentValue != null) {
            /** @type {?} */
            var valuePerHa = this.formGroup.get(TREATMENT_FERTILIZER_QUANTITY_PER_HA).value;
            this.calculateQuantity(changes.totalAreaInHa.currentValue, valuePerHa);
        }
    };
    /**
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.fertilizerChangesSubscription.unsubscribe();
        this.unitChangesSubscription.unsubscribe();
        this.quantityPerHaChangesSubscription.unsubscribe();
        this.quantityChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} treatmentFertilizer
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} treatmentFertilizer
     * @return {?}
     */
    function (treatmentFertilizer) {
        /** @type {?} */
        var fertilizerAsString = isEmpty(treatmentFertilizer.resourceId) ? '' :
            JSON.stringify({ rowKey: treatmentFertilizer.resourceId, name: treatmentFertilizer.name });
        this.formGroup.get(TREATMENT_FERTILIZER).patchValue(fertilizerAsString);
        this.formGroup.get(TREATMENT_FERTILIZER_UNIT).patchValue(treatmentFertilizer.unit);
        this.formGroup.get(TREATMENT_FERTILIZER_QUANTITY_PER_HA).patchValue(treatmentFertilizer.quantityPerHa);
        this.formGroup.get(TREATMENT_FERTILIZER_QUANTITY).patchValue(treatmentFertilizer.quantity);
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var fertilizerAsString = this.formGroup.get(TREATMENT_FERTILIZER).value;
        /** @type {?} */
        var fertilizer = isEmpty(fertilizerAsString) ? {} : JSON.parse(fertilizerAsString);
        /** @type {?} */
        var unit = this.formGroup.get(TREATMENT_FERTILIZER_UNIT).value;
        /** @type {?} */
        var quantityPerHa = +this.formGroup.get(TREATMENT_FERTILIZER_QUANTITY_PER_HA).value;
        /** @type {?} */
        var quantity = +this.formGroup.get(TREATMENT_FERTILIZER_QUANTITY).value;
        return new TreatmentFertilizer(fertilizer.rowKey, fertilizer.name, unit, quantityPerHa, quantity);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.subscribeToFertilizerModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.fertilizerChangesSubscription = this.treatmentFertilizerFormService
            .getFertilizerValue$(formGroup)
            .subscribe((/**
         * @param {?} fertilizerAsString
         * @return {?}
         */
        function (fertilizerAsString) {
            _this.onTreatmentFertilizerChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.subscribeToUnitModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.unitChangesSubscription = this.treatmentFertilizerFormService
            .getUnitValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onTreatmentFertilizerChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.subscribeToQantityPerHaModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityPerHaChangesSubscription = this.treatmentFertilizerFormService
            .getQuantityPerHaValue$(formGroup)
            .subscribe((/**
         * @param {?} quantityPerHa
         * @return {?}
         */
        function (quantityPerHa) {
            _this.calculateQuantity(_this.totalAreaInHa, quantityPerHa);
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.subscribeToQuantityModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityChangesSubscription = this.treatmentFertilizerFormService
            .getQuantityValue$(formGroup)
            .subscribe((/**
         * @param {?} quantity
         * @return {?}
         */
        function (quantity) {
            _this.onTreatmentFertilizerChange();
        }));
    };
    /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} quantityPerHa
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.calculateQuantity = /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} quantityPerHa
     * @return {?}
     */
    function (totalAreaInHa, quantityPerHa) {
        /** @type {?} */
        var quantity = 0;
        if (totalAreaInHa != null && quantityPerHa != null) {
            quantity = this.numberUtilService.round3(totalAreaInHa * quantityPerHa);
        }
        this.formGroup.get(TREATMENT_FERTILIZER_QUANTITY).patchValue(quantity);
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentFertilizerFormComponent.prototype.onTreatmentFertilizerChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.treatmentFertilizerData = this.getFormValue();
        this.treatmentFertilizerChange.emit(this.treatmentFertilizerData);
    };
    TreatmentFertilizerFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-fertilizer-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        TreatmentFertilizerFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TreatmentFertilizerFormComponent.ctorParameters = function () { return [
        { type: NumberUtilService },
        { type: TreatmentFertilizerFormService }
    ]; };
    TreatmentFertilizerFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentFertilizer: [{ type: Input }],
        touched: [{ type: Input }],
        treatmentFertilizerChange: [{ type: Output }]
    };
    return TreatmentFertilizerFormComponent;
}());
if (false) {
    /** @type {?} */
    TreatmentFertilizerFormComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentFertilizerFormComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentFertilizerFormComponent.prototype.treatmentFertilizerChange;
    /** @type {?} */
    TreatmentFertilizerFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    TreatmentFertilizerFormComponent.prototype.formLayout;
    /** @type {?} */
    TreatmentFertilizerFormComponent.prototype.formModel$;
    /** @type {?} */
    TreatmentFertilizerFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormComponent.prototype.treatmentFertilizerData;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormComponent.prototype.fertilizerChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormComponent.prototype.unitChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormComponent.prototype.quantityPerHaChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormComponent.prototype.quantityChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormComponent.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormComponent.prototype.treatmentFertilizerFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizerFormControlComponent = /** @class */ (function () {
    function TreatmentFertilizerFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(TreatmentFertilizerFormControlComponent.prototype, "treatmentFertilizer", {
        get: /**
         * @return {?}
         */
        function () {
            return this._treatmentFertilizer;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._treatmentFertilizer = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    TreatmentFertilizerFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._treatmentFertilizer = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentFertilizerFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentFertilizerFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    TreatmentFertilizerFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    TreatmentFertilizerFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-fertilizer-form-control',
                    template: "<app-treatment-fertilizer-form\r\n    [(treatmentFertilizer)]=\"treatmentFertilizer\"\r\n    [translateKey]=\"translateKey\"\r\n    [totalAreaInHa]=\"totalAreaInHa\"\r\n    [touched]=\"touched\">\r\n</app-treatment-fertilizer-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return TreatmentFertilizerFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    TreatmentFertilizerFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentFertilizer: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return TreatmentFertilizerFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormControlComponent.prototype._treatmentFertilizer;
    /** @type {?} */
    TreatmentFertilizerFormControlComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentFertilizerFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentFertilizerFormControlComponent.prototype.touched;
    /** @type {?} */
    TreatmentFertilizerFormControlComponent.prototype.blur;
    /** @type {?} */
    TreatmentFertilizerFormControlComponent.prototype.change;
    /** @type {?} */
    TreatmentFertilizerFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizerFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZERS = 'TREATMENT_FERTILIZERS';
/**
 * @record
 */
function DynamicTreatmentFertilizersFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicTreatmentFertilizersFormControlModelConfig.prototype.totalAreaInHa;
    /** @type {?|undefined} */
    DynamicTreatmentFertilizersFormControlModelConfig.prototype.minCountRequired;
    /** @type {?|undefined} */
    DynamicTreatmentFertilizersFormControlModelConfig.prototype.readOnly;
}
var DynamicTreatmentFertilizersFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicTreatmentFertilizersFormControlModel, _super);
    function DynamicTreatmentFertilizersFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZERS;
        _this.translateKey = config.translateKey;
        _this.totalAreaInHa = config.totalAreaInHa;
        _this.minCountRequired = config.minCountRequired;
        _this.readOnly = config.readOnly;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentFertilizersFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentFertilizersFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentFertilizersFormControlModel.prototype, "totalAreaInHa", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentFertilizersFormControlModel.prototype, "minCountRequired", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicTreatmentFertilizersFormControlModel.prototype, "readOnly", void 0);
    return DynamicTreatmentFertilizersFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlModel.prototype.type;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlModel.prototype.totalAreaInHa;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlModel.prototype.minCountRequired;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlModel.prototype.readOnly;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicTreatmentFertilizersFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicTreatmentFertilizersFormControlComponent, _super);
    function DynamicTreatmentFertilizersFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicTreatmentFertilizersFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-treatment-fertilizers-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-treatment-fertilizers-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [totalAreaInHa]=\"model.totalAreaInHa\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [readOnly]=\"model.readOnly\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-treatment-fertilizers-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicTreatmentFertilizersFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicTreatmentFertilizersFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicTreatmentFertilizersFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicTreatmentFertilizersFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentFertilizersFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentFertilizersFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizers = /** @class */ (function () {
    function TreatmentFertilizers(fertilizers) {
        this.fertilizers = fertilizers;
    }
    return TreatmentFertilizers;
}());
if (false) {
    /** @type {?} */
    TreatmentFertilizers.prototype.fertilizers;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizersFormControlComponent = /** @class */ (function () {
    function TreatmentFertilizersFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(TreatmentFertilizersFormControlComponent.prototype, "treatmentFertilizers", {
        get: /**
         * @return {?}
         */
        function () {
            return this._treatmentFertilizers;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._treatmentFertilizers = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    TreatmentFertilizersFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._treatmentFertilizers = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentFertilizersFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentFertilizersFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    TreatmentFertilizersFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    TreatmentFertilizersFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-fertilizers-form-control',
                    template: "<app-treatment-fertilizers-form\r\n    [(treatmentFertilizers)]=\"treatmentFertilizers\"\r\n    [translateKey]=\"translateKey\"\r\n    [totalAreaInHa]=\"totalAreaInHa\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [readOnly]=\"readOnly\"\r\n    [touched]=\"touched\">\r\n</app-treatment-fertilizers-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return TreatmentFertilizersFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    TreatmentFertilizersFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        readOnly: [{ type: Input }],
        treatmentFertilizers: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return TreatmentFertilizersFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormControlComponent.prototype._treatmentFertilizers;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.readOnly;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.touched;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.blur;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.change;
    /** @type {?} */
    TreatmentFertilizersFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormControlComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$3 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$3 = {
    grid: {
        host: 'treatment-fertilizers-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var TREATMENT_FERTILIZERS_ARRAY_MODEL = 'treatmentFertilizersArrayModel';
/** @type {?} */
var TREATMENT_FERTILIZERS_FERTILIZER = 'fertilizer';
/** @type {?} */
var TREATMENT_FERTILIZERS_LAYOUT = {
    treatmentFertilizersArrayModel: FORM_LAYOUT_INPUT_ALL$3,
    fertilizer: FORM_LAYOUT_INPUT_ALL_ITEM$3
};
var ɵ0$4 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicTreatmentFertilizerFormControlModel({
            id: TREATMENT_FERTILIZERS_FERTILIZER
        })
    ];
};
/** @type {?} */
var TREATMENT_FERTILIZERS_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: TREATMENT_FERTILIZERS_ARRAY_MODEL,
        initialCount: 0,
        groupFactory: (ɵ0$4)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizersFormService = /** @class */ (function () {
    function TreatmentFertilizersFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.formModelTotalAreaInHaSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnTotalAreaInHaChange$ = this.formModelTotalAreaInHaSubject
            .pipe(map((/**
         * @param {?} totalAreaInHa
         * @return {?}
         */
        function (totalAreaInHa) {
            /** @type {?} */
            var formModel = _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey);
            return _this.assignTotalAreaInHa(formModel, totalAreaInHa);
        })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnTotalAreaInHaChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} totalAreaInHa
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.assignTotalAreaInHa = /**
     * @private
     * @param {?} formModel
     * @param {?} totalAreaInHa
     * @return {?}
     */
    function (formModel, totalAreaInHa) {
        if (totalAreaInHa != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_FERTILIZERS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentSeedModel
             * @return {?}
             */
            function (treatmentSeedModel) {
                treatmentSeedModel.totalAreaInHa = totalAreaInHa;
            })); }));
        }
        return formModel;
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_FERTILIZERS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentSeedModel
             * @return {?}
             */
            function (treatmentSeedModel) {
                treatmentSeedModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizersFormService.prototype.getTreatmentFertilizersArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_FERTILIZERS_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.fertilizer; }));
        })));
    };
    TreatmentFertilizersFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentFertilizersFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TreatmentFertilizersFormService;
}());
if (false) {
    /** @type {?} */
    TreatmentFertilizersFormService.prototype.formModelSubject;
    /** @type {?} */
    TreatmentFertilizersFormService.prototype.formModelTotalAreaInHaSubject;
    /** @type {?} */
    TreatmentFertilizersFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentFertilizersFormComponent = /** @class */ (function () {
    function TreatmentFertilizersFormComponent(treatmentFertilizersFormService) {
        var _this = this;
        this.treatmentFertilizersFormService = treatmentFertilizersFormService;
        this.treatmentFertilizersChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getTreatmentFertilizersFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.treatmentFertilizersFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === TREATMENT_FERTILIZERS_ARRAY_MODEL; }))));
        });
        this.getTreatmentFertilizersArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.treatmentFertilizersFormService
                .findModelById(TREATMENT_FERTILIZERS_ARRAY_MODEL, TREATMENT_FERTILIZERS_FORM_MODEL);
            return (/** @type {?} */ (_this.treatmentFertilizersFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = TREATMENT_FERTILIZERS_LAYOUT;
        this.treatmentFertilizersFormService.formModelSubject.next(TREATMENT_FERTILIZERS_FORM_MODEL);
        this.formGroup = this.treatmentFertilizersFormService.createFormGroup(TREATMENT_FERTILIZERS_FORM_MODEL);
        this.subscribeToTreatmentFertilizersArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(TreatmentFertilizersFormComponent.prototype, "treatmentFertilizers", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.fertilizers != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.treatmentFertilizersData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.treatmentFertilizersData = value;
            }
            else {
                this.treatmentFertilizersData = new TreatmentFertilizers([]);
                this.updateFormValue(this.treatmentFertilizersData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentFertilizersFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.treatmentFertilizersFormService.getFormModel$(this.translateKey);
        this.onUpdateTotalAreaInHa(this.totalAreaInHa);
        this.updateFormValue(this.treatmentFertilizersData);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.totalAreaInHa && changes.totalAreaInHa.currentValue) {
            this.onUpdateTotalAreaInHa(changes.totalAreaInHa.currentValue);
        }
    };
    /**
     * @private
     * @param {?} totalAreaInHa
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.onUpdateTotalAreaInHa = /**
     * @private
     * @param {?} totalAreaInHa
     * @return {?}
     */
    function (totalAreaInHa) {
        this.treatmentFertilizersFormService.formModelTotalAreaInHaSubject.next(totalAreaInHa);
    };
    /**
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.treatmentFertilizersArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} treatmentFertilizers
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} treatmentFertilizers
     * @return {?}
     */
    function (treatmentFertilizers) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (treatmentFertilizers != null && treatmentFertilizers.fertilizers != null) {
            groupSize = treatmentFertilizers.fertilizers.length;
            values = treatmentFertilizers.fertilizers.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ fertilizer: x }); }));
        }
        this.treatmentFertilizersFormService.initFormArrayGroup(groupSize, this.getTreatmentFertilizersArrayModelControl(), this.getTreatmentFertilizersFormArrayModel());
        if (values) {
            this.formGroup.get(TREATMENT_FERTILIZERS_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.subscribeToTreatmentFertilizersArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.treatmentFertilizersArrayModelChangesSubscription = this.treatmentFertilizersFormService
            .getTreatmentFertilizersArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.treatmentFertilizersData = null;
            }
            else {
                _this.treatmentFertilizersData = new TreatmentFertilizers(value);
            }
            _this.treatmentFertilizersChange.emit(_this.treatmentFertilizersData);
        }));
    };
    Object.defineProperty(TreatmentFertilizersFormComponent.prototype, "showAddFertilizerButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getTreatmentFertilizersArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentFertilizersFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getTreatmentFertilizersArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.treatmentFertilizersFormService.removeFormArrayGroup(index, this.getTreatmentFertilizersArrayModelControl(), context);
        this.treatmentFertilizersFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.treatmentFertilizersFormService.insertFormArrayGroup(index, this.getTreatmentFertilizersArrayModelControl(), context);
        this.treatmentFertilizersFormService.formModelSubject.next([context]);
        this.treatmentFertilizersFormService.formModelTotalAreaInHaSubject.next(this.totalAreaInHa);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    TreatmentFertilizersFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.treatmentFertilizersFormService.insertFormArrayGroup(0, this.getTreatmentFertilizersArrayModelControl(), this.getTreatmentFertilizersFormArrayModel());
        this.treatmentFertilizersFormService.formModelSubject.next([this.getTreatmentFertilizersFormArrayModel()]);
        this.treatmentFertilizersFormService.formModelTotalAreaInHaSubject.next(this.totalAreaInHa);
        this.updateFormGroupTouched();
    };
    Object.defineProperty(TreatmentFertilizersFormComponent.prototype, "showButtons", {
        get: /**
         * @return {?}
         */
        function () {
            return this.readOnly !== true;
        },
        enumerable: true,
        configurable: true
    });
    TreatmentFertilizersFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-fertilizers-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #treatmentForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddFertilizerButton && showButtons\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addFertilizer' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n                <ng-template modelId=\"treatmentFertilizersArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"treatment-fertilizers-buttons row mt-2 justify-content-md-end justify-content-xl-center mt-xl-0\"\r\n                        *ngIf=\"showButtons\">\r\n                        <div class=\"col-6 col-md-auto px-md-0\">\r\n                            <button type=\"button\" class=\"btn btn-danger\" *ngIf=\"!removeItemDisabled\" (click)=\"removeItem(context, index)\"\r\n                                [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        </div>\r\n                        <div class=\"col-6 col-md-auto\">\r\n                            <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i\r\n                                    class=\"ft-plus\"></i></button>\r\n                        </div>\r\n                    </div>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        TreatmentFertilizersFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TreatmentFertilizersFormComponent.ctorParameters = function () { return [
        { type: TreatmentFertilizersFormService }
    ]; };
    TreatmentFertilizersFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        readOnly: [{ type: Input }],
        treatmentFertilizers: [{ type: Input }],
        touched: [{ type: Input }],
        treatmentFertilizersChange: [{ type: Output }]
    };
    return TreatmentFertilizersFormComponent;
}());
if (false) {
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.minCountRequired;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.readOnly;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormComponent.prototype._touched;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.treatmentFertilizersChange;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.formLayout;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.formModel$;
    /** @type {?} */
    TreatmentFertilizersFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormComponent.prototype.treatmentFertilizersData;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormComponent.prototype.treatmentFertilizersArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormComponent.prototype.getTreatmentFertilizersFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormComponent.prototype.getTreatmentFertilizersArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    TreatmentFertilizersFormComponent.prototype.treatmentFertilizersFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_IRRIGATION = 'TREATMENT_IRRIGATION';
/**
 * @record
 */
function DynamicTreatmentIrrigationFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicTreatmentIrrigationFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicTreatmentIrrigationFormControlModelConfig.prototype.totalAreaInHa;
}
var DynamicTreatmentIrrigationFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicTreatmentIrrigationFormControlModel, _super);
    function DynamicTreatmentIrrigationFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_IRRIGATION;
        _this.translateKey = config.translateKey;
        _this.totalAreaInHa = config.totalAreaInHa;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentIrrigationFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentIrrigationFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentIrrigationFormControlModel.prototype, "totalAreaInHa", void 0);
    return DynamicTreatmentIrrigationFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlModel.prototype.type;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlModel.prototype.totalAreaInHa;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicTreatmentIrrigationFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicTreatmentIrrigationFormControlComponent, _super);
    function DynamicTreatmentIrrigationFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicTreatmentIrrigationFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-treatment-irrigation-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-treatment-irrigation-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [totalAreaInHa]=\"model.totalAreaInHa\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-treatment-irrigation-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicTreatmentIrrigationFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicTreatmentIrrigationFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicTreatmentIrrigationFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicTreatmentIrrigationFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentIrrigationFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentIrrigationFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$6 = {
    grid: {
        host: 'treatment-irrigation-host',
        container: 'treatment-irrigation-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var TREATMENT_IRRIGATION_QUANTITY_PER_M2 = 'quantityPerM2';
/** @type {?} */
var TREATMENT_IRRIGATION_UNIT = 'unit';
/** @type {?} */
var TREATMENT_IRRIGATION_QUANTITY = 'quantity';
/** @type {?} */
var TREATMENT_IRRIGATION_LAYOUT = {
    quantityPerM2: FORM_LAYOUT_INPUT$6,
    unit: FORM_LAYOUT_INPUT$6,
    quantity: FORM_LAYOUT_INPUT$6,
};
/** @type {?} */
var TREATMENT_IRRIGATION_FORM_MODEL = [
    new DynamicInputModel({
        id: 'quantityPerM2',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        }
    }),
    new DynamicSelectModel({
        id: 'unit',
        options: getOptionsForDynamicSelectModel(TreatmentIrrigationUnit, 'TREATMENT_IRRIGATION_UNITS', false),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'quantity',
        readOnly: true,
        inputType: 'number'
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentIrrigationFormService = /** @class */ (function () {
    function TreatmentIrrigationFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    TreatmentIrrigationFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentIrrigationFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    TreatmentIrrigationFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    TreatmentIrrigationFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentIrrigationFormService.prototype.getUnitValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_IRRIGATION_UNIT).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentIrrigationFormService.prototype.getQuantityPerM2Value$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_IRRIGATION_QUANTITY_PER_M2).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentIrrigationFormService.prototype.getQuantityValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_IRRIGATION_QUANTITY).valueChanges;
    };
    TreatmentIrrigationFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentIrrigationFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TreatmentIrrigationFormService;
}());
if (false) {
    /** @type {?} */
    TreatmentIrrigationFormService.prototype.formModelSubject;
    /** @type {?} */
    TreatmentIrrigationFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentIrrigation = /** @class */ (function () {
    function TreatmentIrrigation(quantityPerM2, unit, quantity) {
        this.quantityPerM2 = quantityPerM2;
        this.unit = unit;
        this.quantity = quantity;
    }
    return TreatmentIrrigation;
}());
if (false) {
    /** @type {?} */
    TreatmentIrrigation.prototype.quantityPerM2;
    /** @type {?} */
    TreatmentIrrigation.prototype.unit;
    /** @type {?} */
    TreatmentIrrigation.prototype.quantity;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentIrrigationFormComponent = /** @class */ (function () {
    function TreatmentIrrigationFormComponent(numberUtilService, treatmentIrrigationFormService) {
        this.numberUtilService = numberUtilService;
        this.treatmentIrrigationFormService = treatmentIrrigationFormService;
        this.treatmentIrrigationChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = TREATMENT_IRRIGATION_LAYOUT;
        this.treatmentIrrigationFormService.formModelSubject.next(TREATMENT_IRRIGATION_FORM_MODEL);
        this.formGroup = this.treatmentIrrigationFormService.createFormGroup(TREATMENT_IRRIGATION_FORM_MODEL);
    }
    Object.defineProperty(TreatmentIrrigationFormComponent.prototype, "treatmentIrrigation", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.treatmentIrrigationData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.treatmentIrrigationData = value;
            }
            else {
                this.treatmentIrrigationData = new TreatmentIrrigation(null, TreatmentIrrigationUnit.Liter, null);
                this.updateFormValue(this.treatmentIrrigationData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentIrrigationFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.treatmentIrrigationFormService.getFormModel$(this.translateKey);
        this.subscribeToUnitModelValueChanges(this.formGroup);
        this.subscribeToQuantityPerM2ModelValueChanges(this.formGroup);
        this.subscribeToQuantityModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.totalAreaInHa && changes.totalAreaInHa.currentValue != null) {
            /** @type {?} */
            var quantityPerM2 = this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY_PER_M2).value;
            /** @type {?} */
            var unit = this.formGroup.get(TREATMENT_IRRIGATION_UNIT).value;
            this.calculateQuantity(changes.totalAreaInHa.currentValue, quantityPerM2, unit);
        }
    };
    /**
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unitChangesSubscription.unsubscribe();
        this.quantityPerM2ChangesSubscription.unsubscribe();
        this.quantityChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} treatmentIrrigation
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} treatmentIrrigation
     * @return {?}
     */
    function (treatmentIrrigation) {
        this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY_PER_M2).patchValue(treatmentIrrigation.quantityPerM2);
        this.formGroup.get(TREATMENT_IRRIGATION_UNIT).patchValue(treatmentIrrigation.unit);
        this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY).patchValue(treatmentIrrigation.quantity);
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var quantityPerM2 = +this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY_PER_M2).value;
        /** @type {?} */
        var unit = this.formGroup.get(TREATMENT_IRRIGATION_UNIT).value;
        /** @type {?} */
        var quantity = +this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY).value;
        return new TreatmentIrrigation(quantityPerM2, unit, quantity);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.subscribeToUnitModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.unitChangesSubscription = this.treatmentIrrigationFormService
            .getUnitValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            /** @type {?} */
            var quantityPerM2 = _this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY_PER_M2).value;
            _this.calculateQuantity(_this.totalAreaInHa, quantityPerM2, unit);
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.subscribeToQuantityPerM2ModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityPerM2ChangesSubscription = this.treatmentIrrigationFormService
            .getQuantityPerM2Value$(formGroup)
            .subscribe((/**
         * @param {?} quantityPerM2
         * @return {?}
         */
        function (quantityPerM2) {
            /** @type {?} */
            var unit = _this.formGroup.get(TREATMENT_IRRIGATION_UNIT).value;
            _this.calculateQuantity(_this.totalAreaInHa, quantityPerM2, unit);
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.subscribeToQuantityModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityChangesSubscription = this.treatmentIrrigationFormService
            .getQuantityValue$(formGroup)
            .subscribe((/**
         * @param {?} quantity
         * @return {?}
         */
        function (quantity) {
            _this.onTreatmentIrrigationChange();
        }));
    };
    /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} quantityPerM2
     * @param {?} unit
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.calculateQuantity = /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} quantityPerM2
     * @param {?} unit
     * @return {?}
     */
    function (totalAreaInHa, quantityPerM2, unit) {
        if (totalAreaInHa == null || quantityPerM2 == null || unit == null) {
            this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY).patchValue(0);
            return;
        }
        // tslint:disable-next-line: no-magic-numbers
        /** @type {?} */
        var quantity = this.numberUtilService.round3(quantityPerM2 * totalAreaInHa * 10000);
        this.formGroup.get(TREATMENT_IRRIGATION_QUANTITY).patchValue(quantity);
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentIrrigationFormComponent.prototype.onTreatmentIrrigationChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.treatmentIrrigationData = this.getFormValue();
        this.treatmentIrrigationChange.emit(this.treatmentIrrigationData);
    };
    TreatmentIrrigationFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-irrigation-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        TreatmentIrrigationFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TreatmentIrrigationFormComponent.ctorParameters = function () { return [
        { type: NumberUtilService },
        { type: TreatmentIrrigationFormService }
    ]; };
    TreatmentIrrigationFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentIrrigation: [{ type: Input }],
        touched: [{ type: Input }],
        treatmentIrrigationChange: [{ type: Output }]
    };
    return TreatmentIrrigationFormComponent;
}());
if (false) {
    /** @type {?} */
    TreatmentIrrigationFormComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentIrrigationFormComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentIrrigationFormComponent.prototype.treatmentIrrigationChange;
    /** @type {?} */
    TreatmentIrrigationFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    TreatmentIrrigationFormComponent.prototype.formLayout;
    /** @type {?} */
    TreatmentIrrigationFormComponent.prototype.formModel$;
    /** @type {?} */
    TreatmentIrrigationFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormComponent.prototype.treatmentIrrigationData;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormComponent.prototype.unitChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormComponent.prototype.quantityPerM2ChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormComponent.prototype.quantityChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormComponent.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormComponent.prototype.treatmentIrrigationFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentIrrigationFormControlComponent = /** @class */ (function () {
    function TreatmentIrrigationFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(TreatmentIrrigationFormControlComponent.prototype, "treatmentIrrigation", {
        get: /**
         * @return {?}
         */
        function () {
            return this._treatmentIrrigation;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._treatmentIrrigation = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    TreatmentIrrigationFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._treatmentIrrigation = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentIrrigationFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentIrrigationFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    TreatmentIrrigationFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    TreatmentIrrigationFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-irrigation-form-control',
                    template: "<app-treatment-irrigation-form\r\n    [(treatmentIrrigation)]=\"treatmentIrrigation\"\r\n    [translateKey]=\"translateKey\"\r\n    [totalAreaInHa]=\"totalAreaInHa\"\r\n    [touched]=\"touched\">\r\n</app-treatment-irrigation-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return TreatmentIrrigationFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    TreatmentIrrigationFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentIrrigation: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return TreatmentIrrigationFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormControlComponent.prototype._treatmentIrrigation;
    /** @type {?} */
    TreatmentIrrigationFormControlComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentIrrigationFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentIrrigationFormControlComponent.prototype.touched;
    /** @type {?} */
    TreatmentIrrigationFormControlComponent.prototype.blur;
    /** @type {?} */
    TreatmentIrrigationFormControlComponent.prototype.change;
    /** @type {?} */
    TreatmentIrrigationFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    TreatmentIrrigationFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDE = 'TREATMENT_PESTICIDE';
/**
 * @record
 */
function DynamicTreatmentPesticideFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicTreatmentPesticideFormControlModelConfig.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlModelConfig.prototype.pesticideTypes;
    /** @type {?|undefined} */
    DynamicTreatmentPesticideFormControlModelConfig.prototype.totalAreaInHa;
}
var DynamicTreatmentPesticideFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicTreatmentPesticideFormControlModel, _super);
    function DynamicTreatmentPesticideFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDE;
        _this.pesticideTypes = config.pesticideTypes;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentPesticideFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentPesticideFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicTreatmentPesticideFormControlModel.prototype, "pesticideTypes", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentPesticideFormControlModel.prototype, "totalAreaInHa", void 0);
    return DynamicTreatmentPesticideFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicTreatmentPesticideFormControlModel.prototype.type;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlModel.prototype.pesticideTypes;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlModel.prototype.totalAreaInHa;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicTreatmentPesticideFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicTreatmentPesticideFormControlComponent, _super);
    function DynamicTreatmentPesticideFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicTreatmentPesticideFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-treatment-pesticide-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-treatment-pesticide-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [pesticideTypes]=\"model.pesticideTypes\"\r\n        [totalAreaInHa]=\"model.totalAreaInHa\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-treatment-pesticide-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicTreatmentPesticideFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicTreatmentPesticideFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicTreatmentPesticideFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicTreatmentPesticideFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicTreatmentPesticideFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentPesticideFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentPesticideFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$7 = {
    grid: {
        host: 'treatment-pesticide-host col-12 col-md-6 col-xl-auto',
        container: 'treatment-pesticide-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var TREATMENT_PESTICIDE = 'pesticide';
/** @type {?} */
var TREATMENT_PESTICIDE_UNIT = 'unit';
/** @type {?} */
var TREATMENT_PESTICIDE_QUANTITY_PER_HA = 'quantityPerHa';
/** @type {?} */
var TREATMENT_PESTICIDE_QUANTITY = 'quantity';
/** @type {?} */
var TREATMENT_PESTICIDE_REASON_OF_USAGE = 'reasonOfUsage';
/** @type {?} */
var TREATMENT_PESTICIDE_LAYOUT = {
    pesticide: FORM_LAYOUT_INPUT$7,
    unit: FORM_LAYOUT_INPUT$7,
    quantityPerHa: FORM_LAYOUT_INPUT$7,
    quantity: FORM_LAYOUT_INPUT$7,
    reasonOfUsage: FORM_LAYOUT_INPUT$7,
};
/** @type {?} */
var TREATMENT_PESTICIDE_FORM_MODEL = [
    new DynamicMultiSelectControlModel({
        id: 'pesticide',
        bindLabel: nameof('name'),
        multiple: false,
        validators: {
            required: null
        },
        searchByField: nameof('name')
    }),
    new DynamicSelectModel({
        id: 'unit',
        options: getOptionsForDynamicSelectModel(TreatmentPesticideUnit, 'TREATMENT_PESTICIDE_UNITS', false),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'quantityPerHa',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        }
    }),
    new DynamicInputModel({
        id: 'quantity',
        readOnly: true,
        inputType: 'number'
    }),
    new DynamicInputModel({
        id: 'reasonOfUsage',
        maxLength: 100,
        validators: {
            maxLength: 100
        }
    }),
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticideFormService = /** @class */ (function () {
    function TreatmentPesticideFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.getPesticideValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_PESTICIDE).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.getUnitValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_PESTICIDE_UNIT).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.getQuantityPerHaValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_PESTICIDE_QUANTITY_PER_HA).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.getQuantityValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_PESTICIDE_QUANTITY).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormService.prototype.getReasonOfUsageValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_PESTICIDE_REASON_OF_USAGE).valueChanges;
    };
    TreatmentPesticideFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentPesticideFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TreatmentPesticideFormService;
}());
if (false) {
    /** @type {?} */
    TreatmentPesticideFormService.prototype.formModelSubject;
    /** @type {?} */
    TreatmentPesticideFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticide = /** @class */ (function () {
    function TreatmentPesticide(resourceId, name, unit, quantityPerHa, quantity, reasonOfUsage, gracePeriod) {
        this.resourceId = resourceId;
        this.name = name;
        this.unit = unit;
        this.quantityPerHa = quantityPerHa;
        this.quantity = quantity;
        this.reasonOfUsage = reasonOfUsage;
        this.gracePeriod = gracePeriod;
    }
    return TreatmentPesticide;
}());
if (false) {
    /** @type {?} */
    TreatmentPesticide.prototype.resourceId;
    /** @type {?} */
    TreatmentPesticide.prototype.name;
    /** @type {?} */
    TreatmentPesticide.prototype.unit;
    /** @type {?} */
    TreatmentPesticide.prototype.quantityPerHa;
    /** @type {?} */
    TreatmentPesticide.prototype.quantity;
    /** @type {?} */
    TreatmentPesticide.prototype.reasonOfUsage;
    /** @type {?} */
    TreatmentPesticide.prototype.gracePeriod;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticideFormComponent = /** @class */ (function () {
    function TreatmentPesticideFormComponent(treatmentPesticideFormService, numberUtilService) {
        this.treatmentPesticideFormService = treatmentPesticideFormService;
        this.numberUtilService = numberUtilService;
        this.treatmentPesticideChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = TREATMENT_PESTICIDE_LAYOUT;
        this.treatmentPesticideFormService.formModelSubject.next(TREATMENT_PESTICIDE_FORM_MODEL);
        this.formGroup = this.treatmentPesticideFormService.createFormGroup(TREATMENT_PESTICIDE_FORM_MODEL);
    }
    Object.defineProperty(TreatmentPesticideFormComponent.prototype, "treatmentPesticide", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.treatmentPesticideData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.treatmentPesticideData = value;
            }
            else {
                this.treatmentPesticideData = new TreatmentPesticide(null, null, TreatmentPesticideUnit.Liter, null, null, '', null);
                this.updateFormValue(this.treatmentPesticideData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentPesticideFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.treatmentPesticideFormService.getFormModel$(this.translateKey);
        this.subscribeToPesticideModelValueChanges(this.formGroup);
        this.subscribeToUnitModelValueChanges(this.formGroup);
        this.subscribeToQuantityPerHaModelValueChanges(this.formGroup);
        this.subscribeToQuantityModelValueChanges(this.formGroup);
        this.subscribeToReasonOfUsageModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.totalAreaInHa && changes.totalAreaInHa.currentValue != null) {
            /** @type {?} */
            var quantityPerHa = this.formGroup.get(TREATMENT_PESTICIDE_QUANTITY_PER_HA).value;
            this.calculateQuantity(changes.totalAreaInHa.currentValue, quantityPerHa);
        }
        if (changes && changes.pesticideTypes) {
            this.treatmentPesticideModel.items = changes.pesticideTypes.currentValue;
            this.updatePesticideFormValue(this.pesticideResourceId, changes.pesticideTypes.currentValue);
        }
    };
    /**
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.pesticideChangesSubscription.unsubscribe();
        this.unitChangesSubscription.unsubscribe();
        this.quantityPerHaChangesSubscription.unsubscribe();
        this.quantityChangesSubscription.unsubscribe();
        this.reasonOfUsageChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} treatmentPesticide
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} treatmentPesticide
     * @return {?}
     */
    function (treatmentPesticide) {
        this.pesticideResourceId = treatmentPesticide.resourceId;
        this.updatePesticideFormValue(treatmentPesticide.resourceId, this.pesticideTypes);
        this.formGroup.get(TREATMENT_PESTICIDE_UNIT).patchValue(treatmentPesticide.unit);
        this.formGroup.get(TREATMENT_PESTICIDE_QUANTITY_PER_HA).patchValue(treatmentPesticide.quantityPerHa);
        this.formGroup.get(TREATMENT_PESTICIDE_QUANTITY).patchValue(treatmentPesticide.quantity);
        this.formGroup.get(TREATMENT_PESTICIDE_REASON_OF_USAGE).patchValue(treatmentPesticide.reasonOfUsage);
    };
    /**
     * @private
     * @param {?} resourceId
     * @param {?} pesticideTypes
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.updatePesticideFormValue = /**
     * @private
     * @param {?} resourceId
     * @param {?} pesticideTypes
     * @return {?}
     */
    function (resourceId, pesticideTypes) {
        /** @type {?} */
        var pesticideType = (pesticideTypes || []).find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.rowKey === resourceId; }));
        this.gracePeriod = this.getGracePeriodFromPesticide(pesticideType);
        this.formGroup.get(TREATMENT_PESTICIDE).patchValue(pesticideType);
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var pesticideType = this.formGroup.get(TREATMENT_PESTICIDE).value;
        /** @type {?} */
        var unit = this.formGroup.get(TREATMENT_PESTICIDE_UNIT).value;
        /** @type {?} */
        var quantityPerHa = +this.formGroup.get(TREATMENT_PESTICIDE_QUANTITY_PER_HA).value;
        /** @type {?} */
        var quantity = +this.formGroup.get(TREATMENT_PESTICIDE_QUANTITY).value;
        /** @type {?} */
        var reasonOfUsage = this.formGroup.get(TREATMENT_PESTICIDE_REASON_OF_USAGE).value;
        return new TreatmentPesticide(pesticideType != null ? pesticideType.rowKey : null, pesticideType != null ? pesticideType.name : null, unit, quantityPerHa, quantity, reasonOfUsage, this.gracePeriod);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.subscribeToPesticideModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.pesticideChangesSubscription = this.treatmentPesticideFormService
            .getPesticideValue$(formGroup)
            .subscribe((/**
         * @param {?} pesticideType
         * @return {?}
         */
        function (pesticideType) {
            _this.gracePeriod = _this.getGracePeriodFromPesticide(pesticideType);
            _this.onTreatmentPesticideChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.subscribeToUnitModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.unitChangesSubscription = this.treatmentPesticideFormService
            .getUnitValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onTreatmentPesticideChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.subscribeToQuantityPerHaModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityPerHaChangesSubscription = this.treatmentPesticideFormService
            .getQuantityPerHaValue$(formGroup)
            .subscribe((/**
         * @param {?} quantityPerHa
         * @return {?}
         */
        function (quantityPerHa) {
            _this.calculateQuantity(_this.totalAreaInHa, quantityPerHa);
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.subscribeToQuantityModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityChangesSubscription = this.treatmentPesticideFormService
            .getQuantityValue$(formGroup)
            .subscribe((/**
         * @param {?} quantity
         * @return {?}
         */
        function (quantity) {
            _this.onTreatmentPesticideChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.subscribeToReasonOfUsageModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.reasonOfUsageChangesSubscription = this.treatmentPesticideFormService
            .getReasonOfUsageValue$(formGroup)
            .subscribe((/**
         * @param {?} reasonOfUsage
         * @return {?}
         */
        function (reasonOfUsage) {
            _this.onTreatmentPesticideChange();
        }));
    };
    /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} quantityPerHa
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.calculateQuantity = /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} quantityPerHa
     * @return {?}
     */
    function (totalAreaInHa, quantityPerHa) {
        /** @type {?} */
        var quantity = 0;
        if (totalAreaInHa != null && quantityPerHa != null) {
            quantity = this.numberUtilService.round3(totalAreaInHa * quantityPerHa);
        }
        this.formGroup.get(TREATMENT_PESTICIDE_QUANTITY).patchValue(quantity);
    };
    /**
     * @private
     * @param {?} pesticideType
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.getGracePeriodFromPesticide = /**
     * @private
     * @param {?} pesticideType
     * @return {?}
     */
    function (pesticideType) {
        if (pesticideType != null && pesticideType.gracePeriods != null && pesticideType.gracePeriods.length > 0) {
            return pesticideType.gracePeriods[0];
        }
        return null;
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentPesticideFormComponent.prototype.onTreatmentPesticideChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.treatmentPesticideData = this.getFormValue();
        this.treatmentPesticideChange.emit(this.treatmentPesticideData);
    };
    Object.defineProperty(TreatmentPesticideFormComponent.prototype, "treatmentPesticideModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this.treatmentPesticideFormService
                .findModelById(TREATMENT_PESTICIDE, TREATMENT_PESTICIDE_FORM_MODEL)));
        },
        enumerable: true,
        configurable: true
    });
    TreatmentPesticideFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-pesticide-form',
                    template: "<div class=\"container-fluid px-0 mt-2\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n    <div *ngIf=\"gracePeriod != null\" class=\"description mt-1 mb-2\">\r\n        <span>{{ translateKey + '.gracePeriod' | translate}}</span>\r\n        <span class=\"font-weight-bold\"> {{ gracePeriod }}</span>\r\n    </div>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        TreatmentPesticideFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TreatmentPesticideFormComponent.ctorParameters = function () { return [
        { type: TreatmentPesticideFormService },
        { type: NumberUtilService }
    ]; };
    TreatmentPesticideFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        pesticideTypes: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentPesticide: [{ type: Input }],
        touched: [{ type: Input }],
        treatmentPesticideChange: [{ type: Output }]
    };
    return TreatmentPesticideFormComponent;
}());
if (false) {
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.pesticideTypes;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.treatmentPesticideChange;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.formLayout;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.formModel$;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.formGroup;
    /** @type {?} */
    TreatmentPesticideFormComponent.prototype.gracePeriod;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.treatmentPesticideData;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.pesticideResourceId;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.pesticideChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.unitChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.quantityPerHaChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.quantityChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.reasonOfUsageChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.treatmentPesticideFormService;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormComponent.prototype.numberUtilService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticideFormControlComponent = /** @class */ (function () {
    function TreatmentPesticideFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(TreatmentPesticideFormControlComponent.prototype, "treatmentPesticide", {
        get: /**
         * @return {?}
         */
        function () {
            return this._treatmentPesticide;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._treatmentPesticide = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    TreatmentPesticideFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._treatmentPesticide = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentPesticideFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentPesticideFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    TreatmentPesticideFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    TreatmentPesticideFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-pesticide-form-control',
                    template: "<app-treatment-pesticide-form\r\n    [(treatmentPesticide)]=\"treatmentPesticide\"\r\n    [translateKey]=\"translateKey\"\r\n    [pesticideTypes]=\"pesticideTypes\"\r\n    [totalAreaInHa]=\"totalAreaInHa\"\r\n    [touched]=\"touched\">\r\n</app-treatment-pesticide-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return TreatmentPesticideFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    TreatmentPesticideFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        pesticideTypes: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentPesticide: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return TreatmentPesticideFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormControlComponent.prototype._treatmentPesticide;
    /** @type {?} */
    TreatmentPesticideFormControlComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentPesticideFormControlComponent.prototype.pesticideTypes;
    /** @type {?} */
    TreatmentPesticideFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentPesticideFormControlComponent.prototype.touched;
    /** @type {?} */
    TreatmentPesticideFormControlComponent.prototype.blur;
    /** @type {?} */
    TreatmentPesticideFormControlComponent.prototype.change;
    /** @type {?} */
    TreatmentPesticideFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticideFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDES = 'TREATMENT_PESTICIDES';
/**
 * @record
 */
function DynamicTreatmentPesticidesFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicTreatmentPesticidesFormControlModelConfig.prototype.totalAreaInHa;
    /** @type {?|undefined} */
    DynamicTreatmentPesticidesFormControlModelConfig.prototype.tenantId;
    /** @type {?|undefined} */
    DynamicTreatmentPesticidesFormControlModelConfig.prototype.cultivationCodeName;
    /** @type {?|undefined} */
    DynamicTreatmentPesticidesFormControlModelConfig.prototype.cultivationTypeCodeName;
    /** @type {?|undefined} */
    DynamicTreatmentPesticidesFormControlModelConfig.prototype.minCountRequired;
}
var DynamicTreatmentPesticidesFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicTreatmentPesticidesFormControlModel, _super);
    function DynamicTreatmentPesticidesFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDES;
        _this.translateKey = config.translateKey;
        _this.totalAreaInHa = config.totalAreaInHa;
        _this.tenantId = config.tenantId;
        _this.cultivationCodeName = config.cultivationCodeName;
        _this.cultivationTypeCodeName = config.cultivationTypeCodeName;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentPesticidesFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentPesticidesFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentPesticidesFormControlModel.prototype, "totalAreaInHa", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentPesticidesFormControlModel.prototype, "tenantId", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentPesticidesFormControlModel.prototype, "cultivationCodeName", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentPesticidesFormControlModel.prototype, "cultivationTypeCodeName", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentPesticidesFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicTreatmentPesticidesFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModel.prototype.type;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModel.prototype.totalAreaInHa;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModel.prototype.tenantId;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModel.prototype.cultivationCodeName;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModel.prototype.cultivationTypeCodeName;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicTreatmentPesticidesFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicTreatmentPesticidesFormControlComponent, _super);
    function DynamicTreatmentPesticidesFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicTreatmentPesticidesFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-treatment-pesticides-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-treatment-pesticides-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [totalAreaInHa]=\"model.totalAreaInHa\"\r\n        [tenantId]=\"model.tenantId\"\r\n        [cultivationCodeName]=\"model.cultivationCodeName\"\r\n        [cultivationTypeCodeName]=\"model.cultivationTypeCodeName\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-treatment-pesticides-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicTreatmentPesticidesFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicTreatmentPesticidesFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicTreatmentPesticidesFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicTreatmentPesticidesFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentPesticidesFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentPesticidesFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticides = /** @class */ (function () {
    function TreatmentPesticides(pesticides) {
        this.pesticides = pesticides;
    }
    return TreatmentPesticides;
}());
if (false) {
    /** @type {?} */
    TreatmentPesticides.prototype.pesticides;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticidesFormControlComponent = /** @class */ (function () {
    function TreatmentPesticidesFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(TreatmentPesticidesFormControlComponent.prototype, "treatmentPesticides", {
        get: /**
         * @return {?}
         */
        function () {
            return this._treatmentPesticides;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._treatmentPesticides = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    TreatmentPesticidesFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._treatmentPesticides = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentPesticidesFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentPesticidesFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    TreatmentPesticidesFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    TreatmentPesticidesFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-pesticides-form-control',
                    template: "<app-treatment-pesticides-form\r\n    [(treatmentPesticides)]=\"treatmentPesticides\"\r\n    [translateKey]=\"translateKey\"\r\n    [totalAreaInHa]=\"totalAreaInHa\"\r\n    [tenantId]=\"tenantId\"\r\n    [cultivationCodeName]=\"cultivationCodeName\"\r\n    [cultivationTypeCodeName]=\"cultivationTypeCodeName\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [touched]=\"touched\">\r\n</app-treatment-pesticides-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return TreatmentPesticidesFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    TreatmentPesticidesFormControlComponent.propDecorators = {
        tenantId: [{ type: Input }],
        cultivationCodeName: [{ type: Input }],
        cultivationTypeCodeName: [{ type: Input }],
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        treatmentPesticides: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return TreatmentPesticidesFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormControlComponent.prototype._treatmentPesticides;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.tenantId;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.cultivationCodeName;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.cultivationTypeCodeName;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.touched;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.blur;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.change;
    /** @type {?} */
    TreatmentPesticidesFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormControlComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$4 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$4 = {
    grid: {
        host: 'treatment-pesticides-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var TREATMENT_PESTICIDES_ARRAY_MODEL = 'treatmentPesticidesArrayModel';
/** @type {?} */
var TREATMENT_PESTICIDES_PESTICIDE = 'pesticide';
/** @type {?} */
var TREATMENT_PESTICIDES_LAYOUT = {
    treatmentPesticidesArrayModel: FORM_LAYOUT_INPUT_ALL$4,
    pesticide: FORM_LAYOUT_INPUT_ALL_ITEM$4
};
var ɵ0$5 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicTreatmentPesticideFormControlModel({
            id: TREATMENT_PESTICIDES_PESTICIDE,
            pesticideTypes: []
        })
    ];
};
/** @type {?} */
var TREATMENT_PESTICIDES_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: TREATMENT_PESTICIDES_ARRAY_MODEL,
        initialCount: 0,
        groupFactory: (ɵ0$5)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticidesFormService = /** @class */ (function () {
    function TreatmentPesticidesFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.formModelPesticideTypesSubject = new BehaviorSubject(null);
        this.formModelTotalAreaInHaSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelPesticideTypesChange$ = this.formModelPesticideTypesSubject
            .pipe(map((/**
         * @param {?} pesticideTypes
         * @return {?}
         */
        function (pesticideTypes) {
            /** @type {?} */
            var formModel = _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey);
            return _this.assignPesticideTypes(formModel, pesticideTypes);
        })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTotalAreaInHa(formModel, _this.formModelTotalAreaInHaSubject.getValue()); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnTotalAreaInHaChange$ = this.formModelTotalAreaInHaSubject
            .pipe(map((/**
         * @param {?} totalAreaInHa
         * @return {?}
         */
        function (totalAreaInHa) {
            /** @type {?} */
            var formModel = _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey);
            return _this.assignTotalAreaInHa(formModel, totalAreaInHa);
        })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignPesticideTypes(formModel, _this.formModelPesticideTypesSubject.getValue()); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelPesticideTypesChange$, formModelOnTotalAreaInHaChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} pesticideTypes
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.assignPesticideTypes = /**
     * @private
     * @param {?} formModel
     * @param {?} pesticideTypes
     * @return {?}
     */
    function (formModel, pesticideTypes) {
        if (pesticideTypes != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_PESTICIDES_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentPesticideModel
             * @return {?}
             */
            function (treatmentPesticideModel) {
                treatmentPesticideModel.pesticideTypes = pesticideTypes;
            })); }));
        }
        return formModel;
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} totalAreaInHa
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.assignTotalAreaInHa = /**
     * @private
     * @param {?} formModel
     * @param {?} totalAreaInHa
     * @return {?}
     */
    function (formModel, totalAreaInHa) {
        if (totalAreaInHa != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_PESTICIDES_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentPesticideModel
             * @return {?}
             */
            function (treatmentPesticideModel) {
                treatmentPesticideModel.totalAreaInHa = totalAreaInHa;
            })); }));
        }
        return formModel;
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_PESTICIDES_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentSeedModel
             * @return {?}
             */
            function (treatmentSeedModel) {
                treatmentSeedModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticidesFormService.prototype.getTreatmentPesticidesArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_PESTICIDES_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.pesticide; }));
        })));
    };
    TreatmentPesticidesFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentPesticidesFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TreatmentPesticidesFormService;
}());
if (false) {
    /** @type {?} */
    TreatmentPesticidesFormService.prototype.formModelSubject;
    /** @type {?} */
    TreatmentPesticidesFormService.prototype.formModelPesticideTypesSubject;
    /** @type {?} */
    TreatmentPesticidesFormService.prototype.formModelTotalAreaInHaSubject;
    /** @type {?} */
    TreatmentPesticidesFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentPesticidesFormComponent = /** @class */ (function () {
    function TreatmentPesticidesFormComponent(pesticideTypeDictionaryService, treatmentPesticidesFormService) {
        var _this = this;
        this.pesticideTypeDictionaryService = pesticideTypeDictionaryService;
        this.treatmentPesticidesFormService = treatmentPesticidesFormService;
        this.treatmentPesticidesChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getTreatmentPesticidesFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.treatmentPesticidesFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === TREATMENT_PESTICIDES_ARRAY_MODEL; }))));
        });
        this.getTreatmentPesticidesArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.treatmentPesticidesFormService
                .findModelById(TREATMENT_PESTICIDES_ARRAY_MODEL, TREATMENT_PESTICIDES_FORM_MODEL);
            return (/** @type {?} */ (_this.treatmentPesticidesFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = TREATMENT_PESTICIDES_LAYOUT;
        this.treatmentPesticidesFormService.formModelSubject.next(TREATMENT_PESTICIDES_FORM_MODEL);
        this.formGroup = this.treatmentPesticidesFormService.createFormGroup(TREATMENT_PESTICIDES_FORM_MODEL);
        this.subscribeToTreatmentPesticidesArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(TreatmentPesticidesFormComponent.prototype, "treatmentPesticides", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.pesticides != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.treatmentPesticidesData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.treatmentPesticidesData = value;
            }
            else {
                this.treatmentPesticidesData = new TreatmentPesticides([]);
                this.updateFormValue(this.treatmentPesticidesData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentPesticidesFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.treatmentPesticidesFormService.getFormModel$(this.translateKey);
        this.onUpdateTotalAreaInHa(this.totalAreaInHa);
        this.updateFormValue(this.treatmentPesticidesData);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.totalAreaInHa && changes.totalAreaInHa.currentValue) {
            this.onUpdateTotalAreaInHa(changes.totalAreaInHa.currentValue);
        }
        if (changes && changes.tenantId && changes.tenantId.currentValue) {
            this.loadPesticides(changes.tenantId.currentValue, this.cultivationCodeName, this.cultivationTypeCodeName);
        }
        if (changes && changes.cultivationCodeName && changes.cultivationCodeName.currentValue) {
            this.loadPesticides(this.tenantId, changes.cultivationCodeName.currentValue, this.cultivationTypeCodeName);
        }
        if (changes && changes.cultivationTypeCodeName && changes.cultivationTypeCodeName.currentValue) {
            this.loadPesticides(this.tenantId, this.cultivationCodeName, changes.cultivationTypeCodeName.currentValue);
        }
    };
    /**
     * @private
     * @param {?} tenantId
     * @param {?} cultivationCodeName
     * @param {?} cultivationTypeCodeName
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.loadPesticides = /**
     * @private
     * @param {?} tenantId
     * @param {?} cultivationCodeName
     * @param {?} cultivationTypeCodeName
     * @return {?}
     */
    function (tenantId, cultivationCodeName, cultivationTypeCodeName) {
        var _this = this;
        this.displaySpinner$.next(true);
        this.pesticideTypeDictionaryService
            .loadDataByCultivationAndCultivationType(tenantId, cultivationCodeName, cultivationTypeCodeName)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var pesticideTypes = (data || []).sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.name.localeCompare(b.name); }));
            _this.onUpdatePesticidedTypes(pesticideTypes);
        }));
    };
    /**
     * @private
     * @param {?} pesticideTypes
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.onUpdatePesticidedTypes = /**
     * @private
     * @param {?} pesticideTypes
     * @return {?}
     */
    function (pesticideTypes) {
        this.treatmentPesticidesFormService.formModelPesticideTypesSubject.next(pesticideTypes);
    };
    /**
     * @private
     * @param {?} totalAreaInHa
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.onUpdateTotalAreaInHa = /**
     * @private
     * @param {?} totalAreaInHa
     * @return {?}
     */
    function (totalAreaInHa) {
        this.treatmentPesticidesFormService.formModelTotalAreaInHaSubject.next(totalAreaInHa);
    };
    /**
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.treatmentPesticidesArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} treatmentPesticides
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} treatmentPesticides
     * @return {?}
     */
    function (treatmentPesticides) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (treatmentPesticides != null && treatmentPesticides.pesticides != null) {
            groupSize = treatmentPesticides.pesticides.length;
            values = treatmentPesticides.pesticides.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ pesticide: x }); }));
        }
        this.treatmentPesticidesFormService.initFormArrayGroup(groupSize, this.getTreatmentPesticidesArrayModelControl(), this.getTreatmentPesticidesFormArrayModel());
        if (values) {
            this.formGroup.get(TREATMENT_PESTICIDES_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.subscribeToTreatmentPesticidesArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.treatmentPesticidesArrayModelChangesSubscription = this.treatmentPesticidesFormService
            .getTreatmentPesticidesArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.treatmentPesticidesData = null;
            }
            else {
                _this.treatmentPesticidesData = new TreatmentPesticides(value);
            }
            _this.treatmentPesticidesChange.emit(_this.treatmentPesticidesData);
        }));
    };
    Object.defineProperty(TreatmentPesticidesFormComponent.prototype, "showAddPesticideButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getTreatmentPesticidesArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentPesticidesFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getTreatmentPesticidesArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.treatmentPesticidesFormService.removeFormArrayGroup(index, this.getTreatmentPesticidesArrayModelControl(), context);
        this.treatmentPesticidesFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.treatmentPesticidesFormService.insertFormArrayGroup(index, this.getTreatmentPesticidesArrayModelControl(), context);
        this.treatmentPesticidesFormService.formModelSubject.next([context]);
        this.treatmentPesticidesFormService.formModelTotalAreaInHaSubject.next(this.totalAreaInHa);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    TreatmentPesticidesFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.treatmentPesticidesFormService.insertFormArrayGroup(0, this.getTreatmentPesticidesArrayModelControl(), this.getTreatmentPesticidesFormArrayModel());
        this.treatmentPesticidesFormService.formModelSubject.next([this.getTreatmentPesticidesFormArrayModel()]);
        this.treatmentPesticidesFormService.formModelTotalAreaInHaSubject.next(this.totalAreaInHa);
        this.updateFormGroupTouched();
    };
    TreatmentPesticidesFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-pesticides-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #treatmentForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddPesticideButton\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addPesticide' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\"> {{legend}}</p>\r\n                </ng-template>\r\n                <ng-template modelId=\"treatmentPesticidesArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"treatment-pesticides-buttons row mt-2 justify-content-md-end justify-content-xl-center mt-xl-0\">\r\n                        <div class=\"col-6 col-md-auto px-md-0\">\r\n                            <button type=\"button\" class=\"btn btn-danger\" *ngIf=\"!removeItemDisabled\" (click)=\"removeItem(context, index)\"><i\r\n                                    class=\"ft-trash\"></i>\r\n                            </button>\r\n                        </div>\r\n                        <div class=\"col-6 col-md-auto\">\r\n                            <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i\r\n                                    class=\"ft-plus\"></i></button>\r\n                        </div>\r\n                    </div>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        TreatmentPesticidesFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TreatmentPesticidesFormComponent.ctorParameters = function () { return [
        { type: PesticideTypeDictionaryService },
        { type: TreatmentPesticidesFormService }
    ]; };
    TreatmentPesticidesFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        tenantId: [{ type: Input }],
        cultivationCodeName: [{ type: Input }],
        cultivationTypeCodeName: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        treatmentPesticides: [{ type: Input }],
        touched: [{ type: Input }],
        treatmentPesticidesChange: [{ type: Output }]
    };
    return TreatmentPesticidesFormComponent;
}());
if (false) {
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.tenantId;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.cultivationCodeName;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.cultivationTypeCodeName;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.minCountRequired;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype._touched;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.treatmentPesticidesChange;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.formLayout;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.formModel$;
    /** @type {?} */
    TreatmentPesticidesFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype.treatmentPesticidesData;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype.treatmentPesticidesArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype.getTreatmentPesticidesFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype.getTreatmentPesticidesArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype.pesticideTypeDictionaryService;
    /**
     * @type {?}
     * @private
     */
    TreatmentPesticidesFormComponent.prototype.treatmentPesticidesFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEED = 'TREATMENT_SEED';
/**
 * @record
 */
function DynamicTreatmentSeedFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicTreatmentSeedFormControlModelConfig.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentSeedFormControlModelConfig.prototype.seedTypes;
    /** @type {?|undefined} */
    DynamicTreatmentSeedFormControlModelConfig.prototype.totalAreaInHa;
}
var DynamicTreatmentSeedFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicTreatmentSeedFormControlModel, _super);
    function DynamicTreatmentSeedFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEED;
        _this.translateKey = config.translateKey;
        _this.seedTypes = config.seedTypes;
        _this.totalAreaInHa = config.totalAreaInHa;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentSeedFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentSeedFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicTreatmentSeedFormControlModel.prototype, "seedTypes", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentSeedFormControlModel.prototype, "totalAreaInHa", void 0);
    return DynamicTreatmentSeedFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicTreatmentSeedFormControlModel.prototype.type;
    /** @type {?} */
    DynamicTreatmentSeedFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentSeedFormControlModel.prototype.seedTypes;
    /** @type {?} */
    DynamicTreatmentSeedFormControlModel.prototype.totalAreaInHa;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicTreatmentSeedFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicTreatmentSeedFormControlComponent, _super);
    function DynamicTreatmentSeedFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicTreatmentSeedFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-treatment-seed-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-treatment-seed-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [seedTypes]=\"model.seedTypes\"\r\n        [totalAreaInHa]=\"model.totalAreaInHa\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-treatment-seed-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicTreatmentSeedFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicTreatmentSeedFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicTreatmentSeedFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicTreatmentSeedFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicTreatmentSeedFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicTreatmentSeedFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicTreatmentSeedFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicTreatmentSeedFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicTreatmentSeedFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicTreatmentSeedFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentSeedFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentSeedFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$8 = {
    grid: {
        host: 'treatment-seed-host col-12 col-md-6 col-xl-auto',
        container: 'treatment-seed-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var TREATMENT_SEED = 'seed';
/** @type {?} */
var TREATMENT_SEED_UNIT = 'unit';
/** @type {?} */
var TREATMENT_SEED_QUANTITY_IN_UNIT = 'quantityInUnit';
/** @type {?} */
var TREATMENT_SEED_QUANTITY_PER_M2 = 'quantityPerM2';
/** @type {?} */
var TREATMENT_SEED_QUANTITY = 'quantity';
/** @type {?} */
var TREATMENT_SEED_LAYOUT = {
    seed: FORM_LAYOUT_INPUT$8,
    unit: FORM_LAYOUT_INPUT$8,
    quantityInUnit: FORM_LAYOUT_INPUT$8,
    quantityPerM2: FORM_LAYOUT_INPUT$8,
    quantity: FORM_LAYOUT_INPUT$8,
};
/** @type {?} */
var TREATMENT_SEED_FORM_MODEL = [
    new DynamicMultiSelectControlModel({
        id: 'seed',
        bindLabel: nameof('name'),
        multiple: false,
        validators: {
            required: null
        },
        searchByField: nameof('name')
    }),
    new DynamicSelectModel({
        id: 'unit',
        options: getOptionsForDynamicSelectModel(TreatmentSeedUnit, 'TREATMENT_SEED_UNITS', false),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'quantityInUnit',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        }
    }),
    new DynamicInputModel({
        id: 'quantityPerM2',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        }
    }),
    new DynamicInputModel({
        id: 'quantity',
        readOnly: true,
        inputType: 'number'
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeedFormService = /** @class */ (function () {
    function TreatmentSeedFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    TreatmentSeedFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentSeedFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    TreatmentSeedFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    TreatmentSeedFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormService.prototype.getSeedValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_SEED).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormService.prototype.getUnitValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_SEED_UNIT).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormService.prototype.getQuantityInUnitValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_SEED_QUANTITY_IN_UNIT).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormService.prototype.getQuantityPerM2Value$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_SEED_QUANTITY_PER_M2).valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormService.prototype.getQuantityValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_SEED_QUANTITY).valueChanges;
    };
    TreatmentSeedFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentSeedFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TreatmentSeedFormService;
}());
if (false) {
    /** @type {?} */
    TreatmentSeedFormService.prototype.formModelSubject;
    /** @type {?} */
    TreatmentSeedFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeed = /** @class */ (function () {
    function TreatmentSeed(resourceId, name, unit, quantityInUnit, quantityPerM2, quantity) {
        this.resourceId = resourceId;
        this.name = name;
        this.unit = unit;
        this.quantityInUnit = quantityInUnit;
        this.quantityPerM2 = quantityPerM2;
        this.quantity = quantity;
    }
    return TreatmentSeed;
}());
if (false) {
    /** @type {?} */
    TreatmentSeed.prototype.resourceId;
    /** @type {?} */
    TreatmentSeed.prototype.name;
    /** @type {?} */
    TreatmentSeed.prototype.unit;
    /** @type {?} */
    TreatmentSeed.prototype.quantityInUnit;
    /** @type {?} */
    TreatmentSeed.prototype.quantityPerM2;
    /** @type {?} */
    TreatmentSeed.prototype.quantity;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeedFormComponent = /** @class */ (function () {
    function TreatmentSeedFormComponent(numberUtilService, treatmentSeedFormService) {
        this.numberUtilService = numberUtilService;
        this.treatmentSeedFormService = treatmentSeedFormService;
        this.treatmentSeedChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = TREATMENT_SEED_LAYOUT;
        this.treatmentSeedFormService.formModelSubject.next(TREATMENT_SEED_FORM_MODEL);
        this.formGroup = this.treatmentSeedFormService.createFormGroup(TREATMENT_SEED_FORM_MODEL);
    }
    Object.defineProperty(TreatmentSeedFormComponent.prototype, "treatmentSeed", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.treatmentSeedData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.treatmentSeedData = value;
            }
            else {
                this.treatmentSeedData = new TreatmentSeed('', null, TreatmentSeedUnit.Kilogram, null, null, null);
                this.updateFormValue(this.treatmentSeedData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentSeedFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.treatmentSeedFormService.getFormModel$(this.translateKey);
        this.subscribeToSeedModelValueChanges(this.formGroup);
        this.subscribeToUnitModelValueChanges(this.formGroup);
        this.subscribeToQuantityInUnitModelValueChanges(this.formGroup);
        this.subscribeToQuantityPerM2ModelValueChanges(this.formGroup);
        this.subscribeToQuantityModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.totalAreaInHa && changes.totalAreaInHa.currentValue != null) {
            /** @type {?} */
            var unit = this.formGroup.get(TREATMENT_SEED_UNIT).value;
            /** @type {?} */
            var quantityInUnit = this.formGroup.get(TREATMENT_SEED_QUANTITY_IN_UNIT).value;
            /** @type {?} */
            var quantityPerM2 = this.formGroup.get(TREATMENT_SEED_QUANTITY_PER_M2).value;
            this.calculateQuantity(changes.totalAreaInHa.currentValue, unit, quantityInUnit, quantityPerM2);
        }
        if (changes && changes.seedTypes) {
            this.treatmentSeedModel.items = changes.seedTypes.currentValue;
            this.updateSeedFormValue(this.seedResourceId, changes.seedTypes.currentValue);
        }
    };
    /**
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.seedChangesSubscription.unsubscribe();
        this.unitChangesSubscription.unsubscribe();
        this.quantityInUnitChangesSubscription.unsubscribe();
        this.quantityPerM2ChangesSubscription.unsubscribe();
        this.quantityChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} treatmentSeed
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} treatmentSeed
     * @return {?}
     */
    function (treatmentSeed) {
        this.seedResourceId = treatmentSeed.resourceId;
        this.updateSeedFormValue(treatmentSeed.resourceId, this.seedTypes);
        this.formGroup.get(TREATMENT_SEED_UNIT).patchValue(treatmentSeed.unit);
        this.formGroup.get(TREATMENT_SEED_QUANTITY_IN_UNIT).patchValue(treatmentSeed.quantityInUnit);
        this.formGroup.get(TREATMENT_SEED_QUANTITY_PER_M2).patchValue(treatmentSeed.quantityPerM2);
        this.formGroup.get(TREATMENT_SEED_QUANTITY).patchValue(treatmentSeed.quantity);
    };
    /**
     * @private
     * @param {?} resourceId
     * @param {?} seedTypes
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.updateSeedFormValue = /**
     * @private
     * @param {?} resourceId
     * @param {?} seedTypes
     * @return {?}
     */
    function (resourceId, seedTypes) {
        /** @type {?} */
        var seed = (seedTypes || []).find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === resourceId; }));
        this.formGroup.get(TREATMENT_SEED).patchValue(seed);
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var seedType = this.formGroup.get(TREATMENT_SEED).value;
        /** @type {?} */
        var unit = this.formGroup.get(TREATMENT_SEED_UNIT).value;
        /** @type {?} */
        var quantityInUnit = +this.formGroup.get(TREATMENT_SEED_QUANTITY_IN_UNIT).value;
        /** @type {?} */
        var quantityPerM2 = +this.formGroup.get(TREATMENT_SEED_QUANTITY_PER_M2).value;
        /** @type {?} */
        var quantity = +this.formGroup.get(TREATMENT_SEED_QUANTITY).value;
        return new TreatmentSeed(seedType != null ? seedType.id : null, seedType != null ? seedType.name : null, unit, quantityInUnit, quantityPerM2, quantity);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.subscribeToSeedModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.seedChangesSubscription = this.treatmentSeedFormService
            .getSeedValue$(formGroup)
            .subscribe((/**
         * @param {?} seedAsString
         * @return {?}
         */
        function (seedAsString) {
            _this.onTreatmentSeedChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.subscribeToUnitModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.unitChangesSubscription = this.treatmentSeedFormService
            .getUnitValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            /** @type {?} */
            var quantityInUnit = _this.formGroup.get(TREATMENT_SEED_QUANTITY_IN_UNIT).value;
            /** @type {?} */
            var quantityPerM2 = _this.formGroup.get(TREATMENT_SEED_QUANTITY_PER_M2).value;
            _this.calculateQuantity(_this.totalAreaInHa, unit, quantityInUnit, quantityPerM2);
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.subscribeToQuantityInUnitModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityInUnitChangesSubscription = this.treatmentSeedFormService
            .getQuantityInUnitValue$(formGroup)
            .subscribe((/**
         * @param {?} quantityInUnit
         * @return {?}
         */
        function (quantityInUnit) {
            /** @type {?} */
            var unit = _this.formGroup.get(TREATMENT_SEED_UNIT).value;
            /** @type {?} */
            var quantityPerM2 = _this.formGroup.get(TREATMENT_SEED_QUANTITY_PER_M2).value;
            _this.calculateQuantity(_this.totalAreaInHa, unit, quantityInUnit, quantityPerM2);
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.subscribeToQuantityPerM2ModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityPerM2ChangesSubscription = this.treatmentSeedFormService
            .getQuantityPerM2Value$(formGroup)
            .subscribe((/**
         * @param {?} quantityPerM2
         * @return {?}
         */
        function (quantityPerM2) {
            /** @type {?} */
            var unit = _this.formGroup.get(TREATMENT_SEED_UNIT).value;
            /** @type {?} */
            var quantityInUnit = _this.formGroup.get(TREATMENT_SEED_QUANTITY_IN_UNIT).value;
            _this.calculateQuantity(_this.totalAreaInHa, unit, quantityInUnit, quantityPerM2);
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.subscribeToQuantityModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityChangesSubscription = this.treatmentSeedFormService
            .getQuantityValue$(formGroup)
            .subscribe((/**
         * @param {?} quantity
         * @return {?}
         */
        function (quantity) {
            _this.onTreatmentSeedChange();
        }));
    };
    /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} unit
     * @param {?} quantityInUnit
     * @param {?} quantityPerM2
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.calculateQuantity = /**
     * @private
     * @param {?} totalAreaInHa
     * @param {?} unit
     * @param {?} quantityInUnit
     * @param {?} quantityPerM2
     * @return {?}
     */
    function (totalAreaInHa, unit, quantityInUnit, quantityPerM2) {
        if (totalAreaInHa == null || unit == null || quantityInUnit == null || quantityPerM2 == null) {
            this.formGroup.get(TREATMENT_SEED_QUANTITY).patchValue(0);
            return;
        }
        // tslint:disable-next-line: no-magic-numbers
        /** @type {?} */
        var totalAreaInMeter = totalAreaInHa * 10000;
        /** @type {?} */
        var quantity = 0;
        switch (unit) {
            case TreatmentSeedUnit.SeedUnit:
                quantity = quantityPerM2 * totalAreaInMeter / quantityInUnit;
                break;
            case TreatmentSeedUnit.Gram:
                // tslint:disable-next-line: no-magic-numbers
                quantity = quantityPerM2 * quantityInUnit * totalAreaInMeter / 1000;
                break;
            case TreatmentSeedUnit.Kilogram:
                // tslint:disable-next-line: no-magic-numbers
                quantity = quantityPerM2 * quantityInUnit * totalAreaInMeter / (1000 * 1000);
                break;
            case TreatmentSeedUnit.Tonne:
                // tslint:disable-next-line: no-magic-numbers
                quantity = quantityPerM2 * quantityInUnit * totalAreaInMeter / (1000 * 1000 * 1000);
                break;
        }
        quantity = this.numberUtilService.round3(quantity);
        this.formGroup.get(TREATMENT_SEED_QUANTITY).patchValue(quantity);
    };
    /**
     * @private
     * @return {?}
     */
    TreatmentSeedFormComponent.prototype.onTreatmentSeedChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.treatmentSeedData = this.getFormValue();
        this.treatmentSeedChange.emit(this.treatmentSeedData);
    };
    Object.defineProperty(TreatmentSeedFormComponent.prototype, "treatmentSeedModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this.treatmentSeedFormService
                .findModelById(TREATMENT_SEED, TREATMENT_SEED_FORM_MODEL)));
        },
        enumerable: true,
        configurable: true
    });
    TreatmentSeedFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-seed-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\" *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        TreatmentSeedFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TreatmentSeedFormComponent.ctorParameters = function () { return [
        { type: NumberUtilService },
        { type: TreatmentSeedFormService }
    ]; };
    TreatmentSeedFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        seedTypes: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentSeed: [{ type: Input }],
        touched: [{ type: Input }],
        treatmentSeedChange: [{ type: Output }]
    };
    return TreatmentSeedFormComponent;
}());
if (false) {
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.seedTypes;
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.treatmentSeedChange;
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.formLayout;
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.formModel$;
    /** @type {?} */
    TreatmentSeedFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.treatmentSeedData;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.seedResourceId;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.seedChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.unitChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.quantityInUnitChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.quantityPerM2ChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.quantityChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormComponent.prototype.treatmentSeedFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeedFormControlComponent = /** @class */ (function () {
    function TreatmentSeedFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(TreatmentSeedFormControlComponent.prototype, "treatmentSeed", {
        get: /**
         * @return {?}
         */
        function () {
            return this._treatmentSeed;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._treatmentSeed = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    TreatmentSeedFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._treatmentSeed = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentSeedFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentSeedFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    TreatmentSeedFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    TreatmentSeedFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-seed-form-control',
                    template: "<app-treatment-seed-form\r\n    [(treatmentSeed)]=\"treatmentSeed\"\r\n    [translateKey]=\"translateKey\"\r\n    [seedTypes]=\"seedTypes\"\r\n    [totalAreaInHa]=\"totalAreaInHa\"\r\n    [touched]=\"touched\">\r\n</app-treatment-seed-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return TreatmentSeedFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    TreatmentSeedFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        seedTypes: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        treatmentSeed: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return TreatmentSeedFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormControlComponent.prototype._treatmentSeed;
    /** @type {?} */
    TreatmentSeedFormControlComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentSeedFormControlComponent.prototype.seedTypes;
    /** @type {?} */
    TreatmentSeedFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentSeedFormControlComponent.prototype.touched;
    /** @type {?} */
    TreatmentSeedFormControlComponent.prototype.blur;
    /** @type {?} */
    TreatmentSeedFormControlComponent.prototype.change;
    /** @type {?} */
    TreatmentSeedFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEEDS = 'TREATMENT_SEEDS';
/**
 * @record
 */
function DynamicTreatmentSeedsFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicTreatmentSeedsFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicTreatmentSeedsFormControlModelConfig.prototype.totalAreaInHa;
    /** @type {?|undefined} */
    DynamicTreatmentSeedsFormControlModelConfig.prototype.cultivationCodeNames;
    /** @type {?|undefined} */
    DynamicTreatmentSeedsFormControlModelConfig.prototype.minCountRequired;
}
var DynamicTreatmentSeedsFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicTreatmentSeedsFormControlModel, _super);
    function DynamicTreatmentSeedsFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEEDS;
        _this.translateKey = config.translateKey;
        _this.totalAreaInHa = config.totalAreaInHa;
        _this.cultivationCodeNames = config.cultivationCodeNames;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentSeedsFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicTreatmentSeedsFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentSeedsFormControlModel.prototype, "totalAreaInHa", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicTreatmentSeedsFormControlModel.prototype, "cultivationCodeNames", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicTreatmentSeedsFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicTreatmentSeedsFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicTreatmentSeedsFormControlModel.prototype.type;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlModel.prototype.totalAreaInHa;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlModel.prototype.cultivationCodeNames;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicTreatmentSeedsFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicTreatmentSeedsFormControlComponent, _super);
    function DynamicTreatmentSeedsFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicTreatmentSeedsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-treatment-seeds-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-treatment-seeds-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [totalAreaInHa]=\"model.totalAreaInHa\"\r\n        [cultivationCodeNames]=\"model.cultivationCodeNames\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-treatment-seeds-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicTreatmentSeedsFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicTreatmentSeedsFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicTreatmentSeedsFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicTreatmentSeedsFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicTreatmentSeedsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentSeedsFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicTreatmentSeedsFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeeds = /** @class */ (function () {
    function TreatmentSeeds(seeds) {
        this.seeds = seeds;
    }
    return TreatmentSeeds;
}());
if (false) {
    /** @type {?} */
    TreatmentSeeds.prototype.seeds;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeedsFormControlComponent = /** @class */ (function () {
    function TreatmentSeedsFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(TreatmentSeedsFormControlComponent.prototype, "treatmentSeeds", {
        get: /**
         * @return {?}
         */
        function () {
            return this._treatmentSeeds;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._treatmentSeeds = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    TreatmentSeedsFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._treatmentSeeds = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentSeedsFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    TreatmentSeedsFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    TreatmentSeedsFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    TreatmentSeedsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-seeds-form-control',
                    template: "<app-treatment-seeds-form\r\n    [(treatmentSeeds)]=\"treatmentSeeds\"\r\n    [translateKey]=\"translateKey\"\r\n    [totalAreaInHa]=\"totalAreaInHa\"\r\n    [cultivationCodeNames]=\"cultivationCodeNames\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [touched]=\"touched\">\r\n</app-treatment-seeds-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return TreatmentSeedsFormControlComponent; })), multi: true }
                    ],
                    styles: [""]
                }] }
    ];
    TreatmentSeedsFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        cultivationCodeNames: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        treatmentSeeds: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return TreatmentSeedsFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormControlComponent.prototype._treatmentSeeds;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.cultivationCodeNames;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.touched;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.blur;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.change;
    /** @type {?} */
    TreatmentSeedsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormControlComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$5 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$5 = {
    grid: {
        host: 'treatment-seeds-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var TREATMENT_SEEDS_ARRAY_MODEL = 'treatmentSeedsArrayModel';
/** @type {?} */
var TREATMENT_SEEDS_SEED = 'seed';
/** @type {?} */
var TREATMENT_SEEDS_LAYOUT = {
    treatmentSeedsArrayModel: FORM_LAYOUT_INPUT_ALL$5,
    seed: FORM_LAYOUT_INPUT_ALL_ITEM$5
};
var ɵ0$6 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicTreatmentSeedFormControlModel({
            id: TREATMENT_SEEDS_SEED,
            seedTypes: []
        })
    ];
};
/** @type {?} */
var TREATMENT_SEEDS_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: TREATMENT_SEEDS_ARRAY_MODEL,
        initialCount: 0,
        groupFactory: (ɵ0$6)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeedsFormService = /** @class */ (function () {
    function TreatmentSeedsFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.formModelSeedTypesSubject = new BehaviorSubject(null);
        this.formModelTotalAreaInHaSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelSeedTypesChange$ = this.formModelSeedTypesSubject
            .pipe(map((/**
         * @param {?} seedTypes
         * @return {?}
         */
        function (seedTypes) {
            /** @type {?} */
            var formModel = _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey);
            return _this.assignSeedTypes(formModel, seedTypes);
        })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTotalAreaInHa(formModel, _this.formModelTotalAreaInHaSubject.getValue()); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnTotalAreaInHaChange$ = this.formModelTotalAreaInHaSubject
            .pipe(map((/**
         * @param {?} totalAreaInHa
         * @return {?}
         */
        function (totalAreaInHa) {
            /** @type {?} */
            var formModel = _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey);
            return _this.assignTotalAreaInHa(formModel, totalAreaInHa);
        })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignSeedTypes(formModel, _this.formModelSeedTypesSubject.getValue()); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelSeedTypesChange$, formModelOnTotalAreaInHaChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} seedTypes
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.assignSeedTypes = /**
     * @private
     * @param {?} formModel
     * @param {?} seedTypes
     * @return {?}
     */
    function (formModel, seedTypes) {
        if (seedTypes != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_SEEDS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentSeedModel
             * @return {?}
             */
            function (treatmentSeedModel) {
                treatmentSeedModel.seedTypes = seedTypes;
            })); }));
        }
        return formModel;
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} totalAreaInHa
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.assignTotalAreaInHa = /**
     * @private
     * @param {?} formModel
     * @param {?} totalAreaInHa
     * @return {?}
     */
    function (formModel, totalAreaInHa) {
        if (totalAreaInHa != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_SEEDS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentSeedModel
             * @return {?}
             */
            function (treatmentSeedModel) {
                treatmentSeedModel.totalAreaInHa = totalAreaInHa;
            })); }));
        }
        return formModel;
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = TREATMENT_SEEDS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentSeedModel
             * @return {?}
             */
            function (treatmentSeedModel) {
                treatmentSeedModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedsFormService.prototype.getTreatmentSeedsArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(TREATMENT_SEEDS_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.seed; }));
        })));
    };
    TreatmentSeedsFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentSeedsFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return TreatmentSeedsFormService;
}());
if (false) {
    /** @type {?} */
    TreatmentSeedsFormService.prototype.formModelSubject;
    /** @type {?} */
    TreatmentSeedsFormService.prototype.formModelSeedTypesSubject;
    /** @type {?} */
    TreatmentSeedsFormService.prototype.formModelTotalAreaInHaSubject;
    /** @type {?} */
    TreatmentSeedsFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentSeedsFormComponent = /** @class */ (function () {
    function TreatmentSeedsFormComponent(treatmentSeedsFormService, dictionariesService) {
        var _this = this;
        this.treatmentSeedsFormService = treatmentSeedsFormService;
        this.dictionariesService = dictionariesService;
        this.treatmentSeedsChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getTreatmentSeedsFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.treatmentSeedsFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === TREATMENT_SEEDS_ARRAY_MODEL; }))));
        });
        this.getTreatmentSeedsArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.treatmentSeedsFormService
                .findModelById(TREATMENT_SEEDS_ARRAY_MODEL, TREATMENT_SEEDS_FORM_MODEL);
            return (/** @type {?} */ (_this.treatmentSeedsFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = TREATMENT_SEEDS_LAYOUT;
        this.treatmentSeedsFormService.formModelSubject.next(TREATMENT_SEEDS_FORM_MODEL);
        this.formGroup = this.treatmentSeedsFormService.createFormGroup(TREATMENT_SEEDS_FORM_MODEL);
        this.subscribeToTreatmentSeedsArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(TreatmentSeedsFormComponent.prototype, "treatmentSeeds", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.seeds != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.treatmentSeedsData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.treatmentSeedsData = value;
            }
            else {
                this.treatmentSeedsData = new TreatmentSeeds([]);
                this.updateFormValue(this.treatmentSeedsData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentSeedsFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formModel$ = this.treatmentSeedsFormService.getFormModel$(this.translateKey);
        this.onUpdateTotalAreaInHa(this.totalAreaInHa);
        this.updateFormValue(this.treatmentSeedsData);
        this.displaySpinner$.next(true);
        this.dictionariesService
            .getItems(DictionaryType.SeedType)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} seedTypes
         * @return {?}
         */
        function (seedTypes) {
            _this.seedTypes = seedTypes;
            _this.onUpdateSeedTypes(_this.cultivationCodeNames, seedTypes);
        }));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.totalAreaInHa && changes.totalAreaInHa.currentValue) {
            this.onUpdateTotalAreaInHa(changes.totalAreaInHa.currentValue);
        }
        if (changes && changes.cultivationCodeNames && changes.cultivationCodeNames.currentValue) {
            this.onUpdateSeedTypes(changes.cultivationCodeNames.currentValue, this.seedTypes);
        }
    };
    /**
     * @private
     * @param {?} cultivationCodeNames
     * @param {?} seedTypes
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.onUpdateSeedTypes = /**
     * @private
     * @param {?} cultivationCodeNames
     * @param {?} seedTypes
     * @return {?}
     */
    function (cultivationCodeNames, seedTypes) {
        /** @type {?} */
        var selectedSeedTypes = [];
        if (cultivationCodeNames != null && cultivationCodeNames.length > 0
            && seedTypes != null && seedTypes.length > 0) {
            selectedSeedTypes = seedTypes
                .filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return cultivationCodeNames.some((/**
             * @param {?} c
             * @return {?}
             */
            function (c) { return c === x.type; })); }))
                .sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.name.localeCompare(b.name); }));
        }
        this.treatmentSeedsFormService.formModelSeedTypesSubject.next(selectedSeedTypes);
    };
    /**
     * @private
     * @param {?} totalAreaInHa
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.onUpdateTotalAreaInHa = /**
     * @private
     * @param {?} totalAreaInHa
     * @return {?}
     */
    function (totalAreaInHa) {
        this.treatmentSeedsFormService.formModelTotalAreaInHaSubject.next(totalAreaInHa);
    };
    /**
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.treatmentSeedsArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} treatmentSeeds
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} treatmentSeeds
     * @return {?}
     */
    function (treatmentSeeds) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (treatmentSeeds != null && treatmentSeeds.seeds != null) {
            groupSize = treatmentSeeds.seeds.length;
            values = treatmentSeeds.seeds.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ seed: x }); }));
        }
        this.treatmentSeedsFormService
            .initFormArrayGroup(groupSize, this.getTreatmentSeedsArrayModelControl(), this.getTreatmentSeedsFormArrayModel());
        if (values) {
            this.formGroup.get(TREATMENT_SEEDS_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.subscribeToTreatmentSeedsArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.treatmentSeedsArrayModelChangesSubscription = this.treatmentSeedsFormService
            .getTreatmentSeedsArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.treatmentSeedsData = null;
            }
            else {
                _this.treatmentSeedsData = new TreatmentSeeds(value);
            }
            _this.treatmentSeedsChange.emit(_this.treatmentSeedsData);
        }));
    };
    Object.defineProperty(TreatmentSeedsFormComponent.prototype, "showAddSeedButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getTreatmentSeedsArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreatmentSeedsFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getTreatmentSeedsArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.treatmentSeedsFormService.removeFormArrayGroup(index, this.getTreatmentSeedsArrayModelControl(), context);
        this.treatmentSeedsFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.treatmentSeedsFormService.insertFormArrayGroup(index, this.getTreatmentSeedsArrayModelControl(), context);
        this.treatmentSeedsFormService.formModelSubject.next([context]);
        this.treatmentSeedsFormService.formModelTotalAreaInHaSubject.next(this.totalAreaInHa);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    TreatmentSeedsFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.treatmentSeedsFormService.insertFormArrayGroup(0, this.getTreatmentSeedsArrayModelControl(), this.getTreatmentSeedsFormArrayModel());
        this.treatmentSeedsFormService.formModelSubject.next([this.getTreatmentSeedsFormArrayModel()]);
        this.treatmentSeedsFormService.formModelTotalAreaInHaSubject.next(this.totalAreaInHa);
        this.updateFormGroupTouched();
    };
    TreatmentSeedsFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-treatment-seeds-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #treatmentForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddSeedButton\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addSeed' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n                <ng-template modelId=\"treatmentSeedsArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"treatment-seeds-buttons row mt-2 justify-content-md-end justify-content-xl-center mt-xl-0\">\r\n                        <div class=\"col-6 col-md-auto px-md-0\">\r\n                            <button type=\"button\" class=\"btn btn-danger\" *ngIf=\"!removeItemDisabled\" (click)=\"removeItem(context, index)\"\r\n                                [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        </div>\r\n                        <div class=\"col-6 col-md-auto\">\r\n                            <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i\r\n                                    class=\"ft-plus\"></i></button>\r\n                        </div>\r\n                    </div>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        TreatmentSeedsFormService
                    ],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TreatmentSeedsFormComponent.ctorParameters = function () { return [
        { type: TreatmentSeedsFormService },
        { type: DictionariesService }
    ]; };
    TreatmentSeedsFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        totalAreaInHa: [{ type: Input }],
        cultivationCodeNames: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        treatmentSeeds: [{ type: Input }],
        touched: [{ type: Input }],
        treatmentSeedsChange: [{ type: Output }]
    };
    return TreatmentSeedsFormComponent;
}());
if (false) {
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.translateKey;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.totalAreaInHa;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.cultivationCodeNames;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.minCountRequired;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype._touched;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.treatmentSeedsChange;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.formLayout;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.formModel$;
    /** @type {?} */
    TreatmentSeedsFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.treatmentSeedsData;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.treatmentSeedsArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.seedTypes;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.getTreatmentSeedsFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.getTreatmentSeedsArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.treatmentSeedsFormService;
    /**
     * @type {?}
     * @private
     */
    TreatmentSeedsFormComponent.prototype.dictionariesService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// number of leap year
/** @type {?} */
var LEAP_YEAR = 2020;
/**
 * @return {?}
 */
function periodsValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var periods = (/** @type {?} */ (control.value));
        if (periods.periods == null || periods.periods.length === 0) {
            return null;
        }
        if (isValidPeriods(periods.periods) === false) {
            return { invalidPeriod: { invalidPeriod: {} } };
        }
        if (isSeparablePeriods(periods.periods) === false) {
            return { separablePeriods: { separablePeriods: {} } };
        }
        return null;
    });
}
/**
 * @return {?}
 */
function periodArrayValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var periods = (/** @type {?} */ (control.value));
        if (periods == null || periods.length === 0) {
            return null;
        }
        if (isDefinedPeriods(periods.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.period; }))) === false) {
            return null;
        }
        if (isValidPeriods(periods.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.period; }))) === false) {
            return { invalidPeriod: { invalidPeriod: {} } };
        }
        if (isSeparablePeriods(periods.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.period; }))) === false) {
            return { separablePeriods: { separablePeriods: {} } };
        }
        return null;
    });
}
/**
 * @param {?} periods
 * @return {?}
 */
function isDefinedPeriods(periods) {
    /** @type {?} */
    var isPeriodDefined = (/**
     * @param {?} period
     * @return {?}
     */
    function (period) {
        if (period == null) {
            return false;
        }
        /** @type {?} */
        var dataA = startDate(period);
        /** @type {?} */
        var dateB = endDate(period);
        if (dataA == null
            || dataA.getMonth() !== period.startMonth - 1
            || dataA.getDate() !== period.startDay) {
            return false;
        }
        if (dateB == null
            || dateB.getMonth() !== period.endMonth - 1
            || dateB.getDate() !== period.endDay) {
            return false;
        }
        return true;
    });
    return periods.some((/**
     * @param {?} period
     * @return {?}
     */
    function (period) { return !isPeriodDefined(period); })) === false;
}
/**
 * @param {?} periods
 * @return {?}
 */
function isValidPeriods(periods) {
    /** @type {?} */
    var isPeriodCorrect = (/**
     * @param {?} period
     * @return {?}
     */
    function (period) {
        if (period == null) {
            return false;
        }
        /** @type {?} */
        var dataA = startDate(period);
        /** @type {?} */
        var dateB = endDate(period);
        if (dataA == null
            || dataA.getMonth() !== period.startMonth - 1
            || dataA.getDate() !== period.startDay) {
            return false;
        }
        if (dateB == null
            || dateB.getMonth() !== period.endMonth - 1
            || dateB.getDate() !== period.endDay) {
            return false;
        }
        return startDate(period) < endDate(period);
    });
    return periods.some((/**
     * @param {?} period
     * @return {?}
     */
    function (period) { return !isPeriodCorrect(period); })) === false;
}
/**
 * @param {?} periods
 * @return {?}
 */
function isSeparablePeriods(periods) {
    if (periods.length > 1) {
        /** @type {?} */
        var sortedPeriods = (periods || []).sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return compareAsc(startDate(a), startDate(b)); }));
        for (var index = 0; index < sortedPeriods.length - 1; index++) {
            /** @type {?} */
            var elementEndDate = endDate(sortedPeriods[index]);
            /** @type {?} */
            var nextElementStartDate = startDate(sortedPeriods[index + 1]);
            if (elementEndDate > nextElementStartDate) {
                return false;
            }
        }
    }
    return true;
}
/**
 * @param {?} period
 * @return {?}
 */
function startDate(period) {
    if (period.startMonth == null || period.startDay == null) {
        return null;
    }
    return new Date(LEAP_YEAR, period.startMonth - 1, period.startDay);
}
/**
 * @param {?} period
 * @return {?}
 */
function endDate(period) {
    if (period.endMonth == null || period.endDay == null) {
        return null;
    }
    return new Date(LEAP_YEAR, period.endMonth - 1, period.endDay);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function treatmentFertilizersValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var treatmentFertilizers = (/** @type {?} */ (control.value));
        if (treatmentFertilizers.fertilizers == null || treatmentFertilizers.fertilizers.length === 0) {
            return null;
        }
        /** @type {?} */
        var isTreatmentFertilizerCorrect = (/**
         * @param {?} fertilizer
         * @return {?}
         */
        function (fertilizer) {
            if (fertilizer == null) {
                return false;
            }
            return !isEmpty(fertilizer.resourceId)
                && !isEmpty(fertilizer.unit)
                && fertilizer.quantityPerHa != null
                && fertilizer.quantityPerHa > 0
                && fertilizer.quantity != null
                && fertilizer.quantity > 0;
        });
        if (treatmentFertilizers.fertilizers.some((/**
         * @param {?} fertilizer
         * @return {?}
         */
        function (fertilizer) { return !isTreatmentFertilizerCorrect(fertilizer); }))) {
            return { treatmentFertilizers: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function treatmentIrrigationValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return { treatmentIrrigation: {} };
        }
        /** @type {?} */
        var treatmentIrrigation = (/** @type {?} */ (control.value));
        if (isEmpty(treatmentIrrigation.unit)
            && treatmentIrrigation.quantityPerM2 == null
            && treatmentIrrigation.quantityPerM2 <= 0
            && treatmentIrrigation.quantity == null
            && treatmentIrrigation.quantity <= 0) {
            return { treatmentIrrigation: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function treatmentPesticidesValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var treatmentPesticides = (/** @type {?} */ (control.value));
        if (treatmentPesticides.pesticides == null || treatmentPesticides.pesticides.length === 0) {
            return null;
        }
        /** @type {?} */
        var isTreatmentPesticideCorrect = (/**
         * @param {?} pesticide
         * @return {?}
         */
        function (pesticide) {
            if (pesticide == null) {
                return false;
            }
            return pesticide.resourceId != null
                && pesticide.resourceId > 0
                && !isEmpty(pesticide.unit)
                && pesticide.quantityPerHa != null
                && pesticide.quantityPerHa > 0
                && pesticide.quantity != null
                && pesticide.quantity > 0;
        });
        if (treatmentPesticides.pesticides.some((/**
         * @param {?} pesticide
         * @return {?}
         */
        function (pesticide) { return !isTreatmentPesticideCorrect(pesticide); }))) {
            return { treatmentPesticides: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function treatmentSeedsValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var treatmentSeeds = (/** @type {?} */ (control.value));
        if (treatmentSeeds.seeds == null || treatmentSeeds.seeds.length === 0) {
            return null;
        }
        /** @type {?} */
        var isTreatmentSeedCorrect = (/**
         * @param {?} seed
         * @return {?}
         */
        function (seed) {
            if (seed == null) {
                return false;
            }
            return !isEmpty(seed.resourceId)
                && !isEmpty(seed.unit)
                && seed.quantityInUnit != null
                && seed.quantityInUnit > 0
                && seed.quantityPerM2 != null
                && seed.quantityPerM2 > 0
                && seed.quantity != null
                && seed.quantity > 0;
        });
        if (treatmentSeeds.seeds.some((/**
         * @param {?} seed
         * @return {?}
         */
        function (seed) { return !isTreatmentSeedCorrect(seed); }))) {
            return { treatmentSeeds: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENT = 'MACHINE_CARD_ELEMENT';
/**
 * @record
 */
function DynamicMachineCardElementFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicMachineCardElementFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicMachineCardElementFormControlModelConfig.prototype.totalAreaInHa;
}
var DynamicMachineCardElementFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicMachineCardElementFormControlModel, _super);
    function DynamicMachineCardElementFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENT;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineCardElementFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineCardElementFormControlModel.prototype, "translateKey", void 0);
    return DynamicMachineCardElementFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMachineCardElementFormControlModel.prototype.type;
    /** @type {?} */
    DynamicMachineCardElementFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMachineCardElementFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMachineCardElementFormControlComponent, _super);
    function DynamicMachineCardElementFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMachineCardElementFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-machine-card-element-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-machine-card-element-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-machine-card-element-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicMachineCardElementFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMachineCardElementFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMachineCardElementFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMachineCardElementFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMachineCardElementFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMachineCardElementFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMachineCardElementFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMachineCardElementFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMachineCardElementFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMachineCardElementFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineCardElementFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineCardElementFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElementModel = /** @class */ (function () {
    function MachineCardElementModel(name, quantity, unit, unitPrice, catalogNumber, kindOfService, manufacturer) {
        this.name = name;
        this.quantity = quantity;
        this.unit = unit;
        this.unitPrice = unitPrice;
        this.catalogNumber = catalogNumber;
        this.kindOfService = kindOfService;
        this.manufacturer = manufacturer;
    }
    return MachineCardElementModel;
}());
if (false) {
    /** @type {?} */
    MachineCardElementModel.prototype.name;
    /** @type {?} */
    MachineCardElementModel.prototype.quantity;
    /** @type {?} */
    MachineCardElementModel.prototype.unit;
    /** @type {?} */
    MachineCardElementModel.prototype.unitPrice;
    /** @type {?} */
    MachineCardElementModel.prototype.catalogNumber;
    /** @type {?} */
    MachineCardElementModel.prototype.kindOfService;
    /** @type {?} */
    MachineCardElementModel.prototype.manufacturer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElementFormControlComponent = /** @class */ (function () {
    function MachineCardElementFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(MachineCardElementFormControlComponent.prototype, "machineCardElement", {
        get: /**
         * @return {?}
         */
        function () {
            return this._machineCardElement;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._machineCardElement = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    MachineCardElementFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._machineCardElement = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineCardElementFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineCardElementFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MachineCardElementFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    MachineCardElementFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-card-element-form-control',
                    template: "<app-machine-card-element-form\r\n    [(machineCardElement)]=\"machineCardElement\"\r\n    [translateKey]=\"translateKey\"\r\n    [touched]=\"touched\">\r\n</app-machine-card-element-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MachineCardElementFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    MachineCardElementFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        machineCardElement: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MachineCardElementFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormControlComponent.prototype._machineCardElement;
    /** @type {?} */
    MachineCardElementFormControlComponent.prototype.translateKey;
    /** @type {?} */
    MachineCardElementFormControlComponent.prototype.touched;
    /** @type {?} */
    MachineCardElementFormControlComponent.prototype.blur;
    /** @type {?} */
    MachineCardElementFormControlComponent.prototype.change;
    /** @type {?} */
    MachineCardElementFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElementFormService = /** @class */ (function () {
    function MachineCardElementFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    MachineCardElementFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    MachineCardElementFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    MachineCardElementFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    MachineCardElementFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormService.prototype.getNameValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('name').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormService.prototype.getUnitValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('unit').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormService.prototype.getUnitPriceValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('unitPrice').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormService.prototype.getQuantityValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('quantity').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormService.prototype.getCatalogNumberValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('catalogNumber').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormService.prototype.getKindOfServeValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('kindOfService').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormService.prototype.getManufacturerValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('manufacturer').valueChanges;
    };
    MachineCardElementFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MachineCardElementFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return MachineCardElementFormService;
}());
if (false) {
    /** @type {?} */
    MachineCardElementFormService.prototype.formModelSubject;
    /** @type {?} */
    MachineCardElementFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$9 = {
    grid: {
        host: 'machine-card-element-host',
        container: 'machine-card-element-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var MACHINE_CARD_ELEMENT_LAYOUT = {
    name: FORM_LAYOUT_INPUT$9,
    quantity: FORM_LAYOUT_INPUT$9,
    unit: FORM_LAYOUT_INPUT$9,
    unitPrice: FORM_LAYOUT_INPUT$9,
    catalogNumber: FORM_LAYOUT_INPUT$9,
    kindOfService: FORM_LAYOUT_INPUT$9,
    manufacturer: FORM_LAYOUT_INPUT$9
};
/** @type {?} */
var MACHINE_CARD_ELEMENT_FORM_MODEL = [
    new DynamicSelectModel({
        id: 'kindOfService',
        options: getOptionsForDynamicSelectModel(MachineServiceCardType, 'SERVICE_CARD_KIND_OF_SERVICE', false),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'name',
        required: true
    }),
    new DynamicInputModel({
        id: 'quantity',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        }
    }),
    new DynamicSelectModel({
        id: 'unit',
        options: getOptionsForDynamicSelectModel(MachineServiceCardUnit, 'SERVICE_CARD_UNITS', false),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'unitPrice',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        },
    }),
    new DynamicInputModel({
        id: 'catalogNumber',
    }),
    new DynamicInputModel({
        id: 'manufacturer',
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElementFormComponent = /** @class */ (function () {
    function MachineCardElementFormComponent(machineCardElementFormService) {
        this.machineCardElementFormService = machineCardElementFormService;
        this.machineCardElementChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = MACHINE_CARD_ELEMENT_LAYOUT;
        this.machineCardElementFormService.formModelSubject.next(MACHINE_CARD_ELEMENT_FORM_MODEL);
        this.formGroup = this.machineCardElementFormService.createFormGroup(MACHINE_CARD_ELEMENT_FORM_MODEL);
    }
    Object.defineProperty(MachineCardElementFormComponent.prototype, "machineCardElement", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.machineCardElementData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.machineCardElementData = value;
            }
            else {
                this.machineCardElementData = new MachineCardElementModel('', 1, MachineServiceCardUnit.UNIT, 0, '', MachineServiceCardType.SERVICE, '');
                this.updateFormValue(this.machineCardElementData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineCardElementFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.machineCardElementFormService.getFormModel$(this.translateKey);
        this.subscribeToUnitModelValueChanges(this.formGroup);
        this.subscribeToKindOfServiceModelValueChanges(this.formGroup);
        this.subscribeToNameModelValueChanges(this.formGroup);
        this.subscribeToUnitPriceModelValueChanges(this.formGroup);
        this.subscribeToQuantityModelValueChanges(this.formGroup);
        this.subscribeToManufacturerModelValueChanges(this.formGroup);
        this.subscribeToCatalogNumberModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unitChangesSubscription.unsubscribe();
        this.kindOfServiceChangesSubscription.unsubscribe();
        this.nameChangesSubscription.unsubscribe();
        this.unitPriceChangesSubscription.unsubscribe();
        this.quantityChangesSubscription.unsubscribe();
        this.manufacturerChangesSubscription.unsubscribe();
        this.catalogNumberChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} machineCardElementModel
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} machineCardElementModel
     * @return {?}
     */
    function (machineCardElementModel) {
        this.formGroup.get('name').patchValue(machineCardElementModel.name);
        this.formGroup.get('quantity').patchValue(machineCardElementModel.quantity);
        this.formGroup.get('unit').patchValue(machineCardElementModel.unit);
        this.formGroup.get('unitPrice').patchValue(machineCardElementModel.unitPrice);
        this.formGroup.get('manufacturer').patchValue(machineCardElementModel.manufacturer);
        this.formGroup.get('catalogNumber').patchValue(machineCardElementModel.catalogNumber);
        this.formGroup.get('kindOfService').patchValue(machineCardElementModel.kindOfService);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.subscribeToUnitModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.unitChangesSubscription = this.machineCardElementFormService
            .getUnitValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineCardElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.subscribeToKindOfServiceModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.kindOfServiceChangesSubscription = this.machineCardElementFormService
            .getKindOfServeValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineCardElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.subscribeToNameModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.nameChangesSubscription = this.machineCardElementFormService
            .getNameValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineCardElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.subscribeToUnitPriceModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.unitPriceChangesSubscription = this.machineCardElementFormService
            .getUnitPriceValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineCardElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.subscribeToQuantityModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.quantityChangesSubscription = this.machineCardElementFormService
            .getQuantityValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineCardElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.subscribeToManufacturerModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.manufacturerChangesSubscription = this.machineCardElementFormService
            .getManufacturerValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineCardElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.subscribeToCatalogNumberModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.catalogNumberChangesSubscription = this.machineCardElementFormService
            .getCatalogNumberValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineCardElementChange();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var name = this.formGroup.get('name').value;
        /** @type {?} */
        var unit = this.formGroup.get('unit').value;
        /** @type {?} */
        var unitPrice = +this.formGroup.get('unitPrice').value;
        /** @type {?} */
        var quantity = +this.formGroup.get('quantity').value;
        /** @type {?} */
        var manufacturer = this.formGroup.get('manufacturer').value;
        /** @type {?} */
        var kindOfService = this.formGroup.get('kindOfService').value;
        /** @type {?} */
        var catalogNumber = this.formGroup.get('catalogNumber').value;
        return new MachineCardElementModel(name, quantity, unit, unitPrice, catalogNumber, kindOfService, manufacturer);
    };
    /**
     * @private
     * @return {?}
     */
    MachineCardElementFormComponent.prototype.onMachineCardElementChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.machineCardElementData = this.getFormValue();
        this.machineCardElementChange.emit(this.machineCardElementData);
    };
    MachineCardElementFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-card-element-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        MachineCardElementFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    MachineCardElementFormComponent.ctorParameters = function () { return [
        { type: MachineCardElementFormService }
    ]; };
    MachineCardElementFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        machineCardElement: [{ type: Input }],
        touched: [{ type: Input }],
        machineCardElementChange: [{ type: Output }]
    };
    return MachineCardElementFormComponent;
}());
if (false) {
    /** @type {?} */
    MachineCardElementFormComponent.prototype.translateKey;
    /** @type {?} */
    MachineCardElementFormComponent.prototype.machineCardElementChange;
    /** @type {?} */
    MachineCardElementFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    MachineCardElementFormComponent.prototype.formLayout;
    /** @type {?} */
    MachineCardElementFormComponent.prototype.formModel$;
    /** @type {?} */
    MachineCardElementFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.machineCardElementData;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.unitChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.kindOfServiceChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.nameChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.unitPriceChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.quantityChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.manufacturerChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.catalogNumberChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementFormComponent.prototype.machineCardElementFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENTS = 'MACHINE_CARD_ELEMENTS';
/**
 * @record
 */
function DynamicMachineCardElementsFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicMachineCardElementsFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicMachineCardElementsFormControlModelConfig.prototype.minCountRequired;
}
var DynamicMachineCardElementsFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicMachineCardElementsFormControlModel, _super);
    function DynamicMachineCardElementsFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENTS;
        _this.translateKey = config.translateKey;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineCardElementsFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineCardElementsFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicMachineCardElementsFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicMachineCardElementsFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMachineCardElementsFormControlModel.prototype.type;
    /** @type {?} */
    DynamicMachineCardElementsFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicMachineCardElementsFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMachineCardElementsFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMachineCardElementsFormControlComponent, _super);
    function DynamicMachineCardElementsFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMachineCardElementsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-machine-card-elements-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-machine-card-elements-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-machine-card-elements-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicMachineCardElementsFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMachineCardElementsFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMachineCardElementsFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMachineCardElementsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineCardElementsFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineCardElementsFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function machineCardElementsValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var machineCardElements = (/** @type {?} */ (control.value));
        if (machineCardElements.elements == null || machineCardElements.elements.length === 0) {
            return null;
        }
        /** @type {?} */
        var isMachineCardElementsCorrect = (/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (element == null) {
                return false;
            }
            return element.name !== ''
                && element.unit !== ''
                && element.quantity != null
                && element.quantity > 0
                && element.unitPrice != null
                && element.unitPrice > 0;
        });
        if (machineCardElements.elements.some((/**
         * @param {?} element
         * @return {?}
         */
        function (element) { return !isMachineCardElementsCorrect(element); }))) {
            return { machineCardElements: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElements = /** @class */ (function () {
    function MachineCardElements(elements) {
        this.elements = elements;
    }
    return MachineCardElements;
}());
if (false) {
    /** @type {?} */
    MachineCardElements.prototype.elements;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElementsFormControlComponent = /** @class */ (function () {
    function MachineCardElementsFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(MachineCardElementsFormControlComponent.prototype, "machineCardElements", {
        get: /**
         * @return {?}
         */
        function () {
            return this._machineCardElements;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._machineCardElements = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    MachineCardElementsFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._machineCardElements = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineCardElementsFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineCardElementsFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MachineCardElementsFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    MachineCardElementsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-card-elements-form-control',
                    template: "<app-machine-card-elements-form\r\n    [(machineCardElements)]=\"machineCardElements\"\r\n    [translateKey]=\"translateKey\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [touched]=\"touched\">\r\n</app-machine-card-elements-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MachineCardElementsFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    MachineCardElementsFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        machineCardElements: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MachineCardElementsFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormControlComponent.prototype._machineCardElements;
    /** @type {?} */
    MachineCardElementsFormControlComponent.prototype.translateKey;
    /** @type {?} */
    MachineCardElementsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    MachineCardElementsFormControlComponent.prototype.touched;
    /** @type {?} */
    MachineCardElementsFormControlComponent.prototype.blur;
    /** @type {?} */
    MachineCardElementsFormControlComponent.prototype.change;
    /** @type {?} */
    MachineCardElementsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormControlComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$6 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$6 = {
    grid: {
        host: 'machine-card-elements-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var MACHINE_CARD_ELEMENTS_ARRAY_MODEL = 'machineCardElementsArrayModel';
/** @type {?} */
var MACHINE_CARD_ELEMENTS_ELEMENT = 'element';
/** @type {?} */
var MACHINE_CARD_ELEMENTS_LAYOUT = {
    machineCardElementsArrayModel: FORM_LAYOUT_INPUT_ALL$6,
    element: FORM_LAYOUT_INPUT_ALL_ITEM$6
};
var ɵ0$7 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicMachineCardElementFormControlModel({
            id: MACHINE_CARD_ELEMENTS_ELEMENT
        })
    ];
};
/** @type {?} */
var MACHINE_CARD_ELEMENTS_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: MACHINE_CARD_ELEMENTS_ARRAY_MODEL,
        initialCount: 1,
        groupFactory: (ɵ0$7)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElementsFormService = /** @class */ (function () {
    function MachineCardElementsFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    MachineCardElementsFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    MachineCardElementsFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    MachineCardElementsFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    MachineCardElementsFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = MACHINE_CARD_ELEMENTS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} machineCardElementModel
             * @return {?}
             */
            function (machineCardElementModel) {
                machineCardElementModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    MachineCardElementsFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    MachineCardElementsFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    MachineCardElementsFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    MachineCardElementsFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    MachineCardElementsFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementsFormService.prototype.getMachineCardElementsArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(MACHINE_CARD_ELEMENTS_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.element; }));
        })));
    };
    MachineCardElementsFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MachineCardElementsFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return MachineCardElementsFormService;
}());
if (false) {
    /** @type {?} */
    MachineCardElementsFormService.prototype.formModelSubject;
    /** @type {?} */
    MachineCardElementsFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineCardElementsFormComponent = /** @class */ (function () {
    function MachineCardElementsFormComponent(machineCardElementsFormService) {
        var _this = this;
        this.machineCardElementsFormService = machineCardElementsFormService;
        this.machineCardElementsChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getMachineCardElementsFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.machineCardElementsFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === MACHINE_CARD_ELEMENTS_ARRAY_MODEL; }))));
        });
        this.getMachineCardElementsArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.machineCardElementsFormService
                .findModelById(MACHINE_CARD_ELEMENTS_ARRAY_MODEL, MACHINE_CARD_ELEMENTS_FORM_MODEL);
            return (/** @type {?} */ (_this.machineCardElementsFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = MACHINE_CARD_ELEMENTS_LAYOUT;
        this.machineCardElementsFormService.formModelSubject.next(MACHINE_CARD_ELEMENTS_FORM_MODEL);
        this.formGroup = this.machineCardElementsFormService.createFormGroup(MACHINE_CARD_ELEMENTS_FORM_MODEL);
        this.subscribeToMachineCardElementsArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(MachineCardElementsFormComponent.prototype, "machineCardElements", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.elements != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.machineCardElementsData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.machineCardElementsData = value;
            }
            else {
                this.machineCardElementsData = new MachineCardElements([]);
                this.updateFormValue(this.machineCardElementsData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineCardElementsFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.machineCardElementsFormService.getFormModel$(this.translateKey);
        this.updateFormValue(this.machineCardElementsData);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.machineCardElementsArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} machineCardElements
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} machineCardElements
     * @return {?}
     */
    function (machineCardElements) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (machineCardElements != null && machineCardElements.elements != null) {
            groupSize = machineCardElements.elements.length;
            values = machineCardElements.elements.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ element: x }); }));
        }
        this.machineCardElementsFormService.initFormArrayGroup(groupSize, this.getMachineCardElementsArrayModelControl(), this.getMachineCardElementsFormArrayModel());
        if (values) {
            this.formGroup.get(MACHINE_CARD_ELEMENTS_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.subscribeToMachineCardElementsArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.machineCardElementsArrayModelChangesSubscription = this.machineCardElementsFormService
            .getMachineCardElementsArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.machineCardElementsData = null;
            }
            else {
                _this.machineCardElementsData = new MachineCardElements(value);
            }
            _this.machineCardElementsChange.emit(_this.machineCardElementsData);
        }));
    };
    Object.defineProperty(MachineCardElementsFormComponent.prototype, "showAddEntryButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getMachineCardElementsArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineCardElementsFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getMachineCardElementsArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.machineCardElementsFormService.removeFormArrayGroup(index, this.getMachineCardElementsArrayModelControl(), context);
        this.machineCardElementsFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.machineCardElementsFormService.insertFormArrayGroup(index, this.getMachineCardElementsArrayModelControl(), context);
        this.machineCardElementsFormService.formModelSubject.next([context]);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    MachineCardElementsFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.machineCardElementsFormService.insertFormArrayGroup(0, this.getMachineCardElementsArrayModelControl(), this.getMachineCardElementsFormArrayModel());
        this.machineCardElementsFormService.formModelSubject.next([this.getMachineCardElementsFormArrayModel()]);
        this.updateFormGroupTouched();
    };
    MachineCardElementsFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-card-elements-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #entriesForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddEntryButton\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addEntry' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n\r\n                <ng-template modelId=\"machineCardElementsArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"machine-card-elements-buttons\">\r\n                        <button type=\"button\" class=\"btn btn-danger\" (click)=\"removeItem(context, index)\" [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i class=\"ft-plus\"></i></button>\r\n                    </div>\r\n                </ng-template>\r\n\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        MachineCardElementsFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    MachineCardElementsFormComponent.ctorParameters = function () { return [
        { type: MachineCardElementsFormService }
    ]; };
    MachineCardElementsFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        machineCardElements: [{ type: Input }],
        touched: [{ type: Input }],
        machineCardElementsChange: [{ type: Output }]
    };
    return MachineCardElementsFormComponent;
}());
if (false) {
    /** @type {?} */
    MachineCardElementsFormComponent.prototype.translateKey;
    /** @type {?} */
    MachineCardElementsFormComponent.prototype.minCountRequired;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormComponent.prototype._touched;
    /** @type {?} */
    MachineCardElementsFormComponent.prototype.machineCardElementsChange;
    /** @type {?} */
    MachineCardElementsFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    MachineCardElementsFormComponent.prototype.formLayout;
    /** @type {?} */
    MachineCardElementsFormComponent.prototype.formModel$;
    /** @type {?} */
    MachineCardElementsFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormComponent.prototype.machineCardElementsData;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormComponent.prototype.machineCardElementsArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormComponent.prototype.getMachineCardElementsFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormComponent.prototype.getMachineCardElementsArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    MachineCardElementsFormComponent.prototype.machineCardElementsFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSION = 'ACL_PERMISSION';
/**
 * @record
 */
function DynamicAclPermissionFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicAclPermissionFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicAclPermissionFormControlModelConfig.prototype.totalAreaInHa;
}
var DynamicAclPermissionFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicAclPermissionFormControlModel, _super);
    function DynamicAclPermissionFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSION;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicAclPermissionFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicAclPermissionFormControlModel.prototype, "translateKey", void 0);
    return DynamicAclPermissionFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicAclPermissionFormControlModel.prototype.type;
    /** @type {?} */
    DynamicAclPermissionFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicAclPermissionFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicAclPermissionFormControlComponent, _super);
    function DynamicAclPermissionFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicAclPermissionFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-acl-permission-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-acl-permission-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-acl-permission-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicAclPermissionFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicAclPermissionFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicAclPermissionFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicAclPermissionFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicAclPermissionFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicAclPermissionFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicAclPermissionFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicAclPermissionFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicAclPermissionFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicAclPermissionFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicAclPermissionFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicAclPermissionFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ACLPermission = /** @class */ (function () {
    function ACLPermission(resourceId, permissions) {
        this.resourceId = resourceId;
        this.permissions = permissions;
    }
    return ACLPermission;
}());
if (false) {
    /** @type {?} */
    ACLPermission.prototype.resourceId;
    /** @type {?} */
    ACLPermission.prototype.permissions;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionFormControlComponent = /** @class */ (function () {
    function AclPermissionFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(AclPermissionFormControlComponent.prototype, "aclPermission", {
        get: /**
         * @return {?}
         */
        function () {
            return this._aclPermission;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._aclPermission = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    AclPermissionFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._aclPermission = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AclPermissionFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AclPermissionFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    AclPermissionFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    AclPermissionFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-acl-permission-form-control',
                    template: "<app-acl-permission-form\r\n    [(aclPermission)]=\"aclPermission\"\r\n    [translateKey]=\"translateKey\"\r\n    [touched]=\"touched\">\r\n</app-acl-permission-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return AclPermissionFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    AclPermissionFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        aclPermission: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return AclPermissionFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormControlComponent.prototype._aclPermission;
    /** @type {?} */
    AclPermissionFormControlComponent.prototype.translateKey;
    /** @type {?} */
    AclPermissionFormControlComponent.prototype.touched;
    /** @type {?} */
    AclPermissionFormControlComponent.prototype.blur;
    /** @type {?} */
    AclPermissionFormControlComponent.prototype.change;
    /** @type {?} */
    AclPermissionFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionFormService = /** @class */ (function () {
    function AclPermissionFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    AclPermissionFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    AclPermissionFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    AclPermissionFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    AclPermissionFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    AclPermissionFormService.prototype.getResourceIdValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('resourceId').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    AclPermissionFormService.prototype.getPermissionsValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('permissions').valueChanges;
    };
    AclPermissionFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AclPermissionFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return AclPermissionFormService;
}());
if (false) {
    /** @type {?} */
    AclPermissionFormService.prototype.formModelSubject;
    /** @type {?} */
    AclPermissionFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ACLPermissionsEnum = {
    READ: 'Read',
    WRITE: 'Read,Write',
    MANAGE: 'Read,Write,Manage',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$a = {
    grid: {
        host: 'acl-permission-host col-5',
        container: 'acl-permission-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var ACL_PERMISSION_LAYOUT = {
    resourceId: {
        grid: __assign({}, FORM_LAYOUT_INPUT$a.grid, { host: 'acl-permissions-host col-6' })
    },
    permissions: FORM_LAYOUT_INPUT$a
};
/** @type {?} */
var ACL_PERMISSION_FORM_MODEL = [
    new DynamicInputModel({
        id: 'resourceId',
        minLength: 36,
        maxLength: 36,
        required: true
    }),
    new DynamicSelectModel({
        id: 'permissions',
        options: getOptionsForDynamicSelectModel(ACLPermissionsEnum, 'ACL_LEVEL', false),
        validators: {
            required: null
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionFormComponent = /** @class */ (function () {
    function AclPermissionFormComponent(numberUtilService, aclPermissionFormService) {
        this.numberUtilService = numberUtilService;
        this.aclPermissionFormService = aclPermissionFormService;
        this.aclPermissionChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = ACL_PERMISSION_LAYOUT;
        this.aclPermissionFormService.formModelSubject.next(ACL_PERMISSION_FORM_MODEL);
        this.formGroup = this.aclPermissionFormService.createFormGroup(ACL_PERMISSION_FORM_MODEL);
    }
    Object.defineProperty(AclPermissionFormComponent.prototype, "aclPermission", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.aclPermissionData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.aclPermissionData = value;
            }
            else {
                this.aclPermissionData = new ACLPermission('', '');
                this.updateFormValue(this.aclPermissionData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AclPermissionFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    AclPermissionFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.aclPermissionFormService.getFormModel$(this.translateKey);
        this.subscribeToResourceIdModelValueChanges(this.formGroup);
        this.subscribeToPermissionsModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    AclPermissionFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @return {?}
     */
    AclPermissionFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.resourceIdChangesSubscription.unsubscribe();
        this.permissionsChangeSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} aclPermission
     * @return {?}
     */
    AclPermissionFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} aclPermission
     * @return {?}
     */
    function (aclPermission) {
        this.formGroup.get('resourceId').patchValue(aclPermission.resourceId);
        this.formGroup.get('permissions').patchValue(aclPermission.permissions);
    };
    /**
     * @private
     * @return {?}
     */
    AclPermissionFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var resourceId = this.formGroup.get('resourceId').value;
        /** @type {?} */
        var permissions = this.formGroup.get('permissions').value;
        return new ACLPermission(resourceId, permissions);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    AclPermissionFormComponent.prototype.subscribeToResourceIdModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.resourceIdChangesSubscription = this.aclPermissionFormService
            .getResourceIdValue$(formGroup)
            .subscribe((/**
         * @param {?} resourceId
         * @return {?}
         */
        function (resourceId) {
            _this.onPermissionsChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    AclPermissionFormComponent.prototype.subscribeToPermissionsModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.permissionsChangeSubscription = this.aclPermissionFormService
            .getPermissionsValue$(formGroup)
            .subscribe((/**
         * @param {?} permissions
         * @return {?}
         */
        function (permissions) {
            _this.onPermissionsChange();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    AclPermissionFormComponent.prototype.onPermissionsChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.aclPermissionData = this.getFormValue();
        this.aclPermissionChange.emit(this.aclPermissionData);
    };
    AclPermissionFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-acl-permission-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        AclPermissionFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    AclPermissionFormComponent.ctorParameters = function () { return [
        { type: NumberUtilService },
        { type: AclPermissionFormService }
    ]; };
    AclPermissionFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        aclPermission: [{ type: Input }],
        touched: [{ type: Input }],
        aclPermissionChange: [{ type: Output }]
    };
    return AclPermissionFormComponent;
}());
if (false) {
    /** @type {?} */
    AclPermissionFormComponent.prototype.translateKey;
    /** @type {?} */
    AclPermissionFormComponent.prototype.aclPermissionChange;
    /** @type {?} */
    AclPermissionFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    AclPermissionFormComponent.prototype.formLayout;
    /** @type {?} */
    AclPermissionFormComponent.prototype.formModel$;
    /** @type {?} */
    AclPermissionFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormComponent.prototype.aclPermissionData;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormComponent.prototype.resourceIdChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormComponent.prototype.permissionsChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormComponent.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    AclPermissionFormComponent.prototype.aclPermissionFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSIONS = 'ACL_PERMISSIONS';
/**
 * @record
 */
function DynamicAclPermissionsFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicAclPermissionsFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicAclPermissionsFormControlModelConfig.prototype.minCountRequired;
}
var DynamicAclPermissionsFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicAclPermissionsFormControlModel, _super);
    function DynamicAclPermissionsFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSIONS;
        _this.translateKey = config.translateKey;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicAclPermissionsFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicAclPermissionsFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicAclPermissionsFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicAclPermissionsFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicAclPermissionsFormControlModel.prototype.type;
    /** @type {?} */
    DynamicAclPermissionsFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicAclPermissionsFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicAclPermissionsFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicAclPermissionsFormControlComponent, _super);
    function DynamicAclPermissionsFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicAclPermissionsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-acl-permissions-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n    <app-acl-permissions-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-acl-permissions-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicAclPermissionsFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicAclPermissionsFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicAclPermissionsFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicAclPermissionsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicAclPermissionsFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicAclPermissionsFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ACLPermissions = /** @class */ (function () {
    function ACLPermissions(permissions) {
        this.permissions = permissions;
    }
    return ACLPermissions;
}());
if (false) {
    /** @type {?} */
    ACLPermissions.prototype.permissions;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionsFormControlComponent = /** @class */ (function () {
    function AclPermissionsFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(AclPermissionsFormControlComponent.prototype, "aclPermissions", {
        get: /**
         * @return {?}
         */
        function () {
            return this._aclPermissions;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._aclPermissions = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    AclPermissionsFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._aclPermissions = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AclPermissionsFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AclPermissionsFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    AclPermissionsFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    AclPermissionsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-acl-permissions-form-control',
                    template: "<app-acl-permissions-form\r\n    [(aclPermissions)]=\"aclPermissions\"\r\n    [translateKey]=\"translateKey\"\r\n    [minCountRequired]=\"minCountRequired\"\r\n    [touched]=\"touched\">\r\n</app-acl-permissions-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return AclPermissionsFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    AclPermissionsFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        aclPermissions: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return AclPermissionsFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormControlComponent.prototype._aclPermissions;
    /** @type {?} */
    AclPermissionsFormControlComponent.prototype.translateKey;
    /** @type {?} */
    AclPermissionsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    AclPermissionsFormControlComponent.prototype.touched;
    /** @type {?} */
    AclPermissionsFormControlComponent.prototype.blur;
    /** @type {?} */
    AclPermissionsFormControlComponent.prototype.change;
    /** @type {?} */
    AclPermissionsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormControlComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$7 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$7 = {
    grid: {
        host: 'acl-permissions-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var ACL_PERMISSIONS_ARRAY_MODEL = 'aclPermissionsArrayModel';
/** @type {?} */
var ACL_PERMISSIONS_PERMISSION = 'permission';
/** @type {?} */
var ACL_PERMISSIONS_LAYOUT = {
    aclPermissionsArrayModel: FORM_LAYOUT_INPUT_ALL$7,
    permission: FORM_LAYOUT_INPUT_ALL_ITEM$7
};
var ɵ0$8 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicAclPermissionFormControlModel({
            id: ACL_PERMISSIONS_PERMISSION
        })
    ];
};
/** @type {?} */
var ACL_PERMISSIONS_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: ACL_PERMISSIONS_ARRAY_MODEL,
        initialCount: 1,
        groupFactory: (ɵ0$8)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionsFormService = /** @class */ (function () {
    function AclPermissionsFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.formModelTotalAreaInHaSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    AclPermissionsFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    AclPermissionsFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    AclPermissionsFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    AclPermissionsFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = ACL_PERMISSIONS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} treatmentSeedModel
             * @return {?}
             */
            function (treatmentSeedModel) {
                treatmentSeedModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    AclPermissionsFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    AclPermissionsFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    AclPermissionsFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    AclPermissionsFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    AclPermissionsFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    AclPermissionsFormService.prototype.getAclPermissionsArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(ACL_PERMISSIONS_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.permission; }));
        })));
    };
    AclPermissionsFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AclPermissionsFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return AclPermissionsFormService;
}());
if (false) {
    /** @type {?} */
    AclPermissionsFormService.prototype.formModelSubject;
    /** @type {?} */
    AclPermissionsFormService.prototype.formModelTotalAreaInHaSubject;
    /** @type {?} */
    AclPermissionsFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionsFormComponent = /** @class */ (function () {
    function AclPermissionsFormComponent(aclPermissionsFormService) {
        var _this = this;
        this.aclPermissionsFormService = aclPermissionsFormService;
        this.aclPermissionsChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getAclPermissionsFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.aclPermissionsFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === ACL_PERMISSIONS_ARRAY_MODEL; }))));
        });
        this.getAclPermissionsArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.aclPermissionsFormService
                .findModelById(ACL_PERMISSIONS_ARRAY_MODEL, ACL_PERMISSIONS_FORM_MODEL);
            return (/** @type {?} */ (_this.aclPermissionsFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.updateFormGroupTouched = (/**
         * @return {?}
         */
        function () {
            if (_this._touched) {
                _this.formGroup.markAllAsTouched();
            }
        });
        this.formLayout = ACL_PERMISSIONS_LAYOUT;
        this.aclPermissionsFormService.formModelSubject.next(ACL_PERMISSIONS_FORM_MODEL);
        this.formGroup = this.aclPermissionsFormService.createFormGroup(ACL_PERMISSIONS_FORM_MODEL);
        this.subscribeToAclPermissionsArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(AclPermissionsFormComponent.prototype, "aclPermissions", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.permissions != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.aclPermissionsData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.aclPermissionsData = value;
            }
            else {
                this.aclPermissionsData = new ACLPermissions([]);
                this.updateFormValue(this.aclPermissionsData);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AclPermissionsFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._touched = value;
            this.updateFormGroupTouched();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.aclPermissionsFormService.getFormModel$(this.translateKey);
        this.updateFormValue(this.aclPermissionsData);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.aclPermissionsArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} aclPermissions
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} aclPermissions
     * @return {?}
     */
    function (aclPermissions) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (aclPermissions != null && aclPermissions.permissions != null) {
            groupSize = aclPermissions.permissions.length;
            values = aclPermissions.permissions.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ permission: x }); }));
        }
        this.aclPermissionsFormService.initFormArrayGroup(groupSize, this.getAclPermissionsArrayModelControl(), this.getAclPermissionsFormArrayModel());
        if (values) {
            this.formGroup.get(ACL_PERMISSIONS_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.subscribeToAclPermissionsArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.aclPermissionsArrayModelChangesSubscription = this.aclPermissionsFormService
            .getAclPermissionsArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.aclPermissionsData = null;
            }
            else {
                _this.aclPermissionsData = new ACLPermissions(value);
            }
            _this.aclPermissionsChange.emit(_this.aclPermissionsData);
        }));
    };
    Object.defineProperty(AclPermissionsFormComponent.prototype, "showAddAclPermissionButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getAclPermissionsArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AclPermissionsFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getAclPermissionsArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.aclPermissionsFormService.removeFormArrayGroup(index, this.getAclPermissionsArrayModelControl(), context);
        this.aclPermissionsFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.aclPermissionsFormService.insertFormArrayGroup(index, this.getAclPermissionsArrayModelControl(), context);
        this.aclPermissionsFormService.formModelSubject.next([context]);
        this.updateFormGroupTouched();
    };
    /**
     * @return {?}
     */
    AclPermissionsFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.aclPermissionsFormService.insertFormArrayGroup(0, this.getAclPermissionsArrayModelControl(), this.getAclPermissionsFormArrayModel());
        this.aclPermissionsFormService.formModelSubject.next([this.getAclPermissionsFormArrayModel()]);
        this.updateFormGroupTouched();
    };
    AclPermissionsFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-acl-permissions-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #permissionsForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddAclPermissionButton\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addPermissions' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n\r\n                <ng-template modelId=\"aclPermissionsArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"acl-permissions-buttons\">\r\n                        <button type=\"button\" class=\"btn btn-danger\" (click)=\"removeItem(context, index)\" [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i class=\"ft-plus\"></i></button>\r\n                    </div>\r\n                </ng-template>\r\n\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        AclPermissionsFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    AclPermissionsFormComponent.ctorParameters = function () { return [
        { type: AclPermissionsFormService }
    ]; };
    AclPermissionsFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        aclPermissions: [{ type: Input }],
        touched: [{ type: Input }],
        aclPermissionsChange: [{ type: Output }]
    };
    return AclPermissionsFormComponent;
}());
if (false) {
    /** @type {?} */
    AclPermissionsFormComponent.prototype.translateKey;
    /** @type {?} */
    AclPermissionsFormComponent.prototype.minCountRequired;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponent.prototype._touched;
    /** @type {?} */
    AclPermissionsFormComponent.prototype.aclPermissionsChange;
    /** @type {?} */
    AclPermissionsFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    AclPermissionsFormComponent.prototype.formLayout;
    /** @type {?} */
    AclPermissionsFormComponent.prototype.formModel$;
    /** @type {?} */
    AclPermissionsFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponent.prototype.aclPermissionsData;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponent.prototype.aclPermissionsArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponent.prototype.getAclPermissionsFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponent.prototype.getAclPermissionsArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponent.prototype.updateFormGroupTouched;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponent.prototype.aclPermissionsFormService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function aclPermissionsValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var aclPermissions = (/** @type {?} */ (control.value));
        if (aclPermissions.permissions == null || aclPermissions.permissions.length === 0) {
            return null;
        }
        /** @type {?} */
        var isPermissionCorrect = (/**
         * @param {?} permission
         * @return {?}
         */
        function (permission) {
            if (permission == null) {
                return false;
            }
            return !isEmpty(permission.resourceId)
                // tslint:disable-next-line:no-magic-numbers
                && permission.resourceId.length === 36
                && !isEmpty(permission.permissions);
        });
        if (aclPermissions.permissions.some((/**
         * @param {?} permission
         * @return {?}
         */
        function (permission) { return !isPermissionCorrect(permission); }))
            || !aclPermissions.permissions.some((/**
             * @param {?} permission
             * @return {?}
             */
            function (permission) { return permission.permissions.indexOf(ACLPermissionsEnum.MANAGE) > -1; }))) {
            return { aclPermissions: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENT = 'MACHINE_ALARM_CONF_ELEMENT';
/**
 * @record
 */
function DynamicMachineAlarmConfElementFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicMachineAlarmConfElementFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicMachineAlarmConfElementFormControlModelConfig.prototype.totalAreaInHa;
}
var DynamicMachineAlarmConfElementFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicMachineAlarmConfElementFormControlModel, _super);
    function DynamicMachineAlarmConfElementFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENT;
        _this.translateKey = config.translateKey;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineAlarmConfElementFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineAlarmConfElementFormControlModel.prototype, "translateKey", void 0);
    return DynamicMachineAlarmConfElementFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlModel.prototype.type;
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlModel.prototype.translateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMachineAlarmConfElementFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMachineAlarmConfElementFormControlComponent, _super);
    function DynamicMachineAlarmConfElementFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMachineAlarmConfElementFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-machine-alarm-conf-element-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-machine-alarm-conf-element-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-machine-alarm-conf-element-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicMachineAlarmConfElementFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMachineAlarmConfElementFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMachineAlarmConfElementFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineAlarmConfElementFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElementModel = /** @class */ (function () {
    function MachineAlarmConfElementModel(thresholdOperator, thresholdProperty, value, values, location) {
        this.thresholdOperator = thresholdOperator;
        this.thresholdProperty = thresholdProperty;
        this.value = value;
        this.values = values;
        this.location = location;
    }
    return MachineAlarmConfElementModel;
}());
if (false) {
    /** @type {?} */
    MachineAlarmConfElementModel.prototype.thresholdOperator;
    /** @type {?} */
    MachineAlarmConfElementModel.prototype.thresholdProperty;
    /** @type {?} */
    MachineAlarmConfElementModel.prototype.value;
    /** @type {?} */
    MachineAlarmConfElementModel.prototype.values;
    /** @type {?} */
    MachineAlarmConfElementModel.prototype.location;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElementFormControlComponent = /** @class */ (function () {
    function MachineAlarmConfElementFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.propagateChange = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(MachineAlarmConfElementFormControlComponent.prototype, "machineAlarmConfElement", {
        get: /**
         * @return {?}
         */
        function () {
            return this._machineAlarmConfElement;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._machineAlarmConfElement = value;
            this.propagateChange(value);
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} obj
     * @return {?}
     */
    MachineAlarmConfElementFormControlComponent.prototype.writeValue = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._machineAlarmConfElement = obj;
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineAlarmConfElementFormControlComponent.prototype.registerOnChange = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.propagateChange = fn;
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineAlarmConfElementFormControlComponent.prototype.registerOnTouched = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MachineAlarmConfElementFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    MachineAlarmConfElementFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-alarm-conf-element-form-control',
                    template: "<app-machine-alarm-conf-element-form\r\n    [(machineAlarmConfElement)]=\"machineAlarmConfElement\"\r\n    [translateKey]=\"translateKey\">\r\n</app-machine-alarm-conf-element-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MachineAlarmConfElementFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    MachineAlarmConfElementFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        machineAlarmConfElement: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MachineAlarmConfElementFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormControlComponent.prototype._machineAlarmConfElement;
    /** @type {?} */
    MachineAlarmConfElementFormControlComponent.prototype.translateKey;
    /** @type {?} */
    MachineAlarmConfElementFormControlComponent.prototype.blur;
    /** @type {?} */
    MachineAlarmConfElementFormControlComponent.prototype.change;
    /** @type {?} */
    MachineAlarmConfElementFormControlComponent.prototype.focus;
    /** @type {?} */
    MachineAlarmConfElementFormControlComponent.prototype.propagateChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElementFormService = /** @class */ (function () {
    function MachineAlarmConfElementFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @param {?} formModel
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.getThresholdOperatorValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('thresholdOperator').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.getThresholdPropertyValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('thresholdProperty').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.getValueValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('value').valueChanges;
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormService.prototype.getLocationValue$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get('location').valueChanges;
    };
    MachineAlarmConfElementFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MachineAlarmConfElementFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return MachineAlarmConfElementFormService;
}());
if (false) {
    /** @type {?} */
    MachineAlarmConfElementFormService.prototype.formModelSubject;
    /** @type {?} */
    MachineAlarmConfElementFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$b = {
    grid: {
        host: 'machine-alarm-conf-element-host',
        container: 'machine-alarm-conf-element-container',
        label: '',
        control: ''
    }
};
/** @type {?} */
var MACHINE_ALARM_CONF_ELEMENT_LAYOUT = {
    thresholdOperator: FORM_LAYOUT_INPUT$b,
    thresholdProperty: FORM_LAYOUT_INPUT$b,
    value: FORM_LAYOUT_INPUT$b,
    values: FORM_LAYOUT_INPUT$b,
    location: FORM_LAYOUT_INPUT$b
};
/** @type {?} */
var MACHINE_ALARM_CONF_ELEMENT_FORM_MODEL = [
    new DynamicSelectModel({
        id: 'thresholdProperty',
        options: getOptionsForDynamicSelectModel(AlarmThresholdProperty, 'ALARM_THRESHOLD_PROPERTY', false),
        validators: {
            required: null
        }
    }),
    new DynamicSelectModel({
        id: 'thresholdOperator',
        options: getOptionsForDynamicSelectModel(ThresholdOperator, 'ALARM_THRESHOLD_OPERATOR', false),
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'value',
        min: 0.1,
        max: 10000,
        inputType: 'number',
        validators: {
            required: null,
            min: 0.1,
            max: 10000
        }
    }),
    new DynamicSelectModel({
        id: 'location',
        options: getOptionsForDynamicSelectModel(AlarmLocation, 'ALARM_LOCATION', false),
        validators: {
            required: null
        }
    }),
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElementFormComponent = /** @class */ (function () {
    function MachineAlarmConfElementFormComponent(machineAlarmConfElementFormService) {
        this.machineAlarmConfElementFormService = machineAlarmConfElementFormService;
        this.machineAlarmConfElementChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = MACHINE_ALARM_CONF_ELEMENT_LAYOUT;
        this.machineAlarmConfElementFormService.formModelSubject.next(MACHINE_ALARM_CONF_ELEMENT_FORM_MODEL);
        this.formGroup = this.machineAlarmConfElementFormService.createFormGroup(MACHINE_ALARM_CONF_ELEMENT_FORM_MODEL);
    }
    Object.defineProperty(MachineAlarmConfElementFormComponent.prototype, "machineAlarmConfElement", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                if (JSON.stringify(value) !== JSON.stringify(this.machineAlarmConfElementData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.machineAlarmConfElementData = value;
            }
            else {
                // tslint:disable-next-line:max-line-length
                this.machineAlarmConfElementData = new MachineAlarmConfElementModel(ThresholdOperator.GreaterThan, AlarmThresholdProperty.SPEED, 0, [0], AlarmLocation.EVERYWHERE);
                this.updateFormValue(this.machineAlarmConfElementData);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.machineAlarmConfElementFormService.getFormModel$(this.translateKey);
        this.subscribeToThresholdOperatorModelValueChanges(this.formGroup);
        this.subscribeToThresholdPropertyModelValueChanges(this.formGroup);
        this.subscribeToValueModelValueChanges(this.formGroup);
        this.subscribeToLocationModelValueChanges(this.formGroup);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.thresholdOperatorChangesSubscription.unsubscribe();
        this.thresholdPropertyChangesSubscription.unsubscribe();
        this.valueChangesSubscription.unsubscribe();
        this.locationChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} machineAlarmConfElementModel
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} machineAlarmConfElementModel
     * @return {?}
     */
    function (machineAlarmConfElementModel) {
        this.formGroup.get('thresholdOperator').patchValue(machineAlarmConfElementModel.thresholdOperator);
        this.formGroup.get('thresholdProperty').patchValue(machineAlarmConfElementModel.thresholdProperty);
        this.formGroup.get('value').patchValue(machineAlarmConfElementModel.value);
        this.formGroup.get('location').patchValue(machineAlarmConfElementModel.location);
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.subscribeToThresholdOperatorModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.thresholdOperatorChangesSubscription = this.machineAlarmConfElementFormService
            .getThresholdOperatorValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineAlarmConfElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.subscribeToThresholdPropertyModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.thresholdPropertyChangesSubscription = this.machineAlarmConfElementFormService
            .getThresholdPropertyValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineAlarmConfElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.subscribeToValueModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.valueChangesSubscription = this.machineAlarmConfElementFormService
            .getValueValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineAlarmConfElementChange();
        }));
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.subscribeToLocationModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.locationChangesSubscription = this.machineAlarmConfElementFormService
            .getLocationValue$(formGroup)
            .subscribe((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this.onMachineAlarmConfElementChange();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.getFormValue = /**
     * @private
     * @return {?}
     */
    function () {
        return new MachineAlarmConfElementModel(this.formGroup.get('thresholdOperator').value, this.formGroup.get('thresholdProperty').value, this.formGroup.get('value').value, [this.formGroup.get('value').value], this.formGroup.get('location').value);
    };
    /**
     * @private
     * @return {?}
     */
    MachineAlarmConfElementFormComponent.prototype.onMachineAlarmConfElementChange = /**
     * @private
     * @return {?}
     */
    function () {
        this.machineAlarmConfElementData = this.getFormValue();
        this.machineAlarmConfElementChange.emit(this.machineAlarmConfElementData);
    };
    MachineAlarmConfElementFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-alarm-conf-element-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        MachineAlarmConfElementFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    MachineAlarmConfElementFormComponent.ctorParameters = function () { return [
        { type: MachineAlarmConfElementFormService }
    ]; };
    MachineAlarmConfElementFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        machineAlarmConfElement: [{ type: Input }],
        machineAlarmConfElementChange: [{ type: Output }]
    };
    return MachineAlarmConfElementFormComponent;
}());
if (false) {
    /** @type {?} */
    MachineAlarmConfElementFormComponent.prototype.translateKey;
    /** @type {?} */
    MachineAlarmConfElementFormComponent.prototype.machineAlarmConfElementChange;
    /** @type {?} */
    MachineAlarmConfElementFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    MachineAlarmConfElementFormComponent.prototype.formLayout;
    /** @type {?} */
    MachineAlarmConfElementFormComponent.prototype.formModel$;
    /** @type {?} */
    MachineAlarmConfElementFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormComponent.prototype.machineAlarmConfElementData;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormComponent.prototype.thresholdOperatorChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormComponent.prototype.thresholdPropertyChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormComponent.prototype.valueChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormComponent.prototype.locationChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementFormComponent.prototype.machineAlarmConfElementFormService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENTS = 'MACHINE_ALARM_CONF_ELEMENTS';
/**
 * @record
 */
function DynamicMachineAlarmConfElementsFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlModelConfig.prototype.translateKey;
    /** @type {?|undefined} */
    DynamicMachineAlarmConfElementsFormControlModelConfig.prototype.minCountRequired;
}
var DynamicMachineAlarmConfElementsFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicMachineAlarmConfElementsFormControlModel, _super);
    function DynamicMachineAlarmConfElementsFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENTS;
        _this.translateKey = config.translateKey;
        _this.minCountRequired = config.minCountRequired;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineAlarmConfElementsFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMachineAlarmConfElementsFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Number)
    ], DynamicMachineAlarmConfElementsFormControlModel.prototype, "minCountRequired", void 0);
    return DynamicMachineAlarmConfElementsFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlModel.prototype.type;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlModel.prototype.minCountRequired;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMachineAlarmConfElementsFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMachineAlarmConfElementsFormControlComponent, _super);
    function DynamicMachineAlarmConfElementsFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMachineAlarmConfElementsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-machine-alarm-conf-elements-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-machine-alarm-conf-elements-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [minCountRequired]=\"model.minCountRequired\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-machine-alarm-conf-elements-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicMachineAlarmConfElementsFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMachineAlarmConfElementsFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMachineAlarmConfElementsFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMachineAlarmConfElementsFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function machineAlarmConfElementsValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var machineAlarmConfElements = (/** @type {?} */ (control.value));
        if (machineAlarmConfElements.elements == null || machineAlarmConfElements.elements.length === 0) {
            return null;
        }
        /** @type {?} */
        var isMachineAlarmConfElementsCorrect = (/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (element == null) {
                return false;
            }
            return element.thresholdOperator
                && element.thresholdProperty
                && element.value != null
                && element.value > 0;
        });
        if (machineAlarmConfElements.elements.some((/**
         * @param {?} element
         * @return {?}
         */
        function (element) { return !isMachineAlarmConfElementsCorrect(element); }))) {
            return { machineAlarmConfElements: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElements = /** @class */ (function () {
    function MachineAlarmConfElements(elements) {
        this.elements = elements;
    }
    return MachineAlarmConfElements;
}());
if (false) {
    /** @type {?} */
    MachineAlarmConfElements.prototype.elements;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElementsFormControlComponent = /** @class */ (function () {
    function MachineAlarmConfElementsFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.propagateChange = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(MachineAlarmConfElementsFormControlComponent.prototype, "machineAlarmConfElements", {
        get: /**
         * @return {?}
         */
        function () {
            return this._machineAlarmConfElements;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._machineAlarmConfElements = value;
            this.propagateChange(value);
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} obj
     * @return {?}
     */
    MachineAlarmConfElementsFormControlComponent.prototype.writeValue = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this._machineAlarmConfElements = obj;
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineAlarmConfElementsFormControlComponent.prototype.registerOnChange = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.propagateChange = fn;
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    MachineAlarmConfElementsFormControlComponent.prototype.registerOnTouched = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MachineAlarmConfElementsFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
    };
    MachineAlarmConfElementsFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-alarm-conf-elements-form-control',
                    template: "<app-machine-alarm-conf-elements-form\r\n    [(machineAlarmConfElements)]=\"machineAlarmConfElements\"\r\n    [translateKey]=\"translateKey\"\r\n    [minCountRequired]=\"minCountRequired\">\r\n</app-machine-alarm-conf-elements-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MachineAlarmConfElementsFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    MachineAlarmConfElementsFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        machineAlarmConfElements: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MachineAlarmConfElementsFormControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormControlComponent.prototype._machineAlarmConfElements;
    /** @type {?} */
    MachineAlarmConfElementsFormControlComponent.prototype.translateKey;
    /** @type {?} */
    MachineAlarmConfElementsFormControlComponent.prototype.minCountRequired;
    /** @type {?} */
    MachineAlarmConfElementsFormControlComponent.prototype.blur;
    /** @type {?} */
    MachineAlarmConfElementsFormControlComponent.prototype.change;
    /** @type {?} */
    MachineAlarmConfElementsFormControlComponent.prototype.focus;
    /** @type {?} */
    MachineAlarmConfElementsFormControlComponent.prototype.propagateChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL$8 = {
    grid: {
        host: 'col-12',
        container: 'row',
        label: 'd-none',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_INPUT_ALL_ITEM$8 = {
    grid: {
        host: 'machine-alarm-conf-elements-host',
        container: '',
        label: 'd-none',
        control: ''
    }
};
/** @type {?} */
var MACHINE_ALARM_CONF_ELEMENTS_ARRAY_MODEL = 'machineAlarmConfElementsArrayModel';
/** @type {?} */
var MACHINE_ALARM_CONF_ELEMENTS_ELEMENT = 'element';
/** @type {?} */
var MACHINE_ALARM_CONF_ELEMENTS_LAYOUT = {
    machineAlarmConfElementsArrayModel: FORM_LAYOUT_INPUT_ALL$8,
    element: FORM_LAYOUT_INPUT_ALL_ITEM$8
};
var ɵ0$9 = /**
 * @return {?}
 */
function () {
    return [
        new DynamicMachineAlarmConfElementFormControlModel({
            id: MACHINE_ALARM_CONF_ELEMENTS_ELEMENT
        })
    ];
};
/** @type {?} */
var MACHINE_ALARM_CONF_ELEMENTS_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: MACHINE_ALARM_CONF_ELEMENTS_ARRAY_MODEL,
        initialCount: 1,
        groupFactory: (ɵ0$9)
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElementsFormService = /** @class */ (function () {
    function MachineAlarmConfElementsFormService(translateFormModelService, translateService, formService) {
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.formService = formService;
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @return {?}
         */
        function () { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.assignTranslateKey(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.assignTranslateKey = /**
     * @private
     * @param {?} formModel
     * @param {?} translateKey
     * @return {?}
     */
    function (formModel, translateKey) {
        if (translateKey != null) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var arrayModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id = MACHINE_ALARM_CONF_ELEMENTS_ARRAY_MODEL; }))));
            // tslint:disable-next-line: no-any
            arrayModel.groups.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.group.forEach((/**
             * @param {?} machineAlarmConfElementModel
             * @return {?}
             */
            function (machineAlarmConfElementModel) {
                machineAlarmConfElementModel.translateKey = translateKey;
            })); }));
        }
        return formModel;
    };
    /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.findModelById = /**
     * @param {?} id
     * @param {?} formModel
     * @return {?}
     */
    function (id, formModel) {
        return this.formService.findModelById(id, formModel);
    };
    /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.findControlByModel = /**
     * @param {?} model
     * @param {?} group
     * @return {?}
     */
    function (model, group) {
        return this.formService.findControlByModel(model, group);
    };
    /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.initFormArrayGroup = /**
     * @param {?} groupSize
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (groupSize, formArray, formArrayModel) {
        this.formService.clearFormArray(formArray, formArrayModel);
        for (var i = 0; i < groupSize; i++) {
            this.formService.insertFormArrayGroup(i, formArray, formArrayModel);
        }
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.removeFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.removeFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.insertFormArrayGroup = /**
     * @param {?} index
     * @param {?} formArray
     * @param {?} formArrayModel
     * @return {?}
     */
    function (index, formArray, formArrayModel) {
        this.formService.insertFormArrayGroup(index, formArray, formArrayModel);
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementsFormService.prototype.getMachineAlarmConfElementsArrayModelValues$ = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        return formGroup.get(MACHINE_ALARM_CONF_ELEMENTS_ARRAY_MODEL).valueChanges
            .pipe(map((/**
         * @param {?} values
         * @return {?}
         */
        function (values) {
            return (values || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.element; }));
        })));
    };
    MachineAlarmConfElementsFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MachineAlarmConfElementsFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: DynamicFormService }
    ]; };
    return MachineAlarmConfElementsFormService;
}());
if (false) {
    /** @type {?} */
    MachineAlarmConfElementsFormService.prototype.formModelSubject;
    /** @type {?} */
    MachineAlarmConfElementsFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfElementsFormComponent = /** @class */ (function () {
    function MachineAlarmConfElementsFormComponent(machineAlarmConfElementsFormService) {
        var _this = this;
        this.machineAlarmConfElementsFormService = machineAlarmConfElementsFormService;
        this.machineAlarmConfElementsChange = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.getMachineAlarmConfElementsFormArrayModel = (/**
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (_this.machineAlarmConfElementsFormService.formModelSubject.value
                .find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === MACHINE_ALARM_CONF_ELEMENTS_ARRAY_MODEL; }))));
        });
        this.getMachineAlarmConfElementsArrayModelControl = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formArrayModel = _this.machineAlarmConfElementsFormService
                .findModelById(MACHINE_ALARM_CONF_ELEMENTS_ARRAY_MODEL, MACHINE_ALARM_CONF_ELEMENTS_FORM_MODEL);
            return (/** @type {?} */ (_this.machineAlarmConfElementsFormService.findControlByModel(formArrayModel, _this.formGroup)));
        });
        this.formLayout = MACHINE_ALARM_CONF_ELEMENTS_LAYOUT;
        this.machineAlarmConfElementsFormService.formModelSubject.next(MACHINE_ALARM_CONF_ELEMENTS_FORM_MODEL);
        this.formGroup = this.machineAlarmConfElementsFormService.createFormGroup(MACHINE_ALARM_CONF_ELEMENTS_FORM_MODEL);
        this.subscribeToMachineAlarmConfElementsArrayModelValueChanges(this.formGroup);
    }
    Object.defineProperty(MachineAlarmConfElementsFormComponent.prototype, "machineAlarmConfElements", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value.elements != null) {
                if (JSON.stringify(value) !== JSON.stringify(this.machineAlarmConfElementsData) && this.formGroup) {
                    this.updateFormValue(value);
                }
                this.machineAlarmConfElementsData = value;
            }
            else {
                this.machineAlarmConfElementsData = new MachineAlarmConfElements([]);
                this.updateFormValue(this.machineAlarmConfElementsData);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.machineAlarmConfElementsFormService.getFormModel$(this.translateKey);
        this.updateFormValue(this.machineAlarmConfElementsData);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
    };
    /**
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.machineAlarmConfElementsArrayModelChangesSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} machineAlarmConfElements
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} machineAlarmConfElements
     * @return {?}
     */
    function (machineAlarmConfElements) {
        /** @type {?} */
        var groupSize = this.minCountRequired;
        /** @type {?} */
        var values = null;
        if (machineAlarmConfElements != null && machineAlarmConfElements.elements != null) {
            groupSize = machineAlarmConfElements.elements.length;
            values = machineAlarmConfElements.elements.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ({ element: x }); }));
        }
        this.machineAlarmConfElementsFormService.initFormArrayGroup(groupSize, this.getMachineAlarmConfElementsArrayModelControl(), this.getMachineAlarmConfElementsFormArrayModel());
        if (values) {
            this.formGroup.get(MACHINE_ALARM_CONF_ELEMENTS_ARRAY_MODEL).patchValue(values);
        }
    };
    /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.subscribeToMachineAlarmConfElementsArrayModelValueChanges = /**
     * @private
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.machineAlarmConfElementsArrayModelChangesSubscription = this.machineAlarmConfElementsFormService
            .getMachineAlarmConfElementsArrayModelValues$(formGroup)
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null || value.length === 0) {
                _this.machineAlarmConfElementsData = null;
            }
            else {
                _this.machineAlarmConfElementsData = new MachineAlarmConfElements(value);
            }
            _this.machineAlarmConfElementsChange.emit(_this.machineAlarmConfElementsData);
        }));
    };
    Object.defineProperty(MachineAlarmConfElementsFormComponent.prototype, "showAddEntryButton", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getMachineAlarmConfElementsArrayModelControl().length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineAlarmConfElementsFormComponent.prototype, "removeItemDisabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getMachineAlarmConfElementsArrayModelControl().length <= this.minCountRequired;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.removeItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.machineAlarmConfElementsFormService.removeFormArrayGroup(index, this.getMachineAlarmConfElementsArrayModelControl(), context);
        this.machineAlarmConfElementsFormService.formModelSubject.next([context]);
    };
    /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.insertItem = /**
     * @param {?} context
     * @param {?} index
     * @return {?}
     */
    function (context, index) {
        this.machineAlarmConfElementsFormService.insertFormArrayGroup(index, this.getMachineAlarmConfElementsArrayModelControl(), context);
        this.machineAlarmConfElementsFormService.formModelSubject.next([context]);
    };
    /**
     * @return {?}
     */
    MachineAlarmConfElementsFormComponent.prototype.addItem = /**
     * @return {?}
     */
    function () {
        this.machineAlarmConfElementsFormService.insertFormArrayGroup(0, this.getMachineAlarmConfElementsArrayModelControl(), this.getMachineAlarmConfElementsFormArrayModel());
        this.machineAlarmConfElementsFormService.formModelSubject.next([this.getMachineAlarmConfElementsFormArrayModel()]);
    };
    MachineAlarmConfElementsFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-alarm-conf-elements-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form #entriesForm class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset *ngIf=\"showAddEntryButton\">\r\n            <button type=\"button\" (click)=\"addItem()\" class=\"btn btn-primary float-right\">\r\n                <i class=\"ft-plus\"></i>\r\n                <span>{{translateKey + '.addEntry' | translate}}</span>\r\n            </button>\r\n        </fieldset>\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row no-gutters\" [group]=\"formGroup\" [layout]=\"formLayout\"\r\n                [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0 mb-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n\r\n                <ng-template modelId=\"machineAlarmConfElementsArrayModel\" let-group let-index=\"index\" let-context=\"context\">\r\n                    <div class=\"machine-card-elements-buttons\">\r\n                        <button type=\"button\" class=\"btn btn-danger\" (click)=\"removeItem(context, index)\" [disabled]=\"removeItemDisabled\"><i class=\"ft-trash\"></i> </button>\r\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"insertItem(group.context, group.index + 1)\"><i class=\"ft-plus\"></i></button>\r\n                    </div>\r\n                </ng-template>\r\n\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        MachineAlarmConfElementsFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    MachineAlarmConfElementsFormComponent.ctorParameters = function () { return [
        { type: MachineAlarmConfElementsFormService }
    ]; };
    MachineAlarmConfElementsFormComponent.propDecorators = {
        translateKey: [{ type: Input }],
        minCountRequired: [{ type: Input }],
        machineAlarmConfElements: [{ type: Input }],
        machineAlarmConfElementsChange: [{ type: Output }]
    };
    return MachineAlarmConfElementsFormComponent;
}());
if (false) {
    /** @type {?} */
    MachineAlarmConfElementsFormComponent.prototype.translateKey;
    /** @type {?} */
    MachineAlarmConfElementsFormComponent.prototype.minCountRequired;
    /** @type {?} */
    MachineAlarmConfElementsFormComponent.prototype.machineAlarmConfElementsChange;
    /** @type {?} */
    MachineAlarmConfElementsFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    MachineAlarmConfElementsFormComponent.prototype.formLayout;
    /** @type {?} */
    MachineAlarmConfElementsFormComponent.prototype.formModel$;
    /** @type {?} */
    MachineAlarmConfElementsFormComponent.prototype.formGroup;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormComponent.prototype.machineAlarmConfElementsData;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormComponent.prototype.machineAlarmConfElementsArrayModelChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormComponent.prototype.getMachineAlarmConfElementsFormArrayModel;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormComponent.prototype.getMachineAlarmConfElementsArrayModelControl;
    /**
     * @type {?}
     * @private
     */
    MachineAlarmConfElementsFormComponent.prototype.machineAlarmConfElementsFormService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_NAME = 'CADASTRAL_REGISTER_NAME';
/**
 * @record
 */
function DynamicCadastralRegisterNameFormControlModelConfig() { }
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlModelConfig.prototype.translateKey;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlModelConfig.prototype.cadastreAsSelectInput;
}
var DynamicCadastralRegisterNameFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicCadastralRegisterNameFormControlModel, _super);
    function DynamicCadastralRegisterNameFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_NAME;
        _this.translateKey = config.translateKey;
        _this.cadastreAsSelectInput = config.cadastreAsSelectInput;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicCadastralRegisterNameFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicCadastralRegisterNameFormControlModel.prototype, "translateKey", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Boolean)
    ], DynamicCadastralRegisterNameFormControlModel.prototype, "cadastreAsSelectInput", void 0);
    return DynamicCadastralRegisterNameFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlModel.prototype.type;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlModel.prototype.translateKey;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlModel.prototype.cadastreAsSelectInput;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicCadastralRegisterNameFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicCadastralRegisterNameFormControlComponent, _super);
    function DynamicCadastralRegisterNameFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicCadastralRegisterNameFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-dynamic-cadastral-register-name-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n\r\n    <app-cadastral-register-name-form-control\r\n        formControlName=\"{{model.id}}\"\r\n        [translateKey]=\"model.translateKey\"\r\n        [cadastreAsSelectInput]=\"model.cadastreAsSelectInput\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\r\n        [touched]=\"control.touched\"\r\n        (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\"\r\n        (focus)=\"onFocus($event)\">\r\n    </app-cadastral-register-name-form-control>\r\n\r\n</ng-container>\r\n"
                }] }
    ];
    /** @nocollapse */
    DynamicCadastralRegisterNameFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicCadastralRegisterNameFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicCadastralRegisterNameFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicCadastralRegisterNameFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicCadastralRegisterNameFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicCadastralRegisterNameFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function cadastralRegisterNameValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return { productDelivery: {} };
        }
        /** @type {?} */
        var cadastralRegister = (/** @type {?} */ (control.value));
        /** @type {?} */
        var isEmptyCadastralRegisterGeoData = (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data == null || isEmpty(data.name);
        });
        if (isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralState)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralCounty)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralCommune)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralArea)
            || isEmpty(cadastralRegister.cadastreNumber)) {
            return { productDelivery: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterNameFormControlComponent = /** @class */ (function () {
    function CadastralRegisterNameFormControlComponent() {
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(CadastralRegisterNameFormControlComponent.prototype, "cadastralRegister", {
        get: /**
         * @return {?}
         */
        function () {
            return this.cadastralRegisterData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.cadastralRegisterData = value;
            this.onChange(value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    CadastralRegisterNameFormControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.cadastralRegisterData = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CadastralRegisterNameFormControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CadastralRegisterNameFormControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CadastralRegisterNameFormControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    CadastralRegisterNameFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cadastral-register-name-form-control',
                    template: "<app-cadastral-register-name-form\r\n    [(cadastralRegister)]=\"cadastralRegister\"\r\n    [translateKey]=\"translateKey\"\r\n    [cadastreAsSelectInput]=\"cadastreAsSelectInput\"\r\n    [touched]=\"touched\"\r\n    [isDisabled]=\"isDisabled\">\r\n</app-cadastral-register-name-form>\r\n",
                    providers: [
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return CadastralRegisterNameFormControlComponent; })), multi: true }
                    ]
                }] }
    ];
    CadastralRegisterNameFormControlComponent.propDecorators = {
        translateKey: [{ type: Input }],
        cadastreAsSelectInput: [{ type: Input }],
        cadastralRegister: [{ type: Input }],
        touched: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return CadastralRegisterNameFormControlComponent;
}());
if (false) {
    /** @type {?} */
    CadastralRegisterNameFormControlComponent.prototype.translateKey;
    /** @type {?} */
    CadastralRegisterNameFormControlComponent.prototype.cadastreAsSelectInput;
    /** @type {?} */
    CadastralRegisterNameFormControlComponent.prototype.touched;
    /** @type {?} */
    CadastralRegisterNameFormControlComponent.prototype.blur;
    /** @type {?} */
    CadastralRegisterNameFormControlComponent.prototype.change;
    /** @type {?} */
    CadastralRegisterNameFormControlComponent.prototype.focus;
    /** @type {?} */
    CadastralRegisterNameFormControlComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormControlComponent.prototype.cadastralRegisterData;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormControlComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterNameProxyService = /** @class */ (function () {
    function CadastralRegisterNameProxyService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.apiUrl = this.config.configuration.api_url + "/v1/cadastre";
    }
    /**
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.getStates = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.apiUrl + "/states";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.getCounties = /**
     * @param {?} stateId
     * @return {?}
     */
    function (stateId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.getCommunes = /**
     * @param {?} stateId
     * @param {?} countyId
     * @return {?}
     */
    function (stateId, countyId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.getAreas = /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @return {?}
     */
    function (stateId, countyId, communeId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas";
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.getArea = /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId;
        return this.httpClient.get(url);
    };
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.getCadastres = /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId + "/katastr";
        return this.httpClient.get(url);
    };
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreId
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.getCadastre = 
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreId
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId, cadastreId) {
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId + "/katastr/" + cadastreId;
        return this.httpClient.get(url);
    };
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreNumber
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.searchCadastre = 
    // tslint:disable-next-line: max-line-length
    /**
     * @param {?} stateId
     * @param {?} countyId
     * @param {?} communeId
     * @param {?} areaId
     * @param {?} cadastreNumber
     * @return {?}
     */
    function (stateId, countyId, communeId, areaId, cadastreNumber) {
        // tslint:disable-next-line: max-line-length
        /** @type {?} */
        var url = this.apiUrl + "/states/" + stateId + "/counties/" + countyId + "/communes/" + communeId + "/areas/" + areaId + "/katastr/search?number=" + cadastreNumber;
        return this.httpClient.get(url).pipe(catchError((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return of(null); })));
    };
    /**
     * @param {?} latitude
     * @param {?} longitude
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.searchCadastres = /**
     * @param {?} latitude
     * @param {?} longitude
     * @return {?}
     */
    function (latitude, longitude) {
        /** @type {?} */
        var url = this.apiUrl + "/area_search?lat=" + latitude + "&lng=" + longitude;
        return this.httpClient.get(url).pipe(catchError((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return of([]); })));
    };
    /**
     * @param {?} teryt
     * @return {?}
     */
    CadastralRegisterNameProxyService.prototype.searchCadastreByTeryt = /**
     * @param {?} teryt
     * @return {?}
     */
    function (teryt) {
        /** @type {?} */
        var url = this.apiUrl + "/search?teryt=" + teryt;
        return this.httpClient.get(url).pipe(catchError((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return of(null); })));
    };
    CadastralRegisterNameProxyService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CadastralRegisterNameProxyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return CadastralRegisterNameProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameProxyService.prototype.apiUrl;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameProxyService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameProxyService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterNameSelect = /** @class */ (function () {
    function CadastralRegisterNameSelect(value, label) {
        this.value = value;
        this.label = label;
    }
    return CadastralRegisterNameSelect;
}());
if (false) {
    /** @type {?} */
    CadastralRegisterNameSelect.prototype.value;
    /** @type {?} */
    CadastralRegisterNameSelect.prototype.label;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterNameFormService = /** @class */ (function () {
    function CadastralRegisterNameFormService(translateFormModelService, translateService, cadastralRegisterProxyService, formService) {
        var _this = this;
        this.translateFormModelService = translateFormModelService;
        this.translateService = translateService;
        this.cadastralRegisterProxyService = cadastralRegisterProxyService;
        this.formService = formService;
        this.statesSubject = new BehaviorSubject(new Array());
        this.formModelSubject = new BehaviorSubject(null);
        this.displaySpinnerSubject = new BehaviorSubject(true);
        this.stateSubscription = this.cadastralRegisterProxyService.getStates()
            .pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.displaySpinnerSubject.next(false); })))
            .subscribe((/**
         * @param {?} states
         * @return {?}
         */
        function (states) { return _this.statesSubject.next(states.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return new CadastralRegisterNameSelect(x.id, x.name); }))); }));
    }
    /**
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.stateSubscription.unsubscribe();
    };
    /**
     * @param {?} formModel
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.createFormGroup = /**
     * @param {?} formModel
     * @return {?}
     */
    function (formModel) {
        return this.formService.createFormGroup(formModel);
    };
    /**
     * @param {?} translateKey
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.getFormModel$ = /**
     * @param {?} translateKey
     * @return {?}
     */
    function (translateKey) {
        var _this = this;
        /** @type {?} */
        var formModelOnChange$ = this.formModelSubject
            .pipe(map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return _this.translateFormModelService.translateFormModel(formModel, translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        /** @type {?} */
        var formModelOnLanguageChange$ = this.translateService.onLangChange
            .pipe(map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.translateFormModelService.translateFormModel(_this.formModelSubject.getValue(), translateKey); })), map((/**
         * @param {?} formModel
         * @return {?}
         */
        function (formModel) { return (/** @type {?} */ (formModel)); })));
        return merge(formModelOnChange$, formModelOnLanguageChange$);
    };
    /**
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.updateFormModelWithStateOptions$ = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var formModel$ = this.formModelSubject
            .pipe(startWith([null]), pairwise(), filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return JSON.stringify(prev) !== JSON.stringify(current);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return current;
        })));
        return combineLatest([formModel$, this.statesSubject])
            .pipe(tap((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), formModel = _b[0], states = _b[1];
            return _this.assignOptions(formModel, 'state', states);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), formModel = _b[0], states = _b[1];
            return formModel;
        })));
    };
    /**
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.updateFormWithCountyOptions$ = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        return this.getValueChanges(form, 'state', true)
            .pipe(startWith([null]), pairwise(), filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return JSON.stringify(prev) !== JSON.stringify(current);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return current;
        })))
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'county', form); })), filter((/**
         * @param {?} state
         * @return {?}
         */
        function (state) { return state; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} state
         * @return {?}
         */
        function (state) { return _this.cadastralRegisterProxyService.getCounties(state.value); })), map((/**
         * @param {?} counties
         * @return {?}
         */
        function (counties) { return counties.map((/**
         * @param {?} county
         * @return {?}
         */
        function (county) { return new CadastralRegisterNameSelect(county.id, county.name); })); })), tap((/**
         * @param {?} counties
         * @return {?}
         */
        function (counties) { return _this.assignOptions(_this.formModelSubject.getValue(), 'county', counties); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.updateFormWithCommuneOptions$ = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        return this.getValueChanges(form, 'county', true)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'commune', form); })), filter((/**
         * @param {?} county
         * @return {?}
         */
        function (county) { return county; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} county
         * @return {?}
         */
        function (county) {
            /** @type {?} */
            var state = form.get('state').value;
            return _this.cadastralRegisterProxyService.getCommunes(state.value, county.value);
        })), map((/**
         * @param {?} communes
         * @return {?}
         */
        function (communes) { return communes.map((/**
         * @param {?} commune
         * @return {?}
         */
        function (commune) { return new CadastralRegisterNameSelect(commune.id, commune.name); })); })), tap((/**
         * @param {?} communes
         * @return {?}
         */
        function (communes) { return _this.assignOptions(_this.formModelSubject.getValue(), 'commune', communes); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.updateFormWithAreaOptions$ = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        return this.getValueChanges(form, 'commune', true)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'area', form); })), filter((/**
         * @param {?} commune
         * @return {?}
         */
        function (commune) { return commune; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} commune
         * @return {?}
         */
        function (commune) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            return _this.cadastralRegisterProxyService.getAreas(state.value, county.value, commune.value);
        })), map((/**
         * @param {?} areas
         * @return {?}
         */
        function (areas) { return areas.map((/**
         * @param {?} area
         * @return {?}
         */
        function (area) { return new CadastralRegisterNameSelect(area.id, area.name); })); })), tap((/**
         * @param {?} areas
         * @return {?}
         */
        function (areas) { return _this.assignOptions(_this.formModelSubject.getValue(), 'area', areas); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.updateFormWithCadastreOptions$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        return this.getValueChanges(form, 'area', cadastreAsSelectInput)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.clearOptions(_this.formModelSubject.getValue(), 'cadastre', form); })), filter((/**
         * @param {?} area
         * @return {?}
         */
        function (area) { return area; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} area
         * @return {?}
         */
        function (area) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            /** @type {?} */
            var commune = form.get('commune').value;
            return _this.cadastralRegisterProxyService.getCadastres(state.value, county.value, commune.value, area.value);
        })), map((/**
         * @param {?} cadastres
         * @return {?}
         */
        function (cadastres) { return cadastres.map((/**
         * @param {?} cadastre
         * @return {?}
         */
        function (cadastre) { return new CadastralRegisterNameSelect(cadastre.id, cadastre.number); })); })), tap((/**
         * @param {?} cadastres
         * @return {?}
         */
        function (cadastres) { return _this.assignOptions(_this.formModelSubject.getValue(), 'cadastre', cadastres); })), map((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return form; })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.getArea$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        return this.getValueChanges(form, 'area', !cadastreAsSelectInput)
            .pipe(tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.patchValue(form, 'cadastre', null); })), filter((/**
         * @param {?} area
         * @return {?}
         */
        function (area) { return area; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} area
         * @return {?}
         */
        function (area) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            /** @type {?} */
            var commune = form.get('commune').value;
            return _this.cadastralRegisterProxyService.getArea(state.value, county.value, commune.value, area.value);
        })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.getCadastreDetails$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        return form.get('cadastre').valueChanges
            .pipe(filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return cadastreAsSelectInput; })), tap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(true); })), switchMap((/**
         * @param {?} cadastre
         * @return {?}
         */
        function (cadastre) {
            /** @type {?} */
            var state = form.get('state').value;
            /** @type {?} */
            var county = form.get('county').value;
            /** @type {?} */
            var commune = form.get('commune').value;
            /** @type {?} */
            var area = form.get('area').value;
            if (cadastre == null
                || state == null || state.value == null
                || county == null || county.value == null
                || commune == null || commune.value == null
                || area == null || area.value == null) {
                return of(null);
            }
            return cadastre.value == null
                ? _this.cadastralRegisterProxyService
                    .searchCadastre(state.value, county.value, commune.value, area.value, cadastre.label)
                : _this.cadastralRegisterProxyService
                    .getCadastre(state.value, county.value, commune.value, area.value, cadastre.value);
        })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @param {?} minCadestralNumberLength
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.getCadastreTextInputValue$ = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @param {?} minCadestralNumberLength
     * @return {?}
     */
    function (form, cadastreAsSelectInput, minCadestralNumberLength) {
        return form.get('cadastre').valueChanges
            .pipe(filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return !cadastreAsSelectInput; })), filter((/**
         * @param {?} value
         * @return {?}
         */
        function (value) { return value === '' || value && value.length >= minCadestralNumberLength; })));
    };
    // tslint:disable-next-line: no-identical-functions
    // tslint:disable-next-line: no-identical-functions
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @param {?} minNameLength
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.getNameTextInputValue$ = 
    // tslint:disable-next-line: no-identical-functions
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @param {?} minNameLength
     * @return {?}
     */
    function (form, cadastreAsSelectInput, minNameLength) {
        return form.get('name').valueChanges.pipe(filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return !cadastreAsSelectInput; })), filter((/**
         * @param {?} value
         * @return {?}
         */
        function (value) { return value && value.length >= minNameLength; })));
    };
    /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.clearFormOptions = /**
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        this.clearOptions(this.formModelSubject.getValue(), 'county', form);
        this.clearOptions(this.formModelSubject.getValue(), 'commune', form);
        this.clearOptions(this.formModelSubject.getValue(), 'area', form);
        if (cadastreAsSelectInput) {
            this.clearOptions(this.formModelSubject.getValue(), 'cadastre', form);
        }
    };
    /**
     * @private
     * @param {?} form
     * @param {?} controlName
     * @param {?} isActiveValueChanges
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.getValueChanges = /**
     * @private
     * @param {?} form
     * @param {?} controlName
     * @param {?} isActiveValueChanges
     * @return {?}
     */
    function (form, controlName, isActiveValueChanges) {
        return form.get(controlName).valueChanges
            .pipe(filter((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return isActiveValueChanges; })), startWith([null]), pairwise(), filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return JSON.stringify(prev) !== JSON.stringify(current);
        })), map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), prev = _b[0], current = _b[1];
            return current;
        })));
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} formGroup
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.clearOptions = /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} formGroup
     * @return {?}
     */
    function (formModel, controlName, formGroup) {
        /** @type {?} */
        var selectModel = (/** @type {?} */ (formModel.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === controlName; }))));
        selectModel.items = [];
        this.patchValue(formGroup, controlName, null);
        this.formModelSubject.next(formModel);
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} data
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.assignOptions = /**
     * @private
     * @param {?} formModel
     * @param {?} controlName
     * @param {?} data
     * @return {?}
     */
    function (formModel, controlName, data) {
        /** @type {?} */
        var selectModel = (/** @type {?} */ (formModel.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === controlName; }))));
        selectModel.items = data;
        this.formModelSubject.next(formModel);
    };
    /**
     * @private
     * @param {?} formGroup
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.patchValue = /**
     * @private
     * @param {?} formGroup
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    function (formGroup, controlName, value) {
        if (this.isEquals(value, formGroup.get(controlName).value) === false) {
            formGroup.get(controlName).patchValue(value);
        }
    };
    /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    CadastralRegisterNameFormService.prototype.isEquals = /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    function (valueA, valueB) {
        if (valueA == null && valueB == null) {
            return true;
        }
        if (valueA == null || valueB == null) {
            return false;
        }
        return JSON.stringify(valueA) === JSON.stringify(valueB);
    };
    CadastralRegisterNameFormService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CadastralRegisterNameFormService.ctorParameters = function () { return [
        { type: TranslateFormModelService },
        { type: TranslateService },
        { type: CadastralRegisterNameProxyService },
        { type: DynamicFormService }
    ]; };
    return CadastralRegisterNameFormService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormService.prototype.stateSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormService.prototype.statesSubject;
    /** @type {?} */
    CadastralRegisterNameFormService.prototype.formModelSubject;
    /** @type {?} */
    CadastralRegisterNameFormService.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormService.prototype.translateFormModelService;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormService.prototype.cadastralRegisterProxyService;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormService.prototype.formService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT_INPUT$c = {
    grid: {
        host: 'col-12 col-xl-6 order-md-1',
        container: 'form-group row',
        label: 'col-12',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT$1 = {
    name: FORM_LAYOUT_INPUT$c,
    state: FORM_LAYOUT_INPUT$c,
    county: FORM_LAYOUT_INPUT$c,
    commune: FORM_LAYOUT_INPUT$c,
    area: FORM_LAYOUT_INPUT$c,
    cadastre: FORM_LAYOUT_INPUT$c
};
/** @type {?} */
var CADASTRE_TEXT_INPUT_FORM_MODEL$1 = [
    new DynamicInputModel({
        id: 'name',
        minLength: 3,
        maxLength: 60,
        validators: {
            required: null,
            minLength: 3,
            maxLength: 60
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'state',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'county',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'commune',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicMultiSelectControlModel({
        id: 'area',
        bindLabel: nameof('label'),
        multiple: false,
        searchByField: nameof('label'),
        required: true,
        validators: {
            required: null
        }
    }),
    new DynamicInputModel({
        id: 'cadastre',
        minLength: 1,
        maxLength: 60,
        updateOn: 'blur',
        validators: {
            minLength: 1,
            maxLength: 60
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CadastralRegisterNameFormComponent = /** @class */ (function () {
    function CadastralRegisterNameFormComponent(cadastralRegisterFormService) {
        this.cadastralRegisterFormService = cadastralRegisterFormService;
        this.minCadestralNumberLength = 0;
        this.minNameLength = 3;
        this.formLayout = FORM_LAYOUT$1;
        this.cadastralRegisterChange = new EventEmitter();
        this.displaySpinnerSubject = this.cadastralRegisterFormService.displaySpinnerSubject;
    }
    Object.defineProperty(CadastralRegisterNameFormComponent.prototype, "displaySpinner$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.displaySpinnerSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterNameFormComponent.prototype, "formGroup", {
        get: /**
         * @return {?}
         */
        function () {
            return this.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterNameFormComponent.prototype, "cadastralRegister", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this.formGroup != null && this.isEquals(value, this.cadastralRegisterData) === false) {
                this.updateFormValue(value);
            }
            this.cadastralRegisterData = value;
            this.clearFormOptionsIfNotStateSelected();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterNameFormComponent.prototype, "cadastreAsSelectInput", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.cadastreAsSelectInputData = value;
            /** @type {?} */
            var formModel = CADASTRE_TEXT_INPUT_FORM_MODEL$1;
            this.form = this.cadastralRegisterFormService.createFormGroup(formModel);
            this.cadastralRegisterFormService.formModelSubject.next(formModel);
            this.subscribeToStateChanges(this.form);
            this.subscribeToCountyChanges(this.form);
            this.subscribeToCommuneChanges(this.form);
            this.subscribeToAreaChangesForSelectInput(this.form, value);
            this.subscribeToAreaChangesForTextInput(this.form, value);
            this.subscribeToCadastreSelectInputChanges(this.form, value);
            this.subscribeToCadastreTextInputChanges(this.form, value);
            this.subscribeToNameTextInputChanges(this.form, value);
            if (this.cadastralRegisterData != null) {
                this.updateFormValue(this.cadastralRegisterData);
            }
            this.clearFormOptionsIfNotStateSelected();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CadastralRegisterNameFormComponent.prototype, "touched", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this.formGroup.markAllAsTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(CadastralRegisterNameFormComponent.prototype, "isDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value != null && value !== this.formGroup.disabled) {
                if (value) {
                    this.formGroup.disable();
                }
                else {
                    this.formGroup.enable();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formModel$ = this.cadastralRegisterFormService.getFormModel$(this.translateKey);
        this.addStatesToFormModel();
    };
    /**
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.addStatesToFormModelSubscription.unsubscribe();
        if (this.stateChangesSubscription) {
            this.stateChangesSubscription.unsubscribe();
        }
        if (this.countyChangesSubscription) {
            this.countyChangesSubscription.unsubscribe();
        }
        if (this.communeChangesSubscription) {
            this.communeChangesSubscription.unsubscribe();
        }
        if (this.areaChangesForSelectInputSubscription) {
            this.areaChangesForSelectInputSubscription.unsubscribe();
        }
        if (this.areaChangesForTextInputSubscription) {
            this.areaChangesForTextInputSubscription.unsubscribe();
        }
        if (this.cadastreSelectInputChangesSubscription) {
            this.cadastreSelectInputChangesSubscription.unsubscribe();
        }
        if (this.cadastreTextInputChangesSubscription) {
            this.cadastreTextInputChangesSubscription.unsubscribe();
        }
    };
    /**
     * @private
     * @param {?} cadastralRegister
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.updateFormValue = /**
     * @private
     * @param {?} cadastralRegister
     * @return {?}
     */
    function (cadastralRegister) {
        /** @type {?} */
        var createCadastralRegisterSelect = (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data != null && data.id != null ? new CadastralRegisterNameSelect(data.id, data.name) : null;
        });
        /** @type {?} */
        var state = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralState) : null;
        /** @type {?} */
        var county = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralCounty) : null;
        /** @type {?} */
        var commune = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralCommune) : null;
        /** @type {?} */
        var area = cadastralRegister != null ? createCadastralRegisterSelect(cadastralRegister.cadastralArea) : null;
        this.patchValue('state', state);
        this.patchValue('county', county);
        this.patchValue('commune', commune);
        this.patchValue('area', area);
        /** @type {?} */
        var cadastre = this.cadastreAsSelectInputData
            ? (cadastralRegister != null && cadastralRegister.cadastreNumber != null
                ? new CadastralRegisterNameSelect(null, cadastralRegister.cadastreNumber)
                : null)
            : (cadastralRegister != null ? cadastralRegister.cadastreNumber : null);
        /** @type {?} */
        var name = cadastralRegister != null ? cadastralRegister.cadastreGroundName : null;
        this.patchValue('cadastre', cadastre);
        this.patchValue('name', name);
    };
    /**
     * @private
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.clearFormOptionsIfNotStateSelected = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.form != null && this.form.get('state').value == null) {
            this.cadastralRegisterFormService.clearFormOptions(this.form, this.cadastreAsSelectInputData);
        }
    };
    /**
     * @private
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.addStatesToFormModel = /**
     * @private
     * @return {?}
     */
    function () {
        this.addStatesToFormModelSubscription = this.cadastralRegisterFormService.updateFormModelWithStateOptions$()
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { }));
    };
    /**
     * @private
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToStateChanges = /**
     * @private
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        this.stateChangesSubscription = this.cadastralRegisterFormService.updateFormWithCountyOptions$(form)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToCountyChanges = /**
     * @private
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        this.countyChangesSubscription = this.cadastralRegisterFormService.updateFormWithCommuneOptions$(form)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToCommuneChanges = /**
     * @private
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        this.communeChangesSubscription = this.cadastralRegisterFormService.updateFormWithAreaOptions$(form)
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToAreaChangesForSelectInput = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.areaChangesForSelectInputSubscription =
            this.cadastralRegisterFormService.updateFormWithCadastreOptions$(form, cadastreAsSelectInput)
                .subscribe((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }), (/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToAreaChangesForTextInput = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.areaChangesForTextInputSubscription = this.cadastralRegisterFormService.getArea$(form, cadastreAsSelectInput)
            .subscribe((/**
         * @param {?} areaGeoDataValue
         * @return {?}
         */
        function (areaGeoDataValue) {
            /** @type {?} */
            var name = _this.getStringFormControlValue('name');
            /** @type {?} */
            var stateGeoData = _this.getGeoDataFromFormControl('state');
            /** @type {?} */
            var countyGeoData = _this.getGeoDataFromFormControl('county');
            /** @type {?} */
            var communeGeoData = _this.getGeoDataFromFormControl('commune');
            /** @type {?} */
            var areaGeoData = areaGeoDataValue;
            /** @type {?} */
            var finalNameValue = name === '' ? null : name;
            _this.cadastralRegisterData = new CadastralRegisterName(finalNameValue, stateGeoData, countyGeoData, communeGeoData, areaGeoData);
            _this.cadastralRegisterChange.emit(_this.cadastralRegisterData);
            _this.cadastralRegisterFormService.displaySpinnerSubject.next(false);
        }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToCadastreSelectInputChanges = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.cadastreSelectInputChangesSubscription = this.cadastralRegisterFormService
            .getCadastreDetails$(form, cadastreAsSelectInput)
            .subscribe((/**
         * @param {?} cadastre
         * @return {?}
         */
        function (cadastre) {
            /** @type {?} */
            var stateGeoData = _this.getGeoDataFromFormControl('state');
            /** @type {?} */
            var countyGeoData = _this.getGeoDataFromFormControl('county');
            /** @type {?} */
            var communeGeoData = _this.getGeoDataFromFormControl('commune');
            /** @type {?} */
            var areaGeoData = _this.getGeoDataFromFormControl('area');
            /** @type {?} */
            var cadastreNumber = cadastre != null ? cadastre.number : null;
            /** @type {?} */
            var cadastreSize = cadastre != null ? cadastre.size : null;
            /** @type {?} */
            var cadastreCoordinates = cadastre != null && cadastre.geojson != null ? cadastre.geojson.coordinates : null;
            /** @type {?} */
            var value = new CadastralRegisterName(null, stateGeoData, countyGeoData, communeGeoData, areaGeoData, cadastreNumber, cadastreSize, cadastreCoordinates);
            if (cadastre != null) {
                _this.cadastralRegisterData = value;
            }
            _this.cadastralRegisterChange.emit(value);
            _this.cadastralRegisterFormService.displaySpinnerSubject.next(false);
        }), (/**
         * @return {?}
         */
        function () { return _this.cadastralRegisterFormService.displaySpinnerSubject.next(false); }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToCadastreTextInputChanges = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        this.cadastreTextInputChangesSubscription = this.cadastralRegisterFormService
            .getCadastreTextInputValue$(form, cadastreAsSelectInput, this.minCadestralNumberLength)
            .subscribe((/**
         * @param {?} cadastreNumber
         * @return {?}
         */
        function (cadastreNumber) {
            /** @type {?} */
            var name = _this.getStringFormControlValue('name');
            /** @type {?} */
            var stateGeoData = _this.getGeoDataFromFormControl('state');
            /** @type {?} */
            var countyGeoData = _this.getGeoDataFromFormControl('county');
            /** @type {?} */
            var communeGeoData = _this.getGeoDataFromFormControl('commune');
            /** @type {?} */
            var areaGeoData = _this.getGeoDataFromFormControl('area');
            /** @type {?} */
            var finalNameValue = name === '' ? null : name;
            _this.cadastralRegisterData = new CadastralRegisterName(finalNameValue, stateGeoData, countyGeoData, communeGeoData, areaGeoData, cadastreNumber);
            _this.cadastralRegisterChange.emit(_this.cadastralRegisterData);
        }));
    };
    /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.subscribeToNameTextInputChanges = /**
     * @private
     * @param {?} form
     * @param {?} cadastreAsSelectInput
     * @return {?}
     */
    function (form, cadastreAsSelectInput) {
        var _this = this;
        /** @type {?} */
        var debounceTimeValue = 1000;
        this.nameChangesSubscription = this.cadastralRegisterFormService
            .getNameTextInputValue$(form, cadastreAsSelectInput, this.minNameLength).pipe(debounceTime(debounceTimeValue)).subscribe((/**
         * @param {?} name
         * @return {?}
         */
        function (name) {
            /** @type {?} */
            var stateGeoData = _this.getGeoDataFromFormControl('state');
            /** @type {?} */
            var countyGeoData = _this.getGeoDataFromFormControl('county');
            /** @type {?} */
            var communeGeoData = _this.getGeoDataFromFormControl('commune');
            /** @type {?} */
            var areaGeoData = _this.getGeoDataFromFormControl('area');
            /** @type {?} */
            var cadastreNumber = _this.getStringFormControlValue('cadastre');
            _this.cadastralRegisterData = new CadastralRegisterName(name, stateGeoData, countyGeoData, communeGeoData, areaGeoData, cadastreNumber);
            _this.cadastralRegisterChange.emit(_this.cadastralRegisterData);
        }));
    };
    /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.getGeoDataFromFormControl = /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        /** @type {?} */
        var cadastralRegisterSelect = this.getFormControlValue(controlName);
        return cadastralRegisterSelect != null && cadastralRegisterSelect.value != null
            ? new CadastralRegisterGeoData(cadastralRegisterSelect.value, cadastralRegisterSelect.label)
            : null;
    };
    /**
     * @param {?} controlName
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.getStringFormControlValue = /**
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        return this.form.get(controlName).value;
    };
    /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.getFormControlValue = /**
     * @private
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        return this.form.get(controlName).value;
    };
    /**
     * @private
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.patchValue = /**
     * @private
     * @param {?} controlName
     * @param {?} value
     * @return {?}
     */
    function (controlName, value) {
        if (this.isEquals(value, this.getFormControlValue(controlName)) === false) {
            this.form.get(controlName).patchValue(value);
        }
    };
    /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    CadastralRegisterNameFormComponent.prototype.isEquals = /**
     * @private
     * @param {?} valueA
     * @param {?} valueB
     * @return {?}
     */
    function (valueA, valueB) {
        if (valueA == null && valueB == null) {
            return true;
        }
        if (valueA == null || valueB == null) {
            return false;
        }
        return JSON.stringify(valueA) === JSON.stringify(valueB);
    };
    CadastralRegisterNameFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cadastral-register-name-form',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <form class=\"form-horizontal ng-dynamic-form\" [formGroup]=\"formGroup\"\r\n        *ngIf=\"formGroup && formModel$ | async as formModel\">\r\n        <fieldset>\r\n            <dynamic-ng-bootstrap-form class=\"row\" [group]=\"formGroup\" [layout]=\"formLayout\" [model]=\"formModel\">\r\n                <ng-template modelType=\"GROUP\" align=\"START\" let-legend=\"legend\">\r\n                    <hr class=\"mt-0\" [ngClass]=\"{ 'mt-0': true, 'mb-0': legend }\" />\r\n                    <p *ngIf=\"legend\" class=\"form-group-legend m-0 mb-1\">{{legend}}</p>\r\n                </ng-template>\r\n            </dynamic-ng-bootstrap-form>\r\n        </fieldset>\r\n    </form>\r\n</div>\r\n",
                    providers: [
                        TranslateFormModelService,
                        CadastralRegisterNameProxyService,
                        CadastralRegisterNameFormService
                    ]
                }] }
    ];
    /** @nocollapse */
    CadastralRegisterNameFormComponent.ctorParameters = function () { return [
        { type: CadastralRegisterNameFormService }
    ]; };
    CadastralRegisterNameFormComponent.propDecorators = {
        cadastralRegister: [{ type: Input }],
        translateKey: [{ type: Input }],
        cadastreAsSelectInput: [{ type: Input }],
        touched: [{ type: Input }],
        isDisabled: [{ type: Input }],
        cadastralRegisterChange: [{ type: Output }]
    };
    return CadastralRegisterNameFormComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.addStatesToFormModelSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.stateChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.countyChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.communeChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.nameChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.areaChangesForSelectInputSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.areaChangesForTextInputSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.cadastreSelectInputChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.cadastreTextInputChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.cadastralRegisterData;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.minCadestralNumberLength;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.minNameLength;
    /** @type {?} */
    CadastralRegisterNameFormComponent.prototype.formModel$;
    /** @type {?} */
    CadastralRegisterNameFormComponent.prototype.formLayout;
    /** @type {?} */
    CadastralRegisterNameFormComponent.prototype.translateKey;
    /** @type {?} */
    CadastralRegisterNameFormComponent.prototype.cadastralRegisterChange;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.cadastreAsSelectInputData;
    /**
     * @type {?}
     * @private
     */
    CadastralRegisterNameFormComponent.prototype.cadastralRegisterFormService;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function cadastralGroundRegisterValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return { ground: {} };
        }
        /** @type {?} */
        var cadastralRegister = (/** @type {?} */ (control.value));
        /** @type {?} */
        var isEmptyCadastralRegisterGeoData = (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data == null || isEmpty(data.name);
        });
        if (isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralState)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralCounty)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralCommune)
            || isEmptyCadastralRegisterGeoData(cadastralRegister.cadastralArea)) {
            return { ground: {} };
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_SELECT = 'CULTIVATION_AREA_SELECT';
/**
 * @record
 */
function DynamicMapCultivationAreaFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicMapCultivationAreaFormControlModelConfig.prototype.organizationLocations;
    /** @type {?|undefined} */
    DynamicMapCultivationAreaFormControlModelConfig.prototype.organizationGrounds;
}
var DynamicMapCultivationAreaFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicMapCultivationAreaFormControlModel, _super);
    function DynamicMapCultivationAreaFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_SELECT;
        _this.organizationLocations = config.organizationLocations || [];
        _this.organizationGrounds = config.organizationGrounds || [];
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMapCultivationAreaFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicMapCultivationAreaFormControlModel.prototype, "organizationLocations", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicMapCultivationAreaFormControlModel.prototype, "organizationGrounds", void 0);
    return DynamicMapCultivationAreaFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMapCultivationAreaFormControlModel.prototype.type;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlModel.prototype.organizationLocations;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlModel.prototype.organizationGrounds;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMapCultivationAreaFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMapCultivationAreaFormControlComponent, _super);
    function DynamicMapCultivationAreaFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMapCultivationAreaFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-map-cultivation-area-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n    <lib-map-cultivation-area-control formControlName=\"{{model.id}}\"\r\n        [organizationLocations]=\"model.organizationLocations\" [organizationGrounds]=\"model.organizationGrounds\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\" (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\" (focus)=\"onFocus($event)\">\r\n    </lib-map-cultivation-area-control>\r\n</ng-container>"
                }] }
    ];
    /** @nocollapse */
    DynamicMapCultivationAreaFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMapCultivationAreaFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMapCultivationAreaFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMapCultivationAreaFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMapCultivationAreaFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapCultivationAreaFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapCultivationAreaFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolygonShapesOptions$1 = /** @class */ (function () {
    function PolygonShapesOptions() {
    }
    PolygonShapesOptions.SELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ff0000',
        fillColor: '#ff0000'
    };
    PolygonShapesOptions.CADASTRAL_POLYGON_OPTIONS = {
        strokeColor: '#ffff00',
        fillColor: '#ffff00'
    };
    PolygonShapesOptions.DRAWED_POLYGON_OPTIONS = {
        strokeColor: '#99ff33',
        fillColor: '#ccffcc'
    };
    return PolygonShapesOptions;
}());
if (false) {
    /** @type {?} */
    PolygonShapesOptions$1.SELECTED_POLYGON_OPTIONS;
    /** @type {?} */
    PolygonShapesOptions$1.CADASTRAL_POLYGON_OPTIONS;
    /** @type {?} */
    PolygonShapesOptions$1.DRAWED_POLYGON_OPTIONS;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapCultivationAreaControlService = /** @class */ (function () {
    function MapCultivationAreaControlService(pureMapService, numberUtilService) {
        this.pureMapService = pureMapService;
        this.numberUtilService = numberUtilService;
        this.oneHectareInSquareMeters = 10000;
        this.drawnPolygonSubject = new BehaviorSubject(null);
        this.cadastralPolygonsSubject = new BehaviorSubject([]);
        this.selectedGroundsFeatureSubject = new BehaviorSubject([]);
        this.polygons = [];
        this.mapCenterZoomValue = 14;
        this.markerPosition = new BehaviorSubject(null);
        this.drawnPolygon$ = this.drawnPolygonSubject.asObservable();
        this.cadastralPolygons$ = this.cadastralPolygonsSubject.asObservable();
        this.selectedGroundsFeatures$ = this.selectedGroundsFeatureSubject.asObservable();
        this.isDrawingEnabled = new BehaviorSubject(false);
        this.isCenteredToMarker = false;
        this.setPolygonSelected = (/**
         * @param {?} polygon
         * @param {?} isSelected
         * @return {?}
         */
        function (polygon, isSelected) {
            polygon.set('selected', isSelected);
            polygon.set('label', polygon.get('name'));
        });
    }
    Object.defineProperty(MapCultivationAreaControlService.prototype, "mapReady$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.pureMapService.mapReady.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCultivationAreaControlService.prototype, "cadastralPolygons", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygons;
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} organizationLocations
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.markPosition = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} organizationLocations
     * @return {?}
     */
    function (organizationLocations) {
        var _this = this;
        /** @type {?} */
        var organizationCenterPoint = organizationLocations.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Point'; }));
        // tslint:disable-next-line: no-magic-numbers
        /** @type {?} */
        var point = new google.maps.LatLng(50.22005290158697, 20.182460816577382);
        if (organizationCenterPoint) {
            // tslint:disable-next-line: max-line-length
            point = new google.maps.LatLng(organizationCenterPoint.geometry.coordinates[1], organizationCenterPoint.geometry.coordinates[0]);
        }
        /** @type {?} */
        var marker = this.pureMapService.createSingleMarker({
            position: point,
            draggable: true
        });
        this.markerPosition.next(this.mapMarkerPositionToGeolocationPosition(point.lat(), point.lng()));
        marker.addListener('dragend', (/**
         * @param {?} dragEndMarkerEvent
         * @return {?}
         */
        function (dragEndMarkerEvent) {
            _this.markerPosition.next(_this.mapMarkerPositionToGeolocationPosition(dragEndMarkerEvent.latLng.lat(), dragEndMarkerEvent.latLng.lng()));
        }));
        if (!this.isCenteredToMarker) {
            this.pureMapService.centerMap(point);
            this.pureMapService.setZoom(this.mapCenterZoomValue);
        }
        this.isCenteredToMarker = true;
    };
    /**
     * @param {?} features
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.draw = /**
     * @param {?} features
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @return {?}
     */
    function (features, isFromCadastralRegister, isFromOrganizationGrounds) {
        var _this = this;
        if (isFromCadastralRegister === void 0) { isFromCadastralRegister = false; }
        if (isFromOrganizationGrounds === void 0) { isFromOrganizationGrounds = false; }
        features
            .filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Polygon'; }))
            .forEach((/**
         * @param {?} feature
         * @return {?}
         */
        function (feature) { return _this.createPolygon((/** @type {?} */ (feature)), isFromCadastralRegister, isFromOrganizationGrounds); }));
        this.cadastralPolygonsSubject.next(this.polygons);
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.turnOnDrawing = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.isDrawingEnabled.value) {
            /** @type {?} */
            var drawingManager = this.pureMapService.createDrawingManager({
                drawingControl: true,
                drawingControlOptions: {
                    drawingModes: [google.maps.drawing.OverlayType.POLYGON],
                    position: google.maps.ControlPosition.TOP_CENTER
                },
                polygonOptions: PolygonShapesOptions$1.DRAWED_POLYGON_OPTIONS
            });
            drawingManager.addListener('overlaycomplete', (/**
             * @param {?} polygon
             * @return {?}
             */
            function (polygon$1) {
                if (polygon$1.type === google.maps.drawing.OverlayType.POLYGON) {
                    if (_this.drawnPolygonSubject.value) {
                        _this.pureMapService.removePolygon(_this.drawnPolygonSubject.value.googlePolygon);
                        _this.drawnPolygonSubject.next(null);
                    }
                    /** @type {?} */
                    var poly_1 = ((/** @type {?} */ (polygon$1.overlay)));
                    poly_1.setMap(null);
                    /** @type {?} */
                    var shapeOptions = PolygonShapesOptions$1.DRAWED_POLYGON_OPTIONS;
                    /** @type {?} */
                    var polygonCenterPoint = _this.getPolygonCenterPoint(poly_1);
                    /** @type {?} */
                    var areaInHa = google.maps.geometry.spherical.computeArea(poly_1.getPath()) / _this.oneHectareInSquareMeters;
                    /** @type {?} */
                    var properties = __assign({ cadastralRegister: null, area: _this.numberUtilService.round2(areaInHa), centerPoint: [polygonCenterPoint.lat(), polygonCenterPoint.lng()], editable: true }, shapeOptions);
                    /** @type {?} */
                    var addPolygon = _this.pureMapService.createPolygon(__assign({ paths: poly_1.getPath() }, properties));
                    /** @type {?} */
                    var polygonCoordinates = _this.getPolygonCoordinates(addPolygon);
                    polygonCoordinates[0].push(polygonCoordinates[0][0]); // add first point at the end to close polygon
                    // add first point at the end to close polygon
                    /** @type {?} */
                    var turfDrawnPolygon = polygon(polygonCoordinates);
                    google.maps.event.addListener(poly_1.getPath(), 'remove_at', (/**
                     * @return {?}
                     */
                    function () { return _this.getPolygonNewPaths(poly_1.getPath()); }));
                    google.maps.event.addListener(poly_1.getPath(), 'set_at', (/**
                     * @return {?}
                     */
                    function () { return _this.getPolygonNewPaths(poly_1.getPath()); }));
                    google.maps.event.addListener(poly_1.getPath(), 'insert_at', (/**
                     * @return {?}
                     */
                    function () { return _this.getPolygonNewPaths(poly_1.getPath()); }));
                    _this.drawnPolygonSubject.next({ googlePolygon: addPolygon, turfPolygon: turfDrawnPolygon });
                }
            }));
            this.isDrawingEnabled.next(true);
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} polygonPaths
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.getPolygonNewPaths = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} polygonPaths
     * @return {?}
     */
    function (polygonPaths) {
        if (this.drawnPolygonSubject.value) {
            /** @type {?} */
            var editedPolygon = this.drawnPolygonSubject.value;
            /** @type {?} */
            var areaInHa = google.maps.geometry.spherical.computeArea(polygonPaths) / this.oneHectareInSquareMeters;
            editedPolygon.googlePolygon.setPath(polygonPaths);
            editedPolygon.googlePolygon.set('area', this.numberUtilService.round2(areaInHa));
            /** @type {?} */
            var newTurfCoordinates = this.getPolygonCoordinates(editedPolygon.googlePolygon);
            newTurfCoordinates[0].push(newTurfCoordinates[0][0]); // add
            editedPolygon.turfPolygon = polygon(newTurfCoordinates);
            this.drawnPolygonSubject.next(editedPolygon);
        }
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.turnOffDrawing = /**
     * @return {?}
     */
    function () {
        if (this.isDrawingEnabled.value) {
            /** @type {?} */
            var drawingManager = this.pureMapService.createDrawingManager({
                drawingControl: false,
                drawingControlOptions: {
                    drawingModes: null
                }
            });
            drawingManager.unbindAll();
            this.isDrawingEnabled.next(false);
        }
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.centerToMarkerPosition = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var point = new google.maps.LatLng(this.markerPosition.value.coords.latitude, this.markerPosition.value.coords.longitude);
        this.pureMapService.centerMap(point);
        this.pureMapService.setZoom(this.mapCenterZoomValue);
    };
    /**
     * @param {?} features
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.fitBoundsMapToNewCadastreFeatures = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        var _this = this;
        if (features.length > 0) {
            /** @type {?} */
            var bounds_1 = new google.maps.LatLngBounds();
            features.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                _this.getPolygonPaths((/** @type {?} */ (x))).forEach((/**
                 * @param {?} path
                 * @return {?}
                 */
                function (path) {
                    bounds_1.extend(path);
                }));
            }));
            this.pureMapService.fitBounds(bounds_1);
        }
    };
    /**
     * @private
     * @param {?} feature
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.createPolygon = /**
     * @private
     * @param {?} feature
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @return {?}
     */
    function (feature, isFromCadastralRegister, isFromOrganizationGrounds) {
        if (isFromCadastralRegister === void 0) { isFromCadastralRegister = false; }
        if (isFromOrganizationGrounds === void 0) { isFromOrganizationGrounds = false; }
        /** @type {?} */
        var unselectedOptions = isFromCadastralRegister || isFromOrganizationGrounds
            ? PolygonShapesOptions$1.CADASTRAL_POLYGON_OPTIONS
            : PolygonShapesOptions$1.DRAWED_POLYGON_OPTIONS;
        feature.properties.selected = false;
        /** @type {?} */
        var polygon$1 = this.pureMapService.createPolygon(__assign({ paths: this.getPolygonPaths(feature) }, feature.properties, unselectedOptions));
        if (isFromOrganizationGrounds) {
            this.setPolygonListeners(polygon$1);
        }
        /** @type {?} */
        var turfPolygon = polygon(feature.geometry.coordinates);
        this.polygons.push({ googlePolygon: polygon$1, turfPolygon: turfPolygon });
        if (isFromCadastralRegister) {
            /** @type {?} */
            var bounds_2 = new google.maps.LatLngBounds();
            this.getPolygonPaths(feature).forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return bounds_2.extend(x); }));
            this.pureMapService.fitBounds(bounds_2);
        }
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.getPolygonFeature = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        return [{
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: this.getPolygonCoordinates(polygon)
                },
                id: v4(),
                properties: {
                    name: polygon.get('name'),
                    area: polygon.get('area'),
                    centerPoint: polygon.get('centerPoint'),
                    cadastralRegister: polygon.get('cadastralRegister')
                }
            }];
    };
    /**
     * @param {?} markerLatitude
     * @param {?} markerLongitude
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.mapMarkerPositionToGeolocationPosition = /**
     * @param {?} markerLatitude
     * @param {?} markerLongitude
     * @return {?}
     */
    function (markerLatitude, markerLongitude) {
        return {
            coords: {
                latitude: markerLatitude,
                longitude: markerLongitude,
                speed: null,
                heading: null,
                altitudeAccuracy: null,
                accuracy: null,
                altitude: null
            },
            timestamp: null
        };
    };
    /**
     * @param {?} intersectedCadastralPolygon
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.getCadastralRegisterFromFeature = /**
     * @param {?} intersectedCadastralPolygon
     * @return {?}
     */
    function (intersectedCadastralPolygon) {
        /** @type {?} */
        var polygonFeature = this.getPolygonFeature(intersectedCadastralPolygon.googlePolygon);
        // tslint:disable-next-line: no-string-literal
        return (/** @type {?} */ (JSON.parse(polygonFeature[0].properties['cadastralRegister'])));
    };
    /**
     * @param {?} drawnPolygon
     * @param {?} grounds
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.mapDrawnPolygonToFeature = /**
     * @param {?} drawnPolygon
     * @param {?} grounds
     * @return {?}
     */
    function (drawnPolygon, grounds) {
        /** @type {?} */
        var parcelName = null;
        /** @type {?} */
        var drawnPolygonFeature = this.getPolygonFeature(drawnPolygon.googlePolygon);
        if (grounds && grounds.length > 0) {
            parcelName = grounds.length > 1 ?
                // tslint:disable-next-line: no-string-literal
                grounds[0].groundCadastralRegister.cadastralArea.name : grounds[0].groundFeature[0].properties['name'];
        }
        return (/** @type {?} */ ([{
                id: v4(),
                geometry: drawnPolygon.turfPolygon.geometry,
                properties: {
                    fillColor: '#ffff00',
                    strokeColor: '#ffff00',
                    zIndex: 1,
                    // tslint:disable-next-line: no-string-literal
                    area: drawnPolygonFeature[0].properties['area'],
                    name: parcelName
                },
                type: 'Feature'
            }]));
    };
    /**
     * @param {?} grounds
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.mapSelectedGroundsFeaturesToParcelFeature = /**
     * @param {?} grounds
     * @return {?}
     */
    function (grounds) {
        /** @type {?} */
        var parcelName = grounds.length > 1 ?
            // tslint:disable-next-line: no-string-literal
            grounds[0].properties.cadastralArea : grounds[0].properties.name;
        return grounds.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return (/** @type {?} */ ({
                // tslint:disable-next-line: no-string-literal
                id: x.properties['groundId'],
                geometry: x.geometry,
                properties: {
                    fillColor: '#ffff00',
                    strokeColor: '#ffff00',
                    zIndex: 1,
                    // tslint:disable-next-line: no-string-literal
                    area: x.properties['area'],
                    name: parcelName
                },
                type: 'Feature'
            }));
        }));
    };
    /**
     * @param {?} intersectedCadastralPolygon
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.mapCadastrePolygonToGroundFeature = /**
     * @param {?} intersectedCadastralPolygon
     * @return {?}
     */
    function (intersectedCadastralPolygon) {
        /** @type {?} */
        var polygonFeature = this.getPolygonFeature(intersectedCadastralPolygon.googlePolygon);
        return (/** @type {?} */ ([{
                id: v4(),
                geometry: intersectedCadastralPolygon.turfPolygon.geometry,
                properties: {
                    fillColor: '#ffff00',
                    strokeColor: '#ffff00',
                    zIndex: 1,
                    // tslint:disable-next-line: no-string-literal
                    area: polygonFeature[0].properties['area'],
                    // tslint:disable-next-line: no-string-literal
                    name: polygonFeature[0].properties['name']
                },
                type: 'Feature'
            }]));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.setPolygonListeners = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        var _this = this;
        polygon.addListener('selected_changed', (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var isPolygonSelected = (/** @type {?} */ (polygon.get('selected')));
            /** @type {?} */
            var polygonOptions = isPolygonSelected
                ? PolygonShapesOptions$1.SELECTED_POLYGON_OPTIONS
                : PolygonShapesOptions$1.CADASTRAL_POLYGON_OPTIONS;
            polygon.setOptions(polygonOptions);
        }));
        polygon.addListener('click', (/**
         * @return {?}
         */
        function () {
            _this.setPolygonSelectedAndUpdateSelectedFeatures(polygon);
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.setPolygonSelectedAndUpdateSelectedFeatures = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var isSelected = polygon.get('selected');
        this.setPolygonSelected(polygon, !isSelected);
        this.updateSelectedFeatures();
    };
    /**
     * @private
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.updateSelectedFeatures = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selectedFeatures = this.getSelectedFeatures();
        this.selectedGroundsFeatureSubject.next(selectedFeatures);
    };
    /**
     * @private
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.getSelectedFeatures = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var selectedPolygons = this.polygons.filter((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) { return !!polygon.googlePolygon.get('selected'); }));
        return selectedPolygons.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: _this.getPolygonCoordinates(x.googlePolygon)
                },
                id: undefined,
                properties: {
                    name: x.googlePolygon.get('name'),
                    area: x.googlePolygon.get('area'),
                    cadastralArea: x.googlePolygon.get('cadastralArea'),
                    cadastreNumber: x.googlePolygon.get('cadastreNumber'),
                    groundId: x.googlePolygon.get('groundId')
                }
            };
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.getPolygonCoordinates = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        return polygon.getPaths().getArray()
            .map((/**
         * @param {?} path
         * @return {?}
         */
        function (path) {
            return path.getArray().map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                return [x.lng(), x.lat()];
            }));
        }));
    };
    /**
     * @private
     * @param {?} feature
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.getPolygonPaths = /**
     * @private
     * @param {?} feature
     * @return {?}
     */
    function (feature) {
        /** @type {?} */
        var coordinates = feature.geometry.coordinates;
        return coordinates[0].map((/**
         * @param {?} coordinate
         * @return {?}
         */
        function (coordinate) {
            return new google.maps.LatLng(coordinate[1], coordinate[0]);
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.getPolygonCenterPoint = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var bounds = new google.maps.LatLngBounds();
        /** @type {?} */
        var polygonCoordinates = this.getPolygonCoordinates(polygon)[0];
        polygonCoordinates.push(polygonCoordinates[0]);
        polygonCoordinates.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            bounds.extend(new google.maps.LatLng(x[0], x[1]));
        }));
        /** @type {?} */
        var boundsCenter = bounds.getCenter();
        return new google.maps.LatLng(boundsCenter.lat(), boundsCenter.lng());
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlService.prototype.clearAllPolygons = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.cadastralPolygonsSubject.value.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            _this.pureMapService.removePolygon(x.googlePolygon);
        }));
        this.selectedGroundsFeatureSubject.next([]);
        this.cadastralPolygonsSubject.next([]);
        if (this.drawnPolygonSubject.value) {
            this.pureMapService.removePolygon(this.drawnPolygonSubject.value.googlePolygon);
            this.drawnPolygonSubject.next(null);
        }
        this.polygons.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.pureMapService.removePolygon(x.googlePolygon); }));
        this.polygons = [];
    };
    MapCultivationAreaControlService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapCultivationAreaControlService.ctorParameters = function () { return [
        { type: PureMapService },
        { type: NumberUtilService }
    ]; };
    return MapCultivationAreaControlService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.oneHectareInSquareMeters;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.drawnPolygonSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.cadastralPolygonsSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.selectedGroundsFeatureSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.polygons;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.mapCenterZoomValue;
    /** @type {?} */
    MapCultivationAreaControlService.prototype.markerPosition;
    /** @type {?} */
    MapCultivationAreaControlService.prototype.drawnPolygon$;
    /** @type {?} */
    MapCultivationAreaControlService.prototype.cadastralPolygons$;
    /** @type {?} */
    MapCultivationAreaControlService.prototype.selectedGroundsFeatures$;
    /** @type {?} */
    MapCultivationAreaControlService.prototype.isDrawingEnabled;
    /** @type {?} */
    MapCultivationAreaControlService.prototype.isCenteredToMarker;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.setPolygonSelected;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.pureMapService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlService.prototype.numberUtilService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapCultivationAreaCadastralService = /** @class */ (function () {
    function MapCultivationAreaCadastralService(geolocationService, numberUtilService, cadastralRegisterProxyService) {
        var _this = this;
        this.geolocationService = geolocationService;
        this.numberUtilService = numberUtilService;
        this.cadastralRegisterProxyService = cadastralRegisterProxyService;
        this.getCurrentPosition = (/**
         * @return {?}
         */
        function () {
            return _this.geolocationService.getCurrentPosition();
        });
        this.searchCadastres = (/**
         * @param {?} position
         * @return {?}
         */
        function (position) {
            return _this.cadastralRegisterProxyService.searchCadastres(position.coords.latitude, position.coords.longitude);
        });
        this.convertToFeatures = (/**
         * @param {?} cadasterDetailsDtos
         * @return {?}
         */
        function (cadasterDetailsDtos) {
            return (cadasterDetailsDtos || [])
                .map((/**
             * @param {?} cadasterDetailsDto
             * @return {?}
             */
            function (cadasterDetailsDto) {
                /** @type {?} */
                var cadastralRegister = _this.buildCadastralRegister(cadasterDetailsDto);
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: cadasterDetailsDto.geojson.coordinates[0]
                    },
                    properties: {
                        name: cadasterDetailsDto.area.name + " - " + cadasterDetailsDto.number,
                        area: _this.round2AreaInHa(cadasterDetailsDto.size),
                        cadastralRegister: cadastralRegister != null ? JSON.stringify(cadastralRegister) : undefined
                    }
                };
            }));
        });
        this.buildCadastralRegister = (/**
         * @param {?} cadasterDetailsDto
         * @return {?}
         */
        function (cadasterDetailsDto) {
            if (cadasterDetailsDto == null
                || cadasterDetailsDto.area == null
                || cadasterDetailsDto.area.commune == null
                || cadasterDetailsDto.area.commune.county == null
                || cadasterDetailsDto.area.commune.county.state == null) {
                return null;
            }
            /** @type {?} */
            var cadastralState = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.county.state.id, cadasterDetailsDto.area.commune.county.state.name);
            /** @type {?} */
            var cadastralCounty = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.county.id, cadasterDetailsDto.area.commune.county.name);
            /** @type {?} */
            var cadastralCommune = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.id, cadasterDetailsDto.area.commune.name);
            /** @type {?} */
            var cadastralArea = new CadastralRegisterGeoData(cadasterDetailsDto.area.id, cadasterDetailsDto.area.name);
            /** @type {?} */
            var cadastreNumber = cadasterDetailsDto.number;
            /** @type {?} */
            var cadastreSizeInHa = cadasterDetailsDto.size;
            /** @type {?} */
            var cadastreCoordinates = cadasterDetailsDto.geojson.coordinates;
            return new CadastralRegister(cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, cadastreSizeInHa, cadastreCoordinates);
        });
    }
    /**
     * @return {?}
     */
    MapCultivationAreaCadastralService.prototype.getCadastresForCurrentPosition = /**
     * @return {?}
     */
    function () {
        return this.getCurrentPosition()
            .pipe(switchMap(this.searchCadastres))
            .pipe(map(this.convertToFeatures));
    };
    /**
     * @param {?} position
     * @return {?}
     */
    MapCultivationAreaCadastralService.prototype.getCadastresForMarkerPosition = /**
     * @param {?} position
     * @return {?}
     */
    function (position) {
        return this.searchCadastres(position)
            .pipe(map(this.convertToFeatures));
    };
    /**
     * @param {?} areaInHa
     * @return {?}
     */
    MapCultivationAreaCadastralService.prototype.round2AreaInHa = /**
     * @param {?} areaInHa
     * @return {?}
     */
    function (areaInHa) {
        return this.numberUtilService.round2(areaInHa);
    };
    MapCultivationAreaCadastralService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapCultivationAreaCadastralService.ctorParameters = function () { return [
        { type: GeolocationService },
        { type: NumberUtilService },
        { type: CadastralRegisterProxyService }
    ]; };
    return MapCultivationAreaCadastralService;
}());
if (false) {
    /** @type {?} */
    MapCultivationAreaCadastralService.prototype.getCurrentPosition;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaCadastralService.prototype.searchCadastres;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaCadastralService.prototype.convertToFeatures;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaCadastralService.prototype.buildCadastralRegister;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaCadastralService.prototype.geolocationService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaCadastralService.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaCadastralService.prototype.cadastralRegisterProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapCultivationAreaControlComponent = /** @class */ (function () {
    function MapCultivationAreaControlComponent(mapAreaSelectControlService, mapAreaCadastralService, notificationService, changeDetection) {
        this.mapAreaSelectControlService = mapAreaSelectControlService;
        this.mapAreaCadastralService = mapAreaCadastralService;
        this.notificationService = notificationService;
        this.changeDetection = changeDetection;
        this.MIN_GROUND_AREA_IN_HA = 0.01;
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        // tslint:disable-next-line: variable-name
        this.isDisabled = false;
        this.showCadastreRegister = false;
        this.selectedGroundFeatures = [];
        this.fieldCardSimplifiedAreasSubject = new BehaviorSubject(null);
        this.organizationLocationsSubject = new BehaviorSubject(null);
        this.organizationLocations$ = this.organizationLocationsSubject.asObservable();
        this.organizationGroundsSubject = new BehaviorSubject([]);
        this.displaySpinnerSubject = new BehaviorSubject(false);
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
        this.mapMode = MapCultivationAreaModeEnum.DRAWING_MODE;
    }
    Object.defineProperty(MapCultivationAreaControlComponent.prototype, "organizationLocations", {
        get: /**
         * @return {?}
         */
        function () {
            return this.organizationLocationsSubject.value;
        },
        set: /**
         * @param {?} organizationLocations
         * @return {?}
         */
        function (organizationLocations) {
            this.organizationLocationsSubject.next(organizationLocations);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCultivationAreaControlComponent.prototype, "organizationGrounds", {
        set: /**
         * @param {?} grounds
         * @return {?}
         */
        function (grounds) {
            this.organizationGroundsSubject.next(grounds);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCultivationAreaControlComponent.prototype, "features", {
        get: /**
         * @return {?}
         */
        function () {
            return this.fieldCardSimplifiedAreasSubject.value;
        },
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            this.fieldCardSimplifiedAreasSubject.next(features || null);
            this.onChange(features);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.features = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    Object.defineProperty(MapCultivationAreaControlComponent.prototype, "displaySpinner$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.displaySpinnerSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.initSubscription = combineLatest([
            this.organizationLocations$,
            this.mapAreaSelectControlService.mapReady$
        ]).subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), organizationLocations = _b[0], map = _b[1];
            if (map) {
                _this.mapAreaSelectControlService.markPosition(organizationLocations);
                _this.mapAreaSelectControlService.turnOnDrawing();
            }
        }));
        this.drawPolygonAndGetCadastralPolygonsSubscription = combineLatest([
            this.mapAreaSelectControlService.cadastralPolygons$,
            this.mapAreaSelectControlService.drawnPolygon$
        ]).subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), cadastralPolygons = _b[0], drawnPolygon = _b[1];
            if (cadastralPolygons != null && cadastralPolygons.length > 0 && drawnPolygon != null) {
                _this.drawnPolygonAndIntersectedGroundsFlow(cadastralPolygons, drawnPolygon);
            }
            else if (drawnPolygon !== null) {
                _this.drawnPolygonToGroundToAddFlow(drawnPolygon);
            }
        }));
        this.selectGroundFeaturesSubscription = this.mapAreaSelectControlService.selectedGroundsFeatures$.subscribe((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            _this.selectedGroundFeatures = x;
            _this.changeDetection.detectChanges();
            /** @type {?} */
            var featureToUpdate = _this.features;
            if (featureToUpdate != null) {
                if (_this.selectedGroundFeatures.length > 0) {
                    featureToUpdate.organizationGrounds = _this.selectedGroundFeatures;
                    featureToUpdate.parcel =
                        _this.mapAreaSelectControlService.mapSelectedGroundsFeaturesToParcelFeature(_this.selectedGroundFeatures);
                    featureToUpdate.creationMode = MapCultivationAreaModeEnum.SELECT_GROUNDS_MODE;
                }
                else {
                    featureToUpdate.organizationGrounds = [];
                    featureToUpdate.parcel = [];
                }
                _this.features = featureToUpdate;
            }
        }));
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.initSubscription != null) {
            this.initSubscription.unsubscribe();
        }
        if (this.drawPolygonAndGetCadastralPolygonsSubscription != null) {
            this.drawPolygonAndGetCadastralPolygonsSubscription.unsubscribe();
        }
        if (this.selectGroundFeaturesSubscription != null) {
            this.selectGroundFeaturesSubscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.showCadastreFeatures = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinnerSubject.next(true);
        this.mapAreaCadastralService.getCadastresForMarkerPosition(this.mapAreaSelectControlService.markerPosition.value)
            .subscribe((/**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            if (features && features.length === 0) {
                _this.notificationService.warning('CULTIVATION.fieldCardForm.notFoundCadastres');
                _this.displaySpinnerSubject.next(false);
                return;
            }
            _this.mapAreaSelectControlService.draw(features, true);
            _this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(features);
            _this.displaySpinnerSubject.next(false);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.displaySpinnerSubject.next(false);
        }));
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.centerMapToMarker = /**
     * @return {?}
     */
    function () {
        this.mapAreaSelectControlService.centerToMarkerPosition();
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.initDrawingMode = /**
     * @return {?}
     */
    function () {
        this.mapMode = MapCultivationAreaModeEnum.DRAWING_MODE;
        this.mapAreaSelectControlService.clearAllPolygons();
        this.mapAreaSelectControlService.turnOnDrawing();
        this.mapAreaSelectControlService.centerToMarkerPosition();
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.initSelectGroundsMode = /**
     * @return {?}
     */
    function () {
        this.mapMode = MapCultivationAreaModeEnum.SELECT_GROUNDS_MODE;
        this.mapAreaSelectControlService.clearAllPolygons();
        this.mapAreaSelectControlService.turnOffDrawing();
        /** @type {?} */
        var groundsFeature = this.organizationGroundsSubject.value.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return (/** @type {?} */ ({
                type: 'Feature',
                geometry: x.locations[0].geometry,
                id: x.id,
                properties: {
                    groundId: x.id,
                    name: x.name,
                    cadastralArea: x.cadastralArea ? x.cadastralArea.name : null,
                    cadastreNumber: x.cadastreNumber,
                    area: x.areaInHa
                }
            }));
        }));
        this.mapAreaSelectControlService.draw(groundsFeature, false, true);
        this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(groundsFeature);
    };
    /**
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.isDrawingMode = /**
     * @return {?}
     */
    function () {
        return this.mapMode === MapCultivationAreaModeEnum.DRAWING_MODE;
    };
    /**
     * @private
     * @param {?} cadastralPolygons
     * @param {?} drawnPolygon
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.calculateIntersectedPolygons = /**
     * @private
     * @param {?} cadastralPolygons
     * @param {?} drawnPolygon
     * @return {?}
     */
    function (cadastralPolygons, drawnPolygon) {
        /** @type {?} */
        var intersectedPolygons = [];
        cadastralPolygons.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            if (intersect(x.turfPolygon, drawnPolygon.turfPolygon)) {
                intersectedPolygons.push(x);
            }
        }));
        return intersectedPolygons;
    };
    /**
     * @private
     * @param {?} intersectedPolygons
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.mapIntersectedCadastralPolygonsToGroundFeatures = /**
     * @private
     * @param {?} intersectedPolygons
     * @return {?}
     */
    function (intersectedPolygons) {
        var _this = this;
        /** @type {?} */
        var groundsFeatureArray = [];
        intersectedPolygons.forEach((/**
         * @param {?} intersectedPolygon
         * @return {?}
         */
        function (intersectedPolygon) {
            /** @type {?} */
            var groundCadastralRegister = _this.mapAreaSelectControlService.getCadastralRegisterFromFeature(intersectedPolygon);
            /** @type {?} */
            var groundFeature = _this.mapAreaSelectControlService.mapCadastrePolygonToGroundFeature(intersectedPolygon)
            // tslint:disable-next-line: no-string-literal
            ;
            // tslint:disable-next-line: no-string-literal
            if (groundFeature[0].properties['area'] < _this.MIN_GROUND_AREA_IN_HA) {
                _this.notificationService.warning('CULTIVATION.fieldCardForm.fieldCardGroundAreaLessThan');
            }
            else {
                groundsFeatureArray.push({ groundFeature: groundFeature, groundCadastralRegister: groundCadastralRegister });
            }
        }));
        return groundsFeatureArray;
    };
    /**
     * @private
     * @param {?} cadastralPolygons
     * @param {?} drawnPolygon
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.drawnPolygonAndIntersectedGroundsFlow = /**
     * @private
     * @param {?} cadastralPolygons
     * @param {?} drawnPolygon
     * @return {?}
     */
    function (cadastralPolygons, drawnPolygon) {
        /** @type {?} */
        var intersectedPolygons = [];
        intersectedPolygons = this.calculateIntersectedPolygons(cadastralPolygons, drawnPolygon);
        if (intersectedPolygons.length > 0) {
            /** @type {?} */
            var groundsFeatureArray = this.mapIntersectedCadastralPolygonsToGroundFeatures(intersectedPolygons);
            /** @type {?} */
            var drawnFeature = this.mapAreaSelectControlService.mapDrawnPolygonToFeature(drawnPolygon, groundsFeatureArray);
            /** @type {?} */
            var featureToUpdate = this.features;
            featureToUpdate.grounds = groundsFeatureArray;
            featureToUpdate.parcel = drawnFeature;
            featureToUpdate.creationMode = MapCultivationAreaModeEnum.DRAWING_MODE;
            this.features = featureToUpdate;
        }
        else {
            this.drawnPolygonToGroundToAddFlow(drawnPolygon);
        }
    };
    /**
     * @private
     * @param {?} drawnPolygon
     * @return {?}
     */
    MapCultivationAreaControlComponent.prototype.drawnPolygonToGroundToAddFlow = /**
     * @private
     * @param {?} drawnPolygon
     * @return {?}
     */
    function (drawnPolygon) {
        /** @type {?} */
        var drawnFeature = this.mapAreaSelectControlService.mapDrawnPolygonToFeature(drawnPolygon, []);
        // tslint:disable-next-line: no-magic-numbers
        if (drawnPolygon.googlePolygon.get('area') <= 0.01) {
            this.notificationService.warning('CULTIVATION.fieldCardForm.drawnAreaLessThan');
            return;
        }
        /** @type {?} */
        var featureToUpdate = this.features;
        featureToUpdate.grounds = [{ groundFeature: drawnFeature, groundCadastralRegister: null }];
        featureToUpdate.parcel = drawnFeature;
        featureToUpdate.creationMode = MapCultivationAreaModeEnum.DRAWING_MODE;
        this.features = featureToUpdate;
    };
    MapCultivationAreaControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-map-cultivation-area-control',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <button class=\"btn btn-raised btn-primary mb-2 mr-2 d-inline\" (click)=\"initDrawingMode()\">{{\r\n        'CULTIVATION.fieldCardForm.draw' | translate }}</button>\r\n    <button class=\"btn btn-raised btn-primary mb-2 mr-2 d-inline\" (click)=\"initSelectGroundsMode()\">{{\r\n        'CULTIVATION.fieldCardForm.selectGrounds' | translate }}</button>\r\n    <div class=\"map-container\">\r\n        <app-pure-map [height]=\"420\" [tilt]=\"0\"></app-pure-map>\r\n        <div *ngIf=\"isDrawingMode()\" class=\"map-buttons\">\r\n            <div class=\"icon-button\">\r\n                <button (click)=\"showCadastreFeatures()\">{{'CULTIVATION.fieldCardForm.showCadastre' |\r\n                    translate}}</button>\r\n            </div>\r\n            <div\r\n                style=\"position: relative; overflow: hidden; width: 110px; height: 1px; margin: 0px 5px; background-color: rgb(230, 230, 230); top: 0px;\">\r\n            </div>\r\n            <div class=\"icon-button icon-button__search\">\r\n                <button (click)=\"centerMapToMarker()\">{{'CULTIVATION.fieldCardForm.centerMap' | translate}}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"this.selectedGroundFeatures.length > 0\" class=\"mt-2\">\r\n        <h5 class=\"mt-1\">{{'CULTIVATION.fieldCardForm.selectedGrounds' | translate}}</h5>\r\n        <div *ngFor=\"let groundFeature of this.selectedGroundFeatures\" class=\"mb-1\">\r\n            <p>{{groundFeature.properties.name}} - {{groundFeature.properties.area + ' ha'}}</p>\r\n        </div>\r\n    </ng-container>\r\n\r\n\r\n</div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        CadastralRegisterProxyService,
                        MapCultivationAreaCadastralService,
                        MapCultivationAreaControlService,
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MapCultivationAreaControlComponent; })), multi: true }
                    ],
                    styles: [".map-container{position:relative}.map-buttons{position:absolute;display:flex;flex-direction:column;background-color:#fff;border-radius:2px;left:15px;bottom:25px;z-index:1000;box-shadow:#000 0 1px 4px -1px}.map-buttons .icon-button{position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;background-color:#fff;border-radius:2px;width:120px;height:40px}.map-buttons .icon-button button{background:padding-box #fff;display:table-cell;border:0;margin:0;text-transform:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;direction:ltr;overflow:hidden;text-align:center;height:40px;vertical-align:middle;color:#565656;font-family:Roboto,Arial,sans-serif;font-size:18px;border-bottom-left-radius:2px;border-top-left-radius:2px;box-shadow:#000 0 1px 4px -1px;min-width:120px}.map-buttons .icon-button button:hover{background:padding-box #ebebeb;display:table-cell}.map-buttons .icon-button button:focus{color:#000}"]
                }] }
    ];
    /** @nocollapse */
    MapCultivationAreaControlComponent.ctorParameters = function () { return [
        { type: MapCultivationAreaControlService },
        { type: MapCultivationAreaCadastralService },
        { type: NotificationService },
        { type: ChangeDetectorRef }
    ]; };
    MapCultivationAreaControlComponent.propDecorators = {
        organizationLocations: [{ type: Input }],
        organizationGrounds: [{ type: Input }],
        features: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MapCultivationAreaControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.MIN_GROUND_AREA_IN_HA;
    /** @type {?} */
    MapCultivationAreaControlComponent.prototype.blur;
    /** @type {?} */
    MapCultivationAreaControlComponent.prototype.change;
    /** @type {?} */
    MapCultivationAreaControlComponent.prototype.focus;
    /** @type {?} */
    MapCultivationAreaControlComponent.prototype.isDisabled;
    /** @type {?} */
    MapCultivationAreaControlComponent.prototype.showCadastreRegister;
    /** @type {?} */
    MapCultivationAreaControlComponent.prototype.selectedGroundFeatures;
    /** @type {?} */
    MapCultivationAreaControlComponent.prototype.mapMode;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.fieldCardSimplifiedAreasSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.organizationLocationsSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.organizationLocations$;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.organizationGroundsSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.initSubscription;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.drawPolygonAndGetCadastralPolygonsSubscription;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.selectGroundFeaturesSubscription;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.mapAreaSelectControlService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.mapAreaCadastralService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaControlComponent.prototype.changeDetection;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function mapCultivationAreaValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return { parcel: {}, grounds: {} };
        }
        /** @type {?} */
        var controlValue = (/** @type {?} */ (control.value));
        if ((controlValue.creationMode === null || controlValue.creationMode === undefined) ||
            (controlValue.parcel.length === 0 && (controlValue.grounds.length === 0 || controlValue.organizationGrounds.length === 0))) {
            return { parcel: {}, grounds: {}, organizationGrounds: {} };
        }
        if (controlValue.parcel.length === 0) {
            return { parcel: {} };
        }
        if (controlValue.parcel.length !== 0) {
            validateParcelAreaInHa(controlValue);
        }
        if (controlValue.creationMode !== null || controlValue.creationMode !== undefined) {
            validateGrounds(controlValue);
        }
        return null;
    });
}
/**
 * @param {?} controlValue
 * @return {?}
 */
function validateParcelAreaInHa(controlValue) {
    /** @type {?} */
    var MIN_AREA_IN_HA = 0.01;
    /** @type {?} */
    var parcelAreaInHaSum = 0;
    controlValue.parcel.forEach((/**
     * @param {?} x
     * @return {?}
     */
    function (x) {
        // tslint:disable-next-line: no-string-literal
        parcelAreaInHaSum += +x.properties['area'];
    }));
    if (parcelAreaInHaSum <= MIN_AREA_IN_HA) {
        return { parcel: {} };
    }
}
/**
 * @param {?} controlValue
 * @return {?}
 */
function validateGrounds(controlValue) {
    if (controlValue.creationMode === MapCultivationAreaModeEnum.DRAWING_MODE) {
        if (controlValue.grounds.length === 0) {
            return { grounds: {} };
        }
    }
    else {
        if (controlValue.organizationGrounds.length === 0) {
            return { organizationGrounds: {} };
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_EDIT_SELECT = 'CULTIVATION_AREA_EDIT_SELECT';
/**
 * @record
 */
function DynamicMapCultivationAreaEditFormControlModelConfig() { }
if (false) {
    /** @type {?|undefined} */
    DynamicMapCultivationAreaEditFormControlModelConfig.prototype.organizationGrounds;
    /** @type {?|undefined} */
    DynamicMapCultivationAreaEditFormControlModelConfig.prototype.creationMode;
}
var DynamicMapCultivationAreaEditFormControlModel = /** @class */ (function (_super) {
    __extends(DynamicMapCultivationAreaEditFormControlModel, _super);
    function DynamicMapCultivationAreaEditFormControlModel(config, layout) {
        var _this = _super.call(this, config, layout) || this;
        _this.type = DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_EDIT_SELECT;
        _this.organizationGrounds = config.organizationGrounds || [];
        _this.creationMode = config.creationMode || MapCultivationAreaModeEnum.DRAWING_MODE;
        return _this;
    }
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMapCultivationAreaEditFormControlModel.prototype, "type", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", Array)
    ], DynamicMapCultivationAreaEditFormControlModel.prototype, "organizationGrounds", void 0);
    __decorate([
        serializable(),
        __metadata("design:type", String)
    ], DynamicMapCultivationAreaEditFormControlModel.prototype, "creationMode", void 0);
    return DynamicMapCultivationAreaEditFormControlModel;
}(DynamicFormValueControlModel));
if (false) {
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlModel.prototype.type;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlModel.prototype.organizationGrounds;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlModel.prototype.creationMode;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicMapCultivationAreaEditFormControlComponent = /** @class */ (function (_super) {
    __extends(DynamicMapCultivationAreaEditFormControlComponent, _super);
    function DynamicMapCultivationAreaEditFormControlComponent(layoutService, validationService) {
        var _this = _super.call(this, layoutService, validationService) || this;
        _this.layoutService = layoutService;
        _this.validationService = validationService;
        // tslint:disable-next-line: no-any
        _this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.change = new EventEmitter();
        _this.customEvent = new EventEmitter();
        // tslint:disable-next-line: no-any
        _this.focus = new EventEmitter();
        return _this;
    }
    DynamicMapCultivationAreaEditFormControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-dynamic-map-cultivation-area-edit-form-control',
                    template: "<ng-container [formGroup]=\"group\">\r\n    <lib-map-cultivation-area-edit-control formControlName=\"{{model.id}}\"\r\n        [organizationGrounds]=\"model.organizationGrounds\" [creationMode]=\"model.creationMode\"\r\n        [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\" (blur)=\"onBlur($event)\"\r\n        (change)=\"onChange($event)\" (focus)=\"onFocus($event)\">\r\n    </lib-map-cultivation-area-edit-control>\r\n</ng-container>"
                }] }
    ];
    /** @nocollapse */
    DynamicMapCultivationAreaEditFormControlComponent.ctorParameters = function () { return [
        { type: DynamicFormLayoutService },
        { type: DynamicFormValidationService }
    ]; };
    DynamicMapCultivationAreaEditFormControlComponent.propDecorators = {
        group: [{ type: Input }],
        layout: [{ type: Input }],
        model: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        customEvent: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return DynamicMapCultivationAreaEditFormControlComponent;
}(DynamicFormControlComponent));
if (false) {
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.group;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.layout;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.model;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.blur;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.change;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.customEvent;
    /** @type {?} */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.focus;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.layoutService;
    /**
     * @type {?}
     * @protected
     */
    DynamicMapCultivationAreaEditFormControlComponent.prototype.validationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolygonShapesOptions$2 = /** @class */ (function () {
    function PolygonShapesOptions() {
    }
    PolygonShapesOptions.SELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ff0000',
        fillColor: '#ff0000'
    };
    PolygonShapesOptions.CADASTRAL_POLYGON_OPTIONS = {
        strokeColor: '#ffff00',
        fillColor: '#ffff00'
    };
    PolygonShapesOptions.DRAWED_POLYGON_OPTIONS = {
        strokeColor: '#99ff33',
        fillColor: '#ccffcc'
    };
    return PolygonShapesOptions;
}());
if (false) {
    /** @type {?} */
    PolygonShapesOptions$2.SELECTED_POLYGON_OPTIONS;
    /** @type {?} */
    PolygonShapesOptions$2.CADASTRAL_POLYGON_OPTIONS;
    /** @type {?} */
    PolygonShapesOptions$2.DRAWED_POLYGON_OPTIONS;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapCultivationAreaEditControlService = /** @class */ (function () {
    function MapCultivationAreaEditControlService(pureMapService, numberUtilService) {
        this.pureMapService = pureMapService;
        this.numberUtilService = numberUtilService;
        this.oneHectareInSquareMeters = 10000;
        this.drawnPolygonSubject = new BehaviorSubject(null);
        this.selectedGroundsFeatureSubject = new BehaviorSubject([]);
        this.polygons = [];
        this.mapCenterZoomValue = 14;
        this.markerPosition = new BehaviorSubject(null);
        this.selectedGroundsFeatures$ = this.selectedGroundsFeatureSubject.asObservable();
        this.isDrawingEnabled = new BehaviorSubject(false);
        this.isCenteredToMarker = false;
        this.setPolygonSelected = (/**
         * @param {?} polygon
         * @param {?} isSelected
         * @return {?}
         */
        function (polygon, isSelected) {
            polygon.set('selected', isSelected);
            polygon.set('label', polygon.get('name'));
        });
    }
    Object.defineProperty(MapCultivationAreaEditControlService.prototype, "mapReady$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.pureMapService.mapReady.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCultivationAreaEditControlService.prototype, "cadastralPolygons", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygons;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCultivationAreaEditControlService.prototype, "drawnPolygon", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getDrawnPolygonFeatures(this.drawnPolygonSubject.value);
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} organizationLocations
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.markPosition = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} organizationLocations
     * @return {?}
     */
    function (organizationLocations) {
        var _this = this;
        /** @type {?} */
        var organizationCenterPoint = organizationLocations.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Point'; }));
        // tslint:disable-next-line: no-magic-numbers
        /** @type {?} */
        var point = new google.maps.LatLng(50.22005290158697, 20.182460816577382);
        if (organizationCenterPoint) {
            // tslint:disable-next-line: max-line-length
            point = new google.maps.LatLng(organizationCenterPoint.geometry.coordinates[1], organizationCenterPoint.geometry.coordinates[0]);
        }
        /** @type {?} */
        var marker = this.pureMapService.createSingleMarker({
            position: point,
            draggable: true
        });
        this.markerPosition.next(this.mapMarkerPositionToGeolocationPosition(point.lat(), point.lng()));
        marker.addListener('dragend', (/**
         * @param {?} dragEndMarkerEvent
         * @return {?}
         */
        function (dragEndMarkerEvent) {
            _this.markerPosition.next(_this.mapMarkerPositionToGeolocationPosition(dragEndMarkerEvent.latLng.lat(), dragEndMarkerEvent.latLng.lng()));
        }));
        if (!this.isCenteredToMarker) {
            this.pureMapService.centerMap(point);
            this.pureMapService.setZoom(this.mapCenterZoomValue);
        }
        this.isCenteredToMarker = true;
    };
    /**
     * @param {?} features
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @param {?=} editable
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.draw = /**
     * @param {?} features
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @param {?=} editable
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    function (features, isFromCadastralRegister, isFromOrganizationGrounds, editable, isDrawnPolygon) {
        var _this = this;
        if (isFromCadastralRegister === void 0) { isFromCadastralRegister = false; }
        if (isFromOrganizationGrounds === void 0) { isFromOrganizationGrounds = false; }
        if (editable === void 0) { editable = false; }
        if (isDrawnPolygon === void 0) { isDrawnPolygon = false; }
        features
            .filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.geometry.type === 'Polygon'; }))
            .forEach((/**
         * @param {?} feature
         * @return {?}
         */
        function (feature) { return _this.createPolygon((/** @type {?} */ (feature)), isFromCadastralRegister, isFromOrganizationGrounds, editable, isDrawnPolygon); }));
    };
    /**
     * @param {?} features
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.selectCurrentFeatures = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        var _this = this;
        features.forEach((/**
         * @param {?} location
         * @return {?}
         */
        function (location) {
            /** @type {?} */
            var foundPolygon = _this.polygons.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.googlePolygon.get('groundId') === location.id; }));
            if (foundPolygon) {
                foundPolygon.googlePolygon.set('selected', true);
            }
        }));
    };
    /**
     * @param {?} currentFeatures
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.confirmSelection = /**
     * @param {?} currentFeatures
     * @return {?}
     */
    function (currentFeatures) {
        /** @type {?} */
        var selectedFeatures = this.getSelectedFeatures();
        /** @type {?} */
        var resultFeatures = [];
        /** @type {?} */
        var features = currentFeatures;
        selectedFeatures.forEach((/**
         * @param {?} selectedFeature
         * @return {?}
         */
        function (selectedFeature) {
            /** @type {?} */
            var foundFeature = features.find((/**
             * @param {?} feature
             * @return {?}
             */
            function (feature) { return feature.id === selectedFeature.id; }));
            if (foundFeature) {
                resultFeatures.push(foundFeature);
            }
            else {
                resultFeatures.push(selectedFeature);
            }
        }));
        return resultFeatures;
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.turnOffDrawing = /**
     * @return {?}
     */
    function () {
        if (this.isDrawingEnabled.value) {
            /** @type {?} */
            var drawingManager = this.pureMapService.createDrawingManager({
                drawingControl: false,
                drawingControlOptions: {
                    drawingModes: null
                }
            });
            drawingManager.unbindAll();
            this.isDrawingEnabled.next(false);
        }
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.centerToMarkerPosition = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var point = new google.maps.LatLng(this.markerPosition.value.coords.latitude, this.markerPosition.value.coords.longitude);
        this.pureMapService.centerMap(point);
        this.pureMapService.setZoom(this.mapCenterZoomValue);
    };
    /**
     * @param {?} features
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.fitBoundsMapToNewCadastreFeatures = /**
     * @param {?} features
     * @return {?}
     */
    function (features) {
        var _this = this;
        if (features.length > 0) {
            /** @type {?} */
            var bounds_1 = new google.maps.LatLngBounds();
            features.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                _this.getPolygonPaths((/** @type {?} */ (x))).forEach((/**
                 * @param {?} path
                 * @return {?}
                 */
                function (path) {
                    bounds_1.extend(path);
                }));
            }));
            this.pureMapService.fitBounds(bounds_1);
        }
    };
    /**
     * @private
     * @param {?} feature
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @param {?=} editable
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.createPolygon = /**
     * @private
     * @param {?} feature
     * @param {?=} isFromCadastralRegister
     * @param {?=} isFromOrganizationGrounds
     * @param {?=} editable
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    function (feature, isFromCadastralRegister, isFromOrganizationGrounds, editable, isDrawnPolygon) {
        if (isFromCadastralRegister === void 0) { isFromCadastralRegister = false; }
        if (isFromOrganizationGrounds === void 0) { isFromOrganizationGrounds = false; }
        if (editable === void 0) { editable = false; }
        if (isDrawnPolygon === void 0) { isDrawnPolygon = false; }
        /** @type {?} */
        var unselectedOptions = isFromCadastralRegister || isFromOrganizationGrounds
            ? PolygonShapesOptions$2.CADASTRAL_POLYGON_OPTIONS
            : PolygonShapesOptions$2.DRAWED_POLYGON_OPTIONS;
        feature.properties.selected = false;
        if (editable) {
            feature.properties.editable = true;
        }
        /** @type {?} */
        var polygon = this.pureMapService.createPolygon(__assign({ paths: this.getPolygonPaths(feature) }, feature.properties, unselectedOptions));
        if (isFromOrganizationGrounds) {
            this.setPolygonListeners(polygon);
        }
        if (editable) {
            this.setEditableListeners(polygon, isDrawnPolygon);
        }
        if (isDrawnPolygon) {
            if (this.drawnPolygonSubject.value) {
                this.pureMapService.removePolygon(this.drawnPolygonSubject.value);
            }
            this.drawnPolygonSubject.next(polygon);
        }
        else {
            this.polygons.push({ googlePolygon: polygon, turfPolygon: null });
        }
        if (isFromCadastralRegister) {
            /** @type {?} */
            var bounds_2 = new google.maps.LatLngBounds();
            this.getPolygonPaths(feature).forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return bounds_2.extend(x); }));
            this.pureMapService.fitBounds(bounds_2);
        }
    };
    /**
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.getDrawnPolygonFeatures = /**
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        return [{
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: this.getPolygonCoordinates(polygon)
                },
                id: polygon.get('id'),
                properties: {
                    name: polygon.get('name'),
                    area: polygon.get('area'),
                }
            }];
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.getPolygonFeatures = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return this.polygons.map((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) {
            return {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: _this.getPolygonCoordinates(polygon.googlePolygon)
                },
                id: polygon.googlePolygon.get('groundId'),
                properties: {
                    name: polygon.googlePolygon.get('name'),
                    area: polygon.googlePolygon.get('area'),
                    groundId: polygon.googlePolygon.get('groundId'),
                }
            };
        }));
    };
    /**
     * @param {?} markerLatitude
     * @param {?} markerLongitude
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.mapMarkerPositionToGeolocationPosition = /**
     * @param {?} markerLatitude
     * @param {?} markerLongitude
     * @return {?}
     */
    function (markerLatitude, markerLongitude) {
        return {
            coords: {
                latitude: markerLatitude,
                longitude: markerLongitude,
                speed: null,
                heading: null,
                altitudeAccuracy: null,
                accuracy: null,
                altitude: null
            },
            timestamp: null
        };
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.setPolygonListeners = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        var _this = this;
        polygon.addListener('selected_changed', (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var isPolygonSelected = (/** @type {?} */ (polygon.get('selected')));
            /** @type {?} */
            var polygonOptions = isPolygonSelected
                ? PolygonShapesOptions$2.SELECTED_POLYGON_OPTIONS
                : PolygonShapesOptions$2.CADASTRAL_POLYGON_OPTIONS;
            polygon.setOptions(polygonOptions);
        }));
        polygon.addListener('click', (/**
         * @return {?}
         */
        function () {
            _this.setPolygonSelectedAndUpdateSelectedFeatures(polygon);
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.setEditableListeners = /**
     * @private
     * @param {?} polygon
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    function (polygon, isDrawnPolygon) {
        var _this = this;
        if (isDrawnPolygon === void 0) { isDrawnPolygon = false; }
        google.maps.event.addListener(polygon.getPath(), 'remove_at', (/**
         * @return {?}
         */
        function () { return _this.setNewPolygonPaths(polygon, polygon.getPath(), isDrawnPolygon); }));
        google.maps.event.addListener(polygon.getPath(), 'set_at', (/**
         * @return {?}
         */
        function () { return _this.setNewPolygonPaths(polygon, polygon.getPath(), isDrawnPolygon); }));
        google.maps.event.addListener(polygon.getPath(), 'insert_at', (/**
         * @return {?}
         */
        function () { return _this.setNewPolygonPaths(polygon, polygon.getPath(), isDrawnPolygon); }));
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} polygon
     * @param {?} path
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.setNewPolygonPaths = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} polygon
     * @param {?} path
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    function (polygon, path, isDrawnPolygon) {
        if (isDrawnPolygon === void 0) { isDrawnPolygon = false; }
        /** @type {?} */
        var areaInHa = google.maps.geometry.spherical.computeArea(path) / this.oneHectareInSquareMeters;
        polygon.setPath(path);
        polygon.set('area', this.numberUtilService.round2(areaInHa));
        if (isDrawnPolygon) {
            this.drawnPolygonSubject.next(polygon);
        }
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.setPolygonSelectedAndUpdateSelectedFeatures = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var isSelected = polygon.get('selected');
        this.setPolygonSelected(polygon, !isSelected);
        this.updateSelectedFeatures();
    };
    /**
     * @private
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.updateSelectedFeatures = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selectedFeatures = this.getSelectedFeatures();
        this.selectedGroundsFeatureSubject.next(selectedFeatures);
    };
    /**
     * @private
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.getSelectedFeatures = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var selectedPolygons = this.polygons.filter((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) { return !!polygon.googlePolygon.get('selected'); }));
        return selectedPolygons.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: _this.getPolygonCoordinates(x.googlePolygon)
                },
                id: x.googlePolygon.get('groundId'),
                properties: {
                    name: x.googlePolygon.get('name'),
                    area: x.googlePolygon.get('area'),
                    id: x.googlePolygon.get('groundId'),
                    groundId: x.googlePolygon.get('groundId')
                }
            };
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.getPolygonCoordinates = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        return polygon.getPaths().getArray()
            .map((/**
         * @param {?} path
         * @return {?}
         */
        function (path) {
            return path.getArray().map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                return [x.lng(), x.lat()];
            }));
        }));
    };
    /**
     * @private
     * @param {?} feature
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.getPolygonPaths = /**
     * @private
     * @param {?} feature
     * @return {?}
     */
    function (feature) {
        /** @type {?} */
        var coordinates = feature.geometry.coordinates;
        return coordinates[0].map((/**
         * @param {?} coordinate
         * @return {?}
         */
        function (coordinate) {
            return new google.maps.LatLng(coordinate[1], coordinate[0]);
        }));
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlService.prototype.clearAllPolygons = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.selectedGroundsFeatureSubject.next([]);
        if (this.drawnPolygonSubject.value) {
            this.pureMapService.removePolygon(this.drawnPolygonSubject.value);
            this.drawnPolygonSubject.next(null);
        }
        this.polygons.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.pureMapService.removePolygon(x.googlePolygon); }));
        this.polygons = [];
    };
    MapCultivationAreaEditControlService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapCultivationAreaEditControlService.ctorParameters = function () { return [
        { type: PureMapService },
        { type: NumberUtilService }
    ]; };
    return MapCultivationAreaEditControlService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.oneHectareInSquareMeters;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.drawnPolygonSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.selectedGroundsFeatureSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.polygons;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.mapCenterZoomValue;
    /** @type {?} */
    MapCultivationAreaEditControlService.prototype.markerPosition;
    /** @type {?} */
    MapCultivationAreaEditControlService.prototype.selectedGroundsFeatures$;
    /** @type {?} */
    MapCultivationAreaEditControlService.prototype.isDrawingEnabled;
    /** @type {?} */
    MapCultivationAreaEditControlService.prototype.isCenteredToMarker;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.setPolygonSelected;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.pureMapService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlService.prototype.numberUtilService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapCultivationAreaEditCadastralService = /** @class */ (function () {
    function MapCultivationAreaEditCadastralService(geolocationService, numberUtilService, cadastralRegisterProxyService) {
        var _this = this;
        this.geolocationService = geolocationService;
        this.numberUtilService = numberUtilService;
        this.cadastralRegisterProxyService = cadastralRegisterProxyService;
        this.getCurrentPosition = (/**
         * @return {?}
         */
        function () {
            return _this.geolocationService.getCurrentPosition();
        });
        this.searchCadastres = (/**
         * @param {?} position
         * @return {?}
         */
        function (position) {
            return _this.cadastralRegisterProxyService.searchCadastres(position.coords.latitude, position.coords.longitude);
        });
        this.convertToFeatures = (/**
         * @param {?} cadasterDetailsDtos
         * @return {?}
         */
        function (cadasterDetailsDtos) {
            return (cadasterDetailsDtos || [])
                .map((/**
             * @param {?} cadasterDetailsDto
             * @return {?}
             */
            function (cadasterDetailsDto) {
                /** @type {?} */
                var cadastralRegister = _this.buildCadastralRegister(cadasterDetailsDto);
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: cadasterDetailsDto.geojson.coordinates[0]
                    },
                    properties: {
                        name: cadasterDetailsDto.area.name + " - " + cadasterDetailsDto.number,
                        area: _this.round2AreaInHa(cadasterDetailsDto.size),
                        cadastralRegister: cadastralRegister != null ? JSON.stringify(cadastralRegister) : undefined
                    }
                };
            }));
        });
        this.buildCadastralRegister = (/**
         * @param {?} cadasterDetailsDto
         * @return {?}
         */
        function (cadasterDetailsDto) {
            if (cadasterDetailsDto == null
                || cadasterDetailsDto.area == null
                || cadasterDetailsDto.area.commune == null
                || cadasterDetailsDto.area.commune.county == null
                || cadasterDetailsDto.area.commune.county.state == null) {
                return null;
            }
            /** @type {?} */
            var cadastralState = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.county.state.id, cadasterDetailsDto.area.commune.county.state.name);
            /** @type {?} */
            var cadastralCounty = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.county.id, cadasterDetailsDto.area.commune.county.name);
            /** @type {?} */
            var cadastralCommune = new CadastralRegisterGeoData(cadasterDetailsDto.area.commune.id, cadasterDetailsDto.area.commune.name);
            /** @type {?} */
            var cadastralArea = new CadastralRegisterGeoData(cadasterDetailsDto.area.id, cadasterDetailsDto.area.name);
            /** @type {?} */
            var cadastreNumber = cadasterDetailsDto.number;
            /** @type {?} */
            var cadastreSizeInHa = cadasterDetailsDto.size;
            /** @type {?} */
            var cadastreCoordinates = cadasterDetailsDto.geojson.coordinates;
            return new CadastralRegister(cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, cadastreSizeInHa, cadastreCoordinates);
        });
    }
    /**
     * @return {?}
     */
    MapCultivationAreaEditCadastralService.prototype.getCadastresForCurrentPosition = /**
     * @return {?}
     */
    function () {
        return this.getCurrentPosition()
            .pipe(switchMap(this.searchCadastres))
            .pipe(map(this.convertToFeatures));
    };
    /**
     * @param {?} position
     * @return {?}
     */
    MapCultivationAreaEditCadastralService.prototype.getCadastresForMarkerPosition = /**
     * @param {?} position
     * @return {?}
     */
    function (position) {
        return this.searchCadastres(position)
            .pipe(map(this.convertToFeatures));
    };
    /**
     * @param {?} areaInHa
     * @return {?}
     */
    MapCultivationAreaEditCadastralService.prototype.round2AreaInHa = /**
     * @param {?} areaInHa
     * @return {?}
     */
    function (areaInHa) {
        return this.numberUtilService.round2(areaInHa);
    };
    MapCultivationAreaEditCadastralService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapCultivationAreaEditCadastralService.ctorParameters = function () { return [
        { type: GeolocationService },
        { type: NumberUtilService },
        { type: CadastralRegisterProxyService }
    ]; };
    return MapCultivationAreaEditCadastralService;
}());
if (false) {
    /** @type {?} */
    MapCultivationAreaEditCadastralService.prototype.getCurrentPosition;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditCadastralService.prototype.searchCadastres;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditCadastralService.prototype.convertToFeatures;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditCadastralService.prototype.buildCadastralRegister;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditCadastralService.prototype.geolocationService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditCadastralService.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditCadastralService.prototype.cadastralRegisterProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapCultivationAreaEditControlComponent = /** @class */ (function () {
    function MapCultivationAreaEditControlComponent(mapAreaSelectControlService, mapAreaCadastralService, notificationService, changeDetection) {
        this.mapAreaSelectControlService = mapAreaSelectControlService;
        this.mapAreaCadastralService = mapAreaCadastralService;
        this.notificationService = notificationService;
        this.changeDetection = changeDetection;
        this.MIN_GROUND_AREA_IN_HA = 0.01;
        // tslint:disable-next-line: no-any
        this.blur = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.change = new EventEmitter();
        // tslint:disable-next-line: no-any
        this.focus = new EventEmitter();
        // tslint:disable-next-line: variable-name
        this.isDisabled = false;
        this.showCadastreRegister = false;
        this.selectGrounds = true;
        this.selectedGroundFeatures = [];
        this.featuresSubject = new BehaviorSubject([]);
        this.features$ = this.featuresSubject.asObservable();
        this.organizationGroundsSubject = new BehaviorSubject([]);
        this.organiationGrounds$ = this.organizationGroundsSubject.asObservable();
        this.displaySpinnerSubject = new BehaviorSubject(false);
        this.useSubscription = false;
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
        this.mapMode = MapCultivationAreaModeEnum.DRAWING_MODE;
    }
    Object.defineProperty(MapCultivationAreaEditControlComponent.prototype, "organizationGrounds", {
        set: /**
         * @param {?} grounds
         * @return {?}
         */
        function (grounds) {
            this.organizationGroundsSubject.next(grounds);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCultivationAreaEditControlComponent.prototype, "creationMode", {
        set: /**
         * @param {?} creationMode
         * @return {?}
         */
        function (creationMode) {
            this.mapMode = creationMode;
            this.changeDetection.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCultivationAreaEditControlComponent.prototype, "features", {
        get: /**
         * @return {?}
         */
        function () {
            return this.featuresSubject.value;
        },
        set: /**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            features.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                delete x.properties.editable;
                delete x.properties.selected;
            }));
            this.featuresSubject.next(features || null);
            this.onChange(features);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} obj
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.features = obj;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.isDisabled = isDisabled;
        this.useSubscription = !isDisabled;
    };
    Object.defineProperty(MapCultivationAreaEditControlComponent.prototype, "displaySpinner$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.displaySpinnerSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line: cognitive-complexity
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.ngOnInit = 
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.initSubscription = combineLatest([
            this.features$,
            this.organiationGrounds$,
            this.mapAreaSelectControlService.mapReady$
        ]).subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 3), features = _b[0], organizationGrounds = _b[1], map = _b[2];
            if (map) {
                if (_this.isDisabled) {
                    _this.setDisabledMode(features);
                }
                else {
                    if (_this.useSubscription) {
                        if (_this.mapMode === MapCultivationAreaModeEnum.DRAWING_MODE && features.length > 0) {
                            _this.initDrawingMode(features, true);
                        }
                        if (organizationGrounds.length > 0 &&
                            _this.mapMode === MapCultivationAreaModeEnum.SELECT_GROUNDS_MODE &&
                            features.length > 0) {
                            _this.initSelectGroundsMode(organizationGrounds, features);
                        }
                    }
                }
            }
        }));
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.initSubscription != null) {
            this.initSubscription.unsubscribe();
        }
        if (this.drawPolygonSubscription != null) {
            this.drawPolygonSubscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.showCadastreFeatures = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinnerSubject.next(true);
        this.mapAreaCadastralService.getCadastresForMarkerPosition(this.mapAreaSelectControlService.markerPosition.value)
            .subscribe((/**
         * @param {?} features
         * @return {?}
         */
        function (features) {
            _this.mapAreaSelectControlService.draw(features, true);
            _this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(features);
            _this.displaySpinnerSubject.next(false);
        }), (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.displaySpinnerSubject.next(false); }));
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.centerMapToMarker = /**
     * @return {?}
     */
    function () {
        this.mapAreaSelectControlService.centerToMarkerPosition();
    };
    /**
     * @param {?=} features
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.initDrawingMode = /**
     * @param {?=} features
     * @param {?=} isDrawnPolygon
     * @return {?}
     */
    function (features, isDrawnPolygon) {
        if (features === void 0) { features = []; }
        if (isDrawnPolygon === void 0) { isDrawnPolygon = false; }
        this.selectGrounds = false;
        this.mapAreaSelectControlService.clearAllPolygons();
        if (features.length > 0) {
            this.mapAreaSelectControlService.draw(features, false, false, true, isDrawnPolygon);
        }
        else {
            this.mapAreaSelectControlService.draw(this.features, false, false, true, isDrawnPolygon);
        }
        this.changeDetection.detectChanges();
    };
    /**
     * @param {?=} organizationGrounds
     * @param {?=} features
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.initSelectGroundsMode = /**
     * @param {?=} organizationGrounds
     * @param {?=} features
     * @return {?}
     */
    function (organizationGrounds, features) {
        var _this = this;
        if (organizationGrounds === void 0) { organizationGrounds = []; }
        if (features === void 0) { features = []; }
        this.selectGrounds = true;
        this.mapAreaSelectControlService.clearAllPolygons();
        this.mapAreaSelectControlService.turnOffDrawing();
        /** @type {?} */
        var groundsFeature = null;
        if (organizationGrounds.length === 0) {
            groundsFeature = this.organizationGroundsSubject.value.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return _this.mapGroundToFeature(x); }));
        }
        else {
            groundsFeature = organizationGrounds.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return _this.mapGroundToFeature(x); }));
        }
        this.mapAreaSelectControlService.draw(groundsFeature, false, true);
        this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(groundsFeature);
        if (features.length === 0) {
            this.mapAreaSelectControlService.selectCurrentFeatures(this.features);
            this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(this.features);
        }
        else {
            this.mapAreaSelectControlService.selectCurrentFeatures(features);
            this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(features);
        }
        this.changeDetection.detectChanges();
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.isDrawingMode = /**
     * @return {?}
     */
    function () {
        return this.mapMode === MapCultivationAreaModeEnum.DRAWING_MODE;
    };
    /**
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.confirmSelection = /**
     * @return {?}
     */
    function () {
        if (this.mapMode === MapCultivationAreaModeEnum.SELECT_GROUNDS_MODE) {
            if (this.selectGrounds) {
                this.useSubscription = false;
                /** @type {?} */
                var featuresToConfirm = this.mapAreaSelectControlService.confirmSelection(this.features);
                if (featuresToConfirm && featuresToConfirm.length === 0) {
                    this.notificationService.warning('CULTIVATION.fieldCardForm.atLeastOneGroundSelected');
                    return;
                }
                this.features = this.mapAreaSelectControlService.confirmSelection(this.features);
                this.initDrawingMode();
            }
            else {
                this.useSubscription = false;
                this.features = this.mapAreaSelectControlService.getPolygonFeatures();
            }
        }
        else {
            this.useSubscription = false;
            this.features = this.mapAreaSelectControlService.drawnPolygon;
        }
    };
    /**
     * @private
     * @param {?} groundItem
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.mapGroundToFeature = /**
     * @private
     * @param {?} groundItem
     * @return {?}
     */
    function (groundItem) {
        return (/** @type {?} */ ({
            type: 'Feature',
            geometry: groundItem.locations[0].geometry,
            id: groundItem.id,
            properties: {
                id: groundItem.id,
                groundId: groundItem.id,
                name: groundItem.name,
                area: groundItem.areaInHa
            }
        }));
    };
    /**
     * @private
     * @param {?} features
     * @return {?}
     */
    MapCultivationAreaEditControlComponent.prototype.setDisabledMode = /**
     * @private
     * @param {?} features
     * @return {?}
     */
    function (features) {
        this.mapAreaSelectControlService.clearAllPolygons();
        this.mapAreaSelectControlService.draw(features, false, false, false);
        this.mapAreaSelectControlService.fitBoundsMapToNewCadastreFeatures(features);
    };
    MapCultivationAreaEditControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-map-cultivation-area-edit-control',
                    template: "<div class=\"container-fluid px-0\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <ng-container *ngIf=\"!isDrawingMode()\">\r\n        <div class=\"d-flex\">\r\n            <div> <button class=\"btn btn-raised btn-primary mb-2 mr-2\" (click)=\"initSelectGroundsMode()\"\r\n                    [disabled]=\"this.selectGrounds\">{{\r\n                    'CULTIVATION.fieldCardForm.selectGrounds' | translate }}</button></div>\r\n            <div><button class=\"btn btn-raised btn-primary mb-2 mr-2\" (click)=\"initDrawingMode()\"\r\n                    [disabled]=\"!this.selectGrounds\">{{\r\n                    'CULTIVATION.fieldCardForm.editShapes' | translate }}\r\n                </button>\r\n            </div>\r\n            <div class=\"ml-auto\">\r\n                <button *ngIf=\"this.selectGrounds\" class=\"btn btn-raised btn-primary mb-2 mr-0\"\r\n                    (click)=\"confirmSelection()\">{{\r\n                    'CULTIVATION.fieldCardForm.confirmSelection' | translate }}</button>\r\n                <button *ngIf=\"!this.selectGrounds\" class=\"btn btn-raised btn-primary mb-2 mr-0\"\r\n                    (click)=\"confirmSelection()\">{{\r\n                    'CULTIVATION.fieldCardForm.confirmTransform' | translate }}</button>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"isDrawingMode()\">\r\n        <div class=\"d-flex\">\r\n            <div class=\"ml-auto\">\r\n                <button *ngIf=\"!this.selectGrounds\" class=\"btn btn-raised btn-primary mb-2 mr-0\"\r\n                    (click)=\"confirmSelection()\">{{\r\n                    'CULTIVATION.fieldCardForm.confirmTransform' | translate }}</button>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <div class=\"map-container\">\r\n        <app-pure-map [height]=\"420\" [tilt]=\"0\"></app-pure-map>\r\n        <!-- <div *ngIf=\"isDrawingMode()\" class=\"map-buttons\">\r\n            <div class=\"icon-button\">\r\n                <button (click)=\"showCadastreFeatures()\">{{'CULTIVATION.fieldCardForm.showCadastre' |\r\n                    translate}}</button>\r\n            </div>\r\n            <div\r\n                style=\"position: relative; overflow: hidden; width: 110px; height: 1px; margin: 0px 5px; background-color: rgb(230, 230, 230); top: 0px;\">\r\n            </div>\r\n            <div class=\"icon-button icon-button__search\">\r\n                <button (click)=\"centerMapToMarker()\">{{'CULTIVATION.fieldCardForm.centerMap' | translate}}</button>\r\n            </div>\r\n        </div> -->\r\n    </div>\r\n    <ng-container *ngIf=\"this.selectedGroundFeatures.length > 0\" class=\"mt-2\">\r\n        <h5 class=\"mt-1\">{{'CULTIVATION.fieldCardForm.selectedGrounds' | translate}}</h5>\r\n        <div *ngFor=\"let groundFeature of this.selectedGroundFeatures\" class=\"mb-1\">\r\n            <p>{{groundFeature.properties.name}} - {{groundFeature.properties.area + ' ha'}}</p>\r\n        </div>\r\n    </ng-container>\r\n\r\n\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        CadastralRegisterProxyService,
                        MapCultivationAreaEditControlService,
                        MapCultivationAreaEditCadastralService,
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return MapCultivationAreaEditControlComponent; })), multi: true }
                    ],
                    styles: [".map-container{position:relative}.map-buttons{position:absolute;display:flex;flex-direction:column;background-color:#fff;border-radius:2px;left:15px;bottom:25px;z-index:1000;box-shadow:#000 0 1px 4px -1px}.map-buttons .icon-button{position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;background-color:#fff;border-radius:2px;width:120px;height:40px}.map-buttons .icon-button button{background:padding-box #fff;display:table-cell;border:0;margin:0;text-transform:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;direction:ltr;overflow:hidden;text-align:center;height:40px;vertical-align:middle;color:#565656;font-family:Roboto,Arial,sans-serif;font-size:18px;border-bottom-left-radius:2px;border-top-left-radius:2px;box-shadow:#000 0 1px 4px -1px;min-width:120px}.map-buttons .icon-button button:hover{background:padding-box #ebebeb;display:table-cell}.map-buttons .icon-button button:focus{color:#000}"]
                }] }
    ];
    /** @nocollapse */
    MapCultivationAreaEditControlComponent.ctorParameters = function () { return [
        { type: MapCultivationAreaEditControlService },
        { type: MapCultivationAreaEditCadastralService },
        { type: NotificationService },
        { type: ChangeDetectorRef }
    ]; };
    MapCultivationAreaEditControlComponent.propDecorators = {
        organizationGrounds: [{ type: Input }],
        creationMode: [{ type: Input }],
        features: [{ type: Input }],
        blur: [{ type: Output }],
        change: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return MapCultivationAreaEditControlComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.MIN_GROUND_AREA_IN_HA;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.blur;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.change;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.focus;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.isDisabled;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.showCadastreRegister;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.selectGrounds;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.selectedGroundFeatures;
    /** @type {?} */
    MapCultivationAreaEditControlComponent.prototype.mapMode;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.featuresSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.features$;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.organizationGroundsSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.organiationGrounds$;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.displaySpinnerSubject;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.initSubscription;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.useSubscription;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.drawPolygonSubscription;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.mapAreaSelectControlService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.mapAreaCadastralService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    MapCultivationAreaEditControlComponent.prototype.changeDetection;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function farmAuditRequirementValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (control.value == null) {
            return null;
        }
        /** @type {?} */
        var farmAuditRequirement = (/** @type {?} */ (control.value));
        if (!isEmpty(farmAuditRequirement.answerKey)) {
            /** @type {?} */
            var answer = farmAuditRequirement.answers.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.key === farmAuditRequirement.answerKey; }));
            if (answer == null) {
                return { farmAuditRequirement: {} };
            }
            if (answer.isRequiredDescription && isEmpty(farmAuditRequirement.answerDescription)) {
                return { farmAuditRequirement: {} };
            }
        }
        return null;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function controlMapFnFactory() {
    // tslint:disable-next-line: prefer-immediate-return
    /** @type {?} */
    var fn = (/**
     * @param {?} model
     * @return {?}
     */
    function (model) {
        // tslint:disable-next-line: no-small-switch
        // tslint:disable-next-line: max-switch-cases
        switch (model.type) {
            case DYNAMIC_FORM_CONTROL_TYPE_BUTTON:
                return DynamicButtonFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_MAP:
                return DynamicMapFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_MAP_AREA_SELECT:
                return DynamicMapAreaSelectFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_FILE_UPLOAD:
                return DynamicFileFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_FILE_SHARING:
                return DynamicFileSharingFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_DICTIONARY:
                return DynamicDictionaryFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER:
                return DynamicCadastralRegisterFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_NAME:
                return DynamicCadastralRegisterNameFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_MAP:
                return DynamicCadastralRegisterMapFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_SELECT:
                return DynamicMapCultivationAreaFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_EDIT_SELECT:
                return DynamicMapCultivationAreaEditFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_DUAL_LIST:
                return DynamicDualListFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_FARM_AUDIT_REQUIREMENT:
                return DynamicFarmAuditRequirementFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_FIELD_AUDIT_AREA:
                return DynamicFieldAuditAreaFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARY:
                return DynamicEmployeeSalaryFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARIES:
                return DynamicEmployeeSalariesFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_NUMERIC_CONDITION:
                return DynamicNumericConditionControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_MULTI_SELECT:
                return DynamicMultiSelectFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_PERIOD:
                return DynamicPeriodFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_PERIODS:
                return DynamicPeriodsFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_COMMISSIONED_AUDIT_RESULT:
                return DynamicCommissionedAuditResultFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_PRODUCT_DELIVERY:
                return DynamicProductDeliveryFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARD:
                return DynamicSupplierAwardFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARDS:
                return DynamicSupplierAwardsFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZER:
                return DynamicTreatmentFertilizerFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_IRRIGATION:
                return DynamicTreatmentIrrigationFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZERS:
                return DynamicTreatmentFertilizersFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDE:
                return DynamicTreatmentPesticideFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDES:
                return DynamicTreatmentPesticidesFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEED:
                return DynamicTreatmentSeedFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEEDS:
                return DynamicTreatmentSeedsFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENT:
                return DynamicMachineCardElementFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENTS:
                return DynamicMachineCardElementsFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSION:
                return DynamicAclPermissionFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSIONS:
                return DynamicAclPermissionsFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENT:
                return DynamicMachineAlarmConfElementFormControlComponent;
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENTS:
                return DynamicMachineAlarmConfElementsFormControlComponent;
            default:
                return null;
        }
    });
    return fn;
}
/**
 * @return {?}
 */
function modelMapFnFactory() {
    // tslint:disable: no-any
    // tslint:disable-next-line: prefer-immediate-return
    /** @type {?} */
    var fn = (/**
     * @param {?} type
     * @param {?} model
     * @param {?} layout
     * @return {?}
     */
    function (type, model, layout) {
        // tslint:disable-next-line: no-small-switch
        // tslint:disable-next-line: max-switch-cases
        switch (type) {
            case DYNAMIC_FORM_CONTROL_TYPE_BUTTON:
                return new DynamicButtonControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_MAP:
                return new DynamicMapControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_MAP_AREA_SELECT:
                return new DynamicMapAreaSelectFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_FILE_UPLOAD:
                return new DynamicFileUploadModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_FILE_SHARING:
                return new DynamicFileSharingFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_DICTIONARY:
                return new DynamicDictionaryControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER:
                return new DynamicCadastralRegisterFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_NAME:
                return new DynamicCadastralRegisterNameFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_MAP:
                return new DynamicCadastralRegisterMapFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_SELECT:
                return new DynamicMapCultivationAreaFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_EDIT_SELECT:
                return new DynamicMapCultivationAreaEditFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_DUAL_LIST:
                return new DynamicDualListFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARY:
                return new DynamicEmployeeSalaryFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARIES:
                return new DynamicEmployeeSalariesFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_FARM_AUDIT_REQUIREMENT:
                return new DynamicFarmAuditRequirementFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_FIELD_AUDIT_AREA:
                return new DynamicFieldAuditAreaFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_NUMERIC_CONDITION:
                return new DynamicNumericConditionModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_MULTI_SELECT:
                return new DynamicMultiSelectControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_PERIOD:
                return new DynamicPeriodFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_PERIODS:
                return new DynamicPeriodsFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_COMMISSIONED_AUDIT_RESULT:
                return new DynamicCommissionedAuditResultFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_PRODUCT_DELIVERY:
                return new DynamicProductDeliveryFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARD:
                return new DynamicSupplierAwardFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARDS:
                return new DynamicSupplierAwardsFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZER:
                return new DynamicTreatmentFertilizerFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZERS:
                return new DynamicTreatmentFertilizersFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_IRRIGATION:
                return new DynamicTreatmentIrrigationFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDE:
                return new DynamicTreatmentPesticideFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDES:
                return new DynamicTreatmentPesticidesFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEED:
                return new DynamicTreatmentSeedFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEEDS:
                return new DynamicTreatmentSeedsFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENT:
                return new DynamicMachineCardElementFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_CARD_ELEMENTS:
                return new DynamicMachineCardElementsFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSION:
                return new DynamicAclPermissionFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_ACL_PERMISSIONS:
                return new DynamicAclPermissionsFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENT:
                return new DynamicMachineAlarmConfElementFormControlModel(model, layout);
            case DYNAMIC_FORM_CONTROL_TYPE_MACHINE_ALARM_CONF_ELEMENTS:
                return new DynamicMachineAlarmConfElementsFormControlModel(model, layout);
            default:
                return null;
        }
    });
    return fn;
}
/** @type {?} */
var validatorsMap = new Map([
    ['cadastralRegisterValidator', cadastralRegisterValidator],
    ['cadastralGroundRegisterValidator', cadastralGroundRegisterValidator],
    ['cadastralRegisterNameValidator', cadastralRegisterNameValidator],
    ['decimalNumberValidator', decimalNumberValidator],
    ['employeeSalariesValidator', employeeSalariesValidator],
    ['farmAuditRequirementValidator', farmAuditRequirementValidator],
    ['numericConditionValidator', numericConditionValidator],
    ['periodsValidator', periodsValidator],
    ['periodArrayValidator', periodArrayValidator],
    ['commissionedAuditResultValidator', commissionedAuditResultValidator],
    ['productDeliveryValidator', productDeliveryValidator],
    ['supplierAwardsValidator', supplierAwardsValidator],
    ['mapCultivationAreaValidator', mapCultivationAreaValidator],
    ['treatmentFertilizersValidator', treatmentFertilizersValidator],
    ['treatmentIrrigationValidator', treatmentIrrigationValidator],
    ['treatmentPesticidesValidator', treatmentPesticidesValidator],
    ['treatmentSeedsValidator', treatmentSeedsValidator],
    ['machineCardElementsValidator', machineCardElementsValidator],
    ['aclPermissionsValidator', aclPermissionsValidator],
    ['machineAlarmConfElementsValidator', machineAlarmConfElementsValidator]
]);
var ɵ0$a = cadastralRegisterValidator, ɵ1 = cadastralGroundRegisterValidator, ɵ2 = cadastralRegisterNameValidator, ɵ3 = decimalNumberValidator, ɵ4 = numericConditionValidator, ɵ5 = employeeSalariesValidator, ɵ6 = farmAuditRequirementValidator, ɵ7 = periodsValidator, ɵ8 = periodArrayValidator, ɵ9 = commissionedAuditResultValidator, ɵ10 = productDeliveryValidator, ɵ11 = mapCultivationAreaValidator, ɵ12 = supplierAwardsValidator, ɵ13 = treatmentFertilizersValidator, ɵ14 = treatmentIrrigationValidator, ɵ15 = treatmentPesticidesValidator, ɵ16 = treatmentSeedsValidator, ɵ17 = machineCardElementsValidator, ɵ18 = aclPermissionsValidator, ɵ19 = machineAlarmConfElementsValidator;
var FormSharedModule = /** @class */ (function () {
    function FormSharedModule() {
    }
    FormSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        FormComponent,
                        SearchFlatFormComponent,
                        SearchFormComponent,
                        SimpleFormComponent,
                        AddFormComponent,
                        MapAreaSelectControlComponent,
                        MapAreaSelectFormControlComponent,
                        MapCultivationAreaControlComponent,
                        MapCultivationAreaEditControlComponent,
                        MapFormControlComponent,
                        DynamicButtonFormControlComponent,
                        ButtonFormControlComponent,
                        DynamicDualListFormControlComponent,
                        DualListFormControlComponent,
                        DualListComponent,
                        DynamicMapAreaSelectFormControlComponent,
                        DynamicMapCultivationAreaFormControlComponent,
                        DynamicMapCultivationAreaEditFormControlComponent,
                        DynamicMapFormControlComponent,
                        DynamicFileFormControlComponent,
                        DynamicFileSharingFormControlComponent,
                        FileSharingFormComponent,
                        FileSharingFormControlComponent,
                        DynamicFarmAuditRequirementFormControlComponent,
                        FarmAuditRequirementFormControlComponent,
                        FarmAuditRequirementFormComponent,
                        DynamicFieldAuditAreaFormControlComponent,
                        FieldAuditAreaFormControlComponent,
                        FieldAuditAreaFormComponent,
                        DynamicEmployeeSalaryFormControlComponent,
                        EmployeeSalaryFormControlComponent,
                        EmployeeSalaryFormComponent,
                        DynamicEmployeeSalariesFormControlComponent,
                        EmployeeSalariesFormControlComponent,
                        EmployeeSalariesFormComponent,
                        DynamicNumericConditionControlComponent,
                        FileFormControlComponent,
                        DynamicDictionaryFormControlComponent,
                        DynamicMultiSelectFormControlComponent,
                        CadastralRegisterFormComponent,
                        CadastralRegisterNameFormComponent,
                        CadastralRegisterFormControlComponent,
                        CadastralRegisterNameFormControlComponent,
                        DynamicCadastralRegisterFormControlComponent,
                        DynamicCadastralRegisterNameFormControlComponent,
                        CadastralRegisterMapFormControlComponent,
                        DynamicCadastralRegisterMapFormControlComponent,
                        NumericConditionControlComponent,
                        DynamicNumericConditionControlComponent,
                        DynamicPeriodFormControlComponent,
                        PeriodFormControlComponent,
                        PeriodFormComponent,
                        DynamicPeriodsFormControlComponent,
                        PeriodsFormControlComponent,
                        PeriodsFormComponent,
                        DynamicCommissionedAuditResultFormControlComponent,
                        CommissionedAuditResultFormControlComponent,
                        CommissionedAuditResultFormComponent,
                        DynamicProductDeliveryFormControlComponent,
                        ProductDeliveryFormControlComponent,
                        ProductDeliveryFormComponent,
                        DynamicSupplierAwardFormControlComponent,
                        SupplierAwardFormControlComponent,
                        SupplierAwardFormComponent,
                        DynamicSupplierAwardsFormControlComponent,
                        SupplierAwardsFormControlComponent,
                        SupplierAwardsFormComponent,
                        DynamicTreatmentFertilizerFormControlComponent,
                        TreatmentFertilizerFormControlComponent,
                        TreatmentFertilizerFormComponent,
                        DynamicTreatmentFertilizersFormControlComponent,
                        TreatmentFertilizersFormControlComponent,
                        TreatmentFertilizersFormComponent,
                        DynamicTreatmentIrrigationFormControlComponent,
                        TreatmentIrrigationFormControlComponent,
                        TreatmentIrrigationFormComponent,
                        DynamicTreatmentPesticideFormControlComponent,
                        TreatmentPesticideFormControlComponent,
                        TreatmentPesticideFormComponent,
                        DynamicTreatmentPesticidesFormControlComponent,
                        TreatmentPesticidesFormControlComponent,
                        TreatmentPesticidesFormComponent,
                        DynamicTreatmentSeedFormControlComponent,
                        TreatmentSeedFormControlComponent,
                        TreatmentSeedFormComponent,
                        DynamicTreatmentSeedsFormControlComponent,
                        TreatmentSeedsFormControlComponent,
                        TreatmentSeedsFormComponent,
                        DynamicMachineCardElementFormControlComponent,
                        MachineCardElementFormControlComponent,
                        MachineCardElementFormComponent,
                        DynamicMachineCardElementsFormControlComponent,
                        MachineCardElementsFormControlComponent,
                        MachineCardElementsFormComponent,
                        DynamicAclPermissionFormControlComponent,
                        AclPermissionFormControlComponent,
                        AclPermissionFormComponent,
                        DynamicAclPermissionsFormControlComponent,
                        AclPermissionsFormControlComponent,
                        AclPermissionsFormComponent,
                        DynamicMachineAlarmConfElementFormControlComponent,
                        MachineAlarmConfElementFormControlComponent,
                        MachineAlarmConfElementFormComponent,
                        DynamicMachineAlarmConfElementsFormControlComponent,
                        MachineAlarmConfElementsFormControlComponent,
                        MachineAlarmConfElementsFormComponent
                    ],
                    entryComponents: [
                        DynamicButtonFormControlComponent,
                        DynamicMapAreaSelectFormControlComponent,
                        DynamicMapFormControlComponent,
                        DynamicFileFormControlComponent,
                        DynamicFileSharingFormControlComponent,
                        DynamicFarmAuditRequirementFormControlComponent,
                        DynamicFieldAuditAreaFormControlComponent,
                        DynamicNumericConditionControlComponent,
                        FileFormControlComponent,
                        DynamicDictionaryFormControlComponent,
                        DynamicMultiSelectFormControlComponent,
                        DynamicCadastralRegisterFormControlComponent,
                        DynamicCadastralRegisterNameFormControlComponent,
                        DynamicCadastralRegisterMapFormControlComponent,
                        DynamicMapCultivationAreaFormControlComponent,
                        DynamicMapCultivationAreaEditFormControlComponent,
                        DynamicDualListFormControlComponent,
                        DynamicEmployeeSalaryFormControlComponent,
                        DynamicEmployeeSalariesFormControlComponent,
                        DynamicPeriodFormControlComponent,
                        DynamicPeriodsFormControlComponent,
                        DynamicCommissionedAuditResultFormControlComponent,
                        DynamicProductDeliveryFormControlComponent,
                        DynamicSupplierAwardFormControlComponent,
                        DynamicSupplierAwardsFormControlComponent,
                        DynamicTreatmentFertilizerFormControlComponent,
                        DynamicTreatmentFertilizersFormControlComponent,
                        DynamicTreatmentIrrigationFormControlComponent,
                        DynamicTreatmentPesticideFormControlComponent,
                        DynamicTreatmentPesticidesFormControlComponent,
                        DynamicTreatmentSeedFormControlComponent,
                        DynamicTreatmentSeedsFormControlComponent,
                        DynamicMachineCardElementFormControlComponent,
                        DynamicMachineCardElementsFormControlComponent,
                        DynamicAclPermissionFormControlComponent,
                        DynamicAclPermissionsFormControlComponent,
                        DynamicMachineAlarmConfElementFormControlComponent,
                        DynamicMachineAlarmConfElementsFormControlComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        DynamicFormsCoreModule,
                        DynamicFormsNGBootstrapUIModule,
                        NgSelectModule,
                        TranslationModule,
                        SpinnerModule,
                        PanelSharedModule,
                        ReactiveFormsModule,
                        GoogleMapsSharedModule,
                        PureGoogleMapsSharedModule,
                        GeolocationModule,
                        GalleryModule,
                        LightboxModule.withConfig({
                            keyboardShortcuts: false,
                            panelClass: 'fullscreen'
                        }),
                    ],
                    exports: [
                        FormComponent,
                        SearchFlatFormComponent,
                        SearchFormComponent,
                        SimpleFormComponent,
                        AddFormComponent,
                        DynamicButtonFormControlComponent,
                        DynamicDualListFormControlComponent,
                        DynamicFileFormControlComponent,
                        DynamicFileSharingFormControlComponent,
                        DynamicFarmAuditRequirementFormControlComponent,
                        DynamicFieldAuditAreaFormControlComponent,
                        DynamicEmployeeSalaryFormControlComponent,
                        DynamicEmployeeSalariesFormControlComponent,
                        DynamicNumericConditionControlComponent,
                        DynamicFormsCoreModule,
                        DynamicFormsNGBootstrapUIModule,
                        ReactiveFormsModule,
                        FileFormControlComponent,
                        NumericConditionControlComponent,
                        DynamicDictionaryFormControlComponent,
                        DynamicMultiSelectFormControlComponent,
                        DynamicPeriodFormControlComponent,
                        DynamicPeriodsFormControlComponent,
                        DynamicCommissionedAuditResultFormControlComponent,
                        DynamicProductDeliveryFormControlComponent,
                        DynamicSupplierAwardFormControlComponent,
                        DynamicSupplierAwardsFormControlComponent,
                        DynamicTreatmentFertilizerFormControlComponent,
                        DynamicTreatmentFertilizersFormControlComponent,
                        DynamicTreatmentIrrigationFormControlComponent,
                        DynamicTreatmentPesticideFormControlComponent,
                        DynamicTreatmentPesticidesFormControlComponent,
                        DynamicTreatmentSeedFormControlComponent,
                        DynamicTreatmentSeedsFormControlComponent,
                        DynamicMachineCardElementFormControlComponent,
                        DynamicMachineCardElementsFormControlComponent,
                        DynamicAclPermissionFormControlComponent,
                        DynamicAclPermissionsFormControlComponent,
                        DynamicMachineAlarmConfElementFormControlComponent,
                        DynamicMachineAlarmConfElementsFormControlComponent
                    ],
                    providers: [
                        {
                            provide: DYNAMIC_FORM_CONTROL_MAP_FN,
                            useFactory: controlMapFnFactory
                        },
                        {
                            provide: DYNAMIC_FORM_MODEL_MAP_FN,
                            useFactory: modelMapFnFactory
                        },
                        {
                            provide: DynamicFormService,
                            useClass: CustomDynamicFormService
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ0$a
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ1
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ2
                        },
                        {
                            provide: NG_VALIDATORS,
                            useValue: ɵ3,
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useValue: ɵ4,
                            multi: true
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ5
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ6
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ7
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ8
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ9
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ10
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ11
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ12
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ13
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ14
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ15
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ16
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ17
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ18
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: ɵ19
                        },
                        {
                            provide: DYNAMIC_VALIDATORS,
                            useValue: validatorsMap
                        }
                    ]
                },] }
    ];
    return FormSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SatelliteSharedModule = /** @class */ (function () {
    function SatelliteSharedModule() {
    }
    SatelliteSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SatelliteImageryComponent,
                        MessageTranslationPipe
                    ],
                    imports: [
                        CommonModule,
                        PanelSharedModule,
                        SpinnerModule,
                        TranslationModule,
                        SatelliteServicesModule,
                        FormSharedModule,
                        NgbdDatepickerRangeModule,
                        GalleryModule,
                        LightboxModule.withConfig({
                            keyboardShortcuts: false,
                            panelClass: 'fullscreen'
                        })
                    ],
                    exports: [
                        SatelliteImageryComponent
                    ]
                },] }
    ];
    return SatelliteSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherServicesModule = /** @class */ (function () {
    function WeatherServicesModule() {
    }
    WeatherServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return WeatherServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherStationForecastService = /** @class */ (function () {
    function WeatherStationForecastService(openweathermapProxyService, notificationService) {
        this.openweathermapProxyService = openweathermapProxyService;
        this.notificationService = notificationService;
    }
    /**
     * @param {?} lon
     * @param {?} lat
     * @param {?} cnt
     * @return {?}
     */
    WeatherStationForecastService.prototype.getUVForecast = /**
     * @param {?} lon
     * @param {?} lat
     * @param {?} cnt
     * @return {?}
     */
    function (lon, lat, cnt) {
        var _this = this;
        return this.openweathermapProxyService.getUVForecast(lon, lat, cnt)
            .pipe(catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.notificationService.error(error, "SHARED.WEATHER.API.uvForecast:errorMessage");
            return of(null);
        })));
    };
    /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    WeatherStationForecastService.prototype.getUVCurrentValue = /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    function (lon, lat) {
        var _this = this;
        return this.openweathermapProxyService.getUVCurrentValue(lon, lat)
            .pipe(catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.notificationService.error(error, "SHARED.WEATHER.API.uvCurrentValue:errorMessage");
            return of(null);
        })));
    };
    /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    WeatherStationForecastService.prototype.getForecast = /**
     * @param {?} lon
     * @param {?} lat
     * @return {?}
     */
    function (lon, lat) {
        var _this = this;
        return this.openweathermapProxyService.getForecast(lon, lat)
            .pipe(catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.notificationService.error(error, "SHARED.WEATHER.API.forecast:errorMessage");
            return of(null);
        })), map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response && response.list; })));
    };
    WeatherStationForecastService.decorators = [
        { type: Injectable, args: [{
                    providedIn: WeatherServicesModule
                },] }
    ];
    /** @nocollapse */
    WeatherStationForecastService.ctorParameters = function () { return [
        { type: OpenweathermapProxyService },
        { type: NotificationService }
    ]; };
    /** @nocollapse */ WeatherStationForecastService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WeatherStationForecastService_Factory() { return new WeatherStationForecastService(ɵɵinject(OpenweathermapProxyService), ɵɵinject(NotificationService)); }, token: WeatherStationForecastService, providedIn: WeatherServicesModule });
    return WeatherStationForecastService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WeatherStationForecastService.prototype.openweathermapProxyService;
    /**
     * @type {?}
     * @private
     */
    WeatherStationForecastService.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherForecastComponent = /** @class */ (function () {
    function WeatherForecastComponent(weatherStationForecastService) {
        this.weatherStationForecastService = weatherStationForecastService;
        this.unsubscribe$ = new Subject();
        this.numerOfdays = 5;
        this.displaySpinnerSubject = new BehaviorSubject(true);
        this.displaySpinner$ = this.displaySpinnerSubject.asObservable();
    }
    /**
     * @return {?}
     */
    WeatherForecastComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.position != null) {
            this.data$ = this.weatherStationForecastService.getForecast(this.position.lng, this.position.lat)
                .pipe(takeUntil(this.unsubscribe$), finalize((/**
             * @return {?}
             */
            function () {
                _this.displaySpinnerSubject.next(false);
            })));
        }
    };
    /**
     * @return {?}
     */
    WeatherForecastComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    WeatherForecastComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-weather-forecast',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\" *ngIf=\"position; else emptyPosition\">\r\n                <label class=\"px-0\">\r\n                    <h5 class=\"m-0\">\r\n                        <i class=\"ft ft-cloud\"></i> {{ 'SHARED.WEATHER.FORECAST.forecast:title' | translate }}\r\n                    </h5>\r\n                </label>\r\n                <hr class=\"mt-0\" />\r\n                <div class=\"alert alert-info\" role=\"alert\">\r\n                    {{ 'SHARED.WEATHER.FORECAST.info:message' | translate: { days: numerOfdays, hours: 3 } }}\r\n                </div>\r\n                <div>\r\n                    <app-weather-forecast-chart [data]=\"data$ | async\"></app-weather-forecast-chart>\r\n                </div>\r\n            </div>\r\n            <ng-template #emptyPosition>\r\n                <div class=\"card-body\">\r\n                    <div class=\"alert alert-info\" role=\"alert\">\r\n                        {{ 'SHARED.WEATHER.FORECAST.missingPosition:message' | translate }}\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    WeatherForecastComponent.ctorParameters = function () { return [
        { type: WeatherStationForecastService }
    ]; };
    WeatherForecastComponent.propDecorators = {
        position: [{ type: Input }]
    };
    return WeatherForecastComponent;
}());
if (false) {
    /** @type {?} */
    WeatherForecastComponent.prototype.position;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastComponent.prototype.unsubscribe$;
    /** @type {?} */
    WeatherForecastComponent.prototype.data$;
    /** @type {?} */
    WeatherForecastComponent.prototype.numerOfdays;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastComponent.prototype.displaySpinnerSubject;
    /** @type {?} */
    WeatherForecastComponent.prototype.displaySpinner$;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastComponent.prototype.weatherStationForecastService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var WEATHER_STATION_MEASUREMENT_TYPES_KEY = 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.';
var WeatherForecastChartComponent = /** @class */ (function () {
    function WeatherForecastChartComponent(translateService, ngZone, changeDetectorRef) {
        this.translateService = translateService;
        this.ngZone = ngZone;
        this.changeDetectorRef = changeDetectorRef;
        this.unsubscribe$ = new Subject();
        this.customTooltips = (/**
         * @param {?} data
         * @param {?} windSpeedLabel
         * @return {?}
         */
        function (data, windSpeedLabel) { return (/**
         * @param {?} tooltip
         * @return {?}
         */
        function (tooltip) {
            // Tooltip Element
            /** @type {?} */
            var tooltipEl = document.getElementById('chartjs-tooltip');
            if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip';
                tooltipEl.innerHTML = '<table></table>';
                this._chart.canvas.parentNode.appendChild(tooltipEl);
            }
            // Hide if no tooltip
            if (tooltip.opacity === 0) {
                tooltipEl.style.opacity = '0';
                return;
            }
            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltip.yAlign) {
                tooltipEl.classList.add(tooltip.yAlign);
            }
            else {
                tooltipEl.classList.add('no-transform');
            }
            /**
             * @param {?} bodyItem
             * @return {?}
             */
            function getBody(bodyItem) {
                return bodyItem.lines;
            }
            // Set Text
            if (tooltip.body) {
                /** @type {?} */
                var index = tooltip.dataPoints[0].index;
                /** @type {?} */
                var row = data[index];
                /** @type {?} */
                var titleLines = tooltip.title || [];
                /** @type {?} */
                var bodyLines = tooltip.body.map(getBody);
                /** @type {?} */
                var innerHtml_1 = '<thead>';
                titleLines.forEach((/**
                 * @param {?} title
                 * @return {?}
                 */
                function (title) {
                    innerHtml_1 += '<tr><th colspan="2" class="text-center">' + title + '</th></tr>';
                }));
                innerHtml_1 += '</thead><tbody>';
                innerHtml_1 += '<tr><td rowspan="4"><img src="http://openweathermap.org/img/wn/' + row.weather[0].icon + '.png" /></td></tr>';
                bodyLines.forEach((/**
                 * @param {?} body
                 * @param {?} i
                 * @return {?}
                 */
                function (body, i) {
                    innerHtml_1 += '<tr><td class="no-wrap">' + body + '</td></tr>';
                }));
                innerHtml_1 += '<tr><td class="no-wrap">' + windSpeedLabel + ': ' + row.wind.speed + '</td></tr>';
                innerHtml_1 += '</tbody>';
                /** @type {?} */
                var tableRoot = tooltipEl.querySelector('table');
                tableRoot.innerHTML = innerHtml_1;
            }
            /** @type {?} */
            var positionY = this._chart.canvas.offsetTop;
            /** @type {?} */
            var positionX = this._chart.canvas.offsetLeft;
            // Display, position, and set styles for font
            tooltipEl.style.opacity = '1';
            tooltipEl.style.left = positionX + tooltip.caretX + 'px';
            tooltipEl.style.top = positionY + tooltip.caretY + 'px';
            tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
            tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
            tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
            tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
        }); });
    }
    /**
     * @return {?}
     */
    WeatherForecastChartComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // refresh chart when language was changed
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.refresh(_this.data);
            _this.changeDetectorRef.markForCheck();
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.chartRef.update();
            }));
        }));
    };
    /**
     * @return {?}
     */
    WeatherForecastChartComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    WeatherForecastChartComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.data) {
            this.refresh(changes.data.currentValue);
        }
    };
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    WeatherForecastChartComponent.prototype.refresh = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.chartData = [
            {
                data: this.createDataForTemperature(data),
                label: this.getLabel(WeatherStationMeasurementTypes.AirTemperature)
            },
            {
                data: this.createDataForHumidity(data),
                label: this.getLabel(WeatherStationMeasurementTypes.AirHumidity),
                yAxisID: 'y-axis-1'
            }
        ];
        this.chartOptions = {
            responsive: true,
            tooltips: {
                enabled: false,
                mode: 'index',
                position: 'nearest',
                custom: this.customTooltips(this.data, this.getLabel(WeatherStationMeasurementTypes.WindSpeed))
            },
            scales: {
                xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: DateTime.DATETIME_MED,
                            displayFormats: { hour: (/** @type {?} */ ({
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    hour12: false,
                                    weekday: 'long',
                                })) },
                            unit: 'hour',
                            unitStepSize: 12
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        type: 'linear',
                        position: 'left',
                        ticks: {
                            callback: (/**
                             * @param {?} value
                             * @param {?} index
                             * @param {?} values
                             * @return {?}
                             */
                            function (value, index, values) { return value + ' ℃'; })
                        }
                    },
                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        position: 'right',
                        ticks: {
                            callback: (/**
                             * @param {?} value
                             * @param {?} index
                             * @param {?} values
                             * @return {?}
                             */
                            function (value, index, values) { return value + ' %'; })
                        }
                    }
                ]
            }
        };
    };
    /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    WeatherForecastChartComponent.prototype.createDataForTemperature = /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    function (measurements) {
        return (measurements || []).map((/**
         * @param {?} m
         * @return {?}
         */
        function (m) {
            return {
                x: DateTime.fromSeconds(m.dt).toISO(),
                y: m.main.temp
            };
        }));
    };
    /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    WeatherForecastChartComponent.prototype.createDataForHumidity = /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    function (measurements) {
        return (measurements || []).map((/**
         * @param {?} m
         * @return {?}
         */
        function (m) {
            return {
                x: DateTime.fromSeconds(m.dt).toISO(),
                y: m.main.humidity
            };
        }));
    };
    /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    WeatherForecastChartComponent.prototype.getLabel = /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    function (measure) {
        return this.translateService.instant(WEATHER_STATION_MEASUREMENT_TYPES_KEY + WeatherStationMeasurementTypes[measure]);
    };
    WeatherForecastChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-weather-forecast-chart',
                    template: "<div *ngIf=\"data; else emptyData\" class=\"chart-container\">\r\n    <canvas\r\n        *ngIf=\"data.length !== 0; else emptyData\"\r\n        baseChart\r\n        [chartType]=\"'line'\"\r\n        [datasets]=\"chartData\"\r\n        [options]=\"chartOptions\"\r\n        [legend]=\"true\"\r\n    ></canvas>\r\n</div>\r\n<ng-template #emptyData>\r\n    <div class=\"text-center align-self-center\">\r\n        {{ 'SHARED.WEATHER.FORECAST.missingForecast:message' | translate }}\r\n    </div>\r\n</ng-template>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".chart-container{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center}canvas{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}"]
                }] }
    ];
    /** @nocollapse */
    WeatherForecastChartComponent.ctorParameters = function () { return [
        { type: TranslateService },
        { type: NgZone },
        { type: ChangeDetectorRef }
    ]; };
    WeatherForecastChartComponent.propDecorators = {
        chartRef: [{ type: ViewChild, args: [BaseChartDirective, { static: false },] }],
        data: [{ type: Input }]
    };
    return WeatherForecastChartComponent;
}());
if (false) {
    /** @type {?} */
    WeatherForecastChartComponent.prototype.chartOptions;
    /** @type {?} */
    WeatherForecastChartComponent.prototype.chartData;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastChartComponent.prototype.chartRef;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastChartComponent.prototype.unsubscribe$;
    /** @type {?} */
    WeatherForecastChartComponent.prototype.data;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastChartComponent.prototype.customTooltips;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastChartComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastChartComponent.prototype.ngZone;
    /**
     * @type {?}
     * @private
     */
    WeatherForecastChartComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var NUMBER_OF_DAYS = 8;
var WeatherIndexUvComponent = /** @class */ (function () {
    function WeatherIndexUvComponent(weatherStationForecastService) {
        this.weatherStationForecastService = weatherStationForecastService;
        this.unsubscribe$ = new Subject();
        this.numerOfdays = NUMBER_OF_DAYS;
    }
    /**
     * @return {?}
     */
    WeatherIndexUvComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.position != null) {
            this.uvIndexData$ = this.weatherStationForecastService.getUVForecast(this.position.lng, this.position.lat, NUMBER_OF_DAYS)
                .pipe(takeUntil(this.unsubscribe$));
            this.currentUVIndex$ = this.weatherStationForecastService.getUVCurrentValue(this.position.lng, this.position.lat)
                .pipe(map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x && x.value; })), takeUntil(this.unsubscribe$));
        }
    };
    /**
     * @return {?}
     */
    WeatherIndexUvComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    WeatherIndexUvComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-weather-index-uv',
                    template: "<div>\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\" *ngIf=\"position; else emptyPosition\">\r\n                <label class=\"px-0\">\r\n                    <h5 class=\"m-0\"><i class=\"ft ft-sun\"></i> {{ 'SHARED.WEATHER.UV_INDEX.currentValue:title' | translate }}</h5>\r\n                </label>\r\n                <hr class=\"mt-0\" />\r\n                <div class=\"pb-4\">\r\n                    <strong>{{ 'SHARED.WEATHER.UV_INDEX.currentValue:label' | translate }}</strong>: <span>{{ (currentUVIndex$ | async) }}</span>\r\n                </div>\r\n                <label class=\"px-0\">\r\n                    <h5 class=\"m-0\"><i class=\"ft ft-activity\"></i> {{ 'SHARED.WEATHER.UV_INDEX.forecast:title' | translate:{ days: numerOfdays } }}</h5>\r\n                </label>\r\n                <hr class=\"mt-0\" />\r\n                <div>\r\n                    <app-weather-index-uv-chart [data]=\"uvIndexData$ | async\"></app-weather-index-uv-chart>\r\n                </div>\r\n            </div>\r\n            <ng-template #emptyPosition>\r\n                <div class=\"card-body\">\r\n                    <div class=\"alert alert-info\" role=\"alert\">\r\n                        {{ 'SHARED.WEATHER.UV_INDEX.missingPosition:message' | translate }}\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    WeatherIndexUvComponent.ctorParameters = function () { return [
        { type: WeatherStationForecastService }
    ]; };
    WeatherIndexUvComponent.propDecorators = {
        position: [{ type: Input }]
    };
    return WeatherIndexUvComponent;
}());
if (false) {
    /** @type {?} */
    WeatherIndexUvComponent.prototype.position;
    /**
     * @type {?}
     * @private
     */
    WeatherIndexUvComponent.prototype.unsubscribe$;
    /** @type {?} */
    WeatherIndexUvComponent.prototype.uvIndexData$;
    /** @type {?} */
    WeatherIndexUvComponent.prototype.currentUVIndex$;
    /** @type {?} */
    WeatherIndexUvComponent.prototype.numerOfdays;
    /**
     * @type {?}
     * @private
     */
    WeatherIndexUvComponent.prototype.weatherStationForecastService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherIndexUvChartComponent = /** @class */ (function () {
    function WeatherIndexUvChartComponent(translateService, ngZone) {
        this.translateService = translateService;
        this.ngZone = ngZone;
        this.unsubscribe$ = new Subject();
    }
    /**
     * @return {?}
     */
    WeatherIndexUvChartComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // refresh chart when language was changed
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.chartRef.update();
            }));
        }));
    };
    /**
     * @return {?}
     */
    WeatherIndexUvChartComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    WeatherIndexUvChartComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.data) {
            /** @type {?} */
            var data = this.createData(changes.data.currentValue);
            this.chartData = [
                { data: data }
            ];
            this.chartOptions = {
                responsive: true,
                scales: {
                    xAxes: [{
                            type: 'time',
                            time: {
                                tooltipFormat: DateTime.DATE_MED,
                                displayFormats: { day: 'cccc' },
                                unit: 'day',
                                unitStepSize: 1
                            }
                        }],
                    yAxes: [
                        this.createYAxisTicks([])
                    ]
                }
            };
        }
    };
    /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    WeatherIndexUvChartComponent.prototype.createData = /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    function (measurements) {
        return (measurements || []).map((/**
         * @param {?} m
         * @return {?}
         */
        function (m) {
            return {
                x: DateTime.fromISO(m.date_iso).toISODate(),
                y: m.value
            };
        }));
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    WeatherIndexUvChartComponent.prototype.createYAxisTicks = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} measurements
     * @return {?}
     */
    function (measurements) {
        return measurements.length > 0 ? {} : {
            beginAtZero: true,
            min: 0.0,
            stepValue: 1,
            max: 11.0
        };
    };
    WeatherIndexUvChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-weather-index-uv-chart',
                    template: "<div *ngIf=\"data; else emptyData\" class=\"chart-container\">\r\n    <canvas\r\n        *ngIf=\"data.length !== 0; else emptyData\"\r\n        baseChart\r\n        [chartType]=\"'line'\"\r\n        [datasets]=\"chartData\"\r\n        [options]=\"chartOptions\"\r\n        [legend]=\"false\"\r\n    ></canvas>\r\n</div>\r\n<ng-template #emptyData>\r\n    <div class=\"text-center align-self-center\">\r\n        {{ 'SHARED.WEATHER.UV_INDEX.missingForecast:message' | translate }}\r\n    </div>\r\n</ng-template>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".chart-container{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center}"]
                }] }
    ];
    /** @nocollapse */
    WeatherIndexUvChartComponent.ctorParameters = function () { return [
        { type: TranslateService },
        { type: NgZone }
    ]; };
    WeatherIndexUvChartComponent.propDecorators = {
        chartRef: [{ type: ViewChild, args: [BaseChartDirective, { static: false },] }],
        data: [{ type: Input }]
    };
    return WeatherIndexUvChartComponent;
}());
if (false) {
    /** @type {?} */
    WeatherIndexUvChartComponent.prototype.chartOptions;
    /** @type {?} */
    WeatherIndexUvChartComponent.prototype.chartData;
    /**
     * @type {?}
     * @private
     */
    WeatherIndexUvChartComponent.prototype.chartRef;
    /**
     * @type {?}
     * @private
     */
    WeatherIndexUvChartComponent.prototype.unsubscribe$;
    /** @type {?} */
    WeatherIndexUvChartComponent.prototype.data;
    /**
     * @type {?}
     * @private
     */
    WeatherIndexUvChartComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    WeatherIndexUvChartComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherCurrentDataComponent = /** @class */ (function () {
    function WeatherCurrentDataComponent(weatherStationForecastService) {
        this.weatherStationForecastService = weatherStationForecastService;
        this.displaySpinner$ = new BehaviorSubject(false);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    WeatherCurrentDataComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var _this = this;
        if (changes && changes.position && changes.position.currentValue) {
            this.displaySpinner$.next(true);
            this.data$ = this.weatherStationForecastService.getForecast(this.position.lng, this.position.lat)
                .pipe(finalize((/**
             * @return {?}
             */
            function () {
                _this.displaySpinner$.next(false);
            })));
        }
    };
    WeatherCurrentDataComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-weather-current-data',
                    template: "<div class=\"main-container\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <!-- <div *ngIf=\"(data$ | async) as data\">\r\n        <div class=\"weather-value\">\r\n            <div class=\"row\">\r\n                <div class=\"col-4\">\r\n                    <label>\r\n                        <i class=\"ft ft-calendar pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.date' | translate) + ':' }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"col-8\">\r\n                    <h4 class=\"m-0\">\r\n                        {{ data[0].dt_txt }}\r\n                    </h4>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"weather-value\">\r\n            <label>\r\n                <i class=\"ft ft-thermometer pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.airTemperature' | translate) + ':' }}\r\n            </label>\r\n            <h4 class=\"m-0\">\r\n                {{ data[0].main.temp | temperature}}\r\n            </h4>\r\n        </div>\r\n        <div class=\"weather-value\">\r\n            <label>\r\n                <i class=\"ft ft-download-cloud pr-1\"></i> {{ ('SHARED.WEATHER.FORECAST.airPressure' | translate) + ':'}}\r\n            </label>\r\n            <h4 class=\"m-0\">\r\n                {{ data[0].main.pressure + ' hPa'}}\r\n            </h4>\r\n        </div>\r\n        <div class=\"weather-value\">\r\n            <label>\r\n                <i class=\"ft ft-droplet pr-1\"></i> {{ ('SHARED.WEATHER.FORECAST.airHumidity' | translate) + ':'}}\r\n            </label>\r\n            <h4 class=\"\">\r\n                {{ data[0].main.humidity | airHumidity}}\r\n            </h4>\r\n        </div>\r\n        <div class=\"weather-value\">\r\n            <label>\r\n                <i class=\"ft ft-wind pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.WindSpeed' | translate) + ':'}}\r\n            </label>\r\n            <h4 class=\"m-0\">\r\n                {{ (data[0].wind.speed | number: '1.0-2') + ' m/s'}}\r\n            </h4>\r\n        </div>\r\n        <div class=\"weather-value\">\r\n            <label>\r\n                <i class=\"ft ft-compass pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.WindDirection' | translate) + ':'}}\r\n            </label>\r\n            <h4 class=\"m-0\">\r\n                {{ (data[0].wind.deg | number: '1.0-2') + ' \u00B0'}}\r\n            </h4>\r\n        </div>\r\n    </div> -->\r\n    <div *ngIf=\"(data$ | async) as data\">\r\n        <table>\r\n            <tr>\r\n                <td>\r\n                    <label>\r\n                        <i class=\"ft ft-calendar pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.date' | translate) + ':' }}\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <h4 class=\"m-0\">\r\n                        {{ data[0].dt_txt }}\r\n                    </h4>\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>\r\n                    <label>\r\n                        <i\r\n                            class=\"ft ft-thermometer pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.airTemperature' | translate) + ':' }}\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <h4 class=\"m-0\">\r\n                        {{ data[0].main.temp | temperature}}\r\n                    </h4>\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>\r\n                    <label>\r\n                        <i class=\"ft ft-download-cloud pr-1\"></i>\r\n                        {{ ('SHARED.WEATHER.FORECAST.airPressure' | translate) + ':'}}\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <h4 class=\"m-0\">\r\n                        {{ data[0].main.pressure + ' hPa'}}\r\n                    </h4>\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>\r\n                    <label>\r\n                        <i class=\"ft ft-droplet pr-1\"></i>\r\n                        {{ ('SHARED.WEATHER.FORECAST.airHumidity' | translate) + ':'}}\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <h4 class=\"m-0\">\r\n                        {{ data[0].main.humidity | airHumidity}}\r\n                    </h4>\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>\r\n                    <label>\r\n                        <i class=\"ft ft-wind pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.WindSpeed' | translate) + ':'}}\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <h4 class=\"m-0\">\r\n                        {{ (data[0].wind.speed | number: '1.0-2') + ' m/s'}}\r\n                    </h4>\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>\r\n                    <label>\r\n                        <i\r\n                            class=\"ft ft-compass pr-1\"></i>{{ ('SHARED.WEATHER.FORECAST.WindDirection' | translate) + ':'}}\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <h4 class=\"m-0\">\r\n                        {{ (data[0].wind.deg | number: '1.0-2') + ' \u00B0'}}\r\n                    </h4>\r\n                </td>\r\n            </tr>\r\n        </table>\r\n    </div>\r\n    <div class=\"error-container d-flex align-items-center justify-content-center\" *ngIf=\"!(data$ | async)\">\r\n        <h4>{{ translationKeyPrefix + '.noData' | translate }}</h4>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".main-container{overflow:auto}.main-container .weather-value{margin-bottom:10px}.main-container table td{padding:3px}.main-container table h4{font-weight:500;letter-spacing:.05rem;font-size:1.1rem;color:grey}.main-container .error-container{height:244px}"]
                }] }
    ];
    /** @nocollapse */
    WeatherCurrentDataComponent.ctorParameters = function () { return [
        { type: WeatherStationForecastService }
    ]; };
    WeatherCurrentDataComponent.propDecorators = {
        position: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }]
    };
    return WeatherCurrentDataComponent;
}());
if (false) {
    /** @type {?} */
    WeatherCurrentDataComponent.prototype.position;
    /** @type {?} */
    WeatherCurrentDataComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    WeatherCurrentDataComponent.prototype.displaySpinner$;
    /** @type {?} */
    WeatherCurrentDataComponent.prototype.data$;
    /**
     * @type {?}
     * @private
     */
    WeatherCurrentDataComponent.prototype.weatherStationForecastService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherSharedModule = /** @class */ (function () {
    function WeatherSharedModule() {
    }
    WeatherSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        WeatherForecastComponent,
                        WeatherForecastChartComponent,
                        WeatherIndexUvComponent,
                        WeatherIndexUvChartComponent,
                        WeatherCurrentDataComponent
                    ],
                    imports: [
                        CommonModule,
                        PanelSharedModule,
                        SpinnerModule,
                        TranslationModule,
                        ChartsModule,
                        WeatherServicesModule,
                        PipesModule
                    ],
                    exports: [
                        WeatherForecastComponent,
                        WeatherIndexUvComponent,
                        WeatherCurrentDataComponent
                    ]
                },] }
    ];
    return WeatherSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MeteogramComponent = /** @class */ (function () {
    function MeteogramComponent() {
    }
    /**
     * @return {?}
     */
    MeteogramComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    MeteogramComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    MeteogramComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-meteogram',
                    template: "<div>\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"alert alert-info\" role=\"alert\">\r\n                    {{ 'SHARED.WEATHER.METEOGRAM.info:message' | translate }}\r\n                </div>\r\n                <label class=\"px-0 m-3\">\r\n                    <h5 class=\"m-0\">\r\n                        <i class=\"ft ft-cloud\"></i> {{ 'SHARED.WEATHER.METEOGRAM.meteogram:title' | translate }}\r\n                    </h5>\r\n                </label>\r\n                <hr class=\"mt-0\" />\r\n                <div class=\"text-center m-5\">\r\n                    <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/meteogram.png\" alt=\"meteogram\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    MeteogramComponent.ctorParameters = function () { return []; };
    return MeteogramComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MeteogramSharedModule = /** @class */ (function () {
    function MeteogramSharedModule() {
    }
    MeteogramSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        MeteogramComponent
                    ],
                    imports: [
                        CommonModule,
                        PanelSharedModule,
                        SpinnerModule,
                        TranslationModule,
                    ],
                    exports: [
                        MeteogramComponent
                    ]
                },] }
    ];
    return MeteogramSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DiseaseModelsComponent = /** @class */ (function () {
    function DiseaseModelsComponent() {
    }
    /**
     * @return {?}
     */
    DiseaseModelsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    DiseaseModelsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    DiseaseModelsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-disease-models',
                    template: "<div>\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"alert alert-info\" role=\"alert\">\r\n                    {{ 'SHARED.DISEASEMODELS.DISEASEMODELS.info:message' | translate }}\r\n                </div>\r\n                <label class=\"px-0 m-3\">\r\n                    <h5 class=\"m-0\">\r\n                        <i class=\"ft ft-file\"></i>\r\n                        {{ 'SHARED.DISEASEMODELS.DISEASEMODELS.diseaseModels:raport' | translate }}\r\n                    </h5>\r\n                </label>\r\n                <hr class=\"mt-0\" />\r\n                <div class=\"col-12 m-3\">\r\n                    <table>\r\n                        <thead>\r\n                            <tr>\r\n                                <th>Gatunek</th>\r\n                                <th>Choroba</th>\r\n                                <th>Warto\u015B\u0107</th>\r\n                                <th>Poziom</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr>\r\n                                <td>Ziemniak</td>\r\n                                <td>Alternarioza</td>\r\n                                <td>50</td>\r\n                                <td>Niskie ostrze\u017Cenie</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td>Ziemniak</td>\r\n                                <td>Czarna n\u00F3\u017Cka / Mokra zgnilizna</td>\r\n                                <td>0.97</td>\r\n                                <td>Brak zagro\u017Ce\u0144</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td>Ziemniak</td>\r\n                                <td>Parch srebrzysty ziemniaka</td>\r\n                                <td>2.59</td>\r\n                                <td>Brak zagro\u017Ce\u0144</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td>Ziemniak</td>\r\n                                <td>Stonka ziemniaczana</td>\r\n                                <td>50</td>\r\n                                <td>Niskie ostrze\u017Cenie</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td>Ziemniak</td>\r\n                                <td>Szara ple\u015B\u0144</td>\r\n                                <td>0</td>\r\n                                <td>Brak zagro\u017Ce\u0144</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td>Ziemniak</td>\r\n                                <td>Zaraza ziemniaka</td>\r\n                                <td>20</td>\r\n                                <td>Brak zagro\u017Ce\u0144</td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n                <label class=\"px-0 m-3\">\r\n                    <h5 class=\"m-0\">\r\n                        <i class=\"ft ft-clipboard\"></i>\r\n                        {{ 'SHARED.DISEASEMODELS.DISEASEMODELS.diseaseModels:comparison' | translate }}\r\n                    </h5>\r\n                </label>\r\n                <hr class=\"mt-0\" />\r\n                <div class=\"text-center\">\r\n                    <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/choroby1.png\" alt=\"choroby1\">\r\n                </div>\r\n                <div class=\"text-center\">\r\n                    <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/choroby2.png\" alt=\"choroby2\">\r\n                </div>\r\n                <div class=\"text-center\">\r\n                    <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/choroby3.png\" alt=\"choroby3\">\r\n                </div>\r\n                <div class=\"text-center\">\r\n                    <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/choroby4.png\" alt=\"choroby4\">\r\n                </div>\r\n                <div class=\"text-center\">\r\n                    <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/choroby5.png\" alt=\"choroby5\">\r\n                </div>\r\n                <div class=\"text-center\">\r\n                    <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/choroby6.png\" alt=\"choroby6\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["table{margin:0 auto;border:1px solid #000;border-collapse:collapse}table td,table th{border:1px solid #000;padding:10px}"]
                }] }
    ];
    /** @nocollapse */
    DiseaseModelsComponent.ctorParameters = function () { return []; };
    return DiseaseModelsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DiseaseModelsSharedModule = /** @class */ (function () {
    function DiseaseModelsSharedModule() {
    }
    DiseaseModelsSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        DiseaseModelsComponent
                    ],
                    imports: [
                        CommonModule,
                        PanelSharedModule,
                        SpinnerModule,
                        TranslationModule,
                    ],
                    exports: [
                        DiseaseModelsComponent
                    ]
                },] }
    ];
    return DiseaseModelsSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LeafMoistureComponent = /** @class */ (function () {
    function LeafMoistureComponent() {
    }
    /**
     * @return {?}
     */
    LeafMoistureComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    LeafMoistureComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    LeafMoistureComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-leaf-moisture',
                    template: "<div>\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"alert alert-info\" role=\"alert\">\r\n                    {{ 'SHARED.LEAFMOISTURE.LEAFMOISTURE.info:message' | translate }}\r\n                </div>\r\n                <div class=\"col-12 mt-4\">\r\n                    <div class=\"text-center\">\r\n                        <img src=\"https://asdevwefarmdata.blob.core.windows.net/temp/wilgotnosc.png\" alt=\"wilgotnosc\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["table{margin:0 auto;border:1px solid #000;border-collapse:collapse}table td,table th{border:1px solid #000;padding:10px}"]
                }] }
    ];
    /** @nocollapse */
    LeafMoistureComponent.ctorParameters = function () { return []; };
    return LeafMoistureComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LeafMoistureSharedModule = /** @class */ (function () {
    function LeafMoistureSharedModule() {
    }
    LeafMoistureSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        LeafMoistureComponent
                    ],
                    imports: [
                        CommonModule,
                        PanelSharedModule,
                        SpinnerModule,
                        TranslationModule,
                    ],
                    exports: [
                        LeafMoistureComponent
                    ]
                },] }
    ];
    return LeafMoistureSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Mixin that adds an initialized property to a directive which, when subscribed to, will emit a
 * value once markInitialized has been called, which should be done during the ngOnInit function.
 * If the subscription is made after it has already been marked as initialized, then it will trigger
 * an emit immediately.
 * \@docs-private
 * @record
 */
function HasInitialized() { }
if (false) {
    /**
     * Stream that emits once during the directive/component's ngOnInit.
     * @type {?}
     */
    HasInitialized.prototype.initialized;
    /**
     * Sets the state as initialized and must be called during ngOnInit to notify subscribers that
     * the directive has been initialized.
     * \@docs-private
     * @type {?}
     */
    HasInitialized.prototype._markInitialized;
}
/**
 * Mixin to augment a directive with an initialized property that will emits when ngOnInit ends.
 * @template T
 * @param {?} base
 * @return {?}
 */
function mixinInitialized(base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        // tslint:disable-next-line: no-any
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spread(args)) || this;
            /**
             * Whether this directive has been marked as initialized.
             */
            // tslint:disable-next-line: variable-name
            _this._isInitialized = false;
            /**
             * List of subscribers that subscribed before the directive was initialized. Should be notified
             * during _markInitialized. Set to null after pending subscribers are notified, and should
             * not expect to be populated after.
             */
            // tslint:disable-next-line: variable-name
            _this._pendingSubscribers = [];
            /**
             * Observable stream that emits when the directive initializes. If already initialized, the
             * subscriber is stored to be notified once _markInitialized is called.
             */
            _this.initialized = new Observable((/**
             * @param {?} subscriber
             * @return {?}
             */
            function (subscriber) {
                // If initialized, immediately notify the subscriber. Otherwise store the subscriber to notify
                // when _markInitialized is called.
                if (_this._isInitialized) {
                    _this._notifySubscriber(subscriber);
                }
                else {
                    if (_this._pendingSubscribers != null) {
                        _this._pendingSubscribers.push(subscriber);
                    }
                }
            }));
            return _this;
        }
        /**
         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
         * of ngOnInit.
         * @docs-private
         */
        /**
         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
         * of ngOnInit.
         * \@docs-private
         * @return {?}
         */
        class_1.prototype._markInitialized = /**
         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
         * of ngOnInit.
         * \@docs-private
         * @return {?}
         */
        function () {
            if (this._isInitialized) {
                throw Error('This directive has already been marked as initialized and ' +
                    'should not be called twice.');
            }
            this._isInitialized = true;
            if (this._pendingSubscribers != null) {
                this._pendingSubscribers.forEach(this._notifySubscriber);
            }
            this._pendingSubscribers = null;
        };
        /** Emits and completes the subscriber stream (should only emit once). */
        /**
         * Emits and completes the subscriber stream (should only emit once).
         * @param {?} subscriber
         * @return {?}
         */
        class_1.prototype._notifySubscriber = /**
         * Emits and completes the subscriber stream (should only emit once).
         * @param {?} subscriber
         * @return {?}
         */
        function (subscriber) {
            subscriber.next();
            subscriber.complete();
        };
        return class_1;
    }(base));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} id
 * @return {?}
 */
function getSortDuplicateSortableIdError(id) {
    return Error("Cannot have two CdkSortables with the same id (" + id + ").");
}
/**
 * @return {?}
 */
function getSortHeaderNotContainedWithinSortError() {
    return Error("CdkSortHeader must be placed within a parent element with the CdkSort directive.");
}
/**
 * @return {?}
 */
function getSortHeaderMissingIdError() {
    return Error("CdkSortHeader must be provided with a unique id.");
}
/**
 * @param {?} direction
 * @return {?}
 */
function getSortInvalidDirectionError(direction) {
    return Error(direction + " is not a valid sort direction ('asc' or 'desc').");
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Interface for a directive that holds sorting state consumed by `MatSortHeader`.
 * @record
 */
function CdkSortable() { }
if (false) {
    /**
     * The id of the column being sorted.
     * @type {?}
     */
    CdkSortable.prototype.id;
    /**
     * Starting sort direction.
     * @type {?}
     */
    CdkSortable.prototype.start;
}
/**
 * The current sort state.
 * @record
 */
function Sort() { }
if (false) {
    /**
     * The id of the column being sorted.
     * @type {?}
     */
    Sort.prototype.active;
    /**
     * The sort direction.
     * @type {?}
     */
    Sort.prototype.direction;
}
// Boilerplate for applying mixins to MatSort.
/**
 * \@docs-private
 */
var  
// Boilerplate for applying mixins to MatSort.
/**
 * \@docs-private
 */
MatSortBase = /** @class */ (function () {
    function MatSortBase() {
    }
    return MatSortBase;
}());
// tslint:disable-next-line: variable-name
/** @type {?} */
var _MatSortMixinBase = mixinInitialized(MatSortBase);
var CdkSort = /** @class */ (function (_super) {
    __extends(CdkSort, _super);
    function CdkSort() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Collection of all registered sortables that this directive manages.
         */
        _this.sortables = new Map();
        /**
         * Used to notify any child components listening to state changes.
         */
        // tslint:disable-next-line: variable-name
        _this._stateChanges = new Subject();
        /**
         * The direction to set when an MatSortable is initially sorted.
         * May be overriden by the MatSortable's sort start.
         */
        // tslint:disable-next-line: no-input-rename
        _this.start = 'asc';
        // tslint:disable-next-line: variable-name
        _this._direction = '';
        /**
         * Event emitted when the user changes either the active sort or sort direction.
         */
        // tslint:disable-next-line: no-output-rename
        _this.sortChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(CdkSort.prototype, "direction", {
        /** The sort direction of the currently active MatSortable. */
        get: /**
         * The sort direction of the currently active MatSortable.
         * @return {?}
         */
        function () { return this._direction; },
        set: /**
         * @param {?} direction
         * @return {?}
         */
        function (direction) {
            if (isDevMode() && direction && direction !== 'asc' && direction !== 'desc') {
                throw getSortInvalidDirectionError(direction);
            }
            this._direction = direction;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register function to be used by the contained MatSortables. Adds the MatSortable to the
     * collection of MatSortables.
     */
    /**
     * Register function to be used by the contained MatSortables. Adds the MatSortable to the
     * collection of MatSortables.
     * @param {?} sortable
     * @return {?}
     */
    CdkSort.prototype.register = /**
     * Register function to be used by the contained MatSortables. Adds the MatSortable to the
     * collection of MatSortables.
     * @param {?} sortable
     * @return {?}
     */
    function (sortable) {
        if (!sortable.id) {
            throw getSortHeaderMissingIdError();
        }
        if (this.sortables.has(sortable.id)) {
            throw getSortDuplicateSortableIdError(sortable.id);
        }
        this.sortables.set(sortable.id, sortable);
    };
    /**
     * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
     * collection of contained MatSortables.
     */
    /**
     * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
     * collection of contained MatSortables.
     * @param {?} sortable
     * @return {?}
     */
    CdkSort.prototype.deregister = /**
     * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
     * collection of contained MatSortables.
     * @param {?} sortable
     * @return {?}
     */
    function (sortable) {
        this.sortables.delete(sortable.id);
    };
    /** Sets the active sort id and determines the new sort direction. */
    /**
     * Sets the active sort id and determines the new sort direction.
     * @param {?} sortable
     * @return {?}
     */
    CdkSort.prototype.sort = /**
     * Sets the active sort id and determines the new sort direction.
     * @param {?} sortable
     * @return {?}
     */
    function (sortable) {
        // tslint:disable-next-line: triple-equals
        if (this.active != sortable.id) {
            this.active = sortable.id;
            this.direction = sortable.start ? sortable.start : this.start;
        }
        else {
            this.direction = this.getNextSortDirection(sortable);
        }
        this.sortChange.emit({ active: this.active, direction: this.direction });
    };
    /** Returns the next sort direction of the active sortable, checking for potential overrides. */
    /**
     * Returns the next sort direction of the active sortable, checking for potential overrides.
     * @param {?} sortable
     * @return {?}
     */
    CdkSort.prototype.getNextSortDirection = /**
     * Returns the next sort direction of the active sortable, checking for potential overrides.
     * @param {?} sortable
     * @return {?}
     */
    function (sortable) {
        if (!sortable) {
            return '';
        }
        // Get the sort direction cycle with the potential sortable overrides.
        // tslint:disable-next-line: prefer-const
        /** @type {?} */
        var sortDirectionCycle = getSortDirectionCycle(sortable.start || this.start);
        // Get and return the next direction in the cycle
        /** @type {?} */
        var nextDirectionIndex = sortDirectionCycle.indexOf(this.direction) + 1;
        if (nextDirectionIndex >= sortDirectionCycle.length) {
            nextDirectionIndex = 0;
        }
        return sortDirectionCycle[nextDirectionIndex];
    };
    /**
     * @return {?}
     */
    CdkSort.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._markInitialized();
    };
    /**
     * @return {?}
     */
    CdkSort.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        this._stateChanges.next();
    };
    /**
     * @return {?}
     */
    CdkSort.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._stateChanges.complete();
    };
    CdkSort.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line: directive-selector
                    selector: '[cdkSort]',
                    exportAs: 'cdkSort'
                },] }
    ];
    CdkSort.propDecorators = {
        active: [{ type: Input, args: ['cdkSortActive',] }],
        start: [{ type: Input, args: ['cdkSortStart',] }],
        direction: [{ type: Input, args: ['cdkSortDirection',] }],
        sortChange: [{ type: Output, args: ['cdkSortChange',] }]
    };
    return CdkSort;
}(_MatSortMixinBase));
if (false) {
    /**
     * Collection of all registered sortables that this directive manages.
     * @type {?}
     */
    CdkSort.prototype.sortables;
    /**
     * Used to notify any child components listening to state changes.
     * @type {?}
     */
    CdkSort.prototype._stateChanges;
    /**
     * The id of the most recently sorted MatSortable.
     * @type {?}
     */
    CdkSort.prototype.active;
    /**
     * The direction to set when an MatSortable is initially sorted.
     * May be overriden by the MatSortable's sort start.
     * @type {?}
     */
    CdkSort.prototype.start;
    /**
     * @type {?}
     * @private
     */
    CdkSort.prototype._direction;
    /**
     * Event emitted when the user changes either the active sort or sort direction.
     * @type {?}
     */
    CdkSort.prototype.sortChange;
}
/**
 * Returns the sort direction cycle to use given the provided parameters of order and clear.
 * @param {?} start
 * @return {?}
 */
function getSortDirectionCycle(start) {
    // tslint:disable-next-line: prefer-const
    /** @type {?} */
    var sortOrder = ['asc', 'desc'];
    // tslint:disable-next-line: triple-equals
    if (start == 'desc') {
        sortOrder.reverse();
    }
    sortOrder.push('');
    return sortOrder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CdkSortHeader = /** @class */ (function () {
    function CdkSortHeader(changeDetectorRef, _sort, _columnDef) {
        var _this = this;
        this._sort = _sort;
        this._columnDef = _columnDef;
        // tslint:disable-next-line: variable-name
        this._arrowDirection = '';
        /**
         * Sets the position of the arrow that displays when sorted.
         */
        this.arrowPosition = 'after';
        if (!_sort) {
            throw getSortHeaderNotContainedWithinSortError();
        }
        this._rerenderSubscription = merge(_sort.sortChange, _sort._stateChanges)
            .subscribe((/**
         * @return {?}
         */
        function () {
            if (_this._isSorted()) {
                _this._updateArrowDirection();
            }
            changeDetectorRef.markForCheck();
        }));
    }
    /**
     * @return {?}
     */
    CdkSortHeader.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.id && this._columnDef) {
            this.id = this._columnDef.name;
        }
        // Initialize the direction of the arrow and set the view state to be immediately that state.
        this._updateArrowDirection();
        this._sort.register(this);
    };
    /**
     * @return {?}
     */
    CdkSortHeader.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._sort.deregister(this);
        this._rerenderSubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    CdkSortHeader.prototype._setIndicatorHintVisible = /**
     * @return {?}
     */
    function () {
        if (!this._isSorted()) {
            this._updateArrowDirection();
        }
    };
    /**
     * @return {?}
     */
    CdkSortHeader.prototype._handleClick = /**
     * @return {?}
     */
    function () {
        this._sort.sort(this);
    };
    /**
     * @return {?}
     */
    CdkSortHeader.prototype._isSorted = /**
     * @return {?}
     */
    function () {
        return this._sort.active === this.id &&
            (this._sort.direction === 'asc' || this._sort.direction === 'desc');
    };
    /**
     * @return {?}
     */
    CdkSortHeader.prototype._updateArrowDirection = /**
     * @return {?}
     */
    function () {
        this._arrowDirection = this._isSorted() ?
            this._sort.direction :
            (this.start || this._sort.start);
    };
    /**
     * @return {?}
     */
    CdkSortHeader.prototype._getAriaSortAttribute = /**
     * @return {?}
     */
    function () {
        if (!this._isSorted()) {
            return null;
        }
        return this._sort.direction === 'asc' ? 'ascending' : 'descending';
    };
    /**
     * @return {?}
     */
    CdkSortHeader.prototype._renderArrow = /**
     * @return {?}
     */
    function () {
        return this._isSorted();
    };
    CdkSortHeader.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line: component-selector
                    selector: '[cdk-sort-header]',
                    exportAs: 'cdkSortHeader',
                    template: "<div class=\"sort-header-container\"\r\n     [class.sort-header-sorted]=\"_isSorted()\"\r\n     (focus)=\"_setIndicatorHintVisible()\"\r\n     (blur)=\"_setIndicatorHintVisible()\">\r\n    <span [ngClass]=\"_arrowDirection\"><ng-content></ng-content></span>\r\n</div>\r\n",
                    // tslint:disable-next-line: use-host-property-decorator
                    host: {
                        '(click)': '_handleClick()',
                        // tslint:disable-next-line: no-duplicate-string
                        '(mouseenter)': '_setIndicatorHintVisible()',
                        '(longpress)': '_setIndicatorHintVisible()',
                        '(mouseleave)': '_setIndicatorHintVisible()',
                        '[attr.aria-sort]': '_getAriaSortAttribute()',
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".sort-header-container{cursor:pointer;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-select:none}.sort-header-sorted>span{float:left}.sort-header-sorted>span.asc:before,.sort-header-sorted>span.desc::before{content:'';display:block;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAmxJREFUeAHtmksrRVEUx72fH8CIGQNJkpGUUmakDEiZSJRIZsRQmCkTJRmZmJgQE0kpX0D5DJKJgff7v+ru2u3O3vvc67TOvsdatdrnnP1Y///v7HvvubdbUiIhBISAEBACQkAICAEhIAQ4CXSh2DnyDfmCPEG2Iv9F9MPlM/LHyAecdyMzHYNwR3fdNK/OH9HXl1UCozD24TCvILxizEDWIEzA0FcM8woCgRrJCoS5PIwrANQSMAJX1LEI9bqpQo4JYNFFKRSvIgsxHDVnqZgIkPnNBM0rIGtYk9YOOsqgbgepRCfdbmFtqhFkVEDVPjJp0+Z6e6hRHhqBKgg6ZDCvYBygVmUoEGoh5JTRvIJwhJo1aUOoh4CLPMyvxxi7EWOMgnCGsXXI1GIXlZUYX7ucU+kbR8NW8lh3O7cue0Pk32MKndfUxQFAwxdirk3fHappAnc0oqDPzDfGTBrCfHP04dM4oTV8cxr0SVzH9FF07xD3ib6xCDE+M+aUcVygtWzzbtGX2rPBrEUYfecfQkaFzYi6HjVnGBdtL7epqAlc1+jRdAap74RrnPc4BCijttY2tRcdN0g17w7HqZrXhdJTYAuS3hd8z+vKgK3V1zWPae0mZDMykadBn1hTQBLnZNwVrJpSe/NwEeDsEwCctEOsJTsgxLvCqUl2ACftEGvJDgjxrnBqkh3ASTvEWrIDQrwrnJpkB3DSDrGW7IAQ7wqnJtkBnLRztejXXVu4+mxz/nQ9jR1w5VB86ejLTFcnnDwhzV+F6T+CHZlx6THSjn76eyyBIOPHyDakhBAQAkJACAgBISAEhIAQYCLwC8JxpAmsEGt6AAAAAElFTkSuQmCC) 0 0/22px no-repeat;width:22px;height:22px;margin-left:4px;float:right}.sort-header-sorted>.desc:before{transform:rotate(180deg);-ms-transform:rotate(180deg)}"]
                }] }
    ];
    /** @nocollapse */
    CdkSortHeader.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: CdkSort, decorators: [{ type: Optional }] },
        { type: CdkColumnDef, decorators: [{ type: Optional }] }
    ]; };
    CdkSortHeader.propDecorators = {
        id: [{ type: Input, args: ['cdk-sort-header',] }],
        arrowPosition: [{ type: Input }],
        start: [{ type: Input }]
    };
    return CdkSortHeader;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CdkSortHeader.prototype._rerenderSubscription;
    /** @type {?} */
    CdkSortHeader.prototype._arrowDirection;
    /** @type {?} */
    CdkSortHeader.prototype.id;
    /**
     * Sets the position of the arrow that displays when sorted.
     * @type {?}
     */
    CdkSortHeader.prototype.arrowPosition;
    /**
     * Overrides the sort start value of the containing CdkSort for this CdkSortable.
     * @type {?}
     */
    CdkSortHeader.prototype.start;
    /** @type {?} */
    CdkSortHeader.prototype._sort;
    /** @type {?} */
    CdkSortHeader.prototype._columnDef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The default page size if there is no page size and there are no provided page size options.
 * @type {?}
 */
var DEFAULT_PAGE_SIZE = 50;
/**
 * Change event object that is emitted when the user selects a
 * different page size or navigates to another page.
 */
var  /**
 * Change event object that is emitted when the user selects a
 * different page size or navigates to another page.
 */
PageEvent = /** @class */ (function () {
    function PageEvent() {
    }
    return PageEvent;
}());
if (false) {
    /**
     * The current page index.
     * @type {?}
     */
    PageEvent.prototype.pageIndex;
    /**
     * Index of the page that was selected previously.
     * \@breaking-change 8.0.0 To be made into a required property.
     * @type {?}
     */
    PageEvent.prototype.previousPageIndex;
    /**
     * The current page size
     * @type {?}
     */
    PageEvent.prototype.pageSize;
    /**
     * The current total number of items being paged
     * @type {?}
     */
    PageEvent.prototype.length;
}
// Boilerplate for applying mixins to CdkPaginator.
/**
 * \@docs-private
 */
var 
// Boilerplate for applying mixins to CdkPaginator.
/**
 * \@docs-private
 */
CdkPaginatorBase = /** @class */ (function () {
    function CdkPaginatorBase() {
    }
    return CdkPaginatorBase;
}());
// tslint:disable-next-line: variable-name
/** @type {?} */
var _CdkPaginatorBase = mixinInitialized(CdkPaginatorBase);
/**
 * Component to provide navigation between paged information. Displays the size of the current
 * page, user-selectable options to change that size, what items are being shown, and
 * navigational button to go to the previous or next page.
 */
var CdkPaginator = /** @class */ (function (_super) {
    __extends(CdkPaginator, _super);
    // tslint:disable-next-line: variable-name
    function CdkPaginator(_changeDetectorRef) {
        var _this = _super.call(this) || this;
        _this._changeDetectorRef = _changeDetectorRef;
        // tslint:disable-next-line: variable-name
        _this._pageIndex = 0;
        // tslint:disable-next-line: variable-name
        _this._length = 0;
        // tslint:disable-next-line: variable-name
        _this._pageSizeOptions = [];
        // tslint:disable-next-line: variable-name
        _this._hidePageSize = false;
        // tslint:disable-next-line: variable-name
        _this._showFirstLastButtons = false;
        /**
         * Event emitted when the paginator changes the page size or page index.
         */
        _this.page = new EventEmitter();
        /**
         * A label for the range of items within the current page and the length of the whole list.
         */
        _this.getRangeLabel = (/**
         * @param {?} page
         * @param {?} pageSize
         * @param {?} length
         * @return {?}
         */
        function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return 0;
            }
            length = Math.max(length, 0);
            /** @type {?} */
            var startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            /** @type {?} */
            var endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            return startIndex + 1 + " - " + endIndex;
        });
        _this.getRangeLengthLabel = (/**
         * @param {?} length
         * @return {?}
         */
        function (length) {
            return Math.max(length, 0);
        });
        return _this;
    }
    Object.defineProperty(CdkPaginator.prototype, "pageIndex", {
        /** The zero-based page index of the displayed list of items. Defaulted to 0. */
        get: /**
         * The zero-based page index of the displayed list of items. Defaulted to 0.
         * @return {?}
         */
        function () { return this._pageIndex; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._pageIndex = Math.max(coerceNumberProperty(value), 0);
            this._changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkPaginator.prototype, "length", {
        /** The length of the total number of items that are being paginated. Defaulted to 0. */
        get: /**
         * The length of the total number of items that are being paginated. Defaulted to 0.
         * @return {?}
         */
        function () { return this._length; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._length = coerceNumberProperty(value);
            this._changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkPaginator.prototype, "pageSize", {
        /** Number of items to display on a page. By default set to 50. */
        get: /**
         * Number of items to display on a page. By default set to 50.
         * @return {?}
         */
        function () { return this._pageSize; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._pageSize = Math.max(coerceNumberProperty(value), 0);
            this._updateDisplayedPageSizeOptions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkPaginator.prototype, "pageSizeOptions", {
        /** The set of provided page size options to display to the user. */
        get: /**
         * The set of provided page size options to display to the user.
         * @return {?}
         */
        function () { return this._pageSizeOptions; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._pageSizeOptions = (value || []).map((/**
             * @param {?} p
             * @return {?}
             */
            function (p) { return coerceNumberProperty(p); }));
            this._updateDisplayedPageSizeOptions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkPaginator.prototype, "hidePageSize", {
        /** Whether to hide the page size selection UI from the user. */
        get: /**
         * Whether to hide the page size selection UI from the user.
         * @return {?}
         */
        function () { return this._hidePageSize; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._hidePageSize = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkPaginator.prototype, "showFirstLastButtons", {
        /** Whether to show the first/last buttons UI to the user. */
        get: /**
         * Whether to show the first/last buttons UI to the user.
         * @return {?}
         */
        function () { return this._showFirstLastButtons; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._showFirstLastButtons = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkPaginator.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._initialized = true;
        this._updateDisplayedPageSizeOptions();
        this._markInitialized();
    };
    /**
     * @return {?}
     */
    CdkPaginator.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    /** Advances to the next page if it exists. */
    /**
     * Advances to the next page if it exists.
     * @return {?}
     */
    CdkPaginator.prototype.nextPage = /**
     * Advances to the next page if it exists.
     * @return {?}
     */
    function () {
        if (!this.hasNextPage()) {
            return;
        }
        /** @type {?} */
        var previousPageIndex = this.pageIndex;
        this.pageIndex++;
        this._emitPageEvent(previousPageIndex);
    };
    /** Move back to the previous page if it exists. */
    /**
     * Move back to the previous page if it exists.
     * @return {?}
     */
    CdkPaginator.prototype.previousPage = /**
     * Move back to the previous page if it exists.
     * @return {?}
     */
    function () {
        if (!this.hasPreviousPage()) {
            return;
        }
        /** @type {?} */
        var previousPageIndex = this.pageIndex;
        this.pageIndex--;
        this._emitPageEvent(previousPageIndex);
    };
    /** Move to the first page if not already there. */
    /**
     * Move to the first page if not already there.
     * @return {?}
     */
    CdkPaginator.prototype.firstPage = /**
     * Move to the first page if not already there.
     * @return {?}
     */
    function () {
        // hasPreviousPage being false implies at the start
        if (!this.hasPreviousPage()) {
            return;
        }
        /** @type {?} */
        var previousPageIndex = this.pageIndex;
        this.pageIndex = 0;
        this._emitPageEvent(previousPageIndex);
    };
    /** Move to the last page if not already there. */
    /**
     * Move to the last page if not already there.
     * @return {?}
     */
    CdkPaginator.prototype.lastPage = /**
     * Move to the last page if not already there.
     * @return {?}
     */
    function () {
        // hasNextPage being false implies at the end
        if (!this.hasNextPage()) {
            return;
        }
        /** @type {?} */
        var previousPageIndex = this.pageIndex;
        this.pageIndex = this.getNumberOfPages() - 1;
        this._emitPageEvent(previousPageIndex);
    };
    /** Whether there is a previous page. */
    /**
     * Whether there is a previous page.
     * @return {?}
     */
    CdkPaginator.prototype.hasPreviousPage = /**
     * Whether there is a previous page.
     * @return {?}
     */
    function () {
        return this.pageIndex >= 1 && this.pageSize !== 0;
    };
    /** Whether there is a next page. */
    /**
     * Whether there is a next page.
     * @return {?}
     */
    CdkPaginator.prototype.hasNextPage = /**
     * Whether there is a next page.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var maxPageIndex = this.getNumberOfPages() - 1;
        return this.pageIndex < maxPageIndex && this.pageSize !== 0;
    };
    /** Calculate the number of pages */
    /**
     * Calculate the number of pages
     * @return {?}
     */
    CdkPaginator.prototype.getNumberOfPages = /**
     * Calculate the number of pages
     * @return {?}
     */
    function () {
        if (!this.pageSize) {
            return 0;
        }
        return Math.ceil(this.length / this.pageSize);
    };
    /**
     * Changes the page size so that the first item displayed on the page will still be
     * displayed using the new page size.
     *
     * For example, if the page size is 10 and on the second page (items indexed 10-19) then
     * switching so that the page size is 5 will set the third page as the current page so
     * that the 10th item will still be displayed.
     */
    /**
     * Changes the page size so that the first item displayed on the page will still be
     * displayed using the new page size.
     *
     * For example, if the page size is 10 and on the second page (items indexed 10-19) then
     * switching so that the page size is 5 will set the third page as the current page so
     * that the 10th item will still be displayed.
     * @param {?} pageSize
     * @return {?}
     */
    CdkPaginator.prototype._changePageSize = /**
     * Changes the page size so that the first item displayed on the page will still be
     * displayed using the new page size.
     *
     * For example, if the page size is 10 and on the second page (items indexed 10-19) then
     * switching so that the page size is 5 will set the third page as the current page so
     * that the 10th item will still be displayed.
     * @param {?} pageSize
     * @return {?}
     */
    function (pageSize) {
        // Current page needs to be updated to reflect the new page size. Navigate to the page
        // containing the previous page's first item.
        /** @type {?} */
        var startIndex = this.pageIndex * this.pageSize;
        /** @type {?} */
        var previousPageIndex = this.pageIndex;
        this.pageIndex = Math.floor(startIndex / pageSize) || 0;
        this.pageSize = pageSize;
        this._emitPageEvent(previousPageIndex);
    };
    /** Checks whether the buttons for going forwards should be disabled. */
    /**
     * Checks whether the buttons for going forwards should be disabled.
     * @return {?}
     */
    CdkPaginator.prototype._nextButtonsDisabled = /**
     * Checks whether the buttons for going forwards should be disabled.
     * @return {?}
     */
    function () {
        return !this.hasNextPage();
    };
    /** Checks whether the buttons for going backwards should be disabled. */
    /**
     * Checks whether the buttons for going backwards should be disabled.
     * @return {?}
     */
    CdkPaginator.prototype._previousButtonsDisabled = /**
     * Checks whether the buttons for going backwards should be disabled.
     * @return {?}
     */
    function () {
        return !this.hasPreviousPage();
    };
    /**
     * Updates the list of page size options to display to the user. Includes making sure that
     * the page size is an option and that the list is sorted.
     */
    /**
     * Updates the list of page size options to display to the user. Includes making sure that
     * the page size is an option and that the list is sorted.
     * @private
     * @return {?}
     */
    CdkPaginator.prototype._updateDisplayedPageSizeOptions = /**
     * Updates the list of page size options to display to the user. Includes making sure that
     * the page size is an option and that the list is sorted.
     * @private
     * @return {?}
     */
    function () {
        if (!this._initialized) {
            return;
        }
        // If no page size is provided, use the first page size option or the default page size.
        if (!this.pageSize) {
            this._pageSize = this.pageSizeOptions.length !== 0 ?
                this.pageSizeOptions[0] :
                DEFAULT_PAGE_SIZE;
        }
        this._displayedPageSizeOptions = this.pageSizeOptions.slice();
        if (this._displayedPageSizeOptions.indexOf(this.pageSize) === -1) {
            this._displayedPageSizeOptions.push(this.pageSize);
        }
        // Sort the numbers using a number-specific sort function.
        this._displayedPageSizeOptions.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return a - b; }));
        this._changeDetectorRef.markForCheck();
    };
    /** Emits an event notifying that a change of the paginator's properties has been triggered. */
    /**
     * Emits an event notifying that a change of the paginator's properties has been triggered.
     * @private
     * @param {?} previousPageIndex
     * @return {?}
     */
    CdkPaginator.prototype._emitPageEvent = /**
     * Emits an event notifying that a change of the paginator's properties has been triggered.
     * @private
     * @param {?} previousPageIndex
     * @return {?}
     */
    function (previousPageIndex) {
        this.page.emit({
            previousPageIndex: previousPageIndex,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            length: this.length
        });
    };
    CdkPaginator.decorators = [
        { type: Component, args: [{
                    selector: 'cdk-paginator',
                    exportAs: 'cdkPaginator',
                    template: "<div class=\"paginator-bg\">\r\n    <div class=\"paginator-range-actions\">\r\n        <div class=\"paginator-range-label\"> {{ getRangeLabel(pageIndex, pageSize, length) }} {{ 'APPLICATION.LIST.of' | translate }} {{\r\n        getRangeLengthLabel(length) }} </div>\r\n        <div class=\"btn-group btn-group-justified btn-group-raised btn-group-sm\">\r\n            <button type=\"button\" class=\"btn btn-outline mr-1 mb-0\" (click)=\"firstPage()\" [disabled]=\"_previousButtonsDisabled()\"\r\n                *ngIf=\"showFirstLastButtons\">\r\n                <i class=\"ft ft-chevrons-left\"></i>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-outline mr-1 mb-0\" (click)=\"previousPage()\" [disabled]=\"_previousButtonsDisabled()\">\r\n                <i class=\"ft ft-chevron-left\"></i>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-outline mr-1 mb-0\" (click)=\"nextPage()\" [disabled]=\"_nextButtonsDisabled()\">\r\n                <i class=\"ft ft-chevron-right\"></i>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-outline mb-0\" (click)=\"lastPage()\" [disabled]=\"_nextButtonsDisabled()\"\r\n                *ngIf=\"showFirstLastButtons\">\r\n                <i class=\"ft ft-chevrons-right\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <div class=\"break\"></div>\r\n    <div class=\"paginator-range-actions\">\r\n        <div class=\"paginator-range-label-count\"> {{ 'APPLICATION.PAGINATION.itemsCount' | translate}} </div>\r\n        <div class=\"btn-group btn-group-justified btn-group-raised btn-group-sm\">\r\n            <select [value]=\"pageSize\" class=\"form-control ng-pristine ng-valid ng-touched\" (change)=\"_changePageSize($event.target.value)\">\r\n                <option *ngFor=\"let pageSizeOption of _displayedPageSizeOptions\" [value]=\"pageSizeOption\"> {{pageSizeOption}}</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    // tslint:disable-next-line: use-input-property-decorator
                    inputs: ['disabled'],
                    // tslint:disable-next-line: use-host-property-decorator
                    host: {
                        // tslint:disable-next-line: object-literal-key-quotes
                        'class': 'cdk-paginator'
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".paginator-range-label{margin:0 32px 0 18px}.paginator-range-label-count{margin:0 18px}.paginator-bg{z-index:100;background:#fff;width:50%;displaY:flex;flex-direction:column;justify-content:end;align-items:flex-end}.paginator-range-actions{display:flex;align-items:center;flex-wrap:wrap}.break{flex-basis:100%;height:0}"]
                }] }
    ];
    /** @nocollapse */
    CdkPaginator.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    CdkPaginator.propDecorators = {
        pageIndex: [{ type: Input }],
        length: [{ type: Input }],
        pageSize: [{ type: Input }],
        pageSizeOptions: [{ type: Input }],
        hidePageSize: [{ type: Input }],
        showFirstLastButtons: [{ type: Input }],
        page: [{ type: Output }]
    };
    return CdkPaginator;
}(_CdkPaginatorBase));
if (false) {
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._initialized;
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._pageIndex;
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._length;
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._pageSize;
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._pageSizeOptions;
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._hidePageSize;
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._showFirstLastButtons;
    /**
     * Event emitted when the paginator changes the page size or page index.
     * @type {?}
     */
    CdkPaginator.prototype.page;
    /**
     * Displayed set of page size options. Will be sorted and include current page size.
     * @type {?}
     */
    CdkPaginator.prototype._displayedPageSizeOptions;
    /**
     * A label for the range of items within the current page and the length of the whole list.
     * @type {?}
     */
    CdkPaginator.prototype.getRangeLabel;
    /** @type {?} */
    CdkPaginator.prototype.getRangeLengthLabel;
    /**
     * @type {?}
     * @private
     */
    CdkPaginator.prototype._changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TableSharedModule = /** @class */ (function () {
    function TableSharedModule() {
    }
    TableSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CdkSort,
                        CdkSortHeader,
                        CdkPaginator
                    ],
                    imports: [
                        CommonModule,
                        CdkTableModule,
                        TranslationModule
                    ],
                    exports: [
                        CdkTableModule,
                        CdkSort,
                        CdkSortHeader,
                        CdkPaginator
                    ]
                },] }
    ];
    return TableSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgbdModalConfirmComponent = /** @class */ (function () {
    function NgbdModalConfirmComponent(modal) {
        this.modal = modal;
    }
    /**
     * @return {?}
     */
    NgbdModalConfirmComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    NgbdModalConfirmComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-ngbd-modal-confirm',
                    template: "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title\" id=\"modal-title\">{{ titleTranslateKey | translate }}</h4>\r\n    <button type=\"button\" class=\"close\" aria-describedby=\"modal-title\" (click)=\"modal.dismiss(false)\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n</div>\r\n<div class=\"modal-body\">\r\n    <p [innerHTML]=\"messageTranslateKey | translate | format: values\"></p>\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"modal.dismiss(false)\">{{ 'APPLICATION.MODAL.cancel' | translate }}</button>\r\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"modal.close(true)\">{{ 'APPLICATION.MODAL.confirm' | translate }}</button>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".btn-danger{color:#fff!important}"]
                }] }
    ];
    /** @nocollapse */
    NgbdModalConfirmComponent.ctorParameters = function () { return [
        { type: NgbActiveModal }
    ]; };
    NgbdModalConfirmComponent.propDecorators = {
        titleTranslateKey: [{ type: Input }],
        messageTranslateKey: [{ type: Input }],
        values: [{ type: Input }]
    };
    return NgbdModalConfirmComponent;
}());
if (false) {
    /** @type {?} */
    NgbdModalConfirmComponent.prototype.titleTranslateKey;
    /** @type {?} */
    NgbdModalConfirmComponent.prototype.messageTranslateKey;
    /** @type {?} */
    NgbdModalConfirmComponent.prototype.values;
    /** @type {?} */
    NgbdModalConfirmComponent.prototype.modal;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormatPipe = /** @class */ (function () {
    function FormatPipe() {
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    FormatPipe.prototype.transform = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        if (value == null) {
            return value;
        }
        return this.formatString.apply(this, __spread([value], (args || [])));
    };
    /**
     * @private
     * @param {?} str
     * @param {...?} val
     * @return {?}
     */
    FormatPipe.prototype.formatString = /**
     * @private
     * @param {?} str
     * @param {...?} val
     * @return {?}
     */
    function (str) {
        var val = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            val[_i - 1] = arguments[_i];
        }
        for (var index = 0; index < val.length; index++) {
            str = str.replace("{" + index + "}", val[index]);
        }
        return str;
    };
    FormatPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'format'
                },] }
    ];
    return FormatPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FORM_LAYOUT$2 = {
    date: {
        grid: {
            host: 'col-12',
            container: 'form-group row',
            label: 'col-12',
            control: 'col-12'
        }
    },
};
/** @type {?} */
var FORM_MODEL = [
    new DynamicDatePickerModel({
        id: 'date',
        toggleIcon: './assets/icons/calendar-icon.svg',
        validators: {
            required: null
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
var DateValidators = /** @class */ (function () {
    function DateValidators() {
    }
    /**
     * @param {?} startDate
     * @return {?}
     */
    DateValidators.dayAfterDate = /**
     * @param {?} startDate
     * @return {?}
     */
    function (startDate) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            if (control.value) {
                /** @type {?} */
                var currentValue = new Date(mapDatePickerValueToISOString(control.value));
                if (startDate >= currentValue) {
                    return {
                        dayAfter: {
                            dayAfter: format(startDate, DateValidators.DATE_FORMAT)
                        }
                    };
                }
            }
            return null;
        });
    };
    /**
     * @param {?} startDate
     * @return {?}
     */
    DateValidators.dayAfter = /**
     * @param {?} startDate
     * @return {?}
     */
    function (startDate) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            if (control.value && startDate.value) {
                /** @type {?} */
                var currentValue = new Date(mapDatePickerValueToISOString(control.value));
                /** @type {?} */
                var startValue = new Date(mapDatePickerValueToISOString(startDate.value));
                if (startValue >= currentValue) {
                    return {
                        dayAfter: {
                            dayAfter: format(startValue, DateValidators.DATE_FORMAT)
                        }
                    };
                }
            }
            return null;
        });
    };
    /**
     * @param {?} endDate
     * @return {?}
     */
    DateValidators.dayBefore = /**
     * @param {?} endDate
     * @return {?}
     */
    function (endDate) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            if (control.value && endDate.value) {
                /** @type {?} */
                var currentValue = new Date(mapDatePickerValueToISOString(control.value));
                /** @type {?} */
                var endDateValue = new Date(mapDatePickerValueToISOString(endDate.value));
                if (endDateValue <= currentValue) {
                    return {
                        dayBefore: {
                            dayBefore: format(endDateValue, DateValidators.DATE_FORMAT)
                        }
                    };
                }
            }
            return null;
        });
    };
    /**
     * @param {?} endDate
     * @return {?}
     */
    DateValidators.dayBeforeDate = /**
     * @param {?} endDate
     * @return {?}
     */
    function (endDate) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            if (control.value) {
                /** @type {?} */
                var currentValue = new Date(mapDatePickerValueToISOString(control.value));
                if (endDate <= currentValue) {
                    return {
                        dayBefore: {
                            dayBefore: format(endDate, DateValidators.DATE_FORMAT)
                        }
                    };
                }
            }
            return null;
        });
    };
    DateValidators.DATE_FORMAT = 'yyyy-MM-dd';
    return DateValidators;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DateValidators.DATE_FORMAT;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgbdModalDateComponent = /** @class */ (function () {
    function NgbdModalDateComponent(modal) {
        this.modal = modal;
        this.formLayout = FORM_LAYOUT$2;
        this.formModel = FORM_MODEL;
    }
    /**
     * @return {?}
     */
    NgbdModalDateComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initValue = {
            date: mapISOStringToDatePickerValue(this.date)
        };
    };
    /**
     * @return {?}
     */
    NgbdModalDateComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var endDate = this.modalDateForm.formGroup.get('date');
        if (this.minDate != null) {
            endDate.setValidators(DateValidators.dayAfterDate(new Date(this.minDate)));
        }
        if (this.maxDate != null) {
            endDate.setValidators(DateValidators.dayBeforeDate(new Date(this.maxDate)));
        }
    };
    /**
     * @return {?}
     */
    NgbdModalDateComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.modal.dismiss(null);
    };
    /**
     * @return {?}
     */
    NgbdModalDateComponent.prototype.onSave = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var date = mapDatePickerValueToISOString(this.modalDateForm.formGroup.value.date);
        this.modal.close(date);
    };
    NgbdModalDateComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-ngbd-modal-date',
                    template: "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title\" id=\"modal-title\">{{ titleTranslateKey | translate }}</h4>\r\n    <button type=\"button\" class=\"close\" aria-describedby=\"modal-title\" (click)=\"onClose()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n</div>\r\n<div class=\"modal-body\">\r\n    <app-simple-form\r\n        #modalDateForm\r\n        [formModel]=\"formModel\"\r\n        [formLayout]=\"formLayout\"\r\n        [model]=\"initValue\"\r\n        [translateKey]=\"formTranslateKey\">\r\n    </app-simple-form>\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"onClose()\">{{ 'APPLICATION.MODAL.cancel' | translate }}</button>\r\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"onSave()\" [disabled]=\"modalDateForm.formGroup.invalid\">{{ saveTranslateKey || 'APPLICATION.MODAL.save' | translate }}</button>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".btn-danger{color:#fff!important}"]
                }] }
    ];
    /** @nocollapse */
    NgbdModalDateComponent.ctorParameters = function () { return [
        { type: NgbActiveModal }
    ]; };
    NgbdModalDateComponent.propDecorators = {
        titleTranslateKey: [{ type: Input }],
        formTranslateKey: [{ type: Input }],
        saveTranslateKey: [{ type: Input }],
        date: [{ type: Input }],
        minDate: [{ type: Input }],
        maxDate: [{ type: Input }],
        modalDateForm: [{ type: ViewChild, args: ['modalDateForm', { static: false },] }]
    };
    return NgbdModalDateComponent;
}());
if (false) {
    /** @type {?} */
    NgbdModalDateComponent.prototype.titleTranslateKey;
    /** @type {?} */
    NgbdModalDateComponent.prototype.formTranslateKey;
    /** @type {?} */
    NgbdModalDateComponent.prototype.saveTranslateKey;
    /** @type {?} */
    NgbdModalDateComponent.prototype.date;
    /** @type {?} */
    NgbdModalDateComponent.prototype.minDate;
    /** @type {?} */
    NgbdModalDateComponent.prototype.maxDate;
    /** @type {?} */
    NgbdModalDateComponent.prototype.modalDateForm;
    /** @type {?} */
    NgbdModalDateComponent.prototype.formLayout;
    /** @type {?} */
    NgbdModalDateComponent.prototype.formModel;
    /** @type {?} */
    NgbdModalDateComponent.prototype.initValue;
    /** @type {?} */
    NgbdModalDateComponent.prototype.modal;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ModalSharedModule = /** @class */ (function () {
    function ModalSharedModule() {
    }
    ModalSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NgbdModalConfirmComponent, NgbdModalDateComponent, FormatPipe],
                    entryComponents: [NgbdModalConfirmComponent, NgbdModalDateComponent],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        NgbModule,
                        FormSharedModule
                    ],
                    exports: [
                        NgbdModalConfirmComponent,
                        NgbdModalDateComponent,
                        NgbModule,
                        FormatPipe
                    ]
                },] }
    ];
    return ModalSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfirmationModalService = /** @class */ (function () {
    function ConfirmationModalService(modalService) {
        this.modalService = modalService;
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} titleTranslateKey
     * @param {?} messageTranslateKey
     * @param {?} values
     * @return {?}
     */
    ConfirmationModalService.prototype.open = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} titleTranslateKey
     * @param {?} messageTranslateKey
     * @param {?} values
     * @return {?}
     */
    function (titleTranslateKey, messageTranslateKey, values) {
        /** @type {?} */
        var modalRef = this.modalService.open(NgbdModalConfirmComponent);
        modalRef.componentInstance.titleTranslateKey = titleTranslateKey;
        modalRef.componentInstance.messageTranslateKey = messageTranslateKey;
        modalRef.componentInstance.values = values;
        return modalRef.result;
    };
    ConfirmationModalService.decorators = [
        { type: Injectable, args: [{ providedIn: ModalSharedModule },] }
    ];
    /** @nocollapse */
    ConfirmationModalService.ctorParameters = function () { return [
        { type: NgbModal }
    ]; };
    /** @nocollapse */ ConfirmationModalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ConfirmationModalService_Factory() { return new ConfirmationModalService(ɵɵinject(NgbModal)); }, token: ConfirmationModalService, providedIn: ModalSharedModule });
    return ConfirmationModalService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ConfirmationModalService.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* TODO - move to farmcloud-shared */
/** @type {?} */
var LOADING_DEBOUNCE_TIME = 250;
// for request less than 250 ms do not display loader
/** @type {?} */
var DEFAULT_PAGE_SIZE$1 = 10;
/**
 * Based on https://github.com/angular/components/blob/master/src/material/table/table-data-source.ts
 * @template T, TFilter
 */
var  /**
 * Based on https://github.com/angular/components/blob/master/src/material/table/table-data-source.ts
 * @template T, TFilter
 */
ServerSideDataSource = /** @class */ (function (_super) {
    __extends(ServerSideDataSource, _super);
    function ServerSideDataSource(httpCallMethod, initFilter) {
        if (initFilter === void 0) { initFilter = null; }
        var _this = _super.call(this) || this;
        _this.httpCallMethod = httpCallMethod;
        _this.renderData = new BehaviorSubject([]);
        _this.internalPageChanges = new Subject();
        _this.noDataSubject = new BehaviorSubject(false);
        _this.errorSubject = new BehaviorSubject(false);
        _this.loadingSubject = new BehaviorSubject(true);
        _this.renderChangesSubscription = Subscription.EMPTY;
        _this._filter = new BehaviorSubject(initFilter);
        _this._forceRefresh = new BehaviorSubject(false);
        _this._updateChangeSubscription();
        _this.noData$ = _this.noDataSubject.asObservable();
        _this.error$ = _this.errorSubject.asObservable().pipe(distinctUntilChanged());
        _this.loading$ = _this.loadingSubject.asObservable().pipe(debounceTime(LOADING_DEBOUNCE_TIME), distinctUntilChanged());
        return _this;
    }
    Object.defineProperty(ServerSideDataSource.prototype, "sort", {
        get: /**
         * @return {?}
         */
        function () { return this._sort; },
        set: /**
         * @param {?} sort
         * @return {?}
         */
        function (sort) {
            this._sort = sort;
            this._updateChangeSubscription();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerSideDataSource.prototype, "paginator", {
        get: /**
         * @return {?}
         */
        function () { return this._paginator; },
        set: /**
         * @param {?} paginator
         * @return {?}
         */
        function (paginator) {
            this._paginator = paginator;
            this._updateChangeSubscription();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} filter
     * @return {?}
     */
    ServerSideDataSource.prototype.setFilter = /**
     * @param {?} filter
     * @return {?}
     */
    function (filter) { this._filter.next(filter); };
    /**
     * @return {?}
     */
    ServerSideDataSource.prototype.forceRefresh = /**
     * @return {?}
     */
    function () { this._forceRefresh.next(true); };
    /**
     * @return {?}
     */
    ServerSideDataSource.prototype._updateChangeSubscription = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var sortChange = this._sort ?
            (/** @type {?} */ (merge(this._sort.sortChange, this._sort.initialized.pipe(map((/**
             * @return {?}
             */
            function () {
                return {
                    active: _this._sort.active,
                    direction: _this._sort.direction
                };
            })))))) :
            of(null);
        /** @type {?} */
        var pageChange = this._paginator ?
            merge(this._paginator.page, this.internalPageChanges, this._paginator.initialized) : NEVER;
        /** @type {?} */
        var requestData = combineLatest([sortChange, pageChange, this._filter, this._forceRefresh])
            .pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 4), sort = _b[0], page = _b[1], filter = _b[2], forceRefresh = _b[3];
            /** @type {?} */
            var filterObject = filter || (/** @type {?} */ ({}));
            /** @type {?} */
            var sorting = sort && !!sort.active && sort.direction !== '';
            /** @type {?} */
            var orderBy = sorting ? sort.active : null;
            /** @type {?} */
            var sortOrder = sorting ? sort.direction : null;
            /** @type {?} */
            var pageNumber = _this.paginator ? _this.paginator.pageIndex : 1;
            /** @type {?} */
            var pageSize = _this.paginator ? _this.paginator.pageSize : DEFAULT_PAGE_SIZE$1;
            return {
                orderBy: orderBy,
                sortOrder: sortOrder,
                pageSize: pageSize,
                page: pageNumber,
                filter: filterObject
            };
        })));
        /** @type {?} */
        var dataServerSide = requestData.pipe(tap((/**
         * @return {?}
         */
        function () {
            _this.loadingSubject.next(true);
            _this.errorSubject.next(false);
        })), switchMap((/**
         * @param {?} request
         * @return {?}
         */
        function (request) { return _this.httpCallMethod(request).pipe(catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.errorSubject.next(true);
            return of({
                totalCount: null,
                items: []
            });
        })), tap((/**
         * @return {?}
         */
        function () { return _this.loadingSubject.next(false); }))); })));
        this.renderChangesSubscription.unsubscribe();
        this.renderChangesSubscription = dataServerSide.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.noDataSubject.next(data.totalCount === 0);
            _this._updatePaginator(data.totalCount || 0);
            return _this.renderData.next((/** @type {?} */ (data.items)));
        }));
    };
    /**
     * @param {?} filteredDataLength
     * @return {?}
     */
    ServerSideDataSource.prototype._updatePaginator = /**
     * @param {?} filteredDataLength
     * @return {?}
     */
    function (filteredDataLength) {
        var _this = this;
        Promise.resolve().then((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var paginator = _this.paginator;
            if (!paginator) {
                return;
            }
            paginator.length = filteredDataLength;
            // If the page index is set beyond the page, reduce it to the last page.
            if (paginator.pageIndex > 0) {
                /** @type {?} */
                var lastPageIndex = Math.ceil(paginator.length / paginator.pageSize) - 1 || 0;
                /** @type {?} */
                var newPageIndex = Math.min(paginator.pageIndex, lastPageIndex);
                if (newPageIndex !== paginator.pageIndex) {
                    paginator.pageIndex = newPageIndex;
                    // Since the paginator only emits after user-generated changes,
                    // we need our own stream so we know to should re-render the data.
                    _this.internalPageChanges.next();
                }
            }
        }));
    };
    /**
     * @return {?}
     */
    ServerSideDataSource.prototype.connect = /**
     * @return {?}
     */
    function () {
        return this.renderData;
    };
    /**
     * @return {?}
     */
    ServerSideDataSource.prototype.disconnect = /**
     * @return {?}
     */
    function () {
        this.renderChangesSubscription.unsubscribe();
    };
    return ServerSideDataSource;
}(DataSource));
if (false) {
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype.renderData;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype.internalPageChanges;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype._sort;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype._paginator;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype._filter;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype._forceRefresh;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype.noDataSubject;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype.errorSubject;
    /** @type {?} */
    ServerSideDataSource.prototype.loadingSubject;
    /** @type {?} */
    ServerSideDataSource.prototype.noData$;
    /** @type {?} */
    ServerSideDataSource.prototype.loading$;
    /** @type {?} */
    ServerSideDataSource.prototype.error$;
    /** @type {?} */
    ServerSideDataSource.prototype.renderChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    ServerSideDataSource.prototype.httpCallMethod;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DOCUMENT_SHARED_SERVICE = new InjectionToken('DocumentSharedService');
/**
 * @record
 */
function IDocumentService() { }
if (false) {
    /**
     * @param {?} requestList
     * @return {?}
     */
    IDocumentService.prototype.find = function (requestList) { };
    /**
     * @param {?} command
     * @return {?}
     */
    IDocumentService.prototype.create = function (command) { };
    /**
     * @param {?} id
     * @return {?}
     */
    IDocumentService.prototype.delete = function (id) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CreateDocumentCommand = /** @class */ (function () {
    function CreateDocumentCommand(title, description, attachment, groundId, groundName, fieldCardId, fieldCardName) {
        this.title = title;
        this.description = description;
        this.attachment = attachment;
        this.groundId = groundId;
        this.groundName = groundName;
        this.fieldCardId = fieldCardId;
        this.fieldCardName = fieldCardName;
    }
    return CreateDocumentCommand;
}());
if (false) {
    /** @type {?} */
    CreateDocumentCommand.prototype.title;
    /** @type {?} */
    CreateDocumentCommand.prototype.description;
    /** @type {?} */
    CreateDocumentCommand.prototype.attachment;
    /** @type {?} */
    CreateDocumentCommand.prototype.groundId;
    /** @type {?} */
    CreateDocumentCommand.prototype.groundName;
    /** @type {?} */
    CreateDocumentCommand.prototype.fieldCardId;
    /** @type {?} */
    CreateDocumentCommand.prototype.fieldCardName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MAX_FILE_SIZE$2 = 20;
// MB
/** @type {?} */
var DOCUMENT_ADD_MODEL = [
    new DynamicFormGroupModel({
        id: 'documentBaseGroup',
        group: [
            new DynamicInputModel({
                id: 'title',
                minLength: 3,
                maxLength: 160,
                required: null,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 160
                }
            }),
            new DynamicTextAreaModel({
                id: 'description',
                maxLength: 1000,
                rows: 9,
                validators: {
                    maxLength: 1000
                }
            })
        ]
    }),
    new DynamicFormGroupModel({
        id: 'documentAttachmentGroup',
        group: [
            new DynamicFileUploadModel({
                id: 'attachment',
                maxSize: MAX_FILE_SIZE$2,
                validators: {
                    required: null,
                }
            })
        ]
    })
];
/** @type {?} */
var DOCUMENT_ADD_LAYOUT = {
    documentBaseGroup: DEFAULT_FORM_LAYOUT_GROUP,
    title: FORM_LAYOUT_SINGLE_LINE_INPUT,
    description: FORM_LAYOUT_SINGLE_LINE_INPUT,
    documentAttachmentGroup: DEFAULT_FORM_LAYOUT_GROUP,
    attachment: {
        grid: {
            host: 'col-12 m-0',
            label: 'd-none'
        }
    }
};
/**
 * @return {?}
 */
function mapToDocumentForm() {
    return {
        documentBaseGroup: {
            title: '',
            description: ''
        },
        documentAttachmentGroup: {
            attachment: null
        }
    };
}
/**
 * @param {?} groundId
 * @param {?} groundName
 * @param {?} fieldCardId
 * @param {?} fieldCardName
 * @param {?} data
 * @return {?}
 */
function mapFromDocumentForm(groundId, groundName, fieldCardId, fieldCardName, data) {
    return new CreateDocumentCommand(data.documentBaseGroup.title, data.documentBaseGroup.description, data.documentAttachmentGroup.attachment.file, groundId, groundName, fieldCardId, fieldCardName);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentAddFormComponent = /** @class */ (function () {
    function DocumentAddFormComponent(activeModal, documentService) {
        this.activeModal = activeModal;
        this.documentService = documentService;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = DOCUMENT_ADD_LAYOUT;
        this.formModel = DOCUMENT_ADD_MODEL;
    }
    /**
     * @return {?}
     */
    DocumentAddFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initValue = mapToDocumentForm();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    DocumentAddFormComponent.prototype.cancel = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.activeModal.close(false);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    DocumentAddFormComponent.prototype.add = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        this.displaySpinner$.next(true);
        /** @type {?} */
        var command = mapFromDocumentForm(this.groundId, this.groundName, this.fieldCardId, this.fieldCardName, $event);
        this.documentService.create(command)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            if (id != null) {
                _this.activeModal.close(true);
            }
        }));
    };
    DocumentAddFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-document-add-form',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ headerTranslationKey | translate }}</h4>\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancel($event)\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <app-add-form\r\n            *ngIf=\"formModel\"\r\n            #addForm\r\n            [formModel]=\"formModel\"\r\n            [formLayout]=\"formLayout\"\r\n            [model]=\"initValue\"\r\n            (add)=\"add($event)\"\r\n            [translateKey]=\"translationKeyPrefix\"\r\n            (afterCancel)=\"cancel($event)\">\r\n        </app-add-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    DocumentAddFormComponent.ctorParameters = function () { return [
        { type: NgbActiveModal },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT_SHARED_SERVICE,] }] }
    ]; };
    DocumentAddFormComponent.propDecorators = {
        groundId: [{ type: Input }],
        groundName: [{ type: Input }],
        fieldCardId: [{ type: Input }],
        fieldCardName: [{ type: Input }],
        headerTranslationKey: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }],
        addForm: [{ type: ViewChild, args: ['addForm', { static: false },] }]
    };
    return DocumentAddFormComponent;
}());
if (false) {
    /** @type {?} */
    DocumentAddFormComponent.prototype.groundId;
    /** @type {?} */
    DocumentAddFormComponent.prototype.groundName;
    /** @type {?} */
    DocumentAddFormComponent.prototype.fieldCardId;
    /** @type {?} */
    DocumentAddFormComponent.prototype.fieldCardName;
    /** @type {?} */
    DocumentAddFormComponent.prototype.headerTranslationKey;
    /** @type {?} */
    DocumentAddFormComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    DocumentAddFormComponent.prototype.addForm;
    /** @type {?} */
    DocumentAddFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    DocumentAddFormComponent.prototype.formLayout;
    /** @type {?} */
    DocumentAddFormComponent.prototype.formModel;
    /** @type {?} */
    DocumentAddFormComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    DocumentAddFormComponent.prototype.activeModal;
    /**
     * @type {?}
     * @private
     */
    DocumentAddFormComponent.prototype.documentService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentListSchema = /** @class */ (function () {
    function DocumentListSchema() {
    }
    return DocumentListSchema;
}());
if (false) {
    /** @type {?} */
    DocumentListSchema.prototype.headerKey;
    /** @type {?} */
    DocumentListSchema.prototype.createButtonKey;
    /** @type {?} */
    DocumentListSchema.prototype.addDocumentModalHeaderKey;
    /** @type {?} */
    DocumentListSchema.prototype.addDocumentModalTranslationKeyPrefix;
    /** @type {?} */
    DocumentListSchema.prototype.listHeaderKey;
    /** @type {?} */
    DocumentListSchema.prototype.listColumnDocumentTypeKey;
    /** @type {?} */
    DocumentListSchema.prototype.listColumnDocumentTypeTranslationPrefix;
    /** @type {?} */
    DocumentListSchema.prototype.listColumnTitleKey;
    /** @type {?} */
    DocumentListSchema.prototype.listColumnDescriptionKey;
    /** @type {?} */
    DocumentListSchema.prototype.listColumnActionsKey;
    /** @type {?} */
    DocumentListSchema.prototype.listDeleteButtonKey;
    /** @type {?} */
    DocumentListSchema.prototype.listDownloadButtonKey;
    /** @type {?} */
    DocumentListSchema.prototype.listEmptyKey;
    /** @type {?} */
    DocumentListSchema.prototype.listErrorKey;
    /** @type {?} */
    DocumentListSchema.prototype.listDeleteConfirmTitle;
    /** @type {?} */
    DocumentListSchema.prototype.listDeleteConfirmText;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentsListComponent = /** @class */ (function () {
    function DocumentsListComponent(modalService, spinnerService, confirmationModalService, documentService) {
        var _this = this;
        this.modalService = modalService;
        this.spinnerService = spinnerService;
        this.confirmationModalService = confirmationModalService;
        this.documentService = documentService;
        this.showDocumentType = false;
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            if (_this.groundId) {
                filter.filter.groundId = _this.groundId;
            }
            if (_this.fieldCardId) {
                filter.filter.fieldCardId = _this.fieldCardId;
            }
            return _this.documentService.find(filter)
                .pipe(map((/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                /** @type {?} */
                var resultItems = d.items.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) {
                    return __assign({ documentType: _this.getDocumentType(x) }, x);
                }));
                return {
                    items: resultItems,
                    totalCount: d.pager.totalCount
                };
            })));
        }));
    }
    /**
     * @return {?}
     */
    DocumentsListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        if (this.showDocumentType) {
            this.displayedColumns = ['title', 'description', 'documentType', 'action'];
        }
        else {
            this.displayedColumns = ['title', 'description', 'action'];
        }
    };
    /**
     * @return {?}
     */
    DocumentsListComponent.prototype.addDocument = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var documentAddFormModal = this.modalService.open(DocumentAddFormComponent, { windowClass: 'right', beforeDismiss: (/**
             * @return {?}
             */
            function () { return false; }) });
        documentAddFormModal.componentInstance.groundId = this.groundId;
        documentAddFormModal.componentInstance.groundName = this.groundName;
        documentAddFormModal.componentInstance.fieldCardId = this.fieldCardId;
        documentAddFormModal.componentInstance.fieldCardName = this.fieldCardName;
        documentAddFormModal.componentInstance.headerTranslationKey = this.schema.addDocumentModalHeaderKey;
        documentAddFormModal.componentInstance.translationKeyPrefix = this.schema.addDocumentModalTranslationKeyPrefix;
        documentAddFormModal.result.then((/**
         * @param {?} added
         * @return {?}
         */
        function (added) {
            if (added) {
                _this.dataSource.forceRefresh();
            }
        }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    DocumentsListComponent.prototype.onDelete = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        this.confirmationModalService.open(this.schema.listDeleteConfirmTitle, this.schema.listDeleteConfirmText, [item.title]).then((/**
         * @return {?}
         */
        function () {
            _this.spinnerService.display();
            _this.documentService.delete(item.id)
                .pipe(finalize((/**
             * @return {?}
             */
            function () {
                _this.spinnerService.hide();
                _this.dataSource.forceRefresh();
            }))).subscribe();
        }), (/**
         * @return {?}
         */
        function () { }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    DocumentsListComponent.prototype.getDocumentType = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (item.groundName) {
            return DocumentEnumType.Ground;
        }
        if (item.fieldCardName) {
            return DocumentEnumType.FieldCard;
        }
        return DocumentEnumType.Document;
    };
    DocumentsListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-documents-list',
                    template: "<div class=\"pt-3 d-flex flex-column flex-md-row align-items-md-center justify-content-md-between\"\r\n    [ngClass]=\"{ 'pt-2 col-12': showInTab }\">\r\n    <h2>{{ schema.headerKey | translate }}</h2>\r\n    <div>\r\n        <button class=\"btn btn-raised btn-secondary ng-star-inserted w-100\" (click)=\"addDocument()\" type=\"button\">\r\n            <i class=\"ft ft-plus\"></i> {{ schema.createButtonKey | translate }}\r\n        </button>\r\n    </div>\r\n</div>\r\n<div [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\" *ngIf=\"schema.listHeaderKey\"><i class=\"ft ft-list\"></i> {{ schema.listHeaderKey |\r\n                    translate }}</h5>\r\n            </label>\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid table-container\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"title\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"title\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-10 col-md-4 pr-0\">\r\n                                {{ schema.listColumnTitleKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-10 col-md-4 pr-0\">\r\n                                {{ element.title }}\r\n                                <span *ngIf=\"groundId == null && element.groundName != null\">\r\n                                    <i class=\"ft ft-info\" data-toggle=\"tooltip\" data-placement=\"top\"\r\n                                        title=\"{{ element.groundName }}\"></i>\r\n                                </span>\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"description\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef\r\n                                [ngClass]=\"{'col-md-5': showDocumentType, 'col-md-7' : !showDocumentType }\"\r\n                                class=\" pr-0 d-none d-md-block\">\r\n                                {{ schema.listColumnDescriptionKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                [ngClass]=\"{'col-md-5': showDocumentType, 'col-md-7' : !showDocumentType }\"\r\n                                class=\" pr-0 d-none d-md-block\">\r\n                                <span *ngIf=\"groundId == null && element.groundName != null\" class=\"font-italic\">\r\n                                    [{{ element.groundName }}]\r\n                                </span>\r\n                                <span *ngIf=\"fieldCardId == null && element.fieldCardName != null\" class=\"font-italic\">\r\n                                    [{{ element.fieldCardName }}]\r\n                                </span>\r\n                                {{ element.description }}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"documentType\" *ngIf=\"showDocumentType\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-md-2 pr-0 d-none d-md-block\">\r\n                                {{ schema.listColumnDocumentTypeKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-md-2 pr-0 d-none d-md-block\">\r\n                                {{schema.listColumnDocumentTypeTranslationPrefix + element.documentType |\r\n                                translate}}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 col-md-1 p-0 text-center\">\r\n                                {{ schema.listColumnActionsKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"col-2 col-md-1 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"d-flex\">\r\n                                    <button (click)=\"onDelete(element)\"\r\n                                        title=\"{{ schema.listDeleteButtonKey | translate }}\"\r\n                                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm shadow-none\">\r\n                                        <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <a *ngIf=\"element.attachment\" href=\"{{ element.attachment.link }}\"\r\n                                        title=\"{{ schema.listDownloadButtonKey | translate }}\" target=\"_blank\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm shadow-none\">\r\n                                        <i class=\"ft ft-download\" aria-hidden=\"true\"></i>\r\n                                    </a>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\"\r\n                            *cdkHeaderRowDef=\"displayedColumns\"> </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\"\r\n                            *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listEmptyKey | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listErrorKey | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                        [pageSizeOptions]=\"[10, 25, 50, 75, 100]\" showFirstLastButtons></cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    DocumentsListComponent.ctorParameters = function () { return [
        { type: NgbModal },
        { type: SpinnerService },
        { type: ConfirmationModalService },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT_SHARED_SERVICE,] }] }
    ]; };
    DocumentsListComponent.propDecorators = {
        groundId: [{ type: Input }],
        groundName: [{ type: Input }],
        showDocumentType: [{ type: Input }],
        fieldCardId: [{ type: Input }],
        fieldCardName: [{ type: Input }],
        schema: [{ type: Input }],
        showInTab: [{ type: Input }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return DocumentsListComponent;
}());
if (false) {
    /** @type {?} */
    DocumentsListComponent.prototype.groundId;
    /** @type {?} */
    DocumentsListComponent.prototype.groundName;
    /** @type {?} */
    DocumentsListComponent.prototype.showDocumentType;
    /** @type {?} */
    DocumentsListComponent.prototype.fieldCardId;
    /** @type {?} */
    DocumentsListComponent.prototype.fieldCardName;
    /** @type {?} */
    DocumentsListComponent.prototype.schema;
    /** @type {?} */
    DocumentsListComponent.prototype.showInTab;
    /** @type {?} */
    DocumentsListComponent.prototype.sort;
    /** @type {?} */
    DocumentsListComponent.prototype.paginator;
    /** @type {?} */
    DocumentsListComponent.prototype.displayedColumns;
    /** @type {?} */
    DocumentsListComponent.prototype.dataSource;
    /**
     * @type {?}
     * @private
     */
    DocumentsListComponent.prototype.modalService;
    /**
     * @type {?}
     * @private
     */
    DocumentsListComponent.prototype.spinnerService;
    /**
     * @type {?}
     * @private
     */
    DocumentsListComponent.prototype.confirmationModalService;
    /**
     * @type {?}
     * @private
     */
    DocumentsListComponent.prototype.documentService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentSharedModule = /** @class */ (function () {
    function DocumentSharedModule() {
    }
    DocumentSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        DocumentsListComponent,
                        DocumentAddFormComponent
                    ],
                    entryComponents: [
                        DocumentAddFormComponent
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        NgbModule,
                        SpinnerModule,
                        PanelSharedModule,
                        FormSharedModule,
                        TableSharedModule,
                        ModalSharedModule
                    ],
                    exports: [
                        DocumentsListComponent
                    ]
                },] }
    ];
    return DocumentSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentFile = /** @class */ (function () {
    function DocumentFile(name, link) {
        this.name = name;
        this.link = link;
    }
    return DocumentFile;
}());
if (false) {
    /** @type {?} */
    DocumentFile.prototype.name;
    /** @type {?} */
    DocumentFile.prototype.link;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentListFilter = /** @class */ (function () {
    function DocumentListFilter() {
    }
    return DocumentListFilter;
}());
if (false) {
    /** @type {?} */
    DocumentListFilter.prototype.title;
    /** @type {?} */
    DocumentListFilter.prototype.groundId;
    /** @type {?} */
    DocumentListFilter.prototype.fieldCardId;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Document = /** @class */ (function () {
    function Document(id, title, description, attachment, groundName, fieldCardName) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.attachment = attachment;
        this.groundName = groundName;
        this.fieldCardName = fieldCardName;
    }
    return Document;
}());
if (false) {
    /** @type {?} */
    Document.prototype.id;
    /** @type {?} */
    Document.prototype.title;
    /** @type {?} */
    Document.prototype.description;
    /** @type {?} */
    Document.prototype.attachment;
    /** @type {?} */
    Document.prototype.groundName;
    /** @type {?} */
    Document.prototype.fieldCardName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LangSelectorComponent = /** @class */ (function () {
    function LangSelectorComponent(translateService) {
        this.translateService = translateService;
        this.flagUrl = './assets/img/flags/';
    }
    /**
     * @return {?}
     */
    LangSelectorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.languages = this.translateService.supportedLanguages().map((/**
         * @param {?} l
         * @return {?}
         */
        function (l) { return _this.mapLanguage(l); }));
        this.selectedLanguage = this.mapLanguage(this.translateService.getLanguage());
    };
    /**
     * @param {?} languageKey
     * @return {?}
     */
    LangSelectorComponent.prototype.changeLanguage = /**
     * @param {?} languageKey
     * @return {?}
     */
    function (languageKey) {
        this.translateService.setLanguage(languageKey);
        this.selectedLanguage = this.mapLanguage(this.translateService.getLanguage());
    };
    /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    LangSelectorComponent.prototype.trackByFn = /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    function (index, item) {
        return item.key;
    };
    /**
     * @private
     * @param {?} language
     * @return {?}
     */
    LangSelectorComponent.prototype.mapLanguage = /**
     * @private
     * @param {?} language
     * @return {?}
     */
    function (language) {
        return {
            key: language,
            flagUrl: "" + this.flagUrl + language + ".png"
        };
    };
    LangSelectorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-lang-selector',
                    template: "<div ngbDropdown [placement]=\"'bottom-right'\">\r\n    <a class=\"nav-link position-relative\" id=\"dropdownLang\" ngbDropdownToggle>\r\n        <i [ngClass]=\"['flag-icon', 'flag-icon-' + selectedLanguage.key]\"></i>\r\n    </a>\r\n    <div aria-labelledby=\"dropdownLang\" ngbDropdownMenu class=\"dropdownLang text-left\">\r\n        <a class=\"dropdown-item py-1 lang\" href=\"javascript:;\" (click)=\"changeLanguage(language.key)\" *ngFor=\"let language of languages; trackBy: trackByFn\">\r\n            <i [ngClass]=\"['flag-icon', 'flag-icon-item', 'flag-icon-' + language.key]\"></i>\r\n            <span>{{ language.key | enumTranslateKey: 'APPLICATION.LANGUAGES' | translate }}</span>\r\n        </a>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".langimg{box-shadow:0 0 10px 0 rgba(128,128,128,.6)}.flag-icon{background-size:contain;background-position:50%;background-repeat:no-repeat;position:relative;display:inline-block;width:1.33333333em;line-height:1em;box-shadow:0 0 10px 0 rgba(128,128,128,.6);height:15px;margin-right:5px}.flag-icon-item{margin-right:10px}.flag-icon-pl{background-image:url(/assets/flags/pl.svg)}.flag-icon-en{background-image:url(/assets/flags/gb.svg)}"]
                }] }
    ];
    /** @nocollapse */
    LangSelectorComponent.ctorParameters = function () { return [
        { type: TranslateService$1 }
    ]; };
    return LangSelectorComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LangSelectorComponent.prototype.flagUrl;
    /** @type {?} */
    LangSelectorComponent.prototype.languages;
    /** @type {?} */
    LangSelectorComponent.prototype.selectedLanguage;
    /**
     * @type {?}
     * @private
     */
    LangSelectorComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MESSAGE_UNREAD_SERVICE = new InjectionToken('Message unread service');
/**
 * @record
 */
function IMessageUnreadService() { }
if (false) {
    /**
     * @return {?}
     */
    IMessageUnreadService.prototype.getUnreadMessages = function () { };
    /**
     * @return {?}
     */
    IMessageUnreadService.prototype.getUnreadMessageCount = function () { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageUnreadNotificationComponent = /** @class */ (function () {
    function MessageUnreadNotificationComponent(messageUnreadService) {
        this.messageUnreadService = messageUnreadService;
    }
    /**
     * @return {?}
     */
    MessageUnreadNotificationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.unreadMessages$ = this.messageUnreadService.getUnreadMessages();
        this.unreadMessageCount$ = this.messageUnreadService.getUnreadMessageCount();
    };
    /**
     * @param {?} index
     * @param {?} message
     * @return {?}
     */
    MessageUnreadNotificationComponent.prototype.trackByFn = /**
     * @param {?} index
     * @param {?} message
     * @return {?}
     */
    function (index, message) {
        return message.id;
    };
    MessageUnreadNotificationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-message-unread-notification',
                    template: "<div ngbDropdown [placement]=\"'bottom-right'\">\r\n    <a class=\"nav-link position-relative\" id=\"dropdownBasic2\" ngbDropdownToggle>\r\n        <i class=\"ft-bell font-medium-3 blue-grey darken-4\"></i>\r\n        <span *ngIf=\"unreadMessageCount$ | async as unreadMessageCount\" class=\"notification badge badge-pill badge-danger\">{{ unreadMessageCount }}</span>\r\n    </a>\r\n    <div ngbDropdownMenu aria-labelledby=\"dropdownBasic2\" class=\"notification-dropdown\">\r\n        <div class=\"noti-list\" [perfectScrollbar] *ngIf=\"unreadMessages$ | async as unreadMessages\">\r\n            <a [routerLink]=\"['/messages', message.id]\" class=\"dropdown-item noti-container py-3 border-bottom border-bottom-blue-grey border-bottom-lighten-4\" *ngFor=\"let message of unreadMessages; trackBy:trackByFn\">\r\n                <i class=\"float-left d-block font-large-1 mt-1 mr-2\" [ngClass]=\"message?.type | messageTypeIcon\"></i>\r\n                <span class=\"noti-wrapper\">\r\n                    <span class=\"noti-title line-height-1 d-block text-bold-400 info\">{{ message.title | htmlTextShort:20 }}</span>\r\n                    <span class=\"noti-text\">{{ message.body | htmlTextShort:50 }}</span>\r\n                </span>\r\n            </a>\r\n            <div class=\"h-100 d-flex justify-content-center\" *ngIf=\"unreadMessages.length === 0\">\r\n                <div class=\"align-self-center\">{{ 'MESSAGE.NAVBAR.list:empty' | translate }}</div>\r\n            </div>\r\n        </div>\r\n        <a routerLink=\"/messages\" class=\"noti-footer primary text-center d-block border-top border-top-blue-grey border-top-lighten-4 text-bold-400 py-1\">{{ 'MESSAGE.NAVBAR.viewAll' | translate }}</a>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    MessageUnreadNotificationComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [MESSAGE_UNREAD_SERVICE,] }] }
    ]; };
    return MessageUnreadNotificationComponent;
}());
if (false) {
    /** @type {?} */
    MessageUnreadNotificationComponent.prototype.unreadMessages$;
    /** @type {?} */
    MessageUnreadNotificationComponent.prototype.unreadMessageCount$;
    /**
     * @type {?}
     * @private
     */
    MessageUnreadNotificationComponent.prototype.messageUnreadService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToggleFullscreenComponent = /** @class */ (function () {
    function ToggleFullscreenComponent() {
    }
    ToggleFullscreenComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-toggle-fullscreen',
                    template: "<a href=\"javascript:;\" class=\"nav-link\" id=\"navbar-fullscreen\" apexToggleFullscreen>\r\n    <i class=\"font-medium-3 blue-grey darken-4\"></i>\r\n    <p class=\"d-none\">fullscreen</p>\r\n</a>\r\n",
                    styles: [""]
                }] }
    ];
    return ToggleFullscreenComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LayoutSharedModule = /** @class */ (function () {
    function LayoutSharedModule() {
    }
    LayoutSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        LangSelectorComponent,
                        MessageUnreadNotificationComponent,
                        ToggleFullscreenComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        NgbModule,
                        SharedModule,
                        PipesModule,
                        TranslationModule
                    ],
                    exports: [
                        LangSelectorComponent,
                        MessageUnreadNotificationComponent,
                        ToggleFullscreenComponent
                    ]
                },] }
    ];
    return LayoutSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageUnread = /** @class */ (function () {
    function MessageUnread() {
    }
    return MessageUnread;
}());
if (false) {
    /** @type {?} */
    MessageUnread.prototype.id;
    /** @type {?} */
    MessageUnread.prototype.type;
    /** @type {?} */
    MessageUnread.prototype.title;
    /** @type {?} */
    MessageUnread.prototype.body;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DatePickerValue() { }
if (false) {
    /** @type {?} */
    DatePickerValue.prototype.year;
    /** @type {?} */
    DatePickerValue.prototype.month;
    /** @type {?} */
    DatePickerValue.prototype.day;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FileModel() { }
if (false) {
    /** @type {?|undefined} */
    FileModel.prototype.id;
    /** @type {?} */
    FileModel.prototype.name;
    /** @type {?|undefined} */
    FileModel.prototype.rootFileName;
    /** @type {?|undefined} */
    FileModel.prototype.mimeType;
    /** @type {?|undefined} */
    FileModel.prototype.link;
    /** @type {?|undefined} */
    FileModel.prototype.file;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} formModel
 * @param {?} groupLayout
 * @param {?} inputLayoutEven
 * @param {?} inputLayoutOdd
 * @return {?}
 */
function GetLayout(formModel, groupLayout, inputLayoutEven, inputLayoutOdd) {
    var e_1, _a;
    /** @type {?} */
    var result = {};
    /** @type {?} */
    var index = 0;
    try {
        for (var formModel_1 = __values(formModel), formModel_1_1 = formModel_1.next(); !formModel_1_1.done; formModel_1_1 = formModel_1.next()) {
            var entry = formModel_1_1.value;
            if (entry.type === DYNAMIC_FORM_CONTROL_TYPE_GROUP) {
                result[entry.id] = groupLayout;
                /** @type {?} */
                var group = GetLayout(((/** @type {?} */ (entry))).group, groupLayout, inputLayoutEven, inputLayoutOdd);
                result = __assign({}, result, group);
            }
            else {
                // tslint:disable-next-line: no-magic-numbers
                result[entry.id] = (index++ % 2 === 0) ? inputLayoutEven : inputLayoutOdd;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (formModel_1_1 && !formModel_1_1.done && (_a = formModel_1.return)) _a.call(formModel_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
/**
 * @param {?} formModel
 * @return {?}
 */
function GetDefaultLayout(formModel) {
    return GetLayout(formModel, DEFAULT_FORM_LAYOUT_GROUP, DEFAULT_FORM_LAYOUT_INPUT, DEFAULT_FORM_LAYOUT_INPUT);
}
/**
 * @param {?} formModel
 * @return {?}
 */
function GetDefaultSingleLineLayout(formModel) {
    return GetLayout(formModel, DEFAULT_FORM_LAYOUT_GROUP, FORM_LAYOUT_SINGLE_LINE_INPUT, FORM_LAYOUT_SINGLE_LINE_INPUT);
}
/**
 * @param {?} formModel
 * @return {?}
 */
function GetDefaultSearchLayout(formModel) {
    return GetLayout(formModel, DEFAULT_FORM_LAYOUT_GROUP, DEFAULT_SEARCH_FORM_LAYOUT_INPUT_EVEN, DEFAULT_SEARCH_FORM_LAYOUT_INPUT_ODD);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} from
 * @param {?} to
 * @return {?}
 */
function getRangeOptionsForDynamicSelectModel(from, to) {
    /** @type {?} */
    var rangeLength = to - from + 1;
    return Array.from({ length: rangeLength }, (/**
     * @param {?} v
     * @param {?} k
     * @return {?}
     */
    function (v, k) { return k + from; })).map((/**
     * @param {?} n
     * @return {?}
     */
    function (n) {
        return {
            label: n.toString(),
            value: n
        };
    }));
}
/**
 * @return {?}
 */
function getYearsRangeOptionsForDynamicSelectModel() {
    /** @type {?} */
    var from = 1980;
    /** @type {?} */
    var to = new Date().getFullYear();
    return getRangeOptionsForDynamicSelectModel(from, to).reverse();
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductDeliveryParcel = /** @class */ (function () {
    function ProductDeliveryParcel(id, name, areaInHa) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
    }
    return ProductDeliveryParcel;
}());
if (false) {
    /** @type {?} */
    ProductDeliveryParcel.prototype.id;
    /** @type {?} */
    ProductDeliveryParcel.prototype.name;
    /** @type {?} */
    ProductDeliveryParcel.prototype.areaInHa;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormModalService = /** @class */ (function () {
    function FormModalService(modalService) {
        this.modalService = modalService;
    }
    /**
     * @param {?} titleTranslateKey
     * @param {?} formTranslateKey
     * @param {?=} saveTranslateKey
     * @param {?=} date
     * @param {?=} minDate
     * @param {?=} maxDate
     * @return {?}
     */
    FormModalService.prototype.openDate = /**
     * @param {?} titleTranslateKey
     * @param {?} formTranslateKey
     * @param {?=} saveTranslateKey
     * @param {?=} date
     * @param {?=} minDate
     * @param {?=} maxDate
     * @return {?}
     */
    function (titleTranslateKey, formTranslateKey, saveTranslateKey, date, minDate, maxDate) {
        if (saveTranslateKey === void 0) { saveTranslateKey = null; }
        if (date === void 0) { date = null; }
        if (minDate === void 0) { minDate = null; }
        if (maxDate === void 0) { maxDate = null; }
        /** @type {?} */
        var modalRef = this.modalService.open(NgbdModalDateComponent);
        modalRef.componentInstance.titleTranslateKey = titleTranslateKey;
        modalRef.componentInstance.formTranslateKey = formTranslateKey;
        modalRef.componentInstance.saveTranslateKey = saveTranslateKey;
        modalRef.componentInstance.date = date;
        modalRef.componentInstance.minDate = minDate;
        modalRef.componentInstance.maxDate = maxDate;
        return modalRef.result;
    };
    FormModalService.decorators = [
        { type: Injectable, args: [{ providedIn: ModalSharedModule },] }
    ];
    /** @nocollapse */
    FormModalService.ctorParameters = function () { return [
        { type: NgbModal }
    ]; };
    /** @nocollapse */ FormModalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FormModalService_Factory() { return new FormModalService(ɵɵinject(NgbModal)); }, token: FormModalService, providedIn: ModalSharedModule });
    return FormModalService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FormModalService.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocationMapSchema = /** @class */ (function () {
    function LocationMapSchema() {
    }
    return LocationMapSchema;
}());
if (false) {
    /** @type {?} */
    LocationMapSchema.prototype.translations;
    /** @type {?} */
    LocationMapSchema.prototype.icons;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocationMapServicesModule = /** @class */ (function () {
    function LocationMapServicesModule() {
    }
    LocationMapServicesModule.decorators = [
        { type: NgModule, args: [{
                    providers: [DatePipe, HumidityPipe, TemperaturePipe, AirHumidityPipe]
                },] }
    ];
    return LocationMapServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var LocationMapItemType = {
    MoistureSensor: 'MoistureSensor',
    WeatherStation: 'WeatherStation',
    Vehicles: 'Vehicles',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocationMapService = /** @class */ (function () {
    function LocationMapService(datePipe, temperaturePipe, humidityPipe, airHumidityPipe, translateService) {
        var _this = this;
        this.datePipe = datePipe;
        this.temperaturePipe = temperaturePipe;
        this.humidityPipe = humidityPipe;
        this.airHumidityPipe = airHumidityPipe;
        this.translateService = translateService;
        this.createMarkerPopupContent = (/**
         * @param {?} item
         * @param {?} schema
         * @return {?}
         */
        function (item, schema) {
            switch (item.type) {
                case LocationMapItemType.MoistureSensor:
                    return _this.createMoistureSensorMarkerPopupContent(item, schema);
                case LocationMapItemType.Vehicles:
                    return _this.createVehicleMarkerPopupContent(item, schema);
                case LocationMapItemType.WeatherStation:
                    return _this.createWeatherStationMarkerPopupContent(item, schema);
                default: return item.name;
            }
        });
        this.createMoistureSensorMarkerPopupContent = (/**
         * @param {?} item
         * @param {?} schema
         * @return {?}
         */
        function (item, schema) {
            return "<div class=\"row si-modal no-gutters mb-0 moisture-sensor-marker-content\">\n                    <div class=\"col-12\"><h6 class=\"font-weight-bold\">" + item.name + "</h6></div>\n                    <div class=\"col-12\">\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                            <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-temperature\"></i>\n                                    " + _this.airTemperatureLabel(schema) + "\n                            </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 mb-0 text-md-right si-modal-data\">\n                                " + _this.formatTemperature(item.airTemperature) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.airHumidityLabel(schema) + "\n                            </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + _this.formatAirHumidity(item.airHumidity) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2 " + ((item.soilHumidityLevel1 < 0) ? 'hidden' : '') + "\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                            <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.soilHumidityLevel1Label(schema) + "\n                            </div>\n                            </div>\n                            <div class=\"col-12 col-md-3 text-md-right si-modal-data\">\n                                " + _this.formatHumidity(item.soilHumidityLevel1) + "\n                            </div>\n                            <div class=\"battery battery-" + _this.getHumidityLevel(item.soilHumidityLevel1) + " col-2\">\n                                " + _this.getHumidityLevelItems(item.soilHumidityLevel1) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2 " + ((item.soilHumidityLevel2 < 0) ? 'hidden' : '') + "\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                            <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.soilHumidityLevel2Label(schema) + "\n                            </div>\n                            </div>\n                            <div class=\"col-12 col-md-3 text-md-right si-modal-data\">\n                                " + _this.formatHumidity(item.soilHumidityLevel2) + "\n                            </div>\n                            <div class=\"battery battery-" + _this.getHumidityLevel(item.soilHumidityLevel2) + " col-2\">\n                                " + _this.getHumidityLevelItems(item.soilHumidityLevel2) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2 " + ((item.soilHumidityLevel3 < 0) ? 'hidden' : '') + "\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                            <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.soilHumidityLevel3Label(schema) + "\n                            </div>\n                            </div>\n                            <div class=\"col-12 col-md-3 text-md-right si-modal-data\">\n                                " + _this.formatHumidity(item.soilHumidityLevel3) + "\n                            </div>\n                            <div class=\"battery battery-" + _this.getHumidityLevel(item.soilHumidityLevel3) + " col-2\">\n                                " + _this.getHumidityLevelItems(item.soilHumidityLevel3) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-calendar-black\"></i>\n                                    " + _this.dateLabel(schema) + "\n                               </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + _this.formatDate(item.lastActiveDate) + "\n                            </div>\n                        </div>\n                        <div style=\"clear:both\"></div>\n                    </div>\n                </div>";
        });
        this.createWeatherStationMarkerPopupContent = (/**
         * @param {?} item
         * @param {?} schema
         * @return {?}
         */
        function (item, schema) {
            return "<div class=\"row si-modal no-gutters mb-0 weather-station-marker-content\">\n                    <div class=\"col-12\"><h6 class=\"font-weight-bold\">" + item.name + "</h6></div>\n                    <div class=\"col-12\">\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                               <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-temperature\"></i>\n                                    " + _this.airTemperatureLabel(schema) + "\n                               </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 mb-0 text-md-right si-modal-data\">\n                                " + _this.formatTemperature(item.airTemperature) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.airHumidityLabel(schema) + "\n                               </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + _this.formatAirHumidity(item.airHumidity) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2 " + ((item.soilHumidityLevel1 < 0) ? 'hidden' : '') + "\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.soilHumidityLevel1Label(schema) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-3 text-md-right si-modal-data\">\n                                " + _this.formatHumidity(item.soilHumidityLevel1) + "\n                            </div>\n                            <div class=\"battery battery-" + _this.getHumidityLevel(item.soilHumidityLevel1) + " col-2\">\n                                " + _this.getHumidityLevelItems(item.soilHumidityLevel1) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2 " + ((item.soilHumidityLevel2 < 0) ? 'hidden' : '') + "\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.soilHumidityLevel2Label(schema) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-3 text-md-right si-modal-data\">\n                                " + _this.formatHumidity(item.soilHumidityLevel2) + "\n                            </div>\n                            <div class=\"battery battery-" + _this.getHumidityLevel(item.soilHumidityLevel2) + " col-2\">\n                                " + _this.getHumidityLevelItems(item.soilHumidityLevel2) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2 " + ((item.soilHumidityLevel3 < 0) ? 'hidden' : '') + "\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-humidity\"></i>\n                                    " + _this.soilHumidityLevel3Label(schema) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-3 text-md-right si-modal-data\">\n                                " + _this.formatHumidity(item.soilHumidityLevel3) + "\n                            </div>\n                            <div class=\"battery battery-" + _this.getHumidityLevel(item.soilHumidityLevel3) + " col-2\">\n                                " + _this.getHumidityLevelItems(item.soilHumidityLevel3) + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-calendar-black\"></i>\n                                    " + _this.dateLabel(schema) + "\n                               </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + _this.formatDate(item.lastActiveDate) + "\n                            </div>\n                        </div>\n                    </div>\n                </div>";
        });
        this.createVehicleMarkerPopupContent = (/**
         * @param {?} item
         * @param {?} schema
         * @return {?}
         */
        function (item, schema) {
            return "<div class=\"row si-modal no-gutters\">\n                <div class=\"col-12 col-md 5 pr-2\">\n                    <img src=\"" + item.imageUrl + "\" class=\"img-thumbnail location-map-marker-tooltip-image\" alt=\"" + item.name + "\">\n                </div>\n                <div class=\"col-12 col-md-7\">\n                    <div class=\"col-12\"><h6 class=\"font-weight-bold\">" + item.name + "</h6></div>\n                    <div class=\"col-12\">\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    <i class=\"farm_icon farm_icon-calendar-black\"></i>\n                                    " + _this.dateLabel(schema) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + _this.formatDate(item.lastActiveDate) + "\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>";
        });
        this.airTemperatureLabel = (/**
         * @param {?} schema
         * @return {?}
         */
        function (schema) {
            return _this.translateService.instant(schema.translations.marker.airTemperature);
        });
        this.airHumidityLabel = (/**
         * @param {?} schema
         * @return {?}
         */
        function (schema) {
            return _this.translateService.instant(schema.translations.marker.airHumidity);
        });
        this.soilHumidityLevel1Label = (/**
         * @param {?} schema
         * @return {?}
         */
        function (schema) {
            return _this.translateService.instant(schema.translations.marker.soilHumidityLevel1);
        });
        this.soilHumidityLevel2Label = (/**
         * @param {?} schema
         * @return {?}
         */
        function (schema) {
            return _this.translateService.instant(schema.translations.marker.soilHumidityLevel2);
        });
        this.soilHumidityLevel3Label = (/**
         * @param {?} schema
         * @return {?}
         */
        function (schema) {
            return _this.translateService.instant(schema.translations.marker.soilHumidityLevel3);
        });
        this.dateLabel = (/**
         * @param {?} schema
         * @return {?}
         */
        function (schema) {
            return _this.translateService.instant(schema.translations.marker.date);
        });
        this.formatTemperature = (/**
         * @param {?=} value
         * @return {?}
         */
        function (value) {
            return _this.temperaturePipe.transform(value);
        });
        this.formatHumidity = (/**
         * @param {?=} value
         * @return {?}
         */
        function (value) {
            return _this.humidityPipe.transform(value);
        });
        this.formatAirHumidity = (/**
         * @param {?=} value
         * @return {?}
         */
        function (value) {
            return _this.airHumidityPipe.transform(value);
        });
        this.formatDate = (/**
         * @param {?=} value
         * @return {?}
         */
        function (value) {
            return value != null ? _this.datePipe.transform(value, 'short') : '-';
        });
        this.getHumidityLevel = (/**
         * @param {?=} value
         * @return {?}
         */
        function (value) {
            // tslint:disable-next-line: no-magic-numbers
            if (value == null || value < 0) {
                // tslint:disable-next-line: no-magic-numbers
                return 0;
            }
            // tslint:disable-next-line: no-magic-numbers
            if (value < 30) {
                // tslint:disable-next-line: no-magic-numbers
                return 4;
            }
            // tslint:disable-next-line: no-magic-numbers
            if (value < 60) {
                // tslint:disable-next-line: no-magic-numbers
                return 3;
            }
            // tslint:disable-next-line: no-magic-numbers
            if (value < 100) {
                // tslint:disable-next-line: no-magic-numbers
                return 2;
            }
            // tslint:disable-next-line: no-magic-numbers
            return 1;
        });
        this.getHumidityLevelItems = (/**
         * @param {?=} value
         * @return {?}
         */
        function (value) {
            /** @type {?} */
            var level = _this.getHumidityLevel(value);
            /** @type {?} */
            var result = '';
            // tslint:disable-next-line: no-magic-numbers
            for (var i = 0; i < level; i++) {
                result += '<div class="level"></div>';
            }
            return result;
        });
    }
    /**
     * @param {?} item
     * @param {?} schema
     * @return {?}
     */
    LocationMapService.prototype.createMarker = /**
     * @param {?} item
     * @param {?} schema
     * @return {?}
     */
    function (item, schema) {
        if (item.location) {
            return {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: item.location
                },
                properties: {
                    name: this.createMarkerPopupContent(item, schema),
                    iconUrl: this.resolveMarkerIcon(item.type, schema)
                }
            };
        }
    };
    /**
     * @private
     * @param {?} type
     * @param {?} schema
     * @return {?}
     */
    LocationMapService.prototype.resolveMarkerIcon = /**
     * @private
     * @param {?} type
     * @param {?} schema
     * @return {?}
     */
    function (type, schema) {
        switch (type) {
            case LocationMapItemType.MoistureSensor:
                return schema.icons.moistureSensorMarkerIconUrl;
            case LocationMapItemType.Vehicles:
                return schema.icons.vehicleMarkerIconUrl;
            case LocationMapItemType.WeatherStation:
                return schema.icons.weatherStationMarkerIconUrl;
            default: return undefined;
        }
    };
    LocationMapService.decorators = [
        { type: Injectable, args: [{
                    providedIn: LocationMapServicesModule
                },] }
    ];
    /** @nocollapse */
    LocationMapService.ctorParameters = function () { return [
        { type: DatePipe },
        { type: TemperaturePipe },
        { type: HumidityPipe },
        { type: AirHumidityPipe },
        { type: TranslateService }
    ]; };
    /** @nocollapse */ LocationMapService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LocationMapService_Factory() { return new LocationMapService(ɵɵinject(DatePipe), ɵɵinject(TemperaturePipe), ɵɵinject(HumidityPipe), ɵɵinject(AirHumidityPipe), ɵɵinject(TranslateService)); }, token: LocationMapService, providedIn: LocationMapServicesModule });
    return LocationMapService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.createMarkerPopupContent;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.createMoistureSensorMarkerPopupContent;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.createWeatherStationMarkerPopupContent;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.createVehicleMarkerPopupContent;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.airTemperatureLabel;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.airHumidityLabel;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.soilHumidityLevel1Label;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.soilHumidityLevel2Label;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.soilHumidityLevel3Label;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.dateLabel;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.formatTemperature;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.formatHumidity;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.formatAirHumidity;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.formatDate;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.getHumidityLevel;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.getHumidityLevelItems;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.datePipe;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.temperaturePipe;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.humidityPipe;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.airHumidityPipe;
    /**
     * @type {?}
     * @private
     */
    LocationMapService.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocationMapComponent = /** @class */ (function () {
    function LocationMapComponent(ngZone, locationMapService, translateService) {
        var _this = this;
        this.ngZone = ngZone;
        this.locationMapService = locationMapService;
        this.translateService = translateService;
        this.unsubscribe$ = new Subject();
        this.mapConfig = new MapConfig();
        this.markerConfig = new MarkerConfig(false, false);
        this.polygonConfig = new PolygonConfig(null, false, false);
        this.displayOnMap = (/**
         * @param {?} elements
         * @return {?}
         */
        function (elements) {
            _this.features = (elements || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return _this.locationMapService.createMarker(x, _this.schema); }));
        });
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    LocationMapComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.items && changes.items.currentValue != null) {
            this.displayOnMap(changes.items.currentValue);
        }
    };
    /**
     * @return {?}
     */
    LocationMapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.displayOnMap(_this.items);
            }));
        }));
    };
    /**
     * @return {?}
     */
    LocationMapComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    LocationMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-location-map',
                    template: "<div class=\"flex-grow-1\" style=\"height: 400px;\">\r\n    <app-map [features]=\"features\" [mapConfig]=\"mapConfig\" [markerConfig]=\"markerConfig\" [polygonConfig]=\"polygonConfig\">\r\n    </app-map>\r\n</div>\r\n<div class=\"row mt-3 mb-2\">\r\n    <div class=\"col-4 text-center\">\r\n        <img [src]=\"schema.icons.moistureSensorMarkerIconUrl\" [alt]=\"schema.translations.moistureSensors | translate\" >\r\n        {{ schema.translations.moistureSensors | translate }}\r\n    </div>\r\n    <div class=\"col-4 text-center\">\r\n        <img [src]=\"schema.icons.weatherStationMarkerIconUrl\" [alt]=\"schema.translations.weatherStations | translate\" >\r\n        {{ schema.translations.weatherStations | translate }}\r\n    </div>\r\n    <div class=\"col-4 text-center\">\r\n        <img [src]=\"schema.icons.vehicleMarkerIconUrl\" [alt]=\"schema.translations.vehicles | translate\" >\r\n        {{ schema.translations.vehicles | translate }}\r\n    </div>\r\n</div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    LocationMapComponent.ctorParameters = function () { return [
        { type: NgZone },
        { type: LocationMapService },
        { type: TranslateService }
    ]; };
    LocationMapComponent.propDecorators = {
        items: [{ type: Input }],
        schema: [{ type: Input }]
    };
    return LocationMapComponent;
}());
if (false) {
    /** @type {?} */
    LocationMapComponent.prototype.items;
    /** @type {?} */
    LocationMapComponent.prototype.schema;
    /**
     * @type {?}
     * @private
     */
    LocationMapComponent.prototype.unsubscribe$;
    /** @type {?} */
    LocationMapComponent.prototype.features;
    /** @type {?} */
    LocationMapComponent.prototype.mapConfig;
    /** @type {?} */
    LocationMapComponent.prototype.markerConfig;
    /** @type {?} */
    LocationMapComponent.prototype.polygonConfig;
    /**
     * @type {?}
     * @private
     */
    LocationMapComponent.prototype.displayOnMap;
    /**
     * @type {?}
     * @private
     */
    LocationMapComponent.prototype.ngZone;
    /**
     * @type {?}
     * @private
     */
    LocationMapComponent.prototype.locationMapService;
    /**
     * @type {?}
     * @private
     */
    LocationMapComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocationMapSharedModule = /** @class */ (function () {
    function LocationMapSharedModule() {
    }
    LocationMapSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [LocationMapComponent],
                    entryComponents: [LocationMapComponent],
                    imports: [
                        CommonModule,
                        GoogleMapsSharedModule,
                        TranslationModule,
                        LocationMapServicesModule
                    ],
                    exports: [
                        LocationMapComponent
                    ],
                    providers: [MapService]
                },] }
    ];
    return LocationMapSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocationMapItem = /** @class */ (function () {
    function LocationMapItem(type, location, name, lastActiveDate, airTemperature, airHumidity, soilHumidityLevel1, soilHumidityLevel2, soilHumidityLevel3, imageUrl) {
        this.type = type;
        this.location = location;
        this.name = name;
        this.lastActiveDate = lastActiveDate;
        this.airTemperature = airTemperature;
        this.airHumidity = airHumidity;
        this.soilHumidityLevel1 = soilHumidityLevel1;
        this.soilHumidityLevel2 = soilHumidityLevel2;
        this.soilHumidityLevel3 = soilHumidityLevel3;
        this.imageUrl = imageUrl;
    }
    return LocationMapItem;
}());
if (false) {
    /** @type {?} */
    LocationMapItem.prototype.type;
    /** @type {?} */
    LocationMapItem.prototype.location;
    /** @type {?} */
    LocationMapItem.prototype.name;
    /** @type {?} */
    LocationMapItem.prototype.lastActiveDate;
    /** @type {?} */
    LocationMapItem.prototype.airTemperature;
    /** @type {?} */
    LocationMapItem.prototype.airHumidity;
    /** @type {?} */
    LocationMapItem.prototype.soilHumidityLevel1;
    /** @type {?} */
    LocationMapItem.prototype.soilHumidityLevel2;
    /** @type {?} */
    LocationMapItem.prototype.soilHumidityLevel3;
    /** @type {?} */
    LocationMapItem.prototype.imageUrl;
}

var _a$9;
/** @type {?} */
var CULTIVATION_CROP_SELECT = (/** @type {?} */ ({
    codeName: 'Cultivation.select',
    dictionaryType: 'CULTIVATION',
    cultivationCategory: 'Cultivation.select'
}));
/** @type {?} */
var PESTICIDE_LIST_FILTER_GROUP = 'filterGroup';
/** @type {?} */
var PESTICIDE_LIST_FILTER_PESTICIDE_NAME = 'pesticideName';
/** @type {?} */
var PESTICIDE_LIST_FILTER_CULTIVATION_CROP = 'cultivationCrop';
/** @type {?} */
var PESTICIDE_LIST_FILTER_ONLY_ECOLOGICAL = 'onlyEcological';
/** @type {?} */
var PESTICIDE_LIST_FILTER_ACTIVE_SUBSTANCE = 'activeSubstance';
/** @type {?} */
var PESTICIDE_LIST_FILTER_AGROFAG = 'agrofag';
/** @type {?} */
var PESTICIDE_SEARCH_FILTER_FORM_LAYOUT = (_a$9 = {},
    _a$9[PESTICIDE_LIST_FILTER_GROUP] = {
        grid: {
            host: 'w-100 mt-1 ',
            container: 'form-layout-group-header-hidden',
            label: 'col-12 px-0'
        },
        element: {
            control: 'row'
        }
    },
    _a$9[PESTICIDE_LIST_FILTER_PESTICIDE_NAME] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$9[PESTICIDE_LIST_FILTER_CULTIVATION_CROP] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$9[PESTICIDE_LIST_FILTER_ONLY_ECOLOGICAL] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$9[PESTICIDE_LIST_FILTER_ACTIVE_SUBSTANCE] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$9[PESTICIDE_LIST_FILTER_AGROFAG] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$9);
/** @type {?} */
var TRANSLATION_DICTIONARY_KEY = 'APPLICATION.DICTIONARIES';
/** @type {?} */
var PESTICIDE_SEARCH_FILTER_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: PESTICIDE_LIST_FILTER_GROUP,
        group: [
            new DynamicDictionaryControlModel({
                id: PESTICIDE_LIST_FILTER_PESTICIDE_NAME,
                dictionaryKey: DictionaryType[DictionaryType.PesticideType]
            }),
            new DynamicMultiSelectControlModel({
                id: PESTICIDE_LIST_FILTER_CULTIVATION_CROP,
                bindLabel: nameof('codeName'),
                groupBy: nameof('cultivationCategory'),
                multiple: false,
                translationPrefix: TRANSLATION_DICTIONARY_KEY,
                searchByField: nameof('codeName')
            }),
            new DynamicSelectModel({
                id: PESTICIDE_LIST_FILTER_ONLY_ECOLOGICAL,
                options: getOptionsForDynamicSelectModel(TrueFalse, 'TRUE_FALSE', false)
            }),
            new DynamicDictionaryControlModel({
                id: PESTICIDE_LIST_FILTER_ACTIVE_SUBSTANCE,
                dictionaryKey: DictionaryType[DictionaryType.ActiveSubstanceType],
                translationPrefix: TRANSLATION_DICTIONARY_KEY,
            }),
            new DynamicDictionaryControlModel({
                id: PESTICIDE_LIST_FILTER_AGROFAG,
                dictionaryKey: DictionaryType[DictionaryType.Agrofag],
                translationPrefix: TRANSLATION_DICTIONARY_KEY,
            })
        ]
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideListFilterForm = /** @class */ (function () {
    function PesticideListFilterForm() {
        var _a;
        this[PESTICIDE_LIST_FILTER_GROUP] = (_a = {},
            _a[PESTICIDE_LIST_FILTER_PESTICIDE_NAME] = '',
            _a[PESTICIDE_LIST_FILTER_CULTIVATION_CROP] = CULTIVATION_CROP_SELECT,
            _a[PESTICIDE_LIST_FILTER_ONLY_ECOLOGICAL] = TrueFalse.False,
            _a[PESTICIDE_LIST_FILTER_ACTIVE_SUBSTANCE] = '',
            _a[PESTICIDE_LIST_FILTER_AGROFAG] = '',
            _a);
    }
    return PesticideListFilterForm;
}());
if (false) {
    /* Skipping unnamed member:
    [PESTICIDE_LIST_FILTER_GROUP]: {
            [PESTICIDE_LIST_FILTER_PESTICIDE_NAME]: string,
            [PESTICIDE_LIST_FILTER_CULTIVATION_CROP]: ICultivationDictionaryModel,
            [PESTICIDE_LIST_FILTER_ONLY_ECOLOGICAL]: string,
            [PESTICIDE_LIST_FILTER_ACTIVE_SUBSTANCE]: string,
            [PESTICIDE_LIST_FILTER_AGROFAG]: string
        }*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideListFilter = /** @class */ (function () {
    function PesticideListFilter(name, cultivationCropCodeName, onlyEcological, activeSubstance, agrofag) {
        this.name = name;
        this.cultivationCropCodeName = cultivationCropCodeName;
        this.onlyEcological = onlyEcological;
        this.activeSubstance = activeSubstance;
        this.agrofag = agrofag;
    }
    return PesticideListFilter;
}());
if (false) {
    /** @type {?} */
    PesticideListFilter.prototype.name;
    /** @type {?} */
    PesticideListFilter.prototype.cultivationCropCodeName;
    /** @type {?} */
    PesticideListFilter.prototype.onlyEcological;
    /** @type {?} */
    PesticideListFilter.prototype.activeSubstance;
    /** @type {?} */
    PesticideListFilter.prototype.agrofag;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideListFilterComponent = /** @class */ (function () {
    function PesticideListFilterComponent(dictionariesService) {
        this.dictionariesService = dictionariesService;
        this.search = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(true);
        this.formLayout = PESTICIDE_SEARCH_FILTER_FORM_LAYOUT;
        this.formModel = PESTICIDE_SEARCH_FILTER_FORM_MODEL;
        this.initValue = new PesticideListFilterForm();
    }
    /**
     * @return {?}
     */
    PesticideListFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.cultivationCropChangesSubscription = this.dictionariesService.getItems(DictionaryType.CultivationCrop)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} cultivationCrops
         * @return {?}
         */
        function (cultivationCrops) {
            /** @type {?} */
            var filterGroup = (/** @type {?} */ (_this.formModel.find((/**
             * @param {?} y
             * @return {?}
             */
            function (y) { return y.id === PESTICIDE_LIST_FILTER_GROUP; }))));
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var cultivationCropFormModel = (/** @type {?} */ (filterGroup.group.find((/**
             * @param {?} y
             * @return {?}
             */
            function (y) { return y.id === PESTICIDE_LIST_FILTER_CULTIVATION_CROP; }))));
            cultivationCropFormModel.items = __spread([CULTIVATION_CROP_SELECT], cultivationCrops);
            _this.searchForm.refreshFormModel.next(true);
        }));
    };
    /**
     * @return {?}
     */
    PesticideListFilterComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.cultivationCropChangesSubscription.unsubscribe();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    PesticideListFilterComponent.prototype.onSearch = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var pesticide = $event[PESTICIDE_LIST_FILTER_GROUP][PESTICIDE_LIST_FILTER_PESTICIDE_NAME];
        /** @type {?} */
        var pesticideName = isEmpty(pesticide) ? null : JSON.parse(pesticide).name;
        /** @type {?} */
        var crop = $event[PESTICIDE_LIST_FILTER_GROUP][PESTICIDE_LIST_FILTER_CULTIVATION_CROP];
        /** @type {?} */
        var filter = new PesticideListFilter(pesticideName, crop == null || crop.codeName === CULTIVATION_CROP_SELECT.codeName ? null : crop.codeName, $event[PESTICIDE_LIST_FILTER_GROUP][PESTICIDE_LIST_FILTER_ONLY_ECOLOGICAL] === TrueFalse.True, $event[PESTICIDE_LIST_FILTER_GROUP][PESTICIDE_LIST_FILTER_ACTIVE_SUBSTANCE], $event[PESTICIDE_LIST_FILTER_GROUP][PESTICIDE_LIST_FILTER_AGROFAG]);
        this.search.emit(filter);
    };
    PesticideListFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-pesticide-list-filter',
                    template: "<app-search-form\r\n    #searchForm\r\n    [formModel]=\"formModel\"\r\n    [formLayout]=\"formLayout\"\r\n    [model]=\"initValue\"\r\n    (search)=\"onSearch($event)\"\r\n    [translateKey]=\"translationKey\">\r\n</app-search-form>\r\n"
                }] }
    ];
    /** @nocollapse */
    PesticideListFilterComponent.ctorParameters = function () { return [
        { type: DictionariesService }
    ]; };
    PesticideListFilterComponent.propDecorators = {
        translationKey: [{ type: Input }],
        search: [{ type: Output }],
        searchForm: [{ type: ViewChild, args: ['searchForm', { static: false },] }]
    };
    return PesticideListFilterComponent;
}());
if (false) {
    /** @type {?} */
    PesticideListFilterComponent.prototype.translationKey;
    /** @type {?} */
    PesticideListFilterComponent.prototype.search;
    /** @type {?} */
    PesticideListFilterComponent.prototype.searchForm;
    /** @type {?} */
    PesticideListFilterComponent.prototype.displaySpinner$;
    /** @type {?} */
    PesticideListFilterComponent.prototype.formLayout;
    /** @type {?} */
    PesticideListFilterComponent.prototype.formModel;
    /** @type {?} */
    PesticideListFilterComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    PesticideListFilterComponent.prototype.cultivationCropChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    PesticideListFilterComponent.prototype.dictionariesService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideServicesModule = /** @class */ (function () {
    function PesticideServicesModule() {
    }
    PesticideServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return PesticideServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideSharedModule = /** @class */ (function () {
    function PesticideSharedModule() {
    }
    PesticideSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        PesticideListFilterComponent
                    ],
                    imports: [
                        FormSharedModule,
                        PesticideServicesModule
                    ],
                    exports: [
                        PesticideListFilterComponent
                    ],
                    entryComponents: [
                        PesticideListFilterComponent
                    ]
                },] }
    ];
    return PesticideSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideListItem = /** @class */ (function () {
    function PesticideListItem(id, name, activeSubstances, cultivations, permissionExpirationDate, isEcological, isAvailable, isPromoted) {
        this.id = id;
        this.name = name;
        this.activeSubstances = activeSubstances;
        this.cultivations = cultivations;
        this.permissionExpirationDate = permissionExpirationDate;
        this.isEcological = isEcological;
        this.isAvailable = isAvailable;
        this.isPromoted = isPromoted;
    }
    return PesticideListItem;
}());
if (false) {
    /** @type {?} */
    PesticideListItem.prototype.id;
    /** @type {?} */
    PesticideListItem.prototype.name;
    /** @type {?} */
    PesticideListItem.prototype.activeSubstances;
    /** @type {?} */
    PesticideListItem.prototype.cultivations;
    /** @type {?} */
    PesticideListItem.prototype.permissionExpirationDate;
    /** @type {?} */
    PesticideListItem.prototype.isEcological;
    /** @type {?} */
    PesticideListItem.prototype.isAvailable;
    /** @type {?} */
    PesticideListItem.prototype.isPromoted;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideProxyService = /** @class */ (function () {
    function PesticideProxyService(config, httpClient) {
        this.httpClient = httpClient;
        this.baseApiUrl = config.configuration.api_url + "/api/v1/pesticides";
    }
    /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    PesticideProxyService.prototype.get = /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    function (tenantId, id) {
        /** @type {?} */
        var url = this.baseApiUrl + ("?tenantId=" + tenantId + "&filter=id," + id);
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.items.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === id; })); })));
    };
    /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    PesticideProxyService.prototype.update = /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    function (id, data) {
        /** @type {?} */
        var url = this.baseApiUrl + ("/" + id);
        return this.httpClient.put(url, data);
    };
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    PesticideProxyService.prototype.getList = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        /** @type {?} */
        var url = this.baseApiUrl + '?fields=id,name,activeSubstances,cultivations,permissionExpirationDate,eko,excludedBy,promo';
        if (tenantId != null) {
            url += "&tenantId=" + tenantId;
        }
        if (requestList.page != null) {
            url += "&page=" + (requestList.page + 1);
        }
        if (requestList.pageSize != null) {
            url += "&pageSize=" + requestList.pageSize;
        }
        /** @type {?} */
        var filter = this.getFilters(requestList.filter);
        if (filter != null) {
            url += "&filter=" + filter;
        }
        return this.httpClient.get(url);
    };
    /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    PesticideProxyService.prototype.getFilters = /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    function (filter) {
        if (filter == null) {
            return null;
        }
        /** @type {?} */
        var filters = [];
        if (isEmpty(filter.name) === false) {
            filters.push("name," + filter.name);
        }
        if (isEmpty(filter.cultivationCropCodeName) === false) {
            filters.push("cultivations.name," + filter.cultivationCropCodeName);
        }
        if (isEmpty(filter.agrofag) === false) {
            filters.push("cultivations.agrofag," + filter.agrofag);
        }
        if (filter.onlyEcological) {
            filters.push("eko," + filter.onlyEcological);
        }
        if (isEmpty(filter.activeSubstance) === false) {
            filters.push("activeSubstance.name," + filter.activeSubstance);
        }
        if (isEmpty(filters) === false) {
            return join(filters, ';');
        }
        return null;
    };
    PesticideProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: PesticideServicesModule
                },] }
    ];
    /** @nocollapse */
    PesticideProxyService.ctorParameters = function () { return [
        { type: AppConfigurationService },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ PesticideProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PesticideProxyService_Factory() { return new PesticideProxyService(ɵɵinject(AppConfigurationService), ɵɵinject(HttpClient)); }, token: PesticideProxyService, providedIn: PesticideServicesModule });
    return PesticideProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PesticideProxyService.prototype.baseApiUrl;
    /**
     * @type {?}
     * @private
     */
    PesticideProxyService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Pesticide = /** @class */ (function () {
    function Pesticide(id, name, gracePeriod, isAvailable, isPromoted, usagePeriods) {
        this.id = id;
        this.name = name;
        this.gracePeriod = gracePeriod;
        this.isAvailable = isAvailable;
        this.isPromoted = isPromoted;
        this.usagePeriods = usagePeriods;
    }
    return Pesticide;
}());
if (false) {
    /** @type {?} */
    Pesticide.prototype.id;
    /** @type {?} */
    Pesticide.prototype.name;
    /** @type {?} */
    Pesticide.prototype.gracePeriod;
    /** @type {?} */
    Pesticide.prototype.isAvailable;
    /** @type {?} */
    Pesticide.prototype.isPromoted;
    /** @type {?} */
    Pesticide.prototype.usagePeriods;
}
var PesticideUsageDate = /** @class */ (function () {
    function PesticideUsageDate(startMonth, startDay, endMonth, endDay) {
        this.startMonth = startMonth;
        this.startDay = startDay;
        this.endMonth = endMonth;
        this.endDay = endDay;
    }
    return PesticideUsageDate;
}());
if (false) {
    /** @type {?} */
    PesticideUsageDate.prototype.startMonth;
    /** @type {?} */
    PesticideUsageDate.prototype.startDay;
    /** @type {?} */
    PesticideUsageDate.prototype.endMonth;
    /** @type {?} */
    PesticideUsageDate.prototype.endDay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideService = /** @class */ (function () {
    function PesticideService(dateUtilService, pesticideProxyService) {
        this.dateUtilService = dateUtilService;
        this.pesticideProxyService = pesticideProxyService;
    }
    /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    PesticideService.prototype.get = /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    function (tenantId, id) {
        var _this = this;
        return this.pesticideProxyService.get(tenantId, id)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return (_this.toPesticide(tenantId, result)); })));
    };
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    PesticideService.prototype.getList = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        var _this = this;
        return this.pesticideProxyService.getList(tenantId, requestList)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return ((/** @type {?} */ ({
            items: result.items.map((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return _this.toPesticideListItem(tenantId, item); })),
            pager: result.pager
        }))); })));
    };
    /**
     * @param {?} tenantId
     * @param {?} id
     * @param {?} command
     * @return {?}
     */
    PesticideService.prototype.update = /**
     * @param {?} tenantId
     * @param {?} id
     * @param {?} command
     * @return {?}
     */
    function (tenantId, id, command) {
        var _this = this;
        return this.pesticideProxyService.get(tenantId, id)
            .pipe(switchMap((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var excludedBy = data.excludedBy || [];
            if (command.isAvailable) {
                data.excludedBy = remove(excludedBy, (/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x === tenantId; }));
            }
            else if (excludedBy.some((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x === tenantId; })) === false) {
                excludedBy.push(tenantId);
                data.excludedBy = excludedBy;
            }
            /** @type {?} */
            var promo = data.promo || [];
            if (command.isPromoted === false) {
                data.promo = remove(promo, (/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x === tenantId; }));
            }
            else if (promo.some((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x === tenantId; })) === false) {
                promo.push(tenantId);
                data.promo = promo;
            }
            data.gracePeriods = command.gracePeriod != null && command.gracePeriod > 0
                ? [command.gracePeriod]
                : [];
            data.usagePeriods = (command.usagePeriods || []).map((/**
             * @param {?} period
             * @return {?}
             */
            function (period) { return ({
                startMonth: period.startMonth,
                startDay: period.startDay,
                endMonth: period.endMonth,
                endDay: period.endDay
            }); }));
            return _this.pesticideProxyService.update(id, data);
        })));
    };
    /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    PesticideService.prototype.toPesticideListItem = /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    function (tenantId, item) {
        return new PesticideListItem(item.id, item.name, (item.activeSubstances || []).map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.name; })), (item.cultivations || []).map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return ({ name: x.name, agrofags: x.agrofags || [] }); })), 
        // tslint:disable-next-line: no-magic-numbers
        this.dateUtilService.fromTimestampToDate(item.permissionExpirationDate * 10).toString(), item.eko, item.excludedBy == null || item.excludedBy.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })) === false, item.promo != null && item.promo.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })));
    };
    /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    PesticideService.prototype.toPesticide = /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    function (tenantId, item) {
        return new Pesticide(item.id, item.name, item.gracePeriods != null && item.gracePeriods.length > 0 ? item.gracePeriods[0] : null, item.excludedBy == null || item.excludedBy.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })) === false, item.promo != null && item.promo.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })), (item.usagePeriods || []).map((/**
         * @param {?} period
         * @return {?}
         */
        function (period) {
            return new PesticideUsageDate(period.startMonth, period.startDay, period.endMonth, period.endDay);
        })));
    };
    PesticideService.decorators = [
        { type: Injectable, args: [{
                    providedIn: PesticideServicesModule
                },] }
    ];
    /** @nocollapse */
    PesticideService.ctorParameters = function () { return [
        { type: DateUtilService },
        { type: PesticideProxyService }
    ]; };
    /** @nocollapse */ PesticideService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PesticideService_Factory() { return new PesticideService(ɵɵinject(DateUtilService), ɵɵinject(PesticideProxyService)); }, token: PesticideService, providedIn: PesticideServicesModule });
    return PesticideService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PesticideService.prototype.dateUtilService;
    /**
     * @type {?}
     * @private
     */
    PesticideService.prototype.pesticideProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpdatePesticideCommand = /** @class */ (function () {
    function UpdatePesticideCommand() {
    }
    return UpdatePesticideCommand;
}());
if (false) {
    /** @type {?} */
    UpdatePesticideCommand.prototype.gracePeriod;
    /** @type {?} */
    UpdatePesticideCommand.prototype.isAvailable;
    /** @type {?} */
    UpdatePesticideCommand.prototype.isPromoted;
    /** @type {?} */
    UpdatePesticideCommand.prototype.usagePeriods;
}
var UpdatePesticidePeriodCommand = /** @class */ (function () {
    function UpdatePesticidePeriodCommand() {
    }
    return UpdatePesticidePeriodCommand;
}());
if (false) {
    /** @type {?} */
    UpdatePesticidePeriodCommand.prototype.startMonth;
    /** @type {?} */
    UpdatePesticidePeriodCommand.prototype.startDay;
    /** @type {?} */
    UpdatePesticidePeriodCommand.prototype.endMonth;
    /** @type {?} */
    UpdatePesticidePeriodCommand.prototype.endDay;
}

var _a$a;
/** @type {?} */
var CULTIVATION_CROP_SELECT$1 = (/** @type {?} */ ({
    codeName: 'Cultivation.select',
    dictionaryType: 'CULTIVATION',
    cultivationCategory: 'Cultivation.select'
}));
/** @type {?} */
var SEED_LIST_FILTER_GROUP = 'filterGroup';
/** @type {?} */
var SEED_LIST_FILTER_SEED_NAME = 'seedName';
/** @type {?} */
var SEED_LIST_FILTER_CULTIVATION_CROP = 'type';
/** @type {?} */
var SEED_SEARCH_FILTER_FORM_LAYOUT = (_a$a = {},
    _a$a[SEED_LIST_FILTER_GROUP] = {
        grid: {
            host: 'w-100 mt-1 ',
            container: 'form-layout-group-header-hidden',
            label: 'col-12 px-0'
        },
        element: {
            control: 'row'
        }
    },
    _a$a[SEED_LIST_FILTER_SEED_NAME] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$a[SEED_LIST_FILTER_CULTIVATION_CROP] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$a);
/** @type {?} */
var TRANSLATION_DICTIONARY_KEY$1 = 'APPLICATION.DICTIONARIES';
/** @type {?} */
var SEED_SEARCH_FILTER_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: SEED_LIST_FILTER_GROUP,
        group: [
            new DynamicInputModel({
                id: SEED_LIST_FILTER_SEED_NAME
            }),
            new DynamicMultiSelectControlModel({
                id: SEED_LIST_FILTER_CULTIVATION_CROP,
                bindLabel: nameof('codeName'),
                groupBy: nameof('cultivationCategory'),
                multiple: false,
                translationPrefix: TRANSLATION_DICTIONARY_KEY$1,
                searchByField: nameof('codeName')
            })
        ]
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedListFilterForm = /** @class */ (function () {
    function SeedListFilterForm() {
        var _a;
        this[SEED_LIST_FILTER_GROUP] = (_a = {},
            _a[SEED_LIST_FILTER_SEED_NAME] = '',
            _a[SEED_LIST_FILTER_CULTIVATION_CROP] = CULTIVATION_CROP_SELECT$1,
            _a);
    }
    return SeedListFilterForm;
}());
if (false) {
    /* Skipping unnamed member:
    [SEED_LIST_FILTER_GROUP]: {
            [SEED_LIST_FILTER_SEED_NAME]: string,
            [SEED_LIST_FILTER_CULTIVATION_CROP]: ICultivationDictionaryModel,
        }*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedListFilter = /** @class */ (function () {
    function SeedListFilter(name, type) {
        this.name = name;
        this.type = type;
    }
    return SeedListFilter;
}());
if (false) {
    /** @type {?} */
    SeedListFilter.prototype.name;
    /** @type {?} */
    SeedListFilter.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedListFilterComponent = /** @class */ (function () {
    function SeedListFilterComponent(dictionariesService) {
        this.dictionariesService = dictionariesService;
        this.search = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(true);
        this.formLayout = SEED_SEARCH_FILTER_FORM_LAYOUT;
        this.formModel = SEED_SEARCH_FILTER_FORM_MODEL;
        this.initValue = new SeedListFilterForm();
    }
    /**
     * @return {?}
     */
    SeedListFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.cultivationCropChangesSubscription = this.dictionariesService.getItems(DictionaryType.CultivationCrop)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} cultivationCrops
         * @return {?}
         */
        function (cultivationCrops) {
            /** @type {?} */
            var filterGroup = (/** @type {?} */ (_this.formModel.find((/**
             * @param {?} y
             * @return {?}
             */
            function (y) { return y.id === SEED_LIST_FILTER_GROUP; }))));
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var cultivationCropFormModel = (/** @type {?} */ (filterGroup.group.find((/**
             * @param {?} y
             * @return {?}
             */
            function (y) { return y.id === SEED_LIST_FILTER_CULTIVATION_CROP; }))));
            cultivationCropFormModel.items = __spread([CULTIVATION_CROP_SELECT$1], cultivationCrops);
            _this.searchForm.refreshFormModel.next(true);
        }));
    };
    /**
     * @return {?}
     */
    SeedListFilterComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.cultivationCropChangesSubscription.unsubscribe();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    SeedListFilterComponent.prototype.onSearch = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var seed = $event[SEED_LIST_FILTER_GROUP][SEED_LIST_FILTER_SEED_NAME];
        /** @type {?} */
        var seedName = isEmpty(seed) ? null : seed;
        /** @type {?} */
        var crop = $event[SEED_LIST_FILTER_GROUP][SEED_LIST_FILTER_CULTIVATION_CROP];
        /** @type {?} */
        var filter = new SeedListFilter(seedName, crop == null || crop.codeName === CULTIVATION_CROP_SELECT$1.codeName ? null : crop.codeName);
        this.search.emit(filter);
    };
    SeedListFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-seed-list-filter',
                    template: "<app-search-form\r\n    #searchForm\r\n    [formModel]=\"formModel\"\r\n    [formLayout]=\"formLayout\"\r\n    [model]=\"initValue\"\r\n    (search)=\"onSearch($event)\"\r\n    [translateKey]=\"translationKey\">\r\n</app-search-form>\r\n"
                }] }
    ];
    /** @nocollapse */
    SeedListFilterComponent.ctorParameters = function () { return [
        { type: DictionariesService }
    ]; };
    SeedListFilterComponent.propDecorators = {
        translationKey: [{ type: Input }],
        search: [{ type: Output }],
        searchForm: [{ type: ViewChild, args: ['searchForm', { static: false },] }]
    };
    return SeedListFilterComponent;
}());
if (false) {
    /** @type {?} */
    SeedListFilterComponent.prototype.translationKey;
    /** @type {?} */
    SeedListFilterComponent.prototype.search;
    /** @type {?} */
    SeedListFilterComponent.prototype.searchForm;
    /** @type {?} */
    SeedListFilterComponent.prototype.displaySpinner$;
    /** @type {?} */
    SeedListFilterComponent.prototype.formLayout;
    /** @type {?} */
    SeedListFilterComponent.prototype.formModel;
    /** @type {?} */
    SeedListFilterComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    SeedListFilterComponent.prototype.cultivationCropChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    SeedListFilterComponent.prototype.dictionariesService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedServicesModule = /** @class */ (function () {
    function SeedServicesModule() {
    }
    SeedServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return SeedServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedSharedModule = /** @class */ (function () {
    function SeedSharedModule() {
    }
    SeedSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SeedListFilterComponent
                    ],
                    imports: [
                        FormSharedModule,
                        SeedServicesModule
                    ],
                    exports: [
                        SeedListFilterComponent
                    ],
                    entryComponents: [
                        SeedListFilterComponent
                    ]
                },] }
    ];
    return SeedSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedListItem = /** @class */ (function () {
    function SeedListItem(id, name, type, isAvailable, producer, isPromoted) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.isAvailable = isAvailable;
        this.producer = producer;
        this.isPromoted = isPromoted;
    }
    return SeedListItem;
}());
if (false) {
    /** @type {?} */
    SeedListItem.prototype.id;
    /** @type {?} */
    SeedListItem.prototype.name;
    /** @type {?} */
    SeedListItem.prototype.type;
    /** @type {?} */
    SeedListItem.prototype.isAvailable;
    /** @type {?} */
    SeedListItem.prototype.producer;
    /** @type {?} */
    SeedListItem.prototype.isPromoted;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedProxyService = /** @class */ (function () {
    function SeedProxyService(config, httpClient) {
        this.httpClient = httpClient;
        this.baseApiUrl = config.configuration.api_url + "/api/v1/seeds";
    }
    /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    SeedProxyService.prototype.get = /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    function (tenantId, id) {
        /** @type {?} */
        var url = this.baseApiUrl + ("?tenantId=" + tenantId + "&filter=id," + id);
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.items.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === id; })); })));
    };
    /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    SeedProxyService.prototype.update = /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    function (id, data) {
        /** @type {?} */
        var url = this.baseApiUrl + ("/" + id);
        return this.httpClient.put(url, data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    SeedProxyService.prototype.create = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.httpClient.post(this.baseApiUrl, data);
    };
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    SeedProxyService.prototype.getList = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        /** @type {?} */
        var url = this.baseApiUrl + '?fields=id,name,type,producer,eko,excludedBy,promo';
        if (tenantId != null) {
            url += "&tenantId=" + tenantId;
        }
        if (requestList.page != null) {
            url += "&page=" + (requestList.page + 1);
        }
        if (requestList.pageSize != null) {
            url += "&pageSize=" + requestList.pageSize;
        }
        /** @type {?} */
        var filter = this.getFilters(requestList.filter);
        if (filter != null) {
            url += "&filter=" + filter;
        }
        return this.httpClient.get(url);
    };
    /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    SeedProxyService.prototype.getFilters = /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    function (filter) {
        if (filter == null) {
            return null;
        }
        /** @type {?} */
        var filters = [];
        if (isEmpty(filter.name) === false) {
            filters.push("name," + filter.name);
        }
        if (isEmpty(filter.type) === false) {
            filters.push("type," + filter.type);
        }
        if (isEmpty(filters) === false) {
            return join(filters, ';');
        }
        return null;
    };
    SeedProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: SeedServicesModule
                },] }
    ];
    /** @nocollapse */
    SeedProxyService.ctorParameters = function () { return [
        { type: AppConfigurationService },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ SeedProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SeedProxyService_Factory() { return new SeedProxyService(ɵɵinject(AppConfigurationService), ɵɵinject(HttpClient)); }, token: SeedProxyService, providedIn: SeedServicesModule });
    return SeedProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SeedProxyService.prototype.baseApiUrl;
    /**
     * @type {?}
     * @private
     */
    SeedProxyService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Seed = /** @class */ (function () {
    function Seed(id, name, type, producer, isAvailable, isPromoted) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.producer = producer;
        this.isAvailable = isAvailable;
        this.isPromoted = isPromoted;
    }
    return Seed;
}());
if (false) {
    /** @type {?} */
    Seed.prototype.id;
    /** @type {?} */
    Seed.prototype.name;
    /** @type {?} */
    Seed.prototype.type;
    /** @type {?} */
    Seed.prototype.producer;
    /** @type {?} */
    Seed.prototype.isAvailable;
    /** @type {?} */
    Seed.prototype.isPromoted;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedService = /** @class */ (function () {
    function SeedService(dateUtilService, seedProxyService) {
        this.dateUtilService = dateUtilService;
        this.seedProxyService = seedProxyService;
    }
    /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    SeedService.prototype.get = /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    function (tenantId, id) {
        var _this = this;
        return this.seedProxyService.get(tenantId, id)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return (_this.toSeed(tenantId, result)); })));
    };
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    SeedService.prototype.getList = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        var _this = this;
        return this.seedProxyService.getList(tenantId, requestList)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return ((/** @type {?} */ ({
            items: result.items.map((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return _this.toSeedListItem(tenantId, item); })),
            pager: result.pager
        }))); })));
    };
    /**
     * @param {?} tenantId
     * @param {?} id
     * @param {?} command
     * @return {?}
     */
    SeedService.prototype.update = /**
     * @param {?} tenantId
     * @param {?} id
     * @param {?} command
     * @return {?}
     */
    function (tenantId, id, command) {
        var _this = this;
        return this.seedProxyService.get(tenantId, id)
            .pipe(switchMap((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var excludedBy = data.excludedBy || [];
            if (command.isAvailable) {
                data.excludedBy = remove(excludedBy, (/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x === tenantId; }));
            }
            else if (excludedBy.some((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x === tenantId; })) === false) {
                excludedBy.push(tenantId);
                data.excludedBy = excludedBy;
            }
            /** @type {?} */
            var promo = data.promo || [];
            if (command.isPromoted === false) {
                data.promo = remove(promo, (/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x === tenantId; }));
            }
            else if (promo.some((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x === tenantId; })) === false) {
                promo.push(tenantId);
                data.promo = promo;
            }
            data.producer = command.producer;
            data.name = command.name;
            data.type = command.type;
            return _this.seedProxyService.update(id, data);
        })));
    };
    /**
     * @param {?} tenantId
     * @param {?} command
     * @return {?}
     */
    SeedService.prototype.create = /**
     * @param {?} tenantId
     * @param {?} command
     * @return {?}
     */
    function (tenantId, command) {
        /** @type {?} */
        var data = (/** @type {?} */ (__assign({}, command, { owner: tenantId, partitionKey: 'Seed' })));
        return this.seedProxyService.create(data);
    };
    /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    SeedService.prototype.toSeedListItem = /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    function (tenantId, item) {
        return new SeedListItem(item.id, item.name, item.type, item.excludedBy == null || item.excludedBy.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })) === false, item.producer, item.promo != null && item.promo.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })));
    };
    /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    SeedService.prototype.toSeed = /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    function (tenantId, item) {
        return new Seed(item.id, item.name, item.type, item.producer, item.excludedBy == null || item.excludedBy.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })) === false, item.promo != null && item.promo.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })));
    };
    SeedService.decorators = [
        { type: Injectable, args: [{
                    providedIn: SeedServicesModule
                },] }
    ];
    /** @nocollapse */
    SeedService.ctorParameters = function () { return [
        { type: DateUtilService },
        { type: SeedProxyService }
    ]; };
    /** @nocollapse */ SeedService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SeedService_Factory() { return new SeedService(ɵɵinject(DateUtilService), ɵɵinject(SeedProxyService)); }, token: SeedService, providedIn: SeedServicesModule });
    return SeedService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SeedService.prototype.dateUtilService;
    /**
     * @type {?}
     * @private
     */
    SeedService.prototype.seedProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpdateSeedCommand = /** @class */ (function () {
    function UpdateSeedCommand() {
    }
    return UpdateSeedCommand;
}());
if (false) {
    /** @type {?} */
    UpdateSeedCommand.prototype.isAvailable;
    /** @type {?} */
    UpdateSeedCommand.prototype.isPromoted;
    /** @type {?} */
    UpdateSeedCommand.prototype.type;
    /** @type {?} */
    UpdateSeedCommand.prototype.producer;
    /** @type {?} */
    UpdateSeedCommand.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SeedListItemDto() { }
if (false) {
    /** @type {?} */
    SeedListItemDto.prototype.type;
    /** @type {?} */
    SeedListItemDto.prototype.name;
    /** @type {?} */
    SeedListItemDto.prototype.partitionKey;
    /** @type {?} */
    SeedListItemDto.prototype.excludedBy;
    /** @type {?} */
    SeedListItemDto.prototype.promo;
    /** @type {?} */
    SeedListItemDto.prototype.id;
    /** @type {?} */
    SeedListItemDto.prototype.producer;
    /** @type {?} */
    SeedListItemDto.prototype.owner;
}

var _a$b;
/** @type {?} */
var FERTILIZER_LIST_FILTER_GROUP = 'filterGroup';
/** @type {?} */
var FERTILIZER_LIST_FILTER_FERTILIZER_NAME = 'fertilizerName';
/** @type {?} */
var FERTILIZER_SEARCH_FILTER_FORM_LAYOUT = (_a$b = {},
    _a$b[FERTILIZER_LIST_FILTER_GROUP] = {
        grid: {
            host: 'w-100 mt-1 ',
            container: 'form-layout-group-header-hidden',
            label: 'col-12 px-0'
        },
        element: {
            control: 'row'
        }
    },
    _a$b[FERTILIZER_LIST_FILTER_FERTILIZER_NAME] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$b);
/** @type {?} */
var TRANSLATION_DICTIONARY_KEY$2 = 'APPLICATION.DICTIONARIES';
/** @type {?} */
var FERTILIZER_SEARCH_FILTER_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: FERTILIZER_LIST_FILTER_GROUP,
        group: [
            new DynamicInputModel({
                id: FERTILIZER_LIST_FILTER_FERTILIZER_NAME
            })
        ]
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerListFilterForm = /** @class */ (function () {
    function FertilizerListFilterForm() {
        var _a;
        this[FERTILIZER_LIST_FILTER_GROUP] = (_a = {},
            _a[FERTILIZER_LIST_FILTER_FERTILIZER_NAME] = '',
            _a);
    }
    return FertilizerListFilterForm;
}());
if (false) {
    /* Skipping unnamed member:
    [FERTILIZER_LIST_FILTER_GROUP]: {
            [FERTILIZER_LIST_FILTER_FERTILIZER_NAME]: string
        }*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerListFilter = /** @class */ (function () {
    function FertilizerListFilter(name) {
        this.name = name;
    }
    return FertilizerListFilter;
}());
if (false) {
    /** @type {?} */
    FertilizerListFilter.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerListFilterComponent = /** @class */ (function () {
    function FertilizerListFilterComponent() {
        this.search = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(true);
        this.formLayout = FERTILIZER_SEARCH_FILTER_FORM_LAYOUT;
        this.formModel = FERTILIZER_SEARCH_FILTER_FORM_MODEL;
        this.initValue = new FertilizerListFilterForm();
    }
    /**
     * @return {?}
     */
    FertilizerListFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.displaySpinner$.next(true);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FertilizerListFilterComponent.prototype.onSearch = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var fertilizer = $event[FERTILIZER_LIST_FILTER_GROUP][FERTILIZER_LIST_FILTER_FERTILIZER_NAME];
        /** @type {?} */
        var fertilizerName = isEmpty(fertilizer) ? null : fertilizer;
        /** @type {?} */
        var filter = new FertilizerListFilter(fertilizerName);
        this.search.emit(filter);
    };
    FertilizerListFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-fertilizer-list-filter',
                    template: "<app-search-form\r\n    #searchForm\r\n    [formModel]=\"formModel\"\r\n    [formLayout]=\"formLayout\"\r\n    [model]=\"initValue\"\r\n    (search)=\"onSearch($event)\"\r\n    [translateKey]=\"translationKey\">\r\n</app-search-form>\r\n"
                }] }
    ];
    /** @nocollapse */
    FertilizerListFilterComponent.ctorParameters = function () { return []; };
    FertilizerListFilterComponent.propDecorators = {
        translationKey: [{ type: Input }],
        search: [{ type: Output }],
        searchForm: [{ type: ViewChild, args: ['searchForm', { static: false },] }]
    };
    return FertilizerListFilterComponent;
}());
if (false) {
    /** @type {?} */
    FertilizerListFilterComponent.prototype.translationKey;
    /** @type {?} */
    FertilizerListFilterComponent.prototype.search;
    /** @type {?} */
    FertilizerListFilterComponent.prototype.searchForm;
    /** @type {?} */
    FertilizerListFilterComponent.prototype.displaySpinner$;
    /** @type {?} */
    FertilizerListFilterComponent.prototype.formLayout;
    /** @type {?} */
    FertilizerListFilterComponent.prototype.formModel;
    /** @type {?} */
    FertilizerListFilterComponent.prototype.initValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerServicesModule = /** @class */ (function () {
    function FertilizerServicesModule() {
    }
    FertilizerServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return FertilizerServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerSharedModule = /** @class */ (function () {
    function FertilizerSharedModule() {
    }
    FertilizerSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        FertilizerListFilterComponent
                    ],
                    imports: [
                        FormSharedModule,
                        FertilizerServicesModule
                    ],
                    exports: [
                        FertilizerListFilterComponent
                    ],
                    entryComponents: [
                        FertilizerListFilterComponent
                    ]
                },] }
    ];
    return FertilizerSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerListItem = /** @class */ (function () {
    function FertilizerListItem(id, name, type, isAvailable, producer, isPromoted) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.isAvailable = isAvailable;
        this.producer = producer;
        this.isPromoted = isPromoted;
    }
    return FertilizerListItem;
}());
if (false) {
    /** @type {?} */
    FertilizerListItem.prototype.id;
    /** @type {?} */
    FertilizerListItem.prototype.name;
    /** @type {?} */
    FertilizerListItem.prototype.type;
    /** @type {?} */
    FertilizerListItem.prototype.isAvailable;
    /** @type {?} */
    FertilizerListItem.prototype.producer;
    /** @type {?} */
    FertilizerListItem.prototype.isPromoted;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerProxyService = /** @class */ (function () {
    function FertilizerProxyService(config, httpClient) {
        this.httpClient = httpClient;
        this.baseApiUrl = config.configuration.api_url + "/api/v1/fertilizers";
    }
    /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    FertilizerProxyService.prototype.get = /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    function (tenantId, id) {
        /** @type {?} */
        var url = this.baseApiUrl + ("?tenantId=" + tenantId + "&filter=id," + id);
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.items.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.id === id; })); })));
    };
    /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    FertilizerProxyService.prototype.update = /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    function (id, data) {
        /** @type {?} */
        var url = this.baseApiUrl + ("/" + id);
        return this.httpClient.put(url, data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    FertilizerProxyService.prototype.create = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.httpClient.post(this.baseApiUrl, data);
    };
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    FertilizerProxyService.prototype.getList = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        /** @type {?} */
        var url = this.baseApiUrl + '?fields=id,name,type,producer,eko,excludedBy,promo';
        if (tenantId != null) {
            url += "&tenantId=" + tenantId;
        }
        if (requestList.page != null) {
            url += "&page=" + (requestList.page + 1);
        }
        if (requestList.pageSize != null) {
            url += "&pageSize=" + requestList.pageSize;
        }
        /** @type {?} */
        var filter = this.getFilters(requestList.filter);
        if (filter != null) {
            url += "&filter=" + filter;
        }
        return this.httpClient.get(url);
    };
    /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    FertilizerProxyService.prototype.getFilters = /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    function (filter) {
        if (filter == null) {
            return null;
        }
        /** @type {?} */
        var filters = [];
        if (isEmpty(filter.name) === false) {
            filters.push("name," + filter.name);
        }
        if (isEmpty(filters) === false) {
            return join(filters, ';');
        }
        return null;
    };
    FertilizerProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: FertilizerServicesModule
                },] }
    ];
    /** @nocollapse */
    FertilizerProxyService.ctorParameters = function () { return [
        { type: AppConfigurationService },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ FertilizerProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FertilizerProxyService_Factory() { return new FertilizerProxyService(ɵɵinject(AppConfigurationService), ɵɵinject(HttpClient)); }, token: FertilizerProxyService, providedIn: FertilizerServicesModule });
    return FertilizerProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FertilizerProxyService.prototype.baseApiUrl;
    /**
     * @type {?}
     * @private
     */
    FertilizerProxyService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerService = /** @class */ (function () {
    function FertilizerService(fertilizerProxyService) {
        this.fertilizerProxyService = fertilizerProxyService;
    }
    /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    FertilizerService.prototype.get = /**
     * @param {?} tenantId
     * @param {?} id
     * @return {?}
     */
    function (tenantId, id) {
        return this.fertilizerProxyService.get(tenantId, id);
    };
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    FertilizerService.prototype.getList = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        var _this = this;
        return this.fertilizerProxyService.getList(tenantId, requestList)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return ((/** @type {?} */ ({
            items: result.items.map((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return _this.toSeedListItem(tenantId, item); })),
            pager: result.pager
        }))); })));
    };
    /**
     * @param {?} tenantId
     * @param {?} id
     * @param {?} command
     * @return {?}
     */
    FertilizerService.prototype.update = /**
     * @param {?} tenantId
     * @param {?} id
     * @param {?} command
     * @return {?}
     */
    function (tenantId, id, command) {
        var _this = this;
        return this.fertilizerProxyService.get(tenantId, id)
            .pipe(switchMap((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var excludedBy = data.excludedBy || [];
            if (command.isAvailable) {
                data.excludedBy = remove(excludedBy, (/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x === tenantId; }));
            }
            else if (excludedBy.some((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x === tenantId; })) === false) {
                excludedBy.push(tenantId);
                data.excludedBy = excludedBy;
            }
            /** @type {?} */
            var promo = data.promo || [];
            if (command.isPromoted === false) {
                data.promo = remove(promo, (/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return x === tenantId; }));
            }
            else if (promo.some((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x === tenantId; })) === false) {
                promo.push(tenantId);
                data.promo = promo;
            }
            data.producer = command.producer;
            data.name = command.name;
            data.type = command.type;
            // composition values
            data.nitrogen = command.nitrogen;
            data.phosphorus = command.phosphorus;
            data.calcium = command.calcium;
            data.magnesium = command.magnesium;
            data.potassium = command.potassium;
            data.sulfur = command.sulfur;
            data.boron = command.boron;
            data.selenium = command.selenium;
            data.copper = command.copper;
            data.iron = command.iron;
            data.zinc = command.zinc;
            data.sodium = command.sodium;
            data.density = command.density;
            data.formulation = command.formulation;
            return _this.fertilizerProxyService.update(id, data);
        })));
    };
    /**
     * @param {?} tenantId
     * @param {?} command
     * @return {?}
     */
    FertilizerService.prototype.create = /**
     * @param {?} tenantId
     * @param {?} command
     * @return {?}
     */
    function (tenantId, command) {
        /** @type {?} */
        var data = (/** @type {?} */ (__assign({}, command, { owner: tenantId, partitionKey: 'Fertilizer' })));
        return this.fertilizerProxyService.create(data);
    };
    /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    FertilizerService.prototype.toSeedListItem = /**
     * @private
     * @param {?} tenantId
     * @param {?} item
     * @return {?}
     */
    function (tenantId, item) {
        return new FertilizerListItem(item.id, item.name, item.type, item.excludedBy == null || item.excludedBy.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })) === false, item.producer, item.promo != null && item.promo.some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === tenantId; })));
    };
    FertilizerService.decorators = [
        { type: Injectable, args: [{
                    providedIn: FertilizerServicesModule
                },] }
    ];
    /** @nocollapse */
    FertilizerService.ctorParameters = function () { return [
        { type: FertilizerProxyService }
    ]; };
    /** @nocollapse */ FertilizerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FertilizerService_Factory() { return new FertilizerService(ɵɵinject(FertilizerProxyService)); }, token: FertilizerService, providedIn: FertilizerServicesModule });
    return FertilizerService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FertilizerService.prototype.fertilizerProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Fertilizer = /** @class */ (function () {
    function Fertilizer(id, name, type, producer, isAvailable, isPromoted, formulation, density, sodium, zinc, iron, copper, selenium, boron, sulfur, potassium, magnesium, calcium, phosphorus, nitrogen) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.producer = producer;
        this.isAvailable = isAvailable;
        this.isPromoted = isPromoted;
        this.formulation = formulation;
        this.density = density;
        this.sodium = sodium;
        this.zinc = zinc;
        this.iron = iron;
        this.copper = copper;
        this.selenium = selenium;
        this.boron = boron;
        this.sulfur = sulfur;
        this.potassium = potassium;
        this.magnesium = magnesium;
        this.calcium = calcium;
        this.phosphorus = phosphorus;
        this.nitrogen = nitrogen;
    }
    return Fertilizer;
}());
if (false) {
    /** @type {?} */
    Fertilizer.prototype.id;
    /** @type {?} */
    Fertilizer.prototype.name;
    /** @type {?} */
    Fertilizer.prototype.type;
    /** @type {?} */
    Fertilizer.prototype.producer;
    /** @type {?} */
    Fertilizer.prototype.isAvailable;
    /** @type {?} */
    Fertilizer.prototype.isPromoted;
    /** @type {?} */
    Fertilizer.prototype.formulation;
    /** @type {?} */
    Fertilizer.prototype.density;
    /** @type {?} */
    Fertilizer.prototype.sodium;
    /** @type {?} */
    Fertilizer.prototype.zinc;
    /** @type {?} */
    Fertilizer.prototype.iron;
    /** @type {?} */
    Fertilizer.prototype.copper;
    /** @type {?} */
    Fertilizer.prototype.selenium;
    /** @type {?} */
    Fertilizer.prototype.boron;
    /** @type {?} */
    Fertilizer.prototype.sulfur;
    /** @type {?} */
    Fertilizer.prototype.potassium;
    /** @type {?} */
    Fertilizer.prototype.magnesium;
    /** @type {?} */
    Fertilizer.prototype.calcium;
    /** @type {?} */
    Fertilizer.prototype.phosphorus;
    /** @type {?} */
    Fertilizer.prototype.nitrogen;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerDto = /** @class */ (function () {
    function FertilizerDto(id, name, type, producer, excludedBy, promo, formulation, density, sodium, zinc, iron, copper, selenium, boron, sulfur, potassium, magnesium, calcium, phosphorus, nitrogen) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.producer = producer;
        this.excludedBy = excludedBy;
        this.promo = promo;
        this.formulation = formulation;
        this.density = density;
        this.sodium = sodium;
        this.zinc = zinc;
        this.iron = iron;
        this.copper = copper;
        this.selenium = selenium;
        this.boron = boron;
        this.sulfur = sulfur;
        this.potassium = potassium;
        this.magnesium = magnesium;
        this.calcium = calcium;
        this.phosphorus = phosphorus;
        this.nitrogen = nitrogen;
    }
    return FertilizerDto;
}());
if (false) {
    /** @type {?} */
    FertilizerDto.prototype.id;
    /** @type {?} */
    FertilizerDto.prototype.name;
    /** @type {?} */
    FertilizerDto.prototype.type;
    /** @type {?} */
    FertilizerDto.prototype.producer;
    /** @type {?} */
    FertilizerDto.prototype.excludedBy;
    /** @type {?} */
    FertilizerDto.prototype.promo;
    /** @type {?} */
    FertilizerDto.prototype.formulation;
    /** @type {?} */
    FertilizerDto.prototype.density;
    /** @type {?} */
    FertilizerDto.prototype.sodium;
    /** @type {?} */
    FertilizerDto.prototype.zinc;
    /** @type {?} */
    FertilizerDto.prototype.iron;
    /** @type {?} */
    FertilizerDto.prototype.copper;
    /** @type {?} */
    FertilizerDto.prototype.selenium;
    /** @type {?} */
    FertilizerDto.prototype.boron;
    /** @type {?} */
    FertilizerDto.prototype.sulfur;
    /** @type {?} */
    FertilizerDto.prototype.potassium;
    /** @type {?} */
    FertilizerDto.prototype.magnesium;
    /** @type {?} */
    FertilizerDto.prototype.calcium;
    /** @type {?} */
    FertilizerDto.prototype.phosphorus;
    /** @type {?} */
    FertilizerDto.prototype.nitrogen;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpdateFertilizerCommand = /** @class */ (function () {
    function UpdateFertilizerCommand() {
    }
    return UpdateFertilizerCommand;
}());
if (false) {
    /** @type {?} */
    UpdateFertilizerCommand.prototype.name;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.type;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.producer;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.isAvailable;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.isPromoted;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.formulation;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.density;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.sodium;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.zinc;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.iron;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.copper;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.selenium;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.boron;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.sulfur;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.potassium;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.magnesium;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.calcium;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.phosphorus;
    /** @type {?} */
    UpdateFertilizerCommand.prototype.nitrogen;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FertilizerListItemDto() { }
if (false) {
    /** @type {?} */
    FertilizerListItemDto.prototype.type;
    /** @type {?} */
    FertilizerListItemDto.prototype.name;
    /** @type {?} */
    FertilizerListItemDto.prototype.partitionKey;
    /** @type {?} */
    FertilizerListItemDto.prototype.excludedBy;
    /** @type {?} */
    FertilizerListItemDto.prototype.promo;
    /** @type {?} */
    FertilizerListItemDto.prototype.id;
    /** @type {?} */
    FertilizerListItemDto.prototype.producer;
    /** @type {?} */
    FertilizerListItemDto.prototype.owner;
}

var _a$c;
/** @type {?} */
var CULTIVATION_CROP_SELECT$2 = (/** @type {?} */ ({
    codeName: 'Cultivation.select',
    dictionaryType: 'CULTIVATION',
    cultivationCategory: 'Cultivation.select'
}));
/** @type {?} */
var PRODUCT_LIST_FILTER_GROUP = 'filterGroup';
/** @type {?} */
var PRODUCT_LIST_FILTER_ORGANIZATION = 'organization';
/** @type {?} */
var PRODUCT_LIST_FILTER_CULTIVATION_CROP = 'cultivation';
/** @type {?} */
var PRODUCT_SEARCH_FILTER_FORM_LAYOUT = (_a$c = {},
    _a$c[PRODUCT_LIST_FILTER_GROUP] = {
        grid: {
            host: 'w-100 mt-1 ',
            container: 'form-layout-group-header-hidden',
            label: 'col-12 px-0'
        },
        element: {
            control: 'row'
        }
    },
    _a$c[PRODUCT_LIST_FILTER_ORGANIZATION] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$c[PRODUCT_LIST_FILTER_CULTIVATION_CROP] = DEFAULT_FORM_LAYOUT_INPUT,
    _a$c);
/** @type {?} */
var TRANSLATION_DICTIONARY_KEY$3 = 'APPLICATION.DICTIONARIES';
/** @type {?} */
var PRODUCT_SEARCH_FILTER_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: PRODUCT_LIST_FILTER_GROUP,
        group: [
            new DynamicInputModel({
                id: PRODUCT_LIST_FILTER_ORGANIZATION
            }),
            new DynamicMultiSelectControlModel({
                id: PRODUCT_LIST_FILTER_CULTIVATION_CROP,
                bindLabel: nameof('codeName'),
                groupBy: nameof('cultivationCategory'),
                multiple: false,
                translationPrefix: TRANSLATION_DICTIONARY_KEY$3,
                searchByField: nameof('codeName')
            })
        ]
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductListFilterForm = /** @class */ (function () {
    function ProductListFilterForm() {
        var _a;
        this[PRODUCT_LIST_FILTER_GROUP] = (_a = {},
            _a[PRODUCT_LIST_FILTER_ORGANIZATION] = '',
            _a[PRODUCT_LIST_FILTER_CULTIVATION_CROP] = CULTIVATION_CROP_SELECT$2,
            _a);
    }
    return ProductListFilterForm;
}());
if (false) {
    /* Skipping unnamed member:
    [PRODUCT_LIST_FILTER_GROUP]: {
            [PRODUCT_LIST_FILTER_ORGANIZATION]: string,
            [PRODUCT_LIST_FILTER_CULTIVATION_CROP]: ICultivationDictionaryModel,
        }*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductListFilter = /** @class */ (function () {
    function ProductListFilter(organizationId, cultivation) {
        this.organizationId = organizationId;
        this.cultivation = cultivation;
    }
    return ProductListFilter;
}());
if (false) {
    /** @type {?} */
    ProductListFilter.prototype.organizationId;
    /** @type {?} */
    ProductListFilter.prototype.cultivation;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductListFilterComponent = /** @class */ (function () {
    function ProductListFilterComponent(dictionariesService) {
        this.dictionariesService = dictionariesService;
        this.search = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(true);
        this.formLayout = PRODUCT_SEARCH_FILTER_FORM_LAYOUT;
        this.formModel = PRODUCT_SEARCH_FILTER_FORM_MODEL;
        this.initValue = new ProductListFilterForm();
    }
    /**
     * @return {?}
     */
    ProductListFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.cultivationCropChangesSubscription = this.dictionariesService.getItems(DictionaryType.CultivationCrop)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} cultivationCrops
         * @return {?}
         */
        function (cultivationCrops) {
            /** @type {?} */
            var filterGroup = (/** @type {?} */ (_this.formModel
                .find((/**
             * @param {?} y
             * @return {?}
             */
            function (y) { return y.id === PRODUCT_LIST_FILTER_GROUP; }))));
            /** @type {?} */
            var cultivationCropFormModel = (/** @type {?} */ (filterGroup.group
                // tslint:disable-next-line:no-any
                .find((/**
             * @param {?} y
             * @return {?}
             */
            function (y) { return y.id === PRODUCT_LIST_FILTER_CULTIVATION_CROP; }))));
            cultivationCropFormModel.items = __spread([CULTIVATION_CROP_SELECT$2], cultivationCrops);
            _this.searchForm.refreshFormModel.next(true);
        }));
    };
    /**
     * @return {?}
     */
    ProductListFilterComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.cultivationCropChangesSubscription.unsubscribe();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ProductListFilterComponent.prototype.onSearch = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var organization = $event[PRODUCT_LIST_FILTER_GROUP][PRODUCT_LIST_FILTER_ORGANIZATION];
        /** @type {?} */
        var crop = $event[PRODUCT_LIST_FILTER_GROUP][PRODUCT_LIST_FILTER_CULTIVATION_CROP];
        /** @type {?} */
        var filter = new ProductListFilter(organization, crop == null || crop.codeName === CULTIVATION_CROP_SELECT$2.codeName ? null : crop.codeName);
        this.search.emit(filter);
    };
    ProductListFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-product-list-filter',
                    template: "<app-search-form\r\n    #searchForm\r\n    [formModel]=\"formModel\"\r\n    [formLayout]=\"formLayout\"\r\n    [model]=\"initValue\"\r\n    (search)=\"onSearch($event)\"\r\n    [translateKey]=\"translationKey\">\r\n</app-search-form>\r\n"
                }] }
    ];
    /** @nocollapse */
    ProductListFilterComponent.ctorParameters = function () { return [
        { type: DictionariesService }
    ]; };
    ProductListFilterComponent.propDecorators = {
        translationKey: [{ type: Input }],
        search: [{ type: Output }],
        searchForm: [{ type: ViewChild, args: ['searchForm', { static: false },] }]
    };
    return ProductListFilterComponent;
}());
if (false) {
    /** @type {?} */
    ProductListFilterComponent.prototype.translationKey;
    /** @type {?} */
    ProductListFilterComponent.prototype.search;
    /** @type {?} */
    ProductListFilterComponent.prototype.searchForm;
    /** @type {?} */
    ProductListFilterComponent.prototype.displaySpinner$;
    /** @type {?} */
    ProductListFilterComponent.prototype.formLayout;
    /** @type {?} */
    ProductListFilterComponent.prototype.formModel;
    /** @type {?} */
    ProductListFilterComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    ProductListFilterComponent.prototype.cultivationCropChangesSubscription;
    /**
     * @type {?}
     * @private
     */
    ProductListFilterComponent.prototype.dictionariesService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductServicesModule = /** @class */ (function () {
    function ProductServicesModule() {
    }
    ProductServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return ProductServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductSharedModule = /** @class */ (function () {
    function ProductSharedModule() {
    }
    ProductSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ProductListFilterComponent
                    ],
                    imports: [
                        FormSharedModule,
                        ProductServicesModule
                    ],
                    exports: [
                        ProductListFilterComponent
                    ],
                    entryComponents: [
                        ProductListFilterComponent
                    ]
                },] }
    ];
    return ProductSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductProxyService = /** @class */ (function () {
    function ProductProxyService(config, httpClient) {
        this.httpClient = httpClient;
        this.baseApiUrl = config.configuration.api_url + "/api/v1/products";
    }
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    ProductProxyService.prototype.getListByTenant = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        /** @type {?} */
        var url = this.baseApiUrl + ("/tenant/" + tenantId + "/?");
        return this.getList(url, requestList);
    };
    /**
     * @param {?} organizationId
     * @param {?} requestList
     * @return {?}
     */
    ProductProxyService.prototype.getListByOrganization = /**
     * @param {?} organizationId
     * @param {?} requestList
     * @return {?}
     */
    function (organizationId, requestList) {
        /** @type {?} */
        var url = this.baseApiUrl + ("/organization/" + organizationId + "/?");
        return this.getList(url, requestList);
    };
    /**
     * @param {?} url
     * @param {?} requestList
     * @return {?}
     */
    ProductProxyService.prototype.getList = /**
     * @param {?} url
     * @param {?} requestList
     * @return {?}
     */
    function (url, requestList) {
        if (requestList.page != null) {
            url += "&page=" + (requestList.page + 1);
        }
        if (requestList.pageSize != null) {
            url += "&pageSize=" + requestList.pageSize;
        }
        /** @type {?} */
        var filter = this.getFilters(requestList.filter);
        if (filter != null) {
            url += "&filter=" + filter;
        }
        return this.httpClient.get(url);
    };
    /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    ProductProxyService.prototype.getFilters = /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    function (filter) {
        if (filter == null) {
            return null;
        }
        /** @type {?} */
        var filters = [];
        if (isEmpty(filter.organizationId) === false) {
            filters.push("organizationId," + filter.organizationId);
        }
        if (isEmpty(filter.cultivation) === false) {
            filters.push("productDefinition.cultivation," + filter.cultivation);
        }
        if (isEmpty(filters) === false) {
            return join(filters, ';');
        }
        return null;
    };
    ProductProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: ProductServicesModule
                },] }
    ];
    /** @nocollapse */
    ProductProxyService.ctorParameters = function () { return [
        { type: AppConfigurationService },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ ProductProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductProxyService_Factory() { return new ProductProxyService(ɵɵinject(AppConfigurationService), ɵɵinject(HttpClient)); }, token: ProductProxyService, providedIn: ProductServicesModule });
    return ProductProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductProxyService.prototype.baseApiUrl;
    /**
     * @type {?}
     * @private
     */
    ProductProxyService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProductService = /** @class */ (function () {
    function ProductService(dateUtilService, productProxyService) {
        this.dateUtilService = dateUtilService;
        this.productProxyService = productProxyService;
    }
    /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    ProductService.prototype.getListByTenant = /**
     * @param {?} tenantId
     * @param {?} requestList
     * @return {?}
     */
    function (tenantId, requestList) {
        return this.productProxyService.getListByTenant(tenantId, requestList);
    };
    /**
     * @param {?} organizationId
     * @param {?} requestList
     * @return {?}
     */
    ProductService.prototype.getListByOrganization = /**
     * @param {?} organizationId
     * @param {?} requestList
     * @return {?}
     */
    function (organizationId, requestList) {
        return this.productProxyService.getListByOrganization(organizationId, requestList);
    };
    ProductService.decorators = [
        { type: Injectable, args: [{
                    providedIn: ProductServicesModule
                },] }
    ];
    /** @nocollapse */
    ProductService.ctorParameters = function () { return [
        { type: DateUtilService },
        { type: ProductProxyService }
    ]; };
    /** @nocollapse */ ProductService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductService_Factory() { return new ProductService(ɵɵinject(DateUtilService), ɵɵinject(ProductProxyService)); }, token: ProductService, providedIn: ProductServicesModule });
    return ProductService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductService.prototype.dateUtilService;
    /**
     * @type {?}
     * @private
     */
    ProductService.prototype.productProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Product = /** @class */ (function () {
    function Product(id, organizationId, tenantId, productDefinition, lotNumber, parcelId, fieldCarDId, quantity, unit) {
        this.id = id;
        this.organizationId = organizationId;
        this.tenantId = tenantId;
        this.productDefinition = productDefinition;
        this.lotNumber = lotNumber;
        this.parcelId = parcelId;
        this.fieldCarDId = fieldCarDId;
        this.quantity = quantity;
        this.unit = unit;
    }
    return Product;
}());
if (false) {
    /** @type {?} */
    Product.prototype.id;
    /** @type {?} */
    Product.prototype.organizationId;
    /** @type {?} */
    Product.prototype.tenantId;
    /** @type {?} */
    Product.prototype.productDefinition;
    /** @type {?} */
    Product.prototype.lotNumber;
    /** @type {?} */
    Product.prototype.parcelId;
    /** @type {?} */
    Product.prototype.fieldCarDId;
    /** @type {?} */
    Product.prototype.quantity;
    /** @type {?} */
    Product.prototype.unit;
}
var ProductDefinition = /** @class */ (function () {
    function ProductDefinition(id, name, catalogDefinitionId, catalogDefinitionName, cultivations, unit) {
    }
    return ProductDefinition;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherStationServicesModule = /** @class */ (function () {
    function WeatherStationServicesModule() {
    }
    WeatherStationServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return WeatherStationServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherStationDataProxyService = /** @class */ (function () {
    function WeatherStationDataProxyService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.apiUrl = this.config.configuration.api_url + "/v1/weatherstations/weatherdata";
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    WeatherStationDataProxyService.prototype.getSpecyficMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        // note: HttpParams generated wrong query string array=value1,value2 instead of array=value1&array=value2
        /** @type {?} */
        var params = {
            stationId: measurementFilter.stationId,
            measurementTypes: measurementFilter.measurementTypes.map((/**
             * @param {?} v
             * @return {?}
             */
            function (v) { return v.toString(); })),
            dateFrom: measurementFilter.dateFrom.toDateString(),
            dateTo: measurementFilter.dateTo.toDateString()
        };
        // tslint:disable-next-line: no-any
        return this.httpClient.get(this.apiUrl + "/" + deviceType, { params: params });
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    WeatherStationDataProxyService.prototype.getMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        // note: HttpParams generated wrong query string array=value1,value2 instead of array=value1&array=value2
        /** @type {?} */
        var params = {
            stationId: measurementFilter.stationId,
            dateFrom: measurementFilter.dateFrom.toDateString(),
            dateTo: measurementFilter.dateTo.toDateString()
        };
        // tslint:disable-next-line: no-any
        return this.httpClient.get(this.apiUrl + "/" + deviceType + "/measures", { params: params });
    };
    WeatherStationDataProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: WeatherStationServicesModule
                },] }
    ];
    /** @nocollapse */
    WeatherStationDataProxyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    /** @nocollapse */ WeatherStationDataProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WeatherStationDataProxyService_Factory() { return new WeatherStationDataProxyService(ɵɵinject(HttpClient), ɵɵinject(AppConfigurationService)); }, token: WeatherStationDataProxyService, providedIn: WeatherStationServicesModule });
    return WeatherStationDataProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WeatherStationDataProxyService.prototype.apiUrl;
    /**
     * @type {?}
     * @private
     */
    WeatherStationDataProxyService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    WeatherStationDataProxyService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherStationDataListService = /** @class */ (function () {
    function WeatherStationDataListService(weatherStationDataProxyService) {
        this.weatherStationDataProxyService = weatherStationDataProxyService;
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    WeatherStationDataListService.prototype.getSpecyficMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        return this.weatherStationDataProxyService.getSpecyficMeasurements(deviceType, measurementFilter);
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    WeatherStationDataListService.prototype.getMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        return this.weatherStationDataProxyService.getMeasurements(deviceType, measurementFilter);
    };
    WeatherStationDataListService.decorators = [
        { type: Injectable, args: [{
                    providedIn: WeatherStationServicesModule
                },] }
    ];
    /** @nocollapse */
    WeatherStationDataListService.ctorParameters = function () { return [
        { type: WeatherStationDataProxyService }
    ]; };
    /** @nocollapse */ WeatherStationDataListService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WeatherStationDataListService_Factory() { return new WeatherStationDataListService(ɵɵinject(WeatherStationDataProxyService)); }, token: WeatherStationDataListService, providedIn: WeatherStationServicesModule });
    return WeatherStationDataListService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WeatherStationDataListService.prototype.weatherStationDataProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var WEATHER_STATION_MEASUREMENT_TYPES_KEY$1 = 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.';
var WeatherStationMeasurementComponent = /** @class */ (function () {
    function WeatherStationMeasurementComponent(weatherStationDataListService, translateService, calendar, ngZone) {
        this.weatherStationDataListService = weatherStationDataListService;
        this.translateService = translateService;
        this.calendar = calendar;
        this.ngZone = ngZone;
        this.dataReady = false;
        this.selectedMeasures = [];
        this.activateMeasureSelection = true;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.lineChartData = [{ data: [], label: '' }];
        this.WeatherStationMeasurementTypes = WeatherStationMeasurementTypes;
        this.lineChartColors = [
            {
                // grey
                backgroundColor: 'rgba(148,159,177,0.2)',
                // tslint:disable-next-line: no-duplicate-string
                borderColor: 'rgba(148,159,177,1)',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
                // red
                backgroundColor: 'rgba(255,0,0,0.3)',
                borderColor: 'red',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            }
        ];
        this.lineChartLegend = true;
        this.lineChartType = 'line';
        this.unsubscribe$ = new Subject();
    }
    Object.defineProperty(WeatherStationMeasurementComponent.prototype, "isWeatherStationDeviceType", {
        get: /**
         * @return {?}
         */
        function () {
            return this.deviceType === DeviceType.WeatherStation;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dateFrom = this.calendar.getToday();
        this.dateTo = this.calendar.getToday();
        this.setupOneLineChartOptions();
        // refresh chart when language was changed
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.chartRef.update();
            }));
        }));
    };
    /**
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @param {?} event
     * @param {?} item
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.onValueChange = /**
     * @param {?} event
     * @param {?} item
     * @return {?}
     */
    function (event, item) {
        if (event) {
            this.selectedMeasures.push(item);
            // tslint:disable-next-line: no-magic-numbers
            if (this.selectedMeasures.length === 2) {
                this.activateMeasureSelection = false;
            }
        }
        else {
            this.selectedMeasures.splice(this.selectedMeasures.indexOf(item), 1);
            this.activateMeasureSelection = true;
        }
        if (this.selectedMeasures.length === 1) {
            this.setupOneLineChartOptions();
            this.getData();
            // tslint:disable-next-line: no-magic-numbers
        }
        else if (this.selectedMeasures.length === 2) {
            this.setupTwoLineChartOptions();
            this.getData();
        }
        else {
            this.lineChartData = [
                { data: [], label: '' }
            ];
            this.dataReady = false;
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.onDateSelect = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (NgbDate.from(this.dateFrom).after(NgbDate.from(this.dateTo))) {
            this.dateShowValidationError = true;
        }
        else {
            this.dateShowValidationError = false;
            if (this.selectedMeasures.length > 0) {
                this.getData();
            }
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.isMeasureSelected = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return this.selectedMeasures.indexOf(item) !== -1;
    };
    /**
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.setupOneLineChartOptions = /**
     * @return {?}
     */
    function () {
        this.lineChartOptions = {
            responsive: true,
            scales: {
                // We use this empty structure as a placeholder for dynamic theming.
                // https://www.chartjs.org/docs/latest/axes/cartesian/time.html
                xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: DateTime.DATETIME_MED,
                            displayFormats: { day: 'LLL dd' },
                            unit: 'day'
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        position: 'left',
                    }
                ]
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'vertical',
                        scaleID: 'x-axis-0',
                        value: 'March',
                        borderColor: 'orange',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            fontColor: 'orange',
                            content: 'LineAnno'
                        }
                    },
                ],
            },
        };
    };
    /**
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.setupTwoLineChartOptions = /**
     * @return {?}
     */
    function () {
        this.lineChartOptions = {
            responsive: true,
            scales: {
                xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: DateTime.DATETIME_MED,
                            displayFormats: { day: 'LLL dd' },
                            unit: 'day'
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        position: 'left',
                    },
                    {
                        id: 'y-axis-1',
                        position: 'right'
                    }
                ]
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'vertical',
                        scaleID: 'x-axis-0',
                        value: 'March',
                        borderColor: 'orange',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            fontColor: 'orange',
                            content: 'LineAnno'
                        }
                    }
                ],
            },
        };
    };
    /**
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.getData = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.dataReady = false;
        this.chartFilter = {
            stationId: this.id,
            measurementTypes: this.selectedMeasures,
            dateFrom: new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day),
            dateTo: new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day),
        };
        this.weatherStationDataListService.getSpecyficMeasurements(this.deviceType, this.chartFilter).pipe(finalize((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(false);
            _this.dataReady = true;
        })), takeUntil(this.unsubscribe$)).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                // tslint:disable-next-line: no-any
                /** @type {?} */
                var firstResult_1 = [];
                // tslint:disable-next-line: no-any
                /** @type {?} */
                var secondResult_1 = [];
                data.forEach((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) {
                    firstResult_1.push({
                        x: DateTime.fromISO(element[0]).toISO(),
                        y: _this.calculateValue(element[1], _this.selectedMeasures[0])
                    });
                    // tslint:disable-next-line: no-magic-numbers
                    if (element.length === 3) {
                        secondResult_1.push({
                            x: DateTime.fromISO(element[0]).toISO(),
                            // tslint:disable-next-line: no-magic-numbers
                            y: _this.calculateValue(element[2], _this.selectedMeasures[1])
                        });
                    }
                }));
                // tslint:disable-next-line: no-magic-numbers
                if (_this.selectedMeasures.length === 2) {
                    _this.lineChartData = [
                        {
                            data: firstResult_1,
                            label: _this.getLabel(_this.selectedMeasures[0])
                        },
                        {
                            data: secondResult_1,
                            label: _this.getLabel(_this.selectedMeasures[1])
                        },
                    ];
                }
                else {
                    _this.lineChartData = [
                        {
                            data: firstResult_1,
                            label: _this.getLabel(_this.selectedMeasures[0])
                        },
                    ];
                }
            }
        }));
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} value
     * @param {?} measurementType
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.calculateValue = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} value
     * @param {?} measurementType
     * @return {?}
     */
    function (value, measurementType) {
        if (measurementType === WeatherStationMeasurementTypes.AirPressure) {
            // tslint:disable-next-line: no-magic-numbers
            return value != null ? Math.round(value) / 100 : value;
        }
        return value;
    };
    /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    WeatherStationMeasurementComponent.prototype.getLabel = /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    function (measure) {
        return this.translateService.instant(WEATHER_STATION_MEASUREMENT_TYPES_KEY$1 + WeatherStationMeasurementTypes[measure]);
    };
    WeatherStationMeasurementComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-weather-station-measurement',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header\">\r\n        <div class=\"card-header d-flex pl-0\">\r\n            <div>\r\n                <form class=\"form-inline\">\r\n                    <div class=\"form-group\">\r\n                        <div class=\"input-group col-9 col-md-5 mx-0 mr-md-1\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpFrom\"\r\n                                [(ngModel)]=\"dateFrom\"\r\n                                ngbDatepicker\r\n                                #d1=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d1.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"input-group col-9 col-md-5 mx-0\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpTo\"\r\n                                [(ngModel)]=\"dateTo\"\r\n                                ngbDatepicker\r\n                                #d2=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d2.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div *ngIf=\"dateShowValidationError\">\r\n                        <small class=\"form-text text-danger\">\r\n                            {{ 'WEATHERSTATION.validation:dateFromAfterDateTo' | translate }}\r\n                        </small>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container-fluid\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-12 col-lg-7 order-lg-2 chart-container\" [appSpinner]=\"displaySpinner$ | async\">\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"200\"\r\n                            [datasets]=\"lineChartData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"\r\n                        ></canvas>\r\n                        <div *ngIf=\"selectedMeasures.length === 0\" class=\"text-center align-self-center\">\r\n                                {{ 'WEATHERSTATION.chart:empty' | translate }}\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-12 col-lg-5 order-lg-1 mt-3 mt-lg-2\">\r\n                        <dl class=\"row\">\r\n                            <dt class=\"col-9\">\r\n                                {{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.AirTemperature' | translate }}\r\n                            </dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.AirTemperature)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.AirTemperature) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">{{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.AirHumidity' | translate }}</dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.AirHumidity)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.AirHumidity) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">\r\n                                {{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.SoilTemperature' | translate }}\r\n                            </dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.SoilTemperature)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.SoilTemperature) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">\r\n                                {{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.SoilHumidityLevel1' | translate }}\r\n                            </dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.SoilHumidityLevel1)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.SoilHumidityLevel1) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">\r\n                                {{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.SoilHumidityLevel2' | translate }}\r\n                            </dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.SoilHumidityLevel2)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.SoilHumidityLevel2) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">\r\n                                {{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.SoilHumidityLevel3' | translate }}\r\n                            </dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.SoilHumidityLevel3)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.SoilHumidityLevel3) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\" *ngIf=\"isWeatherStationDeviceType\">{{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.WindSpeed' | translate }}</dt>\r\n                            <dd class=\"col-3\" *ngIf=\"isWeatherStationDeviceType\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.WindSpeed)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.WindSpeed) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\" *ngIf=\"isWeatherStationDeviceType\">{{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.WindDirection' | translate }}</dt>\r\n                            <dd class=\"col-3\" *ngIf=\"isWeatherStationDeviceType\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.WindDirection)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.WindDirection) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\" *ngIf=\"isWeatherStationDeviceType\">{{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.RainCount' | translate }}</dt>\r\n                            <dd class=\"col-3\" *ngIf=\"isWeatherStationDeviceType\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.RainCount)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.RainCount) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\" *ngIf=\"isWeatherStationDeviceType\">{{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.SunLevel' | translate }}</dt>\r\n                            <dd class=\"col-3\" *ngIf=\"isWeatherStationDeviceType\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.SunLevel)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.SunLevel) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\" *ngIf=\"isWeatherStationDeviceType\">{{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.AirPressure' | translate }}</dt>\r\n                            <dd class=\"col-3\" *ngIf=\"isWeatherStationDeviceType\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.AirPressure)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.AirPressure) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">{{ 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.BatteryPercentage' | translate }}</dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, WeatherStationMeasurementTypes.BatteryPercentage)\"\r\n                                    [disabled]=\"!isMeasureSelected(WeatherStationMeasurementTypes.BatteryPercentage) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n                        </dl>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["dt{font-weight:100}.chart-container{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center}"]
                }] }
    ];
    /** @nocollapse */
    WeatherStationMeasurementComponent.ctorParameters = function () { return [
        { type: WeatherStationDataListService },
        { type: TranslateService },
        { type: NgbCalendar },
        { type: NgZone }
    ]; };
    WeatherStationMeasurementComponent.propDecorators = {
        id: [{ type: Input }],
        deviceType: [{ type: Input }],
        chartRef: [{ type: ViewChild, args: [BaseChartDirective, { static: false },] }]
    };
    return WeatherStationMeasurementComponent;
}());
if (false) {
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.id;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.deviceType;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.dateFrom;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.dateTo;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.dateShowValidationError;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.dataReady;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.selectedMeasures;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.activateMeasureSelection;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.chartFilter;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.displaySpinner$;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.lineChartData;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.WeatherStationMeasurementTypes;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.lineChartOptions;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.lineChartColors;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.lineChartLegend;
    /** @type {?} */
    WeatherStationMeasurementComponent.prototype.lineChartType;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementComponent.prototype.unsubscribe$;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementComponent.prototype.chartRef;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementComponent.prototype.weatherStationDataListService;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementComponent.prototype.calendar;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var WEATHER_STATION_MEASUREMENT_TYPES_KEY$2 = 'APPLICATION.DICTIONARIES.WeatherStationMeasurementTypes.';
var WeatherStationMeasurementsComponent = /** @class */ (function () {
    function WeatherStationMeasurementsComponent(weatherStationDataListService, translateService, calendar, ngZone) {
        this.weatherStationDataListService = weatherStationDataListService;
        this.translateService = translateService;
        this.calendar = calendar;
        this.ngZone = ngZone;
        this.dataReady = false;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.lineChartAirTemperatureData = [{ data: [], label: '' }];
        this.lineChartAirHumidityData = [{ data: [], label: '' }];
        this.lineChartSoilTemperatureData = [{ data: [], label: '' }];
        this.lineChartSoilHumidityData = [{ data: [], label: '' }];
        this.lineChartWindSpeedData = [{ data: [], label: '' }];
        this.lineChartWindDirectionData = [{ data: [], label: '' }];
        this.lineChartRainCountData = [{ data: [], label: '' }];
        this.lineChartSunLevelData = [{ data: [], label: '' }];
        this.lineChartAirPressureData = [{ data: [], label: '' }];
        this.lineChartBatteryPercentageData = [{ data: [], label: '' }];
        this.WeatherStationMeasurementTypes = WeatherStationMeasurementTypes;
        this.lineChartColors = [
            {
                // grey
                backgroundColor: 'rgba(148,159,177,0.2)',
                // tslint:disable-next-line: no-duplicate-string
                borderColor: 'rgba(148,159,177,1)',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
                // red
                backgroundColor: 'rgba(255,0,0,0.3)',
                borderColor: 'red',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
                // green
                backgroundColor: 'rgba(0,255,0,0.3)',
                borderColor: 'red',
                pointBackgroundColor: 'rgba(0,0,255,0.3)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(255,255,0,0.3)'
            }
        ];
        this.lineChartLegend = true;
        this.lineChartType = 'line';
        this.unsubscribe$ = new Subject();
    }
    Object.defineProperty(WeatherStationMeasurementsComponent.prototype, "isWeatherStationDeviceType", {
        get: /**
         * @return {?}
         */
        function () {
            return this.deviceType === DeviceType.WeatherStation;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dateFrom = this.calendar.getToday();
        this.dateTo = this.calendar.getToday();
        this.setupOneLineChartOptions();
        this.getData();
        // refresh chart when language was changed
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.chartRef.forEach((/**
                 * @param {?} chart
                 * @return {?}
                 */
                function (chart) { return chart.update(); }));
            }));
        }));
    };
    /**
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.onDateSelect = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (NgbDate.from(this.dateFrom).after(NgbDate.from(this.dateTo))) {
            this.dateShowValidationError = true;
        }
        else {
            this.dateShowValidationError = false;
            this.getData();
        }
    };
    /**
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.setupOneLineChartOptions = /**
     * @return {?}
     */
    function () {
        this.lineChartOptions = {
            responsive: true,
            scales: {
                // We use this empty structure as a placeholder for dynamic theming.
                // https://www.chartjs.org/docs/latest/axes/cartesian/time.html
                xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: DateTime.DATETIME_MED,
                            displayFormats: { day: 'LLL dd' },
                            unit: 'day'
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        position: 'left',
                    }
                ]
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'vertical',
                        scaleID: 'x-axis-0',
                        value: 'March',
                        borderColor: 'orange',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            fontColor: 'orange',
                            content: 'LineAnno'
                        }
                    },
                ],
            },
        };
    };
    /**
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.getData = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.dataReady = false;
        this.chartFilter = {
            stationId: this.id,
            dateFrom: new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day),
            dateTo: new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day),
        };
        /** @type {?} */
        var converhPa = (/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            // tslint:disable-next-line: no-magic-numbers
            return x != null ? Math.round(x) / 100 : x;
        });
        this.weatherStationDataListService.getMeasurements(this.deviceType, this.chartFilter).pipe(finalize((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(false);
            _this.dataReady = true;
        })), takeUntil(this.unsubscribe$)).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                _this.prepareSoilHumidityData(data);
                // tslint:disable: no-magic-numbers
                _this.lineChartAirTemperatureData = _this.prepareChartWithOneAxis(data, 3, WeatherStationMeasurementTypes.AirTemperature);
                _this.lineChartAirHumidityData = _this.prepareChartWithOneAxis(data, 1, WeatherStationMeasurementTypes.AirHumidity);
                _this.lineChartSoilTemperatureData = _this.prepareChartWithOneAxis(data, 10, WeatherStationMeasurementTypes.SoilTemperature);
                _this.lineChartWindSpeedData = _this.prepareChartWithOneAxis(data, 13, WeatherStationMeasurementTypes.WindSpeed);
                _this.lineChartWindDirectionData = _this.prepareChartWithOneAxis(data, 12, WeatherStationMeasurementTypes.WindDirection);
                _this.lineChartRainCountData = _this.prepareChartWithOneAxis(data, 6, WeatherStationMeasurementTypes.RainCount);
                _this.lineChartSunLevelData = _this.prepareChartWithOneAxis(data, 11, WeatherStationMeasurementTypes.SunLevel);
                // tslint:disable-next-line: max-line-length
                _this.lineChartAirPressureData = _this.prepareChartWithOneAxis(data, 2, WeatherStationMeasurementTypes.AirPressure, converhPa);
                // tslint:disable-next-line: max-line-length
                _this.lineChartBatteryPercentageData = _this.prepareChartWithOneAxis(data, 5, WeatherStationMeasurementTypes.BatteryPercentage);
            }
        }));
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.prepareSoilHumidityData = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        // tslint:disable-next-line: no-any
        /** @type {?} */
        var firstResult = [];
        // tslint:disable-next-line: no-any
        /** @type {?} */
        var secondResult = [];
        // tslint:disable-next-line: no-any
        /** @type {?} */
        var thirdResult = [];
        // tslint:disable: no-magic-numbers
        data.forEach((/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            firstResult.push({
                x: DateTime.fromISO(element[0]).toISO(),
                y: element[6]
            });
            secondResult.push({
                x: DateTime.fromISO(element[0]).toISO(),
                y: element[7]
            });
            thirdResult.push({
                x: DateTime.fromISO(element[0]).toISO(),
                y: element[8]
            });
        }));
        this.lineChartSoilHumidityData = [
            {
                data: firstResult,
                label: this.getLabel(WeatherStationMeasurementTypes.SoilHumidityLevel1)
            },
            {
                data: secondResult,
                label: this.getLabel(WeatherStationMeasurementTypes.SoilHumidityLevel2)
            },
            {
                data: thirdResult,
                label: this.getLabel(WeatherStationMeasurementTypes.SoilHumidityLevel3)
            }
        ];
    };
    /**
     * @private
     * @param {?} data
     * @param {?} index
     * @param {?} measurementType
     * @param {?=} calculateValue
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.prepareChartWithOneAxis = /**
     * @private
     * @param {?} data
     * @param {?} index
     * @param {?} measurementType
     * @param {?=} calculateValue
     * @return {?}
     */
    function (
    // tslint:disable-next-line: no-any
    data, index, measurementType, 
    // tslint:disable-next-line: no-any
    calculateValue) {
        if (calculateValue === void 0) { calculateValue = (/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x; }); }
        // tslint:disable-next-line: no-any
        /** @type {?} */
        var firstResult = [];
        data.forEach((/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            firstResult.push({
                x: DateTime.fromISO(element[0]).toISO(),
                y: calculateValue(element[index])
            });
        }));
        return [
            {
                data: firstResult,
                label: this.getLabel(measurementType)
            }
        ];
    };
    /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    WeatherStationMeasurementsComponent.prototype.getLabel = /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    function (measure) {
        return this.translateService.instant(WEATHER_STATION_MEASUREMENT_TYPES_KEY$2 + WeatherStationMeasurementTypes[measure]);
    };
    WeatherStationMeasurementsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-weather-station-measurements',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header\">\r\n        <div class=\"card-header d-flex pl-0\">\r\n            <div>\r\n                <form class=\"form-inline\">\r\n                    <div class=\"form-group\">\r\n                        <div class=\"input-group col-9 col-md-5 mx-0 mr-md-1\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpFrom\"\r\n                                [(ngModel)]=\"dateFrom\"\r\n                                ngbDatepicker\r\n                                #d1=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d1.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"input-group col-9 col-md-5 mx-0\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpTo\"\r\n                                [(ngModel)]=\"dateTo\"\r\n                                ngbDatepicker\r\n                                #d2=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d2.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div *ngIf=\"dateShowValidationError\">\r\n                        <small class=\"form-text text-danger\">\r\n                            {{ 'WEATHERSTATION.validation:dateFromAfterDateTo' | translate }}\r\n                        </small>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container-fluid\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-12 chart-container\" [appSpinner]=\"displaySpinner$ | async\">\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartAirTemperatureData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"isWeatherStationDeviceType && dataReady\" ></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartAirHumidityData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartSoilTemperatureData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartWindSpeedData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"isWeatherStationDeviceType && dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartWindDirectionData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"isWeatherStationDeviceType && dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartSoilHumidityData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartRainCountData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"isWeatherStationDeviceType && dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartSunLevelData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"isWeatherStationDeviceType && dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartAirPressureData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"isWeatherStationDeviceType && dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartBatteryPercentageData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"></canvas>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["dt{font-weight:100}.chart-container{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center}"]
                }] }
    ];
    /** @nocollapse */
    WeatherStationMeasurementsComponent.ctorParameters = function () { return [
        { type: WeatherStationDataListService },
        { type: TranslateService },
        { type: NgbCalendar },
        { type: NgZone }
    ]; };
    WeatherStationMeasurementsComponent.propDecorators = {
        id: [{ type: Input }],
        deviceType: [{ type: Input }],
        chartRef: [{ type: ViewChildren, args: [BaseChartDirective,] }]
    };
    return WeatherStationMeasurementsComponent;
}());
if (false) {
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.id;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.deviceType;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.dateFrom;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.dateTo;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.dateShowValidationError;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.dataReady;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.chartFilter;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.displaySpinner$;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartAirTemperatureData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartAirHumidityData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartSoilTemperatureData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartSoilHumidityData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartWindSpeedData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartWindDirectionData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartRainCountData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartSunLevelData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartAirPressureData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartBatteryPercentageData;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.WeatherStationMeasurementTypes;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartOptions;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartColors;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartLegend;
    /** @type {?} */
    WeatherStationMeasurementsComponent.prototype.lineChartType;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementsComponent.prototype.unsubscribe$;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementsComponent.prototype.chartRef;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementsComponent.prototype.weatherStationDataListService;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementsComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementsComponent.prototype.calendar;
    /**
     * @type {?}
     * @private
     */
    WeatherStationMeasurementsComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WeatherStationSharedModule = /** @class */ (function () {
    function WeatherStationSharedModule() {
    }
    WeatherStationSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [WeatherStationMeasurementComponent, WeatherStationMeasurementsComponent],
                    entryComponents: [WeatherStationMeasurementComponent, WeatherStationMeasurementsComponent],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        NgbModule,
                        WeatherStationServicesModule,
                        ChartsModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule
                    ],
                    exports: [
                        WeatherStationMeasurementComponent,
                        WeatherStationMeasurementsComponent,
                        NgbModule,
                    ]
                },] }
    ];
    return WeatherStationSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundServicesModule = /** @class */ (function () {
    function GroundServicesModule() {
    }
    GroundServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return GroundServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_LIST_FILTER_FORM_LAYOUT = {
    name: {
        grid: {
            host: 'col-12 col-md-6 order-md-1',
            // tslint:disable-next-line: no-duplicate-string
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    },
    commune: {
        grid: {
            host: 'col-12 col-md-6 order-md-1',
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    },
    areaFrom: {
        grid: {
            host: 'col-12 col-md-6 order-md-2',
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    },
    areaTo: {
        grid: {
            host: 'col-12 col-md-6 order-md-2',
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    },
    lease: {
        grid: {
            host: 'col-12 col-md-6 order-md-3',
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    }
};
/** @type {?} */
var GROUND_LIST_FILTER_FORM_MODEL = [
    new DynamicInputModel({
        id: 'name',
        minLength: 3,
        maxLength: 60,
        validators: {
            minLength: 3,
            maxLength: 60
        }
    }),
    new DynamicInputModel({
        id: 'commune',
        minLength: 3,
        maxLength: 60,
        validators: {
            minLength: 3,
            maxLength: 60
        }
    }),
    new DynamicInputModel({
        id: 'areaFrom',
        min: 0.1,
        max: 1000,
        inputType: 'number',
        validators: {
            min: 0.1,
            max: 1000
        }
    }),
    new DynamicInputModel({
        id: 'areaTo',
        min: 0.1,
        max: 1000,
        inputType: 'number',
        validators: {
            min: 0.1,
            max: 1000
        }
    }),
    new DynamicCheckboxModel({
        id: 'lease',
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundListFilter = /** @class */ (function () {
    function GroundListFilter(name, commune, areaFrom, areaTo, lease, latitude, longitude) {
        this.name = name;
        this.commune = commune;
        this.areaFrom = areaFrom;
        this.areaTo = areaTo;
        this.lease = lease;
        this.latitude = latitude;
        this.longitude = longitude;
    }
    return GroundListFilter;
}());
if (false) {
    /** @type {?} */
    GroundListFilter.prototype.name;
    /** @type {?} */
    GroundListFilter.prototype.commune;
    /** @type {?} */
    GroundListFilter.prototype.areaFrom;
    /** @type {?} */
    GroundListFilter.prototype.areaTo;
    /** @type {?} */
    GroundListFilter.prototype.lease;
    /** @type {?} */
    GroundListFilter.prototype.latitude;
    /** @type {?} */
    GroundListFilter.prototype.longitude;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundListFilterComponent = /** @class */ (function () {
    function GroundListFilterComponent() {
        this.search = new EventEmitter();
        this.formLayout = GROUND_LIST_FILTER_FORM_LAYOUT;
        this.formModel = GROUND_LIST_FILTER_FORM_MODEL;
        this.initValue = {};
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundListFilterComponent.prototype.onSearch = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var listFilter = this.mapFromGroundListFilterForm($event);
        this.search.emit(listFilter);
    };
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    GroundListFilterComponent.prototype.mapFromGroundListFilterForm = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return new GroundListFilter(data.name, data.commune, data.areaFrom, data.areaTo, data.lease);
    };
    GroundListFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-list-filter',
                    template: "<app-search-form\r\n    [formModel]=\"formModel\"\r\n    [formLayout]=\"formLayout\"\r\n    [model]=\"initValue\"\r\n    [translateKey]=\"translationKeyPrefix\"\r\n    (search)=\"onSearch($event)\"\r\n>\r\n</app-search-form>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    GroundListFilterComponent.ctorParameters = function () { return []; };
    GroundListFilterComponent.propDecorators = {
        translationKeyPrefix: [{ type: Input }],
        search: [{ type: Output }]
    };
    return GroundListFilterComponent;
}());
if (false) {
    /** @type {?} */
    GroundListFilterComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    GroundListFilterComponent.prototype.search;
    /** @type {?} */
    GroundListFilterComponent.prototype.formLayout;
    /** @type {?} */
    GroundListFilterComponent.prototype.formModel;
    /** @type {?} */
    GroundListFilterComponent.prototype.initValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundListTableSchema = /** @class */ (function () {
    function GroundListTableSchema(headerKey, nameKey, areaInHaKey, communeKey, leaseKey, actionsKey, showOnMapKey, deleteKey, editKey, detailsKey, listEmptyKey, listErrorKey) {
        this.headerKey = headerKey;
        this.nameKey = nameKey;
        this.areaInHaKey = areaInHaKey;
        this.communeKey = communeKey;
        this.leaseKey = leaseKey;
        this.actionsKey = actionsKey;
        this.showOnMapKey = showOnMapKey;
        this.deleteKey = deleteKey;
        this.editKey = editKey;
        this.detailsKey = detailsKey;
        this.listEmptyKey = listEmptyKey;
        this.listErrorKey = listErrorKey;
    }
    return GroundListTableSchema;
}());
if (false) {
    /** @type {?} */
    GroundListTableSchema.prototype.headerKey;
    /** @type {?} */
    GroundListTableSchema.prototype.nameKey;
    /** @type {?} */
    GroundListTableSchema.prototype.areaInHaKey;
    /** @type {?} */
    GroundListTableSchema.prototype.communeKey;
    /** @type {?} */
    GroundListTableSchema.prototype.leaseKey;
    /** @type {?} */
    GroundListTableSchema.prototype.actionsKey;
    /** @type {?} */
    GroundListTableSchema.prototype.showOnMapKey;
    /** @type {?} */
    GroundListTableSchema.prototype.deleteKey;
    /** @type {?} */
    GroundListTableSchema.prototype.editKey;
    /** @type {?} */
    GroundListTableSchema.prototype.detailsKey;
    /** @type {?} */
    GroundListTableSchema.prototype.listEmptyKey;
    /** @type {?} */
    GroundListTableSchema.prototype.listErrorKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_SHARED_SERVICE = new InjectionToken('GroundSharedService');
/**
 * @record
 */
function IGroundSharedService() { }
if (false) {
    /**
     * @param {?} organizationId
     * @return {?}
     */
    IGroundSharedService.prototype.getAll = function (organizationId) { };
    /**
     * @param {?} organizationId
     * @param {?} requestList
     * @return {?}
     */
    IGroundSharedService.prototype.find = function (organizationId, requestList) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @return {?}
     */
    IGroundSharedService.prototype.get = function (organizationId, groundId) { };
    /**
     * @param {?} organizationId
     * @param {?} command
     * @return {?}
     */
    IGroundSharedService.prototype.create = function (organizationId, command) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} command
     * @return {?}
     */
    IGroundSharedService.prototype.update = function (organizationId, groundId, command) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @return {?}
     */
    IGroundSharedService.prototype.delete = function (organizationId, groundId) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundListTableComponent = /** @class */ (function () {
    function GroundListTableComponent(groundSharedService) {
        var _this = this;
        this.groundSharedService = groundSharedService;
        this.delete = new EventEmitter();
        this.showOnMap = new EventEmitter();
        this.edit = new EventEmitter();
        this.details = new EventEmitter();
        this.displayedColumns = ['name', 'areaInHa', 'commune', 'lease', 'action'];
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} requestList
         * @return {?}
         */
        function (requestList) {
            return _this.groundSharedService.find(_this.organizationId, requestList)
                .pipe(map((/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                return {
                    items: d.items || [],
                    totalCount: d.pager.totalCount
                };
            })));
        }));
    }
    Object.defineProperty(GroundListTableComponent.prototype, "filter", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.dataSource.setFilter(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    GroundListTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundListTableComponent.prototype.onShowOnMap = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.showOnMap.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundListTableComponent.prototype.onDelete = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.delete.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundListTableComponent.prototype.onEdit = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.edit.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundListTableComponent.prototype.onDetails = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.details.emit(item);
    };
    GroundListTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-list-table',
                    template: "<div class=\"mb-2\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"d-flex flex-column flex-md-row justify-content-md-between card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\"><i class=\"ft ft-list\"></i> {{ schema.headerKey | translate }}</h5>\r\n            </label>\r\n            <app-panel-fullscreen-button></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid table-container\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"name\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-3 pr-0\">{{ schema.nameKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-3 pr-0\">{{ element.name }}</div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"areaInHa\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-2 pr-0\">\r\n                                {{ schema.areaInHaKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.areaInHa }}</div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"commune\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-3 pr-0\">\r\n                                {{ schema.communeKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-3 pr-0\">{{ element.cadastralCommune?.name }}</div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"lease\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\">{{ schema.leaseKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 text-left\">\r\n                                <i\r\n                                    [ngClass]=\"{ ft: true, 'ft-check-square': element.lease === true, 'ft-square': element.lease !== true }\"\r\n                                    aria-hidden=\"true\"\r\n                                ></i>\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 text-md-right\">\r\n                                {{ schema.actionsKey | translate | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"sticky-action\">\r\n                                    <div class=\"row no-gutters justify-content-md-end \">\r\n                                        <button\r\n                                            (click)=\"onShowOnMap(element)\"\r\n                                            title=\"{{ schema.showOnMapKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm shadow-none\"\r\n                                        >\r\n                                            <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                        <button\r\n                                            (click)=\"onDelete(element)\"\r\n                                            title=\"{{ schema.deleteKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm shadow-none\"\r\n                                        >\r\n                                            <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                        <button\r\n                                            (click)=\"onEdit(element)\"\r\n                                            title=\"{{ schema.editKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm shadow-none\"\r\n                                        >\r\n                                            <i class=\"ft ft-edit-2\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                        <button\r\n                                            (click)=\"onDetails(element)\"\r\n                                            title=\"{{ schema.detailsKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm shadow-none\"\r\n                                        >\r\n                                            <i class=\"ft ft-info\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\" *cdkHeaderRowDef=\"displayedColumns\"> </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\" *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listEmptyKey | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listErrorKey | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator\r\n                        class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                        [pageSizeOptions]=\"[10, 25, 50, 75, 100]\"\r\n                        showFirstLastButtons\r\n                    ></cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    GroundListTableComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_SHARED_SERVICE,] }] }
    ]; };
    GroundListTableComponent.propDecorators = {
        organizationId: [{ type: Input }],
        filter: [{ type: Input }],
        schema: [{ type: Input }],
        delete: [{ type: Output }],
        showOnMap: [{ type: Output }],
        edit: [{ type: Output }],
        details: [{ type: Output }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return GroundListTableComponent;
}());
if (false) {
    /** @type {?} */
    GroundListTableComponent.prototype.organizationId;
    /** @type {?} */
    GroundListTableComponent.prototype.schema;
    /** @type {?} */
    GroundListTableComponent.prototype.delete;
    /** @type {?} */
    GroundListTableComponent.prototype.showOnMap;
    /** @type {?} */
    GroundListTableComponent.prototype.edit;
    /** @type {?} */
    GroundListTableComponent.prototype.details;
    /** @type {?} */
    GroundListTableComponent.prototype.sort;
    /** @type {?} */
    GroundListTableComponent.prototype.paginator;
    /** @type {?} */
    GroundListTableComponent.prototype.displayedColumns;
    /** @type {?} */
    GroundListTableComponent.prototype.dataSource;
    /**
     * @type {?}
     * @private
     */
    GroundListTableComponent.prototype.groundSharedService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundMapSchema = /** @class */ (function () {
    function GroundMapSchema(headerKey, areaInHaKey, cadastralStateKey, cadastralCountyKey, cadastralCommuneKey, cadastralAreaKey, cadastreNumberKey) {
        this.headerKey = headerKey;
        this.areaInHaKey = areaInHaKey;
        this.cadastralStateKey = cadastralStateKey;
        this.cadastralCountyKey = cadastralCountyKey;
        this.cadastralCommuneKey = cadastralCommuneKey;
        this.cadastralAreaKey = cadastralAreaKey;
        this.cadastreNumberKey = cadastreNumberKey;
    }
    return GroundMapSchema;
}());
if (false) {
    /** @type {?} */
    GroundMapSchema.prototype.headerKey;
    /** @type {?} */
    GroundMapSchema.prototype.areaInHaKey;
    /** @type {?} */
    GroundMapSchema.prototype.cadastralStateKey;
    /** @type {?} */
    GroundMapSchema.prototype.cadastralCountyKey;
    /** @type {?} */
    GroundMapSchema.prototype.cadastralCommuneKey;
    /** @type {?} */
    GroundMapSchema.prototype.cadastralAreaKey;
    /** @type {?} */
    GroundMapSchema.prototype.cadastreNumberKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundMapComponent = /** @class */ (function () {
    function GroundMapComponent(mapService, translateService) {
        this.mapService = mapService;
        this.translateService = translateService;
        this.mapReady = false;
        this.polygonConfig = new PolygonConfig(groundDrawingColor, false, false);
    }
    Object.defineProperty(GroundMapComponent.prototype, "grounds", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.groundsData = value;
            this.drawGrounds();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    GroundMapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.mapService.mapReady.subscribe((/**
         * @return {?}
         */
        function () {
            _this.mapReady = true;
            _this.drawGrounds();
        }));
    };
    /**
     * @return {?}
     */
    GroundMapComponent.prototype.drawGrounds = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.mapReady) {
            /** @type {?} */
            var bounds_1 = new google.maps.LatLngBounds();
            this.mapService.clearPolygons();
            flatten(this.groundsData.map((/**
             * @param {?} ground
             * @return {?}
             */
            function (ground) { return ground.locations.map((/**
             * @param {?} feature
             * @return {?}
             */
            function (feature) {
                /** @type {?} */
                var polygonBounds = new google.maps.LatLngBounds();
                // tslint:disable-next-line: no-string-literal
                /** @type {?} */
                var latLngArray = feature.geometry['coordinates'][0].map((/**
                 * @param {?} cord
                 * @return {?}
                 */
                function (cord) {
                    return new google.maps.LatLng({
                        lat: cord[1],
                        lng: cord[0]
                    });
                }));
                latLngArray.forEach((/**
                 * @param {?} latLng
                 * @return {?}
                 */
                function (latLng) {
                    bounds_1.extend(latLng);
                    polygonBounds.extend(latLng);
                }));
                /** @type {?} */
                var featureProperties = cloneDeep(feature.properties);
                featureProperties.navigate = ['grounds', ground.id];
                return {
                    paths: latLngArray,
                    strokeColor: _this.polygonConfig.drawingColor,
                    fillColor: _this.polygonConfig.drawingColor,
                    properties: featureProperties,
                    bounds: polygonBounds,
                    windowContent: _this.buildPopupContent(ground),
                };
            })); }))).forEach((/**
             * @param {?} polygonConfig
             * @return {?}
             */
            function (polygonConfig) {
                /** @type {?} */
                var infoWindow = new google.maps.InfoWindow({
                    content: polygonConfig.windowContent
                });
                /** @type {?} */
                var polygon = _this.mapService.createPolygon(polygonConfig);
                polygon.addListener('click', (/**
                 * @return {?}
                 */
                function () {
                    infoWindow.setPosition(polygonConfig.bounds.getCenter());
                    infoWindow.open(_this.mapService.map);
                }));
            }));
            if (bounds_1.isEmpty() === false) {
                this.mapService.fitBounds(bounds_1);
            }
        }
    };
    /**
     * @param {?} bounds
     * @return {?}
     */
    GroundMapComponent.prototype.fitMapToGroundBounds = /**
     * @param {?} bounds
     * @return {?}
     */
    function (bounds) {
        this.mapService.fitBounds(bounds);
    };
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    GroundMapComponent.prototype.buildPopupContent = /**
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return "<div class=\"row si-modal no-gutters mb-0\">\n                    <div class=\"col-12\"><h6 class=\"font-weight-bold\">" + item.name + "</h6></div>\n                    <div class=\"col-12\">\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.areaInHaKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 mb-0 text-md-right si-modal-data\">\n                                " + item.areaInHa + " ha\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.cadastralStateKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + (item.cadastralState != null ? item.cadastralState.name : '') + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.cadastralCountyKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + (item.cadastralCounty != null ? item.cadastralCounty.name : '') + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.cadastralCommuneKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + (item.cadastralCommune != null ? item.cadastralCommune.name : '') + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.cadastralAreaKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + (item.cadastralArea != null ? item.cadastralArea.name : '') + "\n                            </div>\n                        </div>\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.cadastreNumberKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 text-md-right si-modal-data\">\n                                " + item.cadastreNumber + "\n                            </div>\n                        </div>\n                        <div style=\"clear:both\"></div>\n                    </div>\n                </div>";
    };
    ;
    GroundMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-map',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-map\"></i> {{ schema.headerKey | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\"\r\n                class=\"float-right mr-1\"></app-panel-hide-button>\r\n        <hr class=\"my-0\" />\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0 pb-2\" [appPanelHide]=\"false\">\r\n                <app-pure-map></app-pure-map>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    GroundMapComponent.ctorParameters = function () { return [
        { type: PureMapService },
        { type: TranslateService$1 }
    ]; };
    GroundMapComponent.propDecorators = {
        grounds: [{ type: Input }],
        schema: [{ type: Input }],
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }]
    };
    return GroundMapComponent;
}());
if (false) {
    /** @type {?} */
    GroundMapComponent.prototype.schema;
    /** @type {?} */
    GroundMapComponent.prototype.panelHide;
    /**
     * @type {?}
     * @private
     */
    GroundMapComponent.prototype.groundsData;
    /**
     * @type {?}
     * @private
     */
    GroundMapComponent.prototype.mapReady;
    /**
     * @type {?}
     * @private
     */
    GroundMapComponent.prototype.polygonConfig;
    /**
     * @type {?}
     * @private
     */
    GroundMapComponent.prototype.mapService;
    /**
     * @type {?}
     * @private
     */
    GroundMapComponent.prototype.translateService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundLocationConverterProxyService = /** @class */ (function () {
    function GroundLocationConverterProxyService(config, httpClient) {
        this.httpClient = httpClient;
        this.baseApiUrl = config.configuration.api_url + "/v1/cadastre";
    }
    /**
     * @param {?} formData
     * @return {?}
     */
    GroundLocationConverterProxyService.prototype.convertFromGeojsonToGeojson = /**
     * @param {?} formData
     * @return {?}
     */
    function (formData) {
        /** @type {?} */
        var parameters = this.prepareQueryParams('geojson');
        return this.httpClient.post(this.apiUrl, formData, { params: parameters, responseType: 'json' });
    };
    /**
     * @param {?} formData
     * @return {?}
     */
    GroundLocationConverterProxyService.prototype.convertFromKmlToGeojson = /**
     * @param {?} formData
     * @return {?}
     */
    function (formData) {
        /** @type {?} */
        var parameters = this.prepareQueryParams('geojson');
        return this.httpClient.post(this.apiUrl, formData, { params: parameters, responseType: 'json' });
    };
    /**
     * @param {?} formData
     * @return {?}
     */
    GroundLocationConverterProxyService.prototype.convertFromShpToGeojson = /**
     * @param {?} formData
     * @return {?}
     */
    function (formData) {
        /** @type {?} */
        var parameters = this.prepareQueryParams('geojson');
        return this.httpClient.post(this.apiUrl, formData, { params: parameters, responseType: 'json' });
    };
    /**
     * @private
     * @param {?} outputFormat
     * @return {?}
     */
    GroundLocationConverterProxyService.prototype.prepareQueryParams = /**
     * @private
     * @param {?} outputFormat
     * @return {?}
     */
    function (outputFormat) {
        /** @type {?} */
        var params = new HttpParams();
        params = params.set('to', outputFormat);
        return params;
    };
    Object.defineProperty(GroundLocationConverterProxyService.prototype, "apiUrl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.baseApiUrl + "/converter";
        },
        enumerable: true,
        configurable: true
    });
    GroundLocationConverterProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    GroundLocationConverterProxyService.ctorParameters = function () { return [
        { type: AppConfigurationService },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ GroundLocationConverterProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GroundLocationConverterProxyService_Factory() { return new GroundLocationConverterProxyService(ɵɵinject(AppConfigurationService), ɵɵinject(HttpClient)); }, token: GroundLocationConverterProxyService, providedIn: "root" });
    return GroundLocationConverterProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundLocationConverterProxyService.prototype.baseApiUrl;
    /**
     * @type {?}
     * @private
     */
    GroundLocationConverterProxyService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundLocationConverterService = /** @class */ (function () {
    function GroundLocationConverterService(groundLocationConverterProxyService) {
        this.groundLocationConverterProxyService = groundLocationConverterProxyService;
    }
    /**
     * @param {?} geojsonFile
     * @return {?}
     */
    GroundLocationConverterService.prototype.convertFromGeojsonToGeojson = /**
     * @param {?} geojsonFile
     * @return {?}
     */
    function (geojsonFile) {
        /** @type {?} */
        var formData = new FormData();
        formData.append('geojson', geojsonFile, geojsonFile.name);
        return this.groundLocationConverterProxyService.convertFromGeojsonToGeojson(formData);
    };
    /**
     * @param {?} kmlFile
     * @return {?}
     */
    GroundLocationConverterService.prototype.convertFromKmlToGeojson = /**
     * @param {?} kmlFile
     * @return {?}
     */
    function (kmlFile) {
        /** @type {?} */
        var formData = new FormData();
        formData.append('kml', kmlFile, kmlFile.name);
        return this.groundLocationConverterProxyService.convertFromKmlToGeojson(formData);
    };
    /**
     * @param {?} shpFile
     * @param {?} dbfFile
     * @return {?}
     */
    GroundLocationConverterService.prototype.convertFromShpToGeojson = /**
     * @param {?} shpFile
     * @param {?} dbfFile
     * @return {?}
     */
    function (shpFile, dbfFile) {
        /** @type {?} */
        var formData = new FormData();
        formData.append('shp', shpFile, shpFile.name);
        formData.append('dbf', dbfFile, dbfFile.name);
        return this.groundLocationConverterProxyService.convertFromShpToGeojson(formData);
    };
    GroundLocationConverterService.decorators = [
        { type: Injectable, args: [{
                    providedIn: GroundServicesModule
                },] }
    ];
    /** @nocollapse */
    GroundLocationConverterService.ctorParameters = function () { return [
        { type: GroundLocationConverterProxyService }
    ]; };
    /** @nocollapse */ GroundLocationConverterService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GroundLocationConverterService_Factory() { return new GroundLocationConverterService(ɵɵinject(GroundLocationConverterProxyService)); }, token: GroundLocationConverterService, providedIn: GroundServicesModule });
    return GroundLocationConverterService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundLocationConverterService.prototype.groundLocationConverterProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var GroundImportSelectFileComponent = /** @class */ (function () {
    function GroundImportSelectFileComponent(activeModal) {
        this.activeModal = activeModal;
        this.displaySpinner$ = new BehaviorSubject(false);
    }
    /**
     * @return {?}
     */
    GroundImportSelectFileComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initValue = this.createInitValue();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundImportSelectFileComponent.prototype.onSave = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        this.displaySpinner$.next(true);
        this.convertFile($event)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.activeModal.close(data);
        }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundImportSelectFileComponent.prototype.onCancel = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.activeModal.close(false);
    };
    GroundImportSelectFileComponent.propDecorators = {
        headerTranslationKey: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }],
        selectFileForm: [{ type: ViewChild, args: ['selectFileForm', { static: false },] }]
    };
    return GroundImportSelectFileComponent;
}());
if (false) {
    /** @type {?} */
    GroundImportSelectFileComponent.prototype.headerTranslationKey;
    /** @type {?} */
    GroundImportSelectFileComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    GroundImportSelectFileComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundImportSelectFileComponent.prototype.selectFileForm;
    /** @type {?} */
    GroundImportSelectFileComponent.prototype.formLayout;
    /** @type {?} */
    GroundImportSelectFileComponent.prototype.formModel;
    /** @type {?} */
    GroundImportSelectFileComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    GroundImportSelectFileComponent.prototype.activeModal;
    /**
     * @abstract
     * @protected
     * @return {?}
     */
    GroundImportSelectFileComponent.prototype.createInitValue = function () { };
    /**
     * @abstract
     * @protected
     * @param {?} form
     * @return {?}
     */
    GroundImportSelectFileComponent.prototype.convertFile = function (form) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MAX_FILE_SIZE$3 = 10;
// MB
/** @type {?} */
var GROUND_IMPORT_SELECT_GEOJSON_FILE_FORM_LAYOUT = {
    geojsonFile: DEFAULT_FORM_LAYOUT_INPUT,
};
/** @type {?} */
var GROUND_IMPORT_SELECT_GEOJSON_FILE_FORM_MODEL = [
    new DynamicFileUploadModel({
        id: 'geojsonFile',
        maxSize: MAX_FILE_SIZE$3
    })
];
/** @type {?} */
var GROUND_IMPORT_SELECT_KML_FILE_FORM_LAYOUT = {
    kmlFile: DEFAULT_FORM_LAYOUT_INPUT,
};
/** @type {?} */
var GROUND_IMPORT_SELECT_KML_FILE_FORM_MODEL = [
    new DynamicFileUploadModel({
        id: 'kmlFile',
        maxSize: MAX_FILE_SIZE$3
    })
];
/** @type {?} */
var GROUND_IMPORT_SELECT_SHP_FILE_FORM_LAYOUT = {
    shpFile: DEFAULT_FORM_LAYOUT_INPUT,
    dbfFile: DEFAULT_FORM_LAYOUT_INPUT
};
/** @type {?} */
var GROUND_IMPORT_SELECT_SHP_FILE_FORM_MODEL = [
    new DynamicFileUploadModel({
        id: 'shpFile',
        maxSize: MAX_FILE_SIZE$3
    }),
    new DynamicFileUploadModel({
        id: 'dbfFile',
        maxSize: MAX_FILE_SIZE$3
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSelectGeojsonFileComponent = /** @class */ (function (_super) {
    __extends(GroundImportSelectGeojsonFileComponent, _super);
    function GroundImportSelectGeojsonFileComponent(activeModal, groundLocationConverterService) {
        var _this = _super.call(this, activeModal) || this;
        _this.groundLocationConverterService = groundLocationConverterService;
        _this.formLayout = GROUND_IMPORT_SELECT_GEOJSON_FILE_FORM_LAYOUT;
        _this.formModel = GROUND_IMPORT_SELECT_GEOJSON_FILE_FORM_MODEL;
        return _this;
    }
    /**
     * @protected
     * @return {?}
     */
    GroundImportSelectGeojsonFileComponent.prototype.createInitValue = /**
     * @protected
     * @return {?}
     */
    function () {
        return { geojsonFile: null };
    };
    /**
     * @protected
     * @param {?} form
     * @return {?}
     */
    GroundImportSelectGeojsonFileComponent.prototype.convertFile = /**
     * @protected
     * @param {?} form
     * @return {?}
     */
    function (form) {
        return this.groundLocationConverterService.convertFromGeojsonToGeojson(form.geojsonFile.file);
    };
    GroundImportSelectGeojsonFileComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-import-select-geojson-file',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ headerTranslationKey | translate }}</h4>\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"onCancel($event)\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <app-add-form *ngIf=\"formModel\"\r\n            #selectFileForm\r\n            [formModel]=\"formModel\"\r\n            [formLayout]=\"formLayout\"\r\n            [model]=\"initValue\"\r\n            (add)=\"onSave($event)\"\r\n            [translateKey]=\"translationKeyPrefix\"\r\n            (afterCancel)=\"onCancel($event)\">\r\n        </app-add-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    GroundImportSelectGeojsonFileComponent.ctorParameters = function () { return [
        { type: NgbActiveModal },
        { type: GroundLocationConverterService }
    ]; };
    return GroundImportSelectGeojsonFileComponent;
}(GroundImportSelectFileComponent));
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundImportSelectGeojsonFileComponent.prototype.groundLocationConverterService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSelectKmlFileComponent = /** @class */ (function (_super) {
    __extends(GroundImportSelectKmlFileComponent, _super);
    function GroundImportSelectKmlFileComponent(activeModal, groundLocationConverterService) {
        var _this = _super.call(this, activeModal) || this;
        _this.groundLocationConverterService = groundLocationConverterService;
        _this.formLayout = GROUND_IMPORT_SELECT_KML_FILE_FORM_LAYOUT;
        _this.formModel = GROUND_IMPORT_SELECT_KML_FILE_FORM_MODEL;
        return _this;
    }
    /**
     * @protected
     * @return {?}
     */
    GroundImportSelectKmlFileComponent.prototype.createInitValue = /**
     * @protected
     * @return {?}
     */
    function () {
        return { kmlFile: null };
    };
    /**
     * @protected
     * @param {?} form
     * @return {?}
     */
    GroundImportSelectKmlFileComponent.prototype.convertFile = /**
     * @protected
     * @param {?} form
     * @return {?}
     */
    function (form) {
        return this.groundLocationConverterService.convertFromKmlToGeojson(form.kmlFile.file);
    };
    GroundImportSelectKmlFileComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-import-select-kml-file',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ headerTranslationKey | translate }}</h4>\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"onCancel($event)\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <app-add-form *ngIf=\"formModel\"\r\n            #selectFileForm\r\n            [formModel]=\"formModel\"\r\n            [formLayout]=\"formLayout\"\r\n            [model]=\"initValue\"\r\n            (add)=\"onSave($event)\"\r\n            [translateKey]=\"translationKeyPrefix\"\r\n            (afterCancel)=\"onCancel($event)\">\r\n        </app-add-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    GroundImportSelectKmlFileComponent.ctorParameters = function () { return [
        { type: NgbActiveModal },
        { type: GroundLocationConverterService }
    ]; };
    return GroundImportSelectKmlFileComponent;
}(GroundImportSelectFileComponent));
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundImportSelectKmlFileComponent.prototype.groundLocationConverterService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSelectShpFileComponent = /** @class */ (function (_super) {
    __extends(GroundImportSelectShpFileComponent, _super);
    function GroundImportSelectShpFileComponent(activeModal, groundLocationConverterService) {
        var _this = _super.call(this, activeModal) || this;
        _this.groundLocationConverterService = groundLocationConverterService;
        _this.formLayout = GROUND_IMPORT_SELECT_SHP_FILE_FORM_LAYOUT;
        _this.formModel = GROUND_IMPORT_SELECT_SHP_FILE_FORM_MODEL;
        return _this;
    }
    /**
     * @protected
     * @return {?}
     */
    GroundImportSelectShpFileComponent.prototype.createInitValue = /**
     * @protected
     * @return {?}
     */
    function () {
        return { shpFile: null, dbfFile: null };
    };
    /**
     * @protected
     * @param {?} form
     * @return {?}
     */
    GroundImportSelectShpFileComponent.prototype.convertFile = /**
     * @protected
     * @param {?} form
     * @return {?}
     */
    function (form) {
        return this.groundLocationConverterService.convertFromShpToGeojson(form.shpFile.file, form.dbfFile.file);
    };
    GroundImportSelectShpFileComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-import-select-shp-file',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ headerTranslationKey | translate }}</h4>\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"onCancel($event)\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <app-add-form *ngIf=\"formModel\"\r\n            #selectFileForm\r\n            [formModel]=\"formModel\"\r\n            [formLayout]=\"formLayout\"\r\n            [model]=\"initValue\"\r\n            (add)=\"onSave($event)\"\r\n            [translateKey]=\"translationKeyPrefix\"\r\n            (afterCancel)=\"onCancel($event)\">\r\n        </app-add-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    GroundImportSelectShpFileComponent.ctorParameters = function () { return [
        { type: NgbActiveModal },
        { type: GroundLocationConverterService }
    ]; };
    return GroundImportSelectShpFileComponent;
}(GroundImportSelectFileComponent));
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundImportSelectShpFileComponent.prototype.groundLocationConverterService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSchema = /** @class */ (function () {
    function GroundImportSchema() {
    }
    return GroundImportSchema;
}());
if (false) {
    /** @type {?} */
    GroundImportSchema.prototype.headerKey;
    /** @type {?} */
    GroundImportSchema.prototype.importSHPButtonKey;
    /** @type {?} */
    GroundImportSchema.prototype.importKMLButtonKey;
    /** @type {?} */
    GroundImportSchema.prototype.importGEOJSONButtonKey;
    /** @type {?} */
    GroundImportSchema.prototype.importSelectFileInfoKey;
    /** @type {?} */
    GroundImportSchema.prototype.selectFileModalHeaderKey;
    /** @type {?} */
    GroundImportSchema.prototype.selectFileTranslationKeyPrefix;
    /** @type {?} */
    GroundImportSchema.prototype.mapHeaderKey;
    /** @type {?} */
    GroundImportSchema.prototype.listHeaderKey;
    /** @type {?} */
    GroundImportSchema.prototype.listColumnChooseKey;
    /** @type {?} */
    GroundImportSchema.prototype.listColumnNameKey;
    /** @type {?} */
    GroundImportSchema.prototype.listColumnAreaInHaKey;
    /** @type {?} */
    GroundImportSchema.prototype.listColumnActionsKey;
    /** @type {?} */
    GroundImportSchema.prototype.listShowOnMapButtonKey;
    /** @type {?} */
    GroundImportSchema.prototype.listEmptyKey;
    /** @type {?} */
    GroundImportSchema.prototype.listErrorKey;
    /** @type {?} */
    GroundImportSchema.prototype.listImportButtonKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportModel = /** @class */ (function () {
    function GroundImportModel() {
    }
    return GroundImportModel;
}());
if (false) {
    /** @type {?} */
    GroundImportModel.prototype.isSelected;
    /** @type {?} */
    GroundImportModel.prototype.name;
    /** @type {?} */
    GroundImportModel.prototype.cadastralState;
    /** @type {?} */
    GroundImportModel.prototype.cadastralCounty;
    /** @type {?} */
    GroundImportModel.prototype.cadastralCommune;
    /** @type {?} */
    GroundImportModel.prototype.cadastralArea;
    /** @type {?} */
    GroundImportModel.prototype.cadastreNumber;
    /** @type {?} */
    GroundImportModel.prototype.areaInHa;
    /** @type {?} */
    GroundImportModel.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSelectedModel = /** @class */ (function (_super) {
    __extends(GroundImportSelectedModel, _super);
    function GroundImportSelectedModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GroundImportSelectedModel;
}(GroundImportModel));
if (false) {
    /** @type {?} */
    GroundImportSelectedModel.prototype.isAvailableSelect;
    /** @type {?} */
    GroundImportSelectedModel.prototype.isSelected;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportComponent = /** @class */ (function () {
    function GroundImportComponent(mapService, modalService, numberUtilService, translateService) {
        var _this = this;
        this.mapService = mapService;
        this.modalService = modalService;
        this.numberUtilService = numberUtilService;
        this.translateService = translateService;
        this.import = new EventEmitter();
        this.showResult = false;
        this.polygonCfg = new PolygonConfig(groundDrawingColor, false, false, false);
        this.markerCfg = new MarkerConfig(false);
        this.groundImports = [];
        this.initView = (/**
         * @param {?} geojsonData
         * @return {?}
         */
        function (geojsonData) {
            _this.groundImports = (geojsonData || [])
                .map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return _this.buildGroundImportSelectedModel(x); }));
            _this.dataSource.forceRefresh();
        });
        this.buildGroundName = (/**
         * @param {?} cadastre
         * @return {?}
         */
        function (cadastre) {
            if (cadastre == null
                || ((cadastre.cadastralArea == null || cadastre.cadastralArea.name == null)
                    && cadastre.cadastreNumber == null)) {
                return null;
            }
            return [
                cadastre.cadastralArea != null && cadastre.cadastralArea.name != null ? cadastre.cadastralArea.name : null,
                cadastre.cadastreNumber
            ].filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x != null; })).join(' - ');
        });
        this.features = new Array();
        this.mapConfig = new MapConfig();
        this.displayedColumns = ['choose', 'name', 'areaInHa', 'action'];
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} requestList
         * @return {?}
         */
        function (requestList) {
            return of({
                items: _this.groundImports,
                totalCount: _this.groundImports.length
            }).pipe(tap((/**
             * @param {?} res
             * @return {?}
             */
            function (res) { return _this.showResult = res.items.length > 0; })), tap((/**
             * @param {?} resp
             * @return {?}
             */
            function (resp) {
                _this.features = resp.items.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) {
                    /** @type {?} */
                    var result = (x.locations || []).slice();
                    result.forEach((/**
                     * @param {?} location
                     * @return {?}
                     */
                    function (location) {
                        location.properties.name = _this.buildPopupContent(x);
                    }));
                    return result;
                })).reduce((/**
                 * @param {?} a
                 * @param {?} b
                 * @return {?}
                 */
                function (a, b) { return a.concat(b); }));
            })));
        }));
    }
    Object.defineProperty(GroundImportComponent.prototype, "polygonConfig", {
        get: /**
         * @return {?}
         */
        function () { return this.polygonCfg; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroundImportComponent.prototype, "markerConfig", {
        get: /**
         * @return {?}
         */
        function () { return this.markerCfg; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    GroundImportComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @return {?}
     */
    GroundImportComponent.prototype.onImportFromGeojson = /**
     * @return {?}
     */
    function () {
        this.openSelectFilesModal(GroundImportSelectGeojsonFileComponent).subscribe(this.initView);
    };
    /**
     * @return {?}
     */
    GroundImportComponent.prototype.onImportFromKml = /**
     * @return {?}
     */
    function () {
        this.openSelectFilesModal(GroundImportSelectKmlFileComponent).subscribe(this.initView);
    };
    /**
     * @return {?}
     */
    GroundImportComponent.prototype.onImportFromShp = /**
     * @return {?}
     */
    function () {
        this.openSelectFilesModal(GroundImportSelectShpFileComponent).subscribe(this.initView);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundImportComponent.prototype.onShowOnMap = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (item.locations.length > 0) {
            // tslint:disable-next-line: no-string-literal
            /** @type {?} */
            var bounds = this.mapService.getPolygonBounds(item.locations[0].geometry['coordinates']);
            this.mapConfig = new MapConfig(bounds);
        }
    };
    /**
     * @return {?}
     */
    GroundImportComponent.prototype.onImport = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selectedGrounds = this.groundImports.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.isSelected; }));
        this.import.emit(selectedGrounds);
    };
    Object.defineProperty(GroundImportComponent.prototype, "isImportEnabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.groundImports.some((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.isSelected; }));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @param {?} content
     * @return {?}
     */
    GroundImportComponent.prototype.openSelectFilesModal = /**
     * @private
     * @param {?} content
     * @return {?}
     */
    function (content) {
        /** @type {?} */
        var selectFilesModal = this.modalService.open(content, { windowClass: 'center', beforeDismiss: (/**
             * @return {?}
             */
            function () { return true; }) });
        selectFilesModal.componentInstance.headerTranslationKey = this.schema.selectFileModalHeaderKey;
        selectFilesModal.componentInstance.translationKeyPrefix = this.schema.selectFileTranslationKeyPrefix;
        return from(selectFilesModal.result);
    };
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    GroundImportComponent.prototype.buildPopupContent = /**
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return "<div class=\"row si-modal no-gutters mb-0\">\n                    <div class=\"col-12\"><h6 class=\"font-weight-bold\">" + (item.name != null ? item.name : '-') + "</h6></div>\n                    <div class=\"col-12\">\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.listColumnAreaInHaKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 mb-0 text-md-right si-modal-data\">\n                                " + item.areaInHa + " ha\n                            </div>\n                        </div>\n                        <div style=\"clear:both\"></div>\n                    </div>\n                </div>";
    };
    /**
     * @private
     * @param {?} x
     * @return {?}
     */
    GroundImportComponent.prototype.buildGroundImportSelectedModel = /**
     * @private
     * @param {?} x
     * @return {?}
     */
    function (x) {
        /** @type {?} */
        var areaInHa = this.numberUtilService.round2(x.sizeInHa);
        /** @type {?} */
        var cadastre = this.getMainCadastre(x);
        /** @type {?} */
        var result = new GroundImportSelectedModel();
        result.isAvailableSelect = cadastre != null && areaInHa > 0;
        result.isSelected = cadastre != null && areaInHa > 0;
        result.name = this.buildGroundName(cadastre);
        result.areaInHa = areaInHa;
        result.cadastralState = cadastre != null ? cadastre.cadastralState : null;
        result.cadastralCounty = cadastre != null ? cadastre.cadastralCounty : null;
        result.cadastralCommune = cadastre != null ? cadastre.cadastralCommune : null;
        result.cadastralArea = cadastre != null ? cadastre.cadastralArea : null;
        result.cadastreNumber = cadastre != null ? cadastre.cadastreNumber : null;
        result.locations = [(/** @type {?} */ ({
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: x.geometry.coordinates[0]
                },
                properties: {
                    area: x.sizeInHa,
                    fillColor: groundDrawingColor,
                    strokeColor: groundDrawingColor,
                    name: result.name
                }
            }))];
        return result;
    };
    /**
     * @private
     * @param {?} groundLocationInfo
     * @return {?}
     */
    GroundImportComponent.prototype.getMainCadastre = /**
     * @private
     * @param {?} groundLocationInfo
     * @return {?}
     */
    function (groundLocationInfo) {
        if (groundLocationInfo == null
            || groundLocationInfo.cadastres == null
            || groundLocationInfo.cadastres.length === 0) {
            return null;
        }
        return groundLocationInfo.cadastres[0];
    };
    GroundImportComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-import',
                    template: "<div class=\"d-flex align-items-center justify-content-between\">\r\n    <h2 class=\"m-0\">{{ schema.headerKey | translate }}</h2>\r\n    <div>\r\n        <button class=\"btn btn-raised ml-3 btn-info\" (click)=\"onImportFromShp()\">\r\n            <i class=\"ft-plus-circle\"></i> {{ schema.importSHPButtonKey | translate }}\r\n        </button>\r\n        <button class=\"btn btn-raised ml-3 btn-info\" (click)=\"onImportFromKml()\">\r\n            <i class=\"ft-plus-circle\"></i> {{ schema.importKMLButtonKey | translate }}\r\n        </button>\r\n        <button class=\"btn btn-raised ml-3 btn-info d-none\" (click)=\"onImportFromGeojson()\">\r\n            <i class=\"ft-plus-circle\"></i> {{ schema.importGEOJSONButtonKey | translate }}\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"card\" [ngClass]=\"{'d-none' : showResult}\" appPanelFullscreen>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container-fluid\">\r\n                <h4 class=\"m-0\">{{ schema.importSelectFileInfoKey | translate }}</h4>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"card\" [ngClass]=\"{'d-none' : !showResult}\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-map\"></i> {{ schema.mapHeaderKey | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-hide-button\r\n            [hidden]=\"false\"\r\n            (hiddenChange)=\"panelHide.setHidden($event)\"\r\n            class=\"float-right\"></app-panel-hide-button>\r\n        <hr class=\"my-0\" />\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <div style=\"height: 450px;\">\r\n                    <app-map [mapConfig]=\"mapConfig\"\r\n                        [polygonConfig]=\"polygonConfig\"\r\n                        [markerConfig]=\"markerConfig\"\r\n                        [features]=\"features\">\r\n                    </app-map>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"mb-2\" [ngClass]=\"{'d-none' : !showResult}\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\">\r\n                    <i class=\"ft ft-list\"></i> {{ schema.listHeaderKey | translate }}\r\n                </h5>\r\n            </label>\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid\">\r\n\r\n                    <cdk-table [dataSource]=\"dataSource\">\r\n\r\n                        <ng-container cdkColumnDef=\"choose\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-1 pr-0\">\r\n                                <span class=\"d-none d-sm-block\">{{ schema.listColumnChooseKey | translate }}</span>\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-1 pr-0\">\r\n                                <div class=\"form-check\">\r\n                                    <input class=\"form-check-input\" type=\"checkbox\" [checked]=\"element.isSelected\"\r\n                                    [disabled]=\"!element.isAvailableSelect\"\r\n                                    (change)=\"element.isSelected = !element.isSelected\">\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-8 col-sm-6 pr-0\">\r\n                                {{ schema.listColumnNameKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-8 col-sm-6 pr-0\">\r\n                                <span [ngClass]=\"{'font-italic' : !element.isSelected}\">{{ element.name }}</span>\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"areaInHa\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"d-none d-sm-block col-sm-3 col-md-4 pr-0\">\r\n                                {{ schema.listColumnAreaInHaKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"d-none d-sm-block col-sm-3 col-md-4 pr-0\">\r\n                                <span [ngClass]=\"{'font-italic' : !element.isSelected}\">{{ element.areaInHa }}</span>\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-3 col-sm-2 col-md-1 text-right\">\r\n                                {{ schema.listColumnActionsKey | translate | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-3 col-sm-2 col-md-1 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-end\">\r\n                                    <button (click)=\"onShowOnMap(element)\"\r\n                                        title=\"{{ schema.listShowOnMapButtonKey | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\"\r\n                            *cdkHeaderRowDef=\"displayedColumns\"></cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\"\r\n                            *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listEmptyKey | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listErrorKey | translate }}</div>\r\n                    </div>\r\n                    <div class=\"d-none\">\r\n                        <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                            [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons></cdk-paginator>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                        <button\r\n                            (click)=\"onImport()\"\r\n                            [disabled]=\"!isImportEnabled\"\r\n                            title=\"{{ schema.listImportButtonKey | translate }}\"\r\n                            class=\"btn btn-raised btn-lg btn-info w-100 mt-3\">\r\n                            <span>{{ schema.listImportButtonKey | translate }}</span>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".form-check{margin-top:-10px}"]
                }] }
    ];
    /** @nocollapse */
    GroundImportComponent.ctorParameters = function () { return [
        { type: MapService },
        { type: NgbModal },
        { type: NumberUtilService },
        { type: TranslateService$1 }
    ]; };
    GroundImportComponent.propDecorators = {
        schema: [{ type: Input }],
        import: [{ type: Output }],
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return GroundImportComponent;
}());
if (false) {
    /** @type {?} */
    GroundImportComponent.prototype.schema;
    /** @type {?} */
    GroundImportComponent.prototype.import;
    /** @type {?} */
    GroundImportComponent.prototype.showResult;
    /** @type {?} */
    GroundImportComponent.prototype.features;
    /** @type {?} */
    GroundImportComponent.prototype.mapConfig;
    /** @type {?} */
    GroundImportComponent.prototype.panelHide;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.polygonCfg;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.markerCfg;
    /** @type {?} */
    GroundImportComponent.prototype.dataSource;
    /** @type {?} */
    GroundImportComponent.prototype.sort;
    /** @type {?} */
    GroundImportComponent.prototype.paginator;
    /** @type {?} */
    GroundImportComponent.prototype.displayedColumns;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.groundImports;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.initView;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.buildGroundName;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.mapService;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.modalService;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    GroundImportComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundCommand = /** @class */ (function () {
    function GroundCommand(name, areaInHa, lease, cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, groundCategory, complexOfAgriculturalSuitability, agronomicCategory, locations) {
        this.name = name;
        this.areaInHa = areaInHa;
        this.lease = lease;
        this.cadastralState = cadastralState;
        this.cadastralCounty = cadastralCounty;
        this.cadastralCommune = cadastralCommune;
        this.cadastralArea = cadastralArea;
        this.cadastreNumber = cadastreNumber;
        this.groundCategory = groundCategory;
        this.complexOfAgriculturalSuitability = complexOfAgriculturalSuitability;
        this.agronomicCategory = agronomicCategory;
        this.locations = locations;
    }
    return GroundCommand;
}());
if (false) {
    /** @type {?} */
    GroundCommand.prototype.name;
    /** @type {?} */
    GroundCommand.prototype.areaInHa;
    /** @type {?} */
    GroundCommand.prototype.lease;
    /** @type {?} */
    GroundCommand.prototype.cadastralState;
    /** @type {?} */
    GroundCommand.prototype.cadastralCounty;
    /** @type {?} */
    GroundCommand.prototype.cadastralCommune;
    /** @type {?} */
    GroundCommand.prototype.cadastralArea;
    /** @type {?} */
    GroundCommand.prototype.cadastreNumber;
    /** @type {?} */
    GroundCommand.prototype.groundCategory;
    /** @type {?} */
    GroundCommand.prototype.complexOfAgriculturalSuitability;
    /** @type {?} */
    GroundCommand.prototype.agronomicCategory;
    /** @type {?} */
    GroundCommand.prototype.locations;
}
var CreateGroundCommand = /** @class */ (function (_super) {
    __extends(CreateGroundCommand, _super);
    function CreateGroundCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreateGroundCommand;
}(GroundCommand));
var UpdateGroundCommand = /** @class */ (function (_super) {
    __extends(UpdateGroundCommand, _super);
    function UpdateGroundCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UpdateGroundCommand;
}(GroundCommand));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundGeoData = /** @class */ (function () {
    function GroundGeoData(id, name) {
        this.id = id;
        this.name = name;
    }
    return GroundGeoData;
}());
if (false) {
    /** @type {?} */
    GroundGeoData.prototype.id;
    /** @type {?} */
    GroundGeoData.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_EDIT_FORM_LAYOUT = {
    groundMapGroup: DEFAULT_FORM_LAYOUT_GROUP,
    groundBaseInfoGroup: DEFAULT_FORM_LAYOUT_GROUP,
    groundLocationGroup: DEFAULT_FORM_LAYOUT_GROUP,
    groundPropertiesGroup: DEFAULT_FORM_LAYOUT_GROUP,
    name: DEFAULT_FORM_LAYOUT_INPUT,
    areaInHa: DEFAULT_FORM_LAYOUT_INPUT,
    lease: DEFAULT_FORM_LAYOUT_INPUT,
    groundCategory: DEFAULT_FORM_LAYOUT_INPUT,
    complexOfAgriculturalSuitability: DEFAULT_FORM_LAYOUT_INPUT,
    agronomicCategory: DEFAULT_FORM_LAYOUT_INPUT,
    features: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    cadastralRegister: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
};
/** @type {?} */
var MAP_FORM_MODEL = new DynamicFormGroupModel({
    id: 'groundMapGroup',
    group: [
        new DynamicCadastralRegisterMapFormControlModel({
            id: 'features',
            mapConfig: new MapConfig(),
            polygonConfig: new PolygonConfig(groundDrawingColor, false, false)
        })
    ]
});
/** @type {?} */
var BASE_INFO_FORM_MODEL = new DynamicFormGroupModel({
    id: 'groundBaseInfoGroup',
    group: [
        new DynamicInputModel({
            id: 'id',
            hidden: true
        }),
        new DynamicInputModel({
            id: 'name',
            minLength: 3,
            maxLength: 60,
            validators: {
                required: null,
                minLength: 3,
                maxLength: 60
            }
        }),
        new DynamicInputModel({
            id: 'areaInHa',
            min: 0.01,
            max: 1000,
            step: 0.01,
            inputType: 'number',
            validators: {
                required: null,
                min: 0.01,
                max: 1000,
                decimalNumberValidator: 2
            }
        }),
        new DynamicCheckboxModel({
            id: 'lease',
        })
    ]
});
/** @type {?} */
var LOCATION_FORM_MODEL = new DynamicFormGroupModel({
    id: 'groundLocationGroup',
    group: [
        new DynamicCadastralRegisterFormControlModel({
            id: 'cadastralRegister',
            translateKey: 'GROUND',
            cadastreAsSelectInput: false,
            validators: {
                cadastralGroundRegisterValidator: {}
            }
        })
    ]
});
/** @type {?} */
var GROUND_PROPERTIES_FORM_MODEL = new DynamicFormGroupModel({
    id: 'groundPropertiesGroup',
    group: [
        new DynamicSelectModel({
            id: 'groundCategory',
            options: [
                { value: GroundCategory.I, label: 'I' },
                { value: GroundCategory.II, label: 'II' },
                { value: GroundCategory.IIIa, label: 'IIIa' },
                { value: GroundCategory.IIIb, label: 'IIIb' },
                { value: GroundCategory.IVa, label: 'IVa' },
                { value: GroundCategory.IVb, label: 'IVb' },
                { value: GroundCategory.V, label: 'V' },
                { value: GroundCategory.VI, label: 'VI' }
            ]
        }),
        new DynamicSelectModel({
            id: 'complexOfAgriculturalSuitability',
            options: getOptionsForDynamicSelectModel(ComplexOfAgriculturalSuitability, 'COMPLEX_OF_AGRICULTURAL_SUITABILITIES', true)
        }),
        new DynamicSelectModel({
            id: 'agronomicCategory',
            options: getOptionsForDynamicSelectModel(AgronomicCategory, 'AGRONOMIC_CATEGORIES', true)
        })
    ]
});
/** @type {?} */
var GROUND_EDIT_FORM_MODEL = [
    MAP_FORM_MODEL, BASE_INFO_FORM_MODEL, LOCATION_FORM_MODEL, GROUND_PROPERTIES_FORM_MODEL
];
/**
 * @param {?} data
 * @return {?}
 */
function mapToGroundEditForm(data) {
    return {
        groundMapGroup: {
            features: new CadastralRegisterMapValue(null, data.locations || [])
        },
        groundBaseInfoGroup: {
            id: data.id,
            name: data.name,
            areaInHa: data.areaInHa,
            lease: data.lease,
        },
        groundLocationGroup: {
            cadastralRegister: new CadastralRegister(data.cadastralState, data.cadastralCounty, data.cadastralCommune, data.cadastralArea, data.cadastreNumber)
        },
        groundPropertiesGroup: {
            groundCategory: data.groundCategory,
            complexOfAgriculturalSuitability: data.complexOfAgriculturalSuitability,
            agronomicCategory: data.agronomicCategory
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromGroundEditForm(data) {
    return new UpdateGroundCommand(data.groundBaseInfoGroup.name, data.groundBaseInfoGroup.areaInHa, data.groundBaseInfoGroup.lease, new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralState.id, data.groundLocationGroup.cadastralRegister.cadastralState.name), new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralCounty.id, data.groundLocationGroup.cadastralRegister.cadastralCounty.name), new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralCommune.id, data.groundLocationGroup.cadastralRegister.cadastralCommune.name), new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralArea.id, data.groundLocationGroup.cadastralRegister.cadastralArea.name), data.groundLocationGroup.cadastralRegister.cadastreNumber, data.groundPropertiesGroup.groundCategory, data.groundPropertiesGroup.complexOfAgriculturalSuitability, data.groundPropertiesGroup.agronomicCategory, data.groundMapGroup.features.features.map((/**
     * @param {?} x
     * @return {?}
     */
    function (x) {
        x.properties.name = data.groundBaseInfoGroup.name;
        return x;
    })));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundEditComponent = /** @class */ (function () {
    function GroundEditComponent(groundSharedService, changeDetectorRef) {
        this.groundSharedService = groundSharedService;
        this.changeDetectorRef = changeDetectorRef;
        this.startFromIsEditing = false;
        this.groundNameChanged = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = GROUND_EDIT_FORM_LAYOUT;
        this.formModel = GROUND_EDIT_FORM_MODEL;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    GroundEditComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.startFromIsEditing && changes.startFromIsEditing.currentValue !== changes.startFromIsEditing.previousValue) {
            this.setEditMode(this.startFromIsEditing);
        }
        if ((changes.groundId && changes.groundId.currentValue !== changes.groundId.previousValue)
            || (changes.organizationId && changes.organizationId.currentValue !== changes.organizationId.previousValue)) {
            this.loadAndInitValue();
        }
    };
    /**
     * @return {?}
     */
    GroundEditComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.getSubscription != null) {
            this.getSubscription.unsubscribe();
        }
        if (this.updateSubscription != null) {
            this.updateSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundEditComponent.prototype.onSave = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        this.displaySpinner$.next(true);
        /** @type {?} */
        var updateCommand = mapFromGroundEditForm($event);
        if (this.updateSubscription != null) {
            this.updateSubscription.unsubscribe();
        }
        this.updateSubscription = this.groundSharedService.update(this.organizationId, this.groundId, updateCommand)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.groundNameChanged.emit(updateCommand.name);
            _this.formDetail.saveSuccess();
            _this.changeDetectorRef.detectChanges();
            _this.formDetail.refreshFormModel();
        }));
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    GroundEditComponent.prototype.onFormGroupInitialized = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        formGroup.get('groundMapGroup').get('features').valueChanges
            .pipe(filter((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            return value && (!!value.cadastralRegister || !!value.features && value.features.length > 0);
        })))
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value.cadastralRegister) {
                formGroup.get('groundLocationGroup').get('cadastralRegister').patchValue(value.cadastralRegister);
            }
            if (value.features && value.features.length > 0) {
                /** @type {?} */
                var area = value.features[0].properties.area;
                /** @type {?} */
                var areaInHaInputModel = formGroup.get('groundBaseInfoGroup').get('areaInHa');
                areaInHaInputModel.patchValue(area);
                areaInHaInputModel.updateValueAndValidity();
            }
        }));
        formGroup.get('groundLocationGroup').get('cadastralRegister').valueChanges
            .subscribe((/**
         * @param {?} cadastralRegister
         * @return {?}
         */
        function (cadastralRegister) {
            if (cadastralRegister != null
                && cadastralRegister.cadastralArea != null
                && cadastralRegister.cadastralArea.name
                && cadastralRegister.cadastreNumber) {
                /** @type {?} */
                var groundNameInputModel = formGroup.get('groundBaseInfoGroup').get('name');
                if (!groundNameInputModel.value) {
                    /** @type {?} */
                    var groundName = cadastralRegister.cadastralArea.name + " - " + cadastralRegister.cadastreNumber;
                    groundNameInputModel.patchValue(groundName);
                    groundNameInputModel.updateValueAndValidity();
                }
            }
        }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundEditComponent.prototype.onIsEditingChange = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.setEditMode($event);
        this.changeDetectorRef.detectChanges();
        this.formDetail.refreshFormModel();
    };
    /**
     * @private
     * @return {?}
     */
    GroundEditComponent.prototype.loadAndInitValue = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.organizationId != null && this.groundId != null) {
            this.displaySpinner$.next(true);
            if (this.getSubscription != null) {
                this.getSubscription.unsubscribe();
            }
            this.getSubscription = this.groundSharedService.get(this.organizationId, this.groundId)
                .pipe(finalize((/**
             * @return {?}
             */
            function () { _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} ground
             * @return {?}
             */
            function (ground) {
                _this.groundNameChanged.emit(ground.name);
                _this.initValue = mapToGroundEditForm(ground);
                _this.refreshFormModel();
            }));
        }
    };
    /**
     * @private
     * @param {?} isEditMode
     * @return {?}
     */
    GroundEditComponent.prototype.setEditMode = /**
     * @private
     * @param {?} isEditMode
     * @return {?}
     */
    function (isEditMode) {
        this.featuresModel.polygonConfig = new PolygonConfig(groundDrawingColor, isEditMode, isEditMode);
    };
    /**
     * @private
     * @return {?}
     */
    GroundEditComponent.prototype.refreshFormModel = /**
     * @private
     * @return {?}
     */
    function () {
        this.formDetail.refreshFormModel();
    };
    Object.defineProperty(GroundEditComponent.prototype, "featuresModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formGroupModel = (/** @type {?} */ (this.formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === 'groundMapGroup'; }))));
            return (/** @type {?} */ (formGroupModel.group.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === 'features'; }))));
        },
        enumerable: true,
        configurable: true
    });
    GroundEditComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-edit',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <app-form *ngIf=\"formModel\"\r\n                    #formDetail\r\n                    [startFromIsEditing]=\"startFromIsEditing\"\r\n                    [formModel]=\"formModel\"\r\n                    [formLayout]=\"formLayout\"\r\n                    [model]=\"initValue\"\r\n                    [translateKey]=\"translationKeyPrefix\"\r\n                    (isEditingChange)=\"onIsEditingChange($event)\"\r\n                    (save)=\"onSave($event)\"\r\n                    (formGroupInitialized)=\"onFormGroupInitialized($event)\">\r\n                </app-form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    GroundEditComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_SHARED_SERVICE,] }] },
        { type: ChangeDetectorRef }
    ]; };
    GroundEditComponent.propDecorators = {
        formDetail: [{ type: ViewChild, args: ['formDetail', { static: false },] }],
        organizationId: [{ type: Input }],
        groundId: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }],
        startFromIsEditing: [{ type: Input }],
        groundNameChanged: [{ type: Output }]
    };
    return GroundEditComponent;
}());
if (false) {
    /** @type {?} */
    GroundEditComponent.prototype.formDetail;
    /** @type {?} */
    GroundEditComponent.prototype.organizationId;
    /** @type {?} */
    GroundEditComponent.prototype.groundId;
    /** @type {?} */
    GroundEditComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    GroundEditComponent.prototype.startFromIsEditing;
    /** @type {?} */
    GroundEditComponent.prototype.groundNameChanged;
    /** @type {?} */
    GroundEditComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundEditComponent.prototype.formLayout;
    /** @type {?} */
    GroundEditComponent.prototype.formModel;
    /** @type {?} */
    GroundEditComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    GroundEditComponent.prototype.getSubscription;
    /**
     * @type {?}
     * @private
     */
    GroundEditComponent.prototype.updateSubscription;
    /**
     * @type {?}
     * @private
     */
    GroundEditComponent.prototype.groundSharedService;
    /**
     * @type {?}
     * @private
     */
    GroundEditComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_CUSTOM_MAP_SHARED_SERVICE = new InjectionToken('GroundCustomMapSharedService');
/**
 * @record
 */
function IGroundCustomMapSharedService() { }
if (false) {
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @return {?}
     */
    IGroundCustomMapSharedService.prototype.getAllByGroundId = function (organizationId, groundId) { };
    /**
     * @param {?} organizationId
     * @param {?} parcelCustomMapId
     * @return {?}
     */
    IGroundCustomMapSharedService.prototype.get = function (organizationId, parcelCustomMapId) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundCustomMapsSchema = /** @class */ (function () {
    function GroundCustomMapsSchema(headerKey, generatedDateKey, vehicleNameKey, machineNameKey, mapTypeKey, actionKey, showOnMapButtonKey, listEmptyKey, listErrorKey) {
        this.headerKey = headerKey;
        this.generatedDateKey = generatedDateKey;
        this.vehicleNameKey = vehicleNameKey;
        this.machineNameKey = machineNameKey;
        this.mapTypeKey = mapTypeKey;
        this.actionKey = actionKey;
        this.showOnMapButtonKey = showOnMapButtonKey;
        this.listEmptyKey = listEmptyKey;
        this.listErrorKey = listErrorKey;
    }
    return GroundCustomMapsSchema;
}());
if (false) {
    /** @type {?} */
    GroundCustomMapsSchema.prototype.headerKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.generatedDateKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.vehicleNameKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.machineNameKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.mapTypeKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.actionKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.showOnMapButtonKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.listEmptyKey;
    /** @type {?} */
    GroundCustomMapsSchema.prototype.listErrorKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundCustomMapsComponent = /** @class */ (function () {
    function GroundCustomMapsComponent(groundSharedService, groundCustomMapSharedService, pureMapService) {
        var _this = this;
        this.groundSharedService = groundSharedService;
        this.groundCustomMapSharedService = groundCustomMapSharedService;
        this.pureMapService = pureMapService;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.groundLocationsSubject = new BehaviorSubject([]);
        this.unsubscribe$ = new Subject();
        this.colors = [
            '#ff0000',
            '#ff3200',
            '#ff4900',
            '#ff5b00',
            '#ff6a00',
            '#ff7700',
            '#ff8402',
            '#ff8f08',
            '#ff9b0f',
            '#ffa517',
            '#ffb01f',
            '#ffba28',
            '#ffc432',
            '#ffcd3e',
            '#ffd74b',
            '#ffe059',
            '#ffe96c',
            '#fff283',
            '#fffaa3',
            '#ffffe0'
        ];
        this.createPolygonProperties = (/**
         * @param {?} result
         * @param {?} coords
         * @param {?} feature
         * @param {?} minVal
         * @param {?} maxVal
         * @return {?}
         */
        function (result, coords, feature, minVal, maxVal) {
            /** @type {?} */
            var colorIndex = 14;
            /** @type {?} */
            var noOpacity = 1;
            /** @type {?} */
            var partialOpacity = 0.75;
            return {
                paths: coords.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return new google.maps.LatLng({ lat: x[1], lng: x[0] }); })),
                strokeColor: result.mapType !== CustomMapType.MachineFill ? null : _this.colors[colorIndex],
                strokeOpacity: result.mapType !== CustomMapType.MachineFill ? 0 : 1,
                fillColor: result.mapType !== CustomMapType.MachineFill
                    ? _this.calculateFillColor(feature.properties.value, minVal, maxVal)
                    : _this.colors[colorIndex],
                fillOpacity: result.mapType !== CustomMapType.MachineFill ? noOpacity : partialOpacity
            };
        });
        this.displayedColumns = ['generatedDate', 'vehicle', 'machine', 'mapType', 'action'];
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} requestList
         * @return {?}
         */
        function (requestList) {
            if (_this.groundId == null || _this.organizationId == null) {
                return of({ items: [], totalCount: 0 });
            }
            return _this.groundCustomMapSharedService.getAllByGroundId(_this.organizationId, _this.groundId)
                .pipe(map((/**
             * @param {?} data
             * @return {?}
             */
            function (data) { return ({ items: data || [], totalCount: (data || []).length }); })));
        }));
        this.polygons = [];
        combineLatest([this.pureMapService.mapReady, this.groundLocationsSubject])
            .pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), _ = _b[0], groundLocations = _b[1];
            return groundLocations;
        })), takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @param {?} groundLocations
         * @return {?}
         */
        function (groundLocations) {
            /** @type {?} */
            var bounds = new google.maps.LatLngBounds();
            groundLocations.forEach((/**
             * @param {?} location
             * @return {?}
             */
            function (location) {
                if ('coordinates' in location.geometry) {
                    /** @type {?} */
                    var coords = (/** @type {?} */ (location.geometry.coordinates[0]));
                    coords.forEach((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return bounds.extend(new google.maps.LatLng({ lat: x[1], lng: x[0] })); }));
                    _this.polygons.push({
                        poly: _this.pureMapService.createPolygon({
                            paths: coords.map((/**
                             * @param {?} x
                             * @return {?}
                             */
                            function (x) { return new google.maps.LatLng({ lat: x[1], lng: x[0] }); })),
                            strokeColor: '#ffffff',
                            fillOpacity: 0
                        }),
                        type: 'contour'
                    });
                }
            }));
            _this.pureMapService.fitBounds(bounds);
        }));
    }
    /**
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var _this = this;
        /** @type {?} */
        var organizationIdChanged = false;
        /** @type {?} */
        var groundIdChanged = false;
        if (changes && changes.organizationId && changes.organizationId.currentValue !== changes.organizationId.previousValue) {
            organizationIdChanged = true;
        }
        if (changes && changes.groundId && changes.groundId.currentValue !== changes.groundId.previousValue) {
            groundIdChanged = true;
        }
        if (organizationIdChanged || groundIdChanged) {
            this.dataSource.forceRefresh();
            this.getGroundLocations(this.organizationId, this.groundId)
                .subscribe((/**
             * @param {?} groundLocations
             * @return {?}
             */
            function (groundLocations) { _this.groundLocationsSubject.next(groundLocations); }));
        }
    };
    /**
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.showOnMapClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        this.scale = null;
        this.polygons.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.type === 'custom'; })).forEach((/**
         * @param {?} elem
         * @return {?}
         */
        function (elem) { return elem.poly.setMap(null); }));
        this.polygons = this.polygons.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.type === 'contour'; }));
        this.displaySpinner$.next(true);
        this.groundCustomMapSharedService
            .get(this.organizationId, item.id)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            /** @type {?} */
            var bounds = new google.maps.LatLngBounds();
            /** @type {?} */
            var minVal = Infinity;
            /** @type {?} */
            var maxVal = 0;
            result.geometry.features.forEach((/**
             * @param {?} feature
             * @return {?}
             */
            function (feature) {
                minVal = (minVal > feature.properties.value) ? feature.properties.value : minVal;
                maxVal = (maxVal < feature.properties.value) ? feature.properties.value : maxVal;
            }));
            if (result.mapType !== CustomMapType.MachineFill) {
                _this.scale = _this.prepareScale(_this.roundValue(minVal, 1), _this.roundValue(maxVal, 1));
            }
            result.geometry.features.forEach((/**
             * @param {?} feature
             * @return {?}
             */
            function (feature) {
                if ('coordinates' in feature.geometry) {
                    /** @type {?} */
                    var coords = (/** @type {?} */ (feature.geometry.coordinates[0]));
                    coords.forEach((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return bounds.extend(new google.maps.LatLng({ lat: x[1], lng: x[0] })); }));
                    _this.polygons.push({
                        poly: _this.pureMapService.createPolygon(_this.createPolygonProperties(result, coords, feature, minVal, maxVal)),
                        type: 'custom'
                    });
                }
            }));
            _this.pureMapService.fitBounds(bounds);
        }));
    };
    /**
     * @private
     * @param {?} organizationId
     * @param {?} groundId
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.getGroundLocations = /**
     * @private
     * @param {?} organizationId
     * @param {?} groundId
     * @return {?}
     */
    function (organizationId, groundId) {
        return this.groundSharedService.get(organizationId, groundId).pipe(map((/**
         * @param {?} ground
         * @return {?}
         */
        function (ground) { return ground != null ? (ground.locations || []) : []; })));
    };
    /**
     * @private
     * @param {?} value
     * @param {?} minVal
     * @param {?} maxVal
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.calculateFillColor = /**
     * @private
     * @param {?} value
     * @param {?} minVal
     * @param {?} maxVal
     * @return {?}
     */
    function (value, minVal, maxVal) {
        /** @type {?} */
        var mult = this.colors.length / (maxVal - minVal);
        return this.colors[parseInt(((maxVal - value) * mult).toString(), 10)];
    };
    /**
     * @private
     * @param {?} minVal
     * @param {?} maxVal
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.prepareScale = /**
     * @private
     * @param {?} minVal
     * @param {?} maxVal
     * @return {?}
     */
    function (minVal, maxVal) {
        /** @type {?} */
        var step = (maxVal - minVal) / this.colors.length;
        /** @type {?} */
        var scale = [];
        for (var i = 0; i < this.colors.length; i++) {
            scale.push({ limit: (minVal + (step * i)), color: this.colors[this.colors.length - 1 - i] });
        }
        return scale;
    };
    /**
     * @private
     * @param {?} value
     * @param {?} scale
     * @return {?}
     */
    GroundCustomMapsComponent.prototype.roundValue = /**
     * @private
     * @param {?} value
     * @param {?} scale
     * @return {?}
     */
    function (value, scale) {
        /** @type {?} */
        var mainPowValue = 10;
        return Math.round(((value + Number.EPSILON) * Math.pow(mainPowValue, scale)) / Math.pow(mainPowValue, scale));
    };
    GroundCustomMapsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-custom-maps',
                    template: "<div class=\"ground-list mb-2\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\" [appSpinner]=\"displaySpinner$ | async\">\r\n            <div class=\"card-body pt-0\">\r\n                <div class=\"container-fluid px-0\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12\">\r\n                            <app-pure-map [height]=\"420\"></app-pure-map>\r\n                            <div class=\"scale\" *ngIf=\"this.scale\">\r\n                                <div class=\"element\" *ngFor=\"let color of scale\" [style.backgroundColor]=\"color.color\">\r\n                                    <div>{{ color.limit }}</div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\">\r\n                    <i class=\"ft ft-list\"></i> {{ schema.headerKey | translate }}\r\n                </h5>\r\n            </label>\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"name\" cdkSortDirection=\"desc\">\r\n\r\n                        <ng-container cdkColumnDef=\"generatedDate\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header\r\n                                class=\"order-2 order-md-1 col-9 col-md-6 col-lg-3 pr-0\">\r\n                                {{ schema.generatedDateKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"order-2 order-md-1 col-9 col-md-6 col-lg-3 pr-0\">\r\n                                {{ element.generatedDate * 1000 | date:\"dd.MM.yyyy\" }}\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"vehicle\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header\r\n                                class=\"order-3 order-md-2 col-md-3 d-none d-md-block pr-0\">\r\n                                {{ schema.vehicleNameKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"order-3 order-md-2 col-md-3 d-none d-md-block pr-0\">{{ element.vehicleName }}\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"machine\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header\r\n                                class=\"order-4 order-md-3 col-6 col-md-1 col-lg-2 d-none d-lg-block pr-0\">\r\n                                {{ schema.machineNameKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"order-4 order-md-3 col-6 col-md-1  col-lg-2 d-none d-lg-block pr-0\">\r\n                                {{ element.machineName }}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"mapType\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header\r\n                                class=\"order-4 order-md-3 col-6 col-md-1 col-lg-2 d-none d-lg-block pr-0\">\r\n                                {{ schema.mapTypeKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"order-4 order-md-3 col-6 col-md-1  col-lg-2 d-none d-lg-block pr-0\">\r\n                                {{ 'APPLICATION.DICTIONARIES.CustomMapTypes.' + element.mapType | translate}}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef\r\n                                class=\"order-1 order-md-4 col-3 col-md-3 col-lg-2 text-md-right\">\r\n                                {{ schema.actionKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"order-1 order-md-4 col-3 col-md-3 col-lg-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-md-end\">\r\n                                    <button (click)=\"showOnMapClick(element)\"\r\n                                        title=\"{{ schema.showOnMapButtonKey | translate }}\"\r\n                                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\"\r\n                            *cdkHeaderRowDef=\"displayedColumns\"></cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\"\r\n                            *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listEmptyKey | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listErrorKey | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                        [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons></cdk-paginator>\r\n                </div>\r\n\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".scale{position:absolute;bottom:0;left:0;padding:10px;background:#fff;border-top-right-radius:5px}.scale .element{display:inline-block;width:40px;height:15px;position:relative}.scale .element div{font-size:12px;position:absolute;bottom:-20px;right:-2px}"]
                }] }
    ];
    /** @nocollapse */
    GroundCustomMapsComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_SHARED_SERVICE,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_CUSTOM_MAP_SHARED_SERVICE,] }] },
        { type: PureMapService }
    ]; };
    GroundCustomMapsComponent.propDecorators = {
        organizationId: [{ type: Input }],
        groundId: [{ type: Input }],
        schema: [{ type: Input }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return GroundCustomMapsComponent;
}());
if (false) {
    /** @type {?} */
    GroundCustomMapsComponent.prototype.organizationId;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.groundId;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.schema;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.sort;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.paginator;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.dataSource;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.displayedColumns;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.groundLocationsSubject;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.unsubscribe$;
    /** @type {?} */
    GroundCustomMapsComponent.prototype.scale;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.colors;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.polygons;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.createPolygonProperties;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.groundSharedService;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.groundCustomMapSharedService;
    /**
     * @type {?}
     * @private
     */
    GroundCustomMapsComponent.prototype.pureMapService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_ADD_FORM_LAYOUT = {
    groundMapGroup: DEFAULT_FORM_LAYOUT_GROUP,
    groundBaseInfoGroup: DEFAULT_FORM_LAYOUT_GROUP,
    groundLocationGroup: DEFAULT_FORM_LAYOUT_GROUP,
    groundPropertiesGroup: DEFAULT_FORM_LAYOUT_GROUP,
    name: DEFAULT_FORM_LAYOUT_INPUT,
    areaInHa: DEFAULT_FORM_LAYOUT_INPUT,
    lease: DEFAULT_FORM_LAYOUT_INPUT,
    groundCategory: DEFAULT_FORM_LAYOUT_INPUT,
    complexOfAgriculturalSuitability: DEFAULT_FORM_LAYOUT_INPUT,
    agronomicCategory: DEFAULT_FORM_LAYOUT_INPUT,
    features: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    cadastralRegister: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
};
/** @type {?} */
var DRAWING_MAP_FORM_MODEL = new DynamicFormGroupModel({
    id: 'groundMapGroup',
    group: [
        new DynamicCadastralRegisterMapFormControlModel({
            id: 'features',
            mapConfig: new MapConfig(),
            polygonConfig: new PolygonConfig()
        })
    ]
});
/** @type {?} */
var BASE_INFO_FORM_MODEL$1 = new DynamicFormGroupModel({
    id: 'groundBaseInfoGroup',
    group: [
        new DynamicInputModel({
            id: 'name',
            minLength: 3,
            maxLength: 60,
            validators: {
                required: null,
                minLength: 3,
                maxLength: 60
            }
        }),
        new DynamicInputModel({
            id: 'areaInHa',
            min: 0.01,
            max: 1000,
            step: 0.01,
            inputType: 'number',
            validators: {
                required: null,
                min: 0.01,
                max: 1000,
                decimalNumberValidator: 2
            }
        }),
        new DynamicCheckboxModel({
            id: 'lease',
        })
    ]
});
/** @type {?} */
var LOCATION_FORM_MODEL$1 = new DynamicFormGroupModel({
    id: 'groundLocationGroup',
    group: [
        new DynamicCadastralRegisterFormControlModel({
            id: 'cadastralRegister',
            translateKey: 'GROUND',
            cadastreAsSelectInput: false,
            validators: {
                cadastralGroundRegisterValidator: {}
            }
        })
    ]
});
/** @type {?} */
var GROUND_PROPERTIES_FORM_MODEL$1 = new DynamicFormGroupModel({
    id: 'groundPropertiesGroup',
    group: [
        new DynamicSelectModel({
            id: 'groundCategory',
            options: [
                { value: GroundCategory.I, label: 'I' },
                { value: GroundCategory.II, label: 'II' },
                { value: GroundCategory.IIIa, label: 'IIIa' },
                { value: GroundCategory.IIIb, label: 'IIIb' },
                { value: GroundCategory.IVa, label: 'IVa' },
                { value: GroundCategory.IVb, label: 'IVb' },
                { value: GroundCategory.V, label: 'V' },
                { value: GroundCategory.VI, label: 'VI' }
            ]
        }),
        new DynamicSelectModel({
            id: 'complexOfAgriculturalSuitability',
            options: getOptionsForDynamicSelectModel(ComplexOfAgriculturalSuitability, 'COMPLEX_OF_AGRICULTURAL_SUITABILITIES', true)
        }),
        new DynamicSelectModel({
            id: 'agronomicCategory',
            options: getOptionsForDynamicSelectModel(AgronomicCategory, 'AGRONOMIC_CATEGORIES', true)
        })
    ]
});
/** @type {?} */
var GROUND_ADD_FORM_MODEL = [
    DRAWING_MAP_FORM_MODEL, BASE_INFO_FORM_MODEL$1, LOCATION_FORM_MODEL$1, GROUND_PROPERTIES_FORM_MODEL$1
];
/**
 * @return {?}
 */
function mapToGroundAdForm() {
    return {
        groundMapGroup: {
            features: new CadastralRegisterMapValue(null, [])
        },
        groundBaseInfoGroup: {
            name: null,
            areaInHa: 0,
            lease: false,
        },
        groundLocationGroup: {
            cadastralRegister: new CadastralRegister(null, null, null, null, null)
        },
        groundPropertiesGroup: {
            groundCategory: null,
            complexOfAgriculturalSuitability: null,
            agronomicCategory: null
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromGroundAddForm(data) {
    return new CreateGroundCommand(data.groundBaseInfoGroup.name, data.groundBaseInfoGroup.areaInHa, data.groundBaseInfoGroup.lease, new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralState.id, data.groundLocationGroup.cadastralRegister.cadastralState.name), new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralCounty.id, data.groundLocationGroup.cadastralRegister.cadastralCounty.name), new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralCommune.id, data.groundLocationGroup.cadastralRegister.cadastralCommune.name), new GroundGeoData(data.groundLocationGroup.cadastralRegister.cadastralArea.id, data.groundLocationGroup.cadastralRegister.cadastralArea.name), data.groundLocationGroup.cadastralRegister.cadastreNumber, data.groundPropertiesGroup.groundCategory, data.groundPropertiesGroup.complexOfAgriculturalSuitability, data.groundPropertiesGroup.agronomicCategory, data.groundMapGroup.features.features.map((/**
     * @param {?} x
     * @return {?}
     */
    function (x) {
        x.properties.name = data.groundBaseInfoGroup.name;
        return x;
    })));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundAddComponent = /** @class */ (function () {
    function GroundAddComponent(groundSharedService) {
        this.groundSharedService = groundSharedService;
        this.added = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formModel = GROUND_ADD_FORM_MODEL;
        this.formLayout = GROUND_ADD_FORM_LAYOUT;
    }
    /**
     * @return {?}
     */
    GroundAddComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initValue = mapToGroundAdForm();
    };
    /**
     * @return {?}
     */
    GroundAddComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.addForm.formGroup.get('groundMapGroup').get('features').valueChanges
            .pipe(filter((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            return value && (!!value.cadastralRegister || !!value.features && value.features.length > 0);
        })))
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value.cadastralRegister) {
                _this.addForm.formGroup.get('groundLocationGroup').get('cadastralRegister').patchValue(value.cadastralRegister);
            }
            if (value.features && value.features.length > 0) {
                /** @type {?} */
                var area = value.features[0].properties.area;
                /** @type {?} */
                var areaInHaInputModel = _this.addForm.formGroup.get('groundBaseInfoGroup').get('areaInHa');
                areaInHaInputModel.patchValue(area);
                areaInHaInputModel.updateValueAndValidity();
            }
        }));
        this.addForm.formGroup.get('groundLocationGroup').get('cadastralRegister').valueChanges
            .subscribe((/**
         * @param {?} cadastralRegister
         * @return {?}
         */
        function (cadastralRegister) {
            if (cadastralRegister != null
                && cadastralRegister.cadastralArea != null
                && cadastralRegister.cadastralArea.name
                && cadastralRegister.cadastreNumber) {
                /** @type {?} */
                var groundNameInputModel = _this.addForm.formGroup.get('groundBaseInfoGroup').get('name');
                if (!groundNameInputModel.value) {
                    /** @type {?} */
                    var groundName = cadastralRegister.cadastralArea.name + " - " + cadastralRegister.cadastreNumber;
                    groundNameInputModel.patchValue(groundName);
                    groundNameInputModel.updateValueAndValidity();
                }
            }
        }));
    };
    /**
     * @return {?}
     */
    GroundAddComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.createSubscription != null) {
            this.createSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundAddComponent.prototype.onAdd = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        this.displaySpinner$.next(true);
        if (this.createSubscription != null) {
            this.createSubscription.unsubscribe();
        }
        /** @type {?} */
        var command = mapFromGroundAddForm($event);
        this.createSubscription = this.groundSharedService.create(this.organizationId, command)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            if (id != null) {
                _this.added.emit(true);
            }
        }));
    };
    /**
     * @return {?}
     */
    GroundAddComponent.prototype.onAfterCancel = /**
     * @return {?}
     */
    function () {
        this.added.emit(false);
    };
    GroundAddComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-add',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <app-add-form *ngIf=\"formModel\"\r\n        #addForm\r\n        [formModel]=\"formModel\"\r\n        [formLayout]=\"formLayout\"\r\n        [model]=\"initValue\"\r\n        [translateKey]=\"translationKeyPrefix\"\r\n        (add)=\"onAdd($event)\"\r\n        (afterCancel)=\"onAfterCancel()\">\r\n    </app-add-form>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    GroundAddComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_SHARED_SERVICE,] }] }
    ]; };
    GroundAddComponent.propDecorators = {
        organizationId: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }],
        added: [{ type: Output }],
        addForm: [{ type: ViewChild, args: ['addForm', { static: false },] }]
    };
    return GroundAddComponent;
}());
if (false) {
    /** @type {?} */
    GroundAddComponent.prototype.organizationId;
    /** @type {?} */
    GroundAddComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    GroundAddComponent.prototype.added;
    /** @type {?} */
    GroundAddComponent.prototype.addForm;
    /** @type {?} */
    GroundAddComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundAddComponent.prototype.initValue;
    /** @type {?} */
    GroundAddComponent.prototype.formLayout;
    /** @type {?} */
    GroundAddComponent.prototype.formModel;
    /**
     * @type {?}
     * @private
     */
    GroundAddComponent.prototype.createSubscription;
    /**
     * @type {?}
     * @private
     */
    GroundAddComponent.prototype.groundSharedService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var GroundSoilSpecimensLayer = {
    Countur: 'Countur',
    Net: 'Net',
    Agronomic: 'Agronomic',
    Ph: 'Ph',
    Phosphorus: 'Phosphorus',
    Potassium: 'Potassium',
    Magnesium: 'Magnesium',
    Manganese: 'Manganese',
    Zinc: 'Zinc',
    Copper: 'Copper',
    Iron: 'Iron',
    Boron: 'Boron',
    Calcium: 'Calcium',
    OrganicCarbon: 'OrganicCarbon',
    Humus: 'Humus' // humus
    ,
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var GroundScansLayer = {
    Countur: 'Countur',
    Scan: 'Scan',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundSpecimenColorService = /** @class */ (function () {
    function GroundSpecimenColorService() {
        this.scanColorRules = {
            scan: [
                {
                    data: [
                        // tslint:disable-next-line: max-line-length
                        { name: GroundSpecimenColorService.POTENTIALLY_LIGHTER, from: 0, to: 25, percentageValue: 0 /*color: this.percentage2color(0)*/ },
                        { name: '', from: 0, to: 25, percentageValue: 20 /*color: this.percentage2color(20)*/ },
                        { name: '', from: 0, to: 25, percentageValue: 40 /*color: this.percentage2color(40)*/ },
                        { name: '', from: 0, to: 25, percentageValue: 60 /*color: this.percentage2color(60)*/ },
                        { name: '', from: 0, to: 25, percentageValue: 80 /*color: this.percentage2color(80)*/ },
                        // tslint:disable-next-line: max-line-length
                        { name: GroundSpecimenColorService.POTENTIALLY_HEAVIER, from: 0, to: 25, percentageValue: 100 /*color: this.percentage2color(100)*/ }
                    ]
                }
            ]
        };
        this.soilSpecimenColorRules = {
            mg: [
                {
                    agronomic: 0,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 1, color: '#f9a2f8' },
                        { name: GroundSpecimenColorService.LOW, from: 1, to: 2, color: '#e855e6' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 2, to: 4, color: '#e85579' },
                        { name: GroundSpecimenColorService.HIGH, from: 4, to: 6, color: '#c42929' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 6, to: 100, color: '#5e0202' }
                    ]
                },
                {
                    agronomic: 1,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 2, color: '#f9a2f8' },
                        { name: GroundSpecimenColorService.LOW, from: 2, to: 3, color: '#e855e6' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 3, to: 5, color: '#e85579' },
                        { name: GroundSpecimenColorService.HIGH, from: 5, to: 7, color: '#c42929' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 7, to: 100, color: '#5e0202' }
                    ]
                },
                {
                    agronomic: 2,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 3, color: '#f9a2f8' },
                        { name: GroundSpecimenColorService.LOW, from: 3, to: 5, color: '#e855e6' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 5, to: 7, color: '#e85579' },
                        { name: GroundSpecimenColorService.HIGH, from: 7, to: 9, color: '#c42929' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 9, to: 100, color: '#5e0202' }
                    ]
                },
                {
                    agronomic: 3,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 4, color: '#f9a2f8' },
                        { name: GroundSpecimenColorService.LOW, from: 4, to: 6, color: '#e855e6' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 6, to: 10, color: '#e85579' },
                        { name: GroundSpecimenColorService.HIGH, from: 10, to: 14, color: '#c42929' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 14, to: 100, color: '#5e0202' }
                    ]
                }
            ],
            k2o: [
                {
                    agronomic: 0,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 2.5, color: '#99b0ff' },
                        { name: GroundSpecimenColorService.LOW, from: 2.5, to: 7.5, color: '#6b8bf9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 7.5, to: 12.5, color: '#4972ff' },
                        { name: GroundSpecimenColorService.HIGH, from: 12.5, to: 17.5, color: '#2c5bf9' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 17.5, to: 100, color: '#0327a3' }
                    ]
                },
                {
                    agronomic: 1,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 5, color: '#99b0ff' },
                        { name: GroundSpecimenColorService.LOW, from: 5, to: 10, color: '#6b8bf9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 10, to: 15, color: '#4972ff' },
                        { name: GroundSpecimenColorService.HIGH, from: 15, to: 20, color: '#2c5bf9' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 20, to: 100, color: '#0327a3' }
                    ]
                },
                {
                    agronomic: 2,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 7.5, color: '#99b0ff' },
                        { name: GroundSpecimenColorService.LOW, from: 7.5, to: 12.5, color: '#6b8bf9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 12.5, to: 20, color: '#4972ff' },
                        { name: GroundSpecimenColorService.HIGH, from: 20, to: 25, color: '#2c5bf9' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 25, to: 100, color: '#0327a3' }
                    ]
                },
                {
                    agronomic: 3,
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 10, color: '#99b0ff' },
                        { name: GroundSpecimenColorService.LOW, from: 10, to: 15, color: '#6b8bf9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 15, to: 25, color: '#4972ff' },
                        { name: GroundSpecimenColorService.HIGH, from: 25, to: 30, color: '#2c5bf9' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 30, to: 100, color: '#0327a3' }
                    ]
                }
            ],
            p2o5: [
                {
                    data: [
                        { name: GroundSpecimenColorService.VERY_LOW, from: 0, to: 5, color: '#e0fcd9' },
                        { name: GroundSpecimenColorService.LOW, from: 5, to: 10, color: '#c2f296' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 10, to: 15, color: '#78db57' },
                        { name: GroundSpecimenColorService.HIGH, from: 15, to: 20, color: '#359615' },
                        { name: GroundSpecimenColorService.VERY_HIGH, from: 20, to: 100, color: '#124203' }
                    ]
                }
            ],
            ph: [
                {
                    data: [
                        { name: GroundSpecimenColorService.VERY_STRONGLY_ACIDIC, from: 0, to: 3, color: '#fff4ad' },
                        { name: GroundSpecimenColorService.STRONGLY_ACIDIC, from: 3, to: 4, color: '#e8ce78' },
                        { name: GroundSpecimenColorService.MODERATELY_ACIDIC, from: 4, to: 5, color: '#c4a748' },
                        { name: GroundSpecimenColorService.SLIGHTLY_ACIDIC, from: 5, to: 6, color: '#a0811c' },
                        { name: GroundSpecimenColorService.SLIGHTLY_ALKALINE, from: 6, to: 7, color: '#a0531c' },
                        { name: GroundSpecimenColorService.MODERATELY_ALKALINE, from: 7, to: 8, color: '#a03a1c' },
                        { name: GroundSpecimenColorService.STRONGLY_ALKALINE, from: 8, to: 10, color: '#a01c1c' }
                    ]
                }
            ],
            agronomic: [
                {
                    data: [
                        { name: GroundSpecimenColorService.VERY_LIGHT, from: 0, to: 1, color: '#e8ce78' },
                        { name: GroundSpecimenColorService.LIGHT, from: 1, to: 2, color: '#a0811c' },
                        { name: GroundSpecimenColorService.AVERAGE, from: 2, to: 3, color: '#a0531c' },
                        { name: GroundSpecimenColorService.HEAVY, from: 3, to: 4, color: '#a03a1c' }
                    ]
                }
            ],
            b: [
                {
                    phFrom: 0,
                    phTo: 4.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 0.8, color: '#fff4ad' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 0.8, to: 2.6, color: '#e8ce78' },
                        { name: GroundSpecimenColorService.HIGH, from: 2.6, to: 10000, color: '#c4a748' }
                    ]
                },
                {
                    phFrom: 4.5,
                    phTo: 5.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 1, color: '#fff4ad' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 1, to: 3.2, color: '#e8ce78' },
                        { name: GroundSpecimenColorService.HIGH, from: 3.2, to: 10000, color: '#c4a748' }
                    ]
                },
                {
                    phFrom: 5.5,
                    phTo: 6.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 1.3, color: '#fff4ad' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 1.3, to: 4.3, color: '#e8ce78' },
                        { name: GroundSpecimenColorService.HIGH, from: 4.3, to: 10000, color: '#c4a748' }
                    ]
                },
                {
                    phFrom: 6.5,
                    phTo: 100,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 2.2, color: '#fff4ad' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 2.2, to: 7.2, color: '#e8ce78' },
                        { name: GroundSpecimenColorService.HIGH, from: 7.2, to: 10000, color: '#c4a748' }
                    ]
                }
            ],
            zn: [
                {
                    agronomic: 0,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 0.7, color: '#ffd2d1' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 0.7, to: 3.3, color: '#e56b68' },
                        { name: GroundSpecimenColorService.HIGH, from: 3.3, to: 100000, color: '#cc0400' }
                    ]
                }, {
                    agronomic: 1,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 1.4, color: '#ffd2d1' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 1.4, to: 6.3, color: '#e56b68' },
                        { name: GroundSpecimenColorService.HIGH, from: 6.3, to: 100000, color: '#cc0400' }
                    ]
                }, {
                    agronomic: 2,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 4.6, color: '#ffd2d1' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 4.6, to: 20.5, color: '#e56b68' },
                        { name: GroundSpecimenColorService.HIGH, from: 20.5, to: 100000, color: '#cc0400' }
                    ]
                }, {
                    agronomic: 3,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 11.5, color: '#ffd2d1' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 11.5, to: 51.1, color: '#e56b68' },
                        { name: GroundSpecimenColorService.HIGH, from: 51.1, to: 100000, color: '#cc0400' }
                    ]
                }
            ],
            cu: [
                {
                    agronomic: 0,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 0.9, color: '#ffd3b8' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 0.9, to: 2.5, color: '#ffb55e' },
                        { name: GroundSpecimenColorService.HIGH, from: 2.5, to: 100000, color: '#ff9705' }
                    ]
                },
                {
                    agronomic: 1,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 1.6, color: '#ffd3b8' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 1.6, to: 4.9, color: '#ffb55e' },
                        { name: GroundSpecimenColorService.HIGH, from: 4.9, to: 100000, color: '#ff9705' }
                    ]
                },
                {
                    agronomic: 2,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 2.3, color: '#ffd3b8' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 2.3, to: 6.7, color: '#ffb55e' },
                        { name: GroundSpecimenColorService.HIGH, from: 6.7, to: 100000, color: '#ff9705' }
                    ]
                },
                {
                    agronomic: 3,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 5, color: '#ffd3b8' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 5, to: 15, color: '#ffb55e' },
                        { name: GroundSpecimenColorService.HIGH, from: 15, to: 100000, color: '#ff9705' }
                    ]
                }
            ],
            fe: [
                {
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 700, color: '#d2bdbc' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 700, to: 3800, color: '#8f7d7d' },
                        { name: GroundSpecimenColorService.HIGH, from: 380, to: 1000000000, color: '#4c3e3e' }
                    ]
                }
            ],
            c: [
                {
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 700, color: '#d2bdbc' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 700, to: 3800, color: '#8f7d7d' },
                        { name: GroundSpecimenColorService.HIGH, from: 380, to: 1000000000, color: '#4c3e3e' }
                    ]
                }
            ],
            ca: [
                {
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 1000, color: '#d2bdbc' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 1000, to: 2000, color: '#8f7d7d' },
                        { name: GroundSpecimenColorService.HIGH, from: 2000, to: 1000000000, color: '#4c3e3e' }
                    ]
                }
            ],
            humus: [
                {
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 2, color: '#d3d3d3' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 2, to: 3, color: '#585858' },
                        { name: GroundSpecimenColorService.HIGH, from: 3, to: 1000000000, color: '#222222' }
                    ]
                }
            ],
            mn: [
                {
                    agronomic: 0,
                    phFrom: 0,
                    phTo: 4.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 9, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 9, to: 90, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 90, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 1,
                    phFrom: 0,
                    phTo: 4.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 13, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 13, to: 130, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 130, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 2,
                    phFrom: 0,
                    phTo: 4.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 16, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 16, to: 160, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 160, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 3,
                    phFrom: 0,
                    phTo: 4.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 18, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 18, to: 180, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 180, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 0,
                    phFrom: 4.5,
                    phTo: 5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 12, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 12, to: 125, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 125, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 1,
                    phFrom: 4.5,
                    phTo: 5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 21, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 21, to: 210, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 210, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 2,
                    phFrom: 4.5,
                    phTo: 5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 28, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 28, to: 280, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 280, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 3,
                    phFrom: 4.5,
                    phTo: 5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 40, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 40, to: 390, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 390, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 0,
                    phFrom: 5,
                    phTo: 5.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 15, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 15, to: 150, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 150, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 1,
                    phFrom: 5,
                    phTo: 5.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 30, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 30, to: 310, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 310, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 2,
                    phFrom: 5,
                    phTo: 5.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 50, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 50, to: 510, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 510, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 3,
                    phFrom: 5,
                    phTo: 5.5,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 75, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 75, to: 750, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 750, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 0,
                    phFrom: 5.5,
                    phTo: 100,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 17, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 17, to: 170, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 170, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 1,
                    phFrom: 5.5,
                    phTo: 100,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 40, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 40, to: 400, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 400, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 2,
                    phFrom: 5.5,
                    phTo: 100,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 85, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 85, to: 830, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 830, to: 1000000, color: '#37264b' }
                    ]
                },
                {
                    agronomic: 3,
                    phFrom: 5.5,
                    phTo: 100,
                    data: [
                        { name: GroundSpecimenColorService.LOW, from: 0, to: 110, color: '#a98dc9' },
                        { name: GroundSpecimenColorService.MEDIUM, from: 110, to: 1100, color: '#70598a' },
                        { name: GroundSpecimenColorService.HIGH, from: 1100, to: 1000000, color: '#37264b' }
                    ]
                }
            ]
        };
        // tslint:disable-next-line: max-line-length
        this.percentage2colorRange = ['#ffffe0', '#fffddb', '#fffad7', '#fff7d1', '#fff5cd', '#fff2c8', '#fff0c4', '#ffedbf', '#ffebba', '#ffe9b7', '#ffe5b2', '#ffe3af', '#ffe0ab', '#ffdda7', '#ffdba4', '#ffd9a0', '#ffd69c', '#ffd399', '#ffd196', '#ffcd93', '#ffca90', '#ffc88d', '#ffc58a', '#ffc288', '#ffbf86', '#ffbd83', '#ffb981', '#ffb67f', '#ffb47d', '#ffb17b', '#ffad79', '#ffaa77', '#ffa775', '#ffa474', '#ffa172', '#ff9e70', '#ff9b6f', '#ff986e', '#ff956c', '#fe916b', '#fe8f6a', '#fd8b69', '#fc8868', '#fb8567', '#fa8266', '#f98065', '#f87d64', '#f77a63', '#f67862', '#f57562', '#f37261', '#f37060', '#f16c5f', '#f0695e', '#ee665d', '#ed645c', '#ec615b', '#ea5e5b', '#e85b59', '#e75859', '#e55658', '#e45356', '#e35056', '#e14d54', '#df4a53', '#dd4852', '#db4551', '#d9434f', '#d8404e', '#d53d4d', '#d43b4b', '#d2384a', '#cf3548', '#cd3346', '#cc3045', '#ca2e43', '#c72b42', '#c52940', '#c2263d', '#c0233c', '#be213a', '#bb1e37', '#ba1c35', '#b71933', '#b41731', '#b2152e', '#b0122c', '#ac1029', '#aa0e27', '#a70b24', '#a40921', '#a2071f', '#a0051c', '#9d0419', '#990215', '#970212', '#94010e', '#91000a', '#8e0006', '#8b0000'];
    }
    /**
     * @private
     * @param {?} percentage
     * @return {?}
     */
    GroundSpecimenColorService.prototype.percentage2color = /**
     * @private
     * @param {?} percentage
     * @return {?}
     */
    function (percentage) {
        /** @type {?} */
        var value = Math.round(percentage);
        if (value >= GroundSpecimenColorService.MAX_PERCENTAGE) {
            // tslint:disable-next-line: no-magic-numbers
            value = 99;
        }
        if (value < GroundSpecimenColorService.MIN_PERCENTAGE) {
            value = GroundSpecimenColorService.MIN_PERCENTAGE;
        }
        // tslint:disable-next-line: radix
        return this.percentage2colorRange[value];
    };
    /**
     * @param {?} layer
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getScanColorLegend = /**
     * @param {?} layer
     * @return {?}
     */
    function (layer) {
        var _this = this;
        switch (layer) {
            case GroundScansLayer.Countur:
                return null;
            case GroundScansLayer.Scan:
                return this.scanColorRules.scan[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: _this.percentage2color(x.percentageValue) }); }));
        }
    };
    /**
     * @param {?} percentage
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getScanColor = /**
     * @param {?} percentage
     * @return {?}
     */
    function (percentage) {
        return this.percentage2color(percentage);
    };
    /**
     * @param {?} layer
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorLegend = /**
     * @param {?} layer
     * @return {?}
     */
    function (layer) {
        switch (layer) {
            case GroundSoilSpecimensLayer.Countur:
                return null;
            case GroundSoilSpecimensLayer.Net:
                return null;
            case GroundSoilSpecimensLayer.Agronomic: // agronomic
                return this.soilSpecimenColorRules.agronomic[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Ph: // ph
                return this.soilSpecimenColorRules.ph[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Phosphorus: // p2o5
                return this.soilSpecimenColorRules.p2o5[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Potassium: // k2o
                return this.soilSpecimenColorRules.k2o[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Magnesium: // mg
                return this.soilSpecimenColorRules.mg[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Manganese: // mn
                return this.soilSpecimenColorRules.mn[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Zinc: // zn
                return this.soilSpecimenColorRules.zn[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Copper: // cu
                return this.soilSpecimenColorRules.cu[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Iron: // fe
                return this.soilSpecimenColorRules.fe[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Boron: // b
                return this.soilSpecimenColorRules.b[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Calcium: // ca
                return this.soilSpecimenColorRules.ca[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.OrganicCarbon: // c
                return this.soilSpecimenColorRules.c[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
            case GroundSoilSpecimensLayer.Humus: // humus
                return this.soilSpecimenColorRules.humus[0].data.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) { return ({ label: x.name, color: x.color }); }));
        }
    };
    /**
     * @param {?} layer
     * @param {?} item
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColor = /**
     * @param {?} layer
     * @param {?} item
     * @return {?}
     */
    function (layer, item) {
        switch (layer) {
            case GroundSoilSpecimensLayer.Countur:
                return '#17202A';
            case GroundSoilSpecimensLayer.Net:
                return '#D35400';
            case GroundSoilSpecimensLayer.Agronomic: // agronomic
                return this.getSoilSpecimenColorAgronomic(item.agronomic);
            case GroundSoilSpecimensLayer.Ph: // ph
                return this.getSoilSpecimenColorPh(item.ph);
            case GroundSoilSpecimensLayer.Phosphorus: // p2o5
                return this.getSoilSpecimenColorPhosphorus(item.p2o5);
            case GroundSoilSpecimensLayer.Potassium: // k2o
                return this.getSoilSpecimenColorPotassium(item.k2o, item.agronomic);
            case GroundSoilSpecimensLayer.Magnesium: // mg
                return this.getSoilSpecimenColorMangesium(item.mg, item.agronomic);
            case GroundSoilSpecimensLayer.Manganese: // mn
                return this.getSoilSpecimenManganese(item.mn, item.agronomic, item.ph);
            case GroundSoilSpecimensLayer.Zinc: // zn
                return this.getSoilSpecimenZinc(item.zn, item.agronomic);
            case GroundSoilSpecimensLayer.Copper: // cu
                return this.getSoilSpecimenCopper(item.cu, item.agronomic);
            case GroundSoilSpecimensLayer.Iron: // fe
                return this.getSoilSpecimenIron(item.fe);
            case GroundSoilSpecimensLayer.Boron: // b
                return this.getSoilSpecimenBoron(item.b, item.ph);
            case GroundSoilSpecimensLayer.Calcium: // ca
                return this.getSoilSpecimenColorCalcium(item.ca);
            case GroundSoilSpecimensLayer.OrganicCarbon: // c
                return this.getSoilSpecimenColorOrganicCarbon(item.c);
            case GroundSoilSpecimensLayer.Humus: // humus
                return this.getSoilSpecimenColorHumus(item.humus);
        }
    };
    /**
     * @private
     * @param {?} agronomic
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorAgronomic = /**
     * @private
     * @param {?} agronomic
     * @return {?}
     */
    function (agronomic) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.agronomic[0];
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= agronomic && agronomic < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} ph
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorPh = /**
     * @private
     * @param {?} ph
     * @return {?}
     */
    function (ph) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.ph[0];
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= ph && ph < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} p2o5
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorPhosphorus = /**
     * @private
     * @param {?} p2o5
     * @return {?}
     */
    function (p2o5) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.p2o5[0];
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= p2o5 && p2o5 < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} k2o
     * @param {?} agronomic
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorPotassium = /**
     * @private
     * @param {?} k2o
     * @param {?} agronomic
     * @return {?}
     */
    function (k2o, agronomic) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.k2o.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.agronomic === agronomic; }));
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= k2o && k2o < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} mg
     * @param {?} agronomic
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorMangesium = /**
     * @private
     * @param {?} mg
     * @param {?} agronomic
     * @return {?}
     */
    function (mg, agronomic) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.mg.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.agronomic === agronomic; }));
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= mg && mg < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} mn
     * @param {?} agronomic
     * @param {?} ph
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenManganese = /**
     * @private
     * @param {?} mn
     * @param {?} agronomic
     * @param {?} ph
     * @return {?}
     */
    function (mn, agronomic, ph) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.mn.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.agronomic === agronomic && x.phFrom <= ph && ph < x.phTo; }));
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= mn && mn < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} zn
     * @param {?} agronomic
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenZinc = /**
     * @private
     * @param {?} zn
     * @param {?} agronomic
     * @return {?}
     */
    function (zn, agronomic) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.zn.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.agronomic === agronomic; }));
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= zn && zn < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} cu
     * @param {?} agronomic
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenCopper = /**
     * @private
     * @param {?} cu
     * @param {?} agronomic
     * @return {?}
     */
    function (cu, agronomic) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.cu.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.agronomic === agronomic; }));
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= cu && cu < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} fe
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenIron = /**
     * @private
     * @param {?} fe
     * @return {?}
     */
    function (fe) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.fe[0];
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= fe && fe < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} b
     * @param {?} ph
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenBoron = /**
     * @private
     * @param {?} b
     * @param {?} ph
     * @return {?}
     */
    function (b, ph) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.b.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.phFrom <= ph && ph < x.phTo; }));
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= b && b < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} ca
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorCalcium = /**
     * @private
     * @param {?} ca
     * @return {?}
     */
    function (ca) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.ca[0];
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= ca && ca < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} c
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorOrganicCarbon = /**
     * @private
     * @param {?} c
     * @return {?}
     */
    function (c) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.c[0];
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= c && c < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    /**
     * @private
     * @param {?} humus
     * @return {?}
     */
    GroundSpecimenColorService.prototype.getSoilSpecimenColorHumus = /**
     * @private
     * @param {?} humus
     * @return {?}
     */
    function (humus) {
        /** @type {?} */
        var item = this.soilSpecimenColorRules.humus[0];
        if (item == null) {
            return null;
        }
        /** @type {?} */
        var dataValue = item.data.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.from <= humus && humus < x.to; }));
        if (dataValue == null) {
            return null;
        }
        return dataValue.color;
    };
    GroundSpecimenColorService.MAX_PERCENTAGE = 100;
    GroundSpecimenColorService.MIN_PERCENTAGE = 0;
    GroundSpecimenColorService.VERY_LOW = 'GROUND.soilSpecimensTab.specimenValue.veryLow';
    GroundSpecimenColorService.LOW = 'GROUND.soilSpecimensTab.specimenValue.low';
    GroundSpecimenColorService.MEDIUM = 'GROUND.soilSpecimensTab.specimenValue.medium';
    GroundSpecimenColorService.HIGH = 'GROUND.soilSpecimensTab.specimenValue.high';
    GroundSpecimenColorService.VERY_HIGH = 'GROUND.soilSpecimensTab.specimenValue.veryHigh';
    GroundSpecimenColorService.VERY_STRONGLY_ACIDIC = 'GROUND.soilSpecimensTab.specimenValue.veryStronglyAcidic';
    GroundSpecimenColorService.STRONGLY_ACIDIC = 'GROUND.soilSpecimensTab.specimenValue.stronglyAcidic';
    GroundSpecimenColorService.MODERATELY_ACIDIC = 'GROUND.soilSpecimensTab.specimenValue.moderatelyAcidic';
    GroundSpecimenColorService.SLIGHTLY_ACIDIC = 'GROUND.soilSpecimensTab.specimenValue.slightlyAcidic';
    GroundSpecimenColorService.SLIGHTLY_ALKALINE = 'GROUND.soilSpecimensTab.specimenValue.slightlyAlkaline';
    GroundSpecimenColorService.MODERATELY_ALKALINE = 'GROUND.soilSpecimensTab.specimenValue.moderatelyAlkaline';
    GroundSpecimenColorService.STRONGLY_ALKALINE = 'GROUND.soilSpecimensTab.specimenValue.stronglyAlkaline';
    GroundSpecimenColorService.VERY_LIGHT = 'GROUND.soilSpecimensTab.specimenValue.veryLight';
    GroundSpecimenColorService.LIGHT = 'GROUND.soilSpecimensTab.specimenValue.light';
    GroundSpecimenColorService.AVERAGE = 'GROUND.soilSpecimensTab.specimenValue.average';
    GroundSpecimenColorService.HEAVY = 'GROUND.soilSpecimensTab.specimenValue.heavy';
    GroundSpecimenColorService.POTENTIALLY_LIGHTER = 'GROUND.scansTab.scanValue.potentiallyLighter';
    GroundSpecimenColorService.POTENTIALLY_HEAVIER = 'GROUND.scansTab.scanValue.potentiallyHeavier';
    GroundSpecimenColorService.decorators = [
        { type: Injectable, args: [{
                    providedIn: GroundServicesModule
                },] }
    ];
    /** @nocollapse */ GroundSpecimenColorService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GroundSpecimenColorService_Factory() { return new GroundSpecimenColorService(); }, token: GroundSpecimenColorService, providedIn: GroundServicesModule });
    return GroundSpecimenColorService;
}());
if (false) {
    /** @type {?} */
    GroundSpecimenColorService.MAX_PERCENTAGE;
    /** @type {?} */
    GroundSpecimenColorService.MIN_PERCENTAGE;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.VERY_LOW;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.LOW;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.MEDIUM;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.HIGH;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.VERY_HIGH;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.VERY_STRONGLY_ACIDIC;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.STRONGLY_ACIDIC;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.MODERATELY_ACIDIC;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.SLIGHTLY_ACIDIC;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.SLIGHTLY_ALKALINE;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.MODERATELY_ALKALINE;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.STRONGLY_ALKALINE;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.VERY_LIGHT;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.LIGHT;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.AVERAGE;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.HEAVY;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.POTENTIALLY_LIGHTER;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.POTENTIALLY_HEAVIER;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.prototype.scanColorRules;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.prototype.soilSpecimenColorRules;
    /**
     * @type {?}
     * @private
     */
    GroundSpecimenColorService.prototype.percentage2colorRange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_IMPORT_DATA_SHARED_SERVICE = new InjectionToken('GroundImportDataSharedService');
/**
 * @record
 */
function IGroundImportDataSharedService() { }
if (false) {
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} model
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.importScans = function (organizationId, groundId, model) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} requestList
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.findScanListItems = function (organizationId, groundId, requestList) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} scanId
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.getScan = function (organizationId, groundId, scanId) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} model
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.importSoilSpecimens = function (organizationId, groundId, model) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} requestList
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.findSoilSpecimenListItems = function (organizationId, groundId, requestList) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} soilSpecimenId
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.getSoilSpecimen = function (organizationId, groundId, soilSpecimenId) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} soilSpecimenId
     * @param {?} recommendations
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.updateSoilSpecimenRecommendations = function (organizationId, groundId, soilSpecimenId, recommendations) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} soilSpecimenId
     * @return {?}
     */
    IGroundImportDataSharedService.prototype.publishSoilSpecimen = function (organizationId, groundId, soilSpecimenId) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundScansMapComponent = /** @class */ (function () {
    function GroundScansMapComponent(groundImportDataSharedService, colorService) {
        this.groundImportDataSharedService = groundImportDataSharedService;
        this.colorService = colorService;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.mapConfig = new MapConfig();
        this.markerConfig = new MarkerConfig(false, false);
        this.polygonConfig = new PolygonConfig(null, false, false);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    GroundScansMapComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.scanId && changes.scanId.currentValue != null) {
            this.loadGroundScan(this.organizationId, this.groundId, changes.scanId.currentValue);
        }
        if (changes.layer && changes.layer.currentValue != null) {
            this.refreshMap();
        }
    };
    /**
     * @private
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} scanId
     * @return {?}
     */
    GroundScansMapComponent.prototype.loadGroundScan = /**
     * @private
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} scanId
     * @return {?}
     */
    function (organizationId, groundId, scanId) {
        var _this = this;
        this.displaySpinner$.next(true);
        this.groundImportDataSharedService.getScan(organizationId, groundId, scanId)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            _this.scan = x;
            _this.refreshMap();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    GroundScansMapComponent.prototype.refreshMap = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.scan != null && this.layer != null) {
            switch (this.layer) {
                case GroundScansLayer.Countur:
                    this.features = this.scan.contour;
                    break;
                case GroundScansLayer.Scan:
                    this.features = this.prepareScanFeature(this.scan);
                    break;
            }
            this.colors = this.colorService.getScanColorLegend(this.layer);
        }
    };
    /**
     * @private
     * @param {?} scan
     * @return {?}
     */
    GroundScansMapComponent.prototype.prepareScanFeature = /**
     * @private
     * @param {?} scan
     * @return {?}
     */
    function (scan) {
        var _this = this;
        /** @type {?} */
        var maxValue = max(scan.scans.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.value; })));
        /** @type {?} */
        var minValue = min(scan.scans.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.value; })));
        /** @type {?} */
        var range = maxValue - minValue;
        /** @type {?} */
        var features = scan.scans.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            /** @type {?} */
            var percentage = (item.value - minValue) * GroundSpecimenColorService.MAX_PERCENTAGE / range;
            /** @type {?} */
            var color = _this.colorService.getScanColor(percentage);
            return item.areas.map((/**
             * @param {?} area
             * @return {?}
             */
            function (area) {
                return (/** @type {?} */ ({
                    type: 'Feature',
                    geometry: area,
                    properties: (/** @type {?} */ ({
                        fillColor: color,
                        fillOpacity: 0.8,
                        strokeColor: color,
                        strokeOpacity: 0.8,
                        name: item.value
                    }))
                }));
            }));
        }));
        return this.reduceLocation(features);
    };
    /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    GroundScansMapComponent.prototype.reduceLocation = /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    function (locations) {
        if (locations == null || locations.length === 0) {
            return [];
        }
        else {
            return locations.reduce((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.concat(b); }));
        }
    };
    GroundScansMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-scans-map',
                    template: "<div style=\"height: 620px;\" [appSpinner]=\"displaySpinner$ | async\">\r\n    <app-map [features]=\"features\" [mapConfig]=\"mapConfig\" [markerConfig]=\"markerConfig\"\r\n        [polygonConfig]=\"polygonConfig\">\r\n    </app-map>\r\n    <div class=\"legend\" *ngIf=\"colors != null && colors.length>0\">\r\n        <div *ngFor=\"let color of colors\">\r\n            <span class=\"color\" [ngStyle]=\"{'background-color': color.color}\"></span>\r\n            <span class=\"label\">{{color.label | translate}}</span>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".legend{position:absolute;bottom:0;background:#fff;padding:10px 20px 10px 0}.legend .color{border:1px solid #000;width:15px;height:15px;display:inline-block}.legend .label{position:relative;top:-4px;padding:0 0 0 10px}"]
                }] }
    ];
    /** @nocollapse */
    GroundScansMapComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_IMPORT_DATA_SHARED_SERVICE,] }] },
        { type: GroundSpecimenColorService }
    ]; };
    GroundScansMapComponent.propDecorators = {
        organizationId: [{ type: Input }],
        groundId: [{ type: Input }],
        scanId: [{ type: Input }],
        layer: [{ type: Input }]
    };
    return GroundScansMapComponent;
}());
if (false) {
    /** @type {?} */
    GroundScansMapComponent.prototype.organizationId;
    /** @type {?} */
    GroundScansMapComponent.prototype.groundId;
    /** @type {?} */
    GroundScansMapComponent.prototype.scanId;
    /** @type {?} */
    GroundScansMapComponent.prototype.layer;
    /** @type {?} */
    GroundScansMapComponent.prototype.displaySpinner$;
    /**
     * @type {?}
     * @private
     */
    GroundScansMapComponent.prototype.scan;
    /** @type {?} */
    GroundScansMapComponent.prototype.features;
    /** @type {?} */
    GroundScansMapComponent.prototype.mapConfig;
    /** @type {?} */
    GroundScansMapComponent.prototype.markerConfig;
    /** @type {?} */
    GroundScansMapComponent.prototype.polygonConfig;
    /** @type {?} */
    GroundScansMapComponent.prototype.colors;
    /**
     * @type {?}
     * @private
     */
    GroundScansMapComponent.prototype.groundImportDataSharedService;
    /**
     * @type {?}
     * @private
     */
    GroundScansMapComponent.prototype.colorService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSoilSpecimen = /** @class */ (function () {
    function GroundImportSoilSpecimen(id, measurementDate, contour, specimens, recommendations, isPublished) {
        this.id = id;
        this.measurementDate = measurementDate;
        this.contour = contour;
        this.specimens = specimens;
        this.recommendations = recommendations;
        this.isPublished = isPublished;
    }
    return GroundImportSoilSpecimen;
}());
if (false) {
    /** @type {?} */
    GroundImportSoilSpecimen.prototype.id;
    /** @type {?} */
    GroundImportSoilSpecimen.prototype.measurementDate;
    /** @type {?} */
    GroundImportSoilSpecimen.prototype.contour;
    /** @type {?} */
    GroundImportSoilSpecimen.prototype.specimens;
    /** @type {?} */
    GroundImportSoilSpecimen.prototype.recommendations;
    /** @type {?} */
    GroundImportSoilSpecimen.prototype.isPublished;
}
var GroundImportSoilSpecimenItem = /** @class */ (function () {
    function GroundImportSoilSpecimenItem(agronomic, ph, p2o5, k2o, mg, mn, zn, cu, fe, b, ca, c, humus, samplingPoints, areas) {
        this.agronomic = agronomic;
        this.ph = ph;
        this.p2o5 = p2o5;
        this.k2o = k2o;
        this.mg = mg;
        this.mn = mn;
        this.zn = zn;
        this.cu = cu;
        this.fe = fe;
        this.b = b;
        this.ca = ca;
        this.c = c;
        this.humus = humus;
        this.samplingPoints = samplingPoints;
        this.areas = areas;
    }
    return GroundImportSoilSpecimenItem;
}());
if (false) {
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.agronomic;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.ph;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.p2o5;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.k2o;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.mg;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.mn;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.zn;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.cu;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.fe;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.b;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.ca;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.c;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.humus;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.samplingPoints;
    /** @type {?} */
    GroundImportSoilSpecimenItem.prototype.areas;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundSoilSpecimensMapComponent = /** @class */ (function () {
    function GroundSoilSpecimensMapComponent(colorService) {
        this.colorService = colorService;
        this.mapConfig = new MapConfig();
        this.markerConfig = new MarkerConfig(false, false);
        this.polygonConfig = new PolygonConfig(null, false, false);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    GroundSoilSpecimensMapComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.soilSpecimen && changes.soilSpecimen.currentValue != null) {
            this.refreshMap();
        }
        if (changes.layer && changes.layer.currentValue != null) {
            this.refreshMap();
        }
        if (changes.showPoints && changes.showPoints.currentValue != null) {
            this.refreshMap();
        }
    };
    /**
     * @private
     * @return {?}
     */
    GroundSoilSpecimensMapComponent.prototype.refreshMap = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.soilSpecimen != null && this.layer != null) {
            switch (this.layer) {
                case GroundSoilSpecimensLayer.Countur:
                    this.features = this.soilSpecimen.contour;
                    break;
                case GroundSoilSpecimensLayer.Net:
                default:
                    this.features = this.prepareSoilSpecimentFeature(this.layer, this.soilSpecimen);
                    break;
            }
            this.colors = this.colorService.getSoilSpecimenColorLegend(this.layer);
        }
        if (this.soilSpecimen != null && this.showPoints) {
            this.features = this.features.concat(this.prepareSoilSpecimentMarkers(this.soilSpecimen));
        }
    };
    /**
     * @private
     * @param {?} layer
     * @param {?} specimen
     * @return {?}
     */
    GroundSoilSpecimensMapComponent.prototype.prepareSoilSpecimentFeature = /**
     * @private
     * @param {?} layer
     * @param {?} specimen
     * @return {?}
     */
    function (layer, specimen) {
        var _this = this;
        /** @type {?} */
        var features = specimen.specimens.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            /** @type {?} */
            var color = _this.colorService.getSoilSpecimenColor(layer, item);
            return item.areas.map((/**
             * @param {?} area
             * @return {?}
             */
            function (area) {
                return (/** @type {?} */ ({
                    type: 'Feature',
                    geometry: area,
                    properties: (/** @type {?} */ ({
                        fillColor: color,
                        fillOpacity: 0.7,
                        strokeColor: color,
                        strokeOpacity: 0.7,
                        name: _this.getGroundSpecimentItemValue(_this.layer, item)
                    }))
                }));
            }));
        }));
        return this.reduceLocation(features);
    };
    /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    GroundSoilSpecimensMapComponent.prototype.reduceLocation = /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    function (locations) {
        if (locations == null || locations.length === 0) {
            return [];
        }
        else {
            return locations.reduce((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.concat(b); }));
        }
    };
    /**
     * @private
     * @param {?} layer
     * @param {?} item
     * @return {?}
     */
    GroundSoilSpecimensMapComponent.prototype.getGroundSpecimentItemValue = /**
     * @private
     * @param {?} layer
     * @param {?} item
     * @return {?}
     */
    function (layer, item) {
        switch (layer) {
            case GroundSoilSpecimensLayer.Countur:
                return null;
            case GroundSoilSpecimensLayer.Net:
                return null;
            case GroundSoilSpecimensLayer.Agronomic: // agronomic
                return item.agronomic;
            case GroundSoilSpecimensLayer.Ph: // ph
                return item.ph;
            case GroundSoilSpecimensLayer.Phosphorus: // p2o5
                return item.p2o5;
            case GroundSoilSpecimensLayer.Potassium: // k2o
                return item.k2o;
            case GroundSoilSpecimensLayer.Magnesium: // mg
                return item.mg;
            case GroundSoilSpecimensLayer.Manganese: // mn
                return item.mn;
            case GroundSoilSpecimensLayer.Zinc: // zn
                return item.zn;
            case GroundSoilSpecimensLayer.Copper: // cu
                return item.cu;
            case GroundSoilSpecimensLayer.Iron: // fe
                return item.fe;
            case GroundSoilSpecimensLayer.Boron: // b
                return item.b;
            case GroundSoilSpecimensLayer.Calcium: // ca
                return item.ca;
            case GroundSoilSpecimensLayer.OrganicCarbon: // c
                return item.c;
            case GroundSoilSpecimensLayer.Humus: // humus
                return item.humus;
        }
    };
    /**
     * @private
     * @param {?} specimen
     * @return {?}
     */
    GroundSoilSpecimensMapComponent.prototype.prepareSoilSpecimentMarkers = /**
     * @private
     * @param {?} specimen
     * @return {?}
     */
    function (specimen) {
        /** @type {?} */
        var features = specimen.specimens.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            return item.samplingPoints.map((/**
             * @param {?} point
             * @return {?}
             */
            function (point) {
                return (/** @type {?} */ ({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: point.coordinates
                    },
                    properties: (/** @type {?} */ ({
                        iconUrl: 'assets/markers/marker-specimen.png'
                    }))
                }));
            }));
        }));
        return this.reduceLocation(features);
    };
    GroundSoilSpecimensMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-soil-specimens-map',
                    template: "<div style=\"height: 620px;\">\r\n    <app-map [features]=\"features\" [mapConfig]=\"mapConfig\" [markerConfig]=\"markerConfig\"\r\n        [polygonConfig]=\"polygonConfig\">\r\n    </app-map>\r\n    <div class=\"legend\" *ngIf=\"colors != null && colors.length>0\">\r\n        <div *ngFor=\"let color of colors\">\r\n            <span class=\"color\" [ngStyle]=\"{'background-color': color.color}\"></span>\r\n            <span class=\"label\">{{color.label | translate}}</span>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".legend{position:absolute;bottom:0;background:#fff;padding:10px 20px 10px 0}.legend .color{border:1px solid #000;width:15px;height:15px;display:inline-block}.legend .label{position:relative;top:-4px;padding:0 0 0 10px}"]
                }] }
    ];
    /** @nocollapse */
    GroundSoilSpecimensMapComponent.ctorParameters = function () { return [
        { type: GroundSpecimenColorService }
    ]; };
    GroundSoilSpecimensMapComponent.propDecorators = {
        soilSpecimen: [{ type: Input }],
        layer: [{ type: Input }],
        showPoints: [{ type: Input }]
    };
    return GroundSoilSpecimensMapComponent;
}());
if (false) {
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.soilSpecimen;
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.layer;
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.showPoints;
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.features;
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.mapConfig;
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.markerConfig;
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.polygonConfig;
    /** @type {?} */
    GroundSoilSpecimensMapComponent.prototype.colors;
    /**
     * @type {?}
     * @private
     */
    GroundSoilSpecimensMapComponent.prototype.colorService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundScansFilterForm = /** @class */ (function () {
    function GroundScansFilterForm(layer) {
        this.layer = layer;
    }
    return GroundScansFilterForm;
}());
if (false) {
    /** @type {?} */
    GroundScansFilterForm.prototype.layer;
}
/** @type {?} */
var GROUND_SCANS_FILTER_FORM_LAYOUT = {
    layer: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    }
};
/** @type {?} */
var GROUND_SCANS_FILTER_FORM_MODEL = [
    new DynamicSelectModel({
        id: 'layer',
        options: [
            { value: GroundScansLayer.Countur, label: 'GROUND.scansTab.filter.layers.countur' },
            { value: GroundScansLayer.Scan, label: 'GROUND.scansTab.filter.layers.scan' }
        ]
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundScansComponent = /** @class */ (function () {
    function GroundScansComponent(groundImportDataSharedService) {
        var _this = this;
        this.groundImportDataSharedService = groundImportDataSharedService;
        this.displaySpinner$ = new BehaviorSubject(true);
        this.layer = GroundScansLayer.Countur;
        this.formLayout = GROUND_SCANS_FILTER_FORM_LAYOUT;
        this.formModel = GROUND_SCANS_FILTER_FORM_MODEL;
        this.initValue = new GroundScansFilterForm(this.layer);
        this.displayedColumns = ['measurementDate', 'action'];
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            _this.displaySpinner$.next(true);
            return _this.groundImportDataSharedService.findScanListItems(_this.organizationId, _this.groundId, filter)
                .pipe(finalize((/**
             * @return {?}
             */
            function () { _this.displaySpinner$.next(false); })))
                .pipe(map((/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                _this.showOnMap(d.items.length > 0 ? d.items[0] : null);
                return {
                    items: d.items,
                    totalCount: d.pager.totalCount
                };
            })));
        }));
    }
    /**
     * @return {?}
     */
    GroundScansComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @return {?}
     */
    GroundScansComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.scanFilterForm.formGroup.get('layer').valueChanges
            .subscribe((/**
         * @param {?} layer
         * @return {?}
         */
        function (layer) {
            _this.layer = layer;
        }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundScansComponent.prototype.showOnMap = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.scanId = item != null ? item.id : null;
    };
    GroundScansComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-scans',
                    template: "<div [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header d-flex\">\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body py-1\">\r\n                <div class=\"container-fluid px-0\">\r\n                    <div class=\"row text-center\" [hidden]=\"!(dataSource.noData$ | async)\">\r\n                        <div class=\"col-12\">\r\n                            <h5>\r\n                                {{ 'GROUND.scansTab.noScans' | translate }}\r\n                            </h5>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\" [hidden]=\"dataSource.noData$ | async\">\r\n                        <div class=\"col-12 col-lg-6 col-xl-8\">\r\n                            <label class=\"px-0 mb-2\">\r\n                                <h5 class=\"m-0\">\r\n                                    <i class=\"ft ft-map\"></i> {{ 'GROUND.scansTab.map' | translate }}\r\n                                </h5>\r\n                            </label>\r\n                            <hr class=\"mt-0\" />\r\n                            <lib-ground-scans-map\r\n                                [organizationId]=\"organizationId\"\r\n                                [groundId]=\"groundId\"\r\n                                [scanId]=\"scanId\"\r\n                                [layer]=\"layer\"></lib-ground-scans-map>\r\n                        </div>\r\n                        <div class=\"col-12 col-lg-6 col-xl-4\">\r\n                            <label class=\"px-0 mb-2 mt-3 mt-lg-0\">\r\n                                <h5 class=\"m-0\">\r\n                                    <i class=\"ft ft-layers\"></i> {{ 'GROUND.scansTab.scans' | translate }}\r\n                                </h5>\r\n                            </label>\r\n                            <hr class=\"mt-0\" />\r\n\r\n                            <app-simple-form #scanFilter [formModel]=\"formModel\" [formLayout]=\"formLayout\"\r\n                                [model]=\"initValue\" [translateKey]=\"'GROUND.scansTab.filter'\">\r\n                            </app-simple-form>\r\n\r\n                            <div class=\"mt-3\">\r\n                                <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"measurementDate\"\r\n                                    cdkSortDirection=\"desc\">\r\n                                    <ng-container cdkColumnDef=\"measurementDate\">\r\n                                        <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header\r\n                                            class=\"col-6 text-truncate\">\r\n                                            {{ 'GROUND.scansTab.measurementDate' | translate }}\r\n                                        </div>\r\n                                        <div cdk-cell *cdkCellDef=\"let item\" class=\"col-9 text-truncate pr-0\">\r\n                                            <span>{{ item.measurementDate | date: 'shortDate' }}</span>\r\n                                        </div>\r\n                                    </ng-container>\r\n                                    <ng-container cdkColumnDef=\"action\">\r\n                                        <div cdk-header-cell *cdkHeaderCellDef class=\"col-3  p-0 text-center\">\r\n                                            {{ 'APPLICATION.LIST.action' | translate }}</div>\r\n                                        <div cdk-cell *cdkCellDef=\"let item\"\r\n                                            class=\"col-3 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                            <div class=\"row no-gutters float-md-right\">\r\n                                                <button (click)=\"showOnMap(item)\"\r\n                                                    title=\"{{ 'GROUND.scansTab.showOnMap:button' | translate }}\"\r\n                                                    class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                                    <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                                </button>\r\n                                            </div>\r\n                                        </div>\r\n                                    </ng-container>\r\n                                    <cdk-header-row class=\"row header-navbar m-0 py-2 extra_bg-light-grey\"\r\n                                        *cdkHeaderRowDef=\"displayedColumns\">\r\n                                    </cdk-header-row>\r\n                                    <cdk-row class=\"row row-striped align-items-center m-0\"\r\n                                        *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                                </cdk-table>\r\n                                <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                                    <div class=\"col text-center py-3\">{{ 'GROUND.scansTab.list:empty' | translate }}\r\n                                    </div>\r\n                                </div>\r\n                                <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                                    <div class=\"col text-center py-3\">{{ 'GROUND.scansTab.list:error' | translate }}\r\n                                    </div>\r\n                                </div>\r\n                                <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                                    [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons></cdk-paginator>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    GroundScansComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_IMPORT_DATA_SHARED_SERVICE,] }] }
    ]; };
    GroundScansComponent.propDecorators = {
        organizationId: [{ type: Input }],
        groundId: [{ type: Input }],
        scanFilterForm: [{ type: ViewChild, args: ['scanFilter', { static: false },] }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return GroundScansComponent;
}());
if (false) {
    /** @type {?} */
    GroundScansComponent.prototype.organizationId;
    /** @type {?} */
    GroundScansComponent.prototype.groundId;
    /** @type {?} */
    GroundScansComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundScansComponent.prototype.scanFilterForm;
    /** @type {?} */
    GroundScansComponent.prototype.formLayout;
    /** @type {?} */
    GroundScansComponent.prototype.formModel;
    /** @type {?} */
    GroundScansComponent.prototype.initValue;
    /** @type {?} */
    GroundScansComponent.prototype.sort;
    /** @type {?} */
    GroundScansComponent.prototype.paginator;
    /** @type {?} */
    GroundScansComponent.prototype.displayedColumns;
    /** @type {?} */
    GroundScansComponent.prototype.dataSource;
    /** @type {?} */
    GroundScansComponent.prototype.scanId;
    /** @type {?} */
    GroundScansComponent.prototype.layer;
    /**
     * @type {?}
     * @private
     */
    GroundScansComponent.prototype.groundImportDataSharedService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundSoilSpecimenFilterForm = /** @class */ (function () {
    function GroundSoilSpecimenFilterForm(layer, showPoints) {
        this.layer = layer;
        this.showPoints = showPoints;
    }
    return GroundSoilSpecimenFilterForm;
}());
if (false) {
    /** @type {?} */
    GroundSoilSpecimenFilterForm.prototype.layer;
    /** @type {?} */
    GroundSoilSpecimenFilterForm.prototype.showPoints;
}
/** @type {?} */
var GROUND_SOIL_SEPECIMENS_FORM_LAYOUT = {
    layer: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    showPoints: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    }
};
/** @type {?} */
var GROUND_SOIL_SEPECIMENS_FORM_MODEL = [
    new DynamicSelectModel({
        id: 'layer',
        options: [
            { value: GroundSoilSpecimensLayer.Countur, label: 'GROUND.soilSpecimensTab.filter.layers.countur' }
        ]
    }),
    new DynamicCheckboxModel({
        id: 'showPoints',
    })
];
/**
 * @param {?} specimen
 * @return {?}
 */
function getActiveLayers(specimen) {
    if (specimen == null || specimen.specimens == null || specimen.specimens.length === 0) {
        return [GroundSoilSpecimensLayer.Countur];
    }
    /** @type {?} */
    var layers = [GroundSoilSpecimensLayer.Countur, GroundSoilSpecimensLayer.Net];
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.agronomic; }))) {
        layers.push(GroundSoilSpecimensLayer.Agronomic);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.ph; }))) {
        layers.push(GroundSoilSpecimensLayer.Ph);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.p2o5; }))) {
        layers.push(GroundSoilSpecimensLayer.Phosphorus);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.k2o; }))) {
        layers.push(GroundSoilSpecimensLayer.Potassium);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.mg; }))) {
        layers.push(GroundSoilSpecimensLayer.Magnesium);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.mn; }))) {
        layers.push(GroundSoilSpecimensLayer.Manganese);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.zn; }))) {
        layers.push(GroundSoilSpecimensLayer.Zinc);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.cu; }))) {
        layers.push(GroundSoilSpecimensLayer.Copper);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.fe; }))) {
        layers.push(GroundSoilSpecimensLayer.Iron);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.b; }))) {
        layers.push(GroundSoilSpecimensLayer.Boron);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.ca; }))) {
        layers.push(GroundSoilSpecimensLayer.Calcium);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.c; }))) {
        layers.push(GroundSoilSpecimensLayer.OrganicCarbon);
    }
    if (specimen.specimens.some((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.humus; }))) {
        layers.push(GroundSoilSpecimensLayer.Humus);
    }
    return layers;
}
/**
 * @param {?} specimen
 * @return {?}
 */
function calculateLayerOptions(specimen) {
    /** @type {?} */
    var options = [
        { value: GroundSoilSpecimensLayer.Countur, label: 'GROUND.soilSpecimensTab.filter.layers.countur' },
        { value: GroundSoilSpecimensLayer.Net, label: 'GROUND.soilSpecimensTab.filter.layers.net' },
        { value: GroundSoilSpecimensLayer.Agronomic, label: 'GROUND.soilSpecimensTab.filter.layers.agronomic' },
        { value: GroundSoilSpecimensLayer.Ph, label: 'GROUND.soilSpecimensTab.filter.layers.ph' },
        { value: GroundSoilSpecimensLayer.Phosphorus, label: 'GROUND.soilSpecimensTab.filter.layers.phosphorus' },
        { value: GroundSoilSpecimensLayer.Potassium, label: 'GROUND.soilSpecimensTab.filter.layers.potassium' },
        { value: GroundSoilSpecimensLayer.Magnesium, label: 'GROUND.soilSpecimensTab.filter.layers.magnesium' },
        { value: GroundSoilSpecimensLayer.Manganese, label: 'GROUND.soilSpecimensTab.filter.layers.manganese' },
        { value: GroundSoilSpecimensLayer.Zinc, label: 'GROUND.soilSpecimensTab.filter.layers.zinc' },
        { value: GroundSoilSpecimensLayer.Copper, label: 'GROUND.soilSpecimensTab.filter.layers.copper' },
        { value: GroundSoilSpecimensLayer.Iron, label: 'GROUND.soilSpecimensTab.filter.layers.iron' },
        { value: GroundSoilSpecimensLayer.Boron, label: 'GROUND.soilSpecimensTab.filter.layers.boron' },
        { value: GroundSoilSpecimensLayer.Calcium, label: 'GROUND.soilSpecimensTab.filter.layers.calcium' },
        { value: GroundSoilSpecimensLayer.OrganicCarbon, label: 'GROUND.soilSpecimensTab.filter.layers.organicCarbon' },
        { value: GroundSoilSpecimensLayer.Humus, label: 'GROUND.soilSpecimensTab.filter.layers.humus' }
    ];
    /** @type {?} */
    var layers = getActiveLayers(specimen);
    return options.filter((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return layers.some((/**
     * @param {?} layer
     * @return {?}
     */
    function (layer) { return layer === x.value; })); }));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function GroundSoilSpecimensRecommendationsForm() { }
if (false) {
    /** @type {?} */
    GroundSoilSpecimensRecommendationsForm.prototype.recommendationsBaseGroup;
}
/** @type {?} */
var GROUND_SOIL_SPECIMENS_RECOMMENDATIONS_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: 'recommendationsBaseGroup',
        group: [
            new DynamicTextAreaModel({
                id: 'content',
                autoFocus: true,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 60
                }
            })
        ]
    }),
];
/** @type {?} */
var GROUND_SOIL_SPECIMENS_RECOMMENDATIONS_FORM_LAYOUT = {
    recommendationsBaseGroup: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    }
};
/**
 * @param {?} soilSpecimenId
 * @param {?} recommendations
 * @return {?}
 */
function mapToRecommendationsForm(soilSpecimenId, recommendations) {
    return {
        recommendationsBaseGroup: {
            id: soilSpecimenId,
            content: recommendations
        }
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundSoilSpecimensComponent = /** @class */ (function () {
    function GroundSoilSpecimensComponent(groundImportDataSharedService) {
        var _this = this;
        this.groundImportDataSharedService = groundImportDataSharedService;
        this.isEditable = false;
        this.displaySpinner$ = new BehaviorSubject(true);
        this.layer = GroundSoilSpecimensLayer.Countur;
        this.showPoints = false;
        this.formLayout = GROUND_SOIL_SEPECIMENS_FORM_LAYOUT;
        this.formModel = GROUND_SOIL_SEPECIMENS_FORM_MODEL;
        this.recommendationFormModel = GROUND_SOIL_SPECIMENS_RECOMMENDATIONS_FORM_MODEL;
        this.recommendationFormLayout = GROUND_SOIL_SPECIMENS_RECOMMENDATIONS_FORM_LAYOUT;
        this.initValue = new GroundSoilSpecimenFilterForm(this.layer, this.showPoints);
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            _this.displaySpinner$.next(true);
            return _this.groundImportDataSharedService.findSoilSpecimenListItems(_this.organizationId, _this.groundId, filter)
                .pipe(finalize((/**
             * @return {?}
             */
            function () { _this.displaySpinner$.next(false); })))
                .pipe(map((/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                _this.showOnMap(d.items.length > 0 ? d.items[0] : null);
                return {
                    items: d.items,
                    totalCount: d.pager.totalCount
                };
            })));
        }));
    }
    /**
     * @return {?}
     */
    GroundSoilSpecimensComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.isEditable) {
            this.displayedColumns = ['measurementDate', 'isPublished', 'action'];
        }
        else {
            this.displayedColumns = ['measurementDate', 'action'];
        }
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @return {?}
     */
    GroundSoilSpecimensComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.soilSpecimenFilterForm.formGroup.get('layer').valueChanges
            .subscribe((/**
         * @param {?} layer
         * @return {?}
         */
        function (layer) {
            _this.layer = layer;
        }));
        this.soilSpecimenFilterForm.formGroup.get('showPoints').valueChanges
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.showPoints = value;
        }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundSoilSpecimensComponent.prototype.showOnMap = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        if (item === null) {
            return;
        }
        this.displaySpinner$.next(true);
        this.groundImportDataSharedService.getSoilSpecimen(this.organizationId, this.groundId, item.id)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            // tslint:disable-next-line: no-any
            /** @type {?} */
            var layerSelectModel = (/** @type {?} */ (_this.formModel.find((/**
             * @param {?} e
             * @return {?}
             */
            function (e) { return e.name === 'layer'; }))));
            layerSelectModel.options = calculateLayerOptions(x);
            _this.soilSpecimen = x;
            _this.layer = GroundSoilSpecimensLayer.Countur;
            _this.showPoints = false;
            _this.initValue = new GroundSoilSpecimenFilterForm(_this.layer, _this.showPoints);
            _this.soilSpecimenFilterForm.refreshFormModel();
            _this.recommendations = x.recommendations;
            _this.recommendationsForm = mapToRecommendationsForm(x.id, x.recommendations);
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    GroundSoilSpecimensComponent.prototype.save = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        this.displaySpinner$.next(true);
        this.recommendations = event.recommendationsBaseGroup.content;
        this.groundImportDataSharedService
            .updateSoilSpecimenRecommendations(this.organizationId, this.groundId, event.recommendationsBaseGroup.id, this.recommendations)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.dataSource.forceRefresh();
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    GroundSoilSpecimensComponent.prototype.changePublishStatus = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        this.displaySpinner$.next(true);
        this.groundImportDataSharedService
            .publishSoilSpecimen(this.organizationId, this.groundId, event.id)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.dataSource.forceRefresh();
        }));
    };
    GroundSoilSpecimensComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-soil-specimens',
                    template: "<div [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header d-flex\">\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body py-1\">\r\n                <div class=\"container-fluid px-0\">\r\n                    <div class=\"row text-center\" [hidden]=\"!(dataSource.noData$ | async)\">\r\n                        <div class=\"col-12\">\r\n                            <h5>\r\n                                {{ 'GROUND.soilSpecimensTab.noSoilSpecimens' | translate }}\r\n                            </h5>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\" [hidden]=\"dataSource.noData$ | async\">\r\n                        <div class=\"col-12 col-lg-6 col-xl-8\">\r\n                            <label class=\"px-0 mb-2\">\r\n                                <h5 class=\"m-0\">\r\n                                    <i class=\"ft ft-map\"></i> {{ 'GROUND.soilSpecimensTab.map' | translate }}\r\n                                </h5>\r\n                            </label>\r\n                            <hr class=\"mt-0\" />\r\n                            <lib-ground-soil-specimens-map [soilSpecimen]=\"soilSpecimen\" [layer]=\"layer\"\r\n                                [showPoints]=\"showPoints\"></lib-ground-soil-specimens-map>\r\n                        </div>\r\n                        <div class=\"col-12 col-lg-6 col-xl-4\">\r\n                            <label class=\"px-0 mb-2 mt-3 mt-lg-0\">\r\n                                <h5 class=\"m-0\">\r\n                                    <i class=\"ft ft-layers\"></i> {{ 'GROUND.soilSpecimensTab.soilSpecimens' | translate\r\n                                    }}\r\n                                </h5>\r\n                            </label>\r\n                            <hr class=\"mt-0\" />\r\n                            <app-simple-form #soilSpecimenFilter [formModel]=\"formModel\" [formLayout]=\"formLayout\"\r\n                                [model]=\"initValue\" [translateKey]=\"'GROUND.soilSpecimensTab.filter'\">\r\n                            </app-simple-form>\r\n\r\n                            <div class=\"mt-3\">\r\n                                <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"measurementDate\"\r\n                                    cdkSortDirection=\"desc\">\r\n                                    <ng-container cdkColumnDef=\"measurementDate\">\r\n                                        <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header\r\n                                            class=\"col-6 text-truncate\">\r\n                                            {{ 'GROUND.soilSpecimensTab.stampleDate' | translate }}\r\n                                        </div>\r\n                                        <div cdk-cell *cdkCellDef=\"let item\" class=\"col-7 text-truncate pr-0\">\r\n                                            <span>{{ item.measurementDate | date: 'shortDate' }}</span>\r\n                                        </div>\r\n                                    </ng-container>\r\n                                    <ng-container cdkColumnDef=\"isPublished\" *ngIf=\"isEditable\">\r\n                                        <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header\r\n                                            class=\"col-3 text-truncate\">\r\n                                            {{ 'GROUND.soilSpecimensTab.isPublished' | translate }}\r\n                                        </div>\r\n                                        <div cdk-cell *cdkCellDef=\"let item\" class=\"col-2 text-truncate pr-0\">\r\n                                            <i *ngIf=\"item.isPublished\" class=\"ft ft-check\" aria-hidden=\"true\"></i>\r\n                                            <i *ngIf=\"!item.isPublished\" class=\"ft ft-x\" aria-hidden=\"true\"></i>\r\n                                        </div>\r\n                                    </ng-container>\r\n                                    <ng-container cdkColumnDef=\"action\">\r\n                                        <div cdk-header-cell *cdkHeaderCellDef class=\"col-3  p-0 text-center\">\r\n                                            {{ 'APPLICATION.LIST.action' | translate }}</div>\r\n                                        <div cdk-cell *cdkCellDef=\"let item\"\r\n                                            class=\"col-3 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                            <div class=\"row no-gutters float-md-right\">\r\n                                                <button (click)=\"showOnMap(item)\"\r\n                                                    title=\"{{ 'GROUND.soilSpecimensTab.showOnMap:button' | translate }}\"\r\n                                                    class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                                    <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                                </button>\r\n                                            </div>\r\n                                            <div *ngIf=\"isEditable\" class=\"row no-gutters float-md-right\">\r\n                                                <button (click)=\"changePublishStatus(item)\"\r\n                                                    title=\"{{ 'GROUND.soilSpecimensTab.changePublishStatus:button' | translate }}\"\r\n                                                    [ngClass]=\"{'btn btn-raised m-0 my-1 mr-1 btn-sm' : true, 'btn-danger': item.isPublished, 'btn-success': !item.isPublished}\">\r\n                                                    <i *ngIf=\"item.isPublished\" class=\"ft ft-download\"\r\n                                                        aria-hidden=\"true\"></i>\r\n                                                    <i *ngIf=\"!item.isPublished\" class=\"ft ft-upload\"\r\n                                                        aria-hidden=\"true\"></i>\r\n                                                </button>\r\n                                            </div>\r\n                                        </div>\r\n                                    </ng-container>\r\n                                    <cdk-header-row class=\"row header-navbar m-0 py-2 extra_bg-light-grey\"\r\n                                        *cdkHeaderRowDef=\"displayedColumns\">\r\n                                    </cdk-header-row>\r\n                                    <cdk-row class=\"row row-striped align-items-center m-0\"\r\n                                        *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                                </cdk-table>\r\n                                <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                                    <div class=\"col text-center py-3\">{{ 'GROUND.soilSpecimensTab.list:empty' |\r\n                                        translate }}</div>\r\n                                </div>\r\n                                <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                                    <div class=\"col text-center py-3\">{{ 'GROUND.soilSpecimensTab.list:error' |\r\n                                        translate }}</div>\r\n                                </div>\r\n                                <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                                    [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons></cdk-paginator>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card\" *ngIf=\"!(dataSource.noData$ | async) && (recommendations || isEditable)\"\r\n        appPanelFullscreen>\r\n        <div class=\"card-header d-flex\">\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body py-1\">\r\n                <div class=\"container-fluid px-0\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12 mt-2\">\r\n                            <app-form *ngIf=\"recommendationsForm\" #formDetail [startFromIsEditing]=\"false\"\r\n                                [formModel]=\"recommendationFormModel\" [formLayout]=\"recommendationFormLayout\"\r\n                                [model]=\"recommendationsForm\" [translateKey]=\"'GROUND'\" (save)=\"save($event)\"\r\n                                [isEditable]=\"isEditable\">\r\n                            </app-form>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    GroundSoilSpecimensComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_IMPORT_DATA_SHARED_SERVICE,] }] }
    ]; };
    GroundSoilSpecimensComponent.propDecorators = {
        organizationId: [{ type: Input }],
        groundId: [{ type: Input }],
        isEditable: [{ type: Input }],
        soilSpecimenFilterForm: [{ type: ViewChild, args: ['soilSpecimenFilter', { static: false },] }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return GroundSoilSpecimensComponent;
}());
if (false) {
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.organizationId;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.groundId;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.isEditable;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.soilSpecimenFilterForm;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.formLayout;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.formModel;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.initValue;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.sort;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.paginator;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.displayedColumns;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.dataSource;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.soilSpecimen;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.layer;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.showPoints;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.recommendations;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.recommendationsForm;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.recommendationFormLayout;
    /** @type {?} */
    GroundSoilSpecimensComponent.prototype.recommendationFormModel;
    /**
     * @type {?}
     * @private
     */
    GroundSoilSpecimensComponent.prototype.groundImportDataSharedService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var GroundDataImportComponent = /** @class */ (function () {
    function GroundDataImportComponent(router, groundSharedService, fileImporterService, notificationService) {
        var _this = this;
        this.router = router;
        this.groundSharedService = groundSharedService;
        this.fileImporterService = fileImporterService;
        this.notificationService = notificationService;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.mapConfig = new MapConfig();
        this.markerConfig = new MarkerConfig(false, false);
        this.polygonConfig = new PolygonConfig(null, false, false);
        this.loadGround = (/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(true);
            _this.groundSharedService.get(_this.organizationId, _this.groundId)
                .pipe(finalize((/**
             * @return {?}
             */
            function () { _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} ground
             * @return {?}
             */
            function (ground) {
                _this.groundLocation = ground.locations;
                _this.initMap();
            }));
        });
        this.parseFile = (/**
         * @param {?} file
         * @return {?}
         */
        function (file) {
            _this.displaySpinner$.next(true);
            _this.fileImporterService.readFile(file)
                .pipe(catchError((/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                _this.notificationService.error(error, 'GROUND.import.parse:error');
                throw error;
            })), finalize((/**
             * @return {?}
             */
            function () { _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                if (_this.validateData(x)) {
                    _this.isLoaded = true;
                    _this.onLoadData(x);
                    _this.contourLocation = _this.createLoadDataContourLocation(x);
                    _this.initMap();
                }
                else {
                    _this.notificationService.error(new Error(), 'GROUND.import.format:error');
                }
            }));
        });
        this.onChangeFile = (/**
         * @return {?}
         */
        function () {
            _this.isLoaded = false;
            _this.onLoadData(null);
            _this.contourLocation = null;
            _this.initMap();
        });
        this.onSaveFile = (/**
         * @return {?}
         */
        function () {
            _this.saveImportedFile().subscribe((/**
             * @return {?}
             */
            function () { _this.onCancel(); }));
        });
    }
    /**
     * @return {?}
     */
    GroundDataImportComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.loadGround();
    };
    /**
     * @private
     * @return {?}
     */
    GroundDataImportComponent.prototype.initMap = /**
     * @private
     * @return {?}
     */
    function () {
        this.features = this.contourLocation
            ? this.groundLocation.concat(this.contourLocation) : this.groundLocation;
    };
    /**
     * @return {?}
     */
    GroundDataImportComponent.prototype.onCancel = /**
     * @return {?}
     */
    function () {
        this.router.navigate(this.returnUrl);
    };
    /**
     * @return {?}
     */
    GroundDataImportComponent.prototype.onAddFile = /**
     * @return {?}
     */
    function () {
        this.file.nativeElement.click();
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundDataImportComponent.prototype.onFileAdded = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if ($event.srcElement.files && $event.srcElement.files[0]) {
            /** @type {?} */
            var file = $event.srcElement.files[0];
            this.parseFile(file);
        }
    };
    GroundDataImportComponent.propDecorators = {
        organizationId: [{ type: Input }],
        groundId: [{ type: Input }],
        returnUrl: [{ type: Input }],
        file: [{ type: ViewChild, args: ['file', { static: false },] }]
    };
    return GroundDataImportComponent;
}());
if (false) {
    /** @type {?} */
    GroundDataImportComponent.prototype.organizationId;
    /** @type {?} */
    GroundDataImportComponent.prototype.groundId;
    /** @type {?} */
    GroundDataImportComponent.prototype.returnUrl;
    /** @type {?} */
    GroundDataImportComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundDataImportComponent.prototype.header;
    /** @type {?} */
    GroundDataImportComponent.prototype.features;
    /** @type {?} */
    GroundDataImportComponent.prototype.mapConfig;
    /** @type {?} */
    GroundDataImportComponent.prototype.markerConfig;
    /** @type {?} */
    GroundDataImportComponent.prototype.polygonConfig;
    /** @type {?} */
    GroundDataImportComponent.prototype.isLoaded;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.groundLocation;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.contourLocation;
    /** @type {?} */
    GroundDataImportComponent.prototype.file;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.loadGround;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.parseFile;
    /** @type {?} */
    GroundDataImportComponent.prototype.onChangeFile;
    /** @type {?} */
    GroundDataImportComponent.prototype.onSaveFile;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.groundSharedService;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.fileImporterService;
    /**
     * @type {?}
     * @private
     */
    GroundDataImportComponent.prototype.notificationService;
    /**
     * @abstract
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundDataImportComponent.prototype.validateData = function (loadedData) { };
    /**
     * @abstract
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundDataImportComponent.prototype.onLoadData = function (loadedData) { };
    /**
     * @abstract
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundDataImportComponent.prototype.createLoadDataContourLocation = function (loadedData) { };
    /**
     * @abstract
     * @protected
     * @return {?}
     */
    GroundDataImportComponent.prototype.saveImportedFile = function () { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileImporterService = /** @class */ (function () {
    function FileImporterService() {
        this.readFile = (/**
         * @template T
         * @param {?} blob
         * @param {?=} reader
         * @return {?}
         */
        function (blob, reader) {
            if (reader === void 0) { reader = new FileReader(); }
            return new Observable((/**
             * @param {?} obs
             * @return {?}
             */
            function (obs) {
                if (!(blob instanceof Blob)) {
                    obs.error(new Error('`blob` must be an instance of File or Blob.'));
                    return;
                }
                reader.onerror = (/**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) { return obs.error(err); });
                reader.onabort = (/**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) { return obs.error(err); });
                // tslint:disable-next-line: no-any
                reader.onload = (/**
                 * @param {?} evt
                 * @return {?}
                 */
                function (evt) { return obs.next((/** @type {?} */ (JSON.parse(evt.target.result)))); });
                reader.onloadend = (/**
                 * @return {?}
                 */
                function () { return obs.complete(); });
                return reader.readAsText(blob, 'UTF-8');
            }));
        });
    }
    FileImporterService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ FileImporterService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FileImporterService_Factory() { return new FileImporterService(); }, token: FileImporterService, providedIn: "root" });
    return FileImporterService;
}());
if (false) {
    /** @type {?} */
    FileImporterService.prototype.readFile;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CreateGroundImportSoilSpecimenCommand = /** @class */ (function () {
    function CreateGroundImportSoilSpecimenCommand(measurementDate, contour, specimens, recommendations, isPublished) {
        this.measurementDate = measurementDate;
        this.contour = contour;
        this.specimens = specimens;
        this.recommendations = recommendations;
        this.isPublished = isPublished;
    }
    return CreateGroundImportSoilSpecimenCommand;
}());
if (false) {
    /** @type {?} */
    CreateGroundImportSoilSpecimenCommand.prototype.measurementDate;
    /** @type {?} */
    CreateGroundImportSoilSpecimenCommand.prototype.contour;
    /** @type {?} */
    CreateGroundImportSoilSpecimenCommand.prototype.specimens;
    /** @type {?} */
    CreateGroundImportSoilSpecimenCommand.prototype.recommendations;
    /** @type {?} */
    CreateGroundImportSoilSpecimenCommand.prototype.isPublished;
}
var GroundImportSoilSpecimenItemCommand = /** @class */ (function () {
    function GroundImportSoilSpecimenItemCommand(sector, agronomic, ph, p2o5, k2o, mg, mn, zn, cu, fe, b, ca, c, humus, samplingPoints, areas) {
        this.sector = sector;
        this.agronomic = agronomic;
        this.ph = ph;
        this.p2o5 = p2o5;
        this.k2o = k2o;
        this.mg = mg;
        this.mn = mn;
        this.zn = zn;
        this.cu = cu;
        this.fe = fe;
        this.b = b;
        this.ca = ca;
        this.c = c;
        this.humus = humus;
        this.samplingPoints = samplingPoints;
        this.areas = areas;
    }
    return GroundImportSoilSpecimenItemCommand;
}());
if (false) {
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.sector;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.agronomic;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.ph;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.p2o5;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.k2o;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.mg;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.mn;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.zn;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.cu;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.fe;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.b;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.ca;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.c;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.humus;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.samplingPoints;
    /** @type {?} */
    GroundImportSoilSpecimenItemCommand.prototype.areas;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundSoilSpecimensImportComponent = /** @class */ (function (_super) {
    __extends(GroundSoilSpecimensImportComponent, _super);
    function GroundSoilSpecimensImportComponent(router, groundSharedService, groundImportDataSharedService, fileImporterService, notificationService) {
        var _this = _super.call(this, router, groundSharedService, fileImporterService, notificationService) || this;
        _this.groundImportDataSharedService = groundImportDataSharedService;
        _this.createCreateGroundImportSoilSpecimenCommand = (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var measurementDate = fromUnixTime(data.date).toISOString();
            /** @type {?} */
            var contour = [(/** @type {?} */ ({
                    type: 'Feature',
                    id: v4(),
                    geometry: data.contour,
                    properties: (/** @type {?} */ ({
                        fillColor: '#000000',
                        strokeColor: '#000000',
                    }))
                }))];
            /** @type {?} */
            var specimens = (data.probe || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                /** @type {?} */
                var nets = data.net.filter((/**
                 * @param {?} n
                 * @return {?}
                 */
                function (n) { return n.sectorID === x.sector; }));
                return _this.createGroundImportSoilSpecimenItemCommand(x, nets);
            }));
            /** @type {?} */
            var recommendations = data.recommendations;
            return new CreateGroundImportSoilSpecimenCommand(measurementDate, contour, specimens, recommendations, true);
        });
        _this.createGroundImportSoilSpecimenItemCommand = (/**
         * @param {?} probe
         * @param {?=} net
         * @return {?}
         */
        function (probe, net) {
            return new GroundImportSoilSpecimenItemCommand(probe.sector, probe.agronomic, probe.ph, probe.p2o5, probe.k2o, probe.mg, probe.mn, probe.zn, probe.cu, probe.fe, probe.b, probe.ca, probe.c, probe.humus, (probe.probes || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ((/** @type {?} */ ({ type: 'Point', coordinates: [x.lng, x.lat] }))); })), (net || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.area; })));
        });
        _this.header = 'GROUND.import.header:soils';
        return _this;
    }
    /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundSoilSpecimensImportComponent.prototype.validateData = /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    function (loadedData) {
        if (loadedData.probe == null || loadedData.probe.length === 0) {
            return false;
        }
        if (loadedData.net == null || loadedData.net.length === 0) {
            return false;
        }
        return true;
    };
    /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundSoilSpecimensImportComponent.prototype.onLoadData = /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    function (loadedData) {
        this.loadedData = loadedData;
    };
    /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundSoilSpecimensImportComponent.prototype.createLoadDataContourLocation = /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    function (loadedData) {
        return [(/** @type {?} */ ({
                geometry: loadedData.contour,
                properties: (/** @type {?} */ ({
                    fillColor: '#000000',
                    strokeColor: '#000000',
                }))
            }))];
    };
    /**
     * @protected
     * @return {?}
     */
    GroundSoilSpecimensImportComponent.prototype.saveImportedFile = /**
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var command = this.createCreateGroundImportSoilSpecimenCommand(this.loadedData);
        return this.groundImportDataSharedService.importSoilSpecimens(this.organizationId, this.groundId, command);
    };
    GroundSoilSpecimensImportComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-soil-specimens-import',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"d-flex\">\r\n        <h2>\r\n            <span class=\"d-none d-md-inline\">{{ header | translate }}</span>\r\n        </h2>\r\n        <div class=\"ml-auto\">\r\n            <a class=\"btn btn-raised btn-warning m-0\" (click)=\"onCancel()\" href=\"javascript:void(0)\">\r\n                <i class=\"ft-x\"></i> {{ 'APPLICATION.FORM.cancel' | translate }}\r\n            </a>\r\n        </div>\r\n    </div>\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header clearfix\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div style=\"height: 400px;\">\r\n                    <app-map\r\n                        [features]=\"features\"\r\n                        [mapConfig]=\"mapConfig\"\r\n                        [markerConfig]=\"markerConfig\"\r\n                        [polygonConfig]=\"polygonConfig\">\r\n                    </app-map>\r\n                </div>\r\n                <div class=\"float-right mt-2 mb-2\">\r\n                    <input type=\"file\" #file style=\"display: none\" (change)=\"onFileAdded($event)\" onclick=\"this.value=null\" accept=\".json\" />\r\n                    <a *ngIf=\"!isLoaded\" class=\"btn btn-raised btn-primary m-0\" (click)=\"onAddFile()\" href=\"javascript:void(0)\">\r\n                        <i class=\"ft-plus-circle\"></i> {{ 'GROUND.import.selectFile' | translate }}\r\n                      </a>\r\n\r\n                    <a *ngIf=\"isLoaded\" class=\"btn btn-raised btn-warning m-0 ml-1\" (click)=\"onChangeFile()\" href=\"javascript:void(0)\">\r\n                        <i class=\"ft-edit-2\"></i> {{ 'GROUND.import.change' | translate }}\r\n                    </a>\r\n\r\n                    <a *ngIf=\"isLoaded\" class=\"btn btn-raised btn-primary m-0 ml-1\" (click)=\"onSaveFile()\" href=\"javascript:void(0)\">\r\n                        <i class=\"ft-save\"></i> {{ 'GROUND.import.save' | translate }}\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    GroundSoilSpecimensImportComponent.ctorParameters = function () { return [
        { type: Router },
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_SHARED_SERVICE,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_IMPORT_DATA_SHARED_SERVICE,] }] },
        { type: FileImporterService },
        { type: NotificationService }
    ]; };
    return GroundSoilSpecimensImportComponent;
}(GroundDataImportComponent));
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundSoilSpecimensImportComponent.prototype.loadedData;
    /**
     * @type {?}
     * @private
     */
    GroundSoilSpecimensImportComponent.prototype.createCreateGroundImportSoilSpecimenCommand;
    /**
     * @type {?}
     * @private
     */
    GroundSoilSpecimensImportComponent.prototype.createGroundImportSoilSpecimenItemCommand;
    /**
     * @type {?}
     * @private
     */
    GroundSoilSpecimensImportComponent.prototype.groundImportDataSharedService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportScanItemCommand = /** @class */ (function () {
    function GroundImportScanItemCommand(sector, value, size, areas) {
        this.sector = sector;
        this.value = value;
        this.size = size;
        this.areas = areas;
    }
    return GroundImportScanItemCommand;
}());
if (false) {
    /** @type {?} */
    GroundImportScanItemCommand.prototype.sector;
    /** @type {?} */
    GroundImportScanItemCommand.prototype.value;
    /** @type {?} */
    GroundImportScanItemCommand.prototype.size;
    /** @type {?} */
    GroundImportScanItemCommand.prototype.areas;
}
var CreateGroundImportScanCommand = /** @class */ (function () {
    function CreateGroundImportScanCommand(measurementDate, contour, scans) {
        this.measurementDate = measurementDate;
        this.contour = contour;
        this.scans = scans;
    }
    return CreateGroundImportScanCommand;
}());
if (false) {
    /** @type {?} */
    CreateGroundImportScanCommand.prototype.measurementDate;
    /** @type {?} */
    CreateGroundImportScanCommand.prototype.contour;
    /** @type {?} */
    CreateGroundImportScanCommand.prototype.scans;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundScansImportComponent = /** @class */ (function (_super) {
    __extends(GroundScansImportComponent, _super);
    function GroundScansImportComponent(router, groundSharedService, groundImportDataSharedService, fileImporterService, notificationService) {
        var _this = _super.call(this, router, groundSharedService, fileImporterService, notificationService) || this;
        _this.groundImportDataSharedService = groundImportDataSharedService;
        _this.createGroundImportScanItemCommand = (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var sector = data.sectorID;
            /** @type {?} */
            var value = data.value;
            /** @type {?} */
            var size = data.size;
            /** @type {?} */
            var areas = data.area.coordinates.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return ((/** @type {?} */ ({ type: 'Polygon', coordinates: x }))); }));
            return new GroundImportScanItemCommand(sector, value, size, areas);
        });
        _this.header = 'GROUND.import.header:scans';
        return _this;
    }
    /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundScansImportComponent.prototype.validateData = /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    function (loadedData) {
        if (loadedData.scan == null || loadedData.scan.length === 0) {
            return false;
        }
        return true;
    };
    /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundScansImportComponent.prototype.onLoadData = /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    function (loadedData) {
        this.loadedData = loadedData;
    };
    /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    GroundScansImportComponent.prototype.createLoadDataContourLocation = /**
     * @protected
     * @param {?} loadedData
     * @return {?}
     */
    function (loadedData) {
        return [(/** @type {?} */ ({
                geometry: loadedData.contour,
                properties: (/** @type {?} */ ({
                    fillColor: '#000000',
                    strokeColor: '#000000',
                }))
            }))];
    };
    /**
     * @protected
     * @return {?}
     */
    GroundScansImportComponent.prototype.saveImportedFile = /**
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var command = this.createCreateGroundImportScanCommand(this.loadedData);
        return this.groundImportDataSharedService.importScans(this.organizationId, this.groundId, command);
    };
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    GroundScansImportComponent.prototype.createCreateGroundImportScanCommand = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        /** @type {?} */
        var measurementDate = fromUnixTime(data.date).toISOString();
        /** @type {?} */
        var contour = [(/** @type {?} */ ({
                type: 'Feature',
                id: v4(),
                geometry: data.contour,
                properties: (/** @type {?} */ ({
                    fillColor: '#000000',
                    strokeColor: '#000000',
                }))
            }))];
        /** @type {?} */
        var scans = (data.scan || []).map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.createGroundImportScanItemCommand(x); }));
        return new CreateGroundImportScanCommand(measurementDate, contour, scans);
    };
    GroundScansImportComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-scans-import',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"d-flex\">\r\n        <h2>\r\n            <span class=\"d-none d-md-inline\">{{ header | translate }}</span>\r\n        </h2>\r\n        <div class=\"ml-auto\">\r\n            <a class=\"btn btn-raised btn-warning m-0\" (click)=\"onCancel()\" href=\"javascript:void(0)\">\r\n                <i class=\"ft-x\"></i> {{ 'APPLICATION.FORM.cancel' | translate }}\r\n            </a>\r\n        </div>\r\n    </div>\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header clearfix\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div style=\"height: 400px;\">\r\n                    <app-map\r\n                        [features]=\"features\"\r\n                        [mapConfig]=\"mapConfig\"\r\n                        [markerConfig]=\"markerConfig\"\r\n                        [polygonConfig]=\"polygonConfig\">\r\n                    </app-map>\r\n                </div>\r\n                <div class=\"float-right mt-2 mb-2\">\r\n                    <input type=\"file\" #file style=\"display: none\" (change)=\"onFileAdded($event)\" onclick=\"this.value=null\" accept=\".json\" />\r\n                    <a *ngIf=\"!isLoaded\" class=\"btn btn-raised btn-primary m-0\" (click)=\"onAddFile()\" href=\"javascript:void(0)\">\r\n                        <i class=\"ft-plus-circle\"></i> {{ 'GROUND.import.selectFile' | translate }}\r\n                      </a>\r\n\r\n                    <a *ngIf=\"isLoaded\" class=\"btn btn-raised btn-warning m-0 ml-1\" (click)=\"onChangeFile()\" href=\"javascript:void(0)\">\r\n                        <i class=\"ft-edit-2\"></i> {{ 'GROUND.import.change' | translate }}\r\n                    </a>\r\n\r\n                    <a *ngIf=\"isLoaded\" class=\"btn btn-raised btn-primary m-0 ml-1\" (click)=\"onSaveFile()\" href=\"javascript:void(0)\">\r\n                        <i class=\"ft-save\"></i> {{ 'GROUND.import.save' | translate }}\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    GroundScansImportComponent.ctorParameters = function () { return [
        { type: Router },
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_SHARED_SERVICE,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_IMPORT_DATA_SHARED_SERVICE,] }] },
        { type: FileImporterService },
        { type: NotificationService }
    ]; };
    return GroundScansImportComponent;
}(GroundDataImportComponent));
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundScansImportComponent.prototype.loadedData;
    /**
     * @type {?}
     * @private
     */
    GroundScansImportComponent.prototype.createGroundImportScanItemCommand;
    /**
     * @type {?}
     * @private
     */
    GroundScansImportComponent.prototype.groundImportDataSharedService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolygonSplitService = /** @class */ (function () {
    function PolygonSplitService() {
    }
    /**
     * @param {?} polygon
     * @param {?} polyline
     * @return {?}
     */
    PolygonSplitService.prototype.splitPolygon = /**
     * @param {?} polygon
     * @param {?} polyline
     * @return {?}
     */
    function (polygon, polyline) {
        /** @type {?} */
        var geometryFactory = new GeometryFactory();
        /** @type {?} */
        var polygonJsts = this.createJstsPolygon(geometryFactory, polygon);
        /** @type {?} */
        var polylineJsts = this.createJstsLinestring(geometryFactory, polyline);
        /** @type {?} */
        var geometryCollection = geometryFactory.createGeometryCollection([polylineJsts, polygonJsts.getExteriorRing()]);
        /** @type {?} */
        var joinedGeometries = UnaryUnionOp.union(geometryCollection);
        /** @type {?} */
        var polygonizer = new Polygonizer();
        polygonizer.add(joinedGeometries);
        /** @type {?} */
        var result = [];
        for (var i = polygonizer.getPolygons().iterator(); i.hasNext();) {
            /** @type {?} */
            var splitedPolygon = i.next();
            /** @type {?} */
            var coords = splitedPolygon.getCoordinates().map((/**
             * @param {?} coord
             * @return {?}
             */
            function (coord) {
                return new google.maps.LatLng(coord.x, coord.y);
            }));
            result.push(coords);
        }
        return result;
    };
    /**
     * @param {?} polygon1
     * @param {?} polygon2
     * @return {?}
     */
    PolygonSplitService.prototype.intersectPolygons = /**
     * @param {?} polygon1
     * @param {?} polygon2
     * @return {?}
     */
    function (polygon1, polygon2) {
        /** @type {?} */
        var geometryFactory = new GeometryFactory();
        /** @type {?} */
        var polygon1Jsts = this.createJstsPolygon(geometryFactory, polygon1);
        /** @type {?} */
        var polygon2Jsts = this.createJstsPolygon(geometryFactory, polygon2);
        /** @type {?} */
        var intersect = OverlayOp.intersection(polygon1Jsts, polygon2Jsts);
        /** @type {?} */
        var difference = OverlayOp.difference(polygon1Jsts, polygon2Jsts);
        return [
            intersect.getCoordinates().map((/**
             * @param {?} coords
             * @return {?}
             */
            function (coords) { return new google.maps.LatLng(coords.x, coords.y); })),
            difference.getCoordinates().map((/**
             * @param {?} coords
             * @return {?}
             */
            function (coords) { return new google.maps.LatLng(coords.x, coords.y); }))
        ];
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} geometryFactory
     * @param {?} polygon
     * @return {?}
     */
    PolygonSplitService.prototype.createJstsPolygon = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} geometryFactory
     * @param {?} polygon
     * @return {?}
     */
    function (geometryFactory, polygon) {
        /** @type {?} */
        var path = polygon.getPath();
        /** @type {?} */
        var coordinates = path.getArray().map((/**
         * @param {?} coord
         * @return {?}
         */
        function (coord) {
            return new Coordinate(coord.lat(), coord.lng());
        }));
        coordinates.push(coordinates[0]);
        /** @type {?} */
        var shell = geometryFactory.createLinearRing(coordinates);
        return geometryFactory.createPolygon(shell, []);
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} geometryFactory
     * @param {?} polyline
     * @return {?}
     */
    PolygonSplitService.prototype.createJstsLinestring = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} geometryFactory
     * @param {?} polyline
     * @return {?}
     */
    function (geometryFactory, polyline) {
        /** @type {?} */
        var path = polyline.getPath();
        /** @type {?} */
        var coordinates = path.getArray().map((/**
         * @param {?} coord
         * @return {?}
         */
        function (coord) {
            return new Coordinate(coord.lat(), coord.lng());
        }));
        return geometryFactory.createLineString(coordinates);
    };
    PolygonSplitService.decorators = [
        { type: Injectable, args: [{
                    providedIn: PureGoogleMapsServicesModule
                },] }
    ];
    /** @nocollapse */ PolygonSplitService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PolygonSplitService_Factory() { return new PolygonSplitService(); }, token: PolygonSplitService, providedIn: PureGoogleMapsServicesModule });
    return PolygonSplitService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CreateGroundParcelCommand = /** @class */ (function () {
    function CreateGroundParcelCommand(name, areaInHa, locations) {
        this.name = name;
        this.areaInHa = areaInHa;
        this.locations = locations;
    }
    return CreateGroundParcelCommand;
}());
if (false) {
    /** @type {?} */
    CreateGroundParcelCommand.prototype.name;
    /** @type {?} */
    CreateGroundParcelCommand.prototype.areaInHa;
    /** @type {?} */
    CreateGroundParcelCommand.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcel = /** @class */ (function () {
    function GroundParcel(id, name, areaInHa, locations) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
        this.locations = locations;
    }
    return GroundParcel;
}());
if (false) {
    /** @type {?} */
    GroundParcel.prototype.id;
    /** @type {?} */
    GroundParcel.prototype.name;
    /** @type {?} */
    GroundParcel.prototype.areaInHa;
    /** @type {?} */
    GroundParcel.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelShapesOptions = /** @class */ (function () {
    function GroundParcelShapesOptions() {
    }
    GroundParcelShapesOptions.UNSELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ffff00',
        fillColor: '#ffff00'
    };
    GroundParcelShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS = {
        strokeColor: '#000080',
        fillColor: '#000080'
    };
    GroundParcelShapesOptions.SELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ff0000',
        fillColor: '#ff0000'
    };
    GroundParcelShapesOptions.POLYLINE_OPTIONS = {
        strokeColor: '#ff0000'
    };
    return GroundParcelShapesOptions;
}());
if (false) {
    /** @type {?} */
    GroundParcelShapesOptions.UNSELECTED_POLYGON_OPTIONS;
    /** @type {?} */
    GroundParcelShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS;
    /** @type {?} */
    GroundParcelShapesOptions.SELECTED_POLYGON_OPTIONS;
    /** @type {?} */
    GroundParcelShapesOptions.POLYLINE_OPTIONS;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SelectedPolygonInfo() { }
if (false) {
    /** @type {?} */
    SelectedPolygonInfo.prototype.isSelected;
    /** @type {?} */
    SelectedPolygonInfo.prototype.name;
    /** @type {?} */
    SelectedPolygonInfo.prototype.areaInHa;
}
/** @type {?} */
var EMPTY_SELECTED_POLYGON_INFO = {
    name: null,
    areaInHa: 0,
    isSelected: false
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelPolygonsService = /** @class */ (function () {
    function GroundParcelPolygonsService(mapService, pureMapService, polygonSplitService, decimalPipe) {
        this.mapService = mapService;
        this.pureMapService = pureMapService;
        this.polygonSplitService = polygonSplitService;
        this.decimalPipe = decimalPipe;
        this.polygons = [];
        this.polygonSelected = new Subject();
        this.polygonsDataSource = new Subject();
        this.splitingToolEnabled = false;
        this.drawingManagerPolygon = null;
        this.isDrawCompleted = new BehaviorSubject(false);
        this.mapReady = this.pureMapService.mapReady;
    }
    /**
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.polygons = [];
    };
    /**
     * @param {?} parcels
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.drawParcels = /**
     * @param {?} parcels
     * @return {?}
     */
    function (parcels) {
        var _this = this;
        parcels.forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) {
            _this.mapService.getPolygonsLatLngLiteralsFromFeatures(p.locations)
                .forEach((/**
             * @param {?} latLng
             * @return {?}
             */
            function (latLng) { return _this.createPolygon(latLng, p); }));
        }));
        /** @type {?} */
        var bounds = new google.maps.LatLngBounds();
        this.polygons.forEach((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) { return polygon.getPath().forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return bounds.extend(p); })); }));
        this.pureMapService.fitBounds(bounds);
        this.refreshDataSource();
    };
    /**
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.startSplitingPolygon = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.splitingToolEnabled = true;
        /** @type {?} */
        var drawingManager = this.pureMapService.createDrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: false,
            polygonOptions: {
                fillColor: '#ffff00',
                fillOpacity: 0.5,
                strokeWeight: 2,
                strokeColor: '#ffffff'
            }
        });
        drawingManager.addListener('overlaycomplete', (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.drawingManagerPolygon = (/** @type {?} */ (event.overlay));
            drawingManager.setMap(null);
            _this.drawingManagerPolygon.setEditable(true);
            _this.isDrawCompleted.next(true);
        }));
    };
    /**
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.submitSplitingPolygon = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.drawingManagerPolygon) {
            /** @type {?} */
            var newPolygonsLatLng = this.polygonSplitService
                .intersectPolygons(this.getSelectedPolygon(), this.drawingManagerPolygon);
            this.removePolygon(this.getSelectedPolygon());
            newPolygonsLatLng.forEach((/**
             * @param {?} latLng
             * @return {?}
             */
            function (latLng) { return _this.createPolygon(latLng); }));
            this.splitingToolEnabled = false;
            this.drawingManagerPolygon.setMap(null);
            this.drawingManagerPolygon = null;
            this.refreshDataSource();
            this.isDrawCompleted.next(false);
        }
    };
    /**
     * @param {?} polygonInfo
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.setPolygonName = /**
     * @param {?} polygonInfo
     * @return {?}
     */
    function (polygonInfo) {
        /** @type {?} */
        var selectedPolygon = this.getSelectedPolygon();
        selectedPolygon.set('name', polygonInfo.name);
        this.refreshDataSource();
    };
    /**
     * @param {?} id
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.selectPolygonOnMap = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        /** @type {?} */
        var polygon = this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.get('id') === id; }))[0];
        this.unselectAllPolygonsExcept(polygon);
        polygon.set('selected', true);
    };
    /**
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.buildCreateGroundParcelCommand = /**
     * @return {?}
     */
    function () {
        return this.polygons.map((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) {
            /** @type {?} */
            var coordinates = polygon.getPaths().getArray().map((/**
             * @param {?} path
             * @return {?}
             */
            function (path) { return path.getArray().map((/**
             * @param {?} latLng
             * @return {?}
             */
            function (latLng) { return [latLng.lng(), latLng.lat()]; })); }));
            /** @type {?} */
            var locations = [{
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: coordinates,
                    },
                    properties: {
                        area: polygon.get('areaInHa'),
                        fillColor: parcelDrawingColor,
                        strokeColor: parcelDrawingColor,
                        name: polygon.get('name')
                    },
                }];
            return new CreateGroundParcelCommand(polygon.get('name'), polygon.get('areaInHa'), locations);
        }));
    };
    /**
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.removeParcels = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.polygons.forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return _this.removePolygon(p); }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.setPolygonListeners = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        var _this = this;
        polygon.addListener('selected_changed', (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var isPolygonSelected = (/** @type {?} */ (polygon.get('selected')));
            /** @type {?} */
            var polygonName = polygon.get('name');
            /** @type {?} */
            var polygonArea = polygon.get('areaInHa');
            _this.polygonSelected.next((/** @type {?} */ ({
                isSelected: isPolygonSelected,
                areaInHa: polygonArea,
                name: polygonName
            })));
            /** @type {?} */
            var polygonOptions = isPolygonSelected
                ? GroundParcelShapesOptions.SELECTED_POLYGON_OPTIONS
                : (polygonName != null
                    ? GroundParcelShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS
                    : GroundParcelShapesOptions.UNSELECTED_POLYGON_OPTIONS);
            polygon.setOptions(polygonOptions);
        }));
        polygon.addListener('click', (/**
         * @return {?}
         */
        function () {
            _this.unselectAllPolygonsExcept(polygon);
            /** @type {?} */
            var value = polygon.get('selected');
            polygon.set('selected', !value);
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.removePolygon = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        polygon.setMap(null);
        google.maps.event.clearInstanceListeners(polygon);
        this.polygons = this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p !== polygon; }));
        this.polygonSelected.next(EMPTY_SELECTED_POLYGON_INFO);
    };
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.calculatePolygonArea = /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        /** @type {?} */
        var meterToHa = 10000;
        /** @type {?} */
        var areaValue = google.maps.geometry.spherical.computeArea(paths) / meterToHa;
        /** @type {?} */
        var digitsInfo = '1.2-2';
        /** @type {?} */
        var locale = 'en-US';
        /** @type {?} */
        var twoDecimalPointArea = this.decimalPipe.transform(areaValue, digitsInfo, locale);
        return Number(twoDecimalPointArea);
    };
    /**
     * @private
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.getSelectedPolygon = /**
     * @private
     * @return {?}
     */
    function () {
        return this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return (/** @type {?} */ (p.get('selected'))) === true; }))[0];
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.unselectAllPolygonsExcept = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var polygonsToBeUnselected = this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p !== polygon; }));
        polygonsToBeUnselected.forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.set('selected', false); }));
    };
    /**
     * @private
     * @param {?} latLng
     * @param {?=} parcel
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.createPolygon = /**
     * @private
     * @param {?} latLng
     * @param {?=} parcel
     * @return {?}
     */
    function (latLng, parcel) {
        /** @type {?} */
        var polygon = this.pureMapService.createPolygon(__assign({ paths: latLng }, GroundParcelShapesOptions.UNSELECTED_POLYGON_OPTIONS));
        this.setPolygonListeners(polygon);
        if (parcel) {
            polygon.set('areaInHa', parcel.areaInHa);
            polygon.set('name', parcel.name);
        }
        else {
            /** @type {?} */
            var polygonArea = this.calculatePolygonArea(polygon.getPath());
            polygon.set('areaInHa', polygonArea);
        }
        polygon.set('id', v4());
        polygon.set('selected', false);
        this.polygons.push(polygon);
    };
    /**
     * @private
     * @return {?}
     */
    GroundParcelPolygonsService.prototype.refreshDataSource = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var polygons = this.polygons.map((/**
         * @param {?} p
         * @return {?}
         */
        function (p) {
            return new GroundParcel(p.get('id'), p.get('name'), p.get('areaInHa'), []);
        }));
        this.polygonsDataSource.next(polygons);
    };
    GroundParcelPolygonsService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    GroundParcelPolygonsService.ctorParameters = function () { return [
        { type: MapService },
        { type: PureMapService },
        { type: PolygonSplitService },
        { type: DecimalPipe }
    ]; };
    return GroundParcelPolygonsService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundParcelPolygonsService.prototype.polygons;
    /** @type {?} */
    GroundParcelPolygonsService.prototype.polygonSelected;
    /** @type {?} */
    GroundParcelPolygonsService.prototype.polygonsDataSource;
    /** @type {?} */
    GroundParcelPolygonsService.prototype.mapReady;
    /** @type {?} */
    GroundParcelPolygonsService.prototype.splitingToolEnabled;
    /** @type {?} */
    GroundParcelPolygonsService.prototype.drawingManagerPolygon;
    /** @type {?} */
    GroundParcelPolygonsService.prototype.isDrawCompleted;
    /**
     * @type {?}
     * @private
     */
    GroundParcelPolygonsService.prototype.mapService;
    /**
     * @type {?}
     * @private
     */
    GroundParcelPolygonsService.prototype.pureMapService;
    /**
     * @type {?}
     * @private
     */
    GroundParcelPolygonsService.prototype.polygonSplitService;
    /**
     * @type {?}
     * @private
     */
    GroundParcelPolygonsService.prototype.decimalPipe;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelInfoModalComponent = /** @class */ (function () {
    function GroundParcelInfoModalComponent(activeModal) {
        this.activeModal = activeModal;
        this.initValue = undefined;
        this.formModel = [
            new DynamicInputModel({
                id: 'name',
                minLength: 3,
                maxLength: 160,
                required: null,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 160
                }
            }),
            new DynamicInputModel({
                id: 'areaInHa',
                readOnly: true
            })
        ];
        this.formLayout = __assign({}, GetDefaultSingleLineLayout(this.formModel));
    }
    /**
     * @return {?}
     */
    GroundParcelInfoModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initValue = this.selectedPolygonInfo;
    };
    /**
     * @return {?}
     */
    GroundParcelInfoModalComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.activeModal.close(false);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    GroundParcelInfoModalComponent.prototype.add = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.activeModal.close($event);
    };
    GroundParcelInfoModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-parcel-info-modal',
                    template: "<div>\r\n    <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ editParcelFormHeaderKey | translate }}</h4>\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancel()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <app-add-form #addForm\r\n            *ngIf=\"formModel\"\r\n            [formModel]=\"formModel\"\r\n            [formLayout]=\"formLayout\"\r\n            [model]=\"initValue\"\r\n            [translateKey]=\"editParcelFormTranslateKey\"\r\n            (add)=\"add($event)\"\r\n            (afterCancel)=\"cancel()\">\r\n        </app-add-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    GroundParcelInfoModalComponent.ctorParameters = function () { return [
        { type: NgbActiveModal }
    ]; };
    GroundParcelInfoModalComponent.propDecorators = {
        editParcelFormHeaderKey: [{ type: Input }],
        editParcelFormTranslateKey: [{ type: Input }],
        selectedPolygonInfo: [{ type: Input }]
    };
    return GroundParcelInfoModalComponent;
}());
if (false) {
    /** @type {?} */
    GroundParcelInfoModalComponent.prototype.editParcelFormHeaderKey;
    /** @type {?} */
    GroundParcelInfoModalComponent.prototype.editParcelFormTranslateKey;
    /** @type {?} */
    GroundParcelInfoModalComponent.prototype.selectedPolygonInfo;
    /** @type {?} */
    GroundParcelInfoModalComponent.prototype.formLayout;
    /** @type {?} */
    GroundParcelInfoModalComponent.prototype.formModel;
    /** @type {?} */
    GroundParcelInfoModalComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    GroundParcelInfoModalComponent.prototype.activeModal;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_PARCEL_SHARED_SERVICE = new InjectionToken('GroundParcelSharedService');
/**
 * @record
 */
function IGroundParcelSharedService() { }
if (false) {
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @return {?}
     */
    IGroundParcelSharedService.prototype.getAllByGroundId = function (organizationId, groundId) { };
    /**
     * @param {?} organizationId
     * @return {?}
     */
    IGroundParcelSharedService.prototype.getAllNotAssignedToParcelGroup = function (organizationId) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @param {?} command
     * @return {?}
     */
    IGroundParcelSharedService.prototype.createParcels = function (organizationId, groundId, command) { };
    /**
     * @param {?} organizationId
     * @param {?} groundId
     * @return {?}
     */
    IGroundParcelSharedService.prototype.deleteParcels = function (organizationId, groundId) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelsSchema = /** @class */ (function () {
    function GroundParcelsSchema(mapHeaderKey, parcelsDeleteButtonKey, parcelsDeleteConfirmTitleKey, parcelsDeleteConfirmMessageKey, parcelsSaveButtonKey, parcelsSaveConfirmTitleKey, parcelsSaveConfirmMessageKey, splitParcelButtonKey, infoParcelButtonKey, confirmSplittingParcelKey, parcelNameMissingWarningKey, parcelStartingSplitInfoKey, parcelDrawingSplitInfoKey, parcelEndingSplitInfoKey, listHeaderKey, parcelNameKey, parcelAreaInHaKey, actionsKey, showOnMapButtonKey, editParcelButtonKey, editParcelFormHeaderKey, editParcelFormTranslateKey) {
        this.mapHeaderKey = mapHeaderKey;
        this.parcelsDeleteButtonKey = parcelsDeleteButtonKey;
        this.parcelsDeleteConfirmTitleKey = parcelsDeleteConfirmTitleKey;
        this.parcelsDeleteConfirmMessageKey = parcelsDeleteConfirmMessageKey;
        this.parcelsSaveButtonKey = parcelsSaveButtonKey;
        this.parcelsSaveConfirmTitleKey = parcelsSaveConfirmTitleKey;
        this.parcelsSaveConfirmMessageKey = parcelsSaveConfirmMessageKey;
        this.splitParcelButtonKey = splitParcelButtonKey;
        this.infoParcelButtonKey = infoParcelButtonKey;
        this.confirmSplittingParcelKey = confirmSplittingParcelKey;
        this.parcelNameMissingWarningKey = parcelNameMissingWarningKey;
        this.parcelStartingSplitInfoKey = parcelStartingSplitInfoKey;
        this.parcelDrawingSplitInfoKey = parcelDrawingSplitInfoKey;
        this.parcelEndingSplitInfoKey = parcelEndingSplitInfoKey;
        this.listHeaderKey = listHeaderKey;
        this.parcelNameKey = parcelNameKey;
        this.parcelAreaInHaKey = parcelAreaInHaKey;
        this.actionsKey = actionsKey;
        this.showOnMapButtonKey = showOnMapButtonKey;
        this.editParcelButtonKey = editParcelButtonKey;
        this.editParcelFormHeaderKey = editParcelFormHeaderKey;
        this.editParcelFormTranslateKey = editParcelFormTranslateKey;
    }
    return GroundParcelsSchema;
}());
if (false) {
    /** @type {?} */
    GroundParcelsSchema.prototype.mapHeaderKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelsDeleteButtonKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelsDeleteConfirmTitleKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelsDeleteConfirmMessageKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelsSaveButtonKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelsSaveConfirmTitleKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelsSaveConfirmMessageKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.splitParcelButtonKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.infoParcelButtonKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.confirmSplittingParcelKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelNameMissingWarningKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelStartingSplitInfoKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelDrawingSplitInfoKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelEndingSplitInfoKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.listHeaderKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelNameKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.parcelAreaInHaKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.actionsKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.showOnMapButtonKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.editParcelButtonKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.editParcelFormHeaderKey;
    /** @type {?} */
    GroundParcelsSchema.prototype.editParcelFormTranslateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelDataSource = /** @class */ (function (_super) {
    __extends(GroundParcelDataSource, _super);
    function GroundParcelDataSource(polygonsData) {
        var _this = _super.call(this) || this;
        _this.polygonsData = polygonsData;
        return _this;
    }
    /**
     * @return {?}
     */
    GroundParcelDataSource.prototype.connect = /**
     * @return {?}
     */
    function () {
        return this.polygonsData;
    };
    /**
     * @return {?}
     */
    GroundParcelDataSource.prototype.disconnect = /**
     * @return {?}
     */
    function () { };
    return GroundParcelDataSource;
}(DataSource));
if (false) {
    /**
     * @type {?}
     * @private
     */
    GroundParcelDataSource.prototype.polygonsData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelsComponent = /** @class */ (function () {
    function GroundParcelsComponent(groundParcelSharedService, groundParcelPolygonService, changeDetectorRef, modalService, confirmationModalService, notificationService) {
        this.groundParcelSharedService = groundParcelSharedService;
        this.groundParcelPolygonService = groundParcelPolygonService;
        this.changeDetectorRef = changeDetectorRef;
        this.modalService = modalService;
        this.confirmationModalService = confirmationModalService;
        this.notificationService = notificationService;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.dataSource = new GroundParcelDataSource(this.groundParcelPolygonService.polygonsDataSource);
        this.displayedColumns = ['name', 'areaInHa', 'action'];
    }
    /**
     * @return {?}
     */
    GroundParcelsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.mapReadySubscription = this.groundParcelPolygonService.mapReady.subscribe((/**
         * @return {?}
         */
        function () {
            _this.groundParcelSharedService.getAllByGroundId(_this.organizationId, _this.groundId)
                .pipe(finalize((/**
             * @return {?}
             */
            function () { return _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} parcels
             * @return {?}
             */
            function (parcels) { return _this.groundParcelPolygonService.drawParcels(parcels); }));
        }));
        this.groundParcelPolygonService.polygonSelected.subscribe((/**
         * @param {?} polygonInfo
         * @return {?}
         */
        function (polygonInfo) {
            _this.isPolygonSelected = polygonInfo.isSelected;
            _this.selectedPolygonInfo = polygonInfo;
            _this.changeDetectorRef.markForCheck();
        }));
        this.allParcelsHaveName$ = this.dataSource.connect().pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.every((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.name !== undefined; })); })));
        this.isDrawCompleted$ = this.groundParcelPolygonService.isDrawCompleted;
    };
    /**
     * @return {?}
     */
    GroundParcelsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.mapReadySubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    GroundParcelsComponent.prototype.startSplitGround = /**
     * @return {?}
     */
    function () {
        this.groundParcelPolygonService.startSplitingPolygon();
    };
    /**
     * @return {?}
     */
    GroundParcelsComponent.prototype.submitSplitGround = /**
     * @return {?}
     */
    function () {
        this.groundParcelPolygonService.submitSplitingPolygon();
    };
    /**
     * @return {?}
     */
    GroundParcelsComponent.prototype.openPolygonInfoModal = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var parcelModal = this.modalService.open(GroundParcelInfoModalComponent, { windowClass: 'right', beforeDismiss: (/**
             * @return {?}
             */
            function () { return false; }) });
        parcelModal.componentInstance.editParcelFormHeaderKey = this.schema.editParcelFormHeaderKey;
        parcelModal.componentInstance.editParcelFormTranslateKey = this.schema.editParcelFormTranslateKey;
        parcelModal.componentInstance.selectedPolygonInfo = this.selectedPolygonInfo;
        parcelModal.result.then((/**
         * @param {?} polygonInfo
         * @return {?}
         */
        function (polygonInfo) {
            if (polygonInfo) {
                _this.groundParcelPolygonService.setPolygonName(polygonInfo);
            }
        }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundParcelsComponent.prototype.showParcelOnMapClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.groundParcelPolygonService.selectPolygonOnMap(item.id);
    };
    /**
     * @return {?}
     */
    GroundParcelsComponent.prototype.saveParcels = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.confirmationModalService.open(this.schema.parcelsSaveConfirmTitleKey, this.schema.parcelsSaveConfirmMessageKey, null)
            .then((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(true);
            /** @type {?} */
            var command = _this.groundParcelPolygonService.buildCreateGroundParcelCommand();
            if (command.filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.name === undefined || x.name === null; })).length > 0) {
                _this.notificationService.error(null, _this.schema.parcelNameMissingWarningKey);
                _this.displaySpinner$.next(false);
            }
            else {
                _this.groundParcelSharedService.createParcels(_this.organizationId, _this.groundId, command)
                    .pipe(finalize((/**
                 * @return {?}
                 */
                function () { return _this.displaySpinner$.next(false); })))
                    .subscribe();
            }
        }), (/**
         * @return {?}
         */
        function () { }));
    };
    /**
     * @return {?}
     */
    GroundParcelsComponent.prototype.removeParcels = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.confirmationModalService.open(this.schema.parcelsDeleteConfirmTitleKey, this.schema.parcelsDeleteConfirmMessageKey, null)
            .then((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(true);
            _this.groundParcelSharedService
                .deleteParcels(_this.organizationId, _this.groundId)
                .pipe(switchMap((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _this.groundParcelSharedService.getAllByGroundId(_this.organizationId, _this.groundId); })))
                .pipe(finalize((/**
             * @return {?}
             */
            function () { return _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} parcels
             * @return {?}
             */
            function (parcels) {
                _this.groundParcelPolygonService.removeParcels();
                _this.groundParcelPolygonService.drawParcels(parcels);
            }));
        }), (/**
         * @return {?}
         */
        function () { }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    GroundParcelsComponent.prototype.openParcelInfoModal = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.groundParcelPolygonService.selectPolygonOnMap(item.id);
        this.openPolygonInfoModal();
    };
    Object.defineProperty(GroundParcelsComponent.prototype, "splitingToolEnabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.groundParcelPolygonService.splitingToolEnabled;
        },
        enumerable: true,
        configurable: true
    });
    GroundParcelsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ground-parcels',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body pt-0\">\r\n                <div class=\"container-fluid px-0\">\r\n                    <div class=\"d-flex\">\r\n                        <div class=\"ml-auto mt-2\">\r\n                            <a class=\"btn btn-raised mr-1 btn-danger\" (click)=\"removeParcels()\">\r\n                                <i class=\"ft-save mr-1\"></i> {{ schema.parcelsDeleteButtonKey | translate }}\r\n                            </a>\r\n                            <a class=\"btn btn-raised mr-1 btn-primary\" (click)=\"saveParcels()\"\r\n                                [class.disabled]=\"!(allParcelsHaveName$ | async)\">\r\n                                <i class=\"ft-save mr-1\"></i> {{ schema.parcelsSaveButtonKey | translate }}\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                    <form class=\"form-horizontal ng-dynamic-form\">\r\n                        <label class=\"col-12 px-0\">\r\n                            <h5 class=\"m-0\"><i class=\"ft ft-home\"></i> {{ schema.mapHeaderKey | translate }}</h5>\r\n                            <hr class=\"mt-1\">\r\n                        </label>\r\n                    </form>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12\">\r\n                            <div class=\"float-left\">\r\n                                <a class=\"btn btn-raised mr-1\" (click)=\"startSplitGround()\" [class.disabled]=\"!isPolygonSelected\"\r\n                                    [class.btn-outline-warning]=\"!splitingToolEnabled\" [class.btn-warning]=\"splitingToolEnabled\">\r\n                                    <i class=\"ft-edit-2 mr-1\"></i> {{ schema.splitParcelButtonKey | translate }}\r\n                                </a>\r\n                                <a class=\"btn btn-raised mr-1 btn-warning\" (click)=\"openPolygonInfoModal()\"\r\n                                    [class.disabled]=\"!isPolygonSelected\">\r\n                                    <i class=\"ft-info mr-1\"></i> {{ schema.infoParcelButtonKey | translate }}\r\n                                </a>\r\n                                <a class=\"btn btn-raised mr-1 btn-success\" (click)=\"submitSplitGround()\" *ngIf=\"splitingToolEnabled\"\r\n                                    [class.disabled]=\"!(isDrawCompleted$ | async)\">\r\n                                    <i class=\"ft-save mr-1\"></i> {{ schema.confirmSplittingParcelKey | translate }}\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12\">\r\n                            <div class=\"alert alert-warning\" *ngIf=\"!(allParcelsHaveName$ | async)\">\r\n                                {{ schema.parcelNameMissingWarningKey | translate }}\r\n                            </div>\r\n                            <div class=\"alert alert-info\" *ngIf=\"!splitingToolEnabled\">\r\n                                {{ schema.parcelStartingSplitInfoKey | translate }}\r\n                            </div>\r\n                            <div class=\"alert alert-info\" *ngIf=\"splitingToolEnabled && !(isDrawCompleted$ | async)\">\r\n                                {{ schema.parcelDrawingSplitInfoKey | translate }} </div>\r\n                            <div class=\"alert alert-info\" *ngIf=\"isDrawCompleted$ | async\">\r\n                                {{ schema.parcelEndingSplitInfoKey | translate }} </div>\r\n                        </div>\r\n                        <div class=\"col-12\">\r\n                            <app-pure-map [height]=\"420\"></app-pure-map>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card\">\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <form class=\"form-horizontal ng-dynamic-form\">\r\n                    <label class=\"col-12 px-0\">\r\n                        <h5 class=\"m-0\"><i class=\"ft ft-map-pin\"></i> {{ schema.listHeaderKey | translate }}</h5>\r\n                        <hr class=\"mt-1\">\r\n                    </label>\r\n                </form>\r\n                <div class=\"container-fluid\">\r\n                    <cdk-table [dataSource]=\"dataSource\">\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-9 col-md-5 col-lg-5 pr-0\">\r\n                                {{ schema.parcelNameKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-9 col-md-5 col-lg-5 pr-0\">\r\n                                {{ groundName }} {{ element.name ? ' - ' + element.name : '' }}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"areaInHa\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-md-4 col-lg-5 d-none d-md-block pr-0\">\r\n                                {{ schema.parcelAreaInHaKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-md-4 col-lg-5 d-none d-md-block pr-0\">\r\n                                {{ element.areaInHa }}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-3 col-md-3 col-lg-2 text-md-right\">\r\n                                {{ schema.actionsKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-3 col-md-3 col-lg-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-md-end\">\r\n                                    <button (click)=\"showParcelOnMapClick(element)\" title=\"{{ schema.showOnMapButtonKey | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button (click)=\"openParcelInfoModal(element)\" title=\"{{ schema.editParcelButtonKey | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-success\">\r\n                                        <i class=\"ft ft-edit-2\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\" *cdkHeaderRowDef=\"displayedColumns\"></cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\" *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [GroundParcelPolygonsService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    GroundParcelsComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_PARCEL_SHARED_SERVICE,] }] },
        { type: GroundParcelPolygonsService },
        { type: ChangeDetectorRef },
        { type: NgbModal },
        { type: ConfirmationModalService },
        { type: NotificationService }
    ]; };
    GroundParcelsComponent.propDecorators = {
        organizationId: [{ type: Input }],
        groundId: [{ type: Input }],
        groundName: [{ type: Input }],
        schema: [{ type: Input }]
    };
    return GroundParcelsComponent;
}());
if (false) {
    /** @type {?} */
    GroundParcelsComponent.prototype.organizationId;
    /** @type {?} */
    GroundParcelsComponent.prototype.groundId;
    /** @type {?} */
    GroundParcelsComponent.prototype.groundName;
    /** @type {?} */
    GroundParcelsComponent.prototype.schema;
    /** @type {?} */
    GroundParcelsComponent.prototype.isPolygonSelected;
    /** @type {?} */
    GroundParcelsComponent.prototype.selectedPolygonInfo;
    /** @type {?} */
    GroundParcelsComponent.prototype.displayedColumns;
    /** @type {?} */
    GroundParcelsComponent.prototype.dataSource;
    /** @type {?} */
    GroundParcelsComponent.prototype.displaySpinner$;
    /** @type {?} */
    GroundParcelsComponent.prototype.mapReadySubscription;
    /** @type {?} */
    GroundParcelsComponent.prototype.isDrawCompleted$;
    /** @type {?} */
    GroundParcelsComponent.prototype.allParcelsHaveName$;
    /**
     * @type {?}
     * @private
     */
    GroundParcelsComponent.prototype.groundParcelSharedService;
    /**
     * @type {?}
     * @private
     */
    GroundParcelsComponent.prototype.groundParcelPolygonService;
    /**
     * @type {?}
     * @private
     */
    GroundParcelsComponent.prototype.changeDetectorRef;
    /**
     * @type {?}
     * @private
     */
    GroundParcelsComponent.prototype.modalService;
    /**
     * @type {?}
     * @private
     */
    GroundParcelsComponent.prototype.confirmationModalService;
    /**
     * @type {?}
     * @private
     */
    GroundParcelsComponent.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PARCEL_GROUP_LIST_FILTER_FORM_LAYOUT = {
    name: {
        grid: {
            host: 'col-12 col-md-6 order-md-1',
            // tslint:disable-next-line: no-duplicate-string
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    },
    areaFrom: {
        grid: {
            host: 'col-12 col-md-6 order-md-2',
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    },
    areaTo: {
        grid: {
            host: 'col-12 col-md-6 order-md-2',
            container: 'form-group row mr-md-1',
            label: 'col-12',
            control: 'col-12'
        }
    }
};
/** @type {?} */
var PARCEL_GROUP_LIST_FILTER_FORM_MODEL = [
    new DynamicInputModel({
        id: 'name',
        minLength: 3,
        maxLength: 60,
        validators: {
            minLength: 3,
            maxLength: 60
        }
    }),
    new DynamicInputModel({
        id: 'areaFrom',
        min: 0.1,
        max: 1000,
        inputType: 'number',
        validators: {
            min: 0.1,
            max: 1000
        }
    }),
    new DynamicInputModel({
        id: 'areaTo',
        min: 0.1,
        max: 1000,
        inputType: 'number',
        validators: {
            min: 0.1,
            max: 1000
        }
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelGroupListFilter = /** @class */ (function () {
    function GroundParcelGroupListFilter(name, areaFrom, areaTo) {
        this.name = name;
        this.areaFrom = areaFrom;
        this.areaTo = areaTo;
    }
    return GroundParcelGroupListFilter;
}());
if (false) {
    /** @type {?} */
    GroundParcelGroupListFilter.prototype.name;
    /** @type {?} */
    GroundParcelGroupListFilter.prototype.areaFrom;
    /** @type {?} */
    GroundParcelGroupListFilter.prototype.areaTo;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupListFilterComponent = /** @class */ (function () {
    function ParcelGroupListFilterComponent() {
        this.search = new EventEmitter();
        this.formLayout = PARCEL_GROUP_LIST_FILTER_FORM_LAYOUT;
        this.formModel = PARCEL_GROUP_LIST_FILTER_FORM_MODEL;
        this.initValue = {};
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    ParcelGroupListFilterComponent.prototype.onSearch = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var listFilter = this.mapFromGroundListFilterForm($event);
        this.search.emit(listFilter);
    };
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    ParcelGroupListFilterComponent.prototype.mapFromGroundListFilterForm = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return new GroundParcelGroupListFilter(data.name, data.areaFrom, data.areaTo);
    };
    ParcelGroupListFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parcel-group-list-filter',
                    template: "<app-search-form\r\n    [formModel]=\"formModel\"\r\n    [formLayout]=\"formLayout\"\r\n    [model]=\"initValue\"\r\n    [translateKey]=\"translationKeyPrefix\"\r\n    (search)=\"onSearch($event)\">\r\n</app-search-form>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    ParcelGroupListFilterComponent.ctorParameters = function () { return []; };
    ParcelGroupListFilterComponent.propDecorators = {
        translationKeyPrefix: [{ type: Input }],
        search: [{ type: Output }]
    };
    return ParcelGroupListFilterComponent;
}());
if (false) {
    /** @type {?} */
    ParcelGroupListFilterComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    ParcelGroupListFilterComponent.prototype.search;
    /** @type {?} */
    ParcelGroupListFilterComponent.prototype.formLayout;
    /** @type {?} */
    ParcelGroupListFilterComponent.prototype.formModel;
    /** @type {?} */
    ParcelGroupListFilterComponent.prototype.initValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupListTableSchema = /** @class */ (function () {
    function ParcelGroupListTableSchema(headerKey, nameKey, areaInHaKey, actionsKey, showOnMapKey, deleteKey, editKey, detailsKey, listEmptyKey, listErrorKey) {
        this.headerKey = headerKey;
        this.nameKey = nameKey;
        this.areaInHaKey = areaInHaKey;
        this.actionsKey = actionsKey;
        this.showOnMapKey = showOnMapKey;
        this.deleteKey = deleteKey;
        this.editKey = editKey;
        this.detailsKey = detailsKey;
        this.listEmptyKey = listEmptyKey;
        this.listErrorKey = listErrorKey;
    }
    return ParcelGroupListTableSchema;
}());
if (false) {
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.headerKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.nameKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.areaInHaKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.actionsKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.showOnMapKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.deleteKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.editKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.detailsKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.listEmptyKey;
    /** @type {?} */
    ParcelGroupListTableSchema.prototype.listErrorKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var GROUND_PARCEL_GROUP_SHARED_SERVICE = new InjectionToken('GroundParcelGroupSharedService');
/**
 * @record
 */
function IGroundParcelGroupSharedService() { }
if (false) {
    /**
     * @param {?} organizationId
     * @return {?}
     */
    IGroundParcelGroupSharedService.prototype.getAll = function (organizationId) { };
    /**
     * @param {?} organizationId
     * @param {?} requestList
     * @return {?}
     */
    IGroundParcelGroupSharedService.prototype.find = function (organizationId, requestList) { };
    /**
     * @param {?} organizationId
     * @param {?} parcelGroupId
     * @return {?}
     */
    IGroundParcelGroupSharedService.prototype.get = function (organizationId, parcelGroupId) { };
    /**
     * @param {?} organizationId
     * @param {?} command
     * @return {?}
     */
    IGroundParcelGroupSharedService.prototype.create = function (organizationId, command) { };
    /**
     * @param {?} organizationId
     * @param {?} parcelGroupId
     * @param {?} command
     * @return {?}
     */
    IGroundParcelGroupSharedService.prototype.update = function (organizationId, parcelGroupId, command) { };
    /**
     * @param {?} organizationId
     * @param {?} parcelGroupId
     * @return {?}
     */
    IGroundParcelGroupSharedService.prototype.delete = function (organizationId, parcelGroupId) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupListTableComponent = /** @class */ (function () {
    function ParcelGroupListTableComponent(groundSharedService) {
        var _this = this;
        this.groundSharedService = groundSharedService;
        this.showOnMap = new EventEmitter();
        this.delete = new EventEmitter();
        this.edit = new EventEmitter();
        this.details = new EventEmitter();
        this.displayedColumns = ['name', 'areaInHa', 'action'];
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} requestList
         * @return {?}
         */
        function (requestList) {
            return _this.groundSharedService.find(_this.organizationId, requestList)
                .pipe(map((/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                return {
                    items: d.items || [],
                    totalCount: d.pager.totalCount
                };
            })));
        }));
    }
    Object.defineProperty(ParcelGroupListTableComponent.prototype, "filter", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.dataSource.setFilter(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ParcelGroupListTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ParcelGroupListTableComponent.prototype.onShowOnMap = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.showOnMap.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ParcelGroupListTableComponent.prototype.onDelete = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.delete.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ParcelGroupListTableComponent.prototype.onEdit = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.edit.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ParcelGroupListTableComponent.prototype.onDetails = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.details.emit(item);
    };
    ParcelGroupListTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parcel-group-list-table',
                    template: "<div class=\"mb-2\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"d-flex flex-column flex-md-row justify-content-md-between card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\">\r\n                    <i class=\"ft ft-list\"></i> {{ schema.headerKey | translate }}\r\n                </h5>\r\n            </label>\r\n            <app-panel-fullscreen-button></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid table-container\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"name\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-7 pr-0\">{{ schema.nameKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-7 pr-0\"> {{ element.name }} </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"areaInHa\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-3 pr-0\">{{ schema.areaInHaKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-3 pr-0\"> {{ element.areaInHa }} </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 text-md-right\">{{ schema.actionsKey | translate | translate }} </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"col-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"sticky-action\">\r\n                                    <div class=\"row no-gutters justify-content-md-end \">\r\n                                        <button (click)=\"onShowOnMap(element)\" title=\"{{ schema.showOnMapKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                            <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                        <button (click)=\"onDelete(element)\"\r\n                                            title=\"{{ schema.deleteKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-danger\">\r\n                                            <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                        <button (click)=\"onEdit(element)\"\r\n                                            title=\"{{ schema.editKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-success\">\r\n                                            <i class=\"ft ft-edit-2\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                        <button (click)=\"onDetails(element)\"\r\n                                            title=\"{{ schema.detailsKey | translate }}\"\r\n                                            class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                            <i class=\"ft ft-info\" aria-hidden=\"true\"></i>\r\n                                        </button>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\"\r\n                            *cdkHeaderRowDef=\"displayedColumns\">\r\n                        </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\"\r\n                            *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listEmptyKey | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ schema.listErrorKey | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                        [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons></cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    ParcelGroupListTableComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_PARCEL_GROUP_SHARED_SERVICE,] }] }
    ]; };
    ParcelGroupListTableComponent.propDecorators = {
        organizationId: [{ type: Input }],
        filter: [{ type: Input }],
        schema: [{ type: Input }],
        showOnMap: [{ type: Output }],
        delete: [{ type: Output }],
        edit: [{ type: Output }],
        details: [{ type: Output }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return ParcelGroupListTableComponent;
}());
if (false) {
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.organizationId;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.schema;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.showOnMap;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.delete;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.edit;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.details;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.sort;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.paginator;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.displayedColumns;
    /** @type {?} */
    ParcelGroupListTableComponent.prototype.dataSource;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupListTableComponent.prototype.groundSharedService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupMapSchema = /** @class */ (function () {
    function ParcelGroupMapSchema(headerKey, areaInHaKey) {
        this.headerKey = headerKey;
        this.areaInHaKey = areaInHaKey;
    }
    return ParcelGroupMapSchema;
}());
if (false) {
    /** @type {?} */
    ParcelGroupMapSchema.prototype.headerKey;
    /** @type {?} */
    ParcelGroupMapSchema.prototype.areaInHaKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupMapComponent = /** @class */ (function () {
    function ParcelGroupMapComponent(mapService, translateService) {
        this.mapService = mapService;
        this.translateService = translateService;
        this.mapReady = false;
        this.polygonConfig = new PolygonConfig(groundDrawingColor, false, false);
    }
    Object.defineProperty(ParcelGroupMapComponent.prototype, "parcelGroups", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.parcelGroupsData = value;
            this.drawParcelGroups();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ParcelGroupMapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.mapService.mapReady.subscribe((/**
         * @return {?}
         */
        function () {
            _this.mapReady = true;
            _this.drawParcelGroups();
        }));
    };
    /**
     * @return {?}
     */
    ParcelGroupMapComponent.prototype.drawParcelGroups = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.mapReady) {
            /** @type {?} */
            var bounds_1 = new google.maps.LatLngBounds();
            this.mapService.clearPolygons();
            flatten(this.parcelGroupsData.map((/**
             * @param {?} ground
             * @return {?}
             */
            function (ground) { return ground.locations.map((/**
             * @param {?} feature
             * @return {?}
             */
            function (feature) {
                /** @type {?} */
                var polygonBounds = new google.maps.LatLngBounds();
                // tslint:disable-next-line: no-string-literal
                /** @type {?} */
                var latLngArray = feature.geometry['coordinates'][0].map((/**
                 * @param {?} cord
                 * @return {?}
                 */
                function (cord) {
                    return new google.maps.LatLng({
                        lat: cord[1],
                        lng: cord[0]
                    });
                }));
                latLngArray.forEach((/**
                 * @param {?} latLng
                 * @return {?}
                 */
                function (latLng) {
                    bounds_1.extend(latLng);
                    polygonBounds.extend(latLng);
                }));
                /** @type {?} */
                var featureProperties = cloneDeep(feature.properties);
                featureProperties.navigate = ['grounds', ground.id];
                return {
                    paths: latLngArray,
                    strokeColor: _this.polygonConfig.drawingColor,
                    fillColor: _this.polygonConfig.drawingColor,
                    properties: featureProperties,
                    bounds: polygonBounds,
                    windowContent: _this.buildPopupContent(ground),
                };
            })); }))).forEach((/**
             * @param {?} polygonConfig
             * @return {?}
             */
            function (polygonConfig) {
                /** @type {?} */
                var infoWindow = new google.maps.InfoWindow({
                    content: polygonConfig.windowContent
                });
                /** @type {?} */
                var polygon = _this.mapService.createPolygon(polygonConfig);
                polygon.addListener('click', (/**
                 * @return {?}
                 */
                function () {
                    infoWindow.setPosition(polygonConfig.bounds.getCenter());
                    infoWindow.open(_this.mapService.map);
                }));
            }));
            if (bounds_1.isEmpty() === false) {
                this.mapService.fitBounds(bounds_1);
            }
        }
    };
    /**
     * @param {?} bounds
     * @return {?}
     */
    ParcelGroupMapComponent.prototype.fitMapToGroundBounds = /**
     * @param {?} bounds
     * @return {?}
     */
    function (bounds) {
        this.mapService.fitBounds(bounds);
    };
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    ParcelGroupMapComponent.prototype.buildPopupContent = /**
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return "<div class=\"row si-modal no-gutters mb-0\">\n                    <div class=\"col-12\"><h6 class=\"font-weight-bold\">" + item.name + "</h6></div>\n                    <div class=\"col-12\">\n                        <div class=\"row no-gutters mb-2\">\n                            <div class=\"col-12 col-md-7 mb-1 mb-md-0\">\n                                <div class=\"d-flex align-items-center mr-1\">\n                                    " + this.translateService.translate(this.schema.areaInHaKey) + "\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-5 mb-0 text-md-right si-modal-data\">\n                                " + item.areaInHa + " ha\n                            </div>\n                        </div>\n                        <div style=\"clear:both\"></div>\n                    </div>\n                </div>";
    };
    ;
    ParcelGroupMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parcel-group-map',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-map\"></i> {{ schema.headerKey | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\"\r\n                class=\"float-right mr-1\"></app-panel-hide-button>\r\n        <hr class=\"my-0\" />\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0 pb-2\" [appPanelHide]=\"false\">\r\n                <app-pure-map></app-pure-map>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    ParcelGroupMapComponent.ctorParameters = function () { return [
        { type: PureMapService },
        { type: TranslateService$1 }
    ]; };
    ParcelGroupMapComponent.propDecorators = {
        parcelGroups: [{ type: Input }],
        schema: [{ type: Input }],
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }]
    };
    return ParcelGroupMapComponent;
}());
if (false) {
    /** @type {?} */
    ParcelGroupMapComponent.prototype.schema;
    /** @type {?} */
    ParcelGroupMapComponent.prototype.panelHide;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupMapComponent.prototype.parcelGroupsData;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupMapComponent.prototype.mapReady;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupMapComponent.prototype.polygonConfig;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupMapComponent.prototype.mapService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupMapComponent.prototype.translateService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelGroupCommand = /** @class */ (function () {
    function GroundParcelGroupCommand(name, parcelIds) {
        this.name = name;
        this.parcelIds = parcelIds;
    }
    return GroundParcelGroupCommand;
}());
if (false) {
    /** @type {?} */
    GroundParcelGroupCommand.prototype.name;
    /** @type {?} */
    GroundParcelGroupCommand.prototype.parcelIds;
}
var CreateGroundParcelGroupCommand = /** @class */ (function (_super) {
    __extends(CreateGroundParcelGroupCommand, _super);
    function CreateGroundParcelGroupCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreateGroundParcelGroupCommand;
}(GroundParcelGroupCommand));
var UpdateGroundParcelGroupCommand = /** @class */ (function (_super) {
    __extends(UpdateGroundParcelGroupCommand, _super);
    function UpdateGroundParcelGroupCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UpdateGroundParcelGroupCommand;
}(GroundParcelGroupCommand));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PARCEL_GROUP_MAP_GROUP_KEY = 'parcelGroupMapGroup';
/** @type {?} */
var PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY = 'parcelGroupBaseInfoGroup';
/** @type {?} */
var PARCEL_GROUP_MAP_KEY = 'parcelGroupMap';
/** @type {?} */
var PARCEL_GROUP_AREA_KEY = 'areaInHa';
/** @type {?} */
var PARCEL_GROUP_PARCELS_KEY = 'parcels';
/** @type {?} */
var PARCEL_GROUP_ADD_FORM_LAYOUT = {
    parcelGroupMapGroup: DEFAULT_FORM_LAYOUT_GROUP,
    parcelGroupBaseInfoGroup: DEFAULT_FORM_LAYOUT_GROUP,
    parcelGroupMap: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'd-none',
            control: 'col-12'
        }
    },
    name: DEFAULT_FORM_LAYOUT_INPUT,
    areaInHa: DEFAULT_FORM_LAYOUT_INPUT,
    parcels: FORM_LAYOUT_SINGLE_LINE_INPUT
};
/** @type {?} */
var PARCEL_GROUP_ADD_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: 'parcelGroupMapGroup',
        group: [
            new DynamicMapControlModel({
                id: 'parcelGroupMap',
                mapConfig: new MapConfig(),
                polygonConfig: new PolygonConfig(groundDrawingColor, false, false, false),
                markerConfig: new MarkerConfig(false)
            })
        ]
    }),
    new DynamicFormGroupModel({
        id: 'parcelGroupBaseInfoGroup',
        group: [
            new DynamicInputModel({
                id: 'name',
                minLength: 3,
                maxLength: 60,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 60
                }
            }),
            new DynamicInputModel({
                id: 'areaInHa',
                min: 0.01,
                max: 1000,
                step: 0.01,
                inputType: 'number',
                readOnly: true,
                validators: {
                    required: null,
                    min: 0.01,
                    max: 1000,
                    decimalNumberValidator: 2
                }
            }),
            new DynamicDualListFormControlModel({
                id: 'parcels',
                bindLabel: nameof('name'),
                translationPrefix: 'testPrefix',
                required: true,
                validators: {
                    required: null
                }
            })
        ]
    })
];
/**
 * @return {?}
 */
function mapToParcelGroupAddForm() {
    return {
        parcelGroupMapGroup: {
            parcelGroupMap: []
        },
        parcelGroupBaseInfoGroup: {
            name: null,
            areaInHa: null,
            parcels: []
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromParcelGroupAddForm(data) {
    return new CreateGroundParcelGroupCommand(data.parcelGroupBaseInfoGroup.name, (data.parcelGroupBaseInfoGroup.parcels || []).map((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.id; })));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelGroup = /** @class */ (function () {
    function GroundParcelGroup(id, name, areaInHa, locations, isOneGround, parcels) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
        this.locations = locations;
        this.isOneGround = isOneGround;
        this.parcels = parcels;
    }
    return GroundParcelGroup;
}());
if (false) {
    /** @type {?} */
    GroundParcelGroup.prototype.id;
    /** @type {?} */
    GroundParcelGroup.prototype.name;
    /** @type {?} */
    GroundParcelGroup.prototype.areaInHa;
    /** @type {?} */
    GroundParcelGroup.prototype.locations;
    /** @type {?} */
    GroundParcelGroup.prototype.isOneGround;
    /** @type {?} */
    GroundParcelGroup.prototype.parcels;
}
var GroundParcelGroupParcel = /** @class */ (function () {
    function GroundParcelGroupParcel(id, name, areaInHa, locations) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
        this.locations = locations;
    }
    return GroundParcelGroupParcel;
}());
if (false) {
    /** @type {?} */
    GroundParcelGroupParcel.prototype.id;
    /** @type {?} */
    GroundParcelGroupParcel.prototype.name;
    /** @type {?} */
    GroundParcelGroupParcel.prototype.areaInHa;
    /** @type {?} */
    GroundParcelGroupParcel.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupAddComponent = /** @class */ (function () {
    function ParcelGroupAddComponent(groundParcelGroupSharedService, groundParcelSharedService, formService, numberUtilService, changeDetectorRef) {
        var _this = this;
        this.groundParcelGroupSharedService = groundParcelGroupSharedService;
        this.groundParcelSharedService = groundParcelSharedService;
        this.formService = formService;
        this.numberUtilService = numberUtilService;
        this.changeDetectorRef = changeDetectorRef;
        this.added = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.refreshFormModel = (/**
         * @return {?}
         */
        function () {
            _this.addForm.refreshFormModel();
        });
        this.formModel = PARCEL_GROUP_ADD_FORM_MODEL;
        this.formLayout = PARCEL_GROUP_ADD_FORM_LAYOUT;
    }
    /**
     * @return {?}
     */
    ParcelGroupAddComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.initValue = mapToParcelGroupAddForm();
        this.displaySpinner$.next(true);
        this.loadDataSubscription = this.groundParcelSharedService.getAllNotAssignedToParcelGroup(this.organizationId)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} parcels
         * @return {?}
         */
        function (parcels) {
            _this.parcelsModel.items = (parcels || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return new GroundParcelGroupParcel(x.id, x.name, x.areaInHa, x.locations); }));
            _this.changeDetectorRef.detectChanges();
            _this.refreshFormModel();
        }));
    };
    /**
     * @return {?}
     */
    ParcelGroupAddComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.parcelsControl.valueChanges
            .subscribe((/**
         * @param {?} parcels
         * @return {?}
         */
        function (parcels) {
            /** @type {?} */
            var totalAreaInHa = _this.numberUtilService.round2(sum((parcels || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.areaInHa; }))));
            _this.areaControl.patchValue(totalAreaInHa);
            /** @type {?} */
            var totalLocations = _this.reduceLocation((parcels || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.locations; })));
            _this.mapControl.patchValue(totalLocations);
        }));
    };
    /**
     * @return {?}
     */
    ParcelGroupAddComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.loadDataSubscription != null) {
            this.loadDataSubscription.unsubscribe();
        }
        if (this.createSubscription != null) {
            this.createSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ParcelGroupAddComponent.prototype.onAdd = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        this.displaySpinner$.next(true);
        if (this.createSubscription != null) {
            this.createSubscription.unsubscribe();
        }
        /** @type {?} */
        var command = mapFromParcelGroupAddForm($event);
        this.createSubscription = this.groundParcelGroupSharedService.create(this.organizationId, command)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            if (id != null) {
                _this.added.emit(true);
            }
        }));
    };
    /**
     * @return {?}
     */
    ParcelGroupAddComponent.prototype.onAfterCancel = /**
     * @return {?}
     */
    function () {
        this.added.emit(false);
    };
    /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    ParcelGroupAddComponent.prototype.reduceLocation = /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    function (locations) {
        if (locations == null || locations.length === 0) {
            return [];
        }
        else {
            return locations.reduce((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.concat(b); }));
        }
    };
    Object.defineProperty(ParcelGroupAddComponent.prototype, "mapControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.addForm.formGroup.get(PARCEL_GROUP_MAP_GROUP_KEY).get(PARCEL_GROUP_MAP_KEY);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParcelGroupAddComponent.prototype, "areaControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.addForm.formGroup.get(PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY).get(PARCEL_GROUP_AREA_KEY);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParcelGroupAddComponent.prototype, "parcelsControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.addForm.formGroup.get(PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY).get(PARCEL_GROUP_PARCELS_KEY);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParcelGroupAddComponent.prototype, "parcelsModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            /** @type {?} */
            var group = this.formService.findModelById(PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY, this.formModel);
            return (/** @type {?} */ (this.formService
                .findModelById(PARCEL_GROUP_PARCELS_KEY, [group])));
        },
        enumerable: true,
        configurable: true
    });
    ParcelGroupAddComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parcel-group-add',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <app-add-form *ngIf=\"formModel\"\r\n        #addForm\r\n        [formModel]=\"formModel\"\r\n        [formLayout]=\"formLayout\"\r\n        [model]=\"initValue\"\r\n        [translateKey]=\"translationKeyPrefix\"\r\n        (add)=\"onAdd($event)\"\r\n        (afterCancel)=\"onAfterCancel()\"\r\n        >\r\n    </app-add-form>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    ParcelGroupAddComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_PARCEL_GROUP_SHARED_SERVICE,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_PARCEL_SHARED_SERVICE,] }] },
        { type: DynamicFormService },
        { type: NumberUtilService },
        { type: ChangeDetectorRef }
    ]; };
    ParcelGroupAddComponent.propDecorators = {
        organizationId: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }],
        added: [{ type: Output }],
        addForm: [{ type: ViewChild, args: ['addForm', { static: false },] }]
    };
    return ParcelGroupAddComponent;
}());
if (false) {
    /** @type {?} */
    ParcelGroupAddComponent.prototype.organizationId;
    /** @type {?} */
    ParcelGroupAddComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    ParcelGroupAddComponent.prototype.added;
    /** @type {?} */
    ParcelGroupAddComponent.prototype.addForm;
    /** @type {?} */
    ParcelGroupAddComponent.prototype.displaySpinner$;
    /** @type {?} */
    ParcelGroupAddComponent.prototype.initValue;
    /** @type {?} */
    ParcelGroupAddComponent.prototype.formLayout;
    /** @type {?} */
    ParcelGroupAddComponent.prototype.formModel;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.loadDataSubscription;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.createSubscription;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.refreshFormModel;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.groundParcelGroupSharedService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.groundParcelSharedService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupAddComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PARCEL_GROUP_MAP_GROUP_KEY$1 = 'parcelGroupMapGroup';
/** @type {?} */
var PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY$1 = 'parcelGroupBaseInfoGroup';
/** @type {?} */
var PARCEL_GROUP_MAP_KEY$1 = 'parcelGroupMap';
/** @type {?} */
var PARCEL_GROUP_AREA_KEY$1 = 'areaInHa';
/** @type {?} */
var PARCEL_GROUP_PARCELS_KEY$1 = 'parcels';
/** @type {?} */
var PARCEL_GROUP_EDIT_FORM_LAYOUT = {
    parcelGroupMapGroup: DEFAULT_FORM_LAYOUT_GROUP,
    parcelGroupBaseInfoGroup: DEFAULT_FORM_LAYOUT_GROUP,
    parcelGroupMap: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'd-none',
            control: 'col-12'
        }
    },
    name: DEFAULT_FORM_LAYOUT_INPUT,
    areaInHa: DEFAULT_FORM_LAYOUT_INPUT,
    parcels: FORM_LAYOUT_SINGLE_LINE_INPUT
};
/** @type {?} */
var PARCEL_GROUP_EDIT_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: 'parcelGroupMapGroup',
        group: [
            new DynamicMapControlModel({
                id: 'parcelGroupMap',
                mapConfig: new MapConfig(),
                polygonConfig: new PolygonConfig(groundDrawingColor, false, false, false),
                markerConfig: new MarkerConfig(false)
            })
        ]
    }),
    new DynamicFormGroupModel({
        id: 'parcelGroupBaseInfoGroup',
        group: [
            new DynamicInputModel({
                id: 'name',
                minLength: 3,
                maxLength: 60,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 60
                }
            }),
            new DynamicInputModel({
                id: 'areaInHa',
                min: 0.01,
                max: 1000,
                step: 0.01,
                inputType: 'number',
                readOnly: true,
                validators: {
                    required: null,
                    min: 0.01,
                    max: 1000,
                    decimalNumberValidator: 2
                }
            }),
            new DynamicDualListFormControlModel({
                id: 'parcels',
                bindLabel: nameof('name'),
                required: true,
                validators: {
                    required: null
                }
            })
        ]
    })
];
/**
 * @param {?} data
 * @return {?}
 */
function mapToParcelGroupEditForm(data) {
    return {
        parcelGroupMapGroup: {
            parcelGroupMap: data.locations
        },
        parcelGroupBaseInfoGroup: {
            name: data.name,
            areaInHa: data.areaInHa,
            parcels: data.parcels
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromParcelGroupEditForm(data) {
    return new UpdateGroundParcelGroupCommand(data.parcelGroupBaseInfoGroup.name, (data.parcelGroupBaseInfoGroup.parcels || []).map((/**
     * @param {?} x
     * @return {?}
     */
    function (x) { return x.id; })));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupEditComponent = /** @class */ (function () {
    function ParcelGroupEditComponent(groundParcelGroupSharedService, groundParcelSharedService, formService, numberUtilService, changeDetectorRef) {
        var _this = this;
        this.groundParcelGroupSharedService = groundParcelGroupSharedService;
        this.groundParcelSharedService = groundParcelSharedService;
        this.formService = formService;
        this.numberUtilService = numberUtilService;
        this.changeDetectorRef = changeDetectorRef;
        this.startFromIsEditing = false;
        this.parcelGroupNameChanged = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.clearItems = (/**
         * @return {?}
         */
        function () {
            _this.parcelsModel.items = [];
        });
        this.addItemsIfNotExists = (/**
         * @param {?} items
         * @return {?}
         */
        function (items) {
            /** @type {?} */
            var newItems = differenceBy(items, _this.parcelsModel.items, (/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id; }));
            _this.parcelsModel.items = _this.parcelsModel.items.concat(newItems).sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.name.localeCompare(b.name); }));
        });
        this.mapControl = (/**
         * @param {?} formGroup
         * @return {?}
         */
        function (formGroup) {
            return formGroup.get(PARCEL_GROUP_MAP_GROUP_KEY$1).get(PARCEL_GROUP_MAP_KEY$1);
        });
        this.areaControl = (/**
         * @param {?} formGroup
         * @return {?}
         */
        function (formGroup) {
            return formGroup.get(PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY$1).get(PARCEL_GROUP_AREA_KEY$1);
        });
        this.parcelsControl = (/**
         * @param {?} formGroup
         * @return {?}
         */
        function (formGroup) {
            return formGroup.get(PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY$1).get(PARCEL_GROUP_PARCELS_KEY$1);
        });
        this.formLayout = PARCEL_GROUP_EDIT_FORM_LAYOUT;
        this.formModel = PARCEL_GROUP_EDIT_FORM_MODEL;
    }
    /**
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.loadDictionarySubscription = this.groundParcelSharedService.getAllNotAssignedToParcelGroup(this.organizationId)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} parcels
         * @return {?}
         */
        function (parcels) {
            /** @type {?} */
            var items = (parcels || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return new GroundParcelGroupParcel(x.id, x.name, x.areaInHa, x.locations); }));
            _this.addItemsIfNotExists(items);
            _this.changeDetectorRef.detectChanges();
            _this.refreshFormModel();
        }));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ((changes.groundId && changes.groundId.currentValue !== changes.groundId.previousValue)
            || (changes.organizationId && changes.organizationId.currentValue !== changes.organizationId.previousValue)) {
            this.clearItems();
            this.loadAndInitValue();
        }
    };
    /**
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.loadDictionarySubscription != null) {
            this.loadDictionarySubscription.unsubscribe();
        }
        if (this.getSubscription != null) {
            this.getSubscription.unsubscribe();
        }
        if (this.updateSubscription != null) {
            this.updateSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.onSave = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        this.displaySpinner$.next(true);
        /** @type {?} */
        var updateCommand = mapFromParcelGroupEditForm($event);
        if (this.updateSubscription != null) {
            this.updateSubscription.unsubscribe();
        }
        this.updateSubscription = this.groundParcelGroupSharedService.update(this.organizationId, this.parcelGroupId, updateCommand)
            .pipe(finalize((/**
         * @return {?}
         */
        function () { _this.displaySpinner$.next(false); })))
            .subscribe((/**
         * @param {?} updated
         * @return {?}
         */
        function (updated) {
            if (updated) {
                _this.initValue = $event;
                _this.parcelGroupNameChanged.emit(updateCommand.name);
                _this.formDetail.saveSuccess();
                _this.changeDetectorRef.detectChanges();
                _this.formDetail.refreshFormModel();
            }
        }));
    };
    /**
     * @param {?} formGroup
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.onFormGroupInitialized = /**
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        this.parcelsControl(formGroup).valueChanges
            .subscribe((/**
         * @param {?} parcels
         * @return {?}
         */
        function (parcels) {
            /** @type {?} */
            var totalAreaInHa = _this.numberUtilService.round2(sum((parcels || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.areaInHa; }))));
            _this.areaControl(formGroup).patchValue(totalAreaInHa);
            /** @type {?} */
            var totalLocations = _this.reduceLocation((parcels || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.locations; })));
            _this.mapControl(formGroup).patchValue(totalLocations);
        }));
    };
    /**
     * @private
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.loadAndInitValue = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.organizationId != null && this.parcelGroupId != null) {
            this.displaySpinner$.next(true);
            if (this.getSubscription != null) {
                this.getSubscription.unsubscribe();
            }
            this.getSubscription = this.groundParcelGroupSharedService.get(this.organizationId, this.parcelGroupId)
                .pipe(finalize((/**
             * @return {?}
             */
            function () { _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} parcelGroup
             * @return {?}
             */
            function (parcelGroup) {
                _this.addItemsIfNotExists(parcelGroup.parcels);
                _this.parcelGroupNameChanged.emit(parcelGroup.name);
                _this.initValue = mapToParcelGroupEditForm(parcelGroup);
                _this.refreshFormModel();
            }));
        }
    };
    /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.reduceLocation = /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    function (locations) {
        if (locations == null || locations.length === 0) {
            return [];
        }
        else {
            return locations.reduce((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.concat(b); }));
        }
    };
    /**
     * @private
     * @return {?}
     */
    ParcelGroupEditComponent.prototype.refreshFormModel = /**
     * @private
     * @return {?}
     */
    function () {
        this.formDetail.refreshFormModel();
    };
    Object.defineProperty(ParcelGroupEditComponent.prototype, "parcelsModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            /** @type {?} */
            var group = this.formService.findModelById(PARCEL_GROUP_BASIC_INFORMATION_GROUP_KEY$1, this.formModel);
            return (/** @type {?} */ (this.formService
                .findModelById(PARCEL_GROUP_PARCELS_KEY$1, [group])));
        },
        enumerable: true,
        configurable: true
    });
    ParcelGroupEditComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parcel-group-edit',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <app-form *ngIf=\"formModel\"\r\n                    #formDetail\r\n                    [startFromIsEditing]=\"startFromIsEditing\"\r\n                    [formModel]=\"formModel\"\r\n                    [formLayout]=\"formLayout\"\r\n                    [model]=\"initValue\"\r\n                    [translateKey]=\"translationKeyPrefix\"\r\n                    (save)=\"onSave($event)\"\r\n                    (formGroupInitialized)=\"onFormGroupInitialized($event)\">\r\n                </app-form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    ParcelGroupEditComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_PARCEL_GROUP_SHARED_SERVICE,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [GROUND_PARCEL_SHARED_SERVICE,] }] },
        { type: DynamicFormService },
        { type: NumberUtilService },
        { type: ChangeDetectorRef }
    ]; };
    ParcelGroupEditComponent.propDecorators = {
        formDetail: [{ type: ViewChild, args: ['formDetail', { static: false },] }],
        organizationId: [{ type: Input }],
        parcelGroupId: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }],
        startFromIsEditing: [{ type: Input }],
        parcelGroupNameChanged: [{ type: Output }]
    };
    return ParcelGroupEditComponent;
}());
if (false) {
    /** @type {?} */
    ParcelGroupEditComponent.prototype.formDetail;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.organizationId;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.parcelGroupId;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.startFromIsEditing;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.parcelGroupNameChanged;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.displaySpinner$;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.formLayout;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.formModel;
    /** @type {?} */
    ParcelGroupEditComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.loadDictionarySubscription;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.getSubscription;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.updateSubscription;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.clearItems;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.addItemsIfNotExists;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.mapControl;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.areaControl;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.parcelsControl;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.groundParcelGroupSharedService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.groundParcelSharedService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.formService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.numberUtilService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupEditComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupCultivationAreaInfoModalComponent = /** @class */ (function () {
    function ParcelGroupCultivationAreaInfoModalComponent(activeModal) {
        this.activeModal = activeModal;
        this.initValue = undefined;
        this.formModel = [
            new DynamicInputModel({
                id: 'name',
                minLength: 3,
                maxLength: 160,
                required: null,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 160
                }
            }),
            new DynamicInputModel({
                id: 'areaInHa',
                readOnly: true
            })
        ];
        this.formLayout = __assign({}, GetDefaultSingleLineLayout(this.formModel));
    }
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initValue = this.selectedPolygonInfo;
    };
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.activeModal.close(false);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.add = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.activeModal.close($event);
    };
    ParcelGroupCultivationAreaInfoModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-cultivation-area-info-modal',
                    template: "<div>\r\n    <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ editCultivationAreaFormHeaderKey | translate }}</h4>\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancel()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <app-add-form #addForm\r\n            *ngIf=\"formModel\"\r\n            [formModel]=\"formModel\"\r\n            [formLayout]=\"formLayout\"\r\n            [model]=\"initValue\"\r\n            [translateKey]=\"editCultivationAreaFormTranslateKey\"\r\n            (add)=\"add($event)\"\r\n            (afterCancel)=\"cancel()\">\r\n        </app-add-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ParcelGroupCultivationAreaInfoModalComponent.ctorParameters = function () { return [
        { type: NgbActiveModal }
    ]; };
    ParcelGroupCultivationAreaInfoModalComponent.propDecorators = {
        editCultivationAreaFormHeaderKey: [{ type: Input }],
        editCultivationAreaFormTranslateKey: [{ type: Input }],
        selectedPolygonInfo: [{ type: Input }]
    };
    return ParcelGroupCultivationAreaInfoModalComponent;
}());
if (false) {
    /** @type {?} */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.editCultivationAreaFormHeaderKey;
    /** @type {?} */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.editCultivationAreaFormTranslateKey;
    /** @type {?} */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.selectedPolygonInfo;
    /** @type {?} */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.formLayout;
    /** @type {?} */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.formModel;
    /** @type {?} */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupCultivationAreaInfoModalComponent.prototype.activeModal;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupCultivationArea = /** @class */ (function () {
    function ParcelGroupCultivationArea(id, name, areaInHa, locations) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
        this.locations = locations;
    }
    return ParcelGroupCultivationArea;
}());
if (false) {
    /** @type {?} */
    ParcelGroupCultivationArea.prototype.id;
    /** @type {?} */
    ParcelGroupCultivationArea.prototype.name;
    /** @type {?} */
    ParcelGroupCultivationArea.prototype.areaInHa;
    /** @type {?} */
    ParcelGroupCultivationArea.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupCultivationAreaCommand = /** @class */ (function () {
    function ParcelGroupCultivationAreaCommand(id, name, areaInHa, locations) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
        this.locations = locations;
    }
    return ParcelGroupCultivationAreaCommand;
}());
if (false) {
    /** @type {?} */
    ParcelGroupCultivationAreaCommand.prototype.id;
    /** @type {?} */
    ParcelGroupCultivationAreaCommand.prototype.name;
    /** @type {?} */
    ParcelGroupCultivationAreaCommand.prototype.areaInHa;
    /** @type {?} */
    ParcelGroupCultivationAreaCommand.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationAreaShapesOptions = /** @class */ (function () {
    function CultivationAreaShapesOptions() {
    }
    CultivationAreaShapesOptions.UNSELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ffff00',
        fillColor: '#ffff00'
    };
    CultivationAreaShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS = {
        strokeColor: '#000080',
        fillColor: '#000080'
    };
    CultivationAreaShapesOptions.SELECTED_POLYGON_OPTIONS = {
        strokeColor: '#ff0000',
        fillColor: '#ff0000'
    };
    CultivationAreaShapesOptions.POLYLINE_OPTIONS = {
        strokeColor: '#ff0000'
    };
    return CultivationAreaShapesOptions;
}());
if (false) {
    /** @type {?} */
    CultivationAreaShapesOptions.UNSELECTED_POLYGON_OPTIONS;
    /** @type {?} */
    CultivationAreaShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS;
    /** @type {?} */
    CultivationAreaShapesOptions.SELECTED_POLYGON_OPTIONS;
    /** @type {?} */
    CultivationAreaShapesOptions.POLYLINE_OPTIONS;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SelectedPolygonInfo$1() { }
if (false) {
    /** @type {?} */
    SelectedPolygonInfo$1.prototype.isSelected;
    /** @type {?} */
    SelectedPolygonInfo$1.prototype.name;
    /** @type {?} */
    SelectedPolygonInfo$1.prototype.areaInHa;
}
/** @type {?} */
var EMPTY_SELECTED_POLYGON_INFO$1 = {
    name: null,
    areaInHa: 0,
    isSelected: false
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationAreaPolygonsService = /** @class */ (function () {
    function CultivationAreaPolygonsService(mapService, pureMapService, polygonSplitService, decimalPipe) {
        this.mapService = mapService;
        this.pureMapService = pureMapService;
        this.polygonSplitService = polygonSplitService;
        this.decimalPipe = decimalPipe;
        this.polygons = [];
        this.polygonSelected = new Subject();
        this.polygonsDataSource = new Subject();
        this.splitingToolEnabled = false;
        this.drawingManagerPolygon = null;
        this.isDrawCompleted = new BehaviorSubject(false);
        this.mapReady = this.pureMapService.mapReady;
    }
    /**
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.polygons = [];
    };
    /**
     * @param {?} cultivationAreas
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.drawCultivationAreas = /**
     * @param {?} cultivationAreas
     * @return {?}
     */
    function (cultivationAreas) {
        var _this = this;
        cultivationAreas.forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) {
            _this.mapService.getPolygonsLatLngLiteralsFromFeatures(p.locations)
                .forEach((/**
             * @param {?} latLng
             * @return {?}
             */
            function (latLng) { return _this.createPolygon(latLng, p); }));
        }));
        /** @type {?} */
        var bounds = new google.maps.LatLngBounds();
        this.polygons.forEach((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) { return polygon.getPath().forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return bounds.extend(p); })); }));
        this.pureMapService.fitBounds(bounds);
        this.refreshDataSource();
    };
    /**
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.startSplitingPolygon = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.splitingToolEnabled = true;
        /** @type {?} */
        var drawingManager = this.pureMapService.createDrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: false,
            polygonOptions: {
                fillColor: '#ffff00',
                fillOpacity: 0.5,
                strokeWeight: 2,
                strokeColor: '#ffffff'
            }
        });
        drawingManager.addListener('overlaycomplete', (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.drawingManagerPolygon = (/** @type {?} */ (event.overlay));
            drawingManager.setMap(null);
            _this.drawingManagerPolygon.setEditable(true);
            _this.isDrawCompleted.next(true);
        }));
    };
    /**
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.submitSplitingPolygon = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.drawingManagerPolygon) {
            /** @type {?} */
            var newPolygonsLatLng = this.polygonSplitService
                .intersectPolygons(this.getSelectedPolygon(), this.drawingManagerPolygon);
            this.removePolygon(this.getSelectedPolygon());
            newPolygonsLatLng.forEach((/**
             * @param {?} latLng
             * @return {?}
             */
            function (latLng) { return _this.createPolygon(latLng); }));
            this.splitingToolEnabled = false;
            this.drawingManagerPolygon.setMap(null);
            this.drawingManagerPolygon = null;
            this.refreshDataSource();
            this.isDrawCompleted.next(false);
        }
    };
    /**
     * @param {?} polygonInfo
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.setPolygonName = /**
     * @param {?} polygonInfo
     * @return {?}
     */
    function (polygonInfo) {
        /** @type {?} */
        var selectedPolygon = this.getSelectedPolygon();
        selectedPolygon.set('name', polygonInfo.name);
        this.refreshDataSource();
    };
    /**
     * @param {?} id
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.selectPolygonOnMap = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        /** @type {?} */
        var polygon = this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.get('id') === id; }))[0];
        this.unselectAllPolygonsExcept(polygon);
        polygon.set('selected', true);
    };
    /**
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.buildCreateGroundParcelCommand = /**
     * @return {?}
     */
    function () {
        return this.polygons.map((/**
         * @param {?} polygon
         * @return {?}
         */
        function (polygon) {
            /** @type {?} */
            var coordinates = polygon.getPaths().getArray().map((/**
             * @param {?} path
             * @return {?}
             */
            function (path) { return path.getArray().map((/**
             * @param {?} latLng
             * @return {?}
             */
            function (latLng) { return [latLng.lng(), latLng.lat()]; })); }));
            /** @type {?} */
            var locations = [{
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: coordinates,
                    },
                    properties: {
                        area: polygon.get('areaInHa'),
                        fillColor: parcelDrawingColor,
                        strokeColor: parcelDrawingColor,
                        name: polygon.get('name')
                    },
                }];
            return new ParcelGroupCultivationAreaCommand(polygon.get('id'), polygon.get('name'), polygon.get('areaInHa'), locations);
        }));
    };
    /**
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.removeParcels = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.polygons.forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return _this.removePolygon(p); }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.setPolygonListeners = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        var _this = this;
        polygon.addListener('selected_changed', (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var isPolygonSelected = (/** @type {?} */ (polygon.get('selected')));
            /** @type {?} */
            var polygonName = polygon.get('name');
            /** @type {?} */
            var polygonArea = polygon.get('areaInHa');
            _this.polygonSelected.next((/** @type {?} */ ({
                isSelected: isPolygonSelected,
                areaInHa: polygonArea,
                name: polygonName
            })));
            /** @type {?} */
            var polygonOptions = isPolygonSelected
                ? CultivationAreaShapesOptions.SELECTED_POLYGON_OPTIONS
                : (polygonName != null
                    ? CultivationAreaShapesOptions.UNSELECTED_POLYGON_PARCEL_OPTIONS
                    : CultivationAreaShapesOptions.UNSELECTED_POLYGON_OPTIONS);
            polygon.setOptions(polygonOptions);
        }));
        polygon.addListener('click', (/**
         * @return {?}
         */
        function () {
            _this.unselectAllPolygonsExcept(polygon);
            /** @type {?} */
            var value = polygon.get('selected');
            polygon.set('selected', !value);
        }));
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.removePolygon = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        polygon.setMap(null);
        google.maps.event.clearInstanceListeners(polygon);
        this.polygons = this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p !== polygon; }));
        this.polygonSelected.next(EMPTY_SELECTED_POLYGON_INFO$1);
    };
    /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.calculatePolygonArea = /**
     * @private
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        /** @type {?} */
        var meterToHa = 10000;
        /** @type {?} */
        var areaValue = google.maps.geometry.spherical.computeArea(paths) / meterToHa;
        /** @type {?} */
        var digitsInfo = '1.2-2';
        /** @type {?} */
        var locale = 'en-US';
        /** @type {?} */
        var twoDecimalPointArea = this.decimalPipe.transform(areaValue, digitsInfo, locale);
        return Number(twoDecimalPointArea);
    };
    /**
     * @private
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.getSelectedPolygon = /**
     * @private
     * @return {?}
     */
    function () {
        return this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return (/** @type {?} */ (p.get('selected'))) === true; }))[0];
    };
    /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.unselectAllPolygonsExcept = /**
     * @private
     * @param {?} polygon
     * @return {?}
     */
    function (polygon) {
        /** @type {?} */
        var polygonsToBeUnselected = this.polygons.filter((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p !== polygon; }));
        polygonsToBeUnselected.forEach((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.set('selected', false); }));
    };
    /**
     * @private
     * @param {?} latLng
     * @param {?=} cultivationArea
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.createPolygon = /**
     * @private
     * @param {?} latLng
     * @param {?=} cultivationArea
     * @return {?}
     */
    function (latLng, cultivationArea) {
        /** @type {?} */
        var polygon = this.pureMapService.createPolygon(__assign({ paths: latLng }, CultivationAreaShapesOptions.UNSELECTED_POLYGON_OPTIONS));
        this.setPolygonListeners(polygon);
        if (cultivationArea) {
            polygon.set('areaInHa', cultivationArea.areaInHa);
            polygon.set('name', cultivationArea.name);
        }
        else {
            /** @type {?} */
            var polygonArea = this.calculatePolygonArea(polygon.getPath());
            polygon.set('areaInHa', polygonArea);
        }
        polygon.set('id', v4());
        polygon.set('selected', false);
        this.polygons.push(polygon);
    };
    /**
     * @private
     * @return {?}
     */
    CultivationAreaPolygonsService.prototype.refreshDataSource = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var polygons = this.polygons.map((/**
         * @param {?} p
         * @return {?}
         */
        function (p) {
            return new ParcelGroupCultivationArea(p.get('id'), p.get('name'), p.get('areaInHa'), []);
        }));
        this.polygonsDataSource.next(polygons);
    };
    CultivationAreaPolygonsService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CultivationAreaPolygonsService.ctorParameters = function () { return [
        { type: MapService },
        { type: PureMapService },
        { type: PolygonSplitService },
        { type: DecimalPipe }
    ]; };
    return CultivationAreaPolygonsService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CultivationAreaPolygonsService.prototype.polygons;
    /** @type {?} */
    CultivationAreaPolygonsService.prototype.polygonSelected;
    /** @type {?} */
    CultivationAreaPolygonsService.prototype.polygonsDataSource;
    /** @type {?} */
    CultivationAreaPolygonsService.prototype.mapReady;
    /** @type {?} */
    CultivationAreaPolygonsService.prototype.splitingToolEnabled;
    /** @type {?} */
    CultivationAreaPolygonsService.prototype.drawingManagerPolygon;
    /** @type {?} */
    CultivationAreaPolygonsService.prototype.isDrawCompleted;
    /**
     * @type {?}
     * @private
     */
    CultivationAreaPolygonsService.prototype.mapService;
    /**
     * @type {?}
     * @private
     */
    CultivationAreaPolygonsService.prototype.pureMapService;
    /**
     * @type {?}
     * @private
     */
    CultivationAreaPolygonsService.prototype.polygonSplitService;
    /**
     * @type {?}
     * @private
     */
    CultivationAreaPolygonsService.prototype.decimalPipe;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PARCEL_GROUP_CULTIVATION_AREA_SHARED_SERVICE = new InjectionToken('ParcelGroupCultivationAreaSharedService');
/**
 * @record
 */
function IParcelGroupCultivationAreaSharedService() { }
if (false) {
    /**
     * @param {?} organizationId
     * @param {?} parcelGroupId
     * @return {?}
     */
    IParcelGroupCultivationAreaSharedService.prototype.getAllByParcelGroupId = function (organizationId, parcelGroupId) { };
    /**
     * @param {?} organizationId
     * @param {?} parcelGroupId
     * @param {?} commands
     * @return {?}
     */
    IParcelGroupCultivationAreaSharedService.prototype.saveAll = function (organizationId, parcelGroupId, commands) { };
    /**
     * @param {?} organizationId
     * @param {?} parcelGroupId
     * @return {?}
     */
    IParcelGroupCultivationAreaSharedService.prototype.delateAll = function (organizationId, parcelGroupId) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupCultivationAreasSchema = /** @class */ (function () {
    function ParcelGroupCultivationAreasSchema(mapHeaderKey, cultivationAreasDeleteButtonKey, cultivationAreasDeleteConfirmTitleKey, cultivationAreasDeleteConfirmMessageKey, cultivationAreasSaveButtonKey, cultivationAreasSaveConfirmTitleKey, cultivationAreasSaveConfirmMessageKey, splitCultivationAreaButtonKey, infoCultivationAreaButtonKey, confirmSplittingCultivationAreaKey, cultivationAreaNameMissingWarningKey, cultivationAreaStartingSplitInfoKey, cultivationAreaDrawingSplitInfoKey, cultivationAreaEndingSplitInfoKey, listHeaderKey, cultivationAreaNameKey, cultivationAreaAreaInHaKey, actionsKey, showOnMapButtonKey, editCultivationAreaButtonKey, editCultivationAreaFormHeaderKey, editCultivationAreaFormTranslateKey) {
        this.mapHeaderKey = mapHeaderKey;
        this.cultivationAreasDeleteButtonKey = cultivationAreasDeleteButtonKey;
        this.cultivationAreasDeleteConfirmTitleKey = cultivationAreasDeleteConfirmTitleKey;
        this.cultivationAreasDeleteConfirmMessageKey = cultivationAreasDeleteConfirmMessageKey;
        this.cultivationAreasSaveButtonKey = cultivationAreasSaveButtonKey;
        this.cultivationAreasSaveConfirmTitleKey = cultivationAreasSaveConfirmTitleKey;
        this.cultivationAreasSaveConfirmMessageKey = cultivationAreasSaveConfirmMessageKey;
        this.splitCultivationAreaButtonKey = splitCultivationAreaButtonKey;
        this.infoCultivationAreaButtonKey = infoCultivationAreaButtonKey;
        this.confirmSplittingCultivationAreaKey = confirmSplittingCultivationAreaKey;
        this.cultivationAreaNameMissingWarningKey = cultivationAreaNameMissingWarningKey;
        this.cultivationAreaStartingSplitInfoKey = cultivationAreaStartingSplitInfoKey;
        this.cultivationAreaDrawingSplitInfoKey = cultivationAreaDrawingSplitInfoKey;
        this.cultivationAreaEndingSplitInfoKey = cultivationAreaEndingSplitInfoKey;
        this.listHeaderKey = listHeaderKey;
        this.cultivationAreaNameKey = cultivationAreaNameKey;
        this.cultivationAreaAreaInHaKey = cultivationAreaAreaInHaKey;
        this.actionsKey = actionsKey;
        this.showOnMapButtonKey = showOnMapButtonKey;
        this.editCultivationAreaButtonKey = editCultivationAreaButtonKey;
        this.editCultivationAreaFormHeaderKey = editCultivationAreaFormHeaderKey;
        this.editCultivationAreaFormTranslateKey = editCultivationAreaFormTranslateKey;
    }
    return ParcelGroupCultivationAreasSchema;
}());
if (false) {
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.mapHeaderKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreasDeleteButtonKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreasDeleteConfirmTitleKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreasDeleteConfirmMessageKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreasSaveButtonKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreasSaveConfirmTitleKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreasSaveConfirmMessageKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.splitCultivationAreaButtonKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.infoCultivationAreaButtonKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.confirmSplittingCultivationAreaKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreaNameMissingWarningKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreaStartingSplitInfoKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreaDrawingSplitInfoKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreaEndingSplitInfoKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.listHeaderKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreaNameKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.cultivationAreaAreaInHaKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.actionsKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.showOnMapButtonKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.editCultivationAreaButtonKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.editCultivationAreaFormHeaderKey;
    /** @type {?} */
    ParcelGroupCultivationAreasSchema.prototype.editCultivationAreaFormTranslateKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationAreaDataSource = /** @class */ (function (_super) {
    __extends(CultivationAreaDataSource, _super);
    function CultivationAreaDataSource(polygonsData) {
        var _this = _super.call(this) || this;
        _this.polygonsData = polygonsData;
        return _this;
    }
    /**
     * @return {?}
     */
    CultivationAreaDataSource.prototype.connect = /**
     * @return {?}
     */
    function () {
        return this.polygonsData;
    };
    /**
     * @return {?}
     */
    CultivationAreaDataSource.prototype.disconnect = /**
     * @return {?}
     */
    function () { };
    return CultivationAreaDataSource;
}(DataSource));
if (false) {
    /**
     * @type {?}
     * @private
     */
    CultivationAreaDataSource.prototype.polygonsData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParcelGroupCultivationAreaComponent = /** @class */ (function () {
    function ParcelGroupCultivationAreaComponent(cultivationAreaSharedService, cultivationAreaPolygonsService, changeDetectorRef, modalService, confirmationModalService, notificationService) {
        this.cultivationAreaSharedService = cultivationAreaSharedService;
        this.cultivationAreaPolygonsService = cultivationAreaPolygonsService;
        this.changeDetectorRef = changeDetectorRef;
        this.modalService = modalService;
        this.confirmationModalService = confirmationModalService;
        this.notificationService = notificationService;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.dataSource = new CultivationAreaDataSource(this.cultivationAreaPolygonsService.polygonsDataSource);
        this.displayedColumns = ['name', 'areaInHa', 'action'];
    }
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.mapReadySubscription = this.cultivationAreaPolygonsService.mapReady.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cultivationAreaSharedService.getAllByParcelGroupId(_this.organizationId, _this.parcelGroupId)
                .pipe(finalize((/**
             * @return {?}
             */
            function () { return _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} cultivationAreas
             * @return {?}
             */
            function (cultivationAreas) { return _this.cultivationAreaPolygonsService.drawCultivationAreas(cultivationAreas); }));
        }));
        this.cultivationAreaPolygonsService.polygonSelected.subscribe((/**
         * @param {?} polygonInfo
         * @return {?}
         */
        function (polygonInfo) {
            _this.isPolygonSelected = polygonInfo.isSelected;
            _this.selectedPolygonInfo = polygonInfo;
            _this.changeDetectorRef.markForCheck();
        }));
        this.allCultivationAreasHaveName$ = this.dataSource.connect().pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.every((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.name !== undefined; })); })));
        this.isDrawCompleted$ = this.cultivationAreaPolygonsService.isDrawCompleted;
    };
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.mapReadySubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.startSplitGround = /**
     * @return {?}
     */
    function () {
        this.cultivationAreaPolygonsService.startSplitingPolygon();
    };
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.submitSplitGround = /**
     * @return {?}
     */
    function () {
        this.cultivationAreaPolygonsService.submitSplitingPolygon();
    };
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.openPolygonInfoModal = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var cultivationAreaModal = this.modalService.open(ParcelGroupCultivationAreaInfoModalComponent, { windowClass: 'right', beforeDismiss: (/**
             * @return {?}
             */
            function () { return false; }) });
        cultivationAreaModal.componentInstance.editCultivationAreaFormHeaderKey = this.schema.editCultivationAreaFormHeaderKey;
        cultivationAreaModal.componentInstance.editCultivationAreaFormTranslateKey = this.schema.editCultivationAreaFormTranslateKey;
        cultivationAreaModal.componentInstance.selectedPolygonInfo = this.selectedPolygonInfo;
        cultivationAreaModal.result.then((/**
         * @param {?} polygonInfo
         * @return {?}
         */
        function (polygonInfo) {
            if (polygonInfo) {
                _this.cultivationAreaPolygonsService.setPolygonName(polygonInfo);
            }
        }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.showCultivationAreaOnMapClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.cultivationAreaPolygonsService.selectPolygonOnMap(item.id);
    };
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.saveCultivationAreas = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.confirmationModalService.open(this.schema.cultivationAreasSaveConfirmTitleKey, this.schema.cultivationAreasSaveConfirmMessageKey, null)
            .then((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(true);
            /** @type {?} */
            var command = _this.cultivationAreaPolygonsService.buildCreateGroundParcelCommand();
            if (command.filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.name === undefined || x.name === null; })).length > 0) {
                _this.notificationService.error(null, _this.schema.cultivationAreaNameMissingWarningKey);
                _this.displaySpinner$.next(false);
            }
            else {
                _this.cultivationAreaSharedService.saveAll(_this.organizationId, _this.parcelGroupId, command)
                    .pipe(finalize((/**
                 * @return {?}
                 */
                function () { return _this.displaySpinner$.next(false); })))
                    .subscribe();
            }
        }), (/**
         * @return {?}
         */
        function () { }));
    };
    /**
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.removeCultivationAreas = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.confirmationModalService.open(this.schema.cultivationAreasDeleteConfirmTitleKey, this.schema.cultivationAreasDeleteConfirmMessageKey, null)
            .then((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(true);
            _this.cultivationAreaSharedService
                .delateAll(_this.organizationId, _this.parcelGroupId)
                // tslint:disable-next-line: max-line-length
                .pipe(switchMap((/**
             * @param {?} _
             * @return {?}
             */
            function (_) { return _this.cultivationAreaSharedService.getAllByParcelGroupId(_this.organizationId, _this.parcelGroupId); })))
                .pipe(finalize((/**
             * @return {?}
             */
            function () { return _this.displaySpinner$.next(false); })))
                .subscribe((/**
             * @param {?} parcels
             * @return {?}
             */
            function (parcels) {
                _this.cultivationAreaPolygonsService.removeParcels();
                _this.cultivationAreaPolygonsService.drawCultivationAreas(parcels);
            }));
        }), (/**
         * @return {?}
         */
        function () { }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ParcelGroupCultivationAreaComponent.prototype.openCultivationAreaInfoModal = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.cultivationAreaPolygonsService.selectPolygonOnMap(item.id);
        this.openPolygonInfoModal();
    };
    Object.defineProperty(ParcelGroupCultivationAreaComponent.prototype, "splitingToolEnabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this.cultivationAreaPolygonsService.splitingToolEnabled;
        },
        enumerable: true,
        configurable: true
    });
    ParcelGroupCultivationAreaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parcel-group-cultivation-areas',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body pt-0\">\r\n                <div class=\"container-fluid px-0\">\r\n                    <div class=\"d-flex\">\r\n                        <div class=\"ml-auto mt-2\">\r\n                            <a class=\"btn btn-raised mr-1 btn-danger\" (click)=\"removeCultivationAreas()\">\r\n                                <i class=\"ft-save mr-1\"></i> {{ schema.cultivationAreasDeleteButtonKey | translate }}\r\n                            </a>\r\n                            <a class=\"btn btn-raised mr-1 btn-primary\" (click)=\"saveCultivationAreas()\"\r\n                                [class.disabled]=\"!(allCultivationAreasHaveName$ | async)\">\r\n                                <i class=\"ft-save mr-1\"></i> {{ schema.cultivationAreasSaveButtonKey | translate }}\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                    <form class=\"form-horizontal ng-dynamic-form\">\r\n                        <label class=\"col-12 px-0\">\r\n                            <h5 class=\"m-0\"><i class=\"ft ft-home\"></i> {{ schema.mapHeaderKey | translate }}</h5>\r\n                            <hr class=\"mt-1\">\r\n                        </label>\r\n                    </form>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12\">\r\n                            <div class=\"float-left\">\r\n                                <a class=\"btn btn-raised mr-1\" (click)=\"startSplitGround()\" [class.disabled]=\"!isPolygonSelected\"\r\n                                    [class.btn-outline-warning]=\"!splitingToolEnabled\" [class.btn-warning]=\"splitingToolEnabled\">\r\n                                    <i class=\"ft-edit-2 mr-1\"></i> {{ schema.splitCultivationAreaButtonKey | translate }}\r\n                                </a>\r\n                                <a class=\"btn btn-raised mr-1 btn-warning\" (click)=\"openPolygonInfoModal()\"\r\n                                    [class.disabled]=\"!isPolygonSelected\">\r\n                                    <i class=\"ft-info mr-1\"></i> {{ schema.infoCultivationAreaButtonKey | translate }}\r\n                                </a>\r\n                                <a class=\"btn btn-raised mr-1 btn-success\" (click)=\"submitSplitGround()\" *ngIf=\"splitingToolEnabled\"\r\n                                    [class.disabled]=\"!(isDrawCompleted$ | async)\">\r\n                                    <i class=\"ft-save mr-1\"></i> {{ schema.confirmSplittingCultivationAreaKey | translate }}\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12\">\r\n                            <div class=\"alert alert-warning\" *ngIf=\"!(allCultivationAreasHaveName$ | async)\">\r\n                                {{ schema.cultivationAreaNameMissingWarningKey | translate }}\r\n                            </div>\r\n                            <div class=\"alert alert-info\" *ngIf=\"!splitingToolEnabled\">\r\n                                {{ schema.cultivationAreaStartingSplitInfoKey | translate }}\r\n                            </div>\r\n                            <div class=\"alert alert-info\" *ngIf=\"splitingToolEnabled && !(isDrawCompleted$ | async)\">\r\n                                {{ schema.cultivationAreaDrawingSplitInfoKey | translate }} </div>\r\n                            <div class=\"alert alert-info\" *ngIf=\"isDrawCompleted$ | async\">\r\n                                {{ schema.cultivationAreaEndingSplitInfoKey | translate }} </div>\r\n                        </div>\r\n                        <div class=\"col-12\">\r\n                            <app-pure-map [height]=\"420\"></app-pure-map>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card\">\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <form class=\"form-horizontal ng-dynamic-form\">\r\n                    <label class=\"col-12 px-0\">\r\n                        <h5 class=\"m-0\"><i class=\"ft ft-map-pin\"></i> {{ schema.listHeaderKey | translate }}</h5>\r\n                        <hr class=\"mt-1\">\r\n                    </label>\r\n                </form>\r\n                <div class=\"container-fluid\">\r\n                    <cdk-table [dataSource]=\"dataSource\">\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-9 col-md-5 col-lg-5 pr-0\">\r\n                                {{ schema.cultivationAreaNameKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-9 col-md-5 col-lg-5 pr-0\">\r\n                                {{ parcelGroupName }} {{ element.name ? ' - ' + element.name : '' }}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"areaInHa\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-md-4 col-lg-5 d-none d-md-block pr-0\">\r\n                                {{ schema.cultivationAreaAreaInHaKey | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-md-4 col-lg-5 d-none d-md-block pr-0\">\r\n                                {{ element.areaInHa }}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-3 col-md-3 col-lg-2 text-md-right\">\r\n                                {{ schema.actionsKey | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-3 col-md-3 col-lg-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-md-end\">\r\n                                    <button (click)=\"showCultivationAreaOnMapClick(element)\" title=\"{{ schema.showOnMapButtonKey | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button (click)=\"openCultivationAreaInfoModal(element)\" title=\"{{ schema.editCultivationAreaButtonKey | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-success\">\r\n                                        <i class=\"ft ft-edit-2\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\" *cdkHeaderRowDef=\"displayedColumns\"></cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\" *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [CultivationAreaPolygonsService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ParcelGroupCultivationAreaComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [PARCEL_GROUP_CULTIVATION_AREA_SHARED_SERVICE,] }] },
        { type: CultivationAreaPolygonsService },
        { type: ChangeDetectorRef },
        { type: NgbModal },
        { type: ConfirmationModalService },
        { type: NotificationService }
    ]; };
    ParcelGroupCultivationAreaComponent.propDecorators = {
        organizationId: [{ type: Input }],
        parcelGroupId: [{ type: Input }],
        parcelGroupName: [{ type: Input }],
        schema: [{ type: Input }]
    };
    return ParcelGroupCultivationAreaComponent;
}());
if (false) {
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.organizationId;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.parcelGroupId;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.parcelGroupName;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.schema;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.isPolygonSelected;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.selectedPolygonInfo;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.displayedColumns;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.dataSource;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.displaySpinner$;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.mapReadySubscription;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.isDrawCompleted$;
    /** @type {?} */
    ParcelGroupCultivationAreaComponent.prototype.allCultivationAreasHaveName$;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupCultivationAreaComponent.prototype.cultivationAreaSharedService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupCultivationAreaComponent.prototype.cultivationAreaPolygonsService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupCultivationAreaComponent.prototype.changeDetectorRef;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupCultivationAreaComponent.prototype.modalService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupCultivationAreaComponent.prototype.confirmationModalService;
    /**
     * @type {?}
     * @private
     */
    ParcelGroupCultivationAreaComponent.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundSharedModule = /** @class */ (function () {
    function GroundSharedModule() {
    }
    GroundSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        GroundAddComponent,
                        GroundListFilterComponent,
                        GroundListTableComponent,
                        GroundMapComponent,
                        GroundImportComponent,
                        GroundImportSelectGeojsonFileComponent,
                        GroundImportSelectKmlFileComponent,
                        GroundImportSelectShpFileComponent,
                        GroundEditComponent,
                        GroundScansComponent,
                        GroundScansMapComponent,
                        GroundSoilSpecimensComponent,
                        GroundSoilSpecimensMapComponent,
                        GroundSoilSpecimensImportComponent,
                        GroundScansImportComponent,
                        GroundParcelsComponent,
                        GroundParcelInfoModalComponent,
                        GroundCustomMapsComponent,
                        ParcelGroupListFilterComponent,
                        ParcelGroupListTableComponent,
                        ParcelGroupMapComponent,
                        ParcelGroupAddComponent,
                        ParcelGroupEditComponent,
                        ParcelGroupCultivationAreaInfoModalComponent,
                        ParcelGroupCultivationAreaComponent
                    ],
                    entryComponents: [
                        GroundImportSelectGeojsonFileComponent,
                        GroundImportSelectKmlFileComponent,
                        GroundImportSelectShpFileComponent,
                        GroundParcelInfoModalComponent,
                        ParcelGroupCultivationAreaInfoModalComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        TranslateModule,
                        NgbModule,
                        ChartsModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule,
                        FormSharedModule,
                        TableSharedModule,
                        ModalSharedModule,
                        GoogleMapsSharedModule,
                        PureGoogleMapsSharedModule,
                        GroundServicesModule
                    ],
                    exports: [
                        GroundAddComponent,
                        GroundListFilterComponent,
                        GroundListTableComponent,
                        GroundMapComponent,
                        GroundImportComponent,
                        GroundEditComponent,
                        GroundScansComponent,
                        GroundSoilSpecimensComponent,
                        GroundSoilSpecimensImportComponent,
                        GroundScansImportComponent,
                        GroundParcelsComponent,
                        GroundCustomMapsComponent,
                        ParcelGroupListFilterComponent,
                        ParcelGroupListTableComponent,
                        ParcelGroupMapComponent,
                        ParcelGroupAddComponent,
                        ParcelGroupEditComponent,
                        ParcelGroupCultivationAreaComponent
                    ],
                    providers: [DecimalPipe, MapService]
                },] }
    ];
    return GroundSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundScansSchema = /** @class */ (function () {
    function GroundScansSchema(sansLayerCounturKey, scansFilterLayerScanKey) {
        this.sansLayerCounturKey = sansLayerCounturKey;
        this.scansFilterLayerScanKey = scansFilterLayerScanKey;
    }
    return GroundScansSchema;
}());
if (false) {
    /** @type {?} */
    GroundScansSchema.prototype.sansLayerCounturKey;
    /** @type {?} */
    GroundScansSchema.prototype.scansFilterLayerScanKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundSoilSpecimensSchema = /** @class */ (function () {
    function GroundSoilSpecimensSchema(soilSpecimensFilterLayerCounturKey, soilSpecimensFilterLayerNetKey, soilSpecimensFilterLayerAgronomicKey, soilSpecimensFilterLayerPhKey, soilSpecimensFilterLayerPhosphorusKey, soilSpecimensFilterLayerPotassiumKey, soilSpecimensFilterLayerMagnesiumKey, soilSpecimensFilterLayerManganeseKey, soilSpecimensFilterLayerZincKey, soilSpecimensFilterLayerCopperKey, soilSpecimensFilterLayerIronKey, soilSpecimensFilterLayerBoronKey, soilSpecimensFilterLayerCalciumKey, soilSpecimensFilterLayerOrganicCarbonKey, soilSpecimensFilterLayerHumusKey) {
        this.soilSpecimensFilterLayerCounturKey = soilSpecimensFilterLayerCounturKey;
        this.soilSpecimensFilterLayerNetKey = soilSpecimensFilterLayerNetKey;
        this.soilSpecimensFilterLayerAgronomicKey = soilSpecimensFilterLayerAgronomicKey;
        this.soilSpecimensFilterLayerPhKey = soilSpecimensFilterLayerPhKey;
        this.soilSpecimensFilterLayerPhosphorusKey = soilSpecimensFilterLayerPhosphorusKey;
        this.soilSpecimensFilterLayerPotassiumKey = soilSpecimensFilterLayerPotassiumKey;
        this.soilSpecimensFilterLayerMagnesiumKey = soilSpecimensFilterLayerMagnesiumKey;
        this.soilSpecimensFilterLayerManganeseKey = soilSpecimensFilterLayerManganeseKey;
        this.soilSpecimensFilterLayerZincKey = soilSpecimensFilterLayerZincKey;
        this.soilSpecimensFilterLayerCopperKey = soilSpecimensFilterLayerCopperKey;
        this.soilSpecimensFilterLayerIronKey = soilSpecimensFilterLayerIronKey;
        this.soilSpecimensFilterLayerBoronKey = soilSpecimensFilterLayerBoronKey;
        this.soilSpecimensFilterLayerCalciumKey = soilSpecimensFilterLayerCalciumKey;
        this.soilSpecimensFilterLayerOrganicCarbonKey = soilSpecimensFilterLayerOrganicCarbonKey;
        this.soilSpecimensFilterLayerHumusKey = soilSpecimensFilterLayerHumusKey;
    }
    return GroundSoilSpecimensSchema;
}());
if (false) {
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerCounturKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerNetKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerAgronomicKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerPhKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerPhosphorusKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerPotassiumKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerMagnesiumKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerManganeseKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerZincKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerCopperKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerIronKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerBoronKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerCalciumKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerOrganicCarbonKey;
    /** @type {?} */
    GroundSoilSpecimensSchema.prototype.soilSpecimensFilterLayerHumusKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundAgroMonitoring = /** @class */ (function () {
    function GroundAgroMonitoring(polygonId, message) {
        this.polygonId = polygonId;
        this.message = message;
    }
    return GroundAgroMonitoring;
}());
if (false) {
    /** @type {?} */
    GroundAgroMonitoring.prototype.polygonId;
    /** @type {?} */
    GroundAgroMonitoring.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundListItem = /** @class */ (function () {
    function GroundListItem(id, name, cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, lease, locations, areaInHa) {
        this.id = id;
        this.name = name;
        this.cadastralState = cadastralState;
        this.cadastralCounty = cadastralCounty;
        this.cadastralCommune = cadastralCommune;
        this.cadastralArea = cadastralArea;
        this.cadastreNumber = cadastreNumber;
        this.lease = lease;
        this.locations = locations;
        this.areaInHa = areaInHa;
    }
    return GroundListItem;
}());
if (false) {
    /** @type {?} */
    GroundListItem.prototype.id;
    /** @type {?} */
    GroundListItem.prototype.name;
    /** @type {?} */
    GroundListItem.prototype.cadastralState;
    /** @type {?} */
    GroundListItem.prototype.cadastralCounty;
    /** @type {?} */
    GroundListItem.prototype.cadastralCommune;
    /** @type {?} */
    GroundListItem.prototype.cadastralArea;
    /** @type {?} */
    GroundListItem.prototype.cadastreNumber;
    /** @type {?} */
    GroundListItem.prototype.lease;
    /** @type {?} */
    GroundListItem.prototype.locations;
    /** @type {?} */
    GroundListItem.prototype.areaInHa;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Ground = /** @class */ (function () {
    function Ground(id, name, areaInHa, lease, cadastralState, cadastralCounty, cadastralCommune, cadastralArea, cadastreNumber, groundCategory, complexOfAgriculturalSuitability, agronomicCategory, locations, agroMonitoringData) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
        this.lease = lease;
        this.cadastralState = cadastralState;
        this.cadastralCounty = cadastralCounty;
        this.cadastralCommune = cadastralCommune;
        this.cadastralArea = cadastralArea;
        this.cadastreNumber = cadastreNumber;
        this.groundCategory = groundCategory;
        this.complexOfAgriculturalSuitability = complexOfAgriculturalSuitability;
        this.agronomicCategory = agronomicCategory;
        this.locations = locations;
        this.agroMonitoringData = agroMonitoringData;
    }
    return Ground;
}());
if (false) {
    /** @type {?} */
    Ground.prototype.id;
    /** @type {?} */
    Ground.prototype.name;
    /** @type {?} */
    Ground.prototype.areaInHa;
    /** @type {?} */
    Ground.prototype.lease;
    /** @type {?} */
    Ground.prototype.cadastralState;
    /** @type {?} */
    Ground.prototype.cadastralCounty;
    /** @type {?} */
    Ground.prototype.cadastralCommune;
    /** @type {?} */
    Ground.prototype.cadastralArea;
    /** @type {?} */
    Ground.prototype.cadastreNumber;
    /** @type {?} */
    Ground.prototype.groundCategory;
    /** @type {?} */
    Ground.prototype.complexOfAgriculturalSuitability;
    /** @type {?} */
    Ground.prototype.agronomicCategory;
    /** @type {?} */
    Ground.prototype.locations;
    /** @type {?} */
    Ground.prototype.agroMonitoringData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundCustomMap = /** @class */ (function () {
    function GroundCustomMap(id, organizationId, parcelId, machineName, vehicleName, sessionId, mapType, generatedDate, geometry) {
        this.id = id;
        this.organizationId = organizationId;
        this.parcelId = parcelId;
        this.machineName = machineName;
        this.vehicleName = vehicleName;
        this.sessionId = sessionId;
        this.mapType = mapType;
        this.generatedDate = generatedDate;
        this.geometry = geometry;
    }
    return GroundCustomMap;
}());
if (false) {
    /** @type {?} */
    GroundCustomMap.prototype.id;
    /** @type {?} */
    GroundCustomMap.prototype.organizationId;
    /** @type {?} */
    GroundCustomMap.prototype.parcelId;
    /** @type {?} */
    GroundCustomMap.prototype.machineName;
    /** @type {?} */
    GroundCustomMap.prototype.vehicleName;
    /** @type {?} */
    GroundCustomMap.prototype.sessionId;
    /** @type {?} */
    GroundCustomMap.prototype.mapType;
    /** @type {?} */
    GroundCustomMap.prototype.generatedDate;
    /** @type {?} */
    GroundCustomMap.prototype.geometry;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportScanListFilter = /** @class */ (function () {
    function GroundImportScanListFilter() {
    }
    return GroundImportScanListFilter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportScanListItem = /** @class */ (function () {
    function GroundImportScanListItem(id, measurementDate) {
        this.id = id;
        this.measurementDate = measurementDate;
    }
    return GroundImportScanListItem;
}());
if (false) {
    /** @type {?} */
    GroundImportScanListItem.prototype.id;
    /** @type {?} */
    GroundImportScanListItem.prototype.measurementDate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportScan = /** @class */ (function () {
    function GroundImportScan(id, measurementDate, contour, scans) {
        this.id = id;
        this.measurementDate = measurementDate;
        this.contour = contour;
        this.scans = scans;
    }
    return GroundImportScan;
}());
if (false) {
    /** @type {?} */
    GroundImportScan.prototype.id;
    /** @type {?} */
    GroundImportScan.prototype.measurementDate;
    /** @type {?} */
    GroundImportScan.prototype.contour;
    /** @type {?} */
    GroundImportScan.prototype.scans;
}
var GroundImportScanItem = /** @class */ (function () {
    function GroundImportScanItem(value, size, areas) {
        this.value = value;
        this.size = size;
        this.areas = areas;
    }
    return GroundImportScanItem;
}());
if (false) {
    /** @type {?} */
    GroundImportScanItem.prototype.value;
    /** @type {?} */
    GroundImportScanItem.prototype.size;
    /** @type {?} */
    GroundImportScanItem.prototype.areas;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSoilSpecimenListFilter = /** @class */ (function () {
    function GroundImportSoilSpecimenListFilter() {
    }
    return GroundImportSoilSpecimenListFilter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundImportSoilSpecimenListItem = /** @class */ (function () {
    function GroundImportSoilSpecimenListItem(id, measurementDate, isPublished) {
        this.id = id;
        this.measurementDate = measurementDate;
        this.isPublished = isPublished;
    }
    return GroundImportSoilSpecimenListItem;
}());
if (false) {
    /** @type {?} */
    GroundImportSoilSpecimenListItem.prototype.id;
    /** @type {?} */
    GroundImportSoilSpecimenListItem.prototype.measurementDate;
    /** @type {?} */
    GroundImportSoilSpecimenListItem.prototype.isPublished;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GroundParcelGroupListItem = /** @class */ (function () {
    function GroundParcelGroupListItem(id, name, areaInHa, locations) {
        this.id = id;
        this.name = name;
        this.areaInHa = areaInHa;
        this.locations = locations;
    }
    return GroundParcelGroupListItem;
}());
if (false) {
    /** @type {?} */
    GroundParcelGroupListItem.prototype.id;
    /** @type {?} */
    GroundParcelGroupListItem.prototype.name;
    /** @type {?} */
    GroundParcelGroupListItem.prototype.areaInHa;
    /** @type {?} */
    GroundParcelGroupListItem.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationListFilterYearForm = /** @class */ (function () {
    function CultivationListFilterYearForm(year) {
        this.year = year;
    }
    return CultivationListFilterYearForm;
}());
if (false) {
    /** @type {?} */
    CultivationListFilterYearForm.prototype.year;
}

var _a$d;
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP = 'filterGroup';
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS = 'cultivations';
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_CULTIVATION_TYPE = 'cultivationType';
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_SHOW_PARCEL_DELETED = 'showParcelDeleted';
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_SHOW_FIELD_CARD_ENDED = 'showFieldCardEnded';
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_YEAR_FORM_LAYOUT = {
    year: {
        grid: {
            host: 'no-gutters',
            container: 'row form-group no-gutters mb-0',
            label: 'col-auto pt-1 pr-1 h5',
            control: 'col-auto'
        }
    }
};
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT_INPUT = {
    grid: {
        host: 'col-12 col-md-6',
        container: 'form-group row',
        label: 'col-12',
        control: 'col-12'
    }
};
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT = (_a$d = {},
    _a$d[CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP] = {
        grid: {
            host: 'w-100 mt-1 ',
            container: 'form-layout-group-header-hidden',
            label: 'col-12 px-0'
        },
        element: {
            control: 'row'
        }
    },
    _a$d[CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS] = CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT_INPUT,
    _a$d[CULTIVATIONS_LIST_MAP_FILTER_CULTIVATION_TYPE] = CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT_INPUT,
    _a$d[CULTIVATIONS_LIST_MAP_FILTER_SHOW_PARCEL_DELETED] = CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT_INPUT,
    _a$d[CULTIVATIONS_LIST_MAP_FILTER_SHOW_FIELD_CARD_ENDED] = CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT_INPUT,
    _a$d);
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_YEAR_FORM_MODEL = [
    new DynamicInputModel({
        id: 'year',
        min: 2000,
        max: 2100,
        inputType: 'number'
    })
];
/** @type {?} */
var CULTIVATIONS_LIST_MAP_FILTER_FORM_MODEL = [
    new DynamicFormGroupModel({
        id: CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP,
        group: [
            new DynamicMultiSelectControlModel({
                id: CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS,
                items: [],
                multiple: true,
                bindLabel: 'codeName',
                translationPrefix: 'APPLICATION.DICTIONARIES'
            }),
            new DynamicSelectModel({
                id: CULTIVATIONS_LIST_MAP_FILTER_CULTIVATION_TYPE,
                options: getOptionsForDynamicSelectModel(CultivationType, 'CULTIVATION_TYPE', true)
            }),
            new DynamicCheckboxModel({
                id: CULTIVATIONS_LIST_MAP_FILTER_SHOW_PARCEL_DELETED,
                label: 'CULTIVATION.list.filter.showParcelDeleted',
            }),
            new DynamicCheckboxModel({
                id: CULTIVATIONS_LIST_MAP_FILTER_SHOW_FIELD_CARD_ENDED,
                label: 'CULTIVATION.list.filter.showFieldCardEnded',
            })
        ]
    })
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationListFilterYearComponent = /** @class */ (function () {
    function CultivationListFilterYearComponent(router) {
        this.router = router;
        this.search = new EventEmitter();
        this.destroyed$ = new Subject();
        this.formLayout = CULTIVATIONS_LIST_MAP_FILTER_YEAR_FORM_LAYOUT;
        this.formModel = CULTIVATIONS_LIST_MAP_FILTER_YEAR_FORM_MODEL;
        this.minYear = +((/** @type {?} */ (this.formModel[0]))).min;
        this.maxYear = +((/** @type {?} */ (this.formModel[0]))).max;
    }
    /**
     * @return {?}
     */
    CultivationListFilterYearComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        function (event) { return event instanceof NavigationEnd; })), takeUntil(this.destroyed$))
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            _this.search.emit(_this.yearControl.value);
        }));
        /** @type {?} */
        var year = new Date().getFullYear();
        this.initValue = new CultivationListFilterYearForm(year);
        this.search.emit(year);
    };
    /**
     * @return {?}
     */
    CultivationListFilterYearComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.yearControl.valueChanges
            .pipe(filter((/**
         * @param {?} value
         * @return {?}
         */
        function (value) { return _this.minYear <= value && value <= _this.maxYear; })))
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.search.emit(value);
        }));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    CultivationListFilterYearComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.year && changes.year.currentValue != null) {
            this.initValue.year = changes.year.currentValue;
            this.search.emit(this.initValue.year);
        }
    };
    /**
     * @return {?}
     */
    CultivationListFilterYearComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.destroyed$.next();
        this.destroyed$.complete();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    CultivationListFilterYearComponent.prototype.onSearch = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.search.emit(+$event.year);
    };
    Object.defineProperty(CultivationListFilterYearComponent.prototype, "yearControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.yearFilter.formGroup.get('year');
        },
        enumerable: true,
        configurable: true
    });
    CultivationListFilterYearComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-list-filter-year',
                    template: "<div class=\"row\">\r\n    <div class=\"col-12\">\r\n        <app-simple-form #yearFilter [formModel]=\"formModel\" [formLayout]=\"formLayout\" [model]=\"initValue\"\r\n            [translateKey]=\"'CULTIVATION.list.filter'\">\r\n        </app-simple-form>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CultivationListFilterYearComponent.ctorParameters = function () { return [
        { type: Router }
    ]; };
    CultivationListFilterYearComponent.propDecorators = {
        search: [{ type: Output }],
        yearFilter: [{ type: ViewChild, args: ['yearFilter', { static: false },] }]
    };
    return CultivationListFilterYearComponent;
}());
if (false) {
    /** @type {?} */
    CultivationListFilterYearComponent.prototype.search;
    /** @type {?} */
    CultivationListFilterYearComponent.prototype.yearFilter;
    /** @type {?} */
    CultivationListFilterYearComponent.prototype.formLayout;
    /** @type {?} */
    CultivationListFilterYearComponent.prototype.formModel;
    /** @type {?} */
    CultivationListFilterYearComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    CultivationListFilterYearComponent.prototype.destroyed$;
    /**
     * @type {?}
     * @private
     */
    CultivationListFilterYearComponent.prototype.minYear;
    /**
     * @type {?}
     * @private
     */
    CultivationListFilterYearComponent.prototype.maxYear;
    /**
     * @type {?}
     * @private
     */
    CultivationListFilterYearComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationListMapComponent = /** @class */ (function () {
    function CultivationListMapComponent() {
    }
    CultivationListMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-list-map',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-map\"></i> {{ 'CULTIVATION.list.map' | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\" class=\"float-right mr-1\"></app-panel-hide-button>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <hr class=\"mt-0\" />\r\n                <app-cultivation-map\r\n                    [parcels]=\"parcels\"\r\n                    [cultivations]=\"cultivations\"\r\n                    [fitBounds]=\"fitBounds\" class=\"flex-grow-1 d-flex flex-column\"></app-cultivation-map>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    CultivationListMapComponent.propDecorators = {
        cultivations: [{ type: Input }],
        parcels: [{ type: Input }],
        fitBounds: [{ type: Input }],
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }]
    };
    return CultivationListMapComponent;
}());
if (false) {
    /** @type {?} */
    CultivationListMapComponent.prototype.cultivations;
    /** @type {?} */
    CultivationListMapComponent.prototype.parcels;
    /** @type {?} */
    CultivationListMapComponent.prototype.fitBounds;
    /** @type {?} */
    CultivationListMapComponent.prototype.panelHide;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationListMapFilterForm = /** @class */ (function () {
    function CultivationListMapFilterForm(cultivations, cultivationType, showParcelDeleted, showFieldCardEnded) {
        var _a;
        this[CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP] = (_a = {},
            _a[CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS] = cultivations,
            _a[CULTIVATIONS_LIST_MAP_FILTER_CULTIVATION_TYPE] = cultivationType,
            _a[CULTIVATIONS_LIST_MAP_FILTER_SHOW_PARCEL_DELETED] = showParcelDeleted,
            _a[CULTIVATIONS_LIST_MAP_FILTER_SHOW_FIELD_CARD_ENDED] = showFieldCardEnded,
            _a);
    }
    return CultivationListMapFilterForm;
}());
if (false) {
    /* Skipping unnamed member:
    [CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP]: {
            [CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS]: ICultivationDictionaryModel[],
            [CULTIVATIONS_LIST_MAP_FILTER_CULTIVATION_TYPE]: string,
            [CULTIVATIONS_LIST_MAP_FILTER_SHOW_PARCEL_DELETED]: boolean,
            [CULTIVATIONS_LIST_MAP_FILTER_SHOW_FIELD_CARD_ENDED]: boolean
        }*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationListMapFilter = /** @class */ (function () {
    function CultivationListMapFilter(cultivations, cultivationType, isParcelDeleted, isFieldCardEnded) {
        this.cultivations = cultivations;
        this.cultivationType = cultivationType;
        this.isParcelDeleted = isParcelDeleted;
        this.isFieldCardEnded = isFieldCardEnded;
    }
    ;
    return CultivationListMapFilter;
}());
if (false) {
    /** @type {?} */
    CultivationListMapFilter.prototype.cultivations;
    /** @type {?} */
    CultivationListMapFilter.prototype.cultivationType;
    /** @type {?} */
    CultivationListMapFilter.prototype.isParcelDeleted;
    /** @type {?} */
    CultivationListMapFilter.prototype.isFieldCardEnded;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationListMapFilterComponent = /** @class */ (function () {
    function CultivationListMapFilterComponent() {
        this.search = new EventEmitter();
        this.formLayout = CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT;
        this.formModel = CULTIVATIONS_LIST_MAP_FILTER_FORM_MODEL;
    }
    /**
     * @return {?}
     */
    CultivationListMapFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initValue = new CultivationListMapFilterForm([], '', false, false);
        this.search.emit(new CultivationListMapFilter([], null, false, false));
    };
    /**
     * @return {?}
     */
    CultivationListMapFilterComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.cultivationsControl.valueChanges
            .subscribe((/**
         * @param {?} cultivationList
         * @return {?}
         */
        function (cultivationList) {
            /** @type {?} */
            var cultivations = cultivationList.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.codeName; }));
            /** @type {?} */
            var cultivationType = _this.convertToCultivationType(_this.cultivationTypeControl.value);
            /** @type {?} */
            var isParcelDeleted = _this.showParcelDeletedControl.value;
            /** @type {?} */
            var isFieldCardEnded = _this.showFieldCardEndedControl.value;
            _this.search.emit(new CultivationListMapFilter(cultivations, cultivationType, isParcelDeleted, isFieldCardEnded));
        }));
        this.cultivationTypeControl.valueChanges
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            /** @type {?} */
            var cultivations = _this.cultivationsControl.value.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.codeName; }));
            /** @type {?} */
            var cultivationType = _this.convertToCultivationType(value);
            /** @type {?} */
            var isParcelDeleted = _this.showParcelDeletedControl.value;
            /** @type {?} */
            var isFieldCardEnded = _this.showFieldCardEndedControl.value;
            _this.search.emit(new CultivationListMapFilter(cultivations, cultivationType, isParcelDeleted, isFieldCardEnded));
        }));
        this.showParcelDeletedControl.valueChanges
            .subscribe((/**
         * @param {?} isParcelDeleted
         * @return {?}
         */
        function (isParcelDeleted) {
            /** @type {?} */
            var cultivations = _this.cultivationsControl.value.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.codeName; }));
            /** @type {?} */
            var cultivationType = _this.convertToCultivationType(_this.cultivationTypeControl.value);
            /** @type {?} */
            var isFieldCardEnded = _this.showFieldCardEndedControl.value;
            _this.search.emit(new CultivationListMapFilter(cultivations, cultivationType, isParcelDeleted, isFieldCardEnded));
        }));
        this.showFieldCardEndedControl.valueChanges
            .subscribe((/**
         * @param {?} isFieldCardEnded
         * @return {?}
         */
        function (isFieldCardEnded) {
            /** @type {?} */
            var cultivations = _this.cultivationsControl.value.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.codeName; }));
            /** @type {?} */
            var cultivationType = _this.convertToCultivationType(_this.cultivationTypeControl.value);
            /** @type {?} */
            var isParcelDeleted = _this.showParcelDeletedControl.value;
            _this.search.emit(new CultivationListMapFilter(cultivations, cultivationType, isParcelDeleted, isFieldCardEnded));
        }));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    CultivationListMapFilterComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.cultivations && changes.cultivations.currentValue != null) {
            this.getCultivationsModel.items = changes.cultivations.currentValue;
            this.initValue[CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP][CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS] = [];
            this.mapFilterForm.refreshFormModel();
        }
    };
    /**
     * @private
     * @param {?} cultivationType
     * @return {?}
     */
    CultivationListMapFilterComponent.prototype.convertToCultivationType = /**
     * @private
     * @param {?} cultivationType
     * @return {?}
     */
    function (cultivationType) {
        return CultivationType[cultivationType];
    };
    Object.defineProperty(CultivationListMapFilterComponent.prototype, "getCultivationsModel", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            // tslint:disable-next-line: no-any
            return ((/** @type {?} */ (this.formModel[0]))).group[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CultivationListMapFilterComponent.prototype, "cultivationsControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.mapFilterForm.formGroup
                .get(CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP)
                .get(CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CultivationListMapFilterComponent.prototype, "cultivationTypeControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.mapFilterForm.formGroup
                .get(CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP)
                .get(CULTIVATIONS_LIST_MAP_FILTER_CULTIVATION_TYPE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CultivationListMapFilterComponent.prototype, "showParcelDeletedControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.mapFilterForm.formGroup
                .get(CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP)
                .get(CULTIVATIONS_LIST_MAP_FILTER_SHOW_PARCEL_DELETED);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CultivationListMapFilterComponent.prototype, "showFieldCardEndedControl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.mapFilterForm.formGroup
                .get(CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP)
                .get(CULTIVATIONS_LIST_MAP_FILTER_SHOW_FIELD_CARD_ENDED);
        },
        enumerable: true,
        configurable: true
    });
    CultivationListMapFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-list-map-filter',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-sliders\"></i> {{ 'APPLICATION.SEARCH.title' | translate }} </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\" class=\"float-right mr-1\">\r\n        </app-panel-hide-button>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <hr class=\"mt-0\" />\r\n                <app-simple-form #mapFilter [formModel]=\"formModel\" [formLayout]=\"formLayout\" [model]=\"initValue\"\r\n                    [translateKey]=\"'CULTIVATION.list.filter'\">\r\n                </app-simple-form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CultivationListMapFilterComponent.ctorParameters = function () { return []; };
    CultivationListMapFilterComponent.propDecorators = {
        cultivations: [{ type: Input }],
        search: [{ type: Output }],
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }],
        mapFilterForm: [{ type: ViewChild, args: ['mapFilter', { static: false },] }]
    };
    return CultivationListMapFilterComponent;
}());
if (false) {
    /** @type {?} */
    CultivationListMapFilterComponent.prototype.cultivations;
    /** @type {?} */
    CultivationListMapFilterComponent.prototype.search;
    /** @type {?} */
    CultivationListMapFilterComponent.prototype.panelHide;
    /** @type {?} */
    CultivationListMapFilterComponent.prototype.mapFilterForm;
    /** @type {?} */
    CultivationListMapFilterComponent.prototype.formLayout;
    /** @type {?} */
    CultivationListMapFilterComponent.prototype.formModel;
    /** @type {?} */
    CultivationListMapFilterComponent.prototype.initValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationListMapTableComponent = /** @class */ (function () {
    function CultivationListMapTableComponent() {
        var _this = this;
        this.showParcelsOnMap = new EventEmitter();
        this.showOnMap = new EventEmitter();
        this.cultivationTypeConventional = CultivationType.Conventional;
        this.dataSource = new ServerSideDataSource((/**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            return _this.onParcelSearch(filter);
        }));
    }
    /**
     * @return {?}
     */
    CultivationListMapTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.displayedColumns = ['crop', 'parcelName', 'fieldCardEndDate', 'action'];
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    CultivationListMapTableComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.filter && changes.filter.currentValue) {
            this.dataSource.setFilter(changes.filter.currentValue);
        }
        if (changes && changes.parcels && changes.parcels.currentValue) {
            this.dataSource.forceRefresh();
        }
    };
    // tslint:disable-next-line: cognitive-complexity
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    CultivationListMapTableComponent.prototype.onParcelSearch = 
    // tslint:disable-next-line: cognitive-complexity
    /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    function (filter) {
        /** @type {?} */
        var filterFieldCardEndedFn = (/**
         * @param {?} parcel
         * @return {?}
         */
        function (parcel) {
            return filter.filter.isFieldCardEnded ? true : parcel.fieldCardEndDate == null;
        });
        /** @type {?} */
        var filterParcelDeleteFn = (/**
         * @param {?} parcel
         * @return {?}
         */
        function (parcel) {
            return filter.filter.isParcelDeleted ? true : !parcel.isDeleted;
        });
        /** @type {?} */
        var filterCultivationsFn = (/**
         * @param {?} parcel
         * @return {?}
         */
        function (parcel) {
            if (filter.filter.cultivations == null || filter.filter.cultivations.length === 0) {
                return true;
            }
            /** @type {?} */
            var parcelCultivations = (parcel.cultivations || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.crop; }));
            return filter.filter.cultivations.some((/**
             * @param {?} c
             * @return {?}
             */
            function (c) { return parcelCultivations.indexOf(c) !== -1; }));
        });
        /** @type {?} */
        var filterCultivationTypeFn = (/**
         * @param {?} parcel
         * @return {?}
         */
        function (parcel) {
            if (filter.filter.cultivationType == null) {
                return true;
            }
            return (parcel.cultivations || []).filter((/**
             * @param {?} c
             * @return {?}
             */
            function (c) { return c.cultivationType === filter.filter.cultivationType; })).length > 0;
        });
        /** @type {?} */
        var sortByParcelNameFn = (/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            if (a.name == null && b.name == null) {
                return 0;
            }
            if (a.name == null) {
                return 1;
            }
            if (b.name == null) {
                return -1;
            }
            /** @type {?} */
            var compare = a.name.localeCompare(b.name);
            return filter.sortOrder === 'asc' ? compare : (-1) * compare;
        });
        /** @type {?} */
        var sortFn = (/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            if (filter.orderBy === 'parcelName') {
                return sortByParcelNameFn(a, b);
            }
            return 0;
        });
        /** @type {?} */
        var start = filter.page * filter.pageSize;
        /** @type {?} */
        var end = (filter.page + 1) * filter.pageSize;
        /** @type {?} */
        var result = (this.parcels || [])
            .filter(filterFieldCardEndedFn)
            .filter(filterParcelDeleteFn)
            .filter(filterCultivationsFn)
            .filter(filterCultivationTypeFn)
            .sort(sortFn);
        return of({
            items: result.slice(start, end),
            totalCount: result.length
        });
    };
    /**
     * @param {?} item
     * @return {?}
     */
    CultivationListMapTableComponent.prototype.onShowOnMap = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.showOnMap.emit(item);
    };
    CultivationListMapTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-list-map-table',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-list\"></i> {{ 'CULTIVATION.list.cultivations' | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0 table-container\">\r\n                <hr class=\"mt-0\" />\r\n                <div>\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"parcelName\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"crop\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-4 text-truncate\">\r\n                                {{ 'CULTIVATION.list.crop' | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let parcel\" class=\"col-4 text-truncate pr-0\">\r\n                                <span [ngClass]=\"{'font-weight-light': parcel.isDeleted}\"\r\n                                    *ngIf=\"parcel.cultivations != null && parcel.cultivations.length > 0\">\r\n                                    <span>{{ parcel.cultivations[0].crop | dictionaryTranslateKey | translate}}</span>\r\n                                    <span *ngIf=\"parcel.cultivations[0].cultivationType != cultivationTypeConventional\">\r\n                                        ({{ parcel.cultivations[0].cultivationType | enumTranslateKey:\r\n                                        'APPLICATION.DICTIONARIES.CULTIVATION_TYPE' | translate}}) </span>\r\n                                    <span *ngIf=\"parcel.isDraft\"> ({{ 'CULTIVATION.list.cropPlanned' | translate\r\n                                        }})</span>\r\n                                </span>\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"parcelName\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-4 text-truncate\">\r\n                                {{ 'CULTIVATION.list.parcelName' | translate }} </div>\r\n                            <div cdk-cell *cdkCellDef=\"let parcel\" class=\"col-4 text-truncate pr-0\">\r\n                                <span [ngClass]=\"{'font-weight-light': parcel.isDeleted}\">{{ parcel.name }}</span>\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"fieldCardEndDate\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 text-truncate\">\r\n                                {{ 'CULTIVATION.list.fieldCardEndDate' | translate }} </div>\r\n                            <div cdk-cell *cdkCellDef=\"let parcel\" class=\"col-2 text-truncate pr-0\">\r\n                                <span class=\"font-italic size-smaller\"\r\n                                    [ngClass]=\"{'font-weight-light': parcel.isDeleted}\"\r\n                                    *ngIf=\"parcel.fieldCardExpectedEndDate && !parcel.fieldCardEndDate\">\r\n                                    {{ parcel.fieldCardExpectedEndDate | i18nDate: 'shortDate' }} <i class=\"ft ft-info\"\r\n                                        data-toggle=\"tooltip\" data-placement=\"top\"\r\n                                        title=\"{{'CULTIVATION.fieldCardForm.expectedEndDate' | translate}}\"></i>\r\n                                </span>\r\n                                <span [ngClass]=\"{'font-weight-light': parcel.isDeleted}\"\r\n                                    *ngIf=\"parcel.fieldCardEndDate\">\r\n                                    {{ parcel.fieldCardEndDate | i18nDate: 'shortDate' }} </span>\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2  p-0 text-center\">\r\n                                {{ 'APPLICATION.LIST.action' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let parcel\" class=\"col-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters float-md-right\">\r\n                                    <button (click)=\"onShowOnMap(parcel)\"\r\n                                        title=\"{{ 'CULTIVATION.list.showOnMap:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <a *ngIf=\"parcel.fieldCardId == null\"\r\n                                        [routerLink]=\"['parcels', parcel.id, 'fieldCards']\"\r\n                                        title=\"{{ 'CULTIVATION.list.addFieldCard:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-success\"> Dodaj kart\u0119 pola </a>\r\n                                    <a *ngIf=\"parcel.fieldCardId != null\"\r\n                                        [routerLink]=\"['parcels', parcel.id, 'fieldCards', parcel.fieldCardId]\"\r\n                                        title=\"{{ 'CULTIVATION.list.fieldCardDetails:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-info\" aria-hidden=\"true\"></i>\r\n                                    </a>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar m-0 py-2 extra_bg-light-grey\"\r\n                            *cdkHeaderRowDef=\"displayedColumns\">\r\n                        </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center m-0\"\r\n                            *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'CULTIVATION.list:empty' | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'CULTIVATION.list:error' | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                        [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons>\r\n                    </cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CultivationListMapTableComponent.ctorParameters = function () { return []; };
    CultivationListMapTableComponent.propDecorators = {
        filter: [{ type: Input }],
        parcels: [{ type: Input }],
        showParcelsOnMap: [{ type: Output }],
        showOnMap: [{ type: Output }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return CultivationListMapTableComponent;
}());
if (false) {
    /** @type {?} */
    CultivationListMapTableComponent.prototype.filter;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.parcels;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.showParcelsOnMap;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.showOnMap;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.sort;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.paginator;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.displayedColumns;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.dataSource;
    /** @type {?} */
    CultivationListMapTableComponent.prototype.cultivationTypeConventional;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationMapComponent = /** @class */ (function () {
    function CultivationMapComponent(ngZone, translateService) {
        var _this = this;
        this.ngZone = ngZone;
        this.translateService = translateService;
        this.unsubscribe$ = new Subject();
        this.mapConfig = new MapConfig();
        this.markerConfig = new MarkerConfig(false, false);
        this.polygonConfig = new PolygonConfig(null, false, false);
        this.displayOnMapOld = (/**
         * @param {?} parcels
         * @param {?} cultivations
         * @return {?}
         */
        function (parcels, cultivations) {
            /** @type {?} */
            var parcelLocations = (parcels || []).filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return location; })).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.locations; }));
            /** @type {?} */
            var cultivationLocations = (cultivations || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.locations; }));
            _this.features = _this.reduceLocation(parcelLocations).concat(_this.reduceLocation(cultivationLocations));
        });
        this.displayOnMap = (/**
         * @param {?} parcels
         * @param {?} cultivations
         * @return {?}
         */
        function (parcels, cultivations) {
            /** @type {?} */
            var cultivationIds = (cultivations || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id; }));
            /** @type {?} */
            var groupedByParcelId = groupBy(parcels || [], (/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id; }));
            _this.features = flatten(map$1(groupedByParcelId, (/**
             * @param {?} list
             * @param {?} _
             * @return {?}
             */
            function (list, _) {
                /** @type {?} */
                var parcelsWithSelectedCultvations = list
                    .filter((/**
                 * @param {?} p
                 * @return {?}
                 */
                function (p) { return p.cultivations != null && p.cultivations.some((/**
                 * @param {?} c
                 * @return {?}
                 */
                function (c) { return cultivationIds.some((/**
                 * @param {?} id
                 * @return {?}
                 */
                function (id) { return id === c.id; })); })); }));
                // parcels has at least one cultivation
                if (parcelsWithSelectedCultvations.length > 0) {
                    parcelsWithSelectedCultvations.sort(_this.sortParcel);
                    /** @type {?} */
                    var crops_1 = flatten(parcelsWithSelectedCultvations.map((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) { return (x.cultivations || []).map((/**
                     * @param {?} c
                     * @return {?}
                     */
                    function (c) { return c.crop; })); })))
                        .map(_this.translateCrop);
                    /** @type {?} */
                    var location_1 = cloneDeep(parcelsWithSelectedCultvations[0].cultivations[0].locations);
                    location_1.forEach((/**
                     * @param {?} l
                     * @return {?}
                     */
                    function (l) {
                        l.properties.name += '<ul><li>' + crops_1.join('</li><li>') + '</li></ul>';
                    }));
                    return {
                        locations: location_1,
                        hasCultivation: true,
                        isDeleted: list.some((/**
                         * @param {?} x
                         * @return {?}
                         */
                        function (x) { return x.isDeleted; }))
                    };
                }
                else {
                    return {
                        locations: list[0].locations,
                        hasCultivation: false,
                        isDeleted: list.some((/**
                         * @param {?} x
                         * @return {?}
                         */
                        function (x) { return x.isDeleted; }))
                    };
                }
            }))
                .sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) {
                if (a.hasCultivation && !b.hasCultivation) {
                    return 1;
                }
                if (!a.hasCultivation && b.hasCultivation) {
                    return -1;
                }
                if (a.isDeleted && !b.isDeleted) {
                    return 1;
                }
                if (!a.isDeleted && b.isDeleted) {
                    return -1;
                }
                return 0;
            }))
                .map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.locations; })));
        });
        this.sortParcel = (/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            /** @type {?} */
            var aEndDate = a == null ? null : (a.fieldCardEndDate != null ? a.fieldCardEndDate : a.fieldCardExpectedEndDate);
            /** @type {?} */
            var bEndDate = b == null ? null : b.fieldCardEndDate != null ? b.fieldCardEndDate : b.fieldCardExpectedEndDate;
            if (aEndDate == null && bEndDate == null) {
                return 0;
            }
            if (aEndDate == null) {
                return 1;
            }
            if (bEndDate == null) {
                return -1;
            }
            return aEndDate < bEndDate ? 1 : aEndDate > bEndDate ? -1 : 0;
        });
        this.translateCrop = (/**
         * @param {?} cultivationCropCodeName
         * @return {?}
         */
        function (cultivationCropCodeName) {
            return _this.translateService.instant('APPLICATION.DICTIONARIES.' + cultivationCropCodeName);
        });
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    CultivationMapComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.parcels && changes.parcels.currentValue != null) {
            this.displayOnMap(changes.parcels.currentValue, this.cultivations);
        }
        if (changes.cultivations && changes.cultivations.currentValue != null) {
            this.displayOnMap(this.parcels, changes.cultivations.currentValue);
        }
        if (changes.fitBounds && changes.fitBounds.currentValue != null) {
            this.mapConfig = new MapConfig(changes.fitBounds.currentValue);
        }
    };
    /**
     * @return {?}
     */
    CultivationMapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.displayOnMap(_this.parcels, _this.cultivations);
            }));
        }));
    };
    /**
     * @return {?}
     */
    CultivationMapComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    CultivationMapComponent.prototype.reduceLocation = /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    function (locations) {
        if (locations == null || locations.length === 0) {
            return [];
        }
        else {
            return locations.reduce((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.concat(b); }));
        }
    };
    CultivationMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-map',
                    template: "<div class=\"flex-grow-1\" style=\"height: 400px;\">\r\n    <app-map [features]=\"features\" [mapConfig]=\"mapConfig\" [markerConfig]=\"markerConfig\"\r\n        [polygonConfig]=\"polygonConfig\">\r\n    </app-map>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".location-map-marker-tooltip-image{max-width:100%!important;max-height:100px}"]
                }] }
    ];
    /** @nocollapse */
    CultivationMapComponent.ctorParameters = function () { return [
        { type: NgZone },
        { type: TranslateService }
    ]; };
    CultivationMapComponent.propDecorators = {
        parcels: [{ type: Input }],
        cultivations: [{ type: Input }],
        fitBounds: [{ type: Input }]
    };
    return CultivationMapComponent;
}());
if (false) {
    /** @type {?} */
    CultivationMapComponent.prototype.parcels;
    /** @type {?} */
    CultivationMapComponent.prototype.cultivations;
    /** @type {?} */
    CultivationMapComponent.prototype.fitBounds;
    /**
     * @type {?}
     * @private
     */
    CultivationMapComponent.prototype.unsubscribe$;
    /** @type {?} */
    CultivationMapComponent.prototype.features;
    /** @type {?} */
    CultivationMapComponent.prototype.mapConfig;
    /** @type {?} */
    CultivationMapComponent.prototype.markerConfig;
    /** @type {?} */
    CultivationMapComponent.prototype.polygonConfig;
    /**
     * @type {?}
     * @private
     */
    CultivationMapComponent.prototype.displayOnMapOld;
    /**
     * @type {?}
     * @private
     */
    CultivationMapComponent.prototype.displayOnMap;
    /**
     * @type {?}
     * @private
     */
    CultivationMapComponent.prototype.sortParcel;
    /**
     * @type {?}
     * @private
     */
    CultivationMapComponent.prototype.translateCrop;
    /**
     * @type {?}
     * @private
     */
    CultivationMapComponent.prototype.ngZone;
    /**
     * @type {?}
     * @private
     */
    CultivationMapComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationWithGroundsMapComponent = /** @class */ (function () {
    function CultivationWithGroundsMapComponent(ngZone, translateService) {
        var _this = this;
        this.ngZone = ngZone;
        this.translateService = translateService;
        this.unsubscribe$ = new Subject();
        this.mapConfig = new MapConfig();
        this.markerConfig = new MarkerConfig(false, false);
        this.polygonConfig = new PolygonConfig(null, false, false);
        this.displayOnMapOld = (/**
         * @param {?} grounds
         * @param {?} cultivations
         * @return {?}
         */
        function (grounds, cultivations) {
            /** @type {?} */
            var groundsLocations = (grounds || []).filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return location; })).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.locations; }));
            /** @type {?} */
            var cultivationLocations = (cultivations || []).map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.locations; }));
            _this.features = _this.reduceLocation(groundsLocations).concat(_this.reduceLocation(cultivationLocations));
        });
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    CultivationWithGroundsMapComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.grounds && changes.grounds.currentValue != null) {
            this.grounds = changes.grounds.currentValue;
            this.displayOnMapOld(changes.grounds.currentValue, this.cultivations);
        }
        if (changes.cultivations && changes.cultivations.currentValue != null) {
            this.cultivations = changes.cultivations.currentValue;
            this.displayOnMapOld(this.grounds, changes.cultivations.currentValue);
        }
        if (changes.fitBounds && changes.fitBounds.currentValue != null) {
            this.mapConfig = new MapConfig(changes.fitBounds.currentValue);
        }
    };
    /**
     * @return {?}
     */
    CultivationWithGroundsMapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.displayOnMapOld(_this.grounds, _this.cultivations);
            }));
        }));
    };
    /**
     * @return {?}
     */
    CultivationWithGroundsMapComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    CultivationWithGroundsMapComponent.prototype.reduceLocation = /**
     * @private
     * @param {?} locations
     * @return {?}
     */
    function (locations) {
        if (locations == null || locations.length === 0) {
            return [];
        }
        else {
            return locations.reduce((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.concat(b); }));
        }
    };
    CultivationWithGroundsMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-with-grounds-map',
                    template: "<div class=\"flex-grow-1\" style=\"height: 400px;\">\r\n    <app-map [features]=\"features\" [mapConfig]=\"mapConfig\" [markerConfig]=\"markerConfig\"\r\n        [polygonConfig]=\"polygonConfig\">\r\n    </app-map>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".location-map-marker-tooltip-image{max-width:100%!important;max-height:100px}"]
                }] }
    ];
    /** @nocollapse */
    CultivationWithGroundsMapComponent.ctorParameters = function () { return [
        { type: NgZone },
        { type: TranslateService }
    ]; };
    CultivationWithGroundsMapComponent.propDecorators = {
        grounds: [{ type: Input }],
        cultivations: [{ type: Input }],
        fitBounds: [{ type: Input }]
    };
    return CultivationWithGroundsMapComponent;
}());
if (false) {
    /** @type {?} */
    CultivationWithGroundsMapComponent.prototype.grounds;
    /** @type {?} */
    CultivationWithGroundsMapComponent.prototype.cultivations;
    /** @type {?} */
    CultivationWithGroundsMapComponent.prototype.fitBounds;
    /**
     * @type {?}
     * @private
     */
    CultivationWithGroundsMapComponent.prototype.unsubscribe$;
    /** @type {?} */
    CultivationWithGroundsMapComponent.prototype.features;
    /** @type {?} */
    CultivationWithGroundsMapComponent.prototype.mapConfig;
    /** @type {?} */
    CultivationWithGroundsMapComponent.prototype.markerConfig;
    /** @type {?} */
    CultivationWithGroundsMapComponent.prototype.polygonConfig;
    /**
     * @type {?}
     * @private
     */
    CultivationWithGroundsMapComponent.prototype.displayOnMapOld;
    /**
     * @type {?}
     * @private
     */
    CultivationWithGroundsMapComponent.prototype.ngZone;
    /**
     * @type {?}
     * @private
     */
    CultivationWithGroundsMapComponent.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationFieldCardMapComponent = /** @class */ (function () {
    function CultivationFieldCardMapComponent() {
    }
    CultivationFieldCardMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-fieldcard-map',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-map\"></i> {{ 'CULTIVATION.list.map' | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\" class=\"float-right mr-1\"></app-panel-hide-button>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <hr class=\"mt-0\" />\r\n                <app-cultivation-with-grounds-map\r\n                    [grounds]=\"grounds\"\r\n                    [cultivations]=\"cultivations\"\r\n                    [fitBounds]=\"fitBounds\" class=\"flex-grow-1 d-flex flex-column\"></app-cultivation-with-grounds-map>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    CultivationFieldCardMapComponent.propDecorators = {
        cultivations: [{ type: Input }],
        grounds: [{ type: Input }],
        fitBounds: [{ type: Input }],
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }]
    };
    return CultivationFieldCardMapComponent;
}());
if (false) {
    /** @type {?} */
    CultivationFieldCardMapComponent.prototype.cultivations;
    /** @type {?} */
    CultivationFieldCardMapComponent.prototype.grounds;
    /** @type {?} */
    CultivationFieldCardMapComponent.prototype.fitBounds;
    /** @type {?} */
    CultivationFieldCardMapComponent.prototype.panelHide;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationFieldCardFormGroundsComponent = /** @class */ (function () {
    function CultivationFieldCardFormGroundsComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.fieldCardGrounds = [];
        this.showOnMap = new EventEmitter();
        this.showDetails = new EventEmitter();
        this.dataSourceSubject$ = new BehaviorSubject([]);
        this.displayedColumns = [];
        this.displayedColumns = ['name', 'areaInHa', 'action'];
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    CultivationFieldCardFormGroundsComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        /** @type {?} */
        var fieldCardGrounds = null;
        if (changes.fieldCardGrounds && changes.fieldCardGrounds.currentValue) {
            fieldCardGrounds = changes.fieldCardGrounds.currentValue;
            this.dataSourceSubject$.next(fieldCardGrounds);
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    CultivationFieldCardFormGroundsComponent.prototype.onDetails = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.showDetails.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    CultivationFieldCardFormGroundsComponent.prototype.onShowOnMap = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.showOnMap.emit(item);
    };
    CultivationFieldCardFormGroundsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-cultivation-fieldcard-form-grounds',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"d-flex flex-column flex-md-row justify-content-md-between card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-list\"></i> {{ 'CULTIVATION.fieldCardForm.groundTable.header' | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button></app-panel-fullscreen-button>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container-fluid table-container\">\r\n                <cdk-table [dataSource]=\"dataSourceSubject$\">\r\n                    <ng-container cdkColumnDef=\"name\">\r\n                        <div cdk-header-cell *cdkHeaderCellDef class=\"col-3 pr-0\">{{\r\n                            'CULTIVATION.fieldCardForm.groundTable.name' | translate}}</div>\r\n                        <div cdk-cell *cdkCellDef=\"let element\" class=\"col-3 pr-0\"> {{ element.name }} </div>\r\n                    </ng-container>\r\n                    <ng-container cdkColumnDef=\"areaInHa\">\r\n                        <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\">{{\r\n                            'CULTIVATION.fieldCardForm.groundTable.areaInHa'\r\n                            | translate }}</div>\r\n                        <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\"> {{ element.areaInHa }}\r\n                        </div>\r\n                    </ng-container>\r\n                    <ng-container cdkColumnDef=\"action\">\r\n                        <div cdk-header-cell *cdkHeaderCellDef class=\"col-7 text-md-right\">{{\r\n                            'APPLICATION.LIST.action' |\r\n                            translate }} </div>\r\n                        <div cdk-cell *cdkCellDef=\"let element\" class=\"col-7 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                            <div class=\"sticky-action\">\r\n                                <div class=\"row no-gutters justify-content-md-end \">\r\n                                    <button (click)=\"onShowOnMap(element)\"\r\n                                        title=\"{{ 'GROUND.LIST.GROUNDS.TABLE.showOnMap:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button (click)=\"onDetails(element)\"\r\n                                        title=\"{{ 'GROUND.LIST.GROUNDS.TABLE.details:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-info\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </ng-container>\r\n                    <cdk-header-row class=\"row header-navbar py-2 extra_bg-light-grey\"\r\n                        *cdkHeaderRowDef=\"displayedColumns\">\r\n                    </cdk-header-row>\r\n                    <cdk-row class=\"row row-striped align-items-center\" *cdkRowDef=\"let row; columns: displayedColumns\">\r\n                    </cdk-row>\r\n                </cdk-table>\r\n                <div class=\"row\" *ngIf=\"dataSourceSubject$.value.length == 0 \">\r\n                    <div class=\"col text-center py-3\">{{ 'CULTIVATION.fieldCardForm.groundTable.list:empty' | translate }}\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CultivationFieldCardFormGroundsComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    CultivationFieldCardFormGroundsComponent.propDecorators = {
        fieldCardGrounds: [{ type: Input }],
        showOnMap: [{ type: Output }],
        showDetails: [{ type: Output }]
    };
    return CultivationFieldCardFormGroundsComponent;
}());
if (false) {
    /** @type {?} */
    CultivationFieldCardFormGroundsComponent.prototype.fieldCardGrounds;
    /** @type {?} */
    CultivationFieldCardFormGroundsComponent.prototype.showOnMap;
    /** @type {?} */
    CultivationFieldCardFormGroundsComponent.prototype.showDetails;
    /** @type {?} */
    CultivationFieldCardFormGroundsComponent.prototype.dataSourceSubject$;
    /** @type {?} */
    CultivationFieldCardFormGroundsComponent.prototype.displayedColumns;
    /**
     * @type {?}
     * @private
     */
    CultivationFieldCardFormGroundsComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationSharedModule = /** @class */ (function () {
    function CultivationSharedModule() {
    }
    CultivationSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CultivationListFilterYearComponent,
                        CultivationListMapComponent,
                        CultivationListMapFilterComponent,
                        CultivationListMapTableComponent,
                        CultivationMapComponent,
                        CultivationWithGroundsMapComponent,
                        CultivationFieldCardMapComponent,
                        CultivationFieldCardFormGroundsComponent
                    ],
                    entryComponents: [
                        CultivationListFilterYearComponent,
                        CultivationListMapComponent,
                        CultivationListMapFilterComponent,
                        CultivationListMapTableComponent,
                        CultivationMapComponent,
                        CultivationWithGroundsMapComponent,
                        CultivationFieldCardMapComponent,
                        CultivationFieldCardFormGroundsComponent
                    ],
                    imports: [
                        CommonModule,
                        ModalSharedModule,
                        GoogleMapsSharedModule,
                        FormSharedModule,
                        RouterModule,
                        FormsModule,
                        PanelSharedModule,
                        TableSharedModule,
                        TranslationModule,
                        SpinnerModule,
                        PipesModule,
                        ReactiveFormsModule,
                        DynamicFormsNGBootstrapUIModule,
                    ],
                    exports: [
                        CultivationListFilterYearComponent,
                        CultivationListMapComponent,
                        CultivationListMapFilterComponent,
                        CultivationListMapTableComponent,
                        CultivationMapComponent,
                        CultivationWithGroundsMapComponent,
                        CultivationFieldCardMapComponent,
                        CultivationFieldCardFormGroundsComponent
                    ],
                    providers: [DecimalPipe, MapService]
                },] }
    ];
    return CultivationSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFieldCardParcelListItem() { }
if (false) {
    /** @type {?} */
    IFieldCardParcelListItem.prototype.id;
    /** @type {?} */
    IFieldCardParcelListItem.prototype.name;
    /** @type {?} */
    IFieldCardParcelListItem.prototype.areaInHa;
    /** @type {?} */
    IFieldCardParcelListItem.prototype.locations;
    /** @type {?} */
    IFieldCardParcelListItem.prototype.isDeleted;
    /** @type {?} */
    IFieldCardParcelListItem.prototype.groundId;
    /** @type {?} */
    IFieldCardParcelListItem.prototype.groundName;
    /** @type {?|undefined} */
    IFieldCardParcelListItem.prototype.fieldCardId;
    /** @type {?|undefined} */
    IFieldCardParcelListItem.prototype.fieldCardExpectedEndDate;
    /** @type {?|undefined} */
    IFieldCardParcelListItem.prototype.fieldCardEndDate;
    /** @type {?|undefined} */
    IFieldCardParcelListItem.prototype.cultivations;
    /** @type {?|undefined} */
    IFieldCardParcelListItem.prototype.nameWithCultivation;
}
/**
 * @record
 */
function IFieldCardCultivation() { }
if (false) {
    /** @type {?} */
    IFieldCardCultivation.prototype.id;
    /** @type {?} */
    IFieldCardCultivation.prototype.crop;
    /** @type {?} */
    IFieldCardCultivation.prototype.foreCrop;
    /** @type {?} */
    IFieldCardCultivation.prototype.secondaryCrop;
    /** @type {?} */
    IFieldCardCultivation.prototype.interCrop;
    /** @type {?} */
    IFieldCardCultivation.prototype.catchCrop;
    /** @type {?} */
    IFieldCardCultivation.prototype.cultivationType;
    /** @type {?} */
    IFieldCardCultivation.prototype.cultivationSubtype;
    /** @type {?} */
    IFieldCardCultivation.prototype.areaInHa;
    /** @type {?} */
    IFieldCardCultivation.prototype.locations;
    /** @type {?|undefined} */
    IFieldCardCultivation.prototype.agroMonitoringData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BuildingsServicesModule = /** @class */ (function () {
    function BuildingsServicesModule() {
    }
    BuildingsServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return BuildingsServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BuildingsMapComponent = /** @class */ (function () {
    function BuildingsMapComponent() {
        this.polygonCfg = new PolygonConfig(groundDrawingColor, false, false);
        this.markerCfg = new MarkerConfig(false);
    }
    Object.defineProperty(BuildingsMapComponent.prototype, "polygonConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.polygonCfg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuildingsMapComponent.prototype, "markerConfig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.markerCfg;
        },
        enumerable: true,
        configurable: true
    });
    BuildingsMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-buildings-map',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-3\">\r\n        <label class=\"px-0\">\r\n            <h5 class=\"m-0\">\r\n                <i class=\"ft ft-map\"></i> {{ 'BUILDINGS.localization' | translate }}\r\n            </h5>\r\n        </label>\r\n        <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\"\r\n                class=\"float-right mr-1\"></app-panel-hide-button>\r\n        <hr class=\"my-0\" />\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <div style=\"height: 450px;\">\r\n                    <app-map [mapConfig]=\"mapConfig\" [polygonConfig]=\"polygonConfig\" [markerConfig]=\"markerConfig\"\r\n                        [features]=\"features\">\r\n                    </app-map>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    BuildingsMapComponent.propDecorators = {
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }],
        mapConfig: [{ type: Input }],
        features: [{ type: Input }]
    };
    return BuildingsMapComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BuildingsMapComponent.prototype.polygonCfg;
    /**
     * @type {?}
     * @private
     */
    BuildingsMapComponent.prototype.markerCfg;
    /** @type {?} */
    BuildingsMapComponent.prototype.panelHide;
    /** @type {?} */
    BuildingsMapComponent.prototype.mapConfig;
    /** @type {?} */
    BuildingsMapComponent.prototype.features;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BuildingsListTableComponent = /** @class */ (function () {
    function BuildingsListTableComponent() {
        this.detailsLink = '..';
        this.showOnMap = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onDelete = new EventEmitter();
        // tslint:disable-next-line: no-output-on-prefix
        this.onSearch = new EventEmitter();
    }
    /**
     * @return {?}
     */
    BuildingsListTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.displayedColumns = ['name', 'buildingType', 'action'];
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BuildingsListTableComponent.prototype.onSearchclick = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.onSearch.emit($event);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    BuildingsListTableComponent.prototype.onDeleteClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.onDelete.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    BuildingsListTableComponent.prototype.showOnMapClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.showOnMap.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    BuildingsListTableComponent.prototype.hasBuildingLocalization = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return item.locations.length > 0;
    };
    BuildingsListTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-buildings-list-table',
                    template: "<div class=\"ground-list mb-2\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\">\r\n                    <i class=\"ft ft-list\"></i> {{ 'BUILDINGS.infoBuilding' | translate }} </h5>\r\n            </label>\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid table-container\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"name\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-4 pr-0\"> {{ 'BUILDINGS.name' | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-4 pr-0\"> {{ element.name }}</div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"buildingType\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-4 pr-0\">\r\n                                {{ 'BUILDINGS.buildingType' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-4 pr-0\">\r\n                                {{ element.buildingType | dictionaryTranslateKey | translate }} </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-4 text-md-right\"> {{ 'APPLICATION.LIST.action' | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-4 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-md-end\">\r\n                                    <button *ngIf=\"hasBuildingLocalization(element)\" (click)=\"showOnMapClick(element)\"\r\n                                        title=\"{{ 'BUILDINGS.showOnMap:button' | translate }}\"\r\n                                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-search\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button *ngIf=\"deletable\" (click)=\"onDeleteClick(element)\"\r\n                                        title=\"{{ 'BUILDINGS.delete:button' | translate }}\"\r\n                                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-danger\">\r\n                                        <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <a *ngIf=\"editable\" [routerLink]=\"['..', element.id, 'edit']\"\r\n                                        title=\"{{ 'BUILDINGS.update:button' | translate }}\"\r\n                                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-success\">\r\n                                        <i class=\"ft ft-edit-2\" aria-hidden=\"true\"></i>\r\n                                    </a>\r\n                                    <a [routerLink]=\"[detailsLink, element.id]\" title=\"{{ 'BUILDINGS.details:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-info\" aria-hidden=\"true\"></i>\r\n                                    </a>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\" *cdkHeaderRowDef=\"displayedColumns\">\r\n                        </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\" *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'BUILDINGS.list:empty' | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'BUILDINGS.list:error' | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\" [pageSizeOptions]=\"[10,25,50,75,100]\"\r\n                        showFirstLastButtons></cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    BuildingsListTableComponent.ctorParameters = function () { return []; };
    BuildingsListTableComponent.propDecorators = {
        dataSource: [{ type: Input }],
        detailsLink: [{ type: Input }],
        editable: [{ type: Input }],
        deletable: [{ type: Input }],
        showOnMap: [{ type: Output }],
        onDelete: [{ type: Output }],
        onSearch: [{ type: Output }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return BuildingsListTableComponent;
}());
if (false) {
    /** @type {?} */
    BuildingsListTableComponent.prototype.displayedColumns;
    /** @type {?} */
    BuildingsListTableComponent.prototype.dataSource;
    /** @type {?} */
    BuildingsListTableComponent.prototype.detailsLink;
    /** @type {?} */
    BuildingsListTableComponent.prototype.editable;
    /** @type {?} */
    BuildingsListTableComponent.prototype.deletable;
    /** @type {?} */
    BuildingsListTableComponent.prototype.showOnMap;
    /** @type {?} */
    BuildingsListTableComponent.prototype.onDelete;
    /** @type {?} */
    BuildingsListTableComponent.prototype.onSearch;
    /** @type {?} */
    BuildingsListTableComponent.prototype.sort;
    /** @type {?} */
    BuildingsListTableComponent.prototype.paginator;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BUILDING_FORM_LAYOUT = {
    buildingMapGroup: DEFAULT_FORM_LAYOUT_GROUP,
    buildingBaseInfoGroup: DEFAULT_FORM_LAYOUT_GROUP,
    name: DEFAULT_FORM_LAYOUT_INPUT,
    description: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    buildingType: DEFAULT_FORM_LAYOUT_INPUT,
    features: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'd-none',
            control: 'col-12'
        }
    },
};
/** @type {?} */
var BASE_INFO_FORM_MODEL$2 = new DynamicFormGroupModel({
    id: 'buildingBaseInfoGroup',
    group: [
        new DynamicInputModel({
            id: 'id',
            hidden: true
        }),
        new DynamicInputModel({
            id: 'name',
            minLength: 3,
            maxLength: 60,
            validators: {
                required: null,
                minLength: 3,
                maxLength: 60
            }
        }),
        new DynamicDictionaryControlModel({
            id: 'buildingType',
            dictionaryKey: DictionaryType[DictionaryType.BuildingType],
            translationPrefix: 'APPLICATION.DICTIONARIES',
            validators: {
                required: null
            }
        }),
        new DynamicTextAreaModel({
            id: 'description',
        }),
    ]
});
/** @type {?} */
var DRAWING_MAP_FORM_MODEL$1 = new DynamicFormGroupModel({
    id: 'buildingMapGroup',
    group: [
        new DynamicMapControlModel({
            id: 'features',
            mapConfig: new MapConfig(),
            polygonConfig: new PolygonConfig(groundDrawingColor, true, true),
            markerConfig: new MarkerConfig(false, false)
        }),
    ]
});
/** @type {?} */
var READONLY_MAP_FORM_MODEL = new DynamicFormGroupModel({
    id: 'buildingMapGroup',
    group: [
        new DynamicMapControlModel({
            id: 'features',
            mapConfig: new MapConfig(),
            polygonConfig: new PolygonConfig(groundDrawingColor, false, false),
            markerConfig: new MarkerConfig(false, false)
        }),
    ]
});
/** @type {?} */
var DRAWING_BUILDING_FORM_MODEL = [
    DRAWING_MAP_FORM_MODEL$1, BASE_INFO_FORM_MODEL$2
];
/** @type {?} */
var READONLY_BUILDING_FORM_MODEL = [
    READONLY_MAP_FORM_MODEL, BASE_INFO_FORM_MODEL$2
];
/**
 * @param {?} data
 * @return {?}
 */
function mapToBuildingForm(data) {
    return {
        buildingMapGroup: {
            features: data.locations
        },
        buildingBaseInfoGroup: {
            id: data.id,
            name: data.name,
            description: data.description,
            buildingType: data.buildingType,
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromBuildingForm(data) {
    return {
        id: data.buildingBaseInfoGroup.id,
        name: data.buildingBaseInfoGroup.name,
        description: data.buildingBaseInfoGroup.description,
        buildingType: data.buildingBaseInfoGroup.buildingType,
        locations: data.buildingMapGroup.features.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            x.properties.name = data.buildingBaseInfoGroup.name;
            return x;
        }))
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BuildingInfoComponent = /** @class */ (function () {
    function BuildingInfoComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.isEditable = true;
        /* Added to minimalize numer of API calls */
        this.initValueChange = new EventEmitter();
        this.update = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = BUILDING_FORM_LAYOUT;
    }
    /**
     * @return {?}
     */
    BuildingInfoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BuildingInfoComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.initValue && changes.initValue.currentValue != null) {
            /** @type {?} */
            var currentValue = changes.initValue.currentValue;
            this.formModel = this.startFromIsEditing ?
                this.constructFormModel(DRAWING_BUILDING_FORM_MODEL, currentValue.buildingMapGroup.features, true) :
                this.constructFormModel(READONLY_BUILDING_FORM_MODEL, currentValue.buildingMapGroup.features, false);
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BuildingInfoComponent.prototype.save = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.update.emit($event);
        this.formDetail.isEditing = false;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BuildingInfoComponent.prototype.onIsEditingChange = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if ($event) {
            this.formModel = this.constructFormModel(DRAWING_BUILDING_FORM_MODEL, this.initValue.buildingMapGroup.features, true);
        }
        else {
            this.formModel = this.constructFormModel(READONLY_BUILDING_FORM_MODEL, this.initValue.buildingMapGroup.features, false);
        }
        this.changeDetectorRef.detectChanges();
        this.formDetail.refreshFormModel();
    };
    /**
     * @private
     * @param {?} formModel
     * @param {?} features
     * @param {?} drawingEnabled
     * @return {?}
     */
    BuildingInfoComponent.prototype.constructFormModel = /**
     * @private
     * @param {?} formModel
     * @param {?} features
     * @param {?} drawingEnabled
     * @return {?}
     */
    function (formModel, features, drawingEnabled) {
        if (features.length > 0) {
            /** @type {?} */
            var formGroupModel = (/** @type {?} */ (formModel.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === 'buildingMapGroup'; }))));
            /** @type {?} */
            var featuresFormModel = (/** @type {?} */ (formGroupModel.group.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.id === 'features'; }))));
            featuresFormModel.polygonConfig = new PolygonConfig(groundDrawingColor, drawingEnabled, drawingEnabled);
        }
        return formModel;
    };
    BuildingInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-building-info',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header\">\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <app-form *ngIf=\"formModel\" #formDetail [startFromIsEditing]=\"startFromIsEditing\"\r\n                    [formModel]=\"formModel\" [formLayout]=\"formLayout\" [model]=\"initValue\" [translateKey]=\"'BUILDINGS'\"\r\n                    (isEditingChange)=\"onIsEditingChange($event)\" (save)=\"save($event)\" [isEditable]=\"isEditable\">\r\n                </app-form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    BuildingInfoComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    BuildingInfoComponent.propDecorators = {
        formDetail: [{ type: ViewChild, args: ['formDetail', { static: false },] }],
        startFromIsEditing: [{ type: Input }],
        id: [{ type: Input }],
        isEditable: [{ type: Input }],
        initValueChange: [{ type: Output }],
        update: [{ type: Output }],
        initValue: [{ type: Input }]
    };
    return BuildingInfoComponent;
}());
if (false) {
    /** @type {?} */
    BuildingInfoComponent.prototype.formDetail;
    /** @type {?} */
    BuildingInfoComponent.prototype.startFromIsEditing;
    /** @type {?} */
    BuildingInfoComponent.prototype.id;
    /** @type {?} */
    BuildingInfoComponent.prototype.isEditable;
    /** @type {?} */
    BuildingInfoComponent.prototype.initValueChange;
    /** @type {?} */
    BuildingInfoComponent.prototype.update;
    /** @type {?} */
    BuildingInfoComponent.prototype.formLayout;
    /** @type {?} */
    BuildingInfoComponent.prototype.formModel;
    /** @type {?} */
    BuildingInfoComponent.prototype.initValue;
    /** @type {?} */
    BuildingInfoComponent.prototype.displaySpinner$;
    /**
     * @type {?}
     * @private
     */
    BuildingInfoComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BuildingsSharedModule = /** @class */ (function () {
    function BuildingsSharedModule() {
    }
    BuildingsSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        BuildingsMapComponent,
                        BuildingsListTableComponent,
                        BuildingInfoComponent
                    ],
                    entryComponents: [
                        BuildingsMapComponent,
                        BuildingsListTableComponent,
                        BuildingInfoComponent
                    ],
                    imports: [
                        CommonModule,
                        NgbModule,
                        ChartsModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule,
                        GoogleMapsSharedModule,
                        FormSharedModule,
                        BuildingsServicesModule,
                        TableSharedModule,
                        RouterModule,
                        TranslateModule,
                        PureGoogleMapsSharedModule,
                        ModalSharedModule,
                        TranslationModule
                    ],
                    exports: [
                        BuildingsMapComponent,
                        BuildingsListTableComponent,
                        BuildingInfoComponent
                    ],
                    providers: [DecimalPipe, MapService]
                },] }
    ];
    return BuildingsSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Building() { }
if (false) {
    /** @type {?} */
    Building.prototype.id;
    /** @type {?} */
    Building.prototype.name;
    /** @type {?} */
    Building.prototype.description;
    /** @type {?} */
    Building.prototype.buildingType;
    /** @type {?} */
    Building.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BuildingsListFilter = /** @class */ (function () {
    function BuildingsListFilter(name, type) {
        this.name = name;
        this.type = type;
    }
    return BuildingsListFilter;
}());
if (false) {
    /** @type {?} */
    BuildingsListFilter.prototype.name;
    /** @type {?} */
    BuildingsListFilter.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BuildingForm() { }
if (false) {
    /** @type {?} */
    BuildingForm.prototype.buildingMapGroup;
    /** @type {?} */
    BuildingForm.prototype.buildingBaseInfoGroup;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AddBuilding() { }
if (false) {
    /** @type {?} */
    AddBuilding.prototype.id;
    /** @type {?} */
    AddBuilding.prototype.name;
    /** @type {?} */
    AddBuilding.prototype.description;
    /** @type {?} */
    AddBuilding.prototype.buildingType;
    /** @type {?} */
    AddBuilding.prototype.locations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IBuildingsCrudService() { }
if (false) {
    /**
     * @param {?} requestList
     * @param {?=} organizationId
     * @return {?}
     */
    IBuildingsCrudService.prototype.getList = function (requestList, organizationId) { };
    /**
     * @param {?} id
     * @param {?=} organizationId
     * @return {?}
     */
    IBuildingsCrudService.prototype.getSingle = function (id, organizationId) { };
    /**
     * @param {?} model
     * @param {?=} organizationId
     * @return {?}
     */
    IBuildingsCrudService.prototype.create = function (model, organizationId) { };
    /**
     * @param {?} model
     * @param {?=} organizationId
     * @return {?}
     */
    IBuildingsCrudService.prototype.update = function (model, organizationId) { };
    /**
     * @param {?} id
     * @param {?=} organizationId
     * @return {?}
     */
    IBuildingsCrudService.prototype.delete = function (id, organizationId) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrganizationProfileStatisticsComponent = /** @class */ (function () {
    function OrganizationProfileStatisticsComponent(decimalPipe) {
        this.decimalPipe = decimalPipe;
        this.summaryOfAreaInHa = 0;
        this.dominantCropArray = [];
        this.isAnyEcological = false;
    }
    Object.defineProperty(OrganizationProfileStatisticsComponent.prototype, "isEcological", {
        get: /**
         * @return {?}
         */
        function () {
            return this.isAnyEcological ? 'yes' : 'no';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    OrganizationProfileStatisticsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.checkAllData();
    };
    /**
     * @private
     * @return {?}
     */
    OrganizationProfileStatisticsComponent.prototype.checkAllData = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.cultivations.forEach((/**
         * @param {?} parcel
         * @return {?}
         */
        function (parcel) {
            if (parcel.cultivations) {
                parcel.cultivations.forEach((/**
                 * @param {?} cultivation
                 * @return {?}
                 */
                function (cultivation) {
                    _this.calculateSumAreainHa(cultivation);
                    _this.checkIfIsEco(cultivation);
                    _this.checkDominantCropAndCount(cultivation);
                }));
            }
        }));
        this.findDominantCrop();
    };
    /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    OrganizationProfileStatisticsComponent.prototype.calculateSumAreainHa = /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    function (cultivation) {
        this.summaryOfAreaInHa += +cultivation.areaInHa;
    };
    /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    OrganizationProfileStatisticsComponent.prototype.checkIfIsEco = /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    function (cultivation) {
        if (!this.isAnyEcological) {
            this.isAnyEcological = cultivation.cultivationType === 'Ecological';
        }
    };
    /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    OrganizationProfileStatisticsComponent.prototype.checkDominantCropAndCount = /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    function (cultivation) {
        /** @type {?} */
        var cropName = cultivation.crop;
        /** @type {?} */
        var foundCrop = this.dominantCropArray.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.crop === cropName; }));
        if (foundCrop) {
            /** @type {?} */
            var indexOfFoundCrop = this.dominantCropArray.indexOf(foundCrop);
            foundCrop.sumAreaInHa += cultivation.areaInHa;
            this.dominantCropArray[indexOfFoundCrop] = foundCrop;
        }
        else {
            this.dominantCropArray.push({ crop: cropName, sumAreaInHa: cultivation.areaInHa });
        }
    };
    /**
     * @private
     * @return {?}
     */
    OrganizationProfileStatisticsComponent.prototype.findDominantCrop = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.dominantCropArray.length > 0) {
            /** @type {?} */
            var maxCount_1 = Math.max.apply(Math, this.dominantCropArray.map((/**
             * @param {?} dominantCrop
             * @return {?}
             */
            function (dominantCrop) { return dominantCrop.sumAreaInHa; })));
            this.dominantCrop = this.dominantCropArray.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.sumAreaInHa === maxCount_1; })).crop;
        }
    };
    OrganizationProfileStatisticsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-organization-profile-statistics',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-2\">\r\n        <h4 class=\"card-title mb-0\">\r\n            <i class=\"ft ft-home\"></i> {{ 'ORGANIZATION.PROFILE.statistics' | translate }}\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\"\r\n                class=\"float-right mr-1\"></app-panel-hide-button>\r\n        </h4>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1 pt-3\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-6\">\r\n                        <p>\r\n                            <b>{{ 'ORGANIZATION.PROFILE.cultivationsArea' | translate}}:</b> {{ summaryOfAreaInHa |\r\n                            number:'1.2-2' }}ha\r\n                        </p>\r\n                        <p><b>{{ 'ORGANIZATION.PROFILE.dominantCrop' | translate}}:</b> {{ dominantCrop |\r\n                            dictionaryTranslateKey | translate }}</p>\r\n                    </div>\r\n                    <div class=\"col-6\">\r\n                        <p><b>{{ 'ORGANIZATION.PROFILE.ecologicalType' | translate}}:</b> {{ 'ORGANIZATION.PROFILE.' +\r\n                            isEcological | translate}}</p>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    OrganizationProfileStatisticsComponent.ctorParameters = function () { return [
        { type: DecimalPipe }
    ]; };
    OrganizationProfileStatisticsComponent.propDecorators = {
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }],
        cultivations: [{ type: Input }]
    };
    return OrganizationProfileStatisticsComponent;
}());
if (false) {
    /** @type {?} */
    OrganizationProfileStatisticsComponent.prototype.panelHide;
    /** @type {?} */
    OrganizationProfileStatisticsComponent.prototype.cultivations;
    /** @type {?} */
    OrganizationProfileStatisticsComponent.prototype.summaryOfAreaInHa;
    /** @type {?} */
    OrganizationProfileStatisticsComponent.prototype.dominantCropArray;
    /** @type {?} */
    OrganizationProfileStatisticsComponent.prototype.isAnyEcological;
    /** @type {?} */
    OrganizationProfileStatisticsComponent.prototype.dominantCrop;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileStatisticsComponent.prototype.decimalPipe;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrganizationProfileCultivationChartComponent = /** @class */ (function () {
    function OrganizationProfileCultivationChartComponent(decimalPipe, translateService) {
        this.decimalPipe = decimalPipe;
        this.translateService = translateService;
        this.MAX_BAR_PADDING = 80;
        this.NORMAL_BAR_PADDING = 50;
        this.CHANGE_BAR_PADDING_COUNT = 4;
        this.showLabels = true;
        this.schemeType = 'ordinal';
        this.barPadding = 50;
        this.showDataLabel = true;
        this.showLegend = false;
        this.animations = true;
        this.xAxis = true;
        this.yAxis = true;
        this.formatDataLabel = this.transformDataLabel.bind(this);
        this.showYAxisLabel = true;
        this.showXAxisLabel = true;
        this.xAxisLabel = this.translateService.instant('ORGANIZATION.PROFILE.cultivation');
        this.yAxisLabel = this.translateService.instant('ORGANIZATION.PROFILE.area');
        this.colorScheme = {
            domain: ['#7bc64b', '#bab63f', '#e8973f', '#e6513d', '#f74897', '#ff36b7', '#f25aea', '#bb54f7']
        };
        this.dominantCropArray = [];
    }
    /**
     * @return {?}
     */
    OrganizationProfileCultivationChartComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.checkAndPrepareData();
    };
    /**
     * @private
     * @return {?}
     */
    OrganizationProfileCultivationChartComponent.prototype.checkAndPrepareData = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.cultivations.forEach((/**
         * @param {?} parcel
         * @return {?}
         */
        function (parcel) {
            if (parcel.cultivations) {
                parcel.cultivations.forEach((/**
                 * @param {?} cultivation
                 * @return {?}
                 */
                function (cultivation) {
                    _this.checkDominantCropAndCount(cultivation);
                }));
            }
        }));
        this.prepareDataForChart();
    };
    /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    OrganizationProfileCultivationChartComponent.prototype.checkDominantCropAndCount = /**
     * @private
     * @param {?} cultivation
     * @return {?}
     */
    function (cultivation) {
        /** @type {?} */
        var cropName = cultivation.crop;
        /** @type {?} */
        var foundCrop = this.dominantCropArray.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.name === cropName; }));
        if (foundCrop) {
            /** @type {?} */
            var indexOfFoundCrop = this.dominantCropArray.indexOf(foundCrop);
            foundCrop.value += cultivation.areaInHa;
            this.dominantCropArray[indexOfFoundCrop] = foundCrop;
        }
        else {
            this.dominantCropArray.push({ name: cropName, value: cultivation.areaInHa });
        }
    };
    /**
     * @private
     * @return {?}
     */
    OrganizationProfileCultivationChartComponent.prototype.prepareDataForChart = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.dominantCropArray = this.dominantCropArray.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return {
                name: x.name = (/** @type {?} */ (_this.translateService.instant("APPLICATION.DICTIONARIES." + x.name))),
                value: x.value
            };
        }));
        this.dominantCropArray.length < this.CHANGE_BAR_PADDING_COUNT ?
            this.barPadding = this.MAX_BAR_PADDING :
            this.barPadding = this.NORMAL_BAR_PADDING;
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    OrganizationProfileCultivationChartComponent.prototype.transformDataLabel = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this.decimalPipe.transform(value, '1.2-2') + " ha";
    };
    ;
    OrganizationProfileCultivationChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-organization-profile-cultivation-chart',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-2\">\r\n        <h4 class=\"card-title mb-0\">\r\n            <i class=\"ft ft-bar-chart\"></i> {{ 'ORGANIZATION.PROFILE.cultivations' | translate }}\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\"\r\n                class=\"float-right mr-1\"></app-panel-hide-button>\r\n        </h4>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1 pt-2\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <div class=\"row justify-content-center\">\r\n                    <div class=\"col-12 col-xs-12 col-sm-12 col-md-10 col-lg-9 chart-height\"\r\n                        *ngIf=\"dominantCropArray.length > 0\">\r\n                        <ngx-charts-bar-vertical [scheme]=\"colorScheme\" [legend]=\"showLegend\"\r\n                            [showXAxisLabel]=\"showXAxisLabel\" [showYAxisLabel]=\"showYAxisLabel\" [xAxis]=\"xAxis\"\r\n                            [yAxis]=\"yAxis\" [xAxisLabel]=\"xAxisLabel\" [yAxisLabel]=\"yAxisLabel\"\r\n                            [results]=\"dominantCropArray\" [schemeType]=\"schemeType\" [showDataLabel]=\"showDataLabel\"\r\n                            [dataLabelFormatting]=\"formatDataLabel\" [barPadding]=\"barPadding\">\r\n                            <ng-template #tooltipTemplate let-model=\"model\">\r\n                                <span *ngIf=\"model\"> <b>{{model.name}}: {{ (model.value | number:'1.2-2') +\r\n                                        'ha'}}</b><br />\r\n                                </span>\r\n                            </ng-template>\r\n                        </ngx-charts-bar-vertical>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".chart-height{height:400px}"]
                }] }
    ];
    /** @nocollapse */
    OrganizationProfileCultivationChartComponent.ctorParameters = function () { return [
        { type: DecimalPipe },
        { type: TranslateService }
    ]; };
    OrganizationProfileCultivationChartComponent.propDecorators = {
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }],
        cultivations: [{ type: Input }]
    };
    return OrganizationProfileCultivationChartComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileCultivationChartComponent.prototype.MAX_BAR_PADDING;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileCultivationChartComponent.prototype.NORMAL_BAR_PADDING;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileCultivationChartComponent.prototype.CHANGE_BAR_PADDING_COUNT;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.panelHide;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.cultivations;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.showLabels;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.schemeType;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.barPadding;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.showDataLabel;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.showLegend;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.animations;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.xAxis;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.yAxis;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.formatDataLabel;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.showYAxisLabel;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.showXAxisLabel;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.xAxisLabel;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.yAxisLabel;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.colorScheme;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.dominantCropArray;
    /** @type {?} */
    OrganizationProfileCultivationChartComponent.prototype.dominantCrop;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileCultivationChartComponent.prototype.decimalPipe;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileCultivationChartComponent.prototype.translateService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrganizationProfileGroundChartComponent = /** @class */ (function () {
    function OrganizationProfileGroundChartComponent(decimalPipe, translateService) {
        this.decimalPipe = decimalPipe;
        this.translateService = translateService;
        this.MAX_BAR_PADDING = 120;
        this.NORMAL_BAR_PADDING = 60;
        this.CHANGE_BAR_PADDING_COUNT = 4;
        this.showLabels = true;
        this.schemeType = 'ordinal';
        this.barPadding = this.NORMAL_BAR_PADDING;
        this.showDataLabel = true;
        this.showLegend = false;
        this.animations = true;
        this.xAxis = true;
        this.yAxis = true;
        this.formatDataLabel = this.transformDataLabel.bind(this);
        this.showYAxisLabel = true;
        this.showXAxisLabel = true;
        this.xAxisLabel = this.translateService.instant('ORGANIZATION.PROFILE.groundCategory');
        this.yAxisLabel = this.translateService.instant('ORGANIZATION.PROFILE.area');
        this.colorScheme = {
            domain: ['#7bc64b', '#bab63f', '#e8973f', '#e6513d', '#f74897', '#ff36b7', '#f25aea', '#bb54f7']
        };
        this.groupedGroundArray = [];
    }
    /**
     * @return {?}
     */
    OrganizationProfileGroundChartComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.checkAndPrepareData();
    };
    /**
     * @private
     * @return {?}
     */
    OrganizationProfileGroundChartComponent.prototype.checkAndPrepareData = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.grounds.forEach((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.groupGroundsByCategory(x); }));
        this.prepareDataForChart();
    };
    /**
     * @private
     * @param {?} ground
     * @return {?}
     */
    OrganizationProfileGroundChartComponent.prototype.groupGroundsByCategory = /**
     * @private
     * @param {?} ground
     * @return {?}
     */
    function (ground) {
        /** @type {?} */
        var groundCategory = ground.groundCategory;
        /** @type {?} */
        var foundGround = this.groupedGroundArray.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.name === (groundCategory ? groundCategory : 'none'); }));
        if (foundGround) {
            /** @type {?} */
            var indexOfFoundCrop = this.groupedGroundArray.indexOf(foundGround);
            foundGround.value += ground.areaInHa;
            this.groupedGroundArray[indexOfFoundCrop] = foundGround;
        }
        else {
            this.groupedGroundArray.push({ name: groundCategory ? groundCategory : 'none', value: ground.areaInHa });
        }
    };
    /**
     * @private
     * @return {?}
     */
    OrganizationProfileGroundChartComponent.prototype.prepareDataForChart = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.groupedGroundArray = this.groupedGroundArray.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return {
                name: x.name === 'none' ? (/** @type {?} */ (_this.translateService.instant("ORGANIZATION.PROFILE.noCategory"))) : x.name,
                value: x.value
            };
        }));
        this.groupedGroundArray.length < this.CHANGE_BAR_PADDING_COUNT ?
            this.barPadding = this.MAX_BAR_PADDING :
            this.barPadding = this.NORMAL_BAR_PADDING;
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    OrganizationProfileGroundChartComponent.prototype.transformDataLabel = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this.decimalPipe.transform(value, '1.2-2') + " ha";
    };
    ;
    OrganizationProfileGroundChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-organization-profile-ground-chart',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header pt-2\">\r\n        <h4 class=\"card-title mb-0\">\r\n            <i class=\"ft ft-bar-chart\"></i> {{ 'ORGANIZATION.PROFILE.grounds' | translate }}\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            <app-panel-hide-button [hidden]=\"false\" (hiddenChange)=\"panelHide.setHidden($event)\"\r\n                class=\"float-right mr-1\"></app-panel-hide-button>\r\n        </h4>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body py-1 pt-2\">\r\n            <div class=\"container-fluid px-0\" [appPanelHide]=\"false\">\r\n                <div class=\"row justify-content-center\">\r\n                    <div class=\"col-12 col-xs-12 col-sm-12 col-md-10 col-lg-9 chart-height\" *ngIf=\"groupedGroundArray.length > 0\">\r\n                        <ngx-charts-bar-vertical [scheme]=\"colorScheme\" [legend]=\"showLegend\"\r\n                            [showXAxisLabel]=\"showXAxisLabel\" [showYAxisLabel]=\"showYAxisLabel\" [xAxis]=\"xAxis\"\r\n                            [yAxis]=\"yAxis\" [xAxisLabel]=\"xAxisLabel\" [yAxisLabel]=\"yAxisLabel\"\r\n                            [results]=\"groupedGroundArray\" [schemeType]=\"schemeType\" [showDataLabel]=\"showDataLabel\"\r\n                            [dataLabelFormatting]=\"formatDataLabel\" [barPadding]=\"barPadding\">\r\n                            <ng-template #tooltipTemplate let-model=\"model\">\r\n                                <span *ngIf=\"model\"> <b> {{ 'ORGANIZATION.PROFILE.groundCategory' | translate }}\r\n                                        {{model.name}}: {{ (model.value | number:'1.2-2') + 'ha'}}</b><br />\r\n                                </span>\r\n                            </ng-template>\r\n                        </ngx-charts-bar-vertical>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".chart-height{height:400px}"]
                }] }
    ];
    /** @nocollapse */
    OrganizationProfileGroundChartComponent.ctorParameters = function () { return [
        { type: DecimalPipe },
        { type: TranslateService }
    ]; };
    OrganizationProfileGroundChartComponent.propDecorators = {
        panelHide: [{ type: ViewChild, args: [PanelHideDirective, { static: false },] }],
        grounds: [{ type: Input }]
    };
    return OrganizationProfileGroundChartComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileGroundChartComponent.prototype.MAX_BAR_PADDING;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileGroundChartComponent.prototype.NORMAL_BAR_PADDING;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileGroundChartComponent.prototype.CHANGE_BAR_PADDING_COUNT;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.panelHide;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.grounds;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.showLabels;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.schemeType;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.barPadding;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.showDataLabel;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.showLegend;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.animations;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.xAxis;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.yAxis;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.formatDataLabel;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.showYAxisLabel;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.showXAxisLabel;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.xAxisLabel;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.yAxisLabel;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.colorScheme;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.groupedGroundArray;
    /** @type {?} */
    OrganizationProfileGroundChartComponent.prototype.dominantCrop;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileGroundChartComponent.prototype.decimalPipe;
    /**
     * @type {?}
     * @private
     */
    OrganizationProfileGroundChartComponent.prototype.translateService;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrganizationSharedModule = /** @class */ (function () {
    function OrganizationSharedModule() {
    }
    OrganizationSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        OrganizationProfileStatisticsComponent,
                        OrganizationProfileCultivationChartComponent,
                        OrganizationProfileGroundChartComponent
                    ],
                    entryComponents: [
                        OrganizationProfileStatisticsComponent,
                        OrganizationProfileCultivationChartComponent,
                        OrganizationProfileGroundChartComponent
                    ],
                    imports: [
                        CommonModule,
                        NgbModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule,
                        TableSharedModule,
                        NgxChartsModule,
                        RouterModule,
                        TranslateModule,
                        TranslationModule
                    ],
                    exports: [
                        OrganizationProfileStatisticsComponent,
                        OrganizationProfileCultivationChartComponent,
                        OrganizationProfileGroundChartComponent
                    ],
                    providers: [DecimalPipe]
                },] }
    ];
    return OrganizationSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FieldCardCultivation() { }
if (false) {
    /** @type {?} */
    FieldCardCultivation.prototype.id;
    /** @type {?} */
    FieldCardCultivation.prototype.crop;
    /** @type {?} */
    FieldCardCultivation.prototype.foreCrop;
    /** @type {?} */
    FieldCardCultivation.prototype.secondaryCrop;
    /** @type {?} */
    FieldCardCultivation.prototype.interCrop;
    /** @type {?} */
    FieldCardCultivation.prototype.catchCrop;
    /** @type {?} */
    FieldCardCultivation.prototype.cultivationType;
    /** @type {?} */
    FieldCardCultivation.prototype.cultivationSubtype;
    /** @type {?} */
    FieldCardCultivation.prototype.areaInHa;
    /** @type {?} */
    FieldCardCultivation.prototype.locations;
    /** @type {?|undefined} */
    FieldCardCultivation.prototype.agroMonitoringData;
}
/**
 * @record
 */
function FieldCardParcelListItem() { }
if (false) {
    /** @type {?} */
    FieldCardParcelListItem.prototype.id;
    /** @type {?} */
    FieldCardParcelListItem.prototype.name;
    /** @type {?} */
    FieldCardParcelListItem.prototype.areaInHa;
    /** @type {?} */
    FieldCardParcelListItem.prototype.locations;
    /** @type {?} */
    FieldCardParcelListItem.prototype.isDeleted;
    /** @type {?} */
    FieldCardParcelListItem.prototype.groundId;
    /** @type {?} */
    FieldCardParcelListItem.prototype.groundName;
    /** @type {?|undefined} */
    FieldCardParcelListItem.prototype.fieldCardId;
    /** @type {?|undefined} */
    FieldCardParcelListItem.prototype.fieldCardExpectedEndDate;
    /** @type {?|undefined} */
    FieldCardParcelListItem.prototype.fieldCardEndDate;
    /** @type {?|undefined} */
    FieldCardParcelListItem.prototype.cultivations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ChartData() { }
if (false) {
    /** @type {?} */
    ChartData.prototype.name;
    /** @type {?} */
    ChartData.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineListTableComponent = /** @class */ (function () {
    function MachineListTableComponent(confirmationModalService) {
        this.confirmationModalService = confirmationModalService;
        this.detail = new EventEmitter();
        this.delete = new EventEmitter();
        this.edit = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MachineListTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.displayedColumns = ['photo', 'name', 'type', 'serialNumber', 'mileage', 'action'];
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    MachineListTableComponent.prototype.onDeleteClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        this.confirmationModalService.open('MACHINE.delete:confirmTitle', 'MACHINE.delete:confirmText', [item.name]).then((/**
         * @return {?}
         */
        function () {
            _this.delete.emit(item);
        }), (/**
         * @return {?}
         */
        function () { }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    MachineListTableComponent.prototype.onEditClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.edit.emit(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    MachineListTableComponent.prototype.onDetailClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.detail.emit(item);
    };
    MachineListTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-list-table',
                    template: "<div class=\"mb-2\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\">\r\n                    <i class=\"ft ft-list\"></i> Lista maszyn\r\n                </h5>\r\n            </label>\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"name\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"photo\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\">{{ 'MACHINE.photo' | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\"><img *ngIf=\"element.image\"\r\n                                    class=\"thumbnail\" [src]=\"element.image.link\" /></div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-2 pr-0\">\r\n                                {{ 'MACHINE.name' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.name }}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"type\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\">{{ 'MACHINE.type' | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.type |\r\n                                dictionaryTranslateKey | translate }}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"serialNumber\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 col-xl-3 pr-0\">\r\n                                {{ 'MACHINE.registerSerialNumber' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 col-xl-3 pr-0\">\r\n                                {{ element.registerNumber || '-' }}/{{ element.serialNumber || '-' }}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"mileage\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-1 pr-0\">\r\n                                {{ 'MACHINE.mileage' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-1 pr-0\">{{ element.mileage }}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-3 col-xl-2 text-md-right\">\r\n                                {{ 'APPLICATION.LIST.action' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"col-3 col-xl-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-md-end\">\r\n                                    <button (click)=\"onDeleteClick(element)\" *ngIf=\"!element.isDeleted\"\r\n                                        title=\"{{ 'MACHINE.delete:button' | translate }}\"\r\n                                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-danger\">\r\n                                        <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button (click)=\"onEditClick(element)\"\r\n                                        title=\"{{ 'MACHINE.update:button' | translate }}\"\r\n                                        class=\"d-none d-md-block btn btn-raised m-0 my-1 mr-1 btn-sm btn-success\">\r\n                                        <i class=\"ft ft-edit-2\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button (click)=\"onDetailClick(element)\"\r\n                                        title=\"{{ 'MACHINE.detail:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-info\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\"\r\n                            *cdkHeaderRowDef=\"displayedColumns\">\r\n                        </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\"\r\n                            *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'MACHINE.list:empty' | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'MACHINE.list:error' | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                        [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons></cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".thumbnail{width:100px;padding:5px}"]
                }] }
    ];
    /** @nocollapse */
    MachineListTableComponent.ctorParameters = function () { return [
        { type: ConfirmationModalService }
    ]; };
    MachineListTableComponent.propDecorators = {
        dataSource: [{ type: Input }],
        detail: [{ type: Output }],
        delete: [{ type: Output }],
        edit: [{ type: Output }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return MachineListTableComponent;
}());
if (false) {
    /** @type {?} */
    MachineListTableComponent.prototype.dataSource;
    /** @type {?} */
    MachineListTableComponent.prototype.detail;
    /** @type {?} */
    MachineListTableComponent.prototype.delete;
    /** @type {?} */
    MachineListTableComponent.prototype.edit;
    /** @type {?} */
    MachineListTableComponent.prototype.sort;
    /** @type {?} */
    MachineListTableComponent.prototype.paginator;
    /** @type {?} */
    MachineListTableComponent.prototype.displayedColumns;
    /**
     * @type {?}
     * @private
     */
    MachineListTableComponent.prototype.confirmationModalService;
}

var _a$e;
/** @type {?} */
var BASE_INFO_GROUP_KEY = 'baseInfoGroup';
/** @type {?} */
var TECHNICAL_INFORMATION_GROUP_KEY = 'technicalInformationGroup';
/** @type {?} */
var PHOTO_GROUP_KEY = 'photoGroup';
/** @type {?} */
var FORM_LAYOUT$3 = (_a$e = {},
    _a$e[BASE_INFO_GROUP_KEY] = DEFAULT_FORM_LAYOUT_GROUP,
    _a$e[TECHNICAL_INFORMATION_GROUP_KEY] = DEFAULT_FORM_LAYOUT_GROUP,
    _a$e[PHOTO_GROUP_KEY] = DEFAULT_FORM_LAYOUT_GROUP,
    _a$e.manufacturer = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.model = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.name = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.type = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.registerNumber = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.serialNumber = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.yearOfProduction = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.boughtDate = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.boughtPrice = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.width = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.avgWorkPriceGroupKey = {
        element: {
            control: 'form-row'
        },
        grid: {
            host: 'col-12 col-md-6 no-header-group'
        }
    },
    _a$e.avgWorkPrice = {
        grid: {
            host: 'col-9'
        }
    },
    _a$e.avgWorkPriceUnit = {
        grid: {
            host: 'col-3 no-label'
        }
    },
    _a$e.fuelTankSize = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.workSpeed = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.transportSpeed = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.mileage = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e.image = DEFAULT_FORM_LAYOUT_INPUT,
    _a$e);
/** @type {?} */
var FORM_MODEL$1 = [
    new DynamicFormGroupModel({
        id: BASE_INFO_GROUP_KEY,
        group: [
            new DynamicInputModel({
                id: 'id',
                hidden: true
            }),
            new DynamicInputModel({
                id: 'manufacturer',
                minLength: 3,
                maxLength: 60,
                validators: {
                    minLength: 3,
                    maxLength: 60
                }
            }),
            new DynamicInputModel({
                id: 'model',
                minLength: 3,
                maxLength: 60,
                validators: {
                    minLength: 3,
                    maxLength: 60
                }
            }),
            new DynamicInputModel({
                id: 'name',
                minLength: 3,
                maxLength: 60,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 60
                }
            }),
            new DynamicDictionaryControlModel({
                id: 'type',
                dictionaryKey: DictionaryType[DictionaryType.MachineType],
                translationPrefix: 'APPLICATION.DICTIONARIES',
                validators: {
                    required: null
                }
            }),
            new DynamicInputModel({
                id: 'registerNumber',
                minLength: 4,
                maxLength: 10,
                validators: {
                    minLength: 4,
                    maxLength: 10
                }
            }),
            new DynamicSelectModel({
                id: 'yearOfProduction',
                options: getYearsRangeOptionsForDynamicSelectModel()
            }),
            new DynamicInputModel({
                id: 'serialNumber',
                minLength: 3,
                maxLength: 20,
                validators: {
                    minLength: 3,
                    maxLength: 20
                }
            }),
            new DynamicDatePickerModel({
                id: 'boughtDate',
                toggleIcon: './assets/icons/calendar-icon.svg'
            }),
            new DynamicInputModel({
                id: 'boughtPrice',
                min: 0,
                max: 10000000,
                step: 1,
                inputType: 'number',
                validators: {
                    min: 0,
                    max: 10000000,
                    decimalNumberValidator: 2
                }
            }),
        ]
    }),
    new DynamicFormGroupModel({
        id: TECHNICAL_INFORMATION_GROUP_KEY,
        group: [
            new DynamicInputModel({
                id: 'width',
                min: 0,
                max: 10000,
                step: 1,
                inputType: 'number',
                suffix: 'cm',
                validators: {
                    min: 0,
                    max: 10000
                }
            }),
            new DynamicFormGroupModel({
                id: 'avgWorkPriceGroupKey',
                group: [
                    new DynamicInputModel({
                        id: 'avgWorkPrice',
                        min: 0,
                        max: 100000,
                        step: 1,
                        inputType: 'number',
                        suffix: 'zł',
                        validators: {
                            min: 0,
                            max: 100000
                        }
                    }),
                    new DynamicSelectModel({
                        id: 'avgWorkPriceUnit',
                        options: getOptionsForDynamicSelectModel(WorkPriceUnit, 'WORK_PRICE_UNIT', true)
                    }),
                ]
            }),
            new DynamicInputModel({
                id: 'fuelTankSize',
                min: 0,
                max: 100000,
                step: 1,
                inputType: 'number',
                suffix: 'l',
                validators: {
                    min: 0,
                    max: 100000
                }
            }),
            new DynamicInputModel({
                id: 'workSpeed',
                min: 0,
                max: 100,
                step: 1,
                inputType: 'number',
                suffix: 'km/h',
                validators: {
                    min: 0,
                    max: 100
                }
            }),
            new DynamicInputModel({
                id: 'transportSpeed',
                min: 0,
                max: 200,
                step: 1,
                inputType: 'number',
                suffix: 'km/h',
                validators: {
                    min: 0,
                    max: 200
                }
            }),
            new DynamicInputModel({
                id: 'mileage',
                min: 0,
                max: 10000000,
                step: 1,
                inputType: 'number',
                validators: {
                    min: 0,
                    max: 10000000
                }
            }),
        ]
    }),
    new DynamicFormGroupModel({
        id: PHOTO_GROUP_KEY,
        group: [
            new DynamicFileUploadModel({
                id: 'image',
                accept: ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/bmp'],
                maxSize: 1
            })
        ]
    })
];
/**
 * @param {?} data
 * @return {?}
 */
function mapToMachineForm(data) {
    data.technical = data.technical || (/** @type {?} */ ({}));
    return {
        baseInfoGroup: {
            id: data.id,
            manufacturer: data.technical.manufacturer,
            model: data.technical.model,
            name: data.name,
            type: data.technical.type,
            registerNumber: data.technical.registerNumber,
            serialNumber: data.technical.serialNumber,
            yearOfProduction: data.technical.yearOfProduction,
            boughtDate: mapISOStringToDatePickerValue(data.boughtDate),
            boughtPrice: data.boughtPrice
        },
        technicalInformationGroup: {
            width: data.technical.width,
            avgWorkPrice: data.avgWorkPrice,
            avgWorkPriceUnit: data.avgWorkPriceUnit,
            fuelTankSize: data.technical.fuelTankSize,
            workSpeed: data.technical.workSpeed,
            transportSpeed: data.technical.transportSpeed,
            mileage: data.technical.mileage
        },
        photoGroup: {
            image: data.image
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromMachineFormToFormData(data) {
    /** @type {?} */
    var formData = new FormData();
    formData.append('name', data.baseInfoGroup.name);
    formData.append('type', data.baseInfoGroup.type);
    if (data.baseInfoGroup.boughtDate != null) {
        formData.append('boughtDate', mapDatePickerValueToISOString(data.baseInfoGroup.boughtDate));
    }
    if (data.baseInfoGroup.boughtPrice != null) {
        formData.append('boughtPrice', data.baseInfoGroup.boughtPrice.toString());
    }
    if (data.photoGroup.image != null && data.photoGroup.image.id == null) {
        formData.append('image', data.photoGroup.image.file, data.photoGroup.image.name);
    }
    if (data.baseInfoGroup.manufacturer != null) {
        formData.append('manufacturer', data.baseInfoGroup.manufacturer);
    }
    if (data.baseInfoGroup.model != null) {
        formData.append('model', data.baseInfoGroup.model);
    }
    if (data.baseInfoGroup.registerNumber != null) {
        formData.append('registerNumber', data.baseInfoGroup.registerNumber);
    }
    if (data.baseInfoGroup.serialNumber != null) {
        formData.append('serialNumber', data.baseInfoGroup.serialNumber);
    }
    if (data.baseInfoGroup.yearOfProduction != null) {
        formData.append('yearOfProduction', data.baseInfoGroup.yearOfProduction.toString());
    }
    mapFromMachineTechnicalInformationFormToFormData(formData, data);
    return formData;
}
/**
 * @param {?} formData
 * @param {?} data
 * @return {?}
 */
function mapFromMachineTechnicalInformationFormToFormData(formData, data) {
    if (data.technicalInformationGroup.avgWorkPrice != null) {
        formData.append('avgWorkPrice', data.technicalInformationGroup.avgWorkPrice.toString());
    }
    if (data.technicalInformationGroup.avgWorkPriceUnit != null) {
        formData.append('avgWorkPriceUnit', data.technicalInformationGroup.avgWorkPriceUnit);
    }
    if (data.technicalInformationGroup.width != null) {
        formData.append('width', data.technicalInformationGroup.width.toString());
    }
    if (data.technicalInformationGroup.fuelTankSize != null) {
        formData.append('fuelTankSize', data.technicalInformationGroup.fuelTankSize.toString());
    }
    if (data.technicalInformationGroup.workSpeed != null) {
        formData.append('workSpeed', data.technicalInformationGroup.workSpeed.toString());
    }
    if (data.technicalInformationGroup.transportSpeed != null) {
        formData.append('transportSpeed', data.technicalInformationGroup.transportSpeed.toString());
    }
    if (data.technicalInformationGroup.mileage != null) {
        formData.append('mileage', data.technicalInformationGroup.mileage.toString());
    }
    return formData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineInfoComponent = /** @class */ (function () {
    function MachineInfoComponent() {
        /* Added to minimalize numer of API calls */
        this.initValueChange = new EventEmitter();
        this.update = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.formLayout = FORM_LAYOUT$3;
        this.formModel = FORM_MODEL$1;
    }
    /**
     * @return {?}
     */
    MachineInfoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    MachineInfoComponent.prototype.save = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.update.emit($event);
    };
    MachineInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-info',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n  <div class=\"card\" appPanelFullscreen>\r\n      <div class=\"card-header\">\r\n          <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n      </div>\r\n      <div class=\"card-content\">\r\n          <div class=\"card-body\">\r\n              <app-form *ngIf=\"formModel\"\r\n                  #formDetail\r\n                  [startFromIsEditing]=\"startFromIsEditing\"\r\n                  [formModel]=\"formModel\"\r\n                  [formLayout]=\"formLayout\"\r\n                  [model]=\"initValue\"\r\n                  [translateKey]=\"'MACHINE'\"\r\n                  (save)=\"save($event)\">\r\n              </app-form>\r\n          </div>\r\n      </div>\r\n  </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    MachineInfoComponent.ctorParameters = function () { return []; };
    MachineInfoComponent.propDecorators = {
        formDetail: [{ type: ViewChild, args: ['formDetail', { static: false },] }],
        startFromIsEditing: [{ type: Input }],
        id: [{ type: Input }],
        initValueChange: [{ type: Output }],
        update: [{ type: Output }],
        initValue: [{ type: Input }]
    };
    return MachineInfoComponent;
}());
if (false) {
    /** @type {?} */
    MachineInfoComponent.prototype.formDetail;
    /** @type {?} */
    MachineInfoComponent.prototype.startFromIsEditing;
    /** @type {?} */
    MachineInfoComponent.prototype.id;
    /** @type {?} */
    MachineInfoComponent.prototype.initValueChange;
    /** @type {?} */
    MachineInfoComponent.prototype.update;
    /** @type {?} */
    MachineInfoComponent.prototype.formLayout;
    /** @type {?} */
    MachineInfoComponent.prototype.formModel;
    /** @type {?} */
    MachineInfoComponent.prototype.initValue;
    /** @type {?} */
    MachineInfoComponent.prototype.displaySpinner$;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineServiceCardComponent = /** @class */ (function () {
    function MachineServiceCardComponent() {
    }
    /**
     * @return {?}
     */
    MachineServiceCardComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.serviceEntries = this.serviceEntries.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            // tslint:disable-next-line:no-magic-numbers
            x.date *= 1000;
            return x;
        }));
    };
    MachineServiceCardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-service-card',
                    template: "<div class=\"timeline\">\r\n    <div class=\"timeline-item\" *ngFor=\"let entry of serviceEntries\">\r\n        <div class=\"card\">\r\n            <div class=\"date\">\r\n                <span class=\"day\">{{ entry.date | date:'dd' }}</span>\r\n                <span class=\"month\">{{ entry.date | date:'MMM' }}</span>\r\n                <span class=\"year\">{{ entry.date | date:'yyyy' }}</span>\r\n            </div>\r\n            <div class=\"card-header\">\r\n                <h4 class=\"card-title text-center\">\r\n                    {{ entry.serviceType | enumTranslateKey: 'MACHINE.SERVICE_CARD.SERVICE_TYPE' | translate }}\r\n                </h4>\r\n                <h5 class=\"text-center\">\r\n                    {{ 'MACHINE.SERVICE_CARD.mileage' | translate}}: {{ entry.mileage | number }}\r\n                </h5>\r\n            </div>\r\n            <div class=\"card-content\">\r\n                <div class=\"description\">{{ entry.description }}</div>\r\n\r\n                <table *ngIf=\"entry.servicesList.length\" class=\"table table-striped table-hover\">\r\n                    <tr>\r\n                        <th></th>\r\n                        <th>{{ 'MACHINE.SERVICE_CARD.TABLE.name' | translate }}</th>\r\n                        <th>{{ 'MACHINE.SERVICE_CARD.TABLE.quantity' | translate }}</th>\r\n                        <th>{{ 'MACHINE.SERVICE_CARD.TABLE.unit' | translate }}</th>\r\n                        <th>{{ 'MACHINE.SERVICE_CARD.TABLE.unitPrice' | translate }}</th>\r\n                    </tr>\r\n                    <tr *ngFor=\"let element of entry.servicesList\">\r\n                        <td>\r\n                            {{element.icon}}\r\n                            <i class=\"ft {{ element.icon }}\"></i>\r\n                        </td>\r\n                        <td>\r\n                            {{ element.name }}\r\n                            <span *ngIf=\"element.catalogNumber\"><br/>({{ element.catalogNumber }})</span>\r\n                            <span *ngIf=\"element.manufacturer\"><br/><u>{{ element.manufacturer }}</u></span>\r\n                        </td>\r\n                        <td>{{ element.quantity }}</td>\r\n                        <td>{{ element.unit | enumTranslateKey: 'MACHINE.SERVICE_CARD.QUANTITY' | translate }}</td>\r\n                        <td>{{ element.unitPrice }}</td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"line\"></div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".timeline{position:relative;margin-top:30px}.timeline .line{position:absolute;height:100%;border:2px solid #5b5b5b;width:1px;left:calc(50% - 1px);z-index:0;top:0}.timeline .timeline-item{position:relative;width:calc(50% - 80px);float:left;margin-left:15px}.timeline .timeline-item:nth-of-type(2n){margin-left:130px;margin-top:130px}.timeline .timeline-item:nth-of-type(2n) .date{left:-105px;right:auto}.timeline .timeline-item .date{position:absolute;background:#a90404;text-align:center;border-radius:10px;width:80px;color:#fff;padding-top:10px;padding-bottom:5px;right:-105px;z-index:10}.timeline .timeline-item .date .day,.timeline .timeline-item .date .month,.timeline .timeline-item .date .year{display:block}.timeline .timeline-item .date .month,.timeline .timeline-item .date .year{margin-top:-5px;font-size:14px}.timeline .timeline-item .date .day{font-weight:700;font-size:20px}.timeline .timeline-item .description{padding:10px}.tab-content{background:0 0}"]
                }] }
    ];
    MachineServiceCardComponent.propDecorators = {
        serviceEntries: [{ type: Input }]
    };
    return MachineServiceCardComponent;
}());
if (false) {
    /** @type {?} */
    MachineServiceCardComponent.prototype.serviceEntries;
}

var _a$f;
/** @type {?} */
var ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY = 'alarmConfEntryElements';
/** @type {?} */
var CONTAINER = 'form-group row';
/** @type {?} */
var ONE_COLUMNS = 'col-12';
/** @type {?} */
var ELEMENTS_LABEL = 'dynamic-form-array-item-label';
/** @type {?} */
var ALARM_CONF_ENTRY_FORM_LAYOUT = (_a$f = {},
    _a$f[ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY] = {
        grid: {
            host: ONE_COLUMNS,
            container: CONTAINER,
            label: 'd-none',
            control: 'col-12'
        }
    },
    _a$f.elements = {
        grid: {
            host: '',
            container: '',
            label: ELEMENTS_LABEL,
            control: ''
        }
    },
    _a$f);
var ɵ0$b = /**
 * @return {?}
 */
function () {
    return [
        new DynamicMachineAlarmConfElementsFormControlModel({
            id: 'elements',
            translateKey: 'MACHINE.ALARMS_CONFIGURATION.entryForm.elementsSection',
            validators: {
                machineAlarmConfElementsValidator: {}
            }
        })
    ];
};
/** @type {?} */
var ALARM_CONF_ENTRY_FORM_MODEL = [
    new DynamicFormArrayModel({
        id: ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY,
        initialCount: 1,
        groupFactory: (ɵ0$b)
    })
];
/**
 * @param {?} data
 * @return {?}
 */
function mapToServiceAlarmConfEntryForm(data) {
    /** @type {?} */
    var formData = (/** @type {?} */ ({}));
    formData[ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY] = [{
            elements: {
                elements: data
            }
        }];
    return formData;
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromServiceAlarmConfEntryFormToCreateAlarmConfCommand(data) {
    /** @type {?} */
    var command = [];
    if (data == null) {
        return command;
    }
    if (data[ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY] != null
        && data[ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY].length > 0
        && data[ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY][0].elements !== null
        && data[ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY][0].elements.elements !== null) {
        command.push.apply(command, __spread(data[ALARM_CONF_ENTRY_ELEMENTS_GROUP_KEY][0].elements.elements.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return __assign({}, x, { values: [x.value] });
        }))));
    }
    return command;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineAlarmConfigurationFormComponent = /** @class */ (function () {
    function MachineAlarmConfigurationFormComponent() {
        this.result = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.startFromIsEditing = false;
    }
    /**
     * @return {?}
     */
    MachineAlarmConfigurationFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formLayout = ALARM_CONF_ENTRY_FORM_LAYOUT;
        this.formModel = ALARM_CONF_ENTRY_FORM_MODEL;
        this.formData = mapToServiceAlarmConfEntryForm(this.initValue);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    MachineAlarmConfigurationFormComponent.prototype.add = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var data = mapFromServiceAlarmConfEntryFormToCreateAlarmConfCommand($event);
        this.result.emit(data);
    };
    MachineAlarmConfigurationFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-alarm-configuration-form',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header d-flex\">\r\n            <h2>{{ 'MACHINE.ALARMS_CONFIGURATION.update:header' | translate }}</h2>\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <app-form\r\n                    *ngIf=\"formModel\"\r\n                    #addForm\r\n                    [formModel]=\"formModel\"\r\n                    [formLayout]=\"formLayout\"\r\n                    [startFromIsEditing]=\"startFromIsEditing\"\r\n                    [model]=\"formData\"\r\n                    (save)=\"add($event)\"\r\n                    [translateKey]=\"'MACHINE.ALARMS_CONFIGURATION'\">\r\n                </app-form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    MachineAlarmConfigurationFormComponent.propDecorators = {
        id: [{ type: Input }],
        initValue: [{ type: Input }],
        result: [{ type: Output }]
    };
    return MachineAlarmConfigurationFormComponent;
}());
if (false) {
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.id;
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.initValue;
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.result;
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.displaySpinner$;
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.formLayout;
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.formModel;
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.formData;
    /** @type {?} */
    MachineAlarmConfigurationFormComponent.prototype.startFromIsEditing;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineGeneratedAlarmsComponent = /** @class */ (function () {
    function MachineGeneratedAlarmsComponent() {
        this.detail = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MachineGeneratedAlarmsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.displayedColumns = ['alarmType', 'date', 'location', 'machine', 'worker', 'action'];
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    MachineGeneratedAlarmsComponent.prototype.onDetailClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.detail.emit(item);
    };
    MachineGeneratedAlarmsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-machine-generated-alarms',
                    template: "<div class=\"mb-2\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header pt-3\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\">\r\n                    <i class=\"ft ft-list\"></i> {{ 'MACHINE.generatedAlarms:header' | translate}}\r\n                </h5>\r\n            </label>\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body\">\r\n                <div class=\"container-fluid\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"name\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"alarmType\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\">{{ 'MACHINE.ALARMS.alarmType' |\r\n                                translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">\r\n                                {{ element.alarmTypeTranslateKey | dictionaryTranslateKey | translate }}\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"date\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-2 pr-0\">\r\n                                {{ 'MACHINE.ALARMS.date' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.timestamp |\r\n                                date:'dd-MM-yyyy HH:mm' }}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"location\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\">{{ 'MACHINE.ALARMS.location' |\r\n                                translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.ground?.name }}</div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"machine\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 col-xl-3 pr-0\">\r\n                                {{ 'MACHINE.ALARMS.machine' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 col-xl-3 pr-0\">\r\n                                {{ element.machine?.name }}\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"worker\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-1 pr-0\">\r\n                                {{ 'MACHINE.ALARMS.worker' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-1 pr-0\">{{ element.worker?.fullName }}\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-3 col-xl-2 text-md-right\">\r\n                                {{ 'APPLICATION.LIST.action' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"col-3 col-xl-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-md-end\">\r\n                                    <button (click)=\"onDetailClick(element)\"\r\n                                        title=\"{{ 'MACHINE.ALARMS.detail:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-info\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\"\r\n                            *cdkHeaderRowDef=\"displayedColumns\">\r\n                        </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\"\r\n                            *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'MACHINE.ALARMS.list:empty' | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'MACHINE.ALARMS.list:error' | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\"\r\n                        [pageSizeOptions]=\"[10,25,50,75,100]\" showFirstLastButtons></cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    MachineGeneratedAlarmsComponent.propDecorators = {
        dataSource: [{ type: Input }],
        detail: [{ type: Output }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return MachineGeneratedAlarmsComponent;
}());
if (false) {
    /** @type {?} */
    MachineGeneratedAlarmsComponent.prototype.dataSource;
    /** @type {?} */
    MachineGeneratedAlarmsComponent.prototype.detail;
    /** @type {?} */
    MachineGeneratedAlarmsComponent.prototype.displayedColumns;
    /** @type {?} */
    MachineGeneratedAlarmsComponent.prototype.sort;
    /** @type {?} */
    MachineGeneratedAlarmsComponent.prototype.paginator;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineSharedModule = /** @class */ (function () {
    function MachineSharedModule() {
    }
    MachineSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        MachineListTableComponent,
                        MachineInfoComponent,
                        MachineServiceCardComponent,
                        MachineAlarmConfigurationFormComponent,
                        MachineGeneratedAlarmsComponent
                    ],
                    entryComponents: [
                        MachineListTableComponent,
                        MachineInfoComponent,
                        MachineServiceCardComponent,
                        MachineAlarmConfigurationFormComponent,
                        MachineGeneratedAlarmsComponent
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        NgbModule,
                        ChartsModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule,
                        GoogleMapsSharedModule,
                        FormSharedModule,
                        TableSharedModule,
                        RouterModule,
                        TranslateModule,
                        PureGoogleMapsSharedModule,
                        ModalSharedModule,
                        TranslationModule
                    ],
                    exports: [
                        MachineListTableComponent,
                        MachineInfoComponent,
                        MachineServiceCardComponent,
                        MachineAlarmConfigurationFormComponent,
                        MachineGeneratedAlarmsComponent
                    ],
                    providers: [DecimalPipe, MapService]
                },] }
    ];
    return MachineSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineListFilter = /** @class */ (function () {
    function MachineListFilter(name, type, yearOfProductionFrom, yearOfProductionTo, mileageFrom, mileageTo) {
        this.name = name;
        this.type = type;
        this.yearOfProductionFrom = yearOfProductionFrom;
        this.yearOfProductionTo = yearOfProductionTo;
        this.mileageFrom = mileageFrom;
        this.mileageTo = mileageTo;
    }
    return MachineListFilter;
}());
if (false) {
    /** @type {?} */
    MachineListFilter.prototype.name;
    /** @type {?} */
    MachineListFilter.prototype.type;
    /** @type {?} */
    MachineListFilter.prototype.yearOfProductionFrom;
    /** @type {?} */
    MachineListFilter.prototype.yearOfProductionTo;
    /** @type {?} */
    MachineListFilter.prototype.mileageFrom;
    /** @type {?} */
    MachineListFilter.prototype.mileageTo;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function MachineListItem() { }
if (false) {
    /** @type {?} */
    MachineListItem.prototype.id;
    /** @type {?} */
    MachineListItem.prototype.name;
    /** @type {?} */
    MachineListItem.prototype.type;
    /** @type {?} */
    MachineListItem.prototype.serialNumber;
    /** @type {?} */
    MachineListItem.prototype.registerNumber;
    /** @type {?} */
    MachineListItem.prototype.mileage;
    /** @type {?} */
    MachineListItem.prototype.image;
    /** @type {?|undefined} */
    MachineListItem.prototype.location;
    /** @type {?|undefined} */
    MachineListItem.prototype.lastActiveDate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StorageSensorServicesModule = /** @class */ (function () {
    function StorageSensorServicesModule() {
    }
    StorageSensorServicesModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return StorageSensorServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StorageSensorDataProxyService = /** @class */ (function () {
    function StorageSensorDataProxyService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.apiUrl = this.config.configuration.api_url + "/v1/weatherstations/weatherdata";
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    StorageSensorDataProxyService.prototype.getSpecyficMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        // note: HttpParams generated wrong query string array=value1,value2 instead of array=value1&array=value2
        /** @type {?} */
        var params = {
            stationId: measurementFilter.stationId,
            measurementTypes: measurementFilter.measurementTypes.map((/**
             * @param {?} v
             * @return {?}
             */
            function (v) { return v.toString(); })),
            dateFrom: measurementFilter.dateFrom.toDateString(),
            dateTo: measurementFilter.dateTo.toDateString()
        };
        // tslint:disable-next-line: no-any
        return this.httpClient.get(this.apiUrl + "/" + deviceType, { params: params });
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    StorageSensorDataProxyService.prototype.getMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        // note: HttpParams generated wrong query string array=value1,value2 instead of array=value1&array=value2
        /** @type {?} */
        var params = {
            stationId: measurementFilter.stationId,
            dateFrom: measurementFilter.dateFrom.toDateString(),
            dateTo: measurementFilter.dateTo.toDateString()
        };
        // tslint:disable-next-line: no-any
        return this.httpClient.get(this.apiUrl + "/" + deviceType + "/measures", { params: params });
    };
    StorageSensorDataProxyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: StorageSensorServicesModule
                },] }
    ];
    /** @nocollapse */
    StorageSensorDataProxyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    /** @nocollapse */ StorageSensorDataProxyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StorageSensorDataProxyService_Factory() { return new StorageSensorDataProxyService(ɵɵinject(HttpClient), ɵɵinject(AppConfigurationService)); }, token: StorageSensorDataProxyService, providedIn: StorageSensorServicesModule });
    return StorageSensorDataProxyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    StorageSensorDataProxyService.prototype.apiUrl;
    /**
     * @type {?}
     * @private
     */
    StorageSensorDataProxyService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    StorageSensorDataProxyService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StorageSensorDataListService = /** @class */ (function () {
    function StorageSensorDataListService(storageSensorDataProxyService) {
        this.storageSensorDataProxyService = storageSensorDataProxyService;
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    StorageSensorDataListService.prototype.getSpecyficMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        return this.storageSensorDataProxyService.getSpecyficMeasurements(deviceType, measurementFilter);
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    StorageSensorDataListService.prototype.getMeasurements = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} deviceType
     * @param {?} measurementFilter
     * @return {?}
     */
    function (deviceType, measurementFilter) {
        return this.storageSensorDataProxyService.getMeasurements(deviceType, measurementFilter);
    };
    StorageSensorDataListService.decorators = [
        { type: Injectable, args: [{
                    providedIn: StorageSensorServicesModule
                },] }
    ];
    /** @nocollapse */
    StorageSensorDataListService.ctorParameters = function () { return [
        { type: StorageSensorDataProxyService }
    ]; };
    /** @nocollapse */ StorageSensorDataListService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StorageSensorDataListService_Factory() { return new StorageSensorDataListService(ɵɵinject(StorageSensorDataProxyService)); }, token: StorageSensorDataListService, providedIn: StorageSensorServicesModule });
    return StorageSensorDataListService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    StorageSensorDataListService.prototype.storageSensorDataProxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var STORAGE_SENSOR_MEASUREMENT_TYPES_KEY = 'APPLICATION.DICTIONARIES.StorageSensorMeasurementTypes.';
var StorageSensorMeasurementsComponent = /** @class */ (function () {
    function StorageSensorMeasurementsComponent(storageSensorDataListService, translateService, calendar, ngZone) {
        this.storageSensorDataListService = storageSensorDataListService;
        this.translateService = translateService;
        this.calendar = calendar;
        this.ngZone = ngZone;
        this.dataReady = false;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.lineChartAirTemperatureData = [{ data: [], label: '' }];
        this.lineChartAirHumidityData = [{ data: [], label: '' }];
        this.lineChartCO2Data = [{ data: [], label: '' }];
        this.lineChartAirPressureData = [{ data: [], label: '' }];
        this.lineChartBatteryPercentageData = [{ data: [], label: '' }];
        this.StorageSensorMeasurementTypes = StorageSensorMeasurementTypes;
        this.lineChartColors = [
            {
                // grey
                backgroundColor: 'rgba(148,159,177,0.2)',
                // tslint:disable-next-line: no-duplicate-string
                borderColor: 'rgba(148,159,177,1)',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
                // red
                backgroundColor: 'rgba(255,0,0,0.3)',
                borderColor: 'red',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
                // green
                backgroundColor: 'rgba(0,255,0,0.3)',
                borderColor: 'red',
                pointBackgroundColor: 'rgba(0,0,255,0.3)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(255,255,0,0.3)'
            }
        ];
        this.lineChartLegend = true;
        this.lineChartType = 'line';
        this.unsubscribe$ = new Subject();
    }
    /**
     * @return {?}
     */
    StorageSensorMeasurementsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dateFrom = this.calendar.getToday();
        this.dateTo = this.calendar.getToday();
        this.setupOneLineChartOptions();
        this.getData();
        // refresh chart when language was changed
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.chartRef.forEach((/**
                 * @param {?} chart
                 * @return {?}
                 */
                function (chart) { return chart.update(); }));
            }));
        }));
    };
    /**
     * @return {?}
     */
    StorageSensorMeasurementsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    StorageSensorMeasurementsComponent.prototype.onDateSelect = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (NgbDate.from(this.dateFrom).after(NgbDate.from(this.dateTo))) {
            this.dateShowValidationError = true;
        }
        else {
            this.dateShowValidationError = false;
            this.getData();
        }
    };
    Object.defineProperty(StorageSensorMeasurementsComponent.prototype, "isBatteryDevice", {
        get: /**
         * @return {?}
         */
        function () {
            return this.deviceType === DeviceType.StoragePrismSensor;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    StorageSensorMeasurementsComponent.prototype.setupOneLineChartOptions = /**
     * @return {?}
     */
    function () {
        this.lineChartOptions = {
            responsive: true,
            scales: {
                // We use this empty structure as a placeholder for dynamic theming.
                // https://www.chartjs.org/docs/latest/axes/cartesian/time.html
                xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: DateTime.DATETIME_MED,
                            displayFormats: { day: 'LLL dd' },
                            unit: 'day'
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        position: 'left',
                    }
                ]
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'vertical',
                        scaleID: 'x-axis-0',
                        value: 'March',
                        borderColor: 'orange',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            fontColor: 'orange',
                            content: 'LineAnno'
                        }
                    },
                ],
            },
        };
    };
    /**
     * @return {?}
     */
    StorageSensorMeasurementsComponent.prototype.getData = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.dataReady = false;
        this.chartFilter = {
            stationId: this.id,
            dateFrom: new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day),
            dateTo: new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day),
        };
        /** @type {?} */
        var converhPa = (/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            // tslint:disable-next-line: no-magic-numbers
            return x != null ? Math.round(x) / 100 : x;
        });
        this.storageSensorDataListService.getMeasurements(this.deviceType, this.chartFilter).pipe(finalize((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(false);
            _this.dataReady = true;
        })), takeUntil(this.unsubscribe$)).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                // tslint:disable: no-magic-numbers
                _this.lineChartAirTemperatureData = _this.prepareChartWithOneAxis(data, 3, StorageSensorMeasurementTypes.AirTemperature);
                _this.lineChartAirHumidityData = _this.prepareChartWithOneAxis(data, 1, StorageSensorMeasurementTypes.AirHumidity);
                _this.lineChartCO2Data = _this.prepareChartWithOneAxis(data, 14, StorageSensorMeasurementTypes.CO2);
                // tslint:disable-next-line: max-line-length
                _this.lineChartAirPressureData = _this.prepareChartWithOneAxis(data, 2, StorageSensorMeasurementTypes.AirPressure, converhPa);
                // tslint:disable-next-line: max-line-length
                _this.lineChartBatteryPercentageData = _this.prepareChartWithOneAxis(data, 5, StorageSensorMeasurementTypes.BatteryPercentage);
            }
        }));
    };
    /**
     * @private
     * @param {?} data
     * @param {?} index
     * @param {?} measurementType
     * @param {?=} calculateValue
     * @return {?}
     */
    StorageSensorMeasurementsComponent.prototype.prepareChartWithOneAxis = /**
     * @private
     * @param {?} data
     * @param {?} index
     * @param {?} measurementType
     * @param {?=} calculateValue
     * @return {?}
     */
    function (
    // tslint:disable-next-line: no-any
    data, index, measurementType, 
    // tslint:disable-next-line: no-any
    calculateValue) {
        if (calculateValue === void 0) { calculateValue = (/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x; }); }
        // tslint:disable-next-line: no-any
        /** @type {?} */
        var firstResult = [];
        data.forEach((/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            firstResult.push({
                x: DateTime.fromISO(element[0]).toISO(),
                y: calculateValue(element[index])
            });
        }));
        return [
            {
                data: firstResult,
                label: this.getLabel(measurementType)
            }
        ];
    };
    /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    StorageSensorMeasurementsComponent.prototype.getLabel = /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    function (measure) {
        return this.translateService.instant(STORAGE_SENSOR_MEASUREMENT_TYPES_KEY + StorageSensorMeasurementTypes[measure]);
    };
    StorageSensorMeasurementsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-storage-sensor-measurements',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header\">\r\n        <div class=\"card-header d-flex pl-0\">\r\n            <div>\r\n                <form class=\"form-inline\">\r\n                    <div class=\"form-group\">\r\n                        <div class=\"input-group col-9 col-md-5 mx-0 mr-md-1\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpFrom\"\r\n                                [(ngModel)]=\"dateFrom\"\r\n                                ngbDatepicker\r\n                                #d1=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d1.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"input-group col-9 col-md-5 mx-0\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpTo\"\r\n                                [(ngModel)]=\"dateTo\"\r\n                                ngbDatepicker\r\n                                #d2=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d2.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div *ngIf=\"dateShowValidationError\">\r\n                        <small class=\"form-text text-danger\">\r\n                            {{ 'WEATHERSTATION.validation:dateFromAfterDateTo' | translate }}\r\n                        </small>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container-fluid\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-12 chart-container\" [appSpinner]=\"displaySpinner$ | async\">\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartAirTemperatureData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\" ></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartAirHumidityData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartAirPressureData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartCO2Data\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"></canvas>\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"100\"\r\n                            [datasets]=\"lineChartBatteryPercentageData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"isBatteryDevice && dataReady\"></canvas>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["dt{font-weight:100}.chart-container{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center}"]
                }] }
    ];
    /** @nocollapse */
    StorageSensorMeasurementsComponent.ctorParameters = function () { return [
        { type: StorageSensorDataListService },
        { type: TranslateService },
        { type: NgbCalendar },
        { type: NgZone }
    ]; };
    StorageSensorMeasurementsComponent.propDecorators = {
        id: [{ type: Input }],
        deviceType: [{ type: Input }],
        chartRef: [{ type: ViewChildren, args: [BaseChartDirective,] }]
    };
    return StorageSensorMeasurementsComponent;
}());
if (false) {
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.id;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.deviceType;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.dateFrom;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.dateTo;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.dateShowValidationError;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.dataReady;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.chartFilter;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.displaySpinner$;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartAirTemperatureData;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartAirHumidityData;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartCO2Data;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartAirPressureData;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartBatteryPercentageData;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.StorageSensorMeasurementTypes;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartOptions;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartColors;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartLegend;
    /** @type {?} */
    StorageSensorMeasurementsComponent.prototype.lineChartType;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementsComponent.prototype.unsubscribe$;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementsComponent.prototype.chartRef;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementsComponent.prototype.storageSensorDataListService;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementsComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementsComponent.prototype.calendar;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementsComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var STORAGE_SENSOR_MEASUREMENT_TYPES_KEY$1 = 'APPLICATION.DICTIONARIES.StorageSensorMeasurementTypes.';
var StorageSensorMeasurementComponent = /** @class */ (function () {
    function StorageSensorMeasurementComponent(storageSensorDataListService, translateService, calendar, ngZone) {
        this.storageSensorDataListService = storageSensorDataListService;
        this.translateService = translateService;
        this.calendar = calendar;
        this.ngZone = ngZone;
        this.dataReady = false;
        this.selectedMeasures = [];
        this.activateMeasureSelection = true;
        this.displaySpinner$ = new BehaviorSubject(false);
        this.lineChartData = [{ data: [], label: '' }];
        this.StorageSensorMeasurementTypes = StorageSensorMeasurementTypes;
        this.lineChartColors = [
            {
                // grey
                backgroundColor: 'rgba(148,159,177,0.2)',
                // tslint:disable-next-line: no-duplicate-string
                borderColor: 'rgba(148,159,177,1)',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
                // red
                backgroundColor: 'rgba(255,0,0,0.3)',
                borderColor: 'red',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            }
        ];
        this.lineChartLegend = true;
        this.lineChartType = 'line';
        this.unsubscribe$ = new Subject();
    }
    Object.defineProperty(StorageSensorMeasurementComponent.prototype, "isBatteryDevice", {
        get: /**
         * @return {?}
         */
        function () {
            return this.deviceType === DeviceType.StoragePrismSensor;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dateFrom = this.calendar.getToday();
        this.dateTo = this.calendar.getToday();
        this.setupOneLineChartOptions();
        // refresh chart when language was changed
        this.translateService.onLangChange
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.ngZone.run((/**
             * @return {?}
             */
            function () {
                _this.chartRef.update();
            }));
        }));
    };
    /**
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @param {?} event
     * @param {?} item
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.onValueChange = /**
     * @param {?} event
     * @param {?} item
     * @return {?}
     */
    function (event, item) {
        if (event) {
            this.selectedMeasures.push(item);
            // tslint:disable-next-line: no-magic-numbers
            if (this.selectedMeasures.length === 2) {
                this.activateMeasureSelection = false;
            }
        }
        else {
            this.selectedMeasures.splice(this.selectedMeasures.indexOf(item), 1);
            this.activateMeasureSelection = true;
        }
        if (this.selectedMeasures.length === 1) {
            this.setupOneLineChartOptions();
            this.getData();
            // tslint:disable-next-line: no-magic-numbers
        }
        else if (this.selectedMeasures.length === 2) {
            this.setupTwoLineChartOptions();
            this.getData();
        }
        else {
            this.lineChartData = [
                { data: [], label: '' }
            ];
            this.dataReady = false;
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.onDateSelect = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (NgbDate.from(this.dateFrom).after(NgbDate.from(this.dateTo))) {
            this.dateShowValidationError = true;
        }
        else {
            this.dateShowValidationError = false;
            if (this.selectedMeasures.length > 0) {
                this.getData();
            }
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.isMeasureSelected = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return this.selectedMeasures.indexOf(item) !== -1;
    };
    /**
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.setupOneLineChartOptions = /**
     * @return {?}
     */
    function () {
        this.lineChartOptions = {
            responsive: true,
            scales: {
                // We use this empty structure as a placeholder for dynamic theming.
                // https://www.chartjs.org/docs/latest/axes/cartesian/time.html
                xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: DateTime.DATETIME_MED,
                            displayFormats: { day: 'LLL dd' },
                            unit: 'day'
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        position: 'left',
                    }
                ]
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'vertical',
                        scaleID: 'x-axis-0',
                        value: 'March',
                        borderColor: 'orange',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            fontColor: 'orange',
                            content: 'LineAnno'
                        }
                    },
                ],
            },
        };
    };
    /**
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.setupTwoLineChartOptions = /**
     * @return {?}
     */
    function () {
        this.lineChartOptions = {
            responsive: true,
            scales: {
                xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: DateTime.DATETIME_MED,
                            displayFormats: { day: 'LLL dd' },
                            unit: 'day'
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        position: 'left',
                    },
                    {
                        id: 'y-axis-1',
                        position: 'right'
                    }
                ]
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'vertical',
                        scaleID: 'x-axis-0',
                        value: 'March',
                        borderColor: 'orange',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            fontColor: 'orange',
                            content: 'LineAnno'
                        }
                    }
                ],
            },
        };
    };
    /**
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.getData = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displaySpinner$.next(true);
        this.dataReady = false;
        this.chartFilter = {
            stationId: this.id,
            measurementTypes: this.selectedMeasures,
            dateFrom: new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day),
            dateTo: new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day),
        };
        this.storageSensorDataListService.getSpecyficMeasurements(this.deviceType, this.chartFilter).pipe(finalize((/**
         * @return {?}
         */
        function () {
            _this.displaySpinner$.next(false);
            _this.dataReady = true;
        })), takeUntil(this.unsubscribe$)).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                // tslint:disable-next-line: no-any
                /** @type {?} */
                var firstResult_1 = [];
                // tslint:disable-next-line: no-any
                /** @type {?} */
                var secondResult_1 = [];
                data.forEach((/**
                 * @param {?} element
                 * @return {?}
                 */
                function (element) {
                    firstResult_1.push({
                        x: DateTime.fromISO(element[0]).toISO(),
                        y: _this.calculateValue(element[1], _this.selectedMeasures[0])
                    });
                    // tslint:disable-next-line: no-magic-numbers
                    if (element.length === 3) {
                        secondResult_1.push({
                            x: DateTime.fromISO(element[0]).toISO(),
                            // tslint:disable-next-line: no-magic-numbers
                            y: _this.calculateValue(element[2], _this.selectedMeasures[1])
                        });
                    }
                }));
                // tslint:disable-next-line: no-magic-numbers
                if (_this.selectedMeasures.length === 2) {
                    _this.lineChartData = [
                        {
                            data: firstResult_1,
                            label: _this.getLabel(_this.selectedMeasures[0])
                        },
                        {
                            data: secondResult_1,
                            label: _this.getLabel(_this.selectedMeasures[1])
                        },
                    ];
                }
                else {
                    _this.lineChartData = [
                        {
                            data: firstResult_1,
                            label: _this.getLabel(_this.selectedMeasures[0])
                        },
                    ];
                }
            }
        }));
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} value
     * @param {?} measurementType
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.calculateValue = 
    // tslint:disable-next-line: no-any
    /**
     * @private
     * @param {?} value
     * @param {?} measurementType
     * @return {?}
     */
    function (value, measurementType) {
        if (measurementType === StorageSensorMeasurementTypes.AirPressure) {
            // tslint:disable-next-line: no-magic-numbers
            return value != null ? Math.round(value) / 100 : value;
        }
        return value;
    };
    /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    StorageSensorMeasurementComponent.prototype.getLabel = /**
     * @private
     * @param {?} measure
     * @return {?}
     */
    function (measure) {
        return this.translateService.instant(STORAGE_SENSOR_MEASUREMENT_TYPES_KEY$1 + StorageSensorMeasurementTypes[measure]);
    };
    StorageSensorMeasurementComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-storage-sensor-measurement',
                    template: "<div class=\"card\" appPanelFullscreen>\r\n    <div class=\"card-header\">\r\n        <div class=\"card-header d-flex pl-0\">\r\n            <div>\r\n                <form class=\"form-inline\">\r\n                    <div class=\"form-group\">\r\n                        <div class=\"input-group col-9 col-md-5 mx-0 mr-md-1\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpFrom\"\r\n                                [(ngModel)]=\"dateFrom\"\r\n                                ngbDatepicker\r\n                                #d1=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d1.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"input-group col-9 col-md-5 mx-0\">\r\n                            <input\r\n                                class=\"form-control\"\r\n                                placeholder=\"yyyy-mm-dd\"\r\n                                name=\"dpTo\"\r\n                                [(ngModel)]=\"dateTo\"\r\n                                ngbDatepicker\r\n                                #d2=\"ngbDatepicker\"\r\n                                (dateSelect)=\"onDateSelect($event)\"\r\n                            />\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-outline-secondary calendar\" (click)=\"d2.toggle()\" type=\"button\"></button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div *ngIf=\"dateShowValidationError\">\r\n                        <small class=\"form-text text-danger\">\r\n                            {{ 'STORAGESENSOR.validation:dateFromAfterDateTo' | translate }}\r\n                        </small>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n            <div class=\"ml-auto\">\r\n                <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body\">\r\n            <div class=\"container-fluid\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-12 col-lg-7 order-lg-2 chart-container\" [appSpinner]=\"displaySpinner$ | async\">\r\n                        <canvas\r\n                            baseChart\r\n                            height=\"200\"\r\n                            [datasets]=\"lineChartData\"\r\n                            [options]=\"lineChartOptions\"\r\n                            [colors]=\"lineChartColors\"\r\n                            [legend]=\"lineChartLegend\"\r\n                            [chartType]=\"lineChartType\"\r\n                            *ngIf=\"dataReady\"\r\n                        ></canvas>\r\n                        <div *ngIf=\"selectedMeasures.length === 0\" class=\"text-center align-self-center\">\r\n                                {{ 'STORAGESENSOR.chart:empty' | translate }}\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-12 col-lg-5 order-lg-1 mt-3 mt-lg-2\">\r\n                        <dl class=\"row\">\r\n                            <dt class=\"col-9\">\r\n                                {{ 'APPLICATION.DICTIONARIES.StorageSensorMeasurementTypes.AirTemperature' | translate }}\r\n                            </dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, StorageSensorMeasurementTypes.AirTemperature)\"\r\n                                    [disabled]=\"!isMeasureSelected(StorageSensorMeasurementTypes.AirTemperature) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">{{ 'APPLICATION.DICTIONARIES.StorageSensorMeasurementTypes.AirHumidity' | translate }}</dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, StorageSensorMeasurementTypes.AirHumidity)\"\r\n                                    [disabled]=\"!isMeasureSelected(StorageSensorMeasurementTypes.AirHumidity) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n\r\n                            <dt class=\"col-9\">{{ 'APPLICATION.DICTIONARIES.StorageSensorMeasurementTypes.CO2' | translate }}</dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, StorageSensorMeasurementTypes.CO2)\"\r\n                                    [disabled]=\"!isMeasureSelected(StorageSensorMeasurementTypes.CO2) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\">{{ 'APPLICATION.DICTIONARIES.StorageSensorMeasurementTypes.AirPressure' | translate }}</dt>\r\n                            <dd class=\"col-3\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, StorageSensorMeasurementTypes.AirPressure)\"\r\n                                    [disabled]=\"!isMeasureSelected(StorageSensorMeasurementTypes.AirPressure) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n\r\n                            <dt class=\"col-9\" *ngIf=\"isBatteryDevice\">{{ 'APPLICATION.DICTIONARIES.StorageSensorMeasurementTypes.BatteryPercentage' | translate }}</dt>\r\n                            <dd class=\"col-3\" *ngIf=\"isBatteryDevice\">\r\n                                <ui-switch\r\n                                    size=\"small\"\r\n                                    (valueChange)=\"onValueChange($event, StorageSensorMeasurementTypes.BatteryPercentage)\"\r\n                                    [disabled]=\"!isMeasureSelected(StorageSensorMeasurementTypes.BatteryPercentage) && !activateMeasureSelection\"\r\n                                ></ui-switch>\r\n                            </dd>\r\n                        </dl>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["dt{font-weight:100}.chart-container{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center}"]
                }] }
    ];
    /** @nocollapse */
    StorageSensorMeasurementComponent.ctorParameters = function () { return [
        { type: StorageSensorDataListService },
        { type: TranslateService },
        { type: NgbCalendar },
        { type: NgZone }
    ]; };
    StorageSensorMeasurementComponent.propDecorators = {
        id: [{ type: Input }],
        deviceType: [{ type: Input }],
        chartRef: [{ type: ViewChild, args: [BaseChartDirective, { static: false },] }]
    };
    return StorageSensorMeasurementComponent;
}());
if (false) {
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.id;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.deviceType;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.dateFrom;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.dateTo;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.dateShowValidationError;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.dataReady;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.selectedMeasures;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.activateMeasureSelection;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.chartFilter;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.displaySpinner$;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.lineChartData;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.StorageSensorMeasurementTypes;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.lineChartOptions;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.lineChartColors;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.lineChartLegend;
    /** @type {?} */
    StorageSensorMeasurementComponent.prototype.lineChartType;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementComponent.prototype.unsubscribe$;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementComponent.prototype.chartRef;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementComponent.prototype.storageSensorDataListService;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementComponent.prototype.calendar;
    /**
     * @type {?}
     * @private
     */
    StorageSensorMeasurementComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StorageSensorSharedModule = /** @class */ (function () {
    function StorageSensorSharedModule() {
    }
    StorageSensorSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [StorageSensorMeasurementsComponent, StorageSensorMeasurementComponent],
                    entryComponents: [StorageSensorMeasurementsComponent, StorageSensorMeasurementComponent],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        NgbModule,
                        StorageSensorServicesModule,
                        ChartsModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule
                    ],
                    exports: [
                        StorageSensorMeasurementsComponent,
                        StorageSensorMeasurementComponent,
                        NgbModule,
                    ]
                },] }
    ];
    return StorageSensorSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Machine() { }
if (false) {
    /** @type {?} */
    Machine.prototype.id;
    /** @type {?} */
    Machine.prototype.name;
    /** @type {?} */
    Machine.prototype.organizationId;
    /** @type {?} */
    Machine.prototype.avgWorkPrice;
    /** @type {?} */
    Machine.prototype.avgWorkPriceUnit;
    /** @type {?} */
    Machine.prototype.boughtDate;
    /** @type {?} */
    Machine.prototype.boughtPrice;
    /** @type {?} */
    Machine.prototype.image;
    /** @type {?} */
    Machine.prototype.technical;
}
/**
 * @record
 */
function MachineTechnicalInfo() { }
if (false) {
    /** @type {?} */
    MachineTechnicalInfo.prototype.manufacturer;
    /** @type {?} */
    MachineTechnicalInfo.prototype.model;
    /** @type {?} */
    MachineTechnicalInfo.prototype.serialNumber;
    /** @type {?} */
    MachineTechnicalInfo.prototype.registerNumber;
    /** @type {?} */
    MachineTechnicalInfo.prototype.type;
    /** @type {?} */
    MachineTechnicalInfo.prototype.width;
    /** @type {?} */
    MachineTechnicalInfo.prototype.yearOfProduction;
    /** @type {?} */
    MachineTechnicalInfo.prototype.fuelTankSize;
    /** @type {?} */
    MachineTechnicalInfo.prototype.workSpeed;
    /** @type {?} */
    MachineTechnicalInfo.prototype.transportSpeed;
    /** @type {?} */
    MachineTechnicalInfo.prototype.mileage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function MachineForm() { }
if (false) {
    /* Skipping unnamed member:
    [BASE_INFO_GROUP_KEY]: {
            id: string,
            manufacturer: string,
            model: string,
            name: string,
            type: string,
            registerNumber: string,
            serialNumber: string,
            yearOfProduction: number,
            boughtDate: DatePickerValue,
            boughtPrice: number
        },*/
    /* Skipping unnamed member:
    [TECHNICAL_INFORMATION_GROUP_KEY]: {
            width: number,
            avgWorkPrice: number,
            avgWorkPriceUnit: WorkPriceUnit,
            fuelTankSize: number,
            workSpeed: number,
            transportSpeed: number,
            mileage: number
        },*/
    /* Skipping unnamed member:
    [PHOTO_GROUP_KEY]: {
            image: FileModel
        }*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ServiceCardEntry = /** @class */ (function () {
    function ServiceCardEntry(date, mileage, serviceType, description, servicesList) {
        this.date = date;
        this.mileage = mileage;
        this.serviceType = serviceType;
        this.description = description;
        this.servicesList = servicesList;
    }
    return ServiceCardEntry;
}());
if (false) {
    /** @type {?} */
    ServiceCardEntry.prototype.date;
    /** @type {?} */
    ServiceCardEntry.prototype.mileage;
    /** @type {?} */
    ServiceCardEntry.prototype.serviceType;
    /** @type {?} */
    ServiceCardEntry.prototype.description;
    /** @type {?} */
    ServiceCardEntry.prototype.servicesList;
}

var _a$g;
/** @type {?} */
var SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY = 'serviceCardEntryBasicInformationGroup';
/** @type {?} */
var SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY = 'serviceCardEntryElements';
/** @type {?} */
var CONTAINER$1 = 'form-group row';
/** @type {?} */
var ONE_COLUMNS$1 = 'col-12';
/** @type {?} */
var ELEMENTS_LABEL$1 = 'dynamic-form-array-item-label';
/** @type {?} */
var SERVICE_CARD_ENTRY_FORM_LAYOUT = (_a$g = {},
    _a$g[SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY] = DEFAULT_FORM_LAYOUT_GROUP,
    _a$g.serviceType = DEFAULT_FORM_LAYOUT_INPUT,
    _a$g.date = DEFAULT_FORM_LAYOUT_INPUT,
    _a$g.mileage = DEFAULT_FORM_LAYOUT_INPUT,
    _a$g.description = DEFAULT_FORM_LAYOUT_INPUT,
    _a$g[SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY] = {
        grid: {
            host: ONE_COLUMNS$1,
            container: CONTAINER$1,
            label: 'd-none',
            control: 'col-12'
        }
    },
    _a$g.elements = {
        grid: {
            host: '',
            container: '',
            label: ELEMENTS_LABEL$1,
            control: ''
        }
    },
    _a$g);
var ɵ0$c = /**
 * @return {?}
 */
function () {
    return [
        new DynamicMachineCardElementsFormControlModel({
            id: 'elements',
            translateKey: 'MACHINE.SERVICE_CARD.entryForm.elementsSection',
            validators: {
                machineCardElementsValidator: {}
            }
        })
    ];
};
/** @type {?} */
var SERVICE_CARD_ENTRY_FORM_MODEL = [
    new DynamicInputModel({
        id: 'id',
        hidden: true
    }),
    new DynamicFormGroupModel({
        id: SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY,
        group: [
            new DynamicDatePickerModel({
                id: 'date',
                toggleIcon: './assets/icons/calendar-icon.svg',
                validators: {
                    required: null
                }
            }),
            new DynamicInputModel({
                id: 'mileage'
            }),
            new DynamicSelectModel({
                id: 'serviceType',
                options: getOptionsForDynamicSelectModel(MachineServiceType, 'SERVICE_TYPE', false),
                required: true
            }),
            new DynamicTextAreaModel({
                id: 'description',
                rows: 4,
                minLength: 0,
                maxLength: 2000,
                validators: {
                    minLength: 0,
                    maxLength: 2000
                }
            })
        ]
    }),
    new DynamicFormArrayModel({
        id: SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY,
        initialCount: 1,
        groupFactory: (ɵ0$c)
    })
];
/**
 * @return {?}
 */
function mapToServiceCardEntryForm() {
    /** @type {?} */
    var formData = (/** @type {?} */ ({}));
    formData[SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY] = {
        serviceType: '',
        date: mapUnixTimestampToDatePickerValue(null),
        mileage: 0,
        description: ''
    };
    formData[SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY] = [];
    return formData;
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromServiceCardEntryFormToCreateTreatmentsCommand(data) {
    /** @type {?} */
    var command = {};
    if (data == null) {
        return command;
    }
    if (data[SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY] != null) {
        command.mileage = data[SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY].mileage;
        command.date = mapDatePickerValueToUnixTimestamp(data[SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY].date);
        command.serviceType = MachineServiceType.OWN;
        command.description = data[SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY].description;
    }
    if (data[SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY] != null
        && data[SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY].length > 0
        && data[SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY][0].elements !== null) {
        command.servicesList = (data[SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY][0].elements.elements || []).map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            return (/** @type {?} */ ({
                name: x.name,
                kindOfService: x.kindOfService,
                unitPrice: x.unitPrice,
                unit: x.unit,
                quantity: x.quantity,
                catalogNumber: x.catalogNumber,
                manufacturer: x.manufacturer
            }));
        }));
    }
    else {
        command.servicesList = [];
    }
    return command;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NoteListItem = /** @class */ (function () {
    function NoteListItem() {
    }
    return NoteListItem;
}());
if (false) {
    /** @type {?} */
    NoteListItem.prototype.id;
    /** @type {?} */
    NoteListItem.prototype.title;
    /** @type {?} */
    NoteListItem.prototype.organizationName;
    /** @type {?} */
    NoteListItem.prototype.organizationId;
    /** @type {?} */
    NoteListItem.prototype.description;
    /** @type {?} */
    NoteListItem.prototype.registeredAt;
    /** @type {?} */
    NoteListItem.prototype.photos;
    /** @type {?} */
    NoteListItem.prototype.fieldCardCrop;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NoteListItemComponent = /** @class */ (function () {
    function NoteListItemComponent(gallery) {
        this.gallery = gallery;
        this.shareable = false;
        this.delete = new EventEmitter();
        this.edit = new EventEmitter();
        this.share = new EventEmitter();
        this.showDelete = false;
        this.showEdit = false;
    }
    /**
     * @return {?}
     */
    NoteListItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.showDelete = this.delete.observers.length > 0;
        this.showEdit = this.edit.observers.length > 0;
        this.galleryId = "note_" + this.note.id;
        this.items = this.note.photos.map((/**
         * @param {?} photo
         * @return {?}
         */
        function (photo) {
            return new ImageItem({ src: photo.link, thumb: photo.link });
        }));
        /** @type {?} */
        var galleryRef = this.gallery.ref(this.galleryId);
        galleryRef.load(this.items);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NoteListItemComponent.prototype.onDelete = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.delete.emit(this.note);
        $event.stopPropagation();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NoteListItemComponent.prototype.onEdit = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.edit.emit(this.note);
        $event.stopPropagation();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NoteListItemComponent.prototype.onShare = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.share.emit(this.note);
        $event.stopPropagation();
    };
    /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    NoteListItemComponent.prototype.trackByFn = /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    function (index, item) {
        return item.id;
    };
    NoteListItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-note-list-item',
                    template: "<div class=\"card bg-light\">\r\n    <div class=\"card-header d-flex justify-content-between\">\r\n        <h4 class=\"card-title\">{{ note?.title }}</h4>\r\n        <div class=\"d-flex\">\r\n            <button\r\n                *ngIf=\"shareable\"\r\n                (click)=\"onShare($event)\"\r\n                title=\"{{ translationKeyPrefix + '.share:button' | translate }}\"\r\n                class=\"btn btn-raised m-0 my-0 mr-1 btn-sm  shadow-none\"\r\n            >\r\n                <i class=\"ft ft-share-2\" aria-hidden=\"true\"></i>\r\n            </button>\r\n            <button\r\n                *ngIf=\"showEdit\"\r\n                (click)=\"onEdit($event)\"\r\n                title=\"{{ translationKeyPrefix + '.update:button' | translate }}\"\r\n                class=\"btn btn-raised m-0 my-0 mr-1 btn-sm shadow-none\"\r\n            >\r\n                <i class=\"ft ft-edit-2\" aria-hidden=\"true\"></i>\r\n            </button>\r\n            <button\r\n                *ngIf=\"showDelete\"\r\n                (click)=\"onDelete($event)\"\r\n                title=\"{{ translationKeyPrefix + '.delete:button' | translate }}\"\r\n                class=\"btn btn-raised m-0 my-0 btn-sm shadow-none\"\r\n            >\r\n                <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-content\">\r\n        <div class=\"card-body px-2\">\r\n            <div class=\"grid\" *ngIf=\"items && items.length > 0; else elseTemplate\">\r\n                <div class=\"grid-item\" *ngFor=\"let item of items; let i = index; trackBy: trackByFn\" [lightbox]=\"i\" [gallery]=\"galleryId\">\r\n                    <img class=\"grid-image\" [src]=\"item.data.thumb\" />\r\n                </div>\r\n            </div>\r\n            <ng-template #elseTemplate>\r\n                <div class=\"grid-empty\">\r\n                    {{ translationKeyPrefix + '.list:noPhoto' | translate }}\r\n                </div>\r\n            </ng-template>\r\n\r\n            <div class=\"mt-1 description\" style=\"-webkit-box-orient: vertical;\">{{ note?.description }}</div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-footer bg-light\">\r\n        <div class=\"optional-text text-left\">{{ note?.registeredAt | i18nDate: 'shortDate' }}</div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".card.bg-light{border:1px solid rgba(0,0,0,.125)}.grid-item{margin:1em .4em 0;border-radius:.2em;overflow:hidden;padding:0;width:100px;height:100px}@media only screen and (max-width:480px){.grid-item{margin:.4em .2em 0;width:100px;height:80px}}.grid{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:0}.grid-empty{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:1em .4em 0;border-radius:.2em;padding:0;width:100%;height:100px}@media only screen and (max-width:480px){.grid-empty{margin:.4em .2em 0;height:80px}}.grid-image{display:block;width:100%;height:100%;background-size:cover;background-position:center center}.description{-webkit-box-orient:vertical;overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;line-height:1.2em;max-height:3.6em;min-height:3.6em}"]
                }] }
    ];
    /** @nocollapse */
    NoteListItemComponent.ctorParameters = function () { return [
        { type: Gallery }
    ]; };
    NoteListItemComponent.propDecorators = {
        note: [{ type: Input }],
        translationKeyPrefix: [{ type: Input }],
        shareable: [{ type: Input }],
        delete: [{ type: Output }],
        edit: [{ type: Output }],
        share: [{ type: Output }]
    };
    return NoteListItemComponent;
}());
if (false) {
    /** @type {?} */
    NoteListItemComponent.prototype.note;
    /** @type {?} */
    NoteListItemComponent.prototype.translationKeyPrefix;
    /** @type {?} */
    NoteListItemComponent.prototype.shareable;
    /** @type {?} */
    NoteListItemComponent.prototype.delete;
    /** @type {?} */
    NoteListItemComponent.prototype.edit;
    /** @type {?} */
    NoteListItemComponent.prototype.share;
    /** @type {?} */
    NoteListItemComponent.prototype.showDelete;
    /** @type {?} */
    NoteListItemComponent.prototype.showEdit;
    /** @type {?} */
    NoteListItemComponent.prototype.galleryId;
    /** @type {?} */
    NoteListItemComponent.prototype.items;
    /**
     * @type {?}
     * @private
     */
    NoteListItemComponent.prototype.gallery;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NoteSharedModule = /** @class */ (function () {
    function NoteSharedModule() {
    }
    NoteSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        NoteListItemComponent
                    ],
                    imports: [
                        CommonModule,
                        TranslationModule,
                        GalleryModule,
                        LightboxModule.withConfig({
                            keyboardShortcuts: false,
                            panelClass: 'fullscreen'
                        }),
                    ],
                    exports: [
                        NoteListItemComponent
                    ]
                },] }
    ];
    return NoteSharedModule;
}());

var _a$h;
/** @type {?} */
var ACL_PERMISSIONS_GROUP_KEY = 'aclPermissionsElements';
/** @type {?} */
var CONTAINER$2 = 'form-group row';
/** @type {?} */
var ONE_COLUMNS$2 = 'col-12';
/** @type {?} */
var ELEMENTS_LABEL$2 = 'dynamic-form-array-item-label';
/** @type {?} */
var ACL_PERMISSIONS_FORM_LAYOUT = (_a$h = {},
    _a$h[ACL_PERMISSIONS_GROUP_KEY] = {
        grid: {
            host: ONE_COLUMNS$2,
            container: CONTAINER$2,
            label: 'd-none',
            control: 'col-12'
        }
    },
    _a$h.permissions = {
        grid: {
            host: '',
            container: '',
            label: ELEMENTS_LABEL$2,
            control: ''
        }
    },
    _a$h);
var ɵ0$d = /**
 * @return {?}
 */
function () {
    return [
        new DynamicAclPermissionsFormControlModel({
            id: 'permissions',
            translateKey: 'APPLICATION.PERMISSIONS.permissionsSection',
            validators: {
                aclPermissionsValidator: {}
            },
            minCountRequired: 1
        })
    ];
};
/** @type {?} */
var ACL_PERMISSIONS_FORM_MODEL$1 = [
    new DynamicFormArrayModel({
        id: ACL_PERMISSIONS_GROUP_KEY,
        initialCount: 1,
        groupFactory: (ɵ0$d)
    })
];
/**
 * @param {?} permissions
 * @return {?}
 */
function mapToAclPermissionsForm(permissions) {
    /** @type {?} */
    var formData = (/** @type {?} */ ({}));
    formData[ACL_PERMISSIONS_GROUP_KEY] = [{
            permissions: {
                permissions: permissions.map((/**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) {
                    return (/** @type {?} */ ({
                        resourceId: x.resourceId,
                        permissions: x.permissions.join(',')
                    }));
                }))
            }
        }];
    return formData;
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromAclPermissionsFormToCreatePermissionsCommand(data) {
    /** @type {?} */
    var command = [];
    if (data == null) {
        return command;
    }
    if (data[ACL_PERMISSIONS_GROUP_KEY] != null
        && data[ACL_PERMISSIONS_GROUP_KEY].length > 0
        && data[ACL_PERMISSIONS_GROUP_KEY][0].permissions !== null) {
        data[ACL_PERMISSIONS_GROUP_KEY][0].permissions.permissions.forEach((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            command.push({
                resourceId: value.resourceId,
                permissions: value.permissions.split(',')
            });
        }));
    }
    return command;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionsFormComponentComponent = /** @class */ (function () {
    function AclPermissionsFormComponentComponent(router, route) {
        this.router = router;
        this.route = route;
        this.newPermissions = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(true);
    }
    /**
     * @return {?}
     */
    AclPermissionsFormComponentComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.formLayout = ACL_PERMISSIONS_FORM_LAYOUT;
        this.formModel = ACL_PERMISSIONS_FORM_MODEL$1;
        this.initValue = mapToAclPermissionsForm(this.permissions);
        this.displaySpinner$.next(false);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    AclPermissionsFormComponentComponent.prototype.add = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var data = mapFromAclPermissionsFormToCreatePermissionsCommand($event);
        this.newPermissions.emit(data);
    };
    AclPermissionsFormComponentComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-acl-permissions-form-component',
                    template: "<div [appSpinner]=\"displaySpinner$ | async\">\r\n  <div class=\"card\" appPanelFullscreen>\r\n      <div class=\"card-header d-flex\">\r\n          <h2>{{ 'APPLICATION.PERMISSIONS.header' | translate }}</h2>\r\n          <div class=\"ml-auto\">\r\n                  <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n              </div>\r\n      </div>\r\n      <div class=\"card-content\">\r\n          <div class=\"card-body\">\r\n              <app-add-form\r\n                  *ngIf=\"formModel\"\r\n                  #addForm\r\n                  [formModel]=\"formModel\"\r\n                  [formLayout]=\"formLayout\"\r\n                  [model]=\"initValue\"\r\n                  (add)=\"add($event)\"\r\n                  [translateKey]=\"'APPLICATION.PERMISSIONS'\"\r\n              ></app-add-form>\r\n          </div>\r\n      </div>\r\n  </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    AclPermissionsFormComponentComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute }
    ]; };
    AclPermissionsFormComponentComponent.propDecorators = {
        permissions: [{ type: Input }],
        newPermissions: [{ type: Output }]
    };
    return AclPermissionsFormComponentComponent;
}());
if (false) {
    /** @type {?} */
    AclPermissionsFormComponentComponent.prototype.permissions;
    /** @type {?} */
    AclPermissionsFormComponentComponent.prototype.newPermissions;
    /** @type {?} */
    AclPermissionsFormComponentComponent.prototype.displaySpinner$;
    /** @type {?} */
    AclPermissionsFormComponentComponent.prototype.formLayout;
    /** @type {?} */
    AclPermissionsFormComponentComponent.prototype.formModel;
    /** @type {?} */
    AclPermissionsFormComponentComponent.prototype.initValue;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponentComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    AclPermissionsFormComponentComponent.prototype.route;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclSharedModule = /** @class */ (function () {
    function AclSharedModule() {
    }
    AclSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        AclPermissionsFormComponentComponent
                    ],
                    entryComponents: [
                        AclPermissionsFormComponentComponent
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        NgbModule,
                        ChartsModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule,
                        GoogleMapsSharedModule,
                        FormSharedModule,
                        TableSharedModule,
                        RouterModule,
                        TranslateModule,
                        PureGoogleMapsSharedModule,
                        ModalSharedModule,
                        TranslationModule
                    ],
                    exports: [
                        AclPermissionsFormComponentComponent,
                        NgbModule,
                    ],
                    providers: [DecimalPipe, MapService]
                },] }
    ];
    return AclSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AclPermissionsCommand = /** @class */ (function () {
    function AclPermissionsCommand(resourceId, permissions) {
        this.resourceId = resourceId;
        this.permissions = permissions;
    }
    return AclPermissionsCommand;
}());
if (false) {
    /** @type {?} */
    AclPermissionsCommand.prototype.resourceId;
    /** @type {?} */
    AclPermissionsCommand.prototype.permissions;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function MachineAlarmThreshold() { }
if (false) {
    /** @type {?} */
    MachineAlarmThreshold.prototype.thresholdOperator;
    /** @type {?} */
    MachineAlarmThreshold.prototype.value;
    /** @type {?} */
    MachineAlarmThreshold.prototype.values;
    /** @type {?} */
    MachineAlarmThreshold.prototype.thresholdProperty;
    /** @type {?} */
    MachineAlarmThreshold.prototype.location;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GeneratedAlarm = /** @class */ (function () {
    function GeneratedAlarm() {
    }
    return GeneratedAlarm;
}());
if (false) {
    /** @type {?} */
    GeneratedAlarm.prototype.vehicleRefId;
    /** @type {?} */
    GeneratedAlarm.prototype.location;
    /** @type {?} */
    GeneratedAlarm.prototype.timestamp;
    /** @type {?} */
    GeneratedAlarm.prototype.alarmType;
    /** @type {?} */
    GeneratedAlarm.prototype.ioData;
    /** @type {?} */
    GeneratedAlarm.prototype.machineRefId;
    /** @type {?} */
    GeneratedAlarm.prototype.workerRefId;
    /** @type {?} */
    GeneratedAlarm.prototype.machine;
    /** @type {?} */
    GeneratedAlarm.prototype.worker;
    /** @type {?} */
    GeneratedAlarm.prototype.ground;
    /** @type {?} */
    GeneratedAlarm.prototype.alarmTypeTranslateKey;
}
/**
 * @record
 */
function GeneratedAlarmGround() { }
if (false) {
    /** @type {?} */
    GeneratedAlarmGround.prototype.id;
    /** @type {?} */
    GeneratedAlarmGround.prototype.name;
    /** @type {?} */
    GeneratedAlarmGround.prototype.areaInHa;
    /** @type {?} */
    GeneratedAlarmGround.prototype.lease;
    /** @type {?} */
    GeneratedAlarmGround.prototype.cadastralState;
    /** @type {?} */
    GeneratedAlarmGround.prototype.cadastralCounty;
    /** @type {?} */
    GeneratedAlarmGround.prototype.cadastralCommune;
    /** @type {?} */
    GeneratedAlarmGround.prototype.cadastralArea;
    /** @type {?} */
    GeneratedAlarmGround.prototype.cadastreNumber;
    /** @type {?} */
    GeneratedAlarmGround.prototype.groundCategory;
    /** @type {?} */
    GeneratedAlarmGround.prototype.complexOfAgriculturalSuitability;
    /** @type {?} */
    GeneratedAlarmGround.prototype.agronomicCategory;
    /** @type {?} */
    GeneratedAlarmGround.prototype.locations;
    /** @type {?|undefined} */
    GeneratedAlarmGround.prototype.agroMonitoringData;
}
/**
 * @record
 */
function GeneratedAlarmGroundGeoData() { }
if (false) {
    /** @type {?} */
    GeneratedAlarmGroundGeoData.prototype.id;
    /** @type {?} */
    GeneratedAlarmGroundGeoData.prototype.name;
}
/**
 * @record
 */
function GeneratedAlarmGroundAgroMonitoring() { }
if (false) {
    /** @type {?} */
    GeneratedAlarmGroundAgroMonitoring.prototype.polygonId;
    /** @type {?} */
    GeneratedAlarmGroundAgroMonitoring.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GpsPosition = /** @class */ (function () {
    function GpsPosition() {
    }
    return GpsPosition;
}());
if (false) {
    /** @type {?} */
    GpsPosition.prototype.latitude;
    /** @type {?} */
    GpsPosition.prototype.longitude;
    /** @type {?} */
    GpsPosition.prototype.speed;
    /** @type {?} */
    GpsPosition.prototype.altitude;
    /** @type {?} */
    GpsPosition.prototype.angle;
    /** @type {?} */
    GpsPosition.prototype.satellites;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IoElement = /** @class */ (function () {
    function IoElement() {
    }
    return IoElement;
}());
if (false) {
    /** @type {?} */
    IoElement.prototype.id;
    /** @type {?} */
    IoElement.prototype.label;
    /** @type {?} */
    IoElement.prototype.value;
    /** @type {?} */
    IoElement.prototype.valueHuman;
    /** @type {?} */
    IoElement.prototype.dimension;
    /** @type {?} */
    IoElement.prototype.type;
    /** @type {?} */
    IoElement.prototype.timestamp;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Employee = /** @class */ (function () {
    function Employee() {
    }
    return Employee;
}());
if (false) {
    /** @type {?} */
    Employee.prototype.id;
    /** @type {?} */
    Employee.prototype.fullName;
    /** @type {?} */
    Employee.prototype.phone;
    /** @type {?} */
    Employee.prototype.employmentType;
    /** @type {?} */
    Employee.prototype.isEmploymentSeasonal;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Message = /** @class */ (function () {
    function Message() {
    }
    return Message;
}());
if (false) {
    /** @type {?} */
    Message.prototype.id;
    /** @type {?} */
    Message.prototype.type;
    /** @type {?} */
    Message.prototype.title;
    /** @type {?} */
    Message.prototype.body;
    /** @type {?} */
    Message.prototype.sender;
    /** @type {?} */
    Message.prototype.isRead;
    /** @type {?} */
    Message.prototype.creationDate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageListComponent = /** @class */ (function () {
    function MessageListComponent() {
        this.selectedMessageChange = new EventEmitter();
    }
    /**
     * @param {?} event
     * @param {?} message
     * @return {?}
     */
    MessageListComponent.prototype.selectMessage = /**
     * @param {?} event
     * @param {?} message
     * @return {?}
     */
    function (event, message) {
        this.selectedMessageChange.next(message);
        event.preventDefault();
        event.stopPropagation();
    };
    /**
     * @param {?} index
     * @param {?} message
     * @return {?}
     */
    MessageListComponent.prototype.trackByFn = /**
     * @param {?} index
     * @param {?} message
     * @return {?}
     */
    function (index, message) {
        return message.id;
    };
    MessageListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-message-list',
                    template: "<div [perfectScrollbar] class=\"email-app-list\">\r\n    <div id=\"users-list\">\r\n        <div class=\"list-group\">\r\n            <div class=\"users-list-padding\">\r\n                <a class=\"list-group-item list-group-item-action\"\r\n                    *ngFor=\"let message of messages; trackBy: trackByFn\"\r\n                    [ngClass]=\"message.id === selectedMessage?.id\r\n                            ? 'bg-blue-grey bg-lighten-5 border-right-primary border-right-2'\r\n                            : 'no-border'\"\r\n                    (click)=\"selectMessage($event, message)\">\r\n                    <span class=\"media\">\r\n                        <app-message-type-avatar [messageType]=\"message.type\"></app-message-type-avatar>\r\n                        <div class=\"media-body text-left\">\r\n                            <h6 [ngClass]=\"message.isRead === true ? 'list-group-item-heading' : 'list-group-item-heading text-bold-400'\" class=\"optional-text\">\r\n                                {{ message.sender }}\r\n                                <span class=\"float-right\">\r\n                                    <span [ngClass]=\"message.isRead === true ? 'font-small-2 float-right' : 'font-small-2 primary'\">\r\n                                        {{ message.creationDate | i18nDate: 'shortDate' }}\r\n                                        </span>\r\n                                </span>\r\n                            </h6>\r\n                            <p [ngClass]=\" message.isRead === true ? 'list-group-item-text text-truncate' : 'list-group-item-text text-truncate text-bold-500'\">\r\n                                {{ message.title | htmlTextShort:20 }}\r\n                            </p>\r\n                            <p class=\"list-group-item-text\">\r\n                                {{ message.body | htmlTextShort:50 }}\r\n                            </p>\r\n                        </div>\r\n                    </span>\r\n                </a>\r\n                <p class=\"primary text-center\" *ngIf=\"messages.length === 0\">{{ 'MESSAGE.SHARED.list:empty' | translate }}</p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    MessageListComponent.propDecorators = {
        messages: [{ type: Input }],
        selectedMessage: [{ type: Input }],
        selectedMessageChange: [{ type: Output }]
    };
    return MessageListComponent;
}());
if (false) {
    /** @type {?} */
    MessageListComponent.prototype.messages;
    /** @type {?} */
    MessageListComponent.prototype.selectedMessage;
    /** @type {?} */
    MessageListComponent.prototype.selectedMessageChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageListItemComponent = /** @class */ (function () {
    function MessageListItemComponent() {
        this.back = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MessageListItemComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.message) {
            this.badgeBgClassName = this.getBadgeBgClassName(changes.message.currentValue);
        }
    };
    /**
     * @return {?}
     */
    MessageListItemComponent.prototype.onBack = /**
     * @return {?}
     */
    function () {
        this.back.emit();
    };
    /**
     * @private
     * @param {?} message
     * @return {?}
     */
    MessageListItemComponent.prototype.getBadgeBgClassName = /**
     * @private
     * @param {?} message
     * @return {?}
     */
    function (message) {
        if (message == null) {
            return '';
        }
        switch (message.type) {
            case MessageType.Advertisement:
                // tslint:disable-next-line: no-duplicate-string
                return 'badge-info';
            case MessageType.Alert:
                return 'badge-danger';
            case MessageType.Information:
                return 'badge-info';
            case MessageType.Reminder:
                return 'badge-warning';
            case MessageType.Standard:
                return 'badge-primary';
            case MessageType.Warning:
                return 'badge-warning';
            default:
                return 'badge-info';
        }
    };
    MessageListItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-message-list-item',
                    template: "<div class=\"email-app-mail-content-detail pt-2\" *ngIf=\"message; else notSelected\">\r\n        <div class=\"email-app-options card-body d-md-none my-0 py-0\">\r\n            <button class=\"btn btn-raised btn-primary back-to-inbox\" (click)=\"onBack()\">\r\n                <i class=\"fa fa-angle-left\"></i>{{ 'MESSAGE.SHARED.detail:back' | translate }}\r\n            </button>\r\n        </div>\r\n        <div class=\"email-app-title card-body py-0\">\r\n            <h3 class=\"list-group-item-heading text-left\">{{ message.title }}</h3>\r\n            <div class=\"d-flex justify-content-between py-2\">\r\n                <span class=\"badge\" [ngClass]=\"badgeBgClassName\">\r\n                    {{ message.type | enumTranslateKey: 'APPLICATION.DICTIONARIES.MESSAGES_TYPES' | translate }}\r\n                </span>\r\n                <span class=\"primary text-right\">{{ message.creationDate | i18nDate: 'fullDate' }}</span>\r\n            </div>\r\n        </div>\r\n            <div id=\"headingCollapse2\" class=\"card-header p-0\" >\r\n                    <div class=\"email-app-sender list-group-item list-group-item-action no-border\" *ngIf=\"message.sender && message.sender.length > 0\">\r\n                        <div class=\"media\">\r\n                            <div class=\"avatar avatar-md mr-2 align-self-center\">\r\n                                <span class=\"media-object rounded-circle text-circle d-flex mr-2 justify-content-center align-items-center bg-info\">\r\n                                    {{ message.sender[0] | uppercase }}\r\n                                </span>\r\n                            </div>\r\n                            <div class=\"media-body text-left align-self-center\">\r\n                                <h6 class=\"list-group-item-heading my-0\">\r\n                                    {{ message.sender }}\r\n                                </h6>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n            </div>\r\n            <div [id]=\"message.id\">\r\n                <div class=\"card-content\">\r\n                    <div class=\"email-app-text card-body\">\r\n                        <div class=\"email-app-message text-left\">\r\n                            <div [innerHTML]=\"message.body | farmPortalWeatherStationsReplaceLink\"></div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n    </div>\r\n<ng-template #notSelected>\r\n    <div class=\"email-app-mail-content-detail pt-2\">\r\n        <p class=\"primary text-center\">{{ 'MESSAGE.SHARED.detail:notSelected' | translate }}</p>\r\n    </div>\r\n</ng-template>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    MessageListItemComponent.propDecorators = {
        message: [{ type: Input }],
        back: [{ type: Output }]
    };
    return MessageListItemComponent;
}());
if (false) {
    /** @type {?} */
    MessageListItemComponent.prototype.message;
    /** @type {?} */
    MessageListItemComponent.prototype.back;
    /** @type {?} */
    MessageListItemComponent.prototype.badgeBgClassName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageListCount = /** @class */ (function () {
    function MessageListCount() {
    }
    return MessageListCount;
}());
if (false) {
    /** @type {?} */
    MessageListCount.prototype.allMessageCount;
    /** @type {?} */
    MessageListCount.prototype.unreadMessageCount;
    /** @type {?} */
    MessageListCount.prototype.alertMessageCount;
    /** @type {?} */
    MessageListCount.prototype.standardMessageCount;
    /** @type {?} */
    MessageListCount.prototype.reminderMessageCount;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageListFilter = /** @class */ (function () {
    function MessageListFilter() {
    }
    return MessageListFilter;
}());
if (false) {
    /** @type {?} */
    MessageListFilter.prototype.unreadOnly;
    /** @type {?} */
    MessageListFilter.prototype.messageType;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageListSidebarComponent = /** @class */ (function () {
    function MessageListSidebarComponent() {
        this.filterChange = new EventEmitter();
        this.MessageType = MessageType;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    MessageListSidebarComponent.prototype.getUnreadMessages = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.filterChange.next({ unreadOnly: true });
        event.preventDefault();
        event.stopPropagation();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MessageListSidebarComponent.prototype.getAllMessages = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.filterChange.next({});
        event.preventDefault();
        event.stopPropagation();
    };
    /**
     * @param {?} event
     * @param {?} messageType
     * @return {?}
     */
    MessageListSidebarComponent.prototype.getMessagesByType = /**
     * @param {?} event
     * @param {?} messageType
     * @return {?}
     */
    function (event, messageType) {
        this.filterChange.next({ messageType: messageType });
        event.preventDefault();
        event.stopPropagation();
    };
    MessageListSidebarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-message-list-sidebar',
                    template: "<div #emailSidebar class=\"email-app-sidebar float-left\">\r\n        <div [perfectScrollbar] class=\"email-app-sidebar-content\">\r\n            <div class=\"email-app-menu\">\r\n                <div class=\"list-group list-group-messages pb-1\">\r\n                    <a class=\"list-group-item no-border text-left\" [ngClass]=\"filter?.unreadOnly != true && filter?.messageType === undefined ? 'active' : ' list-group-item-action'\" (click)=\"getAllMessages($event)\">\r\n                        <i class=\"ft-inbox mr-1 pr-1 float-left\"></i> {{ 'MESSAGE.SHARED.list:all' | translate }}\r\n                        <span class=\"badge badge-success badge-pill float-right\">{{count?.allMessageCount}}</span>\r\n                    </a>\r\n                    <a class=\"list-group-item no-border text-left\" [ngClass]=\"filter?.unreadOnly == true ? 'active' : ' list-group-item-action'\" (click)=\"getUnreadMessages($event)\">\r\n                        <i class=\"ft-mail mr-1 pr-1 float-left\"></i> {{ 'MESSAGE.SHARED.list:unread' | translate }}\r\n                        <span class=\"badge badge-danger badge-pill float-right\" *ngIf=\"count?.unreadMessageCount > 0\">{{count?.unreadMessageCount}}</span>\r\n                    </a>\r\n                </div>\r\n                <h6 class=\"text-muted text-bold-500 ml-1 my-2 text-left\">{{ 'MESSAGE.SHARED.list:categories' | translate }}</h6>\r\n                <div class=\"list-group list-group-messages\">\r\n                    <a class=\"list-group-item no-border text-left\" [ngClass]=\"filter?.messageType === MessageType.Reminder ? 'active' : ' list-group-item-action'\" (click)=\"getMessagesByType($event, MessageType.Reminder)\">\r\n                        <i class=\"ft-circle mr-1 pr-1 float-left warning\"></i> {{ 'APPLICATION.DICTIONARIES.MESSAGES_TYPES.reminder' | translate }}\r\n                        <span class=\"badge badge-warning badge-pill float-right\" *ngIf=\"count?.reminderMessageCount > 0\">{{count?.reminderMessageCount}}</span>\r\n                    </a>\r\n                    <a class=\"list-group-item no-border text-left\" [ngClass]=\"filter?.messageType === MessageType.Alert ? 'active' : ' list-group-item-action'\" (click)=\"getMessagesByType($event, MessageType.Alert)\">\r\n                        <i class=\"ft-circle mr-1 pr-1 float-left danger\"></i> {{ 'APPLICATION.DICTIONARIES.MESSAGES_TYPES.alert' | translate }}\r\n                        <span class=\"badge badge-danger badge-pill float-right\" *ngIf=\"count?.alertMessageCount > 0\">{{count?.alertMessageCount}}</span>\r\n                    </a>\r\n                    <a class=\"list-group-item no-border text-left\" [ngClass]=\"filter?.messageType === MessageType.Standard ? 'active' : ' list-group-item-action'\" (click)=\"getMessagesByType($event, MessageType.Standard)\">\r\n                        <i class=\"ft-circle mr-1 pr-1 float-left primary\"></i> {{ 'APPLICATION.DICTIONARIES.MESSAGES_TYPES.standard' | translate }}\r\n                        <span class=\"badge badge-primary badge-pill float-right\" *ngIf=\"count?.standardMessageCount > 0\">{{count?.standardMessageCount}}</span>\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".badge.badge-pill{min-width:22px}.list-group.list-group-messages a{padding-right:.5rem}"]
                }] }
    ];
    MessageListSidebarComponent.propDecorators = {
        count: [{ type: Input }],
        filter: [{ type: Input }],
        filterChange: [{ type: Output }]
    };
    return MessageListSidebarComponent;
}());
if (false) {
    /** @type {?} */
    MessageListSidebarComponent.prototype.count;
    /** @type {?} */
    MessageListSidebarComponent.prototype.filter;
    /** @type {?} */
    MessageListSidebarComponent.prototype.filterChange;
    /** @type {?} */
    MessageListSidebarComponent.prototype.MessageType;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageTypeAvatarComponent = /** @class */ (function () {
    function MessageTypeAvatarComponent() {
    }
    /**
     * @return {?}
     */
    MessageTypeAvatarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    MessageTypeAvatarComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.messageType) {
            this.iconClassName = this.getIconClassName(changes.messageType.currentValue);
            this.bgClassName = this.getBgClassName(changes.messageType.currentValue);
        }
    };
    /**
     * @private
     * @param {?} type
     * @return {?}
     */
    MessageTypeAvatarComponent.prototype.getBgClassName = /**
     * @private
     * @param {?} type
     * @return {?}
     */
    function (type) {
        switch (type) {
            case MessageType.Advertisement:
                return 'bg-info';
            case MessageType.Alert:
                return 'bg-danger';
            case MessageType.Information:
                return 'bg-info';
            case MessageType.Reminder:
                return 'bg-warning';
            case MessageType.Standard:
                return 'bg-primary';
            case MessageType.Warning:
                return 'bg-warning';
            default:
                return 'bg-info';
        }
    };
    // tslint:disable-next-line: no-identical-functions
    // tslint:disable-next-line: no-identical-functions
    /**
     * @private
     * @param {?} type
     * @return {?}
     */
    MessageTypeAvatarComponent.prototype.getIconClassName = 
    // tslint:disable-next-line: no-identical-functions
    /**
     * @private
     * @param {?} type
     * @return {?}
     */
    function (type) {
        switch (type) {
            case MessageType.Advertisement:
                return 'ft-globe';
            case MessageType.Alert:
                return 'ft-alert-circle';
            case MessageType.Information:
                return 'ft-info';
            case MessageType.Reminder:
                return 'ft-bell';
            case MessageType.Standard:
                return 'ft-mail';
            case MessageType.Warning:
                return 'ft-alert-triangle';
            default:
                return 'ft-mail';
        }
    };
    MessageTypeAvatarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-message-type-avatar',
                    template: "<span class=\"avatar avatar-md mr-2\">\r\n    <span class=\"media-object rounded-circle text-circle d-flex mr-2 ml-0 justify-content-center align-items-center\" [ngClass]=\"bgClassName\">\r\n        <i [ngClass]=\"iconClassName\"></i>\r\n    </span>\r\n</span>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    MessageTypeAvatarComponent.ctorParameters = function () { return []; };
    MessageTypeAvatarComponent.propDecorators = {
        messageType: [{ type: Input }]
    };
    return MessageTypeAvatarComponent;
}());
if (false) {
    /** @type {?} */
    MessageTypeAvatarComponent.prototype.messageType;
    /** @type {?} */
    MessageTypeAvatarComponent.prototype.iconClassName;
    /** @type {?} */
    MessageTypeAvatarComponent.prototype.bgClassName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageSharedModule = /** @class */ (function () {
    function MessageSharedModule() {
    }
    MessageSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        MessageListComponent,
                        MessageListItemComponent,
                        MessageListSidebarComponent,
                        MessageTypeAvatarComponent
                    ],
                    imports: [
                        CommonModule,
                        PerfectScrollbarModule,
                        PipesModule,
                        TranslationModule
                    ],
                    exports: [
                        MessageListComponent,
                        MessageListItemComponent,
                        MessageListSidebarComponent
                    ]
                },] }
    ];
    return MessageSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ServiceSharedModule = /** @class */ (function () {
    function ServiceSharedModule() {
    }
    ServiceSharedModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return ServiceSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadCsvService = /** @class */ (function () {
    function DownloadCsvService() {
    }
    /**
     * @param {?} data
     * @param {?} fields
     * @param {?=} filename
     * @param {?=} translationService
     * @param {?=} translationKey
     * @return {?}
     */
    DownloadCsvService.prototype.downloadFile = /**
     * @param {?} data
     * @param {?} fields
     * @param {?=} filename
     * @param {?=} translationService
     * @param {?=} translationKey
     * @return {?}
     */
    function (data, fields, filename, translationService, translationKey) {
        if (filename === void 0) { filename = 'data'; }
        if (translationService === void 0) { translationService = null; }
        if (translationKey === void 0) { translationKey = ''; }
        /** @type {?} */
        var csvData = this.convertToCSV(data, fields, translationService, translationKey);
        /** @type {?} */
        var blob = new Blob(['\ufeff' + csvData], {
            type: 'text/csv;charset=utf-8;'
        });
        /** @type {?} */
        var downloadLink = document.createElement('a');
        /** @type {?} */
        var url = URL.createObjectURL(blob);
        /** @type {?} */
        var isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1
            && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {
            downloadLink.setAttribute('target', '_blank');
        }
        downloadLink.setAttribute('href', url);
        downloadLink.setAttribute('download', filename + '.csv');
        downloadLink.style.visibility = 'hidden';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    /**
     * @param {?} objArray
     * @param {?} headerList
     * @param {?} translationService
     * @param {?} translationKey
     * @return {?}
     */
    DownloadCsvService.prototype.convertToCSV = /**
     * @param {?} objArray
     * @param {?} headerList
     * @param {?} translationService
     * @param {?} translationKey
     * @return {?}
     */
    function (objArray, headerList, translationService, translationKey) {
        /** @type {?} */
        var separator = ';';
        /** @type {?} */
        var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        /** @type {?} */
        var str = '';
        /** @type {?} */
        var row = (!translationService)
            ? headerList.join(separator)
            : headerList.map((/**
             * @param {?} element
             * @return {?}
             */
            function (element) { return translationService.translate(translationKey + "." + element); }))
                .join(separator);
        str += row + '\r\n';
        array.forEach((/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            /** @type {?} */
            var lineArray = [];
            headerList.forEach((/**
             * @param {?} key
             * @return {?}
             */
            function (key) {
                lineArray.push(element[key]);
            }));
            str += lineArray.join(separator) + '\r\n';
        }));
        return str;
    };
    DownloadCsvService.decorators = [
        { type: Injectable, args: [{
                    providedIn: ServiceSharedModule
                },] }
    ];
    /** @nocollapse */ DownloadCsvService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DownloadCsvService_Factory() { return new DownloadCsvService(); }, token: DownloadCsvService, providedIn: ServiceSharedModule });
    return DownloadCsvService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FarmCertificatesTableComponent = /** @class */ (function () {
    function FarmCertificatesTableComponent() {
        this.swipeIcon = true;
        // tslint:disable-next-line: no-output-on-prefix
        this.onDelete = new EventEmitter();
        this.displaySpinner$ = new BehaviorSubject(false);
        this.unsubscribe = new Subject();
    }
    /**
     * @return {?}
     */
    FarmCertificatesTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.displayedColumns = ['name', 'type', 'code', 'startDate', 'endDate', 'action'];
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @return {?}
     */
    FarmCertificatesTableComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FarmCertificatesTableComponent.prototype.onDeleteClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.onDelete.emit(item);
    };
    FarmCertificatesTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-farm-certificates-table',
                    template: "<div class=\"mb-2\" [appSpinner]=\"dataSource.loading$ | async\">\r\n    <div class=\"card\" appPanelFullscreen>\r\n        <div class=\"card-header pt-3 px-0\">\r\n            <label class=\"px-0\">\r\n                <h5 class=\"m-0\">\r\n                    <i class=\"ft ft-list\"></i> {{ 'FARM.CERTIFICATES.certificatesList:header' | translate}} </h5>\r\n            </label>\r\n            <app-panel-fullscreen-button class=\"float-right\"></app-panel-fullscreen-button>\r\n        </div>\r\n        <div class=\"card-content\">\r\n            <div class=\"card-body px-0\">\r\n                <div class=\"container-fluid table-container\">\r\n                    <cdk-table [dataSource]=\"dataSource\" cdkSort cdkSortActive=\"name\" cdkSortDirection=\"desc\">\r\n                        <ng-container cdkColumnDef=\"name\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef cdk-sort-header class=\"col-2 pr-0\">\r\n                                {{ 'FARM.CERTIFICATES.certificateName' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.name }}</div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"type\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\"> {{ 'FARM.CERTIFICATES.certificateType' | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.type }} </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"code\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 pr-0\"> {{ 'FARM.CERTIFICATES.certificateCode' | translate }}\r\n                            </div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 pr-0\">{{ element.code }} </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"startDate\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 col-xl-2 pr-0\">\r\n                                {{ 'FARM.CERTIFICATES.certificateStartDate' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 col-xl-2 pr-0\"> {{ element.startDate | date:\"dd.MM.yyyy\"}}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"endDate\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 col-xl-2 pr-0\">\r\n                                {{ 'FARM.CERTIFICATES.certificateEndDate' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\" class=\"col-2 col-xl-2 pr-0\"> {{ element.endDate | date:\"dd.MM.yyyy\"}}\r\n                            </div>\r\n                        </ng-container>\r\n                        <ng-container cdkColumnDef=\"action\">\r\n                            <div cdk-header-cell *cdkHeaderCellDef class=\"col-2 col-xl-2 text-md-right\">\r\n                                {{ 'APPLICATION.LIST.action' | translate }}</div>\r\n                            <div cdk-cell *cdkCellDef=\"let element\"\r\n                                class=\"sticky-action col-2 col-xl-2 p-0 pl-1 pl-md-0 pr-0 pr-md-1 w-100\">\r\n                                <div class=\"row no-gutters justify-content-md-end\">\r\n                                    <button (click)=\"onDeleteClick(element)\" *ngIf=\"!element.isDeleted\"\r\n                                        title=\"{{ 'FARM.CERTIFICATES.delete:button' | translate }}\"\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-danger\">\r\n                                        <i class=\"ft ft-trash-2\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <a *ngIf=\"element.file\" href=\"{{ element.file.link }}\"\r\n                                        title=\"{{ 'DOCUMENTS.download:button' | translate }}\" target='_blank'\r\n                                        class=\"btn btn-raised m-0 my-1 mr-1 btn-sm btn-info\">\r\n                                        <i class=\"ft ft-download\" aria-hidden=\"true\"></i>\r\n                                    </a>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <cdk-header-row class=\"row header-navbar extra_bg-light-grey\" *cdkHeaderRowDef=\"displayedColumns\">\r\n                        </cdk-header-row>\r\n                        <cdk-row class=\"row row-striped align-items-center\" *cdkRowDef=\"let row; columns: displayedColumns\"></cdk-row>\r\n                    </cdk-table>\r\n                    <div class=\"row\" *ngIf=\"dataSource.noData$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'FARM.CERTIFICATES.list:empty' | translate }}</div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"dataSource.error$ | async\">\r\n                        <div class=\"col text-center py-3\">{{ 'FARM.CERTIFICATES.list:error' | translate }}</div>\r\n                    </div>\r\n                    <cdk-paginator class=\"row header-navbar d-flex justify-content-end pr-2 py-1\" [pageSizeOptions]=\"[10,25,50,75,100]\"\r\n                        showFirstLastButtons></cdk-paginator>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    FarmCertificatesTableComponent.ctorParameters = function () { return []; };
    FarmCertificatesTableComponent.propDecorators = {
        dataSource: [{ type: Input }],
        onDelete: [{ type: Output }],
        sort: [{ type: ViewChild, args: [CdkSort, { static: true },] }],
        paginator: [{ type: ViewChild, args: [CdkPaginator, { static: true },] }]
    };
    return FarmCertificatesTableComponent;
}());
if (false) {
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.displayedColumns;
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.swipeIcon;
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.dataSource;
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.onDelete;
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.sort;
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.paginator;
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.name;
    /** @type {?} */
    FarmCertificatesTableComponent.prototype.displaySpinner$;
    /**
     * @type {?}
     * @private
     */
    FarmCertificatesTableComponent.prototype.unsubscribe;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FarmSharedModule = /** @class */ (function () {
    function FarmSharedModule() {
    }
    FarmSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        FarmCertificatesTableComponent
                    ],
                    entryComponents: [
                        FarmCertificatesTableComponent
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        NgbModule,
                        UiSwitchModule,
                        SpinnerModule,
                        PanelSharedModule,
                        GoogleMapsSharedModule,
                        FormSharedModule,
                        TableSharedModule,
                        RouterModule,
                        TranslateModule,
                        PureGoogleMapsSharedModule,
                        ModalSharedModule
                    ],
                    exports: [
                        FarmCertificatesTableComponent
                    ],
                    providers: [DecimalPipe, MapService]
                },] }
    ];
    return FarmSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FarmViewCard() { }
if (false) {
    /** @type {?} */
    FarmViewCard.prototype.visibilityGroup;
    /** @type {?} */
    FarmViewCard.prototype.descriptionGroup;
    /** @type {?} */
    FarmViewCard.prototype.productShowGroup;
}
/** @type {?} */
var productsViewcard = [
    { name: 'cereals' },
    { name: 'oilCrops' },
    { name: 'rootCrops' },
    { name: 'industrialCrops' },
    { name: 'rootVegetables' },
    { name: 'leafyVegetables' },
    { name: 'fruitingVegetables' },
    { name: 'leguminousVegetables' },
    { name: 'bulbVegetables' },
    { name: 'hardFruits' },
    { name: 'softFruits' },
    { name: 'herbs' },
    { name: 'animalProduction' }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MAX_FILE_SIZE$4 = 1;
// MB
/** @type {?} */
var groupHostCss = 'mt-1 col-12';
/** @type {?} */
var checkboxHostCss = {
    grid: {
        host: 'col-sm-4 col-12',
        container: 'row',
        label: 'col-12',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_VIEW_CARD = {
    visibilityGroup: DEFAULT_FORM_LAYOUT_GROUP,
    descriptionGroup: DEFAULT_FORM_LAYOUT_GROUP,
    productShowGroup: DEFAULT_FORM_LAYOUT_GROUP,
    shareProfile: DEFAULT_FORM_LAYOUT_INPUT,
    showProducts: DEFAULT_FORM_LAYOUT_INPUT,
    name: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    description: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    photos: {
        grid: {
            host: groupHostCss,
            label: 'mb-3'
        },
        element: {
            control: 'd-flex align-content-start flex-wrap',
            group: 'mx-1 observation-photo-group'
        }
    },
    cereals: checkboxHostCss,
    oilCrops: checkboxHostCss,
    rootCrops: checkboxHostCss,
    industrialCrops: checkboxHostCss,
    rootVegetables: checkboxHostCss,
    leafyVegetables: checkboxHostCss,
    fruitingVegetables: checkboxHostCss,
    leguminousVegetables: checkboxHostCss,
    bulbVegetables: checkboxHostCss,
    hardFruits: checkboxHostCss,
    softFruits: checkboxHostCss,
    herbs: checkboxHostCss,
    animalProduction: checkboxHostCss
};
var ɵ0$e = /**
 * @return {?}
 */
function () {
    return [
        new DynamicFileUploadModel({
            id: 'photo',
            accept: ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/bmp'],
            maxSize: MAX_FILE_SIZE$4
        })
    ];
};
/** @type {?} */
var FORM_MODEL$2 = [
    new DynamicFormGroupModel({
        id: 'visibilityGroup',
        group: [
            new DynamicCheckboxModel({
                id: 'shareProfile',
            }),
            new DynamicCheckboxModel({
                id: 'showProducts'
            })
        ]
    }),
    new DynamicFormGroupModel({
        id: 'descriptionGroup',
        group: [
            new DynamicInputModel({
                id: 'name',
                minLength: 3,
                maxLength: 50,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 50
                }
            }),
            new DynamicTextAreaModel({
                id: 'description',
                minLength: 3,
                maxLength: 1000,
                validators: {
                    required: null,
                    minLength: 3,
                    maxLength: 1000
                }
            }),
            new DynamicFormArrayModel({
                id: 'photos',
                initialCount: 3,
                groupFactory: (ɵ0$e)
            })
        ]
    }),
    new DynamicFormGroupModel({
        id: 'productShowGroup',
        group: getProductCheckboxes()
    })
];
/**
 * @return {?}
 */
function GetFormLayout() {
    // tslint:disable-next-line: no-any
    /** @type {?} */
    var layout = (/** @type {?} */ (GetDefaultLayout(FORM_MODEL$2)));
    layout.features = FORM_LAYOUT_SINGLE_LINE_INPUT;
    return layout;
}
/**
 * @return {?}
 */
function getProductCheckboxes() {
    /** @type {?} */
    var group = [];
    productsViewcard.forEach((/**
     * @param {?} x
     * @return {?}
     */
    function (x) {
        group.push(new DynamicCheckboxModel({
            id: x.name
        }));
    }));
    return group;
}
/**
 * @param {?} data
 * @return {?}
 */
function mapToFarmViewCardForm(data) {
    return {
        visibilityGroup: {
            shareProfile: data.shareProfile,
            showProducts: data.showProducts
        },
        descriptionGroup: {
            name: data.name,
            description: data.description,
            photos: data.photos.map((/**
             * @param {?} x
             * @return {?}
             */
            function (x) {
                return {
                    photo: {
                        id: x.id,
                        name: x.name,
                        link: x.link
                    }
                };
            }))
        },
        productShowGroup: {
            cereals: data.productCultivations.includes('cereals'),
            oilCrops: data.productCultivations.includes('oilCrops'),
            rootCrops: data.productCultivations.includes('rootCrops'),
            industrialCrops: data.productCultivations.includes('industrialCrops'),
            rootVegetables: data.productCultivations.includes('rootVegetables'),
            leafyVegetables: data.productCultivations.includes('leafyVegetables'),
            fruitingVegetables: data.productCultivations.includes('fruitingVegetables'),
            leguminousVegetables: data.productCultivations.includes('leguminousVegetables'),
            bulbVegetables: data.productCultivations.includes('bulbVegetables'),
            hardFruits: data.productCultivations.includes('hardFruits'),
            softFruits: data.productCultivations.includes('softFruits'),
            herbs: data.productCultivations.includes('herbs'),
            animalProduction: data.productCultivations.includes('animalProduction')
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromFarmViewCard(data) {
    return {
        shareProfile: data.visibilityGroup.shareProfile,
        showProducts: data.visibilityGroup.showProducts,
        name: data.descriptionGroup.name,
        description: data.descriptionGroup.description,
        photos: data.descriptionGroup.photos
            .filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x != null && x.photo != null && x.photo.file != null; }))
            .map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.photo.file; })),
        productCultivations: getProductCultivationArray(data.productShowGroup),
        existingPhotoIds: data.descriptionGroup.photos
            .filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x != null && x.photo != null && x.photo.id != null; }))
            .map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.photo.id; }))
    };
}
/**
 * @param {?} obj
 * @return {?}
 */
function getProductCultivationArray(obj) {
    /** @type {?} */
    var arr = [];
    productsViewcard.forEach((/**
     * @param {?} x
     * @return {?}
     */
    function (x) {
        if (obj[x.name] === true) {
            arr.push(x.name);
        }
    }));
    return arr;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MAX_FILE_SIZE$5 = 1;
// MB
/** @type {?} */
var groupHostCss$1 = 'mt-1 col-12';
/** @type {?} */
var checkboxHostCss$1 = {
    grid: {
        host: 'col-4',
        container: 'row',
        label: 'col-12',
        control: 'col-12'
    }
};
/** @type {?} */
var FORM_LAYOUT_CERTIFICATES = {
    certificateGroup: DEFAULT_FORM_LAYOUT_GROUP,
    certificateName: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    certificateType: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    certificateCode: {
        grid: {
            host: 'col-12',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    certificateStartDate: {
        grid: {
            host: 'col-6',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    certificateEndDate: {
        grid: {
            host: 'col-6',
            container: 'row',
            label: 'col-12',
            control: 'col-12'
        }
    },
    certificateFile: {
        grid: {
            host: groupHostCss$1,
            label: 'mb-3'
        },
        element: {
            control: 'd-flex align-content-start flex-wrap',
            group: 'mx-1 observation-photo-group'
        }
    },
};
/** @type {?} */
var FORM_MODEL_CERTIFICATES = [
    new DynamicFormGroupModel({
        id: 'certificateGroup',
        group: [
            new DynamicInputModel({
                id: 'certificateName',
                validators: {
                    required: null
                }
            }),
            new DynamicSelectModel({
                id: 'certificateType',
                options: getOptionsForDynamicSelectModel(CertificateType, 'CERTIFICATE_TYPE', true),
                validators: {
                    required: null
                }
            }),
            new DynamicInputModel({
                id: 'certificateCode',
                validators: {
                    required: null
                }
            }),
            new DynamicDatePickerModel({
                id: 'certificateStartDate',
                // tslint:disable-next-line: no-duplicate-string
                toggleIcon: './assets/icons/calendar-icon.svg',
                validators: {
                    required: null
                }
            }),
            new DynamicDatePickerModel({
                id: 'certificateEndDate',
                toggleIcon: './assets/icons/calendar-icon.svg',
                validators: {
                    required: null
                }
            }),
            new DynamicFileUploadModel({
                id: 'certificateFile',
                maxSize: MAX_FILE_SIZE$5,
                validators: {
                    required: null,
                }
            })
        ]
    })
];
/**
 * @return {?}
 */
function mapToCertificateForm() {
    return {
        certificateGroup: {
            certificateName: '',
            certificateType: '',
            certificateCode: '',
            certificateStartDate: null,
            certificateEndDate: null,
            certificateFile: null
        }
    };
}
/**
 * @param {?} data
 * @return {?}
 */
function mapFromCertificateForm(data) {
    return (/** @type {?} */ ({
        name: data.certificateGroup.certificateName,
        type: data.certificateGroup.certificateType,
        code: data.certificateGroup.certificateCode,
        startDate: mapDatePickerValueToISOString(data.certificateGroup.certificateStartDate),
        endDate: mapDatePickerValueToISOString(data.certificateGroup.certificateEndDate),
        file: data.certificateGroup.certificateFile.file
    }));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FarmCertificate() { }
if (false) {
    /** @type {?} */
    FarmCertificate.prototype.certificateGroup;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function CertificateListItem() { }
if (false) {
    /** @type {?} */
    CertificateListItem.prototype.id;
    /** @type {?} */
    CertificateListItem.prototype.name;
    /** @type {?} */
    CertificateListItem.prototype.code;
    /** @type {?} */
    CertificateListItem.prototype.type;
    /** @type {?} */
    CertificateListItem.prototype.startDate;
    /** @type {?} */
    CertificateListItem.prototype.endDate;
    /** @type {?} */
    CertificateListItem.prototype.file;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AddViewCard() { }
if (false) {
    /** @type {?} */
    AddViewCard.prototype.shareProfile;
    /** @type {?} */
    AddViewCard.prototype.showProducts;
    /** @type {?} */
    AddViewCard.prototype.name;
    /** @type {?} */
    AddViewCard.prototype.description;
    /** @type {?} */
    AddViewCard.prototype.photos;
    /** @type {?} */
    AddViewCard.prototype.productCultivations;
    /** @type {?} */
    AddViewCard.prototype.existingPhotoIds;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ViewCard() { }
if (false) {
    /** @type {?} */
    ViewCard.prototype.shareProfile;
    /** @type {?} */
    ViewCard.prototype.showProducts;
    /** @type {?} */
    ViewCard.prototype.name;
    /** @type {?} */
    ViewCard.prototype.description;
    /** @type {?} */
    ViewCard.prototype.photos;
    /** @type {?} */
    ViewCard.prototype.productCultivations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ServiceCardService = /** @class */ (function () {
    function ServiceCardService(name, quantity, unit, unitPrice, catalogNumber, manufacturer, kindOfService) {
        this.name = name;
        this.quantity = quantity;
        this.unit = unit;
        this.unitPrice = unitPrice;
        this.catalogNumber = catalogNumber;
        this.manufacturer = manufacturer;
        this.kindOfService = kindOfService;
    }
    /**
     * @return {?}
     */
    ServiceCardService.prototype.icon = /**
     * @return {?}
     */
    function () {
        switch (this.kindOfService) {
            case MachineServiceCardType.PART:
                return 'archive';
            case MachineServiceCardType.LIQUID:
                return 'droplet';
            case MachineServiceCardType.SERVICE:
                return 'settings';
            default:
                return '';
        }
    };
    return ServiceCardService;
}());
if (false) {
    /** @type {?} */
    ServiceCardService.prototype.name;
    /** @type {?} */
    ServiceCardService.prototype.quantity;
    /** @type {?} */
    ServiceCardService.prototype.unit;
    /** @type {?} */
    ServiceCardService.prototype.unitPrice;
    /** @type {?} */
    ServiceCardService.prototype.catalogNumber;
    /** @type {?} */
    ServiceCardService.prototype.manufacturer;
    /** @type {?} */
    ServiceCardService.prototype.kindOfService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AclPermissionsCommand, AclSharedModule, AddFormComponent, BUILDING_FORM_LAYOUT, BuildingsListFilter, BuildingsSharedModule, CULTIVATIONS_LIST_MAP_FILTER_CULTIVATIONS, CULTIVATIONS_LIST_MAP_FILTER_CULTIVATION_TYPE, CULTIVATIONS_LIST_MAP_FILTER_FILTER_GROUP, CULTIVATIONS_LIST_MAP_FILTER_FORM_LAYOUT, CULTIVATIONS_LIST_MAP_FILTER_FORM_MODEL, CULTIVATIONS_LIST_MAP_FILTER_SHOW_FIELD_CARD_ENDED, CULTIVATIONS_LIST_MAP_FILTER_SHOW_PARCEL_DELETED, CULTIVATIONS_LIST_MAP_FILTER_YEAR_FORM_LAYOUT, CULTIVATIONS_LIST_MAP_FILTER_YEAR_FORM_MODEL, CadastralRegister, CadastralRegisterGeoData, CadastralRegisterMapValue, CadastralRegisterName, CdkPaginator, CdkSort, CdkSortHeader, CommissionedAuditResult, ConfirmationModalService, CreateDocumentCommand, CreateGroundCommand, CreateGroundImportScanCommand, CreateGroundImportSoilSpecimenCommand, CreateGroundParcelCommand, CreateGroundParcelGroupCommand, CultivationFieldCardFormGroundsComponent, CultivationListFilterYearComponent, CultivationListFilterYearForm, CultivationListMapComponent, CultivationListMapFilter, CultivationListMapFilterComponent, CultivationListMapFilterForm, CultivationListMapTableComponent, CultivationMapComponent, CultivationSharedModule, CustomDynamicFormService, DEFAULT_FORM_LAYOUT_GROUP, DEFAULT_FORM_LAYOUT_INPUT, DEFAULT_SEARCH_FORM_LAYOUT_INPUT_EVEN, DEFAULT_SEARCH_FORM_LAYOUT_INPUT_ODD, DOCUMENT_SHARED_SERVICE, DRAWING_BUILDING_FORM_MODEL, DYNAMIC_FORM_CONTROL_TYPE_BUTTON, DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER, DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_MAP, DYNAMIC_FORM_CONTROL_TYPE_CADASTRAL_REGISTER_NAME, DYNAMIC_FORM_CONTROL_TYPE_COMMISSIONED_AUDIT_RESULT, DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_EDIT_SELECT, DYNAMIC_FORM_CONTROL_TYPE_CULIVATION_AREA_SELECT, DYNAMIC_FORM_CONTROL_TYPE_DICTIONARY, DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARIES, DYNAMIC_FORM_CONTROL_TYPE_EMPLOYEE_SALARY, DYNAMIC_FORM_CONTROL_TYPE_FARM_AUDIT_REQUIREMENT, DYNAMIC_FORM_CONTROL_TYPE_FIELD_AUDIT_AREA, DYNAMIC_FORM_CONTROL_TYPE_FILE_SHARING, DYNAMIC_FORM_CONTROL_TYPE_MAP, DYNAMIC_FORM_CONTROL_TYPE_MAP_AREA_SELECT, DYNAMIC_FORM_CONTROL_TYPE_MULTI_SELECT, DYNAMIC_FORM_CONTROL_TYPE_NUMERIC_CONDITION, DYNAMIC_FORM_CONTROL_TYPE_PERIOD, DYNAMIC_FORM_CONTROL_TYPE_PERIODS, DYNAMIC_FORM_CONTROL_TYPE_PRODUCT_DELIVERY, DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARD, DYNAMIC_FORM_CONTROL_TYPE_SUPPLIER_AWARDS, DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZER, DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_FERTILIZERS, DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_IRRIGATION, DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDE, DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_PESTICIDES, DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEED, DYNAMIC_FORM_CONTROL_TYPE_TREATMENT_SEEDS, DYNAMIC_FORM_DICTIONARY_SERVICE, DYNAMIC_FORM_MODEL_MAP_FN, DataLayerComponent, DateValidators, DatepickerRangeComponent, DiseaseModelsSharedModule, Document, DocumentFile, DocumentListFilter, DocumentListSchema, DocumentSharedModule, DocumentsListComponent, DownloadCsvService, DynamicButtonControlModel, DynamicCadastralRegisterFormControlModel, DynamicCadastralRegisterMapFormControlModel, DynamicCadastralRegisterNameFormControlModel, DynamicCommissionedAuditResultFormControlModel, DynamicDictionaryControlModel, DynamicEmployeeSalariesFormControlModel, DynamicEmployeeSalaryFormControlModel, DynamicFarmAuditRequirementFormControlModel, DynamicFieldAuditAreaFormControlModel, DynamicFileSharingFormControlModel, DynamicMapAreaSelectFormControlModel, DynamicMapControlModel, DynamicMapCultivationAreaEditFormControlModel, DynamicMapCultivationAreaFormControlModel, DynamicMultiSelectControlModel, DynamicNumericConditionModel, DynamicPeriodFormControlModel, DynamicPeriodsFormControlModel, DynamicProductDeliveryFormControlModel, DynamicSupplierAwardFormControlModel, DynamicSupplierAwardsFormControlModel, DynamicTreatmentFertilizerFormControlModel, DynamicTreatmentFertilizersFormControlModel, DynamicTreatmentIrrigationFormControlModel, DynamicTreatmentPesticideFormControlModel, DynamicTreatmentPesticidesFormControlModel, DynamicTreatmentSeedFormControlModel, DynamicTreatmentSeedsFormControlModel, Employee, EmployeeSalaries, EmployeeSalary, FORM_LAYOUT_CERTIFICATES, FORM_LAYOUT_SINGLE_LINE_INPUT, FORM_LAYOUT_VIEW_CARD, FORM_MODEL$2 as FORM_MODEL, FORM_MODEL_CERTIFICATES, FarmAuditRequirement, FarmSharedModule, FeaturesStoreService, Fertilizer, FertilizerDto, FertilizerListFilter, FertilizerListFilterComponent, FertilizerListItem, FertilizerService, FertilizerSharedModule, FieldAuditArea, FileSharing, FormComponent, FormModalService, FormSharedModule, FormatPipe, GROUND_CUSTOM_MAP_SHARED_SERVICE, GROUND_IMPORT_DATA_SHARED_SERVICE, GROUND_PARCEL_GROUP_SHARED_SERVICE, GROUND_PARCEL_SHARED_SERVICE, GROUND_SHARED_SERVICE, GeneratedAlarm, GetDefaultLayout, GetDefaultSearchLayout, GetDefaultSingleLineLayout, GetFormLayout, GetLayout, GoogleMapsSharedModule, GpsPosition, Ground, GroundAddComponent, GroundAgroMonitoring, GroundCustomMap, GroundCustomMapsComponent, GroundCustomMapsSchema, GroundEditComponent, GroundGeoData, GroundImportComponent, GroundImportModel, GroundImportScan, GroundImportScanItem, GroundImportScanItemCommand, GroundImportScanListFilter, GroundImportScanListItem, GroundImportSchema, GroundImportSoilSpecimen, GroundImportSoilSpecimenItem, GroundImportSoilSpecimenItemCommand, GroundImportSoilSpecimenListFilter, GroundImportSoilSpecimenListItem, GroundListFilter, GroundListFilterComponent, GroundListItem, GroundListTableComponent, GroundListTableSchema, GroundMapComponent, GroundMapSchema, GroundParcel, GroundParcelGroup, GroundParcelGroupListFilter, GroundParcelGroupListItem, GroundParcelGroupParcel, GroundParcelsComponent, GroundParcelsSchema, GroundScansComponent, GroundScansImportComponent, GroundScansSchema, GroundSharedModule, GroundSoilSpecimensComponent, GroundSoilSpecimensImportComponent, GroundSoilSpecimensSchema, IoElement, LangSelectorComponent, LayoutSharedModule, LeafMoistureSharedModule, LocationMapComponent, LocationMapItem, LocationMapItemType, LocationMapSchema, LocationMapService, LocationMapServicesModule, LocationMapSharedModule, MESSAGE_UNREAD_SERVICE, MachineListFilter, MachineSharedModule, MapComponent, MapConfig, MapService, MapType, MarkerComponent, MarkerConfig, MarkerService, MarkerStoreService, MatSortBase, Message, MessageListComponent, MessageListCount, MessageListFilter, MessageListItemComponent, MessageListSidebarComponent, MessageSharedModule, MessageUnread, MessageUnreadNotificationComponent, MeteogramSharedModule, ModalSharedModule, NgbdDatepickerRangeModule, NgbdModalConfirmComponent, NgbdModalDateComponent, NoteListItem, NoteSharedModule, OrganizationSharedModule, PARCEL_GROUP_CULTIVATION_AREA_SHARED_SERVICE, PageEvent, PanelFullscreenButtonComponent, PanelFullscreenDirective, PanelHideButtonComponent, PanelHideDirective, PanelSharedModule, ParcelGroupAddComponent, ParcelGroupCultivationArea, ParcelGroupCultivationAreaCommand, ParcelGroupCultivationAreaComponent, ParcelGroupCultivationAreasSchema, ParcelGroupEditComponent, ParcelGroupListFilterComponent, ParcelGroupListTableComponent, ParcelGroupListTableSchema, ParcelGroupMapComponent, ParcelGroupMapSchema, Period, Periods, Pesticide, PesticideListFilter, PesticideListFilterComponent, PesticideListItem, PesticideService, PesticideSharedModule, PesticideUsageDate, PolygonComponent, PolygonConfig, PolygonService, PolygonStoreService, Product, ProductDefinition, ProductDelivery, ProductDeliveryParcel, ProductListFilter, ProductListFilterComponent, ProductService, ProductSharedModule, PureGoogleMapsServicesModule, PureGoogleMapsSharedModule, PureMapComponent, PureMapService, READONLY_BUILDING_FORM_MODEL, RecommendationSharedModule, SERVICE_CARD_ENTRY_ELEMENTS_GROUP_KEY, SERVICE_CARD_ENTRY_FORM_LAYOUT, SERVICE_CARD_ENTRY_FORM_MODEL, SERVICE_CARD_ENTRY_INFORMATION_GROUP_KEY, SatelliteSharedModule, SearchFlatFormComponent, SearchFormComponent, Seed, SeedListFilter, SeedListFilterComponent, SeedListItem, SeedService, SeedSharedModule, ServerSideDataSource, ServiceCardEntry, ServiceSharedModule, SimpleFormComponent, StorageSensorSharedModule, SupplierAward, SupplierAwards, TableSharedModule, TranslateFormModelService, TreatmentFertilizer, TreatmentFertilizers, TreatmentIrrigation, TreatmentPesticide, TreatmentPesticides, TreatmentSeed, TreatmentSeeds, UpdateFertilizerCommand, UpdateGroundCommand, UpdateGroundParcelGroupCommand, UpdatePesticideCommand, UpdatePesticidePeriodCommand, UpdateSeedCommand, WeatherSharedModule, WeatherStationMeasurementComponent, WeatherStationMeasurementsComponent, WeatherStationServicesModule, WeatherStationSharedModule, _MatSortMixinBase, cadastralRegisterNameValidator, cadastralRegisterValidator, commissionedAuditResultValidator, controlMapFnFactory, decimalNumberValidator, employeeSalariesValidator, farmDrawingColor, getOptionsForDynamicMultiSelectControlModel, getOptionsForDynamicSelectModel, getProductCheckboxes, getProductCultivationArray, getRangeOptionsForDynamicSelectModel, getYearsRangeOptionsForDynamicSelectModel, groundDrawingColor, groupDrawingColor, lazyMapsAPILoaderConfigFactory, mapDatePickerValueToISOString, mapDatePickerValueToUnixTimestamp, mapFromBuildingForm, mapFromCertificateForm, mapFromFarmViewCard, mapFromServiceCardEntryFormToCreateTreatmentsCommand, mapISOStringToDatePickerValue, mapToBuildingForm, mapToCertificateForm, mapToFarmViewCardForm, mapToMachineForm, mapToPosition, mapToServiceCardEntryForm, mapUnixTimestampToDatePickerValue, modelMapFnFactory, numericConditionValidator, parcelDrawingColor, periodArrayValidator, periodsValidator, productDeliveryValidator, productsViewcard, supplierAwardsValidator, treatmentFertilizersValidator, treatmentIrrigationValidator, treatmentPesticidesValidator, treatmentSeedsValidator, validatorsMap, FungicideRecommendationsComponent as ɵa, GroundWeatherForecastService as ɵb, DualListFormControlComponent as ɵba, DualListComponent as ɵbb, DynamicMapAreaSelectFormControlComponent as ɵbc, DynamicMapCultivationAreaFormControlComponent as ɵbd, DynamicMapCultivationAreaEditFormControlComponent as ɵbe, DynamicMapFormControlComponent as ɵbf, DynamicFileFormControlComponent as ɵbg, DynamicFileSharingFormControlComponent as ɵbh, FileSharingFormComponent as ɵbi, FileSharingFormService as ɵbj, FileSharingFormControlComponent as ɵbk, DynamicFarmAuditRequirementFormControlComponent as ɵbl, FarmAuditRequirementFormControlComponent as ɵbm, FarmAuditRequirementFormComponent as ɵbn, FarmAuditRequirementFormService as ɵbo, DynamicFieldAuditAreaFormControlComponent as ɵbp, FieldAuditAreaFormControlComponent as ɵbq, FieldAuditAreaFormComponent as ɵbr, FieldAuditAreaFormService as ɵbs, DynamicEmployeeSalaryFormControlComponent as ɵbt, EmployeeSalaryFormControlComponent as ɵbu, EmployeeSalaryFormComponent as ɵbv, EmployeeSalaryFormService as ɵbw, DynamicEmployeeSalariesFormControlComponent as ɵbx, EmployeeSalariesFormControlComponent as ɵby, EmployeeSalariesFormComponent as ɵbz, RecommendationServicesModule as ɵc, EmployeeSalariesFormService as ɵca, DynamicNumericConditionControlComponent as ɵcb, FileFormControlComponent as ɵcc, FileFormService as ɵcd, DynamicDictionaryFormControlComponent as ɵce, DynamicMultiSelectFormControlComponent as ɵcf, CadastralRegisterFormComponent as ɵcg, CadastralRegisterFormService as ɵch, CadastralRegisterNameFormComponent as ɵci, CadastralRegisterNameProxyService as ɵcj, CadastralRegisterNameFormService as ɵck, CadastralRegisterFormControlComponent as ɵcl, CadastralRegisterNameFormControlComponent as ɵcm, DynamicCadastralRegisterFormControlComponent as ɵcn, DynamicCadastralRegisterNameFormControlComponent as ɵco, CadastralRegisterMapFormControlComponent as ɵcp, DynamicCadastralRegisterMapFormControlComponent as ɵcq, NumericConditionControlComponent as ɵcr, DynamicPeriodFormControlComponent as ɵcs, PeriodFormControlComponent as ɵct, PeriodFormComponent as ɵcu, PeriodFormService as ɵcv, DynamicPeriodsFormControlComponent as ɵcw, PeriodsFormControlComponent as ɵcx, PeriodsFormComponent as ɵcy, PeriodsFormService as ɵcz, OpenweathermapProxyService as ɵd, DynamicCommissionedAuditResultFormControlComponent as ɵda, CommissionedAuditResultFormControlComponent as ɵdb, CommissionedAuditResultFormComponent as ɵdc, CommissionedAuditResultFormService as ɵdd, DynamicProductDeliveryFormControlComponent as ɵde, ProductDeliveryFormControlComponent as ɵdf, ProductDeliveryFormComponent as ɵdg, ProductDeliveryFormService as ɵdh, DynamicSupplierAwardFormControlComponent as ɵdi, SupplierAwardFormControlComponent as ɵdj, SupplierAwardFormComponent as ɵdk, SupplierAwardFormService as ɵdl, DynamicSupplierAwardsFormControlComponent as ɵdm, SupplierAwardsFormControlComponent as ɵdn, SupplierAwardsFormComponent as ɵdo, SupplierAwardsFormService as ɵdp, DynamicTreatmentFertilizerFormControlComponent as ɵdq, TreatmentFertilizerFormControlComponent as ɵdr, TreatmentFertilizerFormComponent as ɵds, TreatmentFertilizerFormService as ɵdt, DynamicTreatmentFertilizersFormControlComponent as ɵdu, TreatmentFertilizersFormControlComponent as ɵdv, TreatmentFertilizersFormComponent as ɵdw, TreatmentFertilizersFormService as ɵdx, DynamicTreatmentIrrigationFormControlComponent as ɵdy, TreatmentIrrigationFormControlComponent as ɵdz, FungicideRecommendationsService as ɵe, TreatmentIrrigationFormComponent as ɵea, TreatmentIrrigationFormService as ɵeb, DynamicTreatmentPesticideFormControlComponent as ɵec, TreatmentPesticideFormControlComponent as ɵed, TreatmentPesticideFormComponent as ɵee, TreatmentPesticideFormService as ɵef, DynamicTreatmentPesticidesFormControlComponent as ɵeg, TreatmentPesticidesFormControlComponent as ɵeh, TreatmentPesticidesFormComponent as ɵei, TreatmentPesticidesFormService as ɵej, DynamicTreatmentSeedFormControlComponent as ɵek, TreatmentSeedFormControlComponent as ɵel, TreatmentSeedFormComponent as ɵem, TreatmentSeedFormService as ɵen, DynamicTreatmentSeedsFormControlComponent as ɵeo, TreatmentSeedsFormControlComponent as ɵep, TreatmentSeedsFormComponent as ɵeq, TreatmentSeedsFormService as ɵer, DynamicMachineCardElementFormControlComponent as ɵes, MachineCardElementFormControlComponent as ɵet, MachineCardElementFormComponent as ɵeu, MachineCardElementFormService as ɵev, DynamicMachineCardElementsFormControlComponent as ɵew, MachineCardElementsFormControlComponent as ɵex, MachineCardElementsFormComponent as ɵey, MachineCardElementsFormService as ɵez, FungicideRecommendationPipe as ɵf, DynamicAclPermissionFormControlComponent as ɵfa, AclPermissionFormControlComponent as ɵfb, AclPermissionFormComponent as ɵfc, AclPermissionFormService as ɵfd, DynamicAclPermissionsFormControlComponent as ɵfe, AclPermissionsFormControlComponent as ɵff, AclPermissionsFormComponent as ɵfg, AclPermissionsFormService as ɵfh, DynamicMachineAlarmConfElementFormControlComponent as ɵfi, MachineAlarmConfElementFormControlComponent as ɵfj, MachineAlarmConfElementFormComponent as ɵfk, MachineAlarmConfElementFormService as ɵfl, DynamicMachineAlarmConfElementsFormControlComponent as ɵfm, MachineAlarmConfElementsFormControlComponent as ɵfn, MachineAlarmConfElementsFormComponent as ɵfo, MachineAlarmConfElementsFormService as ɵfp, cadastralGroundRegisterValidator as ɵfq, decimalNumberValidator as ɵfr, numericConditionValidator as ɵfs, farmAuditRequirementValidator as ɵft, mapCultivationAreaValidator as ɵfu, machineCardElementsValidator as ɵfv, aclPermissionsValidator as ɵfw, machineAlarmConfElementsValidator as ɵfx, WeatherForecastComponent as ɵfy, WeatherStationForecastService as ɵfz, SatelliteImageryComponent as ɵg, WeatherServicesModule as ɵga, WeatherForecastChartComponent as ɵgb, WeatherIndexUvComponent as ɵgc, WeatherIndexUvChartComponent as ɵgd, WeatherCurrentDataComponent as ɵge, MeteogramComponent as ɵgf, DiseaseModelsComponent as ɵgg, LeafMoistureComponent as ɵgh, mixinInitialized as ɵgi, DocumentAddFormComponent as ɵgj, ToggleFullscreenComponent as ɵgk, PesticideServicesModule as ɵgl, PesticideProxyService as ɵgm, SeedServicesModule as ɵgn, SeedProxyService as ɵgo, FertilizerServicesModule as ɵgp, FertilizerProxyService as ɵgq, ProductServicesModule as ɵgr, ProductProxyService as ɵgs, WeatherStationDataListService as ɵgt, WeatherStationDataProxyService as ɵgu, GroundImportSelectGeojsonFileComponent as ɵgv, GroundImportSelectFileComponent as ɵgw, GroundLocationConverterService as ɵgx, GroundServicesModule as ɵgy, GroundLocationConverterProxyService as ɵgz, AgromonitoringService as ɵh, GroundImportSelectKmlFileComponent as ɵha, GroundImportSelectShpFileComponent as ɵhb, GroundScansMapComponent as ɵhc, GroundSpecimenColorService as ɵhd, GroundSoilSpecimensMapComponent as ɵhe, GroundDataImportComponent as ɵhf, FileImporterService as ɵhg, GroundParcelPolygonsService as ɵhh, PolygonSplitService as ɵhi, GroundParcelInfoModalComponent as ɵhj, ParcelGroupCultivationAreaInfoModalComponent as ɵhk, CultivationAreaPolygonsService as ɵhl, CultivationWithGroundsMapComponent as ɵhm, CultivationFieldCardMapComponent as ɵhn, BuildingsMapComponent as ɵho, BuildingsListTableComponent as ɵhp, BuildingInfoComponent as ɵhq, BuildingsServicesModule as ɵhr, OrganizationProfileStatisticsComponent as ɵhs, OrganizationProfileCultivationChartComponent as ɵht, OrganizationProfileGroundChartComponent as ɵhu, MachineListTableComponent as ɵhv, MachineInfoComponent as ɵhw, MachineServiceCardComponent as ɵhx, MachineAlarmConfigurationFormComponent as ɵhy, MachineGeneratedAlarmsComponent as ɵhz, SatelliteServicesModule as ɵi, StorageSensorMeasurementsComponent as ɵia, StorageSensorDataListService as ɵib, StorageSensorServicesModule as ɵic, StorageSensorDataProxyService as ɵid, StorageSensorMeasurementComponent as ɵie, ServiceCardService as ɵif, NoteListItemComponent as ɵig, AclPermissionsFormComponentComponent as ɵih, MessageTypeAvatarComponent as ɵii, FarmCertificatesTableComponent as ɵij, AgromonitoringProxyService as ɵj, MessageTranslationPipe as ɵk, MapAreaSelectControlComponent as ɵl, CadastralRegisterProxyService as ɵm, MapAreaCadastralService as ɵn, MapAreaSelectControlService as ɵo, MapAreaSelectFormControlComponent as ɵp, MapCultivationAreaControlComponent as ɵq, MapCultivationAreaCadastralService as ɵr, MapCultivationAreaControlService as ɵs, MapCultivationAreaEditControlComponent as ɵt, MapCultivationAreaEditControlService as ɵu, MapCultivationAreaEditCadastralService as ɵv, MapFormControlComponent as ɵw, DynamicButtonFormControlComponent as ɵx, ButtonFormControlComponent as ɵy, DynamicDualListFormControlComponent as ɵz };
//# sourceMappingURL=farmcloud-shared.js.map
